import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Coordinate: any;
  Date: any;
  Money: any;
  Timestamp: any;
  Upload: any;
  _FieldSet: any;
};

export type ActivitiesResult = {
  __typename?: 'ActivitiesResult';
  activities: Array<Activity>;
};

export type Activity = {
  __typename?: 'Activity';
  change?: Maybe<ActivityChangeDetail>;
  courierId: Scalars['ID'];
  /** Server receive time — differs from `time` (tap-time) for OFFLINE replays */
  createdAt: Scalars['Timestamp'];
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: ActivityEntityType;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  infoType: ActivityInfoType;
  offlineMode: OfflineMode;
  time: Scalars['Timestamp'];
  updatedByDriver?: Maybe<Driver>;
  updatedByEmail?: Maybe<Scalars['String']>;
  updatedByEndCustomer?: Maybe<EndCustomer>;
  updatedByEndUser?: Maybe<EndUser>;
  updatedByUser?: Maybe<CourieUser>;
};

export type ActivityChangeDetail = {
  __typename?: 'ActivityChangeDetail';
  new?: Maybe<ActivitySnapshot>;
  old?: Maybe<ActivitySnapshot>;
};

export enum ActivityEntityType {
  AddressBook = 'ADDRESS_BOOK',
  Driver = 'DRIVER',
  DriverStopTemplateSequenceOnDay = 'DRIVER_STOP_TEMPLATE_SEQUENCE_ON_DAY',
  EndCustomer = 'END_CUSTOMER',
  Invoice = 'INVOICE',
  Quotes = 'QUOTES',
  RouteTemplate = 'ROUTE_TEMPLATE',
  Shipment = 'SHIPMENT',
  ShipmentTemplate = 'SHIPMENT_TEMPLATE'
}

export enum ActivityInfoType {
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type ActivitySnapshot = {
  __typename?: 'ActivitySnapshot';
  entries?: Maybe<Array<Maybe<ActivitySnapshotEntry>>>;
  value?: Maybe<Scalars['String']>;
};

export type ActivitySnapshotEntry = {
  __typename?: 'ActivitySnapshotEntry';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AdditionalLegInput = {
  packageCount?: InputMaybe<Scalars['Int']>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
};

export enum AddressBookAutoFillType {
  Default = 'DEFAULT',
  ExcludeInstructions = 'EXCLUDE_INSTRUCTIONS'
}

export type AddressBookEntry = {
  __typename?: 'AddressBookEntry';
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  emailRecipients?: Maybe<Array<Scalars['String']>>;
  endCustomer?: Maybe<EndCustomer>;
  endCustomerId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  location: Location;
  phone?: Maybe<Scalars['String']>;
  suite?: Maybe<Scalars['String']>;
};

/** AddressBookEntry Connection */
export type AddressBookEntryConnection = {
  __typename?: 'AddressBookEntryConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<AddressBookEntryEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** AddressBookEntry Edge */
export type AddressBookEntryEdge = {
  __typename?: 'AddressBookEntryEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<AddressBookEntry>;
};

export enum AddressBookSavingType {
  EmailDisabled = 'EMAIL_DISABLED',
  EmailEnabled = 'EMAIL_ENABLED'
}

export enum AddressBookSortField {
  CompanyName = 'COMPANY_NAME',
  ContactName = 'CONTACT_NAME',
  CreatedAt = 'CREATED_AT',
  EndCustomer = 'END_CUSTOMER'
}

export type AddressBookSorting = {
  direction: SortingDirection;
  field: AddressBookSortField;
};

export type AddressPrediction = {
  __typename?: 'AddressPrediction';
  description: Scalars['String'];
  googlePlaceId: Scalars['String'];
  matchedSubstrings: Array<MatchedSubstring>;
};

export type AdjustmentOverrideInput = {
  adjustmentId: Scalars['ID'];
  amount: Scalars['Money'];
};

export type Agent = {
  __typename?: 'Agent';
  agentType: AgentType;
  courierId: Scalars['ID'];
  /** Null through Courier.agents unless the caller has agents.view. */
  details?: Maybe<AgentDetails>;
  id: Scalars['ID'];
  optedIn: Scalars['Boolean'];
  /** The agent's Vapi assistant (Customer Support today), for Courie's web widgets. */
  vapiAssistantId?: Maybe<Scalars['String']>;
};

export type AgentCreate = {
  agentType: AgentType;
  details?: InputMaybe<AgentDetailsInput>;
  optedIn: Scalars['Boolean'];
};

export type AgentDetails = {
  __typename?: 'AgentDetails';
  customerSupportAgentDetails?: Maybe<CustomerSupportAgentSetting>;
  qualityReviewAgentDetails?: Maybe<QualityReviewAgentSetting>;
};

export type AgentDetailsInput = {
  customerSupportAgentDetails?: InputMaybe<CustomerSupportAgentSettingInput>;
  qualityReviewAgentDetails?: InputMaybe<QualityReviewAgentSettingInput>;
};

export type AgentFullUpdate = {
  details?: InputMaybe<AgentDetailsInput>;
  id: Scalars['ID'];
  optedIn: Scalars['Boolean'];
};

export enum AgentType {
  CustomerSupport = 'CUSTOMER_SUPPORT',
  DriverConfirmationNextTask = 'DRIVER_CONFIRMATION_NEXT_TASK',
  DriverDailyCheckIn = 'DRIVER_DAILY_CHECK_IN',
  QualityReview = 'QUALITY_REVIEW'
}

export type AlternateUniverseDriverDayOverview = {
  __typename?: 'AlternateUniverseDriverDayOverview';
  routeWithShipmentAssignmentOrder: RouteOverview;
};

export type AnalyticsDashboard = {
  __typename?: 'AnalyticsDashboard';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  metabaseDashboardId: Scalars['ID'];
  name: Scalars['String'];
};

export enum ApiProvider {
  AlternativeCourier = 'ALTERNATIVE_COURIER',
  BlueYonder = 'BLUE_YONDER',
  Deliverect = 'DELIVERECT',
  Loginext = 'LOGINEXT',
  Nexus = 'NEXUS',
  QuickbookOnline = 'QUICKBOOK_ONLINE',
  Staples = 'STAPLES'
}

export type AppliedTax = {
  __typename?: 'AppliedTax';
  name: Scalars['String'];
  ratePercent: Scalars['Float'];
  taxAmount: Scalars['Float'];
  taxRateId: Scalars['String'];
  taxableAmount: Scalars['Float'];
};

export type Artifact = {
  __typename?: 'Artifact';
  actions: Array<ArtifactAction>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  lngLat?: Maybe<LngLat>;
  publicUrl?: Maybe<Scalars['String']>;
  shipmentId?: Maybe<Scalars['ID']>;
  stopId?: Maybe<Scalars['ID']>;
  taskId?: Maybe<Scalars['ID']>;
  type: ArtifactType;
  value?: Maybe<Scalars['String']>;
};

export type ArtifactAction = {
  __typename?: 'ArtifactAction';
  artifactId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  stopId?: Maybe<Scalars['ID']>;
  taskId?: Maybe<Scalars['ID']>;
  type: ArtifactActionType;
};

export enum ArtifactActionType {
  ConfirmScan = 'CONFIRM_SCAN',
  CreateScan = 'CREATE_SCAN',
  Sign = 'SIGN',
  TakePhoto = 'TAKE_PHOTO',
  UploadDocument = 'UPLOAD_DOCUMENT'
}

export enum ArtifactType {
  BarCode = 'BAR_CODE',
  DocumentFile = 'DOCUMENT_FILE',
  PhotoFile = 'PHOTO_FILE',
  QrCode = 'QR_CODE',
  SignatureFile = 'SIGNATURE_FILE'
}

export type AutomationTimeScheduleItem = {
  __typename?: 'AutomationTimeScheduleItem';
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type AutomationTimeScheduleItemInput = {
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type AutomationTimeScheduleList = {
  __typename?: 'AutomationTimeScheduleList';
  items: Array<AutomationTimeScheduleItem>;
};

export type AutomationTimeScheduleListInput = {
  items: Array<AutomationTimeScheduleItemInput>;
};

export type BankAccountDetail = {
  __typename?: 'BankAccountDetail';
  bankCode?: Maybe<Scalars['String']>;
  institutionNumber?: Maybe<Scalars['String']>;
  maskedAccountNumber: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  transitNumber?: Maybe<Scalars['String']>;
};

export type BiWeeklySchedule = {
  __typename?: 'BiWeeklySchedule';
  startDateISO8601: Scalars['String'];
};

export type BiWeeklyScheduleInput = {
  startDateISO8601: Scalars['String'];
};

export type BillOfLadingDoc = {
  __typename?: 'BillOfLadingDoc';
  fileId?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  pdfUrl: Scalars['String'];
};

export type BillableItem = {
  __typename?: 'BillableItem';
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  endCustomers: Array<EndCustomer>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  serviceType: ServiceType;
  serviceTypeId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
  unit: BillableItemUnit;
};

/** BillableItem Connection */
export type BillableItemConnection = {
  __typename?: 'BillableItemConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<BillableItemEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** BillableItem Edge */
export type BillableItemEdge = {
  __typename?: 'BillableItemEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<BillableItem>;
};

export enum BillableItemUnit {
  PerBusinessDay = 'PER_BUSINESS_DAY',
  PerDay = 'PER_DAY',
  PerDayWithCompletedStops = 'PER_DAY_WITH_COMPLETED_STOPS',
  PerMonth = 'PER_MONTH',
  PerStop = 'PER_STOP',
  PerWeek = 'PER_WEEK'
}

/**
 * Whether this order is priced and billed to the customer. A leg a splitting builder created is
 * NON_BILLABLE: the customer's original order carries the price, the leg is only driver work.
 */
export enum BillableType {
  Billable = 'BILLABLE',
  NonBillable = 'NON_BILLABLE'
}

export type BulkApproveDriverPaysFailure = {
  __typename?: 'BulkApproveDriverPaysFailure';
  failure: Scalars['String'];
  id: Scalars['ID'];
};

export type BulkApproveDriverPaysResults = {
  __typename?: 'BulkApproveDriverPaysResults';
  approvedEntries: Array<DriverPayEntry>;
  failures: Array<BulkApproveDriverPaysFailure>;
};

export type BulkArtifactsResult = {
  __typename?: 'BulkArtifactsResult';
  errorMessages: Array<Scalars['String']>;
  succeededArtifacts: Array<Artifact>;
};

export type BulkDispatchResults = {
  __typename?: 'BulkDispatchResults';
  failedShipmentIds: Array<Scalars['ID']>;
  succeededShipmentIds: Array<Scalars['ID']>;
};

export type BulkInvoiceApprovalFailure = {
  __typename?: 'BulkInvoiceApprovalFailure';
  invoiceId: Scalars['ID'];
  message: Scalars['String'];
};

export type BulkInvoiceApprovalResult = {
  __typename?: 'BulkInvoiceApprovalResult';
  approved: Array<Invoice>;
  failures: Array<BulkInvoiceApprovalFailure>;
};

export type BulkInvoiceEmailSendResults = {
  __typename?: 'BulkInvoiceEmailSendResults';
  failures?: Maybe<Array<InvoiceIdAndEmailSendErrorPair>>;
  successes?: Maybe<Array<InvoiceIdAndEmailSendPair>>;
};

export type BulkInvoicePaymentResult = {
  __typename?: 'BulkInvoicePaymentResult';
  errors?: Maybe<Array<Scalars['String']>>;
  processedPayments?: Maybe<Array<InvoicePayment>>;
};

export type BulkMultiplyPricingRulesResult = {
  __typename?: 'BulkMultiplyPricingRulesResult';
  numSuccess: Scalars['Int'];
};

export type BulkPaymentReminderEmailFailure = {
  __typename?: 'BulkPaymentReminderEmailFailure';
  contactEmail: Scalars['String'];
  endCustomerId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
};

export type BulkPaymentReminderEmailOptedOut = {
  __typename?: 'BulkPaymentReminderEmailOptedOut';
  contactEmail: Scalars['String'];
  endCustomerId: Scalars['String'];
};

export type BulkPaymentReminderEmailResults = {
  __typename?: 'BulkPaymentReminderEmailResults';
  failures: Array<BulkPaymentReminderEmailFailure>;
  optedOut: Array<BulkPaymentReminderEmailOptedOut>;
  successes: Array<BulkPaymentReminderEmailSuccess>;
};

export type BulkPaymentReminderEmailSuccess = {
  __typename?: 'BulkPaymentReminderEmailSuccess';
  communication: EndCustomerCommunication;
  contactEmail: Scalars['String'];
  endCustomerId: Scalars['String'];
};

export type BulkRerateJobInput = {
  endDate: Scalars['Date'];
  pricingListIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate: Scalars['Date'];
};

export type BulkRerateJobResult = {
  __typename?: 'BulkRerateJobResult';
  jobId: Scalars['ID'];
  message: Scalars['String'];
};

export type BulkScanResult = {
  __typename?: 'BulkScanResult';
  errorMessages: Array<Scalars['String']>;
  succeededEvents: Array<PackageEventResult>;
};

export type BulkUploadAddressBookResult = {
  __typename?: 'BulkUploadAddressBookResult';
  errors?: Maybe<Array<BulkUploadAddressBookRowError>>;
  isAsynchronous?: Maybe<Scalars['Boolean']>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadAddressBookRowError = {
  __typename?: 'BulkUploadAddressBookRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type BulkUploadCallerContactsResult = {
  __typename?: 'BulkUploadCallerContactsResult';
  errors?: Maybe<Array<BulkUploadCallerContactsRowError>>;
  isAsynchronous: Scalars['Boolean'];
  numSuccess: Scalars['Int'];
};

export type BulkUploadCallerContactsRowError = {
  __typename?: 'BulkUploadCallerContactsRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type BulkUploadEndCustomersResult = {
  __typename?: 'BulkUploadEndCustomersResult';
  errors?: Maybe<Array<BulkUploadEndCustomersRowError>>;
  isAsynchronous: Scalars['Boolean'];
  numSuccess: Scalars['Int'];
};

export type BulkUploadEndCustomersRowError = {
  __typename?: 'BulkUploadEndCustomersRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type BulkUploadOrdersResult = {
  __typename?: 'BulkUploadOrdersResult';
  error?: Maybe<CsvValidationError>;
  isAsynchronous?: Maybe<Scalars['Boolean']>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadPackageMovementsResult = {
  __typename?: 'BulkUploadPackageMovementsResult';
  errors: Array<BulkUploadPackageMovementsRowError>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadPackageMovementsRowError = {
  __typename?: 'BulkUploadPackageMovementsRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type BulkUploadPricingListsResult = {
  __typename?: 'BulkUploadPricingListsResult';
  errors?: Maybe<Array<BulkUploadPricingListsRowError>>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadPricingListsRowError = {
  __typename?: 'BulkUploadPricingListsRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type BulkUploadPricingRulesResult = {
  __typename?: 'BulkUploadPricingRulesResult';
  errors?: Maybe<Array<BulkUploadPricingRulesRowError>>;
  isAsynchronous?: Maybe<Scalars['Boolean']>;
  numSkipped?: Maybe<Scalars['Int']>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadPricingRulesRowError = {
  __typename?: 'BulkUploadPricingRulesRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type BulkUploadRecurringOrdersResult = {
  __typename?: 'BulkUploadRecurringOrdersResult';
  error?: Maybe<CsvValidationError>;
  isAsynchronous?: Maybe<Scalars['Boolean']>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadSurchargesResult = {
  __typename?: 'BulkUploadSurchargesResult';
  errors?: Maybe<Array<BulkUploadSurchargesRowError>>;
  isAsynchronous?: Maybe<Scalars['Boolean']>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadSurchargesRowError = {
  __typename?: 'BulkUploadSurchargesRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type CallerContact = {
  __typename?: 'CallerContact';
  emails?: Maybe<Array<Scalars['String']>>;
  endCustomer: EndCustomer;
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type CircleZone = {
  __typename?: 'CircleZone';
  center: LngLat;
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  maxRadiusInMeters: Scalars['Float'];
  minRadiusInMeters: Scalars['Float'];
  name: Scalars['String'];
};

export type CityStateCountryCreate = {
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
};

export enum CommunicationTypeId {
  ArrivedAtDo = 'ARRIVED_AT_DO',
  ArrivedAtPu = 'ARRIVED_AT_PU',
  DailySummary = 'DAILY_SUMMARY',
  DriverDispatched = 'DRIVER_DISPATCHED',
  DropOffOtw = 'DROP_OFF_OTW',
  EndUserInvited = 'END_USER_INVITED',
  Invoice = 'INVOICE',
  NewUserCreated = 'NEW_USER_CREATED',
  OrderClosed = 'ORDER_CLOSED',
  OrderCreated = 'ORDER_CREATED',
  OrderDelivered = 'ORDER_DELIVERED',
  PasswordChanged = 'PASSWORD_CHANGED',
  PaymentReminder = 'PAYMENT_REMINDER',
  PickUpCompleted = 'PICK_UP_COMPLETED',
  PickUpOtw = 'PICK_UP_OTW',
  StatusUpdate = 'STATUS_UPDATE',
  WeeklySummary = 'WEEKLY_SUMMARY'
}

export type CompleteTaskInput = {
  driverNote?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
};

export type CostCenter = {
  __typename?: 'CostCenter';
  email?: Maybe<Scalars['String']>;
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  suite?: Maybe<Scalars['String']>;
};

export type CostCenterCreate = {
  email?: InputMaybe<Scalars['String']>;
  endCustomerId: Scalars['ID'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
};

export type CostCenterFullUpdate = {
  email?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
};

export type CourieUser = {
  __typename?: 'CourieUser';
  computedPermissions: Array<Scalars['String']>;
  courierId?: Maybe<Scalars['ID']>;
  customRoles: Array<CustomRole>;
  email: Scalars['String'];
  enabledNotifications: Array<NotificationType>;
  firebaseUid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  profilePhotoUrl?: Maybe<Scalars['String']>;
  roleType: UserRoleType;
};

/** CourieUser Connection */
export type CourieUserConnection = {
  __typename?: 'CourieUserConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<CourieUserEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** CourieUser Edge */
export type CourieUserEdge = {
  __typename?: 'CourieUserEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<CourieUser>;
};

export type Courier = {
  __typename?: 'Courier';
  addressBookAutoFillType: AddressBookAutoFillType;
  addressBookSavingType: AddressBookSavingType;
  /** The courier's agents, optionally of one type. Callers without agents.view see only turned-on agents, without details. */
  agents: Array<Agent>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  billingStreetAddress?: Maybe<Scalars['String']>;
  billingZip?: Maybe<Scalars['String']>;
  currencyDisplay: Scalars['String'];
  customFields: Array<CustomField>;
  customerLoginImageUrl?: Maybe<Scalars['String']>;
  customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>;
  customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility;
  customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType;
  customerPortalNotice?: Maybe<Scalars['String']>;
  customerPortalOrderEntryType: CustomerPortalOrderEntryType;
  customerPortalPath?: Maybe<Scalars['String']>;
  dateFormatPreference: DateFormatPreference;
  defaultCurrency?: Maybe<Scalars['String']>;
  defaultInvoiceTaxCodeName?: Maybe<Scalars['String']>;
  defaultInvoicingFrequency?: Maybe<InvoicingFrequency>;
  defaultPreAuthorizeAmountMinimum?: Maybe<Scalars['Money']>;
  defaultPreAuthorizeAmountMultiplier?: Maybe<Scalars['Money']>;
  defaultPricingListId?: Maybe<Scalars['String']>;
  defaultSalesTerm?: Maybe<SalesTerm>;
  /**
   * The option that the courier-settings UI pre-selects in the pricing-rule
   * and surcharge forms. Pricing rules and surcharges each carry their own
   * `weightBasis`, which is what pricing reads today. A future "fall back to
   * this default when the rule has no basis" mode is deferred until needed.
   */
  defaultWeightBasis: WeightBasis;
  /**
   * Dimensional weight divisor: dim weight (lb) = (length * width * height) / dimFactor.
   * `null` means dim weight is disabled for this courier.
   */
  dimFactor?: Maybe<Scalars['Float']>;
  dispatcherCellPhoneNumber?: Maybe<Scalars['String']>;
  dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>;
  displayName: Scalars['String'];
  distanceUnit: DistanceUnit;
  driverPayStatementVisibility: DriverPayStatementVisibility;
  driverPodRequirementType: DriverPodRequirementType;
  driverPriceVisibilityType: DriverPriceVisibilityType;
  driverTaskVisibilityType: DriverTaskVisibilityType;
  driversMileageReimbursementMethod: DriversMileageReimbursementMethod;
  driversTimeRecordingMethod: DriversTimeRecordingMethod;
  dropOffPodRequirementType: PodRequirementAtStop;
  eiaDataSeriesIdDiesel?: Maybe<Scalars['String']>;
  eiaDataSeriesIdGas?: Maybe<Scalars['String']>;
  emailConfigurations: Array<CourierEmailConfiguration>;
  enabledCommunicationTypes: Array<CommunicationTypeId>;
  endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType;
  estimatedDwellTimeAtStopInSeconds?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  finixMerchantId?: Maybe<Scalars['String']>;
  freeWaitTimeInSeconds: Scalars['Int'];
  /**
   * This courier's saved fuel surcharge grids, or just the default grid when it has none
   * (see `FuelSurchargeGrid.isDefault`); empty when neither exists. More than one grid per
   * courier is planned. Pricing does not use saved grids yet. Requires pricing.view; null
   * only when the caller lacks it.
   */
  fuelSurchargeGrids?: Maybe<Array<FuelSurchargeGrid>>;
  gpsRestrictionType: GpsRestrictionType;
  holidaySchedules: Array<HolidaySchedule>;
  id: Scalars['ID'];
  invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType;
  invoiceCycleStartDate?: Maybe<Scalars['Date']>;
  invoiceExportType: InvoiceExportType;
  invoiceOrdersInclusionType: InvoiceOrdersInclusionType;
  isTestAccount: Scalars['Boolean'];
  liveRouteSequencingType: LiveRouteSequencingType;
  locationIdentifyTypesDropOff: Array<LocationIdentifyType>;
  locationIdentifyTypesPickUp: Array<LocationIdentifyType>;
  logoUrl: Scalars['String'];
  maxDistanceToCompleteTaskInMeters?: Maybe<Scalars['Int']>;
  minimumTimeRequiredForWaitTimeSurchargeInSeconds?: Maybe<Scalars['Int']>;
  multiStopPricingSequenceType: MultiStopPricingSequenceType;
  multiStopsOptimizationType: MultiStopsOptimizationType;
  name: Scalars['String'];
  orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType;
  orderIdentifierColumnType: OrderIdentifierColumnType;
  orderPriceTaxDisplayType?: Maybe<OrderPriceTaxDisplayType>;
  outOfTownSurchargeMultiplier?: Maybe<Scalars['Float']>;
  /**  Additional fields outside of couriers table */
  packageTypes: Array<PackageType>;
  pickupCloseTimesSetting: TimeWindowSetting;
  pickupPodRequirementType: PodRequirementAtStop;
  /**
   * Employee-only setting: the distance/duration source used for pricing
   * (trip previews, distance matrix). Not a route-optimization engine setting.
   */
  pricingDistanceSource: MapApi;
  primaryEmail?: Maybe<Scalars['String']>;
  primaryLocation?: Maybe<Location>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  returnPodRequirementType: PodRequirementAtStop;
  salesTerms: Array<SalesTerm>;
  shipmentsCustomFilters?: Maybe<ShipmentsCustomFilters>;
  startDate?: Maybe<Scalars['Date']>;
  stopCompletionGuard: StopCompletionGuard;
  taxRates: Array<CourierTaxRate>;
  timeFormatPreference: TimeFormatPreference;
  timeZoneId: Scalars['String'];
  vehicleTypes: Array<VehicleType>;
  weightUnit: WeightUnit;
};


export type CourierAgentsArgs = {
  agentType?: InputMaybe<AgentType>;
};

export type CourierBrand = {
  __typename?: 'CourierBrand';
  ccEmails?: Maybe<Array<Scalars['String']>>;
  city: Scalars['String'];
  country: Scalars['String'];
  courierId: Scalars['ID'];
  email: Scalars['String'];
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  replyToEmails?: Maybe<Array<Scalars['String']>>;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
};

/**
 * A courier's reply-to / cc email configuration for outbound end-customer emails. A null
 * communicationType is the org-wide default applied to every email type; a non-null value is
 * the override for that specific type.
 */
export type CourierEmailConfiguration = {
  __typename?: 'CourierEmailConfiguration';
  ccEmails?: Maybe<Array<Scalars['String']>>;
  communicationType?: Maybe<CommunicationTypeId>;
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  replyToEmails?: Maybe<Array<Scalars['String']>>;
};

export type CourierHoliday = {
  __typename?: 'CourierHoliday';
  id: Scalars['ID'];
  name: Scalars['String'];
  recurrenceRule: Scalars['String'];
};

export type CourierOfflineSettings = {
  __typename?: 'CourierOfflineSettings';
  gpsValidation: OfflineValidationMode;
  locationScanValidation: OfflineValidationMode;
  podValidation: OfflineValidationMode;
  questionValidation: OfflineValidationMode;
  scanValidation: OfflineValidationMode;
};

export type CourierSecret = {
  __typename?: 'CourierSecret';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  serviceType: CourierSecretServiceType;
};

export enum CourierSecretServiceType {
  GoogleMaps = 'GOOGLE_MAPS'
}

export type CourierTaxRate = {
  __typename?: 'CourierTaxRate';
  excludedServiceTypeIds: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  ratePercent: Scalars['Float'];
};

export type CourierTerm = {
  __typename?: 'CourierTerm';
  content: Scalars['String'];
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CoverageArea = {
  __typename?: 'CoverageArea';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  zoneIds: Array<Scalars['ID']>;
  /**
   * The full zone definitions referenced by `zoneIds`, resolved via the
   * standard zones-by-id loader.
   */
  zones: Array<Zone>;
};

export type CreateEmailTemplateInput = {
  body: Scalars['String'];
  courierId: Scalars['ID'];
  emailTypeId: Scalars['ID'];
  groupId: Scalars['ID'];
  subject: Scalars['String'];
};

export type CreatedMcpApiKey = {
  __typename?: 'CreatedMcpApiKey';
  /** The plain key. Returned only here, once; it can't be shown again. */
  key: Scalars['String'];
  mcpApiKey: McpApiKey;
};

/** Staff only: includes the internal note. */
export type Credit = {
  __typename?: 'Credit';
  amount: Scalars['Money'];
  applications: Array<CreditApplication>;
  availableAmount: Scalars['Money'];
  createdAt: Scalars['Timestamp'];
  createdBy: Scalars['String'];
  creditNumber: Scalars['String'];
  displayId: Scalars['Int'];
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  issuedOn: Scalars['Date'];
  note: Scalars['String'];
  sourceInvoice?: Maybe<Invoice>;
  sourceInvoiceId?: Maybe<Scalars['ID']>;
  status: CreditStatus;
};

export type CreditApplication = {
  __typename?: 'CreditApplication';
  amountApplied: Scalars['Money'];
  createdAt: Scalars['Timestamp'];
  createdBy: Scalars['String'];
  creditId: Scalars['ID'];
  id: Scalars['ID'];
  invoice: Invoice;
  invoiceId: Scalars['ID'];
};

export type CreditCardDetail = {
  __typename?: 'CreditCardDetail';
  brand: Scalars['String'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  lastFour: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** Credit Connection */
export type CreditConnection = {
  __typename?: 'CreditConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<CreditEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** Credit Edge */
export type CreditEdge = {
  __typename?: 'CreditEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<Credit>;
};

export enum CreditStatus {
  FullyApplied = 'FULLY_APPLIED',
  PartiallyApplied = 'PARTIALLY_APPLIED',
  Unapplied = 'UNAPPLIED'
}

export type CsvValidationCellError = {
  __typename?: 'CsvValidationCellError';
  columnName?: Maybe<Scalars['String']>;
  errorMessage: Scalars['String'];
};

export type CsvValidationError = {
  __typename?: 'CsvValidationError';
  errorMessages: Array<Scalars['String']>;
  lineErrors: Array<CsvValidationLineError>;
};

export type CsvValidationLineError = {
  __typename?: 'CsvValidationLineError';
  cellErrors: Array<CsvValidationCellError>;
  lineNumber: Scalars['Int'];
};

export type CustomField = {
  __typename?: 'CustomField';
  choices?: Maybe<Array<Scalars['String']>>;
  courierTerm?: Maybe<CourierTerm>;
  customerSpecificityType: CustomFieldCustomerSpecificity;
  customerVisibilityType: CustomFieldCustomerVisibilityType;
  defaultOptionIndex?: Maybe<Scalars['Int']>;
  helperText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isVisibleToDrivers: Scalars['Boolean'];
  maxValue?: Maybe<Scalars['Float']>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  orderingSequenceNumber?: Maybe<Scalars['Int']>;
  requirementType: CustomFieldCustomerRequirementType;
  terms?: Maybe<CustomFieldTermsConfig>;
  type: CustomFieldType;
};

export enum CustomFieldCustomerRequirementType {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export enum CustomFieldCustomerSpecificity {
  EndCustomerSpecific = 'END_CUSTOMER_SPECIFIC',
  Public = 'PUBLIC'
}

export enum CustomFieldCustomerVisibilityType {
  CustomerCreatable = 'CUSTOMER_CREATABLE',
  CustomerReadOnly = 'CUSTOMER_READ_ONLY',
  DispatcherOnly = 'DISPATCHER_ONLY'
}

export type CustomFieldTermsConfig = {
  __typename?: 'CustomFieldTermsConfig';
  courierTermId: Scalars['ID'];
  triggerChoice: Scalars['Int'];
};

export type CustomFieldTermsConfigInput = {
  courierTermId: Scalars['ID'];
  triggerChoice: Scalars['Int'];
};

export enum CustomFieldType {
  Integer = 'INTEGER',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  courierId: Scalars['ID'];
  entityId: Scalars['String'];
  field: CustomField;
  fieldId: Scalars['ID'];
  valueDisplay: Scalars['String'];
  valueInteger?: Maybe<Scalars['Int']>;
  valueNumber?: Maybe<Scalars['Float']>;
  valueText?: Maybe<Scalars['String']>;
};

export type CustomFieldValueInput = {
  fieldId: Scalars['ID'];
  valueInteger?: InputMaybe<Scalars['Int']>;
  valueNumber?: InputMaybe<Scalars['Float']>;
  valueText?: InputMaybe<Scalars['String']>;
};

export type CustomFilterOverview = {
  __typename?: 'CustomFilterOverview';
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type CustomRole = {
  __typename?: 'CustomRole';
  courierId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  overrides: Array<PermissionOverride>;
  parentRole: UserRoleType;
};

export enum CustomerPortalAdditionalRequiredFields {
  CompanyName = 'COMPANY_NAME',
  CostCenter = 'COST_CENTER',
  PackageDescription = 'PACKAGE_DESCRIPTION',
  PackageDimensions = 'PACKAGE_DIMENSIONS',
  PackageQuantity = 'PACKAGE_QUANTITY',
  PackageSize = 'PACKAGE_SIZE',
  PackageType = 'PACKAGE_TYPE',
  PackageWeight = 'PACKAGE_WEIGHT',
  PhoneNumber = 'PHONE_NUMBER',
  ReferenceNumber = 'REFERENCE_NUMBER',
  ServiceType = 'SERVICE_TYPE',
  Suite = 'SUITE',
  VehicleType = 'VEHICLE_TYPE'
}

export enum CustomerPortalDeliverByTimeVisibility {
  CanView = 'CAN_VIEW',
  Hidden = 'HIDDEN'
}

export enum CustomerPortalEtaVisibility {
  AlwaysShow = 'ALWAYS_SHOW',
  OnlyShowForNextTask = 'ONLY_SHOW_FOR_NEXT_TASK'
}

export enum CustomerPortalLocationCreateType {
  BlockNewLocationOnlyAllowAddressBook = 'BLOCK_NEW_LOCATION_ONLY_ALLOW_ADDRESS_BOOK',
  Default = 'DEFAULT'
}

export enum CustomerPortalNewCustomerPaymentMethodPromptType {
  None = 'NONE',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export enum CustomerPortalOrderEntryType {
  Form = 'FORM',
  Wizard = 'WIZARD'
}

export type CustomerSupportAgentSetting = {
  __typename?: 'CustomerSupportAgentSetting';
  /** Whether the voice assistant may cancel orders that have no driver yet. */
  cancelEnabled: Scalars['Boolean'];
  frequentlyAskedQuestions?: Maybe<Array<CustomerSupportFrequentlyAskedQuestion>>;
  /** What the courier wants callers to know, such as services, hours and areas served. */
  generalInformation?: Maybe<Scalars['String']>;
  /** How the courier wants the assistant to act on calls: tone, what to do and what not to do. Courie's safety rules still apply. */
  generalInstruction?: Maybe<Scalars['String']>;
  /** How the courier wants an order taken. When empty, the assistant uses Courie's default steps. */
  orderEntryInstruction?: Maybe<Scalars['String']>;
  /** Whether the voice assistant may quote and book orders. Tracking and prices work either way. */
  orderingEnabled: Scalars['Boolean'];
  /** Whether the voice assistant may change orders that have no driver yet. */
  updateEnabled: Scalars['Boolean'];
};

export type CustomerSupportAgentSettingInput = {
  cancelEnabled?: InputMaybe<Scalars['Boolean']>;
  /** At most 50; each question and answer at most 1,000 characters. Blank ones are dropped. */
  frequentlyAskedQuestions?: InputMaybe<Array<CustomerSupportFrequentlyAskedQuestionInput>>;
  /** At most 4,000 characters. */
  generalInformation?: InputMaybe<Scalars['String']>;
  /** At most 4,000 characters. */
  generalInstruction?: InputMaybe<Scalars['String']>;
  /** At most 4,000 characters. */
  orderEntryInstruction?: InputMaybe<Scalars['String']>;
  orderingEnabled?: InputMaybe<Scalars['Boolean']>;
  updateEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type CustomerSupportFrequentlyAskedQuestion = {
  __typename?: 'CustomerSupportFrequentlyAskedQuestion';
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type CustomerSupportFrequentlyAskedQuestionInput = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

export enum DateFormatPreference {
  DdMmYyyy = 'DD_MM_YYYY',
  MmDdYyyy = 'MM_DD_YYYY'
}

export enum DayOfTheWeek {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export enum DayType {
  BusinessDay = 'BUSINESS_DAY',
  CalendarDay = 'CALENDAR_DAY'
}

export type DispatchAdditionalFilters = {
  includeDrivers: Scalars['Boolean'];
  /** # if true, includes the drivers with the following filters. Otherwise, exclude them. */
  maxDistanceInMetersIfLocationExists?: InputMaybe<Scalars['Int']>;
  minimumVehicleCapacityInPoundsIfExists?: InputMaybe<Scalars['Int']>;
  vehicleTypeIdIfExists?: InputMaybe<Scalars['ID']>;
};

export enum DispatchPageType {
  DriverSchedule = 'DRIVER_SCHEDULE',
  Fleet = 'FLEET',
  Orders = 'ORDERS'
}

export type DispatchPreview = {
  __typename?: 'DispatchPreview';
  distanceAdditionalInMeters?: Maybe<Scalars['Float']>;
  distanceInMeters?: Maybe<Scalars['Float']>;
  driver: Driver;
  durationAdditionalInSeconds?: Maybe<Scalars['Float']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  numCurrentTasks: Scalars['Int'];
  remainingWorkloadInSeconds?: Maybe<Scalars['Float']>;
  shipment: Shipment;
  shipmentDate: Scalars['Date'];
  shipmentId: Scalars['ID'];
  tags: Array<DispatchPreviewTag>;
};

export enum DispatchPreviewReadyStatus {
  ReadyLater = 'READY_LATER',
  ReadyNow = 'READY_NOW',
  ReadySoon = 'READY_SOON'
}

export type DispatchPreviewSaveInput = {
  distanceAdditionalInMeters?: InputMaybe<Scalars['Float']>;
  distanceInMeters?: InputMaybe<Scalars['Float']>;
  driverId: Scalars['ID'];
  durationAdditionalInSeconds?: InputMaybe<Scalars['Float']>;
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  numCurrentTasks: Scalars['Int'];
  remainingWorkloadInSeconds?: InputMaybe<Scalars['Float']>;
  section?: InputMaybe<Scalars['String']>;
  shipmentId: Scalars['ID'];
  tags: Array<DispatchPreviewTag>;
};

export enum DispatchPreviewTag {
  Closest = 'CLOSEST',
  FastestDelivery = 'FASTEST_DELIVERY',
  LeastDeviation = 'LEAST_DEVIATION',
  LeastTasks = 'LEAST_TASKS',
  LeastWorkload = 'LEAST_WORKLOAD',
  NoLocationData = 'NO_LOCATION_DATA',
  NoTask = 'NO_TASK',
  TooFar = 'TOO_FAR',
  WeightCapacityLimit = 'WEIGHT_CAPACITY_LIMIT',
  WrongVehicleType = 'WRONG_VEHICLE_TYPE'
}

export enum DispatchScope {
  /**  The given shipment plus every dispatchable sibling in its assignment group. */
  AssignmentGroup = 'ASSIGNMENT_GROUP',
  /**  Only the given shipment. The default when the argument is absent. */
  SingleOrder = 'SINGLE_ORDER'
}

export enum DispatchSource {
  Dispatcher = 'DISPATCHER',
  Driver = 'DRIVER'
}

export type DispatchStopsOnDayInput = {
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']>>;
  orderingAlgorithmType: OrderingAlgorithmType;
  stopDate: Scalars['Date'];
  stopIds: Array<Scalars['ID']>;
};

/**
 * Whether this order may be sent to a driver. An order split into legs keeps the
 * price and the customer relationship, but the driving happens on its legs, so the
 * original is NON_DISPATCHABLE — it is a billing record, not work.
 */
export enum DispatchableType {
  Dispatchable = 'DISPATCHABLE',
  NonDispatchable = 'NON_DISPATCHABLE'
}

export enum DispatcherOrderEntryAdditionalField {
  Caller = 'CALLER',
  CallerPhone = 'CALLER_PHONE',
  CompanyName = 'COMPANY_NAME',
  CostCenter = 'COST_CENTER',
  DeliverBy = 'DELIVER_BY',
  PackageDescription = 'PACKAGE_DESCRIPTION',
  PackageDimensions = 'PACKAGE_DIMENSIONS',
  PackageQuantity = 'PACKAGE_QUANTITY',
  PackageSize = 'PACKAGE_SIZE',
  PackageType = 'PACKAGE_TYPE',
  PackageWeight = 'PACKAGE_WEIGHT',
  PhoneNumber = 'PHONE_NUMBER',
  ReadyTime = 'READY_TIME',
  ReferenceNumber = 'REFERENCE_NUMBER',
  RequiredCredentials = 'REQUIRED_CREDENTIALS',
  ServiceType = 'SERVICE_TYPE',
  Suite = 'SUITE',
  VehicleType = 'VEHICLE_TYPE'
}

export enum DistanceUnit {
  Kilometer = 'KILOMETER',
  Miles = 'MILES'
}

export enum DocumentType {
  BackgroundCheck = 'BACKGROUND_CHECK',
  BloodbornePathogenCertification = 'BLOODBORNE_PATHOGEN_CERTIFICATION',
  CarInsurance = 'CAR_INSURANCE',
  CommercialInsurance = 'COMMERCIAL_INSURANCE',
  CommercialVehicleInspection = 'COMMERCIAL_VEHICLE_INSPECTION',
  DriversLicense = 'DRIVERS_LICENSE',
  DrugTestResult = 'DRUG_TEST_RESULT',
  HazmatCertification = 'HAZMAT_CERTIFICATION',
  HipaaCertification = 'HIPAA_CERTIFICATION',
  MotorVehicleReport = 'MOTOR_VEHICLE_REPORT',
  ProofOfId = 'PROOF_OF_ID',
  ProofOfWorkAuthorization = 'PROOF_OF_WORK_AUTHORIZATION',
  RefrigerationCertification = 'REFRIGERATION_CERTIFICATION',
  SecurityClearance = 'SECURITY_CLEARANCE',
  SexualHarassmentTraining = 'SEXUAL_HARASSMENT_TRAINING',
  TdgCertification = 'TDG_CERTIFICATION',
  Tsa = 'TSA',
  VehicleRegistration = 'VEHICLE_REGISTRATION',
  WorksafeCertification = 'WORKSAFE_CERTIFICATION'
}

export type Driver = {
  __typename?: 'Driver';
  appVersion?: Maybe<Scalars['String']>;
  assignedLabels: Array<Label>;
  avatarDisplay?: Maybe<Scalars['String']>;
  baseWorkSchedule?: Maybe<DriverWorkSchedule>;
  commission?: Maybe<Scalars['Money']>;
  courier: Courier;
  courierId: Scalars['ID'];
  dailyEarningTarget?: Maybe<Scalars['Money']>;
  deactivatedAt?: Maybe<Scalars['Timestamp']>;
  deactivationScheduledAt?: Maybe<Scalars['Date']>;
  displayCity?: Maybe<Scalars['String']>;
  displayCountry?: Maybe<Scalars['String']>;
  displayState?: Maybe<Scalars['String']>;
  displayStreetAddress?: Maybe<Scalars['String']>;
  displayZip?: Maybe<Scalars['String']>;
  documents: Array<DriverDocument>;
  driverPaySummary: DriverPaySummary;
  email?: Maybe<Scalars['String']>;
  employmentType?: Maybe<DriverEmploymentType>;
  firstName: Scalars['String'];
  hasTaxId: Scalars['Boolean'];
  homeLocation?: Maybe<Location>;
  homeLocationId?: Maybe<Scalars['ID']>;
  hourlyRateOvertime: Scalars['Money'];
  hourlyRateRegular: Scalars['Money'];
  icCompanyName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastReportedLocation?: Maybe<DriverLocation>;
  locationHistory: Array<DriverLocation>;
  middleName?: Maybe<Scalars['String']>;
  mileageRate: Scalars['Money'];
  nextTimeEventPrompt?: Maybe<DriverTimeEventPrompt>;
  numRecurringStops: Scalars['Int'];
  odometerRequirement: OdometerRequirementType;
  outOfOrderTasks: Array<Task>;
  payrollPricingList?: Maybe<PricingList>;
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  remoteEntities: Array<RemoteEntity>;
  selfRoutingType: DriverSelfRoutingType;
  speed: Scalars['Float'];
  /**
   * searchTerm: free-text search over the task's order, using the same index as
   * shipments(simpleSearch:): contact, company, phone, address, instruction,
   * reference number, tracking number, order number, package description.
   * Every word must match; the last word matches as a prefix. The index is per
   * shipment, so a hit on one stop returns the driver's tasks for every stop of
   * that shipment. Null or blank means no filter.
   */
  tasks: Array<Task>;
  /** @deprecated Plaintext tax id is never returned. Use hasTaxId and updateDriverCompensation to change the value. */
  taxId?: Maybe<Scalars['String']>;
  /** # Additional fields that do not exist in drivers table belows */
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['ID']>;
  vehicleType?: Maybe<VehicleType>;
  weightCapacityInPounds?: Maybe<Scalars['Float']>;
  workType: DriverWorkType;
};


export type DriverDriverPaySummaryArgs = {
  maxDate: Scalars['Date'];
  minDate: Scalars['Date'];
  shipmentStatuses?: InputMaybe<Array<ShipmentStatus>>;
};


export type DriverLocationHistoryArgs = {
  after?: InputMaybe<Scalars['Timestamp']>;
  before?: InputMaybe<Scalars['Timestamp']>;
  date?: InputMaybe<Scalars['Date']>;
};


export type DriverNextTimeEventPromptArgs = {
  date: Scalars['Date'];
};


export type DriverNumRecurringStopsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type DriverOutOfOrderTasksArgs = {
  date: Scalars['Date'];
};


export type DriverTasksArgs = {
  date?: InputMaybe<Scalars['Date']>;
  maxDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  statusFilter?: InputMaybe<Array<TaskStatus>>;
};

export type DriverAnnouncement = {
  __typename?: 'DriverAnnouncement';
  description: Scalars['String'];
  priority: DriverAnnouncementPriority;
  title: Scalars['String'];
};

export enum DriverAnnouncementPriority {
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type DriverAnswer = {
  __typename?: 'DriverAnswer';
  answerNumber?: Maybe<Scalars['Float']>;
  answerPhotoUrl?: Maybe<Scalars['String']>;
  answerText?: Maybe<Scalars['String']>;
  driverQuestionId: Scalars['ID'];
  id: Scalars['ID'];
  question: DriverQuestion;
  taskId: Scalars['ID'];
};

export enum DriverAssignmentValidationType {
  None = 'NONE',
  ValidateSameDriverOnly = 'VALIDATE_SAME_DRIVER_ONLY'
}

export type DriverBreadcrumb = {
  __typename?: 'DriverBreadcrumb';
  curves: Array<DriverBreadcrumbCurve>;
  driverId: Scalars['ID'];
};

export type DriverBreadcrumbCurve = {
  __typename?: 'DriverBreadcrumbCurve';
  locations: Array<DriverLocation>;
};

export type DriverCompensation = {
  commission?: InputMaybe<Scalars['Money']>;
  dailyEarningTarget?: InputMaybe<Scalars['Money']>;
  hourlyRateOvertime: Scalars['Money'];
  hourlyRateRegular: Scalars['Money'];
  mileageRate: Scalars['Money'];
};

export type DriverCompliancePolicy = {
  __typename?: 'DriverCompliancePolicy';
  entityId: Scalars['ID'];
  excludedDocumentTypes: Array<DocumentType>;
  id: Scalars['ID'];
  requiredDocumentTypes: Array<DocumentType>;
  warnedDocumentTypes: Array<DocumentType>;
};

/** Driver Connection */
export type DriverConnection = {
  __typename?: 'DriverConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<DriverEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type DriverDailyWork = {
  __typename?: 'DriverDailyWork';
  dailyOvertimeWorkDuration: Scalars['Int'];
  dailyOvertimeWorkDurationInHours: Scalars['Float'];
  dailyRegularWorkDuration: Scalars['Int'];
  dailyRegularWorkDurationInHours: Scalars['Float'];
  date: Scalars['Date'];
  isConsistentEvents: Scalars['Boolean'];
  milesByOdometer: Scalars['Int'];
  workDurationInHours: Scalars['Float'];
  workDurationInMinutes: Scalars['Int'];
};

export type DriverDayOverview = {
  __typename?: 'DriverDayOverview';
  alternateUniverseDay: AlternateUniverseDriverDayOverview;
  date: Scalars['Date'];
  distanceSavedInMeters?: Maybe<Scalars['Float']>;
  driverId: Scalars['ID'];
  durationSavedInSeconds?: Maybe<Scalars['Float']>;
  routeOverview: RouteOverview;
};

export type DriverDaysOverview = {
  __typename?: 'DriverDaysOverview';
  distanceSavedInMeters: Scalars['Float'];
  driverId: Scalars['ID'];
  durationSavedInSeconds: Scalars['Float'];
  overviews: Array<DriverDayOverview>;
  totalDistanceInMeters: Scalars['Float'];
  totalDistanceInMetersAlternate: Scalars['Float'];
  totalDurationInSeconds: Scalars['Float'];
  totalDurationInSecondsAlternate: Scalars['Float'];
};

export type DriverDefaultRoutingConfiguration = {
  __typename?: 'DriverDefaultRoutingConfiguration';
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  endLocation?: Maybe<Location>;
  endLocationId?: Maybe<Scalars['ID']>;
  endTime?: Maybe<Scalars['Timestamp']>;
  isWorkDay?: Maybe<Scalars['Boolean']>;
  startLocation?: Maybe<Location>;
  startLocationId?: Maybe<Scalars['ID']>;
  startTime?: Maybe<Scalars['Timestamp']>;
  useCurrentLocationAtStart?: Maybe<Scalars['Boolean']>;
};

export type DriverDocument = {
  __typename?: 'DriverDocument';
  documentType: DocumentType;
  driver: Driver;
  driverId: Scalars['ID'];
  expirationDate?: Maybe<Scalars['Date']>;
  files: Array<StorageFile>;
  id: Scalars['ID'];
};

/** DriverDocument Connection */
export type DriverDocumentConnection = {
  __typename?: 'DriverDocumentConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<DriverDocumentEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** DriverDocument Edge */
export type DriverDocumentEdge = {
  __typename?: 'DriverDocumentEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<DriverDocument>;
};

export enum DriverDocumentSortField {
  CreatedAt = 'CREATED_AT',
  DocumentType = 'DOCUMENT_TYPE',
  DriverName = 'DRIVER_NAME',
  ExpirationDate = 'EXPIRATION_DATE'
}

export type DriverDocumentSorting = {
  direction: SortingDirection;
  field: DriverDocumentSortField;
};

/** Driver Edge */
export type DriverEdge = {
  __typename?: 'DriverEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<Driver>;
};

export enum DriverEmploymentType {
  Employee = 'EMPLOYEE',
  IndependentContractor = 'INDEPENDENT_CONTRACTOR'
}

export type DriverFullUpdate = {
  avatarDisplay?: InputMaybe<Scalars['String']>;
  commission?: InputMaybe<Scalars['Money']>;
  displayCity?: InputMaybe<Scalars['String']>;
  displayCountry?: InputMaybe<Scalars['String']>;
  displayState?: InputMaybe<Scalars['String']>;
  displayStreetAddress?: InputMaybe<Scalars['String']>;
  displayZip?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  homeLocationId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  odometerRequirement?: InputMaybe<OdometerRequirementType>;
  phone: Scalars['String'];
  selfRoutingType?: InputMaybe<DriverSelfRoutingType>;
  speed?: InputMaybe<Scalars['Float']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
  weightCapacityInPounds?: InputMaybe<Scalars['Float']>;
  workType?: InputMaybe<DriverWorkType>;
};

export type DriverLocation = {
  __typename?: 'DriverLocation';
  lastReportedTime: Scalars['Timestamp'];
  lngLat: LngLat;
};

export type DriverPayAllocation = {
  __typename?: 'DriverPayAllocation';
  allocationAmount?: Maybe<Scalars['Money']>;
  allocationRate?: Maybe<Scalars['Money']>;
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  shipmentId: Scalars['ID'];
};

export type DriverPayAllocationInput = {
  allocationAmount?: InputMaybe<Scalars['Money']>;
  allocationRate?: InputMaybe<Scalars['Money']>;
  driverId: Scalars['ID'];
};

export type DriverPayAllocationReplacement = {
  allocations: Array<DriverPayAllocationInput>;
  shipmentId: Scalars['ID'];
};

export type DriverPayDeduction = {
  __typename?: 'DriverPayDeduction';
  amount: Scalars['Money'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DriverPayDeductionValueInput = {
  amount: Scalars['Money'];
  name: Scalars['String'];
};

export type DriverPayEntry = {
  __typename?: 'DriverPayEntry';
  amountTotal: Scalars['Money'];
  deductionsTotal: Scalars['Money'];
  driver: Driver;
  driverId: Scalars['ID'];
  endDate: Scalars['Date'];
  id: Scalars['ID'];
  ordersCount: Scalars['Int'];
  pdfFile: PayrollReportFile;
  remoteEntities: Array<RemoteEntity>;
  startDate: Scalars['Date'];
  status: DriverPayStatus;
};

export type DriverPayEntryConnection = {
  __typename?: 'DriverPayEntryConnection';
  entries: Array<DriverPayEntry>;
  hasMore: Scalars['Boolean'];
};

export enum DriverPayExportType {
  None = 'NONE',
  Qbo = 'QBO'
}

export enum DriverPayStatementVisibility {
  ApprovedOnly = 'APPROVED_ONLY',
  IncludeUnapproved = 'INCLUDE_UNAPPROVED'
}

export enum DriverPayStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

export type DriverPaySummary = {
  __typename?: 'DriverPaySummary';
  numOrders: Scalars['Int'];
  totalPay: Scalars['Money'];
};

export enum DriverPayrollSortField {
  AmountTotal = 'AMOUNT_TOTAL',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverLastName = 'DRIVER_LAST_NAME',
  NumOrders = 'NUM_ORDERS'
}

export type DriverPayrollSorting = {
  direction: SortingDirection;
  field: DriverPayrollSortField;
};

export enum DriverPodRequirementType {
  DropOffOnly = 'DROP_OFF_ONLY',
  DropOffOnlyPhotoAndSignature = 'DROP_OFF_ONLY_PHOTO_AND_SIGNATURE',
  None = 'NONE',
  PickupAndDropOff = 'PICKUP_AND_DROP_OFF',
  PickupAndDropOffPhotoAndSignature = 'PICKUP_AND_DROP_OFF_PHOTO_AND_SIGNATURE'
}

export enum DriverPriceVisibilityType {
  None = 'NONE',
  ShowDriverPay = 'SHOW_DRIVER_PAY',
  ShowFullPrice = 'SHOW_FULL_PRICE'
}

export type DriverQuestion = {
  __typename?: 'DriverQuestion';
  choices?: Maybe<Array<Scalars['String']>>;
  courierId: Scalars['ID'];
  customerVisibility: DriverQuestionCustomerVisibility;
  id: Scalars['ID'];
  packageTypeIds?: Maybe<Array<Scalars['ID']>>;
  packageTypes: Array<PackageType>;
  question: Scalars['String'];
  requirementType: DriverQuestionRequirementType;
  sequenceNumber: Scalars['Int'];
  serviceTypeIds?: Maybe<Array<Scalars['ID']>>;
  serviceTypes: Array<ServiceType>;
  stopLabelIds?: Maybe<Array<Scalars['ID']>>;
  stopLabels: Array<Label>;
  stopTypes?: Maybe<Array<ShipmentStopType>>;
  type: DriverQuestionType;
};

export type DriverQuestionCreate = {
  choices?: InputMaybe<Array<Scalars['String']>>;
  /**  Optional. Omitted means INTERNAL_ONLY. */
  customerVisibility?: InputMaybe<DriverQuestionCustomerVisibility>;
  listId: Scalars['ID'];
  packageTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  question: Scalars['String'];
  requirementType: DriverQuestionRequirementType;
  sequenceNumber: Scalars['Int'];
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  stopLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  stopTypes?: InputMaybe<Array<ShipmentStopType>>;
  type: DriverQuestionType;
};

export enum DriverQuestionCustomerVisibility {
  InternalOnly = 'INTERNAL_ONLY',
  Show = 'SHOW'
}

export type DriverQuestionList = {
  __typename?: 'DriverQuestionList';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  inAdditionToBase: Scalars['Boolean'];
  isBase: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum DriverQuestionRequirementType {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export enum DriverQuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  Photo = 'PHOTO',
  Text = 'TEXT'
}

export type DriverQuestionUpdate = {
  choices?: InputMaybe<Array<Scalars['String']>>;
  /**
   *  Optional. Omitted on create means INTERNAL_ONLY.
   *  Omitted on fullUpdate PRESERVES the stored value rather than resetting it —
   *  deliberate, so clients that predate this field cannot silently un-share a
   *  question. See docs/superpowers/specs/2026-08-06-driver-question-customer-visibility-design.md
   */
  customerVisibility?: InputMaybe<DriverQuestionCustomerVisibility>;
  id: Scalars['ID'];
  packageTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  question: Scalars['String'];
  requirementType: DriverQuestionRequirementType;
  sequenceNumber: Scalars['Int'];
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  stopLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  stopTypes?: InputMaybe<Array<ShipmentStopType>>;
  type: DriverQuestionType;
};

export enum DriverReportColumnId {
  Driver = 'DRIVER',
  MileageReimbursement = 'MILEAGE_REIMBURSEMENT',
  MileageReimbursementMethod = 'MILEAGE_REIMBURSEMENT_METHOD',
  NumCompletedOrder = 'NUM_COMPLETED_ORDER',
  NumDaysWorked = 'NUM_DAYS_WORKED',
  OvertimeHourlyRate = 'OVERTIME_HOURLY_RATE',
  OvertimeWorkDuration = 'OVERTIME_WORK_DURATION',
  RegularHourlyRate = 'REGULAR_HOURLY_RATE',
  RegularWorkDuration = 'REGULAR_WORK_DURATION',
  ReimbursementPerMile = 'REIMBURSEMENT_PER_MILE',
  SuggestedBonus = 'SUGGESTED_BONUS',
  TotalCommission = 'TOTAL_COMMISSION',
  TotalMilesByGps = 'TOTAL_MILES_BY_GPS',
  TotalMilesByOdometer = 'TOTAL_MILES_BY_ODOMETER',
  TotalPay = 'TOTAL_PAY',
  TotalRevenue = 'TOTAL_REVENUE',
  TotalWorkDuration = 'TOTAL_WORK_DURATION',
  WageOvertime = 'WAGE_OVERTIME',
  WageRegular = 'WAGE_REGULAR',
  WageTotal = 'WAGE_TOTAL',
  WageTotalWithMileageReimbursement = 'WAGE_TOTAL_WITH_MILEAGE_REIMBURSEMENT'
}

export enum DriverReportGranularity {
  Daily = 'DAILY',
  Total = 'TOTAL'
}

export type DriverReportItem = {
  __typename?: 'DriverReportItem';
  deductions: Array<PayrollDeductionAmount>;
  driver: Driver;
  driverId: Scalars['String'];
  endDate: Scalars['Date'];
  mileageReimbursement: Scalars['Money'];
  mileageReimbursementMethod: DriversMileageReimbursementMethod;
  numCompletedOrder: Scalars['Int'];
  numDaysWorked: Scalars['Int'];
  overtimeDailyCalculatedWorkDurationInHours: Scalars['Float'];
  overtimeDailyCalculatedWorkDurationInMinutes: Scalars['Int'];
  overtimeHourlyRate: Scalars['Money'];
  regularDailyCalculatedWorkDurationInHours: Scalars['Float'];
  regularDailyCalculatedWorkDurationInMinutes: Scalars['Int'];
  regularHourlyRate: Scalars['Money'];
  reimbursementPerMile: Scalars['Money'];
  startDate: Scalars['Date'];
  suggestedBonus: Scalars['Money'];
  totalCommission: Scalars['Money'];
  totalMilesByGPS: Scalars['Int'];
  totalMilesByOdometer: Scalars['Int'];
  totalPay: Scalars['Money'];
  totalRevenue: Scalars['Money'];
  totalWorkDurationInHours: Scalars['Float'];
  totalWorkDurationInMinutes: Scalars['Int'];
  wageOvertime: Scalars['Money'];
  wageRegular: Scalars['Money'];
  wageTotal: Scalars['Money'];
  wageTotalWithMileageReimbursement: Scalars['Money'];
  workDurations: Array<DriverDailyWork>;
};

export type DriverScheduleForDate = {
  __typename?: 'DriverScheduleForDate';
  completedShipments: Array<Shipment>;
  confirmedAt?: Maybe<Scalars['Timestamp']>;
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  emailSentAt?: Maybe<Scalars['Timestamp']>;
  hasWorkloadChanged?: Maybe<Scalars['Boolean']>;
  labels: Array<Scalars['String']>;
  shipmentTemplates: Array<ShipmentTemplate>;
  shipments: Array<Shipment>;
  timeBlocks: Array<DriverScheduleTimeBlock>;
};

export type DriverScheduleForDates = {
  __typename?: 'DriverScheduleForDates';
  driver: Driver;
  schedule: Array<DriverScheduleForDate>;
};

export type DriverScheduleTimeBlock = {
  __typename?: 'DriverScheduleTimeBlock';
  end: Scalars['Timestamp'];
  start: Scalars['Timestamp'];
};

export type DriverScheduleTimeBlockInput = {
  end: Scalars['Timestamp'];
  start: Scalars['Timestamp'];
};

export type DriverScheduleWeekDaily = {
  __typename?: 'DriverScheduleWeekDaily';
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type DriverScheduleWeekDailyInput = {
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type DriverSchedulesResult = {
  __typename?: 'DriverSchedulesResult';
  driverSchedules: Array<DriverScheduleForDates>;
  unassignedShipments: Array<UnassignedShipmentsForDate>;
};

export enum DriverSelfRoutingType {
  CanSelfRoute = 'CAN_SELF_ROUTE',
  None = 'NONE'
}

export enum DriverSortField {
  CreatedAt = 'CREATED_AT',
  DeactivatedAt = 'DEACTIVATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  IsActive = 'IS_ACTIVE',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  WorkType = 'WORK_TYPE'
}

export type DriverSorting = {
  direction: SortingDirection;
  field: DriverSortField;
};

export enum DriverTaskVisibilityType {
  AllTasks = 'ALL_TASKS',
  OnlyNextTask = 'ONLY_NEXT_TASK'
}

export type DriverTimeEvent = {
  __typename?: 'DriverTimeEvent';
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  eventAt: Scalars['Timestamp'];
  eventType: DriverTimeEventType;
  id: Scalars['ID'];
  odometerInMiles?: Maybe<Scalars['Int']>;
  reason?: Maybe<DriverTimeEventReason>;
  updatedBy: Scalars['ID'];
};

export type DriverTimeEventCreateInput = {
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  eventAt: Scalars['Timestamp'];
  eventType: DriverTimeEventType;
  odometerInMiles?: InputMaybe<Scalars['Int']>;
  reason: DriverTimeEventReason;
};

export type DriverTimeEventInput = {
  odometerInMiles: Scalars['Int'];
  type: DriverTimeEventType;
};

export type DriverTimeEventPrompt = {
  __typename?: 'DriverTimeEventPrompt';
  type: DriverTimeEventPromptType;
};

export enum DriverTimeEventPromptType {
  TimeIn = 'TIME_IN',
  TimeOut = 'TIME_OUT'
}

export enum DriverTimeEventReason {
  LunchBreak = 'LUNCH_BREAK',
  WorkStartEnd = 'WORK_START_END'
}

export enum DriverTimeEventType {
  TimeIn = 'TIME_IN',
  TimeOut = 'TIME_OUT'
}

export type DriverTimeEventUpdateInput = {
  eventAt: Scalars['Timestamp'];
  eventType: DriverTimeEventType;
  id: Scalars['ID'];
  odometerInMiles?: InputMaybe<Scalars['Int']>;
  reason: DriverTimeEventReason;
};

export type DriverWorkSchedule = {
  __typename?: 'DriverWorkSchedule';
  weekDailyList: Array<DriverScheduleWeekDaily>;
};

export type DriverWorkScheduleInput = {
  weekDailyList: Array<DriverScheduleWeekDailyInput>;
};

export enum DriverWorkType {
  Regular = 'REGULAR',
  Specialized = 'SPECIALIZED'
}

export type DriversCsvFile = {
  __typename?: 'DriversCsvFile';
  url: Scalars['String'];
};

export enum DriversMileageReimbursementMethod {
  ByGps = 'BY_GPS',
  ByOdometer = 'BY_ODOMETER',
  NoMileageReimbursement = 'NO_MILEAGE_REIMBURSEMENT'
}

export type DriversReportFile = {
  __typename?: 'DriversReportFile';
  url: Scalars['String'];
};

export enum DriversTimeRecordingMethod {
  None = 'NONE',
  TimeInOut = 'TIME_IN_OUT'
}

/** EIA fuel rate context for a dynamic fuel surcharge (CRI-112). */
export type EiaFuelRate = {
  __typename?: 'EiaFuelRate';
  fuelType: FuelType;
  percent: Scalars['Float'];
  /** Dollars per gallon. Money (not Float) keeps EIA's 3-decimal precision, e.g. 4.141. */
  ratePerGallon: Scalars['Money'];
  /** EIA publication period (the Monday of the week the rate covers). */
  ratePeriod: Scalars['Date'];
};

/**
 * The EIA rate context for one dynamic fuel surcharge rule on an order, keyed by
 * surchargePricingRuleId so clients can label the matching breakdown line. Fetched
 * via eiaFuelRateLines — deliberately NOT a field on PricingBreakDownItem, so the
 * order-price read path stays untouched for the many callers that don't need it. (CRI-112)
 */
export type EiaFuelRateLine = {
  __typename?: 'EiaFuelRateLine';
  eiaFuelRate: EiaFuelRate;
  surchargePricingRuleId: Scalars['ID'];
};

export enum EmailDeliveryStatus {
  Bounced = 'BOUNCED',
  Created = 'CREATED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  SentToProvider = 'SENT_TO_PROVIDER'
}

export type EmailRecord = {
  __typename?: 'EmailRecord';
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  emailTypeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  remoteId?: Maybe<Scalars['String']>;
  status: EmailDeliveryStatus;
  statusReason?: Maybe<Scalars['String']>;
  statusUpdatedAt?: Maybe<Scalars['Timestamp']>;
  subject?: Maybe<Scalars['String']>;
  toEmails?: Maybe<Array<Scalars['String']>>;
};

/** EmailRecord Connection */
export type EmailRecordConnection = {
  __typename?: 'EmailRecordConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<EmailRecordEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** EmailRecord Edge */
export type EmailRecordEdge = {
  __typename?: 'EmailRecordEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<EmailRecord>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  body: Scalars['String'];
  courierId: Scalars['ID'];
  emailTypeId: Scalars['ID'];
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  subject: Scalars['String'];
};

export type EmailTemplateGroup = {
  __typename?: 'EmailTemplateGroup';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type EmailVariable = {
  __typename?: 'EmailVariable';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type EndCustomer = {
  __typename?: 'EndCustomer';
  accountComments: Array<EndCustomerComment>;
  accountStatus: EndCustomerAccountStatus;
  additionalRequiredFields?: Maybe<Array<CustomerPortalAdditionalRequiredFields>>;
  assignedLabels: Array<Label>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingCustomer?: Maybe<EndCustomer>;
  billingCustomerId?: Maybe<Scalars['ID']>;
  billingEmails: Array<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  billingStreetAddress?: Maybe<Scalars['String']>;
  billingZip?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  costCenters: Array<CostCenter>;
  courier: Courier;
  courierBrand?: Maybe<CourierBrand>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  customFields?: Maybe<Array<CustomField>>;
  customerPortalEtaVisibility?: Maybe<CustomerPortalEtaVisibility>;
  customerPortalLocationCreateType?: Maybe<CustomerPortalLocationCreateType>;
  defaultServiceTypeId?: Maybe<Scalars['ID']>;
  dispatcherOrderEntryAdditionalFields?: Maybe<Array<DispatcherOrderEntryAdditionalField>>;
  displayId: Scalars['Int'];
  driverQuestionList?: Maybe<DriverQuestionList>;
  driverQuestionListId?: Maybe<Scalars['ID']>;
  dropoffPodRequirement?: Maybe<PodRequirementAtStop>;
  emailTemplateGroup?: Maybe<EmailTemplateGroup>;
  emailTemplateGroupId?: Maybe<Scalars['ID']>;
  enabledCommunicationTypes: Array<CommunicationTypeId>;
  endCustomerCreatedSource?: Maybe<EndCustomerCreatedSource>;
  excludeConvenienceFees: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  firebaseUid?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  holidaySchedule?: Maybe<HolidaySchedule>;
  holidayScheduleId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  invoiceCycleStartDate?: Maybe<Scalars['Date']>;
  invoicePdfTemplate?: Maybe<InvoicePdfTemplate>;
  invoicingFrequency?: Maybe<InvoicingFrequency>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  newCustomerConfirmationStatus: NewCustomerConfirmationStatus;
  note?: Maybe<Scalars['String']>;
  paymentInstruments: Array<PaymentInstrument>;
  payrollPricingList?: Maybe<PricingList>;
  payrollPricingListId?: Maybe<Scalars['ID']>;
  pickupPodRequirement?: Maybe<PodRequirementAtStop>;
  podEmails?: Maybe<Array<Scalars['ID']>>;
  portalPriceVisibilityOverride?: Maybe<EndCustomerPriceVisibilityType>;
  preAuthorizeAmountMinimum?: Maybe<Scalars['Money']>;
  preAuthorizeAmountMultiplier?: Maybe<Scalars['Money']>;
  pricingList?: Maybe<PricingList>;
  pricingListId?: Maybe<Scalars['ID']>;
  remoteEntities: Array<RemoteEntity>;
  returnPodRequirement?: Maybe<PodRequirementAtStop>;
  salesTermId?: Maybe<Scalars['ID']>;
  scanRequirementType: ScanRequirement;
  stopCompletionGuard?: Maybe<StopCompletionGuard>;
  stopEtaCoercionType?: Maybe<StopEtaCoercionType>;
  suite?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
  totalPricingMultiplier: Scalars['Money'];
  visibleServiceTypeIds?: Maybe<Array<Scalars['ID']>>;
};

export enum EndCustomerAccountStatus {
  Active = 'ACTIVE',
  BlockOrderCreate = 'BLOCK_ORDER_CREATE'
}

export type EndCustomerComment = {
  __typename?: 'EndCustomerComment';
  createdAt: Scalars['Timestamp'];
  createdBy: Scalars['String'];
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type EndCustomerCommunication = {
  __typename?: 'EndCustomerCommunication';
  communicationTypeId?: Maybe<CommunicationTypeId>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  dateCreated: Scalars['Date'];
  email?: Maybe<EmailRecord>;
  emailId?: Maybe<Scalars['ID']>;
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  idempotencyToken?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  shipmentId?: Maybe<Scalars['ID']>;
  stopId?: Maybe<Scalars['ID']>;
};

/** EndCustomer Connection */
export type EndCustomerConnection = {
  __typename?: 'EndCustomerConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<EndCustomerEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type EndCustomerCreateInput = {
  companyName?: InputMaybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  courierId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
};

export enum EndCustomerCreatedSource {
  Api = 'API',
  CustomerPortal = 'CUSTOMER_PORTAL',
  User = 'USER'
}

/** EndCustomer Edge */
export type EndCustomerEdge = {
  __typename?: 'EndCustomerEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<EndCustomer>;
};

export type EndCustomerFullUpdate = {
  accountStatus?: InputMaybe<EndCustomerAccountStatus>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmails?: InputMaybe<Array<Scalars['String']>>;
  billingState?: InputMaybe<Scalars['String']>;
  billingStreetAddress?: InputMaybe<Scalars['String']>;
  billingZip?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  courierBrandId?: InputMaybe<Scalars['ID']>;
  customerPortalLocationCreateType?: InputMaybe<CustomerPortalLocationCreateType>;
  driverQuestionListId?: InputMaybe<Scalars['ID']>;
  emailTemplateGroupId?: InputMaybe<Scalars['ID']>;
  excludeConvenienceFees?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceCycleStartDate?: InputMaybe<Scalars['Date']>;
  invoicePdfTemplateId?: InputMaybe<Scalars['ID']>;
  invoicingFrequency: InvoicingFrequency;
  lastName?: InputMaybe<Scalars['String']>;
  payrollPricingListId?: InputMaybe<Scalars['ID']>;
  portalPriceVisibilityOverride?: InputMaybe<EndCustomerPriceVisibilityType>;
  preAuthorizeAmountMinimum?: InputMaybe<Scalars['Money']>;
  preAuthorizeAmountMultiplier?: InputMaybe<Scalars['Money']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  scanRequirementType?: InputMaybe<ScanRequirement>;
  stopCompletionGuard?: InputMaybe<StopCompletionGuard>;
  stopEtaCoercionType?: InputMaybe<StopEtaCoercionType>;
  suite?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  totalPricingMultiplier?: InputMaybe<Scalars['Money']>;
};

export type EndCustomerMinimumPhotoPodSettings = {
  __typename?: 'EndCustomerMinimumPhotoPodSettings';
  endCustomerId: Scalars['ID'];
  minimumPhotoCount: Scalars['Int'];
};

export enum EndCustomerPriceVisibilityType {
  None = 'NONE',
  ShowFullPrice = 'SHOW_FULL_PRICE',
  ShowToAccountHolder = 'SHOW_TO_ACCOUNT_HOLDER'
}

export type EndCustomerSalesTermUpdate = {
  endCustomerId: Scalars['ID'];
  salesTermId: Scalars['ID'];
};

export enum EndCustomerScope {
  All = 'ALL',
  Specific = 'SPECIFIC'
}

export enum EndCustomerSortField {
  CompanyName = 'COMPANY_NAME',
  ContactEmail = 'CONTACT_EMAIL',
  CreatedAt = 'CREATED_AT',
  DisplayId = 'DISPLAY_ID',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type EndCustomerSorting = {
  direction: SortingDirection;
  field: EndCustomerSortField;
};

export type EndCustomersCsvFile = {
  __typename?: 'EndCustomersCsvFile';
  url: Scalars['String'];
};

export type EndCustomersOverview = {
  __typename?: 'EndCustomersOverview';
  numUnconfirmedCustomerPortalEndCustomers: Scalars['Int'];
};

export type EndUser = {
  __typename?: 'EndUser';
  courierId: Scalars['String'];
  email: Scalars['String'];
  endCustomerId: Scalars['String'];
  firebaseUid?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role: EndUserRoleType;
};

export enum EndUserRoleType {
  Administrator = 'ADMINISTRATOR',
  OrderManager = 'ORDER_MANAGER'
}

export enum EntityType {
  Bill = 'Bill',
  Company = 'Company',
  CostCenter = 'CostCenter',
  Customer = 'Customer',
  DeductionItem = 'DeductionItem',
  Driver = 'Driver',
  Invoice = 'Invoice',
  Order = 'Order',
  Service = 'Service',
  Vendor = 'Vendor'
}

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

export type EveryNWeeksSchedule = {
  __typename?: 'EveryNWeeksSchedule';
  intervalWeeks: Scalars['Int'];
  startDateISO8601: Scalars['String'];
  weekDays: Array<DayOfTheWeek>;
};

export type EveryNWeeksScheduleInput = {
  intervalWeeks: Scalars['Int'];
  startDateISO8601: Scalars['String'];
  weekDays: Array<DayOfTheWeek>;
};

export type ExceptionReason = {
  __typename?: 'ExceptionReason';
  code: Scalars['String'];
  courierId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  finalState: ExceptionReasonFinalState;
  id: Scalars['ID'];
  name: Scalars['String'];
  reattemptConfigs: Array<ExceptionReattemptConfig>;
};

/** ExceptionReason Connection */
export type ExceptionReasonConnection = {
  __typename?: 'ExceptionReasonConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<ExceptionReasonEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export enum ExceptionReasonDriverAssignmentType {
  SameDriver = 'SAME_DRIVER',
  SameRouteGenerateIfMissing = 'SAME_ROUTE_GENERATE_IF_MISSING',
  SameRouteOnlyIfGenerated = 'SAME_ROUTE_ONLY_IF_GENERATED',
  Unassigned = 'UNASSIGNED'
}

/** ExceptionReason Edge */
export type ExceptionReasonEdge = {
  __typename?: 'ExceptionReasonEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<ExceptionReason>;
};

export type ExceptionReasonEndCustomerOverride = {
  __typename?: 'ExceptionReasonEndCustomerOverride';
  courierId: Scalars['ID'];
  endCustomer?: Maybe<EndCustomer>;
  endCustomerId: Scalars['ID'];
  exceptionReason?: Maybe<ExceptionReason>;
  exceptionReasonId: Scalars['ID'];
  finalState: ExceptionReasonFinalState;
  id: Scalars['ID'];
  reattemptConfigs: Array<ExceptionReattemptConfig>;
  /** Null means the override applies to every service type. */
  serviceTypeIds?: Maybe<Array<Scalars['ID']>>;
};

/** ExceptionReasonEndCustomerOverride Connection */
export type ExceptionReasonEndCustomerOverrideConnection = {
  __typename?: 'ExceptionReasonEndCustomerOverrideConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<ExceptionReasonEndCustomerOverrideEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** ExceptionReasonEndCustomerOverride Edge */
export type ExceptionReasonEndCustomerOverrideEdge = {
  __typename?: 'ExceptionReasonEndCustomerOverrideEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<ExceptionReasonEndCustomerOverride>;
};

export enum ExceptionReasonFinalState {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  UnassignedAndHold = 'UNASSIGNED_AND_HOLD'
}

export type ExceptionReattemptConfig = {
  __typename?: 'ExceptionReattemptConfig';
  dayType: DayType;
  driverAssignmentType: ExceptionReasonDriverAssignmentType;
  numDays: Scalars['Int'];
  proofOfDeliveryRequirement: PodRequirementAtStop;
};

export type ExceptionReattemptConfigInput = {
  dayType: DayType;
  driverAssignmentType: ExceptionReasonDriverAssignmentType;
  numDays: Scalars['Int'];
  proofOfDeliveryRequirement: PodRequirementAtStop;
};

export type FcmToken = {
  __typename?: 'FcmToken';
  driverId: Scalars['ID'];
  fcmToken: Scalars['String'];
};

export type FeeTransfer = {
  __typename?: 'FeeTransfer';
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  parentPaymentTransfer?: Maybe<PaymentTransfer>;
  parentPaymentTransferId?: Maybe<Scalars['ID']>;
  remoteId?: Maybe<Scalars['String']>;
  remoteParentTransferId?: Maybe<Scalars['String']>;
  remoteState?: Maybe<Scalars['String']>;
  settlementId?: Maybe<Scalars['ID']>;
};

/** FeeTransfer Connection */
export type FeeTransferConnection = {
  __typename?: 'FeeTransferConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<FeeTransferEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** FeeTransfer Edge */
export type FeeTransferEdge = {
  __typename?: 'FeeTransferEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<FeeTransfer>;
};

export enum FileType {
  Document = 'DOCUMENT',
  Photo = 'PHOTO',
  Signature = 'SIGNATURE'
}

export type FuelSurchargeGrid = {
  __typename?: 'FuelSurchargeGrid';
  /** Sorted by minRate. */
  bands: Array<FuelSurchargeGridBand>;
  createdAt: Scalars['Timestamp'];
  /** Email of the user who uploaded this grid. */
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** True when this is the shared default grid, not the courier's own. */
  isDefault: Scalars['Boolean'];
};

/**
 * A fuel price range and its surcharge percents. Money (not Float) keeps the exact
 * 3-decimal rates and percents, like EiaFuelRate.ratePerGallon.
 */
export type FuelSurchargeGridBand = {
  __typename?: 'FuelSurchargeGridBand';
  dieselPercent: Scalars['Money'];
  gasPercent: Scalars['Money'];
  /** Fuel price in $/gallon, not included in the band. Null means "and above". */
  maxRate?: Maybe<Scalars['Money']>;
  /** Fuel price in $/gallon, included in the band. */
  minRate: Scalars['Money'];
};

export enum FuelType {
  Diesel = 'DIESEL',
  Gas = 'GAS'
}

export type GenerateResetPasswordLinkResult = {
  __typename?: 'GenerateResetPasswordLinkResult';
  link?: Maybe<Scalars['String']>;
};

export enum GpsRestrictionType {
  AllowOutsideGeofence = 'ALLOW_OUTSIDE_GEOFENCE',
  BlockOutsideGeofence = 'BLOCK_OUTSIDE_GEOFENCE'
}

/** Where the handed-over stops go in the new driver's day. */
export enum HandOverPlacement {
  Append = 'APPEND',
  Prepend = 'PREPEND'
}

export type HandOverResult = {
  __typename?: 'HandOverResult';
  movedShipmentCount: Scalars['Int'];
};

export enum HoldStatus {
  None = 'NONE',
  OnHold = 'ON_HOLD'
}

export enum HolidayBehavior {
  AlwaysInstantiate = 'ALWAYS_INSTANTIATE',
  Cancel = 'CANCEL',
  NextBusinessDay = 'NEXT_BUSINESS_DAY',
  PreviousBusinessDay = 'PREVIOUS_BUSINESS_DAY'
}

export type HolidaySchedule = {
  __typename?: 'HolidaySchedule';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type HolidayScheduleBehavior = {
  __typename?: 'HolidayScheduleBehavior';
  behavior: HolidayBehavior;
  courierHolidayId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
  name: Scalars['String'];
  recurrenceRule: Scalars['String'];
};

export type HolidaySchedulePricingAmount = {
  __typename?: 'HolidaySchedulePricingAmount';
  baseAmount?: Maybe<Scalars['Money']>;
  holidayScheduleId: Scalars['ID'];
  minimumAmount?: Maybe<Scalars['Money']>;
  pricePerMileAmount?: Maybe<Scalars['Money']>;
};

export type HolidaySchedulePricingAmountInput = {
  baseAmount?: InputMaybe<Scalars['Money']>;
  holidayScheduleId: Scalars['ID'];
  minimumAmount?: InputMaybe<Scalars['Money']>;
  pricePerMileAmount?: InputMaybe<Scalars['Money']>;
};

export type HolidaySchedulePricingAmountList = {
  __typename?: 'HolidaySchedulePricingAmountList';
  schedules: Array<HolidaySchedulePricingAmount>;
};

export type HolidaySchedulePricingAmountListInput = {
  schedules: Array<HolidaySchedulePricingAmountInput>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amountTotal: Scalars['Money'];
  appliedTaxes: Array<AppliedTax>;
  approvedAt?: Maybe<Scalars['Timestamp']>;
  communications: Array<EndCustomerCommunication>;
  costCenter?: Maybe<CostCenter>;
  costCenterId?: Maybe<Scalars['String']>;
  courierId: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  creditApplications: Array<InvoiceCreditApplication>;
  displayId: Scalars['Int'];
  endCustomer: EndCustomer;
  endCustomerId: Scalars['String'];
  endCustomerPayLink?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  id: Scalars['ID'];
  invoiceNumber: Scalars['String'];
  invoicePaymentStatus: InvoicePaymentStatus;
  isForceGenerated: Scalars['Boolean'];
  paymentSource?: Maybe<InvoicePaymentResource>;
  /**
   *  BLU-70: set while the invoice is in the Refunded tab; cleared when it returns to PAID.
   *  Refund history lives on payment transfers, not this flag.
   */
  refundedAt?: Maybe<Scalars['Timestamp']>;
  remoteEntities: Array<RemoteEntity>;
  separateGenerationKey?: Maybe<Scalars['String']>;
  separateGenerationType?: Maybe<SeparateInvoiceGenerationType>;
  startDate: Scalars['Date'];
  status: InvoiceStatus;
};

export enum InvoiceApprovalPreconditionType {
  None = 'NONE',
  OrderMustBeClosed = 'ORDER_MUST_BE_CLOSED'
}

export type InvoiceBalance = {
  __typename?: 'InvoiceBalance';
  invoiceId: Scalars['ID'];
  manualPaymentsForInvoice: Array<InvoiceManualPayment>;
  remainingBalance: Scalars['Money'];
  transfers: Array<PaymentTransfer>;
};

/** Invoice Connection */
export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** Customer-safe view of an applied credit; never carries the note. */
export type InvoiceCreditApplication = {
  __typename?: 'InvoiceCreditApplication';
  amountApplied: Scalars['Money'];
  appliedAt: Scalars['Timestamp'];
  creditId: Scalars['ID'];
  creditNumber: Scalars['String'];
  id: Scalars['ID'];
};

export enum InvoiceDetailColumnFields {
  AllCustomFields = 'ALL_CUSTOM_FIELDS',
  CallerEmail = 'CALLER_EMAIL',
  CallerNameAndPhone = 'CALLER_NAME_AND_PHONE',
  DeliveredAt = 'DELIVERED_AT',
  DeliveryInstruction = 'DELIVERY_INSTRUCTION',
  Destination = 'DESTINATION',
  Distance = 'DISTANCE',
  DriverName = 'DRIVER_NAME',
  EndCustomerReferenceNumber = 'END_CUSTOMER_REFERENCE_NUMBER',
  OrderPlacedBy = 'ORDER_PLACED_BY',
  Origin = 'ORIGIN',
  PackageCount = 'PACKAGE_COUNT',
  PackageSize = 'PACKAGE_SIZE',
  PackageType = 'PACKAGE_TYPE',
  PackageWeight = 'PACKAGE_WEIGHT',
  PickedUpAt = 'PICKED_UP_AT',
  PickupInstruction = 'PICKUP_INSTRUCTION',
  PodSignName = 'POD_SIGN_NAME',
  RoundTripIfApplicable = 'ROUND_TRIP_IF_APPLICABLE',
  SurchargesVisible = 'SURCHARGES_VISIBLE',
  TrackingNumber = 'TRACKING_NUMBER',
  VehicleType = 'VEHICLE_TYPE'
}

export type InvoiceDocument = {
  __typename?: 'InvoiceDocument';
  id: Scalars['ID'];
  invoiceId: Scalars['ID'];
  invoicePdfTemplateId?: Maybe<Scalars['ID']>;
  url: Scalars['String'];
};

/** Invoice Edge */
export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<Invoice>;
};

export type InvoiceEmailSendInput = {
  attachCsv: Scalars['Boolean'];
  attachOrderAttachments?: Scalars['Boolean'];
  attachPdf: Scalars['Boolean'];
  combineIntoSinglePdf?: Scalars['Boolean'];
  emailRecipientsCommaSeparated: Scalars['String'];
  invoiceId: Scalars['ID'];
};

export enum InvoiceExportType {
  None = 'NONE',
  Qbo = 'QBO'
}

export type InvoiceExtendedDetail = {
  __typename?: 'InvoiceExtendedDetail';
  amountTotal: Scalars['Money'];
  invoice: Invoice;
  shipments: Array<Shipment>;
};

export type InvoiceIdAndEmailSendErrorPair = {
  __typename?: 'InvoiceIdAndEmailSendErrorPair';
  error?: Maybe<Scalars['String']>;
  invoiceId: Scalars['String'];
};

export type InvoiceIdAndEmailSendPair = {
  __typename?: 'InvoiceIdAndEmailSendPair';
  endCustomerCommunication: EndCustomerCommunication;
  invoiceId: Scalars['String'];
};

export type InvoiceManualBulkPayment = {
  __typename?: 'InvoiceManualBulkPayment';
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  paidOn: Scalars['Date'];
};

export type InvoiceManualBulkPaymentAllocationInput = {
  amount: Scalars['Money'];
  invoiceId: Scalars['ID'];
};

export type InvoiceManualPayment = {
  __typename?: 'InvoiceManualPayment';
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  invoice: Invoice;
  invoiceId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  paidOn: Scalars['Date'];
};

/** InvoiceManualPayment Connection */
export type InvoiceManualPaymentConnection = {
  __typename?: 'InvoiceManualPaymentConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<InvoiceManualPaymentEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** InvoiceManualPayment Edge */
export type InvoiceManualPaymentEdge = {
  __typename?: 'InvoiceManualPaymentEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<InvoiceManualPayment>;
};

export enum InvoiceOrdersInclusionType {
  HideZeroOrders = 'HIDE_ZERO_ORDERS',
  ShowAll = 'SHOW_ALL'
}

export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  allocatedAmount: Scalars['Money'];
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  invoice: Invoice;
  invoiceId: Scalars['ID'];
  paymentTransferId: Scalars['ID'];
};

export enum InvoicePaymentResource {
  CourieAndManualPayment = 'COURIE_AND_MANUAL_PAYMENT',
  CouriePayment = 'COURIE_PAYMENT',
  Credit = 'CREDIT',
  Manual = 'MANUAL',
  QuickbookOnlineSync = 'QUICKBOOK_ONLINE_SYNC'
}

export enum InvoicePaymentStatus {
  Paid = 'PAID',
  PartialPaid = 'PARTIAL_PAID',
  PaymentProcessing = 'PAYMENT_PROCESSING',
  Unpaid = 'UNPAID'
}

export enum InvoicePdfColumn {
  Amount = 'AMOUNT',
  CustomDetails = 'CUSTOM_DETAILS',
  Date = 'DATE',
  DateReadyServiceTypeDeliverDate = 'DATE_READY_SERVICE_TYPE_DELIVER_DATE',
  Destination = 'DESTINATION',
  DestinationShortCompanyName = 'DESTINATION_SHORT_COMPANY_NAME',
  DestinationWithTime = 'DESTINATION_WITH_TIME',
  FullBreakdown = 'FULL_BREAKDOWN',
  OrderId = 'ORDER_ID',
  OrderIdCaller = 'ORDER_ID_CALLER',
  Origin = 'ORIGIN',
  OriginShortCompanyName = 'ORIGIN_SHORT_COMPANY_NAME',
  OriginWithTime = 'ORIGIN_WITH_TIME',
  Package = 'PACKAGE',
  ReferencesCostCenter = 'REFERENCES_COST_CENTER',
  ServiceAbbreviated = 'SERVICE_ABBREVIATED',
  ServiceFull = 'SERVICE_FULL',
  SurchargesVisible = 'SURCHARGES_VISIBLE',
  TrackingNumber = 'TRACKING_NUMBER',
  VehicleType = 'VEHICLE_TYPE'
}

export type InvoicePdfColumnWithWidth = {
  __typename?: 'InvoicePdfColumnWithWidth';
  column: InvoicePdfColumn;
  widthPercentage: Scalars['Money'];
};

export type InvoicePdfColumnWithWidthInput = {
  column: InvoicePdfColumn;
  widthPercentage: Scalars['Money'];
};

export type InvoicePdfTemplate = {
  __typename?: 'InvoicePdfTemplate';
  borderSize: Scalars['Float'];
  brandColor: Scalars['String'];
  columnsWithWidth: Array<InvoicePdfColumnWithWidth>;
  courierId: Scalars['String'];
  detailColumnFields: Array<InvoiceDetailColumnFields>;
  finalMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  labelColor: Scalars['String'];
  largeTextFontSize: Scalars['Float'];
  marginLeft: Scalars['Float'];
  name: Scalars['String'];
  orderCombinationType: OrderCombinationType;
  returnSlipType: InvoiceReturnSlipType;
  separateGenerationType: SeparateInvoiceGenerationType;
  showTableBorder: Scalars['Boolean'];
  smallTextFontSize: Scalars['Float'];
  subtotalGroupedByCustomField?: Maybe<CustomField>;
  subtotalGroupedByCustomFieldId?: Maybe<Scalars['String']>;
  subtotalGroupedByType: InvoiceSubtotalGroupByType;
  subtotalPageBreakType: InvoiceSubtotalPageBreakType;
  summaryDisplayType: InvoiceSummaryDisplayType;
  tableContentFontSize: Scalars['Float'];
};

/** InvoicePdfTemplate Connection */
export type InvoicePdfTemplateConnection = {
  __typename?: 'InvoicePdfTemplateConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<InvoicePdfTemplateEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type InvoicePdfTemplateCreateInput = {
  brandColor: Scalars['String'];
  columnsWithWidth: Array<InvoicePdfColumnWithWidthInput>;
  detailColumnFields: Array<InvoiceDetailColumnFields>;
  finalMessage?: InputMaybe<Scalars['String']>;
  largeTextFontSize?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  orderCombinationType?: InputMaybe<OrderCombinationType>;
  returnSlipType?: InputMaybe<InvoiceReturnSlipType>;
  separateGenerationType: SeparateInvoiceGenerationType;
  smallTextFontSize?: InputMaybe<Scalars['Float']>;
  subtotalGroupedByCustomFieldId?: InputMaybe<Scalars['String']>;
  subtotalGroupedByType: InvoiceSubtotalGroupByType;
  subtotalPageBreakType: InvoiceSubtotalPageBreakType;
  summaryDisplayType: InvoiceSummaryDisplayType;
  tableContentFontSize?: InputMaybe<Scalars['Float']>;
};

/** InvoicePdfTemplate Edge */
export type InvoicePdfTemplateEdge = {
  __typename?: 'InvoicePdfTemplateEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<InvoicePdfTemplate>;
};

export type InvoicePdfTemplateUpdateInput = {
  brandColor: Scalars['String'];
  columnsWithWidth: Array<InvoicePdfColumnWithWidthInput>;
  detailColumnFields: Array<InvoiceDetailColumnFields>;
  finalMessage?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  largeTextFontSize?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  orderCombinationType?: InputMaybe<OrderCombinationType>;
  returnSlipType?: InputMaybe<InvoiceReturnSlipType>;
  separateGenerationType: SeparateInvoiceGenerationType;
  smallTextFontSize?: InputMaybe<Scalars['Float']>;
  subtotalGroupedByCustomFieldId?: InputMaybe<Scalars['String']>;
  subtotalGroupedByType: InvoiceSubtotalGroupByType;
  subtotalPageBreakType: InvoiceSubtotalPageBreakType;
  summaryDisplayType: InvoiceSummaryDisplayType;
  tableContentFontSize?: InputMaybe<Scalars['Float']>;
};

export enum InvoiceReturnSlipType {
  IncludeInTheBeginning = 'INCLUDE_IN_THE_BEGINNING',
  None = 'NONE'
}

export enum InvoiceSortField {
  ApprovedAt = 'APPROVED_AT',
  DisplayId = 'DISPLAY_ID',
  EndCustomerName = 'END_CUSTOMER_NAME',
  EndDate = 'END_DATE',
  StartDate = 'START_DATE'
}

export type InvoiceSorting = {
  direction: SortingDirection;
  field: InvoiceSortField;
};

export enum InvoiceStatus {
  Approved = 'APPROVED',
  ToReview = 'TO_REVIEW',
  Voided = 'VOIDED'
}

export enum InvoiceSubtotalGroupByType {
  CostCenter = 'COST_CENTER',
  CustomField = 'CUSTOM_FIELD',
  EndCustomerReferenceNumber = 'END_CUSTOMER_REFERENCE_NUMBER',
  None = 'NONE'
}

export enum InvoiceSubtotalPageBreakType {
  None = 'NONE',
  PageBreakEachSubtotal = 'PAGE_BREAK_EACH_SUBTOTAL'
}

export enum InvoiceSummaryDisplayType {
  ByGroupedByField = 'BY_GROUPED_BY_FIELD',
  None = 'NONE'
}

export type InvoicesOverview = {
  __typename?: 'InvoicesOverview';
  numPartialPaid: Scalars['Int'];
  numPaymentProcessing: Scalars['Int'];
  /**  BLU-70: approved invoices with refunded_at set. Cleared when payment status returns to PAID. */
  numRefunded: Scalars['Int'];
  numToReview: Scalars['Int'];
  numUnpaid: Scalars['Int'];
};

export enum InvoicingFrequency {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  NoInvoice = 'NO_INVOICE',
  PerOrder = 'PER_ORDER',
  PerOrderPreAuthorize = 'PER_ORDER_PRE_AUTHORIZE',
  SemiMonthly = 'SEMI_MONTHLY',
  Weekly = 'WEEKLY',
  WeeklySplitByMonth = 'WEEKLY_SPLIT_BY_MONTH'
}

export type IssueWithSuggestions = {
  __typename?: 'IssueWithSuggestions';
  description: Scalars['String'];
  suggestions: Array<Scalars['String']>;
  tag: Scalars['String'];
};

export type KeyValuePair = {
  __typename?: 'KeyValuePair';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Label = {
  __typename?: 'Label';
  color?: Maybe<Scalars['String']>;
  courierId: Scalars['ID'];
  entityType: LabelEntityType;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum LabelEntityType {
  Driver = 'DRIVER',
  EndCustomer = 'END_CUSTOMER',
  Order = 'ORDER',
  Stop = 'STOP',
  Zone = 'ZONE'
}

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  accountExpiresAt?: Maybe<Scalars['Timestamp']>;
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  isValid: Scalars['Boolean'];
  isValidAndFresh: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  provider: ApiProvider;
  remoteId: Scalars['String'];
};

export type LinkedAccountCreate = {
  accessToken: Scalars['String'];
  accessTokenExpiresInSeconds?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  provider: ApiProvider;
  refreshToken?: InputMaybe<Scalars['String']>;
  refreshTokenExpiresInSeconds?: InputMaybe<Scalars['Int']>;
  remoteId: Scalars['String'];
};

export type LiveRoute = {
  __typename?: 'LiveRoute';
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  routeTemplate?: Maybe<RouteTemplate>;
  routeTemplateId?: Maybe<Scalars['ID']>;
  statusList: Array<RouteStatus>;
  /**
   * The route's stops in sequence. With `endCustomerIds`, only the stops whose order belongs to one
   * of those accounts, still in route order; without it, every stop on the route. The customer
   * portal passes its active account so a route shared between customers shows each of them only
   * their own stops (CRI-191).
   */
  stopsInSequence: Array<Stop>;
};


export type LiveRouteStopsInSequenceArgs = {
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** LiveRoute Connection */
export type LiveRouteConnection = {
  __typename?: 'LiveRouteConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<LiveRouteEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** LiveRoute Edge */
export type LiveRouteEdge = {
  __typename?: 'LiveRouteEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<LiveRoute>;
};

export enum LiveRouteSequencingType {
  InterleaveRoutes = 'INTERLEAVE_ROUTES',
  KeepRoutesGrouped = 'KEEP_ROUTES_GROUPED'
}

export enum LiveRoutesSortField {
  Name = 'NAME'
}

export type LiveRoutesSorting = {
  direction: SortingDirection;
  field: LiveRoutesSortField;
};

export type LngLat = {
  __typename?: 'LngLat';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type LngLatInput = {
  lat?: InputMaybe<Scalars['Coordinate']>;
  lng?: InputMaybe<Scalars['Coordinate']>;
};

export type Location = {
  __typename?: 'Location';
  city: Scalars['String'];
  country: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lngLat: LngLat;
  locationValidityType: LocationValidityType;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  zipCode?: Maybe<Scalars['String']>;
};

export enum LocationIdentifyType {
  City = 'CITY',
  CompanyName = 'COMPANY_NAME',
  CompanyNameWithCityState = 'COMPANY_NAME_WITH_CITY_STATE',
  FullAddressWithCompanyName = 'FULL_ADDRESS_WITH_COMPANY_NAME',
  FullAddressWithCompanyNameAndSuite = 'FULL_ADDRESS_WITH_COMPANY_NAME_AND_SUITE',
  StreetAddress = 'STREET_ADDRESS',
  Zip = 'ZIP',
  Zone = 'ZONE'
}

export type LocationResult = {
  __typename?: 'LocationResult';
  location?: Maybe<Location>;
};

export type LocationScanCode = {
  __typename?: 'LocationScanCode';
  addressDisplay: Scalars['String'];
  code: Scalars['String'];
  courierId: Scalars['ID'];
  customerIds?: Maybe<Array<Scalars['ID']>>;
  description?: Maybe<Scalars['String']>;
  endCustomers: Array<EndCustomer>;
  id: Scalars['ID'];
  lngLat: LngLat;
  referenceLocationId?: Maybe<Scalars['ID']>;
  requirementType: LocationScanRequirement;
  suite?: Maybe<Scalars['String']>;
};

export type LocationScanCodeConnection = {
  __typename?: 'LocationScanCodeConnection';
  edges: Array<LocationScanCodeEdge>;
  pageInfo: PageInfo;
};

export type LocationScanCodeEdge = {
  __typename?: 'LocationScanCodeEdge';
  cursor: Scalars['String'];
  node: LocationScanCode;
};

export enum LocationScanCodesSortField {
  AddressDisplay = 'ADDRESS_DISPLAY',
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  Description = 'DESCRIPTION',
  RequirementType = 'REQUIREMENT_TYPE',
  Suite = 'SUITE'
}

export type LocationScanCodesSorting = {
  direction: SortingDirection;
  field: LocationScanCodesSortField;
};

export enum LocationScanRequirement {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

/** Whether this location's coordinate really points at the address. */
export enum LocationValidityType {
  /**
   * The address could not be found, so the coordinate is a 0,0 placeholder. Distance,
   * zone and price shown for this location mean nothing until the address is fixed.
   */
  FakeCoordinate = 'FAKE_COORDINATE',
  /** The coordinate came from a real lookup and points at the address. */
  Valid = 'VALID'
}

export type LocationsResultOverview = {
  __typename?: 'LocationsResultOverview';
  locations: Array<Location>;
  totalDistanceInMiles?: Maybe<Scalars['Float']>;
};

/**
 * The distance/duration source used for pricing (trip previews, distance
 * matrix). Not a route-optimization engine setting.
 */
export enum MapApi {
  Google = 'GOOGLE',
  Mapbox = 'MAPBOX',
  Osrm = 'OSRM'
}

export type MatchedSubstring = {
  __typename?: 'MatchedSubstring';
  length: Scalars['Int'];
  offset: Scalars['Int'];
};

/**  A per-courier key for the MCP server (tools.courie.ai/mcp). The key itself is never stored. */
export type McpApiKey = {
  __typename?: 'McpApiKey';
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  invalidatedAt?: Maybe<Scalars['Timestamp']>;
  invalidatedBy?: Maybe<Scalars['String']>;
  /** First characters of the key, to tell keys apart. */
  keyPrefix: Scalars['String'];
  name: Scalars['String'];
  /** What the key may be used for; decides which MCP tools accept it. */
  purpose: McpApiKeyPurpose;
};

export enum McpApiKeyPurpose {
  /** A courier's Customer Support (Vapi) assistant: only tools safe to show an end customer. */
  CustomerSupport = 'CUSTOMER_SUPPORT'
}

export type MemorizationOnDay = {
  __typename?: 'MemorizationOnDay';
  day?: Maybe<Scalars['Date']>;
  dayOfWeek?: Maybe<DayOfTheWeek>;
  stopTemplateSequenceNumbers: Array<ScheduledStopTemplateSequenceNumber>;
  unmemorizedShipmentTemplates: Array<ShipmentTemplate>;
  unmemorizedStopTemplates: Array<StopTemplate>;
};

export type MemorizationResult = {
  __typename?: 'MemorizationResult';
  days: Array<MemorizationOnDay>;
};

export type MonthlySchedule = {
  __typename?: 'MonthlySchedule';
  days: Array<Scalars['Int']>;
};

export type MonthlyScheduleInput = {
  days: Array<Scalars['Int']>;
};

export enum MultiStopPricingSequenceType {
  ActualRoute = 'ACTUAL_ROUTE',
  OrderEntrySequence = 'ORDER_ENTRY_SEQUENCE'
}

export enum MultiStopsOptimizationType {
  KeepOrderEntrySequence = 'KEEP_ORDER_ENTRY_SEQUENCE',
  OptimizeBySystem = 'OPTIMIZE_BY_SYSTEM'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Employee-only: adds a courier-specific analytics dashboard row. */
  addCourierAnalyticsDashboard: AnalyticsDashboard;
  addEndCustomerComment: EndCustomerComment;
  addRecurringOrdersToRouteTemplate: RouteTemplate;
  addStopTemplateIdsToPackageMovement: PackageMovement;
  applyCredit: CreditApplication;
  approveDriverPay: DriverPayEntry;
  approveInvoice: Invoice;
  approveInvoices: BulkInvoiceApprovalResult;
  approveRoutingJob: RoutingJob;
  approveShipmentDetails: Shipment;
  /**
   * Assigns a billable item to an order (template or live), or unassigns when
   * billableItemId is null. Rejected when the order is already invoiced or
   * absorbed into an additional invoice line item.
   */
  assignBillableItemToOrder: Order;
  assignDefaultDriverId?: Maybe<Scalars['ID']>;
  assignDriverForShipmentTemplates: Array<ShipmentTemplate>;
  assignDriverVehicleType?: Maybe<Driver>;
  assignHolidayScheduleToEndCustomer: EndCustomer;
  assignHolidayScheduleToRecurringOrder?: Maybe<Order>;
  assignLabelsToEntities: Scalars['Int'];
  assignPricingListToEndCustomer: EndCustomer;
  assignShipmentsToLiveRoute: LiveRoute;
  attachAnswerPhotoToOrder: OrderAttachment;
  autocompleteAddress: Array<AddressPrediction>;
  /**
   * Mints a single-order invoice dated to the order's completion date, for any invoicing
   * frequency, ignoring the customer's high-water mark. Fails when the order is not completed,
   * already has an invoice, or its customer is NO_INVOICE.
   */
  backfillInvoiceForOrder: Invoice;
  /**
   * Invoices every orphaned order of the courier completed within [startDate, endDate]: a
   * completed, uninvoiced order whose customer is per-order, or whose completion date is already
   * behind the customer's invoicing high-water mark (frequency switched after completion, order
   * moved to another customer, invoice voided, backdated force complete). Per-order customers get
   * one invoice per order; periodic customers one catch-up invoice per generation group, dated to
   * the earliest..latest completion date. NO_INVOICE customers are skipped. Never touches existing
   * invoices; safe to re-run. The nightly invoice cron runs the same sweep over the last 30 days.
   */
  backfillOrphanedOrderInvoices: Array<Invoice>;
  /**
   * Applies an order group builder to a set of orders.
   *
   * Supported build types are COMBINE_INTO_ONE, ROUND_TRIP_TWO_LEGS and MIDDLE_STOP_TWO_LEGS.
   * COMBINE_INTO_ONE links the orders into one group and leaves everything else about them.
   * ROUND_TRIP_TWO_LEGS splits a round trip into an outbound order and a return order.
   * MIDDLE_STOP_TWO_LEGS splits a simple order into a billing-only original and two driver
   * legs through the builder's warehouse stop.
   * assignmentGroups must be absent for both split types.
   * Any other build type is rejected.
   *
   * orderIds lists every member of the group. assignmentGroups optionally partitions
   * them; a builder whose assignmentType is SINGLE_GROUP needs exactly one entry
   * containing exactly those orders, and a builder whose assignmentType is NONE must
   * get none. Sequencing is the builder's decision, never the request's.
   */
  buildOrderGroups: Array<OrderGroup>;
  bulkApproveDriverPays: BulkApproveDriverPaysResults;
  bulkDeleteAddressBook?: Maybe<Scalars['Boolean']>;
  bulkDeleteEndCustomers: Scalars['Int'];
  bulkDeletePricingRules: Scalars['Int'];
  bulkDispatchDriverForShipments: BulkDispatchResults;
  bulkForceCompleteShipments: Array<Shipment>;
  bulkMultiplyPricingRules: BulkMultiplyPricingRulesResult;
  bulkUnassignDriversFromShipment: Array<Shipment>;
  bulkUpdateOrderInvoiceDate: Array<Order>;
  bulkUploadAddressBook?: Maybe<BulkUploadAddressBookResult>;
  bulkUploadCallerContacts: BulkUploadCallerContactsResult;
  bulkUploadEndCustomers: BulkUploadEndCustomersResult;
  bulkUploadOrders: BulkUploadOrdersResult;
  bulkUploadPackageMovements: BulkUploadPackageMovementsResult;
  bulkUploadPricingLists: BulkUploadPricingListsResult;
  bulkUploadPricingRules: BulkUploadPricingRulesResult;
  bulkUploadRecurringOrders: BulkUploadRecurringOrdersResult;
  bulkUploadSurcharges: BulkUploadSurchargesResult;
  calculateExtraSecondsFromMilesOverLimitForServiceType?: Maybe<Scalars['Int']>;
  cancelRoutingJob: RoutingJob;
  cancelScheduledDriverDeactivation: Driver;
  changePasswordDriver: Driver;
  changePasswordEndCustomer: EndCustomer;
  changePasswordEndUser: EndUser;
  changePasswordUser: CourieUser;
  changeSequenceForRouteTemplate: RouteTemplate;
  clearDriverPhoto: Driver;
  clearHoldStatus: Array<Shipment>;
  clearOrderLegDistanceOverride: Scalars['Boolean'];
  completeTaskV1: Task;
  completeTasksInBulkV1: Array<Task>;
  convertQuotesToOrders: Array<Shipment>;
  copyMemorizations: Array<MemorizationOnDay>;
  createAddressBook: AddressBookEntry;
  createAgent: Agent;
  createBillableItem: BillableItem;
  createBulkRerateJob: BulkRerateJobResult;
  createBulkScanEvents: BulkScanResult;
  createCallerContact: CallerContact;
  createCircleZone: CircleZone;
  createCostCenter: CostCenter;
  createCourier: Courier;
  createCourierBrand: CourierBrand;
  /**
   * Employee-only: create a courier holiday — an RRULE-based recurring date
   * (RFC5545 recurrence rule). Managed in the Admin UI; separate from the
   * per-recurring-order holiday behavior (e.g. Do Not Create Order).
   */
  createCourierHoliday: CourierHoliday;
  createCourierTerm: CourierTerm;
  createCredit: Credit;
  createCustomField: CustomField;
  createCustomRole: CustomRole;
  createDriver: Driver;
  createDriverDocument: DriverDocument;
  createDriverQuestion: DriverQuestion;
  createDriverQuestionList: DriverQuestionList;
  createEmailTemplate?: Maybe<EmailTemplate>;
  createEmailTemplateGroup?: Maybe<EmailTemplateGroup>;
  createEndCustomer: EndCustomer;
  createEndUser: EndUser;
  createExceptionReason: ExceptionReason;
  createExceptionReasonEndCustomerOverride: ExceptionReasonEndCustomerOverride;
  createHolidaySchedule: HolidaySchedule;
  createInvoiceManualPayment: InvoiceManualPayment;
  createInvoicePdfTemplate: InvoicePdfTemplate;
  createLabel: Label;
  createLiveOrder: Order;
  createLocationScanCode: LocationScanCode;
  /** Courie employees only. Creates an MCP key for a courier (e.g. for its Vapi assistant). */
  createMcpApiKey: CreatedMcpApiKey;
  createMultiInvoiceManualPayment: InvoiceManualBulkPayment;
  createOneOffOrder?: Maybe<Scalars['ID']>;
  createOrderAttachments: Array<OrderAttachment>;
  createOrderAutomationRule: OrderAutomation;
  createOrderGroupBuilder: OrderGroupBuilder;
  createPackageEventType: PackageEventType;
  createPackageMovement: PackageMovement;
  createPackageType: PackageType;
  createPartner: Partner;
  createPaymentAdditionalFeeRule: PaymentAdditionalFeeRule;
  createPaymentInstrument: PaymentInstrument;
  createPayrollDeductionRule: PayrollDeductionRule;
  createPricingList: PricingList;
  createPricingRule: PricingRule;
  createQuote: QuoteResult;
  createRecurringOrder?: Maybe<Scalars['ID']>;
  createRouteTemplate: RouteTemplate;
  createRoutingJob: RoutingJob;
  createSavedView: SavedView;
  createScanEvent: PackageEventResult;
  createSecret: CourierSecret;
  createServiceType: ServiceType;
  createSurchargePricingRule: SurchargePricingRule;
  createUser: CourieUser;
  createVehicleType: VehicleType;
  createWebhookSubscription: WebhookSubscription;
  createZipGroup: ZipGroup;
  createZone: Zone;
  createZones: Array<Zone>;
  deactivateDriver: Driver;
  deleteAddressBook?: Maybe<Scalars['Boolean']>;
  deleteBillableItem: Scalars['Boolean'];
  deleteCallerContact: Scalars['Boolean'];
  deleteCircleZone: Scalars['Boolean'];
  deleteCourierBrand: Scalars['Boolean'];
  /**
   * Soft-deletes the reply-to / cc configuration for a communication type (null deletes the
   * org-wide default); emails of that type fall through to the default afterwards. Returns
   * true when a configuration existed and was deleted.
   */
  deleteCourierEmailConfiguration: Scalars['Boolean'];
  /**
   * Employee-only: delete a courier holiday. Any holiday-schedule behaviors
   * referencing it are removed as well.
   */
  deleteCourierHoliday: Scalars['Boolean'];
  deleteCredit: Credit;
  deleteCustomRole: Scalars['Boolean'];
  deleteDriver: Driver;
  deleteDriverCompliancePolicy: Scalars['Boolean'];
  deleteDriverDocument: Scalars['Boolean'];
  deleteDriverQuestion: DriverQuestion;
  deleteDriverQuestionList: DriverQuestionList;
  deleteEmailTemplate?: Maybe<Scalars['Boolean']>;
  deleteEmailTemplateGroup?: Maybe<Scalars['Boolean']>;
  deleteExceptionReason: Scalars['Boolean'];
  deleteExceptionReasonEndCustomerOverride: Scalars['Boolean'];
  deleteFirebaseUserForDriver: Driver;
  deleteFirebaseUserForEndCustomer: EndCustomer;
  deleteHolidaySchedule: Scalars['Boolean'];
  deleteHolidayScheduleBehavior: Scalars['Boolean'];
  deleteInvoicePdfTemplate: Scalars['Boolean'];
  deleteLabel: Scalars['Boolean'];
  deleteLinkedAccount: Scalars['Boolean'];
  deleteLocationScanCode: LocationScanCode;
  deleteOrderAttachment: Scalars['Boolean'];
  deleteOrderAutomationRule: Scalars['Boolean'];
  deleteOrderGroupBuilder: Scalars['Boolean'];
  deletePackageEventType: PackageEventType;
  deletePackageType: PackageType;
  deletePaymentInstrument: Scalars['Boolean'];
  deletePayrollDeductionRule: PayrollDeductionRule;
  deletePricingList: Scalars['Boolean'];
  deletePricingRule: Scalars['Boolean'];
  deleteQuote: Quote;
  deleteRouteTemplate: RouteTemplate;
  deleteSavedView: Scalars['Boolean'];
  deleteScheduledTransfer: Scalars['Boolean'];
  deleteServiceType: ServiceType;
  deleteSurchargePricingRule: Scalars['Boolean'];
  deleteVehicleType: VehicleType;
  dispatchDriverForShipment?: Maybe<Scalars['ID']>;
  dispatchDriverForShipmentMultiDay?: Maybe<Scalars['ID']>;
  /**
   * Employee-only: allows Metabase for a courier and creates the Metabase user
   * immediately instead of waiting for the sync cron. No-op if already created.
   */
  enableCourierMetabase: Courier;
  excludeStopTemplateIdsFromPackageMovement: PackageMovement;
  exportPricingRulesCsv: PricingRulesCsvFile;
  exportSurchargeRulesCsv: SurchargeRulesCsvFile;
  finalizeOrderPricing: Scalars['Int'];
  /** Dispatcher: manual task arrivals and/or shipment unfree wait override; returns updated shipments in input order. */
  forceArriveForShipments: Array<Shipment>;
  forceCompleteShipment: Shipment;
  forceCompleteStops: Shipment;
  forceExportDriverPay: DriverPayEntry;
  forceGenerateInvoices: Array<Invoice>;
  forceInstantiateRecurringOrders: Array<Order>;
  forceMarkAsAttempted: Scalars['ID'];
  /**
   * Regenerates the live route for a route template on a given date on demand so that post-generation
   * edits to the route template (e.g. adjusted stop times) are reflected immediately.
   *
   * If no live route exists for (routeTemplateId, targetDate) yet, one is generated from scratch from the
   * current template. If a live route already exists, it is regenerated: the route's template-based
   * recurring-order instances are torn down and recreated from the current template, while manually-added
   * shipments and the route's current driver are preserved, and the operation is rejected if any stop is
   * already in progress or completed.
   *
   * `respectOrderLevelSchedule` controls which of the route's orders are (re)generated: when true, only
   * orders whose own recurrence schedule occurs on `targetDate` are generated (normal behavior); when
   * false, every order on the route template is generated regardless of its per-order schedule.
   */
  forceRegenerateLiveRoute: LiveRoute;
  forceSendReceipt: Scalars['ID'];
  fullUpdateAddressBook: AddressBookEntry;
  fullUpdateAgent: Agent;
  fullUpdateBillableItem: BillableItem;
  fullUpdateCallerContact: CallerContact;
  /** Deprecated: Use sparseUpdateColumnVisibility instead */
  fullUpdateColumnVisibility: VisibleColumnsConfig;
  fullUpdateCostCenter: CostCenter;
  fullUpdateCourierBrand: CourierBrand;
  fullUpdateCustomField: CustomField;
  fullUpdateDriver: Driver;
  fullUpdateDriverDocument: DriverDocument;
  fullUpdateDriverQuestion: DriverQuestion;
  fullUpdateDriverQuestionList: DriverQuestionList;
  fullUpdateEmailTemplate?: Maybe<EmailTemplate>;
  fullUpdateEmailTemplateGroup?: Maybe<EmailTemplateGroup>;
  fullUpdateEndCustomer: EndCustomer;
  fullUpdateExceptionReason: ExceptionReason;
  fullUpdateExceptionReasonEndCustomerOverride: ExceptionReasonEndCustomerOverride;
  fullUpdateInvoicePdfTemplate: InvoicePdfTemplate;
  fullUpdateLabel: Label;
  fullUpdateLocation: LocationResult;
  fullUpdateLocationScanCode: LocationScanCode;
  fullUpdateOrder: Order;
  fullUpdateOrderAutomationRule: OrderAutomation;
  fullUpdateOrderGroupBuilder: OrderGroupBuilder;
  fullUpdatePackageEventType: PackageEventType;
  fullUpdatePackageType: PackageType;
  fullUpdatePaymentAdditionalFeeRule: PaymentAdditionalFeeRule;
  fullUpdatePayrollDeductionRule: PayrollDeductionRule;
  fullUpdatePriceList: PricingList;
  fullUpdatePricingRule: PricingRule;
  fullUpdateRecurringOrder: Order;
  fullUpdateSavedView: SavedView;
  fullUpdateServiceType: ServiceType;
  fullUpdateSurchargePricingRule: SurchargePricingRule;
  fullUpdateUser: CourieUser;
  fullUpdateVehicleType: VehicleType;
  fullUpdateZipGroup: ZipGroup;
  generateAccountStatementCsv: Scalars['String'];
  /**
   * Generates a single Bill-of-Lading PDF containing all input orders (one BoL
   * per page, page-break between orders), uploads it once, and returns a URL.
   *
   * Returns `[BillOfLadingDoc!]!` for backward compatibility — every existing
   * caller (per-row web/portal buttons, partners REST API) was written against
   * the original "N orders in, N docs out" shape but only ever passes N=1 and
   * reads `[0].pdfUrl`. The list shape is preserved so those callers continue
   * working unchanged; in practice the list **always contains exactly one
   * element** regardless of input length.
   *
   * At N>1 the returned doc's `orderId` is set to the first input order's id —
   * there is no single owning order for a merged PDF, and the schema requires
   * `orderId: ID!` to be non-null. No caller reads this field today, so the
   * choice is effectively cosmetic; the first-order anchor matches the
   * underlying GCS filename convention (`BillOfLading-{firstOrder.displayId}-{ms}.pdf`).
   */
  generateBillOfLadingPdf: Array<BillOfLadingDoc>;
  generateCsvForDrivers: DriversCsvFile;
  generateCsvForEndCustomers: EndCustomersCsvFile;
  generateCsvForInvoices: Scalars['String'];
  generateCsvForOrders: OrdersCsvFile;
  generateCsvForRecurringOrders: OrdersCsvFile;
  generateDriverHoursWorkedReport?: Maybe<DriversReportFile>;
  generateDriversReportCsv?: Maybe<DriversReportFile>;
  generateInvoiceSummaryCsv: Scalars['String'];
  generateOrdersPdf: OrdersFile;
  generatePayrollReport?: Maybe<PayrollReportFile>;
  generatePdfForInvoice: InvoiceDocument;
  generatePdfForInvoices: InvoiceDocument;
  generateResetPasswordLink: GenerateResetPasswordLinkResult;
  generateSalesReportCsv?: Maybe<SalesReportFile>;
  getOrCreateEndCustomerAccountNumber?: Maybe<Scalars['String']>;
  getOrCreateLocationFromCoordinate: LocationResult;
  getOrCreateLocations: Array<LocationResult>;
  getOrCreateLocationsWithOverview: LocationsResultOverview;
  getOrForceInstantiateRecurringOrders: Array<Order>;
  getOrGenerateDriverPayEntries: Array<DriverPayEntry>;
  /** Moves a driver's unfinished orders and routes for one day to another driver. */
  handOverDriverDay: HandOverResult;
  initiateInvoicePayment: InvoicePayment;
  initiateInvoicePayments?: Maybe<BulkInvoicePaymentResult>;
  initiateInvoiceRefund: InvoicePayment;
  /** A portal user tells Courie which of their customers a support call they just started is for. */
  linkSupportCall: SupportCall;
  markArtifactAsDeleted: Artifact;
  markAsArrivedV1: Task;
  markAsAttempted: Task;
  markAsHold: Array<Shipment>;
  markCostCenterDeleted?: Maybe<Scalars['Boolean']>;
  markCustomFieldAsDeleted: Scalars['Boolean'];
  markDriverQuestionListAsBase: DriverQuestionList;
  markEndCustomerConfirmedAsNew: EndCustomer;
  markEndCustomerDeleted?: Maybe<Scalars['Boolean']>;
  markEndUserAsDeleted: Scalars['ID'];
  markInvoiceAsPaidManually: Array<Invoice>;
  markInvoicePdfTemplateAsDefault: InvoicePdfTemplate;
  markShipmentAsClosed: Shipment;
  markShipmentAsDeleted: Shipment;
  markShipmentAsFailed: Shipment;
  markShipmentTemplatesAsDeleted: Array<ShipmentTemplate>;
  markShipmentsAsClosed: Array<Shipment>;
  markShipmentsAsConfirmed: Array<Shipment>;
  markShipmentsAsDeleted: Array<Shipment>;
  /**
   *  Marks the given stop templates as fixed sequence for the given shipment template and courier.
   *  This is different from upsertStopTemplateSequenceNumbers because it 'fixes' the sequence numbers
   *  inside the Shipment rather than per driver.
   */
  markStopTemplatesAsFixedSequence: Array<StopTemplate>;
  markUnassignedShipmentAsFailed: Shipment;
  markUserAsDeleted: CourieUser;
  mergeEndCustomers: EndCustomer;
  mergeOrders: Order;
  modifyDriverPayDeductions: DriverPayEntry;
  modifyDriverTimeEvents: Array<DriverTimeEvent>;
  modifyOrderPricing: OrderPrice;
  optimizeRouteForDispatch: OptimizeRouteForDispatchResult;
  overrideAdjustmentAmount: PricingAdjustment;
  overrideOrderLegDistance: TripDistanceOverride;
  overrideOrderMiles: Order;
  overridePodMetadata: Shipment;
  overridePricingDetail: Shipment;
  /**  Overrides the completed_at times for completed stops */
  overrideStopCompletedTimes: Array<Stop>;
  overrideTripDistance: TripDistanceOverride;
  previewInvoicePdfFromCreate: InvoiceDocument;
  previewInvoicePdfFromUpdate: InvoiceDocument;
  previewOrderPricingModification: PreviewOrderPricingModificationResult;
  previewPrice: PreviewPriceResult;
  /**  Generates a PDF manifest for a driver's LIVE route on a specific day */
  printLiveRoutePdf: StorageFile;
  /**  Generates a PDF manifest for a driver's planned route on a specific day of the week */
  printMemorizationsPdf: StorageFile;
  proposeShipmentDetails: Shipment;
  randomizeTimes: Scalars['ID'];
  reactivateDriver: Driver;
  reassignLiveRoute: LiveRoute;
  recordDriverLocation: Scalars['ID'];
  recordMobileAppError: Scalars['Boolean'];
  recordOrderClick: Scalars['Boolean'];
  recordPromptAction: PromptAction;
  /**  Courie employees only: brings an existing Customer Support assistant up to today's instructions. */
  refreshCustomerSupportAssistant: Agent;
  refreshDispatchPreviews: RefreshDispatchPreviewsResult;
  refreshEtaStale: Driver;
  removeRecurringOrdersFromRouteTemplate: RouteTemplate;
  removeTripDistanceOverride: Scalars['Boolean'];
  renameRouteTemplate: RouteTemplate;
  reorderLiveRouteSequence: LiveRoute;
  replaceAllocation: Array<DriverPayAllocation>;
  replaceRoute: Array<Task>;
  replaceRoutingVehicleSequence: Array<RoutingNode>;
  replaceSalesCommissions: Array<SalesCommission>;
  resetShipment: Shipment;
  revertStopCompletion: Shipment;
  saveFirebaseSignUp: Scalars['Boolean'];
  scanCreate: Artifact;
  scanCreateInBulk: BulkArtifactsResult;
  scanVerify: Artifact;
  scanVerifyInBulk: BulkArtifactsResult;
  scheduleDriverDeactivation: Driver;
  scheduleTransfer: ScheduledTransfer;
  sendBulkPaymentReminderEmails: BulkPaymentReminderEmailResults;
  sendCommunicationToEndCustomer?: Maybe<EndCustomerCommunication>;
  sendDriverScheduleConfirmationEmails: Array<Scalars['ID']>;
  sendEmailToDrivers: PayrollEmail;
  sendInvoiceEmail?: Maybe<EndCustomerCommunication>;
  sendInvoiceEmails?: Maybe<BulkInvoiceEmailSendResults>;
  sendPasswordResetEmail?: Maybe<Scalars['Int']>;
  setDefaultSavedView: Scalars['Boolean'];
  setDriverQuestionsSequence: Array<DriverQuestion>;
  setDriverScheduleOverride: DriverScheduleForDate;
  setEmailTemplateGroupAsDefault?: Maybe<EmailTemplateGroup>;
  setEndCustomerRequiredFields: EndCustomer;
  setOrderAutomationRuleOptedOut: OrderAutomation;
  sparseUpdateColumnVisibility: VisibleColumnsConfig;
  startTaskV1: Task;
  syncDriverWithFirebase: SyncDriverWithFirebaseResult;
  syncEndCustomerWithFirebase: SyncEndCustomerWithFirebaseResult;
  syncInvoice: Invoice;
  syncUserWithFirebase: SyncUserWithFirebaseResult;
  transferShipment: Array<RoutingNode>;
  triggerRecurringOrderGeneration: Scalars['String'];
  unapplyCredit: CreditApplication;
  unassignDriverFromShipment: Shipment;
  unassignLabelsFromEntity: Scalars['Int'];
  uncloseShipment: Shipment;
  uncloseShipments: Array<Shipment>;
  unfinalizeOrderPricing: Scalars['Int'];
  unsetDefaultEmailTemplateGroup?: Maybe<Scalars['Boolean']>;
  updateBasePriceOverride: Order;
  updateBillingEndCustomerId: EndCustomer;
  updateCircleZone: CircleZone;
  updateCommissionableBase: Order;
  /**
   * Employee-only: sets the distance/duration source used for pricing
   * (trip previews, distance matrix). Not a route-optimization engine setting.
   */
  updateCourierDistanceSource: Courier;
  /** Employee-only: update a courier holiday's name and recurrence rule. */
  updateCourierHoliday: CourierHoliday;
  updateCourierOpsSettings: Courier;
  updateCourierSettings?: Maybe<Courier>;
  updateCustomRoleOverrides: CustomRole;
  updateDeliverySettings?: Maybe<Courier>;
  updateDispatchSettings?: Maybe<Courier>;
  updateDriverAppVersion: Driver;
  updateDriverAvailabilityV1: Driver;
  updateDriverBaseWorkSchedule: Driver;
  updateDriverCompensation: Driver;
  updateDriverPayOverride: Order;
  updateDriverReportedWaitTime: Stop;
  updateDriverSettings?: Maybe<Courier>;
  updateEnabledCourierCommunicationsTypes: Array<Maybe<CommunicationTypeId>>;
  updateEnabledEndCustomerCommunicationsTypes: Array<Maybe<CommunicationTypeId>>;
  /**
   * Sets which order emails send for orders on live routes of this route template. Orders on a
   * live route are suppressed by default; the listed types opt back in (the end customer's /
   * courier's own opt-in settings still apply). Only order-lifecycle types are accepted;
   * others are ignored.
   */
  updateEnabledRouteTemplateCommunicationsTypes: Array<Maybe<CommunicationTypeId>>;
  updateEndCustomerAccountStatus: EndCustomer;
  updateEndCustomerCustomFields: EndCustomer;
  updateEndCustomerNote: EndCustomer;
  updateEndCustomerPackageTypeOverrides: Array<PackageTypeOverride>;
  updateEndCustomerPodRequirement: EndCustomer;
  updateEndCustomerVisibleServiceTypeIds: EndCustomer;
  updateEndUserRole: EndUser;
  updateHolidaySchedule: Scalars['Boolean'];
  updateInternalNote: Shipment;
  updateLocationScanCodeEndCustomerIds: LocationScanCode;
  updateOptedIn: Scalars['Boolean'];
  updateOrderInvoiceDate: Order;
  /**
   * Applies an add list and a remove list of ORDER labels across every order in
   * orderIds, in one transaction. Labels in neither list are left untouched.
   * Returns the number of affected label assignments.
   */
  updateOrderLabels: Scalars['Int'];
  /**  Marks a card as the customer's default (clearing the customer's other defaults), or clears it */
  updatePaymentInstrumentIsDefault: PaymentInstrument;
  updatePodEmails: EndCustomer;
  updatePortalSettings?: Maybe<Courier>;
  updatePriceOverrideForRecurringOrder: Order;
  updatePricingRuleAdvancedMultipliers: PricingRule;
  updatePricingRuleHolidaySchedulePricingAmounts: PricingRule;
  updatePricingRuleTimeScheduleSpecificAmounts: PricingRule;
  updatePricingSettings?: Maybe<Courier>;
  updateQuote: QuoteResult;
  updateRegionalSettings?: Maybe<Courier>;
  updateRouteTemplateSchedule: RouteTemplate;
  updateSalesTermsForEndCustomers: Array<EndCustomer>;
  updateServiceTypeBusinessHoursSchedule: ServiceType;
  updateServiceTypePricingMultiplier: ServiceType;
  updateServiceTypeReadyTimeSchedule: ServiceType;
  updateServiceTypeVisibleVehicleTypes: ServiceType;
  /**
   * Replaces the courier's shipment buckets (the extra filter chips on the shipments
   * dashboard) with the given list, in the given order. Sending an empty list removes
   * every bucket. Bucket identity is the name: renaming one drops it from any saved
   * view that referenced it.
   */
  updateShipmentsCustomFilters: Courier;
  updateSurchargePricingRuleAdvancedMultipliers: SurchargePricingRule;
  updateSurchargePricingRuleAdvancedSetting: SurchargePricingRule;
  updateSurchargePricingRuleInvoiceSummaryGroup: SurchargePricingRule;
  updateSurchargePricingRuleTaxableStatus: SurchargePricingRule;
  updateUserNotificationSettings: Array<NotificationType>;
  updateVehicleTypeReadyTimeSchedule: VehicleType;
  updateVehicleTypeVisiblePackageTypes: VehicleType;
  updateWebhookSubscription: WebhookSubscription;
  updateZones: Array<Zone>;
  uploadDriverPhoto: Driver;
  uploadFileV1: Artifact;
  uploadFilesForMultiTaskV1: Array<Artifact>;
  /**
   * Replaces the courier's fuel surcharge grid with the bands in this CSV
   * (columns: min rate, max rate, gas percent, diesel percent). All or nothing: if any
   * row has a problem, nothing is saved and every problem is returned by row. (CRI-9)
   */
  uploadFuelSurchargeGridCsv: UploadFuelSurchargeGridCsvResult;
  uploadZonesFromKmz: UploadZonesFromKmzResult;
  /**
   * Sets the reply-to / cc emails for a courier's outbound end-customer emails. A null
   * communicationType configures the org-wide default that applies to every email type;
   * otherwise it configures the override for that specific type. Both lists fully overwrite
   * the stored values (pass the complete desired state; null or an empty list clears the field).
   */
  upsertCourierEmailConfiguration: CourierEmailConfiguration;
  /**
   * Upserts the courier's offline replay waiver policy — creates the settings
   * row on first change. Every write is audited in
   * courier_offline_settings_history with the authenticated user.
   */
  upsertCourierOfflineSettings: CourierOfflineSettings;
  /**
   * Creates or replaces the courier's coverage area. The resulting coverage
   * area always contains the de-duplicated `zoneIds` from the input.
   */
  upsertCoverageArea: CoverageArea;
  upsertDriverAnswer: DriverAnswer;
  upsertDriverCompliancePolicy: DriverCompliancePolicy;
  upsertFcmTokenV1: FcmToken;
  upsertHolidayScheduleBehavior: Scalars['Boolean'];
  upsertLinkedAccount: LinkedAccount;
  upsertPayrollSettings: PayrollSetting;
  upsertRemoteEntityLinkage: RemoteEntity;
  upsertShipmentTemplateDriverAssignments: Array<ShipmentTemplateDriverAssignment>;
  upsertStopTemplateSequenceNumbers: Array<ScheduledStopTemplateSequenceNumber>;
  upsertUserStore: UserStore;
  voidInvoices: Array<Invoice>;
};


export type MutationAddCourierAnalyticsDashboardArgs = {
  courierId: Scalars['ID'];
  metabaseDashboardId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddEndCustomerCommentArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationAddRecurringOrdersToRouteTemplateArgs = {
  courierId: Scalars['ID'];
  routeTemplateId: Scalars['ID'];
  shipmentTemplateIdsToAdd: Array<Scalars['ID']>;
  stopTemplateIdsInSequence: Array<Scalars['ID']>;
};


export type MutationAddStopTemplateIdsToPackageMovementArgs = {
  courierId: Scalars['ID'];
  packageMovementId: Scalars['ID'];
  stopTemplateIdsToInclude: Array<Scalars['ID']>;
};


export type MutationApplyCreditArgs = {
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  creditId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type MutationApproveDriverPayArgs = {
  courierId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
};


export type MutationApproveInvoiceArgs = {
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type MutationApproveInvoicesArgs = {
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']>;
};


export type MutationApproveRoutingJobArgs = {
  approvedBy: Scalars['String'];
  courierId: Scalars['ID'];
  jobId: Scalars['ID'];
};


export type MutationApproveShipmentDetailsArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
};


export type MutationAssignBillableItemToOrderArgs = {
  billableItemId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationAssignDefaultDriverIdArgs = {
  courierId: Scalars['ID'];
  newDriverId: Scalars['ID'];
  orderId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  stopTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationAssignDriverForShipmentTemplatesArgs = {
  courierId: Scalars['ID'];
  driverId?: InputMaybe<Scalars['ID']>;
  shipmentTemplateIds: Array<Scalars['ID']>;
};


export type MutationAssignDriverVehicleTypeArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};


export type MutationAssignHolidayScheduleToEndCustomerArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  holidayScheduleId?: InputMaybe<Scalars['ID']>;
};


export type MutationAssignHolidayScheduleToRecurringOrderArgs = {
  courierId: Scalars['ID'];
  holidayScheduleId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
};


export type MutationAssignLabelsToEntitiesArgs = {
  courierId: Scalars['ID'];
  entityIds: Array<Scalars['ID']>;
  entityType: LabelEntityType;
  labelIds: Array<Scalars['ID']>;
};


export type MutationAssignPricingListToEndCustomerArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  newPricingListId?: InputMaybe<Scalars['ID']>;
};


export type MutationAssignShipmentsToLiveRouteArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
  targetDate: Scalars['Date'];
  targetRouteTemplateId: Scalars['ID'];
};


export type MutationAttachAnswerPhotoToOrderArgs = {
  courierId: Scalars['ID'];
  driverAnswerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationAutocompleteAddressArgs = {
  text: Scalars['String'];
};


export type MutationBackfillInvoiceForOrderArgs = {
  courierId: Scalars['String'];
  orderId: Scalars['ID'];
};


export type MutationBackfillOrphanedOrderInvoicesArgs = {
  courierId: Scalars['String'];
  endCustomerIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type MutationBuildOrderGroupsArgs = {
  assignmentGroups?: InputMaybe<Array<OrderGroupAssignmentGroupInput>>;
  courierId: Scalars['ID'];
  orderGroupBuilderId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type MutationBulkApproveDriverPaysArgs = {
  courierId: Scalars['ID'];
  driverPayEntryIds: Array<Scalars['ID']>;
};


export type MutationBulkDeleteAddressBookArgs = {
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationBulkDeleteEndCustomersArgs = {
  courierId: Scalars['ID'];
};


export type MutationBulkDeletePricingRulesArgs = {
  courierId: Scalars['ID'];
  isBasePricingListOnly: Scalars['Boolean'];
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  serviceTypeIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationBulkDispatchDriverForShipmentsArgs = {
  courierId: Scalars['ID'];
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationBulkForceCompleteShipmentsArgs = {
  completeAtOverride?: InputMaybe<Scalars['Timestamp']>;
  completedBy: Scalars['String'];
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
  stopIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationBulkMultiplyPricingRulesArgs = {
  courierId: Scalars['ID'];
  isBasePricingList: Scalars['Boolean'];
  multiplier: Scalars['Float'];
  pricingListId?: InputMaybe<Scalars['ID']>;
};


export type MutationBulkUnassignDriversFromShipmentArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationBulkUpdateOrderInvoiceDateArgs = {
  courierId: Scalars['ID'];
  invoiceDate?: InputMaybe<Scalars['Date']>;
  orderIds: Array<Scalars['ID']>;
};


export type MutationBulkUploadAddressBookArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationBulkUploadCallerContactsArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationBulkUploadEndCustomersArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  ignoreInvalidAddresses?: InputMaybe<Scalars['Boolean']>;
  ignoreInvalidInvoiceFrequencies?: InputMaybe<Scalars['Boolean']>;
  ignoreInvalidPricingLists?: InputMaybe<Scalars['Boolean']>;
  onlyOverrideExistingEndCustomers?: InputMaybe<Scalars['Boolean']>;
  skipExistingEndCustomers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBulkUploadOrdersArgs = {
  acquisitionType?: InputMaybe<OrderAcquisitionType>;
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
};


export type MutationBulkUploadPackageMovementsArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationBulkUploadPricingListsArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationBulkUploadPricingRulesArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  overrideExistingPricingRules?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBulkUploadRecurringOrdersArgs = {
  acquisitionType?: InputMaybe<OrderAcquisitionType>;
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
  onlyUpdateExistingRecurringOrders?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBulkUploadSurchargesArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationCalculateExtraSecondsFromMilesOverLimitForServiceTypeArgs = {
  courierId: Scalars['ID'];
  googlePlaceIds: Array<Scalars['ID']>;
  serviceTypeId: Scalars['ID'];
};


export type MutationCancelRoutingJobArgs = {
  canceledBy: Scalars['String'];
  courierId: Scalars['ID'];
  jobId: Scalars['ID'];
};


export type MutationCancelScheduledDriverDeactivationArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
};


export type MutationChangePasswordDriverArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  password: Scalars['String'];
};


export type MutationChangePasswordEndCustomerArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  password: Scalars['String'];
};


export type MutationChangePasswordEndUserArgs = {
  courierId: Scalars['ID'];
  endUserId: Scalars['ID'];
  password: Scalars['String'];
};


export type MutationChangePasswordUserArgs = {
  courierId: Scalars['ID'];
  password: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationChangeSequenceForRouteTemplateArgs = {
  courierId: Scalars['ID'];
  routeTemplateId: Scalars['ID'];
  stopTemplateIdsInSequence: Array<Scalars['ID']>;
};


export type MutationClearDriverPhotoArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
};


export type MutationClearHoldStatusArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationClearOrderLegDistanceOverrideArgs = {
  courierId: Scalars['ID'];
  destinationStopId: Scalars['ID'];
  orderId: Scalars['ID'];
  originStopId: Scalars['ID'];
};


export type MutationCompleteTaskV1Args = {
  completedOffline?: InputMaybe<Scalars['Boolean']>;
  courierId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  driverNote?: InputMaybe<Scalars['String']>;
  lngLat?: InputMaybe<LngLatInput>;
  occurredAt?: InputMaybe<Scalars['Timestamp']>;
  taskId: Scalars['ID'];
};


export type MutationCompleteTasksInBulkV1Args = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  inputs: Array<CompleteTaskInput>;
  lngLat?: InputMaybe<LngLatInput>;
};


export type MutationConvertQuotesToOrdersArgs = {
  courierId: Scalars['ID'];
  pickupReadyTime?: InputMaybe<Scalars['Timestamp']>;
  quoteShipmentIds: Array<Scalars['ID']>;
  shipmentDate: Scalars['Date'];
};


export type MutationCopyMemorizationsArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  fromDayOfWeek: DayOfTheWeek;
  toDayOfTheWeeks: Array<DayOfTheWeek>;
  toDays?: InputMaybe<Array<Scalars['Date']>>;
};


export type MutationCreateAddressBookArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  emailRecipients?: InputMaybe<Array<Scalars['String']>>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAgentArgs = {
  courierId: Scalars['ID'];
  create: AgentCreate;
};


export type MutationCreateBillableItemArgs = {
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  serviceTypeId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
  unit: BillableItemUnit;
};


export type MutationCreateBulkRerateJobArgs = {
  courierId: Scalars['ID'];
  input: BulkRerateJobInput;
};


export type MutationCreateBulkScanEventsArgs = {
  courierId: Scalars['ID'];
  deviceId?: InputMaybe<Scalars['String']>;
  deviceTime?: InputMaybe<Scalars['Timestamp']>;
  eventBy: Scalars['String'];
  lngLat?: InputMaybe<LngLatInput>;
  packageEventTypeID?: InputMaybe<Scalars['ID']>;
  scanValues: Array<ScanCreateValue>;
};


export type MutationCreateCallerContactArgs = {
  courierId: Scalars['ID'];
  emails?: InputMaybe<Array<Scalars['String']>>;
  endCustomerId: Scalars['ID'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCircleZoneArgs = {
  center: LngLatInput;
  courierId: Scalars['ID'];
  maxRadiusInMeters: Scalars['Float'];
  minRadiusInMeters: Scalars['Float'];
  name: Scalars['String'];
};


export type MutationCreateCostCenterArgs = {
  costCenterCreate: CostCenterCreate;
  courierId: Scalars['ID'];
};


export type MutationCreateCourierArgs = {
  customerPortalPath: Scalars['String'];
  defaultCurrency: Scalars['String'];
  defaultTimeZoneId: Scalars['String'];
  isTestAccount: Scalars['Boolean'];
  name: Scalars['String'];
  primaryEmail: Scalars['String'];
  primaryPhoneNumber: Scalars['String'];
};


export type MutationCreateCourierBrandArgs = {
  ccEmails?: InputMaybe<Array<Scalars['String']>>;
  city: Scalars['String'];
  country: Scalars['String'];
  courierId: Scalars['ID'];
  email: Scalars['String'];
  logoFile?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  replyToEmails?: InputMaybe<Array<Scalars['String']>>;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
};


export type MutationCreateCourierHolidayArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  recurrenceRule: Scalars['String'];
};


export type MutationCreateCourierTermArgs = {
  content: Scalars['String'];
  courierId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateCreditArgs = {
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  issuedOn: Scalars['Date'];
  note: Scalars['String'];
  sourceInvoiceId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateCustomFieldArgs = {
  choices?: InputMaybe<Array<Scalars['String']>>;
  courierId: Scalars['ID'];
  customerSpecificityType?: InputMaybe<CustomFieldCustomerSpecificity>;
  defaultOptionIndex?: InputMaybe<Scalars['Int']>;
  helperText?: InputMaybe<Scalars['String']>;
  isVisibleToDrivers?: InputMaybe<Scalars['Boolean']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  minValue?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  orderingSequenceNumber?: InputMaybe<Scalars['Int']>;
  requirementType?: InputMaybe<CustomFieldCustomerRequirementType>;
  terms?: InputMaybe<CustomFieldTermsConfigInput>;
  type: CustomFieldType;
  visibilityType?: InputMaybe<CustomFieldCustomerVisibilityType>;
};


export type MutationCreateCustomRoleArgs = {
  courierId: Scalars['String'];
  name: Scalars['String'];
  parentRole: UserRoleType;
};


export type MutationCreateDriverArgs = {
  courierId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  homeLocationId?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  photoUrl?: InputMaybe<Scalars['String']>;
  speed?: InputMaybe<Scalars['Float']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
  weightCapacityInPounds?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateDriverDocumentArgs = {
  courierId: Scalars['ID'];
  documentType: DocumentType;
  driverId: Scalars['ID'];
  expirationDate?: InputMaybe<Scalars['Date']>;
  files: Array<Scalars['Upload']>;
};


export type MutationCreateDriverQuestionArgs = {
  courierId: Scalars['ID'];
  input: DriverQuestionCreate;
};


export type MutationCreateDriverQuestionListArgs = {
  courierId: Scalars['ID'];
  inAdditionToBase?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type MutationCreateEmailTemplateArgs = {
  courierId: Scalars['ID'];
  createInput: CreateEmailTemplateInput;
};


export type MutationCreateEmailTemplateGroupArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateEndCustomerArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  courierId: Scalars['ID'];
  endCustomerCreatedSource?: InputMaybe<EndCustomerCreatedSource>;
  firstName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  invoicingFrequency?: InputMaybe<InvoicingFrequency>;
  lastName?: InputMaybe<Scalars['String']>;
  paymentInstrumentCreate?: InputMaybe<PaymentInstrumentCreate>;
  payrollPricingListId?: InputMaybe<Scalars['ID']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  suite?: InputMaybe<Scalars['String']>;
};


export type MutationCreateEndUserArgs = {
  courierId: Scalars['String'];
  email: Scalars['String'];
  endCustomerId: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationCreateExceptionReasonArgs = {
  code: Scalars['String'];
  courierId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  finalState: ExceptionReasonFinalState;
  name: Scalars['String'];
  reattemptConfigs: Array<ExceptionReattemptConfigInput>;
};


export type MutationCreateExceptionReasonEndCustomerOverrideArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  exceptionReasonId: Scalars['ID'];
  finalState: ExceptionReasonFinalState;
  reattemptConfigs: Array<ExceptionReattemptConfigInput>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCreateHolidayScheduleArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateInvoiceManualPaymentArgs = {
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  invoiceId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  paidOn: Scalars['Date'];
};


export type MutationCreateInvoicePdfTemplateArgs = {
  courierId: Scalars['ID'];
  input: InvoicePdfTemplateCreateInput;
  updatedBy: Scalars['String'];
};


export type MutationCreateLabelArgs = {
  courierId: Scalars['ID'];
  entityType: LabelEntityType;
  name: Scalars['String'];
};


export type MutationCreateLiveOrderArgs = {
  acquisitionType: OrderAcquisitionType;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  billingAccountNumber?: InputMaybe<Scalars['String']>;
  branchId?: InputMaybe<Scalars['ID']>;
  caller?: InputMaybe<Scalars['String']>;
  callerPhone?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  endUserId?: InputMaybe<Scalars['ID']>;
  fraudSessionId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  orderGroupBuildDetail?: InputMaybe<OrderGroupBuildDetailInput>;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  originalOrderId?: InputMaybe<Scalars['ID']>;
  paymentInstrumentId?: InputMaybe<Scalars['ID']>;
  priceOverride?: InputMaybe<Scalars['Money']>;
  priceOverrideBreakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput>>;
  pricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate>>;
  requiredDocumentTypes?: InputMaybe<Array<DocumentType>>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipments: Array<ShipmentCreateInput>;
  warnedDocumentTypes?: InputMaybe<Array<DocumentType>>;
};


export type MutationCreateLocationScanCodeArgs = {
  code: Scalars['String'];
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  requirementType?: InputMaybe<LocationScanRequirement>;
  suite?: InputMaybe<Scalars['String']>;
};


export type MutationCreateMcpApiKeyArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateMultiInvoiceManualPaymentArgs = {
  allocations: Array<InvoiceManualBulkPaymentAllocationInput>;
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  paidOn: Scalars['Date'];
};


export type MutationCreateOneOffOrderArgs = {
  acquisitionType: OrderAcquisitionType;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  billingAccountNumber?: InputMaybe<Scalars['String']>;
  branchId?: InputMaybe<Scalars['ID']>;
  caller?: InputMaybe<Scalars['String']>;
  callerPhone?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  endUserId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  orderGroupBuildDetail?: InputMaybe<OrderGroupBuildDetailInput>;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  originalOrderId?: InputMaybe<Scalars['ID']>;
  pricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate>>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipments: Array<ShipmentCreateInput>;
};


export type MutationCreateOrderAttachmentsArgs = {
  courierId: Scalars['ID'];
  orderAttachmentUploads: Array<OrderAttachmentCreate>;
};


export type MutationCreateOrderAutomationRuleArgs = {
  actionRules: Array<OrderAutomationActionRuleInput>;
  courierId: Scalars['ID'];
  filters: Array<OrderAutomationFilterInput>;
  name: Scalars['String'];
  priority?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateOrderGroupBuilderArgs = {
  assignmentType: OrderGroupBuildAssignmentType;
  buildType: OrderGroupBuildType;
  courierId: Scalars['ID'];
  customerVisibilityType: OrderGroupBuildCustomerVisibilityType;
  name: Scalars['String'];
  orderEntryAutoApply?: InputMaybe<OrderGroupBuildOrderEntryAutoApplyType>;
  sequencingType: OrderGroupBuildSequencingType;
  stationaryStop?: InputMaybe<StationaryStopInput>;
};


export type MutationCreatePackageEventTypeArgs = {
  action: PackageEventPostAction;
  courierId: Scalars['ID'];
  driverAssignmentValidationType?: InputMaybe<DriverAssignmentValidationType>;
  name: Scalars['String'];
  packageScanNewPackageHandleType: PackageScanNewPackageHandleType;
  reassignDriverId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreatePackageMovementArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  stopTemplateIdsToInclude?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCreatePackageTypeArgs = {
  category?: InputMaybe<PackageTypeCategory>;
  courierId: Scalars['ID'];
  defaultHeight?: InputMaybe<Scalars['Float']>;
  defaultLength?: InputMaybe<Scalars['Float']>;
  defaultWeight?: InputMaybe<Scalars['Float']>;
  defaultWeightApplication?: InputMaybe<PackageTypeDefaultWeightApplication>;
  defaultWidth?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type MutationCreatePartnerArgs = {
  associatedCourierIds: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreatePaymentAdditionalFeeRuleArgs = {
  courierId: Scalars['ID'];
  input: PaymentAdditionalFeeRuleCreate;
};


export type MutationCreatePaymentInstrumentArgs = {
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  source: PaymentInstrumentAcquisitionSource;
  token: Scalars['String'];
};


export type MutationCreatePayrollDeductionRuleArgs = {
  amount: Scalars['Money'];
  amountType: PayrollDeductionAmountType;
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  ruleType: PayrollDeductionRuleType;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCreatePricingListArgs = {
  copyBasePricingRules?: InputMaybe<Scalars['Boolean']>;
  courierId: Scalars['ID'];
  fallbackToBasePricingList?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pricingListIdToCopyFrom?: InputMaybe<Scalars['ID']>;
  pricingRulesValueMultiplier?: InputMaybe<Scalars['Float']>;
};


export type MutationCreatePricingRuleArgs = {
  courierId: Scalars['ID'];
  pricingRuleCreate: PricingRuleCreate;
};


export type MutationCreateQuoteArgs = {
  acquisitionType: OrderAcquisitionType;
  caller?: InputMaybe<Scalars['String']>;
  callerPhone?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerId: Scalars['ID'];
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  numDaysToExpire: Scalars['Int'];
  orderPrice: QuoteOrderPriceInput;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipments: Array<ShipmentCreateInput>;
};


export type MutationCreateRecurringOrderArgs = {
  acquisitionType: OrderAcquisitionType;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  branchId?: InputMaybe<Scalars['ID']>;
  caller?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  recurrenceDetail: RecurrenceDetailInput;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipmentTemplates: Array<ShipmentTemplateCreateInput>;
};


export type MutationCreateRouteTemplateArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  shipmentTemplateIdsToAdd?: InputMaybe<Array<Scalars['ID']>>;
  stopTemplateIdsInSequence?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCreateRoutingJobArgs = {
  courierId: Scalars['ID'];
  jobCreate: RoutingJobCreate;
  vehicleCreates: Array<RoutingVehicleCreate>;
};


export type MutationCreateSavedViewArgs = {
  courierId: Scalars['ID'];
  filters: Array<SavedViewFilterInput>;
  name: Scalars['String'];
  page: SavedViewPage;
  primaryFilter?: InputMaybe<Scalars['String']>;
  sortFields: Array<SavedViewSortInput>;
  userOrEmployeeId: Scalars['ID'];
};


export type MutationCreateScanEventArgs = {
  courierId: Scalars['ID'];
  deviceId?: InputMaybe<Scalars['String']>;
  deviceTime?: InputMaybe<Scalars['Timestamp']>;
  eventBy: Scalars['String'];
  lngLat?: InputMaybe<LngLatInput>;
  packageEventTypeID?: InputMaybe<Scalars['ID']>;
  scanType: ScanType;
  value: Scalars['String'];
};


export type MutationCreateSecretArgs = {
  courierId: Scalars['ID'];
  secretValue: Scalars['String'];
  serviceType: CourierSecretServiceType;
};


export type MutationCreateServiceTypeArgs = {
  courierId: Scalars['ID'];
  deliveryRoutedDaysAfter?: InputMaybe<Scalars['Int']>;
  deliveryTimeInMinutes?: InputMaybe<Scalars['Int']>;
  dueTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  dueTimeInDaysAfter?: InputMaybe<Scalars['Int']>;
  dueTimeSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  dueTimeType?: InputMaybe<ServiceTypeDueTimeType>;
  extraSecondsPerMilePastLimit?: InputMaybe<Scalars['Float']>;
  freeWaitTimeInSeconds?: InputMaybe<Scalars['Int']>;
  milesLimit?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  orderingSequenceNumber?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInDaysAfter?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInMinutes?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  pickupCloseType?: InputMaybe<ServiceTypeDueTimeType>;
  visibilityType?: InputMaybe<ServiceTypeVisibilityType>;
};


export type MutationCreateSurchargePricingRuleArgs = {
  courierId: Scalars['ID'];
  surchargePricingRuleCreate: SurchargePricingRuleCreate;
};


export type MutationCreateUserArgs = {
  courierId: Scalars['String'];
  email: Scalars['String'];
  firebaseUserId?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<UserRoleType>;
};


export type MutationCreateVehicleTypeArgs = {
  courierId: Scalars['ID'];
  fuelType?: InputMaybe<FuelType>;
  maxPackageHeight?: InputMaybe<Scalars['Float']>;
  maxPackageLength?: InputMaybe<Scalars['Float']>;
  maxPackageWidth?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  shortCode: Scalars['String'];
};


export type MutationCreateWebhookSubscriptionArgs = {
  additionalHeaders?: InputMaybe<Array<WebhookHeaderInput>>;
  authHeader?: InputMaybe<Scalars['String']>;
  courierId: Scalars['String'];
  endCustomerScope: EndCustomerScope;
  partnerId: Scalars['String'];
  scopedEndCustomerIds?: InputMaybe<Array<Scalars['String']>>;
  secret?: InputMaybe<Scalars['String']>;
  subscribedEvents: Array<WebhookEventName>;
  url: Scalars['String'];
};


export type MutationCreateZipGroupArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']>;
};


export type MutationCreateZoneArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  polygon: PolygonInput;
  type: ZoneType;
};


export type MutationCreateZonesArgs = {
  courierId: Scalars['ID'];
  zones: Array<ZoneCreate>;
};


export type MutationDeactivateDriverArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
};


export type MutationDeleteAddressBookArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteBillableItemArgs = {
  billableItemId: Scalars['ID'];
  courierId: Scalars['ID'];
};


export type MutationDeleteCallerContactArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteCircleZoneArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteCourierBrandArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteCourierEmailConfigurationArgs = {
  communicationType?: InputMaybe<CommunicationTypeId>;
  courierId: Scalars['ID'];
};


export type MutationDeleteCourierHolidayArgs = {
  courierHolidayId: Scalars['ID'];
  courierId: Scalars['ID'];
};


export type MutationDeleteCreditArgs = {
  courierId: Scalars['ID'];
  creditId: Scalars['ID'];
};


export type MutationDeleteCustomRoleArgs = {
  courierId: Scalars['String'];
  customRoleId: Scalars['String'];
};


export type MutationDeleteDriverArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
};


export type MutationDeleteDriverCompliancePolicyArgs = {
  courierId: Scalars['ID'];
  entityId: Scalars['ID'];
};


export type MutationDeleteDriverDocumentArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteDriverQuestionArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteDriverQuestionListArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteEmailTemplateArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteEmailTemplateGroupArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteExceptionReasonArgs = {
  courierId: Scalars['ID'];
  exceptionReasonId: Scalars['ID'];
};


export type MutationDeleteExceptionReasonEndCustomerOverrideArgs = {
  courierId: Scalars['ID'];
  overrideId: Scalars['ID'];
};


export type MutationDeleteFirebaseUserForDriverArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
};


export type MutationDeleteFirebaseUserForEndCustomerArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type MutationDeleteHolidayScheduleArgs = {
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
};


export type MutationDeleteHolidayScheduleBehaviorArgs = {
  courierHolidayId: Scalars['ID'];
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
};


export type MutationDeleteInvoicePdfTemplateArgs = {
  courierId: Scalars['ID'];
  deletedBy: Scalars['String'];
  invoicePdfTemplateId: Scalars['ID'];
};


export type MutationDeleteLabelArgs = {
  courierId: Scalars['ID'];
  labelId: Scalars['ID'];
};


export type MutationDeleteLinkedAccountArgs = {
  courierId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationDeleteLocationScanCodeArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationDeleteOrderAttachmentArgs = {
  courierId: Scalars['ID'];
  orderAttachmentId: Scalars['ID'];
};


export type MutationDeleteOrderAutomationRuleArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteOrderGroupBuilderArgs = {
  courierId: Scalars['ID'];
  orderGroupBuilderId: Scalars['ID'];
};


export type MutationDeletePackageEventTypeArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeletePackageTypeArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationDeletePaymentInstrumentArgs = {
  courierId: Scalars['ID'];
  paymentInstrumentId: Scalars['ID'];
};


export type MutationDeletePayrollDeductionRuleArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeletePricingListArgs = {
  courierId: Scalars['ID'];
  pricingListId: Scalars['ID'];
};


export type MutationDeletePricingRuleArgs = {
  courierId: Scalars['ID'];
  pricingRuleId: Scalars['ID'];
};


export type MutationDeleteQuoteArgs = {
  courierId: Scalars['ID'];
  quoteShipmentId: Scalars['ID'];
};


export type MutationDeleteRouteTemplateArgs = {
  courierId: Scalars['ID'];
  routeTemplateId: Scalars['ID'];
};


export type MutationDeleteSavedViewArgs = {
  courierId: Scalars['ID'];
  savedViewId: Scalars['ID'];
  userOrEmployeeId: Scalars['ID'];
};


export type MutationDeleteScheduledTransferArgs = {
  courierId: Scalars['ID'];
  scheduledTransferId: Scalars['ID'];
};


export type MutationDeleteServiceTypeArgs = {
  courierId: Scalars['ID'];
  serviceTypeId: Scalars['ID'];
};


export type MutationDeleteSurchargePricingRuleArgs = {
  courierId: Scalars['ID'];
  surchargePricingRuleId: Scalars['ID'];
};


export type MutationDeleteVehicleTypeArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDispatchDriverForShipmentArgs = {
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']>>;
  courierId: Scalars['ID'];
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  orderingAlgorithmType?: InputMaybe<OrderingAlgorithmType>;
  shipmentId: Scalars['ID'];
  stopIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationDispatchDriverForShipmentMultiDayArgs = {
  courierId: Scalars['ID'];
  days: Array<DispatchStopsOnDayInput>;
  dispatchPageType?: InputMaybe<DispatchPageType>;
  dispatchPreviewSection?: InputMaybe<Scalars['String']>;
  dispatchPreviewSortingType?: InputMaybe<Scalars['String']>;
  dispatchPreviews?: InputMaybe<Array<DispatchPreviewSaveInput>>;
  dispatchScope?: InputMaybe<DispatchScope>;
  dispatchSource?: InputMaybe<DispatchSource>;
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  driverRank?: InputMaybe<Scalars['Int']>;
  orderingAlgorithmType: OrderingAlgorithmType;
  shipmentId: Scalars['ID'];
};


export type MutationEnableCourierMetabaseArgs = {
  courierId: Scalars['ID'];
};


export type MutationExcludeStopTemplateIdsFromPackageMovementArgs = {
  courierId: Scalars['ID'];
  packageMovementId: Scalars['ID'];
  stopTemplateIdsToExclude: Array<Scalars['ID']>;
};


export type MutationExportPricingRulesCsvArgs = {
  courierId: Scalars['ID'];
  isBasePricingList: Scalars['Boolean'];
  pricingListId?: InputMaybe<Scalars['ID']>;
};


export type MutationExportSurchargeRulesCsvArgs = {
  courierId: Scalars['ID'];
  isBasePricingList: Scalars['Boolean'];
  pricingListId?: InputMaybe<Scalars['ID']>;
};


export type MutationFinalizeOrderPricingArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationForceArriveForShipmentsArgs = {
  courierId: Scalars['ID'];
  shipmentArrivalOverrides: Array<ShipmentArrivalOverrideInput>;
  updatedBy: Scalars['String'];
};


export type MutationForceCompleteShipmentArgs = {
  completeAtOverride?: InputMaybe<Scalars['Timestamp']>;
  completedBy: Scalars['String'];
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type MutationForceCompleteStopsArgs = {
  completedBy: Scalars['String'];
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  stopIds: Array<Scalars['ID']>;
};


export type MutationForceExportDriverPayArgs = {
  courierId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
  provider: ApiProvider;
};


export type MutationForceGenerateInvoicesArgs = {
  courierId: Scalars['String'];
  endCustomerIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endCustomerLabelFilter?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  invoiceFrequency?: InputMaybe<InvoicingFrequency>;
  startDate: Scalars['Date'];
};


export type MutationForceInstantiateRecurringOrdersArgs = {
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']>;
  targetDate: Scalars['Date'];
};


export type MutationForceMarkAsAttemptedArgs = {
  courierId: Scalars['ID'];
  exceptionReasonId: Scalars['ID'];
  stopId: Scalars['ID'];
};


export type MutationForceRegenerateLiveRouteArgs = {
  courierId: Scalars['ID'];
  respectOrderLevelSchedule: Scalars['Boolean'];
  routeTemplateId: Scalars['ID'];
  targetDate: Scalars['Date'];
};


export type MutationForceSendReceiptArgs = {
  courierId: Scalars['ID'];
  emailRecipients: Array<Scalars['String']>;
  paymentTransferId: Scalars['ID'];
};


export type MutationFullUpdateAddressBookArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  emailRecipients?: InputMaybe<Array<Scalars['String']>>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
};


export type MutationFullUpdateAgentArgs = {
  courierId: Scalars['ID'];
  fullUpdate: AgentFullUpdate;
};


export type MutationFullUpdateBillableItemArgs = {
  amount: Scalars['Money'];
  billableItemId: Scalars['ID'];
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  serviceTypeId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
  unit: BillableItemUnit;
};


export type MutationFullUpdateCallerContactArgs = {
  courierId: Scalars['ID'];
  emails?: InputMaybe<Array<Scalars['String']>>;
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationFullUpdateColumnVisibilityArgs = {
  courierId: Scalars['String'];
  driverReportColumnIds?: InputMaybe<Array<DriverReportColumnId>>;
  salesReportColumnIds?: InputMaybe<Array<SalesReportColumnId>>;
  updatedBy: Scalars['String'];
  userOrEmployeeId: Scalars['String'];
};


export type MutationFullUpdateCostCenterArgs = {
  costCenterFullUpdate: CostCenterFullUpdate;
  courierId: Scalars['ID'];
};


export type MutationFullUpdateCourierBrandArgs = {
  ccEmails?: InputMaybe<Array<Scalars['String']>>;
  city: Scalars['String'];
  clearLogo?: InputMaybe<Scalars['Boolean']>;
  country: Scalars['String'];
  courierId: Scalars['ID'];
  email: Scalars['String'];
  id: Scalars['ID'];
  logoFile?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  replyToEmails?: InputMaybe<Array<Scalars['String']>>;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
};


export type MutationFullUpdateCustomFieldArgs = {
  choices?: InputMaybe<Array<Scalars['String']>>;
  courierId: Scalars['ID'];
  customerSpecificityType: CustomFieldCustomerSpecificity;
  defaultOptionIndex?: InputMaybe<Scalars['Int']>;
  helperText?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isVisibleToDrivers?: InputMaybe<Scalars['Boolean']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  minValue?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  orderingSequenceNumber?: InputMaybe<Scalars['Int']>;
  requirementType?: InputMaybe<CustomFieldCustomerRequirementType>;
  terms?: InputMaybe<CustomFieldTermsConfigInput>;
  visibilityType: CustomFieldCustomerVisibilityType;
};


export type MutationFullUpdateDriverArgs = {
  courierId: Scalars['ID'];
  fullUpdate: DriverFullUpdate;
};


export type MutationFullUpdateDriverDocumentArgs = {
  courierId: Scalars['ID'];
  expirationDate?: InputMaybe<Scalars['Date']>;
  files: Array<Scalars['Upload']>;
  id: Scalars['ID'];
};


export type MutationFullUpdateDriverQuestionArgs = {
  courierId: Scalars['ID'];
  input: DriverQuestionUpdate;
};


export type MutationFullUpdateDriverQuestionListArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  inAdditionToBase?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type MutationFullUpdateEmailTemplateArgs = {
  body: Scalars['String'];
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  subject: Scalars['String'];
};


export type MutationFullUpdateEmailTemplateGroupArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationFullUpdateEndCustomerArgs = {
  courierId: Scalars['ID'];
  fullUpdate: EndCustomerFullUpdate;
};


export type MutationFullUpdateExceptionReasonArgs = {
  code: Scalars['String'];
  courierId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  exceptionReasonId: Scalars['ID'];
  finalState: ExceptionReasonFinalState;
  name: Scalars['String'];
  reattemptConfigs: Array<ExceptionReattemptConfigInput>;
};


export type MutationFullUpdateExceptionReasonEndCustomerOverrideArgs = {
  courierId: Scalars['ID'];
  finalState: ExceptionReasonFinalState;
  overrideId: Scalars['ID'];
  reattemptConfigs: Array<ExceptionReattemptConfigInput>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationFullUpdateInvoicePdfTemplateArgs = {
  courierId: Scalars['ID'];
  input: InvoicePdfTemplateUpdateInput;
  updatedBy: Scalars['String'];
};


export type MutationFullUpdateLabelArgs = {
  courierId: Scalars['ID'];
  labelId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationFullUpdateLocationArgs = {
  city: Scalars['String'];
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  streetAddress: Scalars['String'];
};


export type MutationFullUpdateLocationScanCodeArgs = {
  code: Scalars['String'];
  courierId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  requirementType?: InputMaybe<LocationScanRequirement>;
  suite?: InputMaybe<Scalars['String']>;
};


export type MutationFullUpdateOrderArgs = {
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  caller?: InputMaybe<Scalars['String']>;
  callerPhone?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  customFieldValuesToReplace?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerId: Scalars['ID'];
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  requiredDocumentTypes?: InputMaybe<Array<DocumentType>>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipmentUpdates: Array<ShipmentFullUpdate>;
  updatedBy?: InputMaybe<Scalars['String']>;
  warnedDocumentTypes?: InputMaybe<Array<DocumentType>>;
};


export type MutationFullUpdateOrderAutomationRuleArgs = {
  courierId: Scalars['ID'];
  fullUpdate: OrderAutomationRuleFullUpdateInput;
};


export type MutationFullUpdateOrderGroupBuilderArgs = {
  assignmentType: OrderGroupBuildAssignmentType;
  buildType: OrderGroupBuildType;
  courierId: Scalars['ID'];
  customerVisibilityType: OrderGroupBuildCustomerVisibilityType;
  name: Scalars['String'];
  orderEntryAutoApply?: InputMaybe<OrderGroupBuildOrderEntryAutoApplyType>;
  orderGroupBuilderId: Scalars['ID'];
  sequencingType: OrderGroupBuildSequencingType;
  stationaryStop?: InputMaybe<StationaryStopInput>;
};


export type MutationFullUpdatePackageEventTypeArgs = {
  action: PackageEventPostAction;
  courierId: Scalars['ID'];
  driverAssignmentValidationType?: InputMaybe<DriverAssignmentValidationType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  packageScanNewPackageHandleType: PackageScanNewPackageHandleType;
  reassignDriverId?: InputMaybe<Scalars['ID']>;
};


export type MutationFullUpdatePackageTypeArgs = {
  category?: InputMaybe<PackageTypeCategory>;
  courierId?: InputMaybe<Scalars['ID']>;
  defaultHeight?: InputMaybe<Scalars['Float']>;
  defaultLength?: InputMaybe<Scalars['Float']>;
  defaultWeight?: InputMaybe<Scalars['Float']>;
  defaultWeightApplication?: InputMaybe<PackageTypeDefaultWeightApplication>;
  defaultWidth?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationFullUpdatePaymentAdditionalFeeRuleArgs = {
  courierId: Scalars['ID'];
  input: PaymentAdditionalFeeRuleFullUpdate;
};


export type MutationFullUpdatePayrollDeductionRuleArgs = {
  amount: Scalars['Money'];
  amountType: PayrollDeductionAmountType;
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ruleType: PayrollDeductionRuleType;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationFullUpdatePriceListArgs = {
  courierId: Scalars['ID'];
  fallbackToBasePricingList: Scalars['Boolean'];
  name: Scalars['String'];
  pricingListId: Scalars['ID'];
};


export type MutationFullUpdatePricingRuleArgs = {
  courierId: Scalars['ID'];
  pricingRuleFullUpdate: PricingRuleFullUpdate;
};


export type MutationFullUpdateRecurringOrderArgs = {
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  customFieldValuesToReplace?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerId: Scalars['ID'];
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  recurrenceDetail: RecurrenceDetailInput;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipmentTemplateUpdates: Array<ShipmentTemplateFullUpdate>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationFullUpdateSavedViewArgs = {
  courierId: Scalars['ID'];
  filters: Array<SavedViewFilterInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  primaryFilter?: InputMaybe<Scalars['String']>;
  sortFields: Array<SavedViewSortInput>;
};


export type MutationFullUpdateServiceTypeArgs = {
  courierId: Scalars['ID'];
  fullUpdate: ServiceTypeFullUpdate;
};


export type MutationFullUpdateSurchargePricingRuleArgs = {
  courierId: Scalars['ID'];
  surchargePricingRuleFullUpdate: SurchargePricingRuleFullUpdate;
};


export type MutationFullUpdateUserArgs = {
  courierId: Scalars['ID'];
  customRoleIds?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  id: Scalars['ID'];
  roleType: UserRoleType;
};


export type MutationFullUpdateVehicleTypeArgs = {
  courierId: Scalars['ID'];
  fuelType?: InputMaybe<FuelType>;
  id: Scalars['ID'];
  maxPackageHeight?: InputMaybe<Scalars['Float']>;
  maxPackageLength?: InputMaybe<Scalars['Float']>;
  maxPackageWidth?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  shortCode: Scalars['String'];
};


export type MutationFullUpdateZipGroupArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']>;
  zipGroupId: Scalars['ID'];
};


export type MutationGenerateAccountStatementCsvArgs = {
  courierId: Scalars['String'];
  endCustomerId: Scalars['ID'];
};


export type MutationGenerateBillOfLadingPdfArgs = {
  courierId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type MutationGenerateCsvForDriversArgs = {
  courierId: Scalars['ID'];
};


export type MutationGenerateCsvForEndCustomersArgs = {
  courierId: Scalars['ID'];
};


export type MutationGenerateCsvForInvoicesArgs = {
  courierId: Scalars['String'];
  invoiceIds: Array<Scalars['ID']>;
};


export type MutationGenerateCsvForOrdersArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type MutationGenerateCsvForRecurringOrdersArgs = {
  courierId: Scalars['ID'];
};


export type MutationGenerateDriverHoursWorkedReportArgs = {
  courierId: Scalars['ID'];
  driverIds: Array<Scalars['ID']>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type MutationGenerateDriversReportCsvArgs = {
  courierId: Scalars['ID'];
  driverWorkTypes?: InputMaybe<Array<DriverWorkType>>;
  granularity?: InputMaybe<DriverReportGranularity>;
  maxDate: Scalars['Date'];
  minDate: Scalars['Date'];
};


export type MutationGenerateInvoiceSummaryCsvArgs = {
  costCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  courierId: Scalars['String'];
  displayIds?: InputMaybe<Array<Scalars['Int']>>;
  endCustomerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endCustomerLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  invoicingFrequency?: InputMaybe<Array<InputMaybe<InvoicingFrequency>>>;
  maxApprovedAt?: InputMaybe<Scalars['Timestamp']>;
  maxEndDate?: InputMaybe<Scalars['Date']>;
  minApprovedAt?: InputMaybe<Scalars['Timestamp']>;
  minEndDate?: InputMaybe<Scalars['Date']>;
  paymentStatuses?: InputMaybe<Array<InputMaybe<InvoicePaymentStatus>>>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<InputMaybe<InvoiceStatus>>>;
  trackingNumbers?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationGenerateOrdersPdfArgs = {
  numPackages?: InputMaybe<Scalars['Int']>;
  orderIds: Array<Scalars['ID']>;
  useOrderNumPackages?: InputMaybe<Scalars['Boolean']>;
};


export type MutationGeneratePayrollReportArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type MutationGeneratePdfForInvoiceArgs = {
  courierId: Scalars['String'];
  invoiceId: Scalars['ID'];
};


export type MutationGeneratePdfForInvoicesArgs = {
  courierId: Scalars['String'];
  invoiceIds: Array<Scalars['ID']>;
};


export type MutationGenerateResetPasswordLinkArgs = {
  email: Scalars['String'];
};


export type MutationGenerateSalesReportCsvArgs = {
  courierId: Scalars['ID'];
  includeAllSurcharge?: InputMaybe<Scalars['Boolean']>;
  maxCompletedDate?: InputMaybe<Scalars['Date']>;
  maxDate?: InputMaybe<Scalars['Date']>;
  minCompletedDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
};


export type MutationGetOrCreateEndCustomerAccountNumberArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type MutationGetOrCreateLocationFromCoordinateArgs = {
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  lngLat: LngLatInput;
};


export type MutationGetOrCreateLocationsArgs = {
  googlePlaceIds: Array<Scalars['String']>;
};


export type MutationGetOrCreateLocationsWithOverviewArgs = {
  googlePlaceIds: Array<Scalars['String']>;
};


export type MutationGetOrForceInstantiateRecurringOrdersArgs = {
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']>;
  shouldUseTemplateDriver: Scalars['Boolean'];
  targetDate: Scalars['Date'];
};


export type MutationGetOrGenerateDriverPayEntriesArgs = {
  courierId: Scalars['ID'];
  driverLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  driverSearch?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  onlyIncludeEntriesInApprovedRange?: InputMaybe<Scalars['Boolean']>;
  sortFields?: InputMaybe<Array<DriverPayrollSorting>>;
  startDate: Scalars['Date'];
};


export type MutationHandOverDriverDayArgs = {
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  placement: HandOverPlacement;
  sourceDriverId: Scalars['ID'];
  targetDriverId: Scalars['ID'];
};


export type MutationInitiateInvoicePaymentArgs = {
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  emailRecipients?: InputMaybe<Array<Scalars['String']>>;
  fraudSessionId?: InputMaybe<Scalars['String']>;
  idempotencyToken: Scalars['String'];
  invoiceId: Scalars['ID'];
  paymentInstrumentId: Scalars['ID'];
};


export type MutationInitiateInvoicePaymentsArgs = {
  baseIdempotencyToken: Scalars['String'];
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  invoiceIds: Array<Scalars['ID']>;
};


export type MutationInitiateInvoiceRefundArgs = {
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  idempotencyToken: Scalars['String'];
  parentPaymentTransferId: Scalars['ID'];
};


export type MutationLinkSupportCallArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  vapiCallId: Scalars['String'];
};


export type MutationMarkArtifactAsDeletedArgs = {
  artifactId: Scalars['ID'];
  courierId: Scalars['ID'];
};


export type MutationMarkAsArrivedV1Args = {
  arrivedOffline?: InputMaybe<Scalars['Boolean']>;
  courierId?: InputMaybe<Scalars['ID']>;
  driverTimeEvent?: InputMaybe<DriverTimeEventInput>;
  occurredAt?: InputMaybe<Scalars['Timestamp']>;
  taskId: Scalars['ID'];
};


export type MutationMarkAsAttemptedArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  exceptionReasonId?: InputMaybe<Scalars['ID']>;
  taskId: Scalars['ID'];
};


export type MutationMarkAsHoldArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationMarkCostCenterDeletedArgs = {
  costCenterId: Scalars['ID'];
  courierId: Scalars['ID'];
};


export type MutationMarkCustomFieldAsDeletedArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationMarkDriverQuestionListAsBaseArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  isBase: Scalars['Boolean'];
};


export type MutationMarkEndCustomerConfirmedAsNewArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type MutationMarkEndCustomerDeletedArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type MutationMarkEndUserAsDeletedArgs = {
  courierId: Scalars['ID'];
  endUserId: Scalars['ID'];
};


export type MutationMarkInvoiceAsPaidManuallyArgs = {
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']>;
  markedBy: Scalars['String'];
};


export type MutationMarkInvoicePdfTemplateAsDefaultArgs = {
  courierId: Scalars['ID'];
  invoicePdfTemplateId: Scalars['ID'];
  updatedBy: Scalars['String'];
};


export type MutationMarkShipmentAsClosedArgs = {
  closedBy?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type MutationMarkShipmentAsDeletedArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type MutationMarkShipmentAsFailedArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type MutationMarkShipmentTemplatesAsDeletedArgs = {
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']>;
};


export type MutationMarkShipmentsAsClosedArgs = {
  closedBy?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationMarkShipmentsAsConfirmedArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationMarkShipmentsAsDeletedArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationMarkStopTemplatesAsFixedSequenceArgs = {
  courierId: Scalars['ID'];
  shipmentTemplateId: Scalars['ID'];
  stopTemplateIdsInSequence: Array<Scalars['ID']>;
};


export type MutationMarkUnassignedShipmentAsFailedArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type MutationMarkUserAsDeletedArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationMergeEndCustomersArgs = {
  courierId: Scalars['ID'];
  sourceEndCustomerId: Scalars['ID'];
  targetEndCustomerId: Scalars['ID'];
};


export type MutationMergeOrdersArgs = {
  courierId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type MutationModifyDriverPayDeductionsArgs = {
  courierId: Scalars['ID'];
  deductionIdsToRemove: Array<Scalars['ID']>;
  deductionsToAdd: Array<DriverPayDeductionValueInput>;
  driverPayEntryId: Scalars['ID'];
};


export type MutationModifyDriverTimeEventsArgs = {
  courierId: Scalars['ID'];
  eventIdsToDelete: Array<Scalars['ID']>;
  newEvent?: InputMaybe<DriverTimeEventCreateInput>;
  updatedBy: Scalars['ID'];
  updates: Array<DriverTimeEventUpdateInput>;
};


export type MutationModifyOrderPricingArgs = {
  adjustmentIdsToRemove?: InputMaybe<Array<Scalars['ID']>>;
  adjustmentOverrides?: InputMaybe<Array<AdjustmentOverrideInput>>;
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate>>;
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
  priceOverrideBreakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput>>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationOptimizeRouteForDispatchArgs = {
  baseTime?: InputMaybe<Scalars['Timestamp']>;
  courierId: Scalars['ID'];
  dispatchScope?: InputMaybe<DispatchScope>;
  driverId: Scalars['ID'];
  endLocationId?: InputMaybe<Scalars['ID']>;
  newShipmentId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  startLocationId?: InputMaybe<Scalars['ID']>;
  stopDate?: InputMaybe<Scalars['Date']>;
};


export type MutationOverrideAdjustmentAmountArgs = {
  adjustmentId: Scalars['ID'];
  amountOverride?: InputMaybe<Scalars['Money']>;
  courierId: Scalars['ID'];
};


export type MutationOverrideOrderLegDistanceArgs = {
  courierId: Scalars['ID'];
  destinationStopId: Scalars['ID'];
  distanceInMeters: Scalars['Float'];
  orderId: Scalars['ID'];
  originStopId: Scalars['ID'];
};


export type MutationOverrideOrderMilesArgs = {
  courierId: Scalars['ID'];
  milesOverride?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['ID'];
};


export type MutationOverridePodMetadataArgs = {
  courierId: Scalars['ID'];
  deliveredAt?: InputMaybe<Scalars['Timestamp']>;
  shipmentId: Scalars['ID'];
  signedBy?: InputMaybe<Scalars['String']>;
  updatedBy: Scalars['String'];
};


export type MutationOverridePricingDetailArgs = {
  adjustmentUpdates?: InputMaybe<Array<PricingAdjustmentUpdate>>;
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate>>;
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  unfreeWaitTimeInMinutes?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationOverrideStopCompletedTimesArgs = {
  courierId: Scalars['ID'];
  overrides: Array<StopCompletedTimeOverride>;
  shipmentId: Scalars['ID'];
};


export type MutationOverrideTripDistanceArgs = {
  courierId: Scalars['ID'];
  destinationLocationId: Scalars['ID'];
  distanceInMeters: Scalars['Float'];
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  sourceLocationId: Scalars['ID'];
};


export type MutationPreviewInvoicePdfFromCreateArgs = {
  courierId: Scalars['ID'];
  template: InvoicePdfTemplateCreateInput;
};


export type MutationPreviewInvoicePdfFromUpdateArgs = {
  courierId: Scalars['ID'];
  template: InvoicePdfTemplateUpdateInput;
};


export type MutationPreviewOrderPricingModificationArgs = {
  adjustmentIdsToRemove?: InputMaybe<Array<Scalars['ID']>>;
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate>>;
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
};


export type MutationPreviewPriceArgs = {
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  courierId: Scalars['ID'];
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  googlePlaceIds?: InputMaybe<Array<Scalars['String']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  orderAcquisitionType?: InputMaybe<OrderAcquisitionType>;
  packageCount?: InputMaybe<Scalars['Int']>;
  packageItems?: InputMaybe<Array<PackageItemInput>>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeight?: InputMaybe<Scalars['Float']>;
  priceOverride?: InputMaybe<Scalars['Money']>;
  priceOverrideBreakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput>>;
  requestedPricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate>>;
  serviceTypeId?: InputMaybe<Scalars['String']>;
  shipmentDate?: InputMaybe<Scalars['Date']>;
  shipmentType?: InputMaybe<ShipmentType>;
  stopTypes?: InputMaybe<Array<ShipmentStopType>>;
  timeWindows?: InputMaybe<Array<TimeWindowInput>>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};


export type MutationPrintLiveRoutePdfArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  targetDate: Scalars['Date'];
};


export type MutationPrintMemorizationsPdfArgs = {
  courierId: Scalars['ID'];
  dayOfWeek: DayOfTheWeek;
  driverId: Scalars['ID'];
};


export type MutationProposeShipmentDetailsArgs = {
  courierId: Scalars['ID'];
  proposedNumPackages: Scalars['Int'];
  proposedPackageWeightInPounds: Scalars['Float'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
};


export type MutationRandomizeTimesArgs = {
  courierId: Scalars['ID'];
};


export type MutationReactivateDriverArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
};


export type MutationReassignLiveRouteArgs = {
  courierId: Scalars['ID'];
  liveRouteId: Scalars['ID'];
  newDriverId: Scalars['ID'];
};


export type MutationRecordDriverLocationArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  detailsAsJson?: InputMaybe<Scalars['String']>;
  driverId: Scalars['ID'];
  lastReportedTimeString?: InputMaybe<Scalars['String']>;
  lngLat: LngLatInput;
};


export type MutationRecordMobileAppErrorArgs = {
  driverEmail?: InputMaybe<Scalars['String']>;
  driverId?: InputMaybe<Scalars['ID']>;
  payloadAsJson?: InputMaybe<Scalars['String']>;
};


export type MutationRecordOrderClickArgs = {
  input: RecordOrderClickInput;
};


export type MutationRecordPromptActionArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  input: RecordPromptActionInput;
};


export type MutationRefreshCustomerSupportAssistantArgs = {
  courierId: Scalars['ID'];
};


export type MutationRefreshDispatchPreviewsArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  shipmentDate?: InputMaybe<Scalars['Date']>;
  shipmentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationRefreshEtaStaleArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
};


export type MutationRemoveRecurringOrdersFromRouteTemplateArgs = {
  courierId: Scalars['ID'];
  routeTemplateId: Scalars['ID'];
  shipmentTemplateIdsToRemove: Array<Scalars['ID']>;
};


export type MutationRemoveTripDistanceOverrideArgs = {
  courierId: Scalars['ID'];
  destinationLocationId: Scalars['ID'];
  sourceLocationId: Scalars['ID'];
};


export type MutationRenameRouteTemplateArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  routeTemplateId: Scalars['ID'];
};


export type MutationReorderLiveRouteSequenceArgs = {
  courierId: Scalars['ID'];
  liveRouteId: Scalars['ID'];
  stopIdsInSequence: Array<Scalars['ID']>;
};


export type MutationReplaceAllocationArgs = {
  courierId: Scalars['ID'];
  replacement: DriverPayAllocationReplacement;
};


export type MutationReplaceRouteArgs = {
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']>>;
  courierId?: InputMaybe<Scalars['ID']>;
  dispatchSource?: InputMaybe<DispatchSource>;
  driverId: Scalars['ID'];
  newStopIds: Array<Scalars['ID']>;
  orderingAlgorithmType?: InputMaybe<OrderingAlgorithmType>;
  replacedBy?: InputMaybe<Scalars['String']>;
  shipmentDate: Scalars['Date'];
};


export type MutationReplaceRoutingVehicleSequenceArgs = {
  courierId: Scalars['ID'];
  routingNodeIds: Array<Scalars['ID']>;
  routingVehicleId: Scalars['ID'];
};


export type MutationReplaceSalesCommissionsArgs = {
  commissions: Array<SalesCommissionInput>;
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type MutationResetShipmentArgs = {
  courierId: Scalars['ID'];
  resetBy: Scalars['String'];
  shipmentId: Scalars['ID'];
};


export type MutationRevertStopCompletionArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  stopIds: Array<Scalars['ID']>;
};


export type MutationSaveFirebaseSignUpArgs = {
  courierId: Scalars['ID'];
  email: Scalars['String'];
};


export type MutationScanCreateArgs = {
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['ID']>;
  lngLat?: InputMaybe<LngLatInput>;
  scanType: ScanType;
  taskId?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};


export type MutationScanCreateInBulkArgs = {
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['ID']>;
  lngLat?: InputMaybe<LngLatInput>;
  scanValues: Array<ScanCreateValue>;
  taskId?: InputMaybe<Scalars['ID']>;
};


export type MutationScanVerifyArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  lngLat?: InputMaybe<LngLatInput>;
  scanType: ScanType;
  taskId?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};


export type MutationScanVerifyInBulkArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  lngLat?: InputMaybe<LngLatInput>;
  scanValues: Array<ScanCreateValue>;
  taskId?: InputMaybe<Scalars['ID']>;
};


export type MutationScheduleDriverDeactivationArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  scheduledAt: Scalars['Date'];
};


export type MutationScheduleTransferArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  targetDriverId: Scalars['ID'];
  triggerStopId: Scalars['ID'];
};


export type MutationSendBulkPaymentReminderEmailsArgs = {
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']>;
};


export type MutationSendCommunicationToEndCustomerArgs = {
  communicationTypeId?: InputMaybe<CommunicationTypeId>;
  courierId: Scalars['ID'];
  emailRecipientsCommaSeparated?: InputMaybe<Scalars['String']>;
  shipmentId?: InputMaybe<Scalars['ID']>;
  stopId?: InputMaybe<Scalars['ID']>;
};


export type MutationSendDriverScheduleConfirmationEmailsArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['Date'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
  includeEmptyDrivers?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['Date'];
};


export type MutationSendEmailToDriversArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  driverPayEntryId: Scalars['ID'];
  recipients: Array<Scalars['String']>;
};


export type MutationSendInvoiceEmailArgs = {
  courierId: Scalars['ID'];
  invoiceEmailSendInput: InvoiceEmailSendInput;
};


export type MutationSendInvoiceEmailsArgs = {
  courierId: Scalars['ID'];
  invoiceEmailSendInputs: Array<InvoiceEmailSendInput>;
};


export type MutationSendPasswordResetEmailArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  endUserIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSetDefaultSavedViewArgs = {
  courierId: Scalars['ID'];
  page: SavedViewPage;
  savedViewId: Scalars['ID'];
  userOrEmployeeId: Scalars['ID'];
};


export type MutationSetDriverQuestionsSequenceArgs = {
  courierId: Scalars['ID'];
  questionIds: Array<Scalars['ID']>;
};


export type MutationSetDriverScheduleOverrideArgs = {
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  isDayOff: Scalars['Boolean'];
  labels: Array<Scalars['String']>;
  timeBlocks: Array<DriverScheduleTimeBlockInput>;
};


export type MutationSetEmailTemplateGroupAsDefaultArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationSetEndCustomerRequiredFieldsArgs = {
  additionalFields?: InputMaybe<Array<CustomerPortalAdditionalRequiredFields>>;
  courierId: Scalars['ID'];
  dispatchAdditionalFields?: InputMaybe<Array<DispatcherOrderEntryAdditionalField>>;
  endCustomerId: Scalars['ID'];
};


export type MutationSetOrderAutomationRuleOptedOutArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  optedOut: Scalars['Boolean'];
};


export type MutationSparseUpdateColumnVisibilityArgs = {
  courierId: Scalars['String'];
  driverReportColumnIds?: InputMaybe<Array<DriverReportColumnId>>;
  salesReportColumnIds?: InputMaybe<Array<SalesReportColumnId>>;
  updatedBy: Scalars['String'];
  userOrEmployeeId: Scalars['String'];
};


export type MutationStartTaskV1Args = {
  courierId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  taskId: Scalars['ID'];
};


export type MutationSyncDriverWithFirebaseArgs = {
  email: Scalars['String'];
  firebaseUid: Scalars['String'];
};


export type MutationSyncEndCustomerWithFirebaseArgs = {
  courierId: Scalars['ID'];
  email: Scalars['String'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  firebaseUid: Scalars['String'];
};


export type MutationSyncInvoiceArgs = {
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type MutationSyncUserWithFirebaseArgs = {
  email?: InputMaybe<Scalars['String']>;
  firebaseUid?: InputMaybe<Scalars['String']>;
};


export type MutationTransferShipmentArgs = {
  courierId: Scalars['ID'];
  routingJobId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  targetDriverId: Scalars['ID'];
};


export type MutationTriggerRecurringOrderGenerationArgs = {
  courierId: Scalars['ID'];
  maxDate: Scalars['Date'];
  minDate: Scalars['Date'];
};


export type MutationUnapplyCreditArgs = {
  courierId: Scalars['ID'];
  creditApplicationId: Scalars['ID'];
};


export type MutationUnassignDriverFromShipmentArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type MutationUnassignLabelsFromEntityArgs = {
  courierId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: LabelEntityType;
  labelIds: Array<Scalars['ID']>;
};


export type MutationUncloseShipmentArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type MutationUncloseShipmentsArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationUnfinalizeOrderPricingArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationUnsetDefaultEmailTemplateGroupArgs = {
  courierId: Scalars['ID'];
};


export type MutationUpdateBasePriceOverrideArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBillingEndCustomerIdArgs = {
  billingEndCustomerId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type MutationUpdateCircleZoneArgs = {
  center: LngLatInput;
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  maxRadiusInMeters: Scalars['Float'];
  minRadiusInMeters: Scalars['Float'];
  name: Scalars['String'];
};


export type MutationUpdateCommissionableBaseArgs = {
  commissionableBaseFixed?: InputMaybe<Scalars['Money']>;
  commissionableBasePercent?: InputMaybe<Scalars['Money']>;
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCourierDistanceSourceArgs = {
  courierId: Scalars['ID'];
  pricingDistanceSource: MapApi;
};


export type MutationUpdateCourierHolidayArgs = {
  courierHolidayId: Scalars['ID'];
  courierId: Scalars['ID'];
  name: Scalars['String'];
  recurrenceRule: Scalars['String'];
};


export type MutationUpdateCourierOpsSettingsArgs = {
  customerPortalPath?: InputMaybe<Scalars['String']>;
  driversMileageReimbursementMethod: DriversMileageReimbursementMethod;
  driversTimeRecordingMethod: DriversTimeRecordingMethod;
  finixMerchantId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isTestAccount: Scalars['Boolean'];
  name: Scalars['String'];
  outOfTownSurchargeMultiplier?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationUpdateCourierSettingsArgs = {
  billingCity?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  billingStreetAddress?: InputMaybe<Scalars['String']>;
  billingZip?: InputMaybe<Scalars['String']>;
  clearLogo?: InputMaybe<Scalars['Boolean']>;
  courierId: Scalars['ID'];
  defaultTimeZoneId: Scalars['String'];
  dispatcherCellPhoneNumber?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  logoFile?: InputMaybe<Scalars['Upload']>;
  primaryAddressLocationId: Scalars['ID'];
  primaryEmail: Scalars['String'];
  primaryPhoneNumber: Scalars['String'];
};


export type MutationUpdateCustomRoleOverridesArgs = {
  courierId: Scalars['String'];
  customRoleId: Scalars['String'];
  overrides: Array<PermissionOverrideInput>;
};


export type MutationUpdateDeliverySettingsArgs = {
  courierId: Scalars['ID'];
  dropOffPodRequirementType: PodRequirementAtStop;
  pickupPodRequirementType: PodRequirementAtStop;
  returnPodRequirementType: PodRequirementAtStop;
};


export type MutationUpdateDispatchSettingsArgs = {
  additionalRequiredFields: Array<DispatcherOrderEntryAdditionalField>;
  addressBookAutoFillType?: InputMaybe<AddressBookAutoFillType>;
  addressBookSavingType?: InputMaybe<AddressBookSavingType>;
  courierId: Scalars['ID'];
  estimatedDwellTimeInSeconds: Scalars['Int'];
  liveRouteSequencingType?: InputMaybe<LiveRouteSequencingType>;
  locationIdentifyTypesDropOff?: InputMaybe<Array<LocationIdentifyType>>;
  locationIdentifyTypesPickUp?: InputMaybe<Array<LocationIdentifyType>>;
  multiStopsOptimizationType?: InputMaybe<MultiStopsOptimizationType>;
  orderEntryDefaultAddressAutoFillType?: InputMaybe<OrderEntryDefaultAddressAutoFillType>;
  orderIdentifierColumnType?: InputMaybe<OrderIdentifierColumnType>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
};


export type MutationUpdateDriverAppVersionArgs = {
  appVersion: Scalars['String'];
  driverId: Scalars['ID'];
};


export type MutationUpdateDriverAvailabilityV1Args = {
  courierId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  isAvailable: Scalars['Boolean'];
};


export type MutationUpdateDriverBaseWorkScheduleArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  workSchedule: DriverWorkScheduleInput;
};


export type MutationUpdateDriverCompensationArgs = {
  compensation: DriverCompensation;
  courierId: Scalars['ID'];
  dontChangeTaxId?: InputMaybe<Scalars['Boolean']>;
  driverId: Scalars['ID'];
  employmentType: DriverEmploymentType;
  icCompanyName?: InputMaybe<Scalars['String']>;
  payrollPricingListId?: InputMaybe<Scalars['ID']>;
  taxId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDriverPayOverrideArgs = {
  courierId: Scalars['ID'];
  driverPayOverride?: InputMaybe<Scalars['Money']>;
  driverPayPercent?: InputMaybe<Scalars['Money']>;
  orderId: Scalars['ID'];
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDriverReportedWaitTimeArgs = {
  courierId: Scalars['ID'];
  stopId: Scalars['ID'];
  waitTimeInMinutes: Scalars['Int'];
};


export type MutationUpdateDriverSettingsArgs = {
  courierId: Scalars['ID'];
  driverPayStatementVisibility?: InputMaybe<DriverPayStatementVisibility>;
  gpsRestrictionType?: InputMaybe<GpsRestrictionType>;
  maxDistanceToCompleteTaskInMeters?: InputMaybe<Scalars['Int']>;
  priceVisibilityType: DriverPriceVisibilityType;
  stopCompletionGuard: StopCompletionGuard;
  taskVisibilityType: DriverTaskVisibilityType;
};


export type MutationUpdateEnabledCourierCommunicationsTypesArgs = {
  courierId: Scalars['ID'];
  enabledCommunicationTypeIds: Array<CommunicationTypeId>;
};


export type MutationUpdateEnabledEndCustomerCommunicationsTypesArgs = {
  courierId: Scalars['ID'];
  enabledCommunicationTypeIds: Array<CommunicationTypeId>;
  endCustomerId: Scalars['ID'];
};


export type MutationUpdateEnabledRouteTemplateCommunicationsTypesArgs = {
  courierId: Scalars['ID'];
  enabledCommunicationTypeIds: Array<CommunicationTypeId>;
  routeTemplateId: Scalars['ID'];
};


export type MutationUpdateEndCustomerAccountStatusArgs = {
  accountStatus: EndCustomerAccountStatus;
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type MutationUpdateEndCustomerCustomFieldsArgs = {
  courierId: Scalars['ID'];
  customFieldIds: Array<Scalars['ID']>;
  endCustomerId: Scalars['ID'];
};


export type MutationUpdateEndCustomerNoteArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateEndCustomerPackageTypeOverridesArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  overrides: Array<PackageTypeOverrideInput>;
};


export type MutationUpdateEndCustomerPodRequirementArgs = {
  courierId: Scalars['ID'];
  dropoffPodRequirement?: InputMaybe<PodRequirementAtStop>;
  endCustomerId: Scalars['ID'];
  pickupPodRequirement?: InputMaybe<PodRequirementAtStop>;
  returnPodRequirement?: InputMaybe<PodRequirementAtStop>;
};


export type MutationUpdateEndCustomerVisibleServiceTypeIdsArgs = {
  courierId: Scalars['ID'];
  defaultServiceTypeId?: InputMaybe<Scalars['ID']>;
  endCustomerId: Scalars['ID'];
  visibleServiceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdateEndUserRoleArgs = {
  courierId: Scalars['ID'];
  endUserId: Scalars['ID'];
  role: EndUserRoleType;
};


export type MutationUpdateHolidayScheduleArgs = {
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateInternalNoteArgs = {
  courierId: Scalars['ID'];
  internalNote: Scalars['String'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
};


export type MutationUpdateLocationScanCodeEndCustomerIdsArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
};


export type MutationUpdateOptedInArgs = {
  agentId: Scalars['ID'];
  optedIn: Scalars['Boolean'];
};


export type MutationUpdateOrderInvoiceDateArgs = {
  courierId: Scalars['ID'];
  invoiceDate?: InputMaybe<Scalars['Date']>;
  orderId: Scalars['ID'];
};


export type MutationUpdateOrderLabelsArgs = {
  addLabelIds: Array<Scalars['ID']>;
  courierId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
  removeLabelIds: Array<Scalars['ID']>;
};


export type MutationUpdatePaymentInstrumentIsDefaultArgs = {
  courierId: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  paymentInstrumentId: Scalars['ID'];
};


export type MutationUpdatePodEmailsArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  podEmails?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdatePortalSettingsArgs = {
  additionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>;
  courierId: Scalars['ID'];
  customerPortalDeliverByTimeVisibility?: InputMaybe<CustomerPortalDeliverByTimeVisibility>;
  customerPortalNewCustomerPaymentMethodPromptType?: InputMaybe<CustomerPortalNewCustomerPaymentMethodPromptType>;
  customerPortalNotice?: InputMaybe<Scalars['String']>;
  orderEntryType: CustomerPortalOrderEntryType;
  priceVisibilityType: EndCustomerPriceVisibilityType;
};


export type MutationUpdatePriceOverrideForRecurringOrderArgs = {
  breakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput>>;
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePricingRuleAdvancedMultipliersArgs = {
  advancedMultiplier?: InputMaybe<PricingRuleAdvancedMultiplierInput>;
  courierId: Scalars['ID'];
  pricingRuleId: Scalars['ID'];
};


export type MutationUpdatePricingRuleHolidaySchedulePricingAmountsArgs = {
  courierId: Scalars['ID'];
  holidaySchedulePricingAmounts: HolidaySchedulePricingAmountListInput;
  pricingRuleId: Scalars['ID'];
};


export type MutationUpdatePricingRuleTimeScheduleSpecificAmountsArgs = {
  courierId: Scalars['ID'];
  pricingRuleId: Scalars['ID'];
  timeScheduleSpecificAmounts: TimeScheduleSpecificAmountsInput;
};


export type MutationUpdatePricingSettingsArgs = {
  courierId: Scalars['ID'];
  defaultCurrency?: InputMaybe<Scalars['String']>;
  defaultInvoiceTaxCodeName?: InputMaybe<Scalars['String']>;
  defaultInvoicingFrequency?: InputMaybe<InvoicingFrequency>;
  defaultPreAuthorizeAmountMinimum?: InputMaybe<Scalars['Money']>;
  defaultPreAuthorizeAmountMultiplier?: InputMaybe<Scalars['Money']>;
  defaultSalesTermId?: InputMaybe<Scalars['ID']>;
  defaultWeightBasis?: InputMaybe<WeightBasis>;
  dimFactor?: InputMaybe<Scalars['Float']>;
  freeWaitTimeInSeconds: Scalars['Int'];
  invoiceApprovalPreconditionType?: InputMaybe<InvoiceApprovalPreconditionType>;
  invoiceCycleStartDate?: InputMaybe<Scalars['Date']>;
  invoiceOrdersInclusionType?: InputMaybe<InvoiceOrdersInclusionType>;
  minimumTimeRequiredForWaitTimeSurchargeInSeconds?: InputMaybe<Scalars['Int']>;
  multiStopPricingSequenceType?: InputMaybe<MultiStopPricingSequenceType>;
  orderPriceTaxDisplayType?: InputMaybe<OrderPriceTaxDisplayType>;
};


export type MutationUpdateQuoteArgs = {
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  caller?: InputMaybe<Scalars['String']>;
  callerPhone?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  numDaysToExpire: Scalars['Int'];
  orderPrice: QuoteOrderPriceInput;
  requiredDocumentTypes?: InputMaybe<Array<DocumentType>>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipmentUpdate: QuoteShipmentFullUpdate;
  warnedDocumentTypes?: InputMaybe<Array<DocumentType>>;
};


export type MutationUpdateRegionalSettingsArgs = {
  courierId: Scalars['ID'];
  currencyDisplay: Scalars['String'];
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  distanceUnit: DistanceUnit;
  weightUnit: WeightUnit;
};


export type MutationUpdateRouteTemplateScheduleArgs = {
  courierId: Scalars['ID'];
  routeTemplateId: Scalars['ID'];
  schedule?: InputMaybe<RouteTemplateScheduleListInput>;
};


export type MutationUpdateSalesTermsForEndCustomersArgs = {
  courierId: Scalars['ID'];
  input: Array<EndCustomerSalesTermUpdate>;
};


export type MutationUpdateServiceTypeBusinessHoursScheduleArgs = {
  businessHoursSchedule?: InputMaybe<TimeScheduleInput>;
  courierId: Scalars['ID'];
  serviceTypeId: Scalars['ID'];
};


export type MutationUpdateServiceTypePricingMultiplierArgs = {
  courierId: Scalars['ID'];
  multiplier?: InputMaybe<Scalars['Money']>;
  multiplierMode: ServiceTypeMultiplierMode;
  serviceTypeId: Scalars['ID'];
};


export type MutationUpdateServiceTypeReadyTimeScheduleArgs = {
  courierId: Scalars['ID'];
  readyTimeSchedule: TimeScheduleInput;
  serviceTypeId: Scalars['ID'];
};


export type MutationUpdateServiceTypeVisibleVehicleTypesArgs = {
  courierId: Scalars['ID'];
  defaultVehicleTypeId?: InputMaybe<Scalars['ID']>;
  serviceTypeId: Scalars['ID'];
  visibleVehicleTypeIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateShipmentsCustomFiltersArgs = {
  courierId: Scalars['ID'];
  filters: Array<ShipmentsCustomFilterInput>;
};


export type MutationUpdateSurchargePricingRuleAdvancedMultipliersArgs = {
  advancedMultiplier?: InputMaybe<SurchargePricingRuleAdvancedMultiplierInput>;
  courierId: Scalars['ID'];
  surchargePricingRuleId: Scalars['ID'];
};


export type MutationUpdateSurchargePricingRuleAdvancedSettingArgs = {
  courierId: Scalars['ID'];
  input: SurchargePricingRuleAdvancedSettingsInput;
};


export type MutationUpdateSurchargePricingRuleInvoiceSummaryGroupArgs = {
  courierId: Scalars['ID'];
  invoiceSummaryGroup?: InputMaybe<Scalars['String']>;
  surchargePricingRuleId: Scalars['ID'];
};


export type MutationUpdateSurchargePricingRuleTaxableStatusArgs = {
  courierId: Scalars['ID'];
  surchargePricingRuleId: Scalars['ID'];
  taxableStatus: SurchargeTaxStatus;
};


export type MutationUpdateUserNotificationSettingsArgs = {
  courierId: Scalars['ID'];
  enabledNotificationTypes: Array<NotificationType>;
  userId: Scalars['ID'];
};


export type MutationUpdateVehicleTypeReadyTimeScheduleArgs = {
  courierId: Scalars['ID'];
  readyTimeSchedule: TimeScheduleInput;
  vehicleTypeId: Scalars['ID'];
};


export type MutationUpdateVehicleTypeVisiblePackageTypesArgs = {
  courierId: Scalars['ID'];
  vehicleTypeId: Scalars['ID'];
  visiblePackageTypeIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateWebhookSubscriptionArgs = {
  additionalHeaders?: InputMaybe<Array<WebhookHeaderInput>>;
  authHeader?: InputMaybe<Scalars['String']>;
  endCustomerScope?: InputMaybe<EndCustomerScope>;
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  scopedEndCustomerIds?: InputMaybe<Array<Scalars['String']>>;
  secret?: InputMaybe<Scalars['String']>;
  subscribedEvents?: InputMaybe<Array<WebhookEventName>>;
  url?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateZonesArgs = {
  courierId: Scalars['ID'];
  zones: Array<ZoneUpdate>;
};


export type MutationUploadDriverPhotoArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationUploadFileV1Args = {
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
  lngLat?: InputMaybe<LngLatInput>;
  taskId?: InputMaybe<Scalars['ID']>;
  type: FileType;
  value?: InputMaybe<Scalars['String']>;
};


export type MutationUploadFilesForMultiTaskV1Args = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  lngLat?: InputMaybe<LngLatInput>;
  taskIds: Array<Scalars['ID']>;
  type: FileType;
  value?: InputMaybe<Scalars['String']>;
};


export type MutationUploadFuelSurchargeGridCsvArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationUploadZonesFromKmzArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationUpsertCourierEmailConfigurationArgs = {
  ccEmails?: InputMaybe<Array<Scalars['String']>>;
  communicationType?: InputMaybe<CommunicationTypeId>;
  courierId: Scalars['ID'];
  replyToEmails?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpsertCourierOfflineSettingsArgs = {
  courierId: Scalars['ID'];
  gpsValidation: OfflineValidationMode;
  locationScanValidation: OfflineValidationMode;
  podValidation: OfflineValidationMode;
  questionValidation: OfflineValidationMode;
  scanValidation: OfflineValidationMode;
};


export type MutationUpsertCoverageAreaArgs = {
  courierId: Scalars['ID'];
  zoneIds: Array<Scalars['ID']>;
};


export type MutationUpsertDriverAnswerArgs = {
  answerNumber?: InputMaybe<Scalars['Float']>;
  answerPhoto?: InputMaybe<Scalars['Upload']>;
  answerText?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  driverQuestionId: Scalars['ID'];
  taskId: Scalars['ID'];
};


export type MutationUpsertDriverCompliancePolicyArgs = {
  courierId: Scalars['ID'];
  entityId: Scalars['ID'];
  excludedDocumentTypes?: InputMaybe<Array<DocumentType>>;
  requiredDocumentTypes?: InputMaybe<Array<DocumentType>>;
  warnedDocumentTypes?: InputMaybe<Array<DocumentType>>;
};


export type MutationUpsertFcmTokenV1Args = {
  courierId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  fcmToken: Scalars['String'];
};


export type MutationUpsertHolidayScheduleBehaviorArgs = {
  courierHolidayId: Scalars['ID'];
  courierId: Scalars['ID'];
  holidayBehavior: HolidayBehavior;
  holidayScheduleId: Scalars['ID'];
};


export type MutationUpsertLinkedAccountArgs = {
  linkedAccountCreate: LinkedAccountCreate;
};


export type MutationUpsertPayrollSettingsArgs = {
  courierId: Scalars['ID'];
  defaultCommission: Scalars['Float'];
  driverPayExportType?: InputMaybe<DriverPayExportType>;
  ordersInclusionType?: InputMaybe<PayrollOrdersInclusionType>;
  payPeriodStartDate?: InputMaybe<Scalars['Date']>;
  payPeriodType: PayPeriodType;
};


export type MutationUpsertRemoteEntityLinkageArgs = {
  courierId: Scalars['ID'];
  upsert: RemoteEntityLinkageUpsert;
};


export type MutationUpsertShipmentTemplateDriverAssignmentsArgs = {
  courierId: Scalars['ID'];
  upserts: Array<ShipmentTemplateDriverAssignmentUpsertInput>;
};


export type MutationUpsertStopTemplateSequenceNumbersArgs = {
  courierId: Scalars['ID'];
  upserts: Array<ScheduledStopTemplateSequenceNumberUpsert>;
};


export type MutationUpsertUserStoreArgs = {
  courierId: Scalars['ID'];
  key: Scalars['String'];
  userOrEmployeeId: Scalars['ID'];
  value: Scalars['String'];
};


export type MutationVoidInvoicesArgs = {
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']>;
};

export enum NewCustomerConfirmationStatus {
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED'
}

export enum NotificationType {
  DailyOrdersPreview = 'DAILY_ORDERS_PREVIEW',
  NewUnassignedOrder = 'NEW_UNASSIGNED_ORDER'
}

export enum OdometerRequirementType {
  None = 'NONE',
  RequiredAtFirstArrived = 'REQUIRED_AT_FIRST_ARRIVED'
}

export enum OfflineMode {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export enum OfflineValidationMode {
  Bypass = 'BYPASS',
  Validate = 'VALIDATE'
}

export type OptimizeRouteForDispatchResult = {
  __typename?: 'OptimizeRouteForDispatchResult';
  /**
   *  Every shipment a group commit will assign, in step order. Null unless a whole assignment group was routed.
   *  For display only: the commit works the group out again itself.
   */
  allShipmentIdsForGroupDispatch?: Maybe<Array<Scalars['ID']>>;
  stops: Array<Stop>;
};

export type Order = {
  __typename?: 'Order';
  acquisitionType: OrderAcquisitionType;
  additionalEmailRecipients?: Maybe<Array<Scalars['String']>>;
  additionalInfoCount: Scalars['Int'];
  assignedLabels: Array<Label>;
  basePriceOverride?: Maybe<Scalars['Money']>;
  billableItem?: Maybe<BillableItem>;
  billableType: BillableType;
  caller?: Maybe<Scalars['String']>;
  callerPhone?: Maybe<Scalars['String']>;
  commissionableBaseFixed?: Maybe<Scalars['Money']>;
  commissionableBasePercent?: Maybe<Scalars['Money']>;
  costCenter?: Maybe<CostCenter>;
  costCenterId?: Maybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdByEndCustomer?: Maybe<EndCustomer>;
  createdByEndUser?: Maybe<EndUser>;
  /** # additional fields */
  createdByUser?: Maybe<CourieUser>;
  customFieldValues: Array<CustomFieldValue>;
  dispatchableType: DispatchableType;
  displayId: Scalars['Int'];
  driverPayOverride?: Maybe<Scalars['Money']>;
  driverPayPercent?: Maybe<Scalars['Money']>;
  endCustomer: EndCustomer;
  endCustomerReferenceNumber?: Maybe<Scalars['String']>;
  holidaySchedule?: Maybe<HolidaySchedule>;
  id: Scalars['ID'];
  milesOverride?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  orderAttachments: Array<OrderAttachment>;
  /**  The order group this order belongs to. Null when the order is in no live order group. */
  orderGroupOverview?: Maybe<OrderGroupOverview>;
  /**  Deprecated. Use orderPayBreakDownWithAllocation instead. */
  orderPayBreakDown?: Maybe<OrderPayBreakDown>;
  orderPayBreakDownWithAllocation?: Maybe<OrderPayBreakDownWithAllocationResult>;
  price: OrderPrice;
  priceOverride?: Maybe<Scalars['Money']>;
  priceOverrideBreakdown?: Maybe<Array<PriceOverrideBreakdownItem>>;
  pricingStopIds?: Maybe<Array<Scalars['ID']>>;
  recurrenceDetail?: Maybe<RecurrenceDetail>;
  recurrenceType: RecurrenceType;
  serviceType?: Maybe<ServiceType>;
  shipment?: Maybe<Shipment>;
  taxCodeOverride?: Maybe<Scalars['String']>;
  userHasClicked: Scalars['Boolean'];
};


export type OrderUserHasClickedArgs = {
  userId: Scalars['ID'];
};

export enum OrderAcquisitionType {
  /** Booked by the Customer Support (voice) assistant for the customer on the call. */
  AiCustomerSupportAgent = 'AI_CUSTOMER_SUPPORT_AGENT',
  Api = 'API',
  BulkUpload = 'BULK_UPLOAD',
  CustomerPortal = 'CUSTOMER_PORTAL',
  ThirdPartyEndCustomer = 'THIRD_PARTY_END_CUSTOMER',
  User = 'USER'
}

export type OrderAttachment = {
  __typename?: 'OrderAttachment';
  fileName: Scalars['String'];
  id: Scalars['ID'];
  publicUrl: Scalars['String'];
};

export type OrderAttachmentCreate = {
  file: Scalars['Upload'];
  orderId: Scalars['ID'];
};

export type OrderAutomation = {
  __typename?: 'OrderAutomation';
  actionRules: Array<OrderAutomationActionRule>;
  courierId: Scalars['ID'];
  filters: Array<OrderAutomationFilter>;
  id: Scalars['ID'];
  name: Scalars['String'];
  optedOutAt?: Maybe<Scalars['Timestamp']>;
  priority?: Maybe<Scalars['Int']>;
  triggerType: OrderAutomationTriggerType;
};

export type OrderAutomationActionRule = {
  __typename?: 'OrderAutomationActionRule';
  actionType: OrderAutomationActionType;
  dayOffset?: Maybe<Scalars['Int']>;
  destination?: Maybe<Scalars['String']>;
  destinationType?: Maybe<PricingBoundaryType>;
  driverFilterType: OrderAutomationDriverFilterType;
  driverIds?: Maybe<Array<Scalars['ID']>>;
  driverLabelIds?: Maybe<Array<Scalars['ID']>>;
  driverLabels: Array<Label>;
  drivers: Array<Driver>;
  id: Scalars['ID'];
  keepStopType?: Maybe<ShipmentStopType>;
  labelIds?: Maybe<Array<Scalars['ID']>>;
  maxStopsPerDriver?: Maybe<Scalars['Int']>;
  orderAutomationId: Scalars['ID'];
  origin?: Maybe<Scalars['String']>;
  originType?: Maybe<PricingBoundaryType>;
  rank: Scalars['Int'];
  routeTemplate?: Maybe<RouteTemplate>;
  routeTemplateId?: Maybe<Scalars['ID']>;
  taxCode?: Maybe<Scalars['String']>;
  vehicleTypeIds?: Maybe<Array<Scalars['ID']>>;
  vehicleTypes: Array<VehicleType>;
};

export type OrderAutomationActionRuleInput = {
  actionType: OrderAutomationActionType;
  dayOffset?: InputMaybe<Scalars['Int']>;
  destination?: InputMaybe<Scalars['String']>;
  destinationType?: InputMaybe<PricingBoundaryType>;
  driverFilterType?: InputMaybe<OrderAutomationDriverFilterType>;
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  keepStopType?: InputMaybe<ShipmentStopType>;
  labelIds?: InputMaybe<Array<Scalars['ID']>>;
  maxStopsPerDriver?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['String']>;
  originType?: InputMaybe<PricingBoundaryType>;
  routeTemplateId?: InputMaybe<Scalars['ID']>;
  taxCode?: InputMaybe<Scalars['String']>;
  vehicleTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum OrderAutomationActionType {
  LabelAssignment = 'LABEL_ASSIGNMENT',
  MakeSingleStop = 'MAKE_SINGLE_STOP',
  RouteAssignment = 'ROUTE_ASSIGNMENT',
  RuleBasedDriverAssignment = 'RULE_BASED_DRIVER_ASSIGNMENT',
  SetShipmentDate = 'SET_SHIPMENT_DATE',
  SetTaxCode = 'SET_TAX_CODE'
}

/** OrderAutomation Connection */
export type OrderAutomationConnection = {
  __typename?: 'OrderAutomationConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<OrderAutomationEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export enum OrderAutomationDriverFilterType {
  All = 'ALL',
  Online = 'ONLINE'
}

/** OrderAutomation Edge */
export type OrderAutomationEdge = {
  __typename?: 'OrderAutomationEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<OrderAutomation>;
};

export type OrderAutomationEndCustomerFilter = {
  __typename?: 'OrderAutomationEndCustomerFilter';
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  orderAutomationFilterId: Scalars['ID'];
};

export type OrderAutomationEndCustomerFilterInput = {
  endCustomerId: Scalars['ID'];
};

export type OrderAutomationFilter = {
  __typename?: 'OrderAutomationFilter';
  entityIds?: Maybe<Array<Scalars['ID']>>;
  filterType: OrderAutomationFilterType;
  id: Scalars['ID'];
  orderAutomationEndCustomerFilters?: Maybe<Array<OrderAutomationEndCustomerFilter>>;
  orderAutomationId: Scalars['ID'];
  orderAutomationZoneToZoneFilters?: Maybe<Array<OrderAutomationZoneToZoneFilter>>;
  schedule?: Maybe<AutomationTimeScheduleList>;
};

export type OrderAutomationFilterInput = {
  entityIds?: InputMaybe<Array<Scalars['ID']>>;
  filterType: OrderAutomationFilterType;
  orderAutomationEndCustomerFilters?: InputMaybe<Array<OrderAutomationEndCustomerFilterInput>>;
  orderAutomationZoneToZoneFilters?: InputMaybe<Array<OrderAutomationZoneToZoneFilterInput>>;
  schedule?: InputMaybe<AutomationTimeScheduleListInput>;
};

export enum OrderAutomationFilterType {
  DeliverByTimeSchedule = 'DELIVER_BY_TIME_SCHEDULE',
  EndCustomers = 'END_CUSTOMERS',
  EntryTimeSchedule = 'ENTRY_TIME_SCHEDULE',
  PackageTypes = 'PACKAGE_TYPES',
  ReadyTimeSchedule = 'READY_TIME_SCHEDULE',
  ServiceTypes = 'SERVICE_TYPES',
  VehicleTypes = 'VEHICLE_TYPES',
  ZoneToZones = 'ZONE_TO_ZONES'
}

export type OrderAutomationRuleFullUpdateInput = {
  actionRules: Array<OrderAutomationActionRuleInput>;
  filters: Array<OrderAutomationFilterInput>;
  id: Scalars['ID'];
  name: Scalars['String'];
  priority?: InputMaybe<Scalars['Int']>;
};

export enum OrderAutomationTriggerType {
  OrderCreate = 'ORDER_CREATE'
}

export type OrderAutomationZoneToZoneFilter = {
  __typename?: 'OrderAutomationZoneToZoneFilter';
  destination?: Maybe<Scalars['String']>;
  destinationType?: Maybe<PricingBoundaryType>;
  /** @deprecated Use destination and destinationType instead */
  destinationZoneId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  orderAutomationFilterId: Scalars['ID'];
  origin?: Maybe<Scalars['String']>;
  originType?: Maybe<PricingBoundaryType>;
  /** @deprecated Use origin and originType instead */
  originZoneId?: Maybe<Scalars['ID']>;
};

export type OrderAutomationZoneToZoneFilterInput = {
  destination?: InputMaybe<Scalars['String']>;
  destinationType?: InputMaybe<PricingBoundaryType>;
  destinationZoneId?: InputMaybe<Scalars['ID']>;
  origin?: InputMaybe<Scalars['String']>;
  originType?: InputMaybe<PricingBoundaryType>;
  originZoneId?: InputMaybe<Scalars['ID']>;
};

export type OrderClick = {
  __typename?: 'OrderClick';
  clickedBy: Scalars['String'];
  id: Scalars['ID'];
  orderId: Scalars['ID'];
};

export enum OrderCombinationType {
  AllOrders = 'ALL_ORDERS',
  None = 'NONE',
  OrderPerRecurringOrder = 'ORDER_PER_RECURRING_ORDER'
}

export type OrderDriverComplianceStatus = {
  __typename?: 'OrderDriverComplianceStatus';
  missingRequired: Array<DocumentType>;
  missingWarned: Array<DocumentType>;
  orderId: Scalars['ID'];
};

export enum OrderEntryDefaultAddressAutoFillType {
  DropOff = 'DROP_OFF',
  None = 'NONE',
  PickUp = 'PICK_UP'
}

export type OrderGroup = {
  __typename?: 'OrderGroup';
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  displayId: Scalars['Int'];
  id: Scalars['ID'];
  orderGroupBuilderId?: Maybe<Scalars['ID']>;
};

export type OrderGroupAssignmentGroupInput = {
  /**
   * Members of this assignment group. When the builder is SEQUENCED the list order is
   * the sequence: first = 1, second = 2, and so on.
   */
  orderIds: Array<Scalars['ID']>;
};

export enum OrderGroupBuildAssignmentType {
  None = 'NONE',
  SingleGroup = 'SINGLE_GROUP'
}

export enum OrderGroupBuildCustomerVisibilityType {
  AllVisible = 'ALL_VISIBLE',
  NonBillableOrdersInvisible = 'NON_BILLABLE_ORDERS_INVISIBLE'
}

/**
 * Asks the order's builder to create extra legs while the order is booked.
 * For a round trip: exactly one leg, the way back. Empty fields copy the outbound trip.
 */
export type OrderGroupBuildDetailInput = {
  additionalLegs: Array<AdditionalLegInput>;
  orderGroupBuilderId: Scalars['ID'];
};

export enum OrderGroupBuildOrderEntryAutoApplyType {
  AutoApplyOnRoundTrip = 'AUTO_APPLY_ON_ROUND_TRIP',
  None = 'NONE'
}

export enum OrderGroupBuildSequencingType {
  None = 'NONE',
  Sequenced = 'SEQUENCED'
}

export enum OrderGroupBuildType {
  CombineIntoOne = 'COMBINE_INTO_ONE',
  MiddleStopTwoLegs = 'MIDDLE_STOP_TWO_LEGS',
  RoundTripTwoLegs = 'ROUND_TRIP_TWO_LEGS',
  SplitIntoSingleStops = 'SPLIT_INTO_SINGLE_STOPS'
}

export type OrderGroupBuilder = {
  __typename?: 'OrderGroupBuilder';
  assignmentType: OrderGroupBuildAssignmentType;
  buildType: OrderGroupBuildType;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  customerVisibilityType: OrderGroupBuildCustomerVisibilityType;
  id: Scalars['ID'];
  name: Scalars['String'];
  orderEntryAutoApply: OrderGroupBuildOrderEntryAutoApplyType;
  sequencingType: OrderGroupBuildSequencingType;
  stationaryStop?: Maybe<StationaryStop>;
};

/** OrderGroupBuilder Connection */
export type OrderGroupBuilderConnection = {
  __typename?: 'OrderGroupBuilderConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<OrderGroupBuilderEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** OrderGroupBuilder Edge */
export type OrderGroupBuilderEdge = {
  __typename?: 'OrderGroupBuilderEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<OrderGroupBuilder>;
};

export type OrderGroupDetail = {
  __typename?: 'OrderGroupDetail';
  /**
   *  True when the dispatchable members form one ordered chain: every one has a step number and they
   *  all sit in the same live assignment group.
   */
  isSequenced: Scalars['Boolean'];
  /**  Billing-only (non-dispatchable) members first, then the chain in step order. */
  members: Array<OrderGroupMemberDetail>;
  orderGroup: OrderGroup;
  /**  The builder that produced this group. Null when it was built without one, or the builder was deleted. */
  orderGroupBuilder?: Maybe<OrderGroupBuilder>;
};

export type OrderGroupMemberDetail = {
  __typename?: 'OrderGroupMemberDetail';
  /**  The live assignment group this member is in; null when it has none, or that group was deleted. */
  assignmentGroupId?: Maybe<Scalars['ID']>;
  /**  "Leg 1 of 2", "1 of 3", "Billing Only" or "Non Dispatchable". The same text the order's row label shows. */
  label: Scalars['String'];
  membershipType: OrderGroupMembershipType;
  order: Order;
  /**  Null when this member is not sequenced. */
  sequenceNumber?: Maybe<Scalars['Int']>;
};

/**
 *  The role an order plays in its group. ORIGINAL is the customer's own order; AUTO_GENERATED is a leg
 *  a splitting builder created.
 */
export enum OrderGroupMembershipType {
  AutoGenerated = 'AUTO_GENERATED',
  Original = 'ORIGINAL'
}

export type OrderGroupOverview = {
  __typename?: 'OrderGroupOverview';
  /**
   *  The live assignment group the order is in. Null when its order group has no assignment group,
   *  or that assignment group was deleted. Same rule group dispatch uses.
   */
  assignmentGroupId?: Maybe<Scalars['ID']>;
  /**  "Leg 1 of 2", "1 of 3", "Billing Only" or "Non Dispatchable". The same text the order group modal shows. */
  label: Scalars['String'];
  /**  The group's per-courier number, shown as "#123". */
  orderGroupDisplayId: Scalars['Int'];
  orderGroupId: Scalars['ID'];
};

export enum OrderIdentifierColumnType {
  OrderId = 'ORDER_ID',
  TrackingNumber = 'TRACKING_NUMBER'
}

export type OrderPayBreakDown = {
  __typename?: 'OrderPayBreakDown';
  items: Array<OrderPayBreakDownItem>;
  total: Scalars['Money'];
};

export type OrderPayBreakDownItem = {
  __typename?: 'OrderPayBreakDownItem';
  amount: Scalars['Money'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type OrderPayBreakDownWithAllocation = {
  __typename?: 'OrderPayBreakDownWithAllocation';
  allocationAmount?: Maybe<Scalars['Money']>;
  allocationRate?: Maybe<Scalars['Money']>;
  breakdown: OrderPayBreakDown;
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars['ID']>;
};

export type OrderPayBreakDownWithAllocationEntry = {
  __typename?: 'OrderPayBreakDownWithAllocationEntry';
  orderId: Scalars['ID'];
  result: OrderPayBreakDownWithAllocationResult;
};

export type OrderPayBreakDownWithAllocationResult = {
  __typename?: 'OrderPayBreakDownWithAllocationResult';
  allocations: Array<OrderPayBreakDownWithAllocation>;
  isOverride: Scalars['Boolean'];
  total: Scalars['Money'];
};

export type OrderPrice = {
  __typename?: 'OrderPrice';
  basePriceOverride?: Maybe<Scalars['Money']>;
  customSurchargeAdjustments?: Maybe<Array<PricingAdjustment>>;
  isBasePriceOverride: Scalars['Boolean'];
  isFinalized: Scalars['Boolean'];
  isPriceOverride: Scalars['Boolean'];
  nonTaxableTotal: Scalars['Money'];
  priceOverride?: Maybe<Scalars['Money']>;
  priceOverrideBreakdown?: Maybe<Array<PriceOverrideBreakdownItem>>;
  pricingBreakDown: PricingBreakDown;
  taxBreakDown?: Maybe<OrderPriceTaxBreakdown>;
  taxableTotal: Scalars['Money'];
  total: Scalars['Money'];
  totalAfterTax: Scalars['Money'];
  tripPrices: Array<OrderPriceTripPrice>;
};

export type OrderPriceTaxBreakdown = {
  __typename?: 'OrderPriceTaxBreakdown';
  taxItems: Array<OrderPriceTaxItem>;
  totalTaxAmount: Scalars['Money'];
};

export enum OrderPriceTaxDisplayType {
  IncludeGst = 'INCLUDE_GST',
  IncludeHst = 'INCLUDE_HST',
  None = 'NONE'
}

export type OrderPriceTaxItem = {
  __typename?: 'OrderPriceTaxItem';
  amount: Scalars['Money'];
  name: Scalars['String'];
};

export type OrderPriceTripPrice = {
  __typename?: 'OrderPriceTripPrice';
  amount: Scalars['Money'];
  durationsInSeconds: Scalars['Int'];
  miles: Scalars['Float'];
  packageWeightInLbs?: Maybe<Scalars['Float']>;
  pricingMultiplier: Scalars['Money'];
  pricingRuleDisplay: Scalars['String'];
  readyTimeList: Array<Scalars['Timestamp']>;
  scope: PriceScope;
  selectedPricingRuleId?: Maybe<Scalars['ID']>;
  unfreeMiles: Scalars['Float'];
};

export enum OrderingAlgorithmType {
  Beginning = 'BEGINNING',
  End = 'END',
  LeastDeviation = 'LEAST_DEVIATION',
  Manual = 'MANUAL',
  OnTimeFirstReoptimized = 'ON_TIME_FIRST_REOPTIMIZED',
  Reoptimized = 'REOPTIMIZED',
  /** @deprecated No longer supported. Use REOPTIMIZED. */
  ReoptimizedMileage = 'REOPTIMIZED_MILEAGE'
}

export type OrdersCsvFile = {
  __typename?: 'OrdersCsvFile';
  url: Scalars['String'];
};

export type OrdersFile = {
  __typename?: 'OrdersFile';
  url: Scalars['String'];
};

export type OtherQualityReviewResult = {
  __typename?: 'OtherQualityReviewResult';
  issues: Array<IssueWithSuggestions>;
  verdict: Scalars['String'];
};

export type OtherReviewSetting = {
  __typename?: 'OtherReviewSetting';
  userPrompt?: Maybe<Scalars['String']>;
};

export type OtherReviewSettingInput = {
  userPrompt?: InputMaybe<Scalars['String']>;
};

export enum OverrideType {
  Grant = 'GRANT',
  Revoke = 'REVOKE'
}

export type Package = {
  __typename?: 'Package';
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  events: Array<PackageEvent>;
  id: Scalars['ID'];
  /** # additional fields */
  lastEvent?: Maybe<PackageEvent>;
  reference: Scalars['String'];
  shipments: Array<Shipment>;
  status: PackageStatus;
};

/** Package Connection */
export type PackageConnection = {
  __typename?: 'PackageConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<PackageEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type PackageCountBasedMultiplier = {
  __typename?: 'PackageCountBasedMultiplier';
  maxPackageCount?: Maybe<Scalars['Int']>;
  minPackageCount?: Maybe<Scalars['Int']>;
  multiplier: Scalars['Money'];
};

export type PackageCountBasedMultiplierInput = {
  maxPackageCount?: InputMaybe<Scalars['Int']>;
  minPackageCount?: InputMaybe<Scalars['Int']>;
  multiplier: Scalars['Money'];
};

/** Package Edge */
export type PackageEdge = {
  __typename?: 'PackageEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<Package>;
};

export type PackageEvent = {
  __typename?: 'PackageEvent';
  action: PackageEventPostAction;
  courierId: Scalars['ID'];
  createdAt: Scalars['String'];
  deviceId?: Maybe<Scalars['String']>;
  deviceTime?: Maybe<Scalars['String']>;
  eventBy: Scalars['String'];
  eventByDriver?: Maybe<Driver>;
  /**
   *  Human-readable event-type name, always populated: falls back to the built-in
   *  scan-mode name (e.g. "Scan at Pickup") when there is no courier-defined packageEventType.
   */
  eventTypeName: Scalars['String'];
  fromParty?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lngLat?: Maybe<LngLat>;
  packageEventType?: Maybe<PackageEventType>;
  packageEventTypeId?: Maybe<Scalars['ID']>;
  packageId: Scalars['ID'];
  packageStatus: PackageStatus;
  toParty?: Maybe<Scalars['String']>;
};

export enum PackageEventPostAction {
  AssignAndPickup = 'ASSIGN_AND_PICKUP',
  CreatePackageAndAssociateToMyNextOrder = 'CREATE_PACKAGE_AND_ASSOCIATE_TO_MY_NEXT_ORDER',
  Delivery = 'DELIVERY',
  InformPackageAssignment = 'INFORM_PACKAGE_ASSIGNMENT',
  None = 'NONE',
  OutOfWarehouse = 'OUT_OF_WAREHOUSE',
  OutOfWarehouseReassignToSelf = 'OUT_OF_WAREHOUSE_REASSIGN_TO_SELF',
  Pickup = 'PICKUP',
  PickupAndStoreAtWarehouse = 'PICKUP_AND_STORE_AT_WAREHOUSE',
  StoreAtWarehouse = 'STORE_AT_WAREHOUSE',
  StoreAtWarehouseReassign = 'STORE_AT_WAREHOUSE_REASSIGN'
}

export type PackageEventResult = {
  __typename?: 'PackageEventResult';
  packageEvent: PackageEvent;
  successMessage: Scalars['String'];
};

export type PackageEventType = {
  __typename?: 'PackageEventType';
  action: PackageEventPostAction;
  driverAssignmentValidationType: DriverAssignmentValidationType;
  id: Scalars['ID'];
  name: Scalars['String'];
  packageScanNewPackageHandleType: PackageScanNewPackageHandleType;
  reassignDriver?: Maybe<Driver>;
  reassignDriverId?: Maybe<Scalars['ID']>;
};

/**  Wrapper of PackageEventType that is made for mobile app query */
export type PackageEventTypeForDriver = {
  __typename?: 'PackageEventTypeForDriver';
  isDefault: Scalars['Boolean'];
  packageEventType: PackageEventType;
};

export type PackageItem = {
  __typename?: 'PackageItem';
  height?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  /** Optional per-item override; null inherits the shipment's package type. */
  packageTypeId?: Maybe<Scalars['ID']>;
  /**
   * How many identical physical pieces this row stands for. Dimensions and `weight` are per piece,
   * so `quantity: 5, weight: 10` is 5 pieces weighing 50 lbs in total. Null on rows written before
   * quantity existed and reads as 1.
   */
  quantity?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type PackageItemInput = {
  height?: InputMaybe<Scalars['Float']>;
  length?: InputMaybe<Scalars['Float']>;
  /** Optional per-item override; null inherits the shipment's package type. */
  packageTypeId?: InputMaybe<Scalars['ID']>;
  /**
   * How many identical physical pieces this row stands for. Dimensions and `weight` are per piece,
   * so `quantity: 5, weight: 10` is 5 pieces weighing 50 lbs in total. Omit for a single piece.
   */
  quantity?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type PackageMovement = {
  __typename?: 'PackageMovement';
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** PackageMovement Connection */
export type PackageMovementConnection = {
  __typename?: 'PackageMovementConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<PackageMovementEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** PackageMovement Edge */
export type PackageMovementEdge = {
  __typename?: 'PackageMovementEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<PackageMovement>;
};

export enum PackageScanNewPackageHandleType {
  AssociateWithTrackingNumber = 'ASSOCIATE_WITH_TRACKING_NUMBER',
  None = 'NONE'
}

export enum PackageSize {
  L = 'L',
  M = 'M',
  S = 'S',
  Xl = 'XL',
  Xs = 'XS',
  Xxl = 'XXL'
}

export enum PackageStatus {
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Driver = 'DRIVER',
  Warehouse = 'WAREHOUSE'
}

export type PackageType = {
  __typename?: 'PackageType';
  category: PackageTypeCategory;
  courierId: Scalars['ID'];
  defaultHeight?: Maybe<Scalars['Float']>;
  defaultLength?: Maybe<Scalars['Float']>;
  defaultWeight?: Maybe<Scalars['Float']>;
  defaultWeightApplication: PackageTypeDefaultWeightApplication;
  defaultWidth?: Maybe<Scalars['Float']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum PackageTypeCategory {
  General = 'GENERAL',
  Skid = 'SKID'
}

export enum PackageTypeDefaultWeightApplication {
  Locked = 'LOCKED',
  Normal = 'NORMAL'
}

export type PackageTypeOverride = {
  __typename?: 'PackageTypeOverride';
  customName?: Maybe<Scalars['String']>;
  defaultHeight?: Maybe<Scalars['Float']>;
  defaultLength?: Maybe<Scalars['Float']>;
  defaultWeight?: Maybe<Scalars['Float']>;
  defaultWeightApplication?: Maybe<PackageTypeDefaultWeightApplication>;
  defaultWidth?: Maybe<Scalars['Float']>;
  entityId: Scalars['ID'];
  packageTypeId: Scalars['ID'];
  status: PackageTypeOverrideStatus;
};

export type PackageTypeOverrideInput = {
  customName?: InputMaybe<Scalars['String']>;
  defaultHeight?: InputMaybe<Scalars['Float']>;
  defaultLength?: InputMaybe<Scalars['Float']>;
  defaultWeight?: InputMaybe<Scalars['Float']>;
  defaultWeightApplication?: InputMaybe<PackageTypeDefaultWeightApplication>;
  defaultWidth?: InputMaybe<Scalars['Float']>;
  packageTypeId: Scalars['ID'];
  status: PackageTypeOverrideStatus;
};

export enum PackageTypeOverrideStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

/** PageInfo */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Field endCursor */
  endCursor?: Maybe<Scalars['String']>;
  /** Field hasNextPage */
  hasNextPage: Scalars['Boolean'];
  /** Field hasPreviousPage */
  hasPreviousPage: Scalars['Boolean'];
  /** Field startCursor */
  startCursor?: Maybe<Scalars['String']>;
};

export type Partner = {
  __typename?: 'Partner';
  apiKey?: Maybe<Scalars['String']>;
  courierIds: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PayPeriod = {
  __typename?: 'PayPeriod';
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export enum PayPeriodType {
  Biweekly = 'BIWEEKLY',
  Semimonthly = 'SEMIMONTHLY',
  Weekly = 'WEEKLY'
}

export type PaymentAdditionalFee = {
  __typename?: 'PaymentAdditionalFee';
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  paymentAdditionalFeeRuleId: Scalars['ID'];
  paymentTransferId: Scalars['ID'];
  status: PaymentAdditionalFeeStatus;
};

export type PaymentAdditionalFeeRule = {
  __typename?: 'PaymentAdditionalFeeRule';
  amount?: Maybe<Scalars['Money']>;
  applyLevel: PaymentFeeApplyLevel;
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  percent?: Maybe<Scalars['Money']>;
};

export type PaymentAdditionalFeeRuleCreate = {
  amount?: InputMaybe<Scalars['Money']>;
  applyLevel: PaymentFeeApplyLevel;
  name: Scalars['String'];
  percent?: InputMaybe<Scalars['Money']>;
};

export type PaymentAdditionalFeeRuleFullUpdate = {
  amount?: InputMaybe<Scalars['Money']>;
  applyLevel: PaymentFeeApplyLevel;
  id: Scalars['ID'];
  name: Scalars['String'];
  percent?: InputMaybe<Scalars['Money']>;
};

export enum PaymentAdditionalFeeStatus {
  Created = 'CREATED',
  Sent = 'SENT',
  Succeeded = 'SUCCEEDED'
}

export type PaymentAuthorization = {
  __typename?: 'PaymentAuthorization';
  amount: Scalars['Money'];
  /**  what Finix actually approved (may be less than amountRequested if partial authorization) */
  amountRequested?: Maybe<Scalars['Money']>;
  /**  what was originally sent to Finix to authorize */
  captureAmount?: Maybe<Scalars['Money']>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  endCustomer?: Maybe<EndCustomer>;
  endCustomerId: Scalars['ID'];
  expiresAt: Scalars['Timestamp'];
  /**  derived: CAPTURED > VOIDED > FAILED > PENDING */
  failureCode?: Maybe<Scalars['String']>;
  failureMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orders: Array<Order>;
  sourcePaymentInstrument?: Maybe<PaymentInstrument>;
  sourcePaymentInstrumentId?: Maybe<Scalars['ID']>;
  /**  what was ultimately captured and charged to the customer */
  status: PaymentAuthorizationStatus;
};

/** PaymentAuthorization Connection */
export type PaymentAuthorizationConnection = {
  __typename?: 'PaymentAuthorizationConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<PaymentAuthorizationEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** PaymentAuthorization Edge */
export type PaymentAuthorizationEdge = {
  __typename?: 'PaymentAuthorizationEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<PaymentAuthorization>;
};

export enum PaymentAuthorizationStatus {
  Captured = 'CAPTURED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Voided = 'VOIDED'
}

export enum PaymentFeeApplyLevel {
  EachPayment = 'EACH_PAYMENT',
  Invoice = 'INVOICE'
}

export type PaymentInstrument = {
  __typename?: 'PaymentInstrument';
  bankAccountDetail?: Maybe<BankAccountDetail>;
  costCenterId?: Maybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  creditCardDetail?: Maybe<CreditCardDetail>;
  endCustomerId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  paymentInstrumentType: PaymentInstrumentType;
};

export enum PaymentInstrumentAcquisitionSource {
  CustomerPortal = 'CUSTOMER_PORTAL',
  Onboarding = 'ONBOARDING',
  Web = 'WEB'
}

export type PaymentInstrumentCreate = {
  source: PaymentInstrumentAcquisitionSource;
  token: Scalars['String'];
};

export enum PaymentInstrumentType {
  BankAccount = 'BANK_ACCOUNT',
  CanadianBankAccount = 'CANADIAN_BANK_ACCOUNT',
  CreditCard = 'CREDIT_CARD',
  PlaidBankAccount = 'PLAID_BANK_ACCOUNT'
}

export type PaymentSettlement = {
  __typename?: 'PaymentSettlement';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  merchantId: Scalars['String'];
  netAmount: Scalars['Money'];
  providerCreatedAt: Scalars['Timestamp'];
  remoteId: Scalars['String'];
  status: SettlementStatus;
  totalAmount: Scalars['Money'];
  totalFee: Scalars['Money'];
  totalFeeIncludingSubscriptionBilling: Scalars['Money'];
  type: Scalars['String'];
};

/** PaymentSettlement Connection */
export type PaymentSettlementConnection = {
  __typename?: 'PaymentSettlementConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<PaymentSettlementEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** PaymentSettlement Edge */
export type PaymentSettlementEdge = {
  __typename?: 'PaymentSettlementEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<PaymentSettlement>;
};

export type PaymentTransfer = {
  __typename?: 'PaymentTransfer';
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  currency: Scalars['String'];
  displayId: Scalars['Int'];
  endCustomer?: Maybe<EndCustomer>;
  endCustomerId?: Maybe<Scalars['ID']>;
  failureCode?: Maybe<Scalars['String']>;
  failureMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoicePayments: Array<InvoicePayment>;
  parentPaymentTransfer?: Maybe<PaymentTransfer>;
  paymentAdditionalFees: Array<PaymentAdditionalFee>;
  refundType: PaymentTransferRefundType;
  sourcePaymentInstrument?: Maybe<PaymentInstrument>;
  status: PaymentTransferStatus;
};

/** PaymentTransfer Connection */
export type PaymentTransferConnection = {
  __typename?: 'PaymentTransferConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<PaymentTransferEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** PaymentTransfer Edge */
export type PaymentTransferEdge = {
  __typename?: 'PaymentTransferEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<PaymentTransfer>;
};

export enum PaymentTransferRefundType {
  None = 'NONE',
  Refund = 'REFUND'
}

export enum PaymentTransferStatus {
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  ProviderCanceled = 'PROVIDER_CANCELED',
  Returned = 'RETURNED',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type PayrollDeductionAmount = {
  __typename?: 'PayrollDeductionAmount';
  amountTotal: Scalars['Money'];
  name: Scalars['String'];
};

export enum PayrollDeductionAmountType {
  PerDay = 'PER_DAY',
  PerWeekRoundCeiling = 'PER_WEEK_ROUND_CEILING',
  PerWeekRoundFloor = 'PER_WEEK_ROUND_FLOOR',
  SemiMonthly = 'SEMI_MONTHLY'
}

export type PayrollDeductionRule = {
  __typename?: 'PayrollDeductionRule';
  amount?: Maybe<Scalars['Money']>;
  amountType: PayrollDeductionAmountType;
  courierId: Scalars['ID'];
  driverIds?: Maybe<Array<Scalars['ID']>>;
  drivers: Array<Driver>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ruleType: PayrollDeductionRuleType;
  startDate?: Maybe<Scalars['Date']>;
};

/** PayrollDeductionRule Connection */
export type PayrollDeductionRuleConnection = {
  __typename?: 'PayrollDeductionRuleConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<PayrollDeductionRuleEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** PayrollDeductionRule Edge */
export type PayrollDeductionRuleEdge = {
  __typename?: 'PayrollDeductionRuleEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<PayrollDeductionRule>;
};

export enum PayrollDeductionRuleSortField {
  Amount = 'AMOUNT',
  Name = 'NAME',
  WhenToApply = 'WHEN_TO_APPLY'
}

export type PayrollDeductionRuleSorting = {
  direction: SortingDirection;
  field: PayrollDeductionRuleSortField;
};

export enum PayrollDeductionRuleType {
  AlwaysApply = 'ALWAYS_APPLY',
  DriverSpecific = 'DRIVER_SPECIFIC'
}

export type PayrollEmail = {
  __typename?: 'PayrollEmail';
  driverId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
  emailId?: Maybe<Scalars['String']>;
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  recipients: Array<Scalars['String']>;
};

export enum PayrollOrdersInclusionType {
  HideZeroPayOrders = 'HIDE_ZERO_PAY_ORDERS',
  ShowAll = 'SHOW_ALL'
}

export type PayrollReport = {
  __typename?: 'PayrollReport';
  amountTotal: Scalars['Money'];
  driver: Driver;
  driverId: Scalars['ID'];
  endDate: Scalars['Date'];
  ordersCount: Scalars['Int'];
  pdfFile: PayrollReportFile;
  startDate: Scalars['Date'];
};

export type PayrollReportFile = {
  __typename?: 'PayrollReportFile';
  url: Scalars['String'];
};

export type PayrollSetting = {
  __typename?: 'PayrollSetting';
  courierId: Scalars['ID'];
  defaultCommission: Scalars['Money'];
  driverPayExportType: DriverPayExportType;
  ordersInclusionType: PayrollOrdersInclusionType;
  payPeriodStartDate?: Maybe<Scalars['Date']>;
  payPeriodType: PayPeriodType;
};

export type PermissionOverride = {
  __typename?: 'PermissionOverride';
  overrideType: OverrideType;
  permission: Scalars['String'];
};

export type PermissionOverrideInput = {
  overrideType: OverrideType;
  permission: Scalars['String'];
};

export type PhotoReviewSetting = {
  __typename?: 'PhotoReviewSetting';
  checkDeliveryConfirmation: Scalars['Boolean'];
  checkInappropriateContent: Scalars['Boolean'];
  checkPackageVisibility: Scalars['Boolean'];
  checkPhotoClarity: Scalars['Boolean'];
  userPrompt?: Maybe<Scalars['String']>;
};

export type PhotoReviewSettingInput = {
  checkDeliveryConfirmation?: InputMaybe<Scalars['Boolean']>;
  checkInappropriateContent?: InputMaybe<Scalars['Boolean']>;
  checkPackageVisibility?: InputMaybe<Scalars['Boolean']>;
  checkPhotoClarity?: InputMaybe<Scalars['Boolean']>;
  userPrompt?: InputMaybe<Scalars['String']>;
};

export type PodIssue = {
  __typename?: 'PodIssue';
  description: Scalars['String'];
  suggestions: Array<Scalars['String']>;
  tag: Scalars['String'];
};

export enum PodRequirementAtStop {
  None = 'NONE',
  Photo = 'PHOTO',
  PhotoAndSignature = 'PHOTO_AND_SIGNATURE',
  PhotoOrSignature = 'PHOTO_OR_SIGNATURE',
  Signature = 'SIGNATURE'
}

export type PodResult = {
  __typename?: 'PodResult';
  issues: Array<PodIssue>;
  verdict: Scalars['String'];
};

export type Polygon = {
  __typename?: 'Polygon';
  points: Array<LngLat>;
};

export type PolygonInput = {
  points: Array<LngLatInput>;
};

export type PreviewEtaForRouteResult = {
  __typename?: 'PreviewEtaForRouteResult';
  stopEtas: Array<StopEta>;
};

export type PreviewOrderPricingModificationResult = {
  __typename?: 'PreviewOrderPricingModificationResult';
  total: Scalars['Money'];
};

export type PreviewPriceResult = {
  __typename?: 'PreviewPriceResult';
  breakdown: PricingBreakDown;
  orderPrice?: Maybe<OrderPrice>;
  pricingList?: Maybe<PricingList>;
  pricingListId?: Maybe<Scalars['ID']>;
  taxBreakDown?: Maybe<OrderPriceTaxBreakdown>;
  total: Scalars['Money'];
  totalAfterTax: Scalars['Money'];
};

export type PriceOverrideBreakdownItem = {
  __typename?: 'PriceOverrideBreakdownItem';
  amount: Scalars['Money'];
  description: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
};

export type PriceOverrideBreakdownItemInput = {
  amount: Scalars['Money'];
  description: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
};

/** Controls whether a pricing rule prices each segment independently or the whole order once. */
export enum PriceScope {
  /** The rule fires once for the whole order at totalOrderMiles; emits a single order-level trip price. */
  PerOrder = 'PER_ORDER',
  /** Default: each consecutive stop pair is priced independently. */
  PerSegment = 'PER_SEGMENT'
}

export type PricingAdjustment = {
  __typename?: 'PricingAdjustment';
  amount: Scalars['Money'];
  amountDriverPay?: Maybe<Scalars['Money']>;
  id: Scalars['ID'];
  isAmountOverride: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  surchargePricingRule?: Maybe<SurchargePricingRule>;
  surchargePricingRuleId?: Maybe<Scalars['ID']>;
  type?: Maybe<PricingAdjustmentType>;
};

export type PricingAdjustmentCreate = {
  amountDriverPay?: InputMaybe<Scalars['Money']>;
  amount_total?: InputMaybe<Scalars['Money']>;
  note?: InputMaybe<Scalars['String']>;
  surchargePricingRuleId?: InputMaybe<Scalars['ID']>;
  type: PricingAdjustmentType;
};

export enum PricingAdjustmentType {
  Custom = 'CUSTOM',
  RuleBased = 'RULE_BASED'
}

export type PricingAdjustmentUpdate = {
  amountTotal: Scalars['Money'];
  id: Scalars['ID'];
};

export enum PricingBoundaryType {
  CircleZone = 'CIRCLE_ZONE',
  City = 'CITY',
  Zip = 'ZIP',
  ZipGroup = 'ZIP_GROUP',
  ZoneId = 'ZONE_ID'
}

export type PricingBreakDown = {
  __typename?: 'PricingBreakDown';
  items: Array<PricingBreakDownItem>;
};

export type PricingBreakDownItem = {
  __typename?: 'PricingBreakDownItem';
  adjustmentId?: Maybe<Scalars['ID']>;
  amount: Scalars['Money'];
  description?: Maybe<Scalars['String']>;
  isAdjustmentOverride: Scalars['Boolean'];
  isBasePrice?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** The rule this line came from. Lets clients branch on amountType without another call. (CRI-112) */
  surchargePricingRule?: Maybe<SurchargePricingRule>;
  surchargePricingRuleId?: Maybe<Scalars['ID']>;
};

export type PricingIssue = {
  __typename?: 'PricingIssue';
  description: Scalars['String'];
  suggestedInformationUpdate?: Maybe<PricingReviewSuggestedInformationUpdate>;
  suggestedSurchargeAdd?: Maybe<PricingReviewSuggestedSurchargeAdd>;
  suggestions: Array<Scalars['String']>;
  tag: Scalars['String'];
};

export type PricingList = {
  __typename?: 'PricingList';
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  fallbackToBasePricingList: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PricingResult = {
  __typename?: 'PricingResult';
  issues: Array<PricingIssue>;
  verdict: Scalars['String'];
};

export type PricingReviewSetting = {
  __typename?: 'PricingReviewSetting';
  checkIncorrectInformation: Scalars['Boolean'];
  checkMissingSurcharges: Scalars['Boolean'];
  checkMissingWaitTimeSurcharge: Scalars['Boolean'];
  checkZeroMainPrice: Scalars['Boolean'];
  ignoreOverriddenPrices: Scalars['Boolean'];
  userPrompt?: Maybe<Scalars['String']>;
};

export type PricingReviewSettingInput = {
  checkIncorrectInformation?: InputMaybe<Scalars['Boolean']>;
  checkMissingSurcharges?: InputMaybe<Scalars['Boolean']>;
  checkMissingWaitTimeSurcharge?: InputMaybe<Scalars['Boolean']>;
  checkZeroMainPrice?: InputMaybe<Scalars['Boolean']>;
  ignoreOverriddenPrices?: InputMaybe<Scalars['Boolean']>;
  userPrompt?: InputMaybe<Scalars['String']>;
};

export type PricingReviewSuggestedInformationUpdate = {
  __typename?: 'PricingReviewSuggestedInformationUpdate';
  suggestedNumberOfPackages?: Maybe<Scalars['Int']>;
  suggestedPackageWeightInPounds?: Maybe<Scalars['Float']>;
  suggestedTotalWaitTimeInMinutes?: Maybe<Scalars['Float']>;
};

export type PricingReviewSuggestedSurchargeAdd = {
  __typename?: 'PricingReviewSuggestedSurchargeAdd';
  reason: Scalars['String'];
  suggestedAmount?: Maybe<Scalars['Float']>;
  suggestedNumberOfPackages?: Maybe<Scalars['Int']>;
  suggestedPackageWeightInPounds?: Maybe<Scalars['Float']>;
  suggestedTotalWaitTimeInMinutes?: Maybe<Scalars['Float']>;
  surchargeIdToAdd: Scalars['String'];
  surchargeRule: SurchargePricingRule;
};

export type PricingRule = {
  __typename?: 'PricingRule';
  advancedMultiplier?: Maybe<PricingRuleAdvancedMultiplier>;
  basePrice: Scalars['Money'];
  commissionableBaseFixed?: Maybe<Scalars['Money']>;
  commissionableBasePercent?: Maybe<Scalars['Money']>;
  courierId: Scalars['ID'];
  destination?: Maybe<Scalars['String']>;
  destinationDisplay: Scalars['String'];
  destinationType?: Maybe<PricingBoundaryType>;
  driverCommission?: Maybe<Scalars['Money']>;
  driverPayFixed?: Maybe<Scalars['Money']>;
  forReturnTripOnly: Scalars['Boolean'];
  freeMiles?: Maybe<Scalars['Float']>;
  holidaySchedulePricingAmounts?: Maybe<HolidaySchedulePricingAmountList>;
  id: Scalars['ID'];
  /** Also prices trips going from the destination to the origin. */
  isReciprocal: Scalars['Boolean'];
  maxMiles?: Maybe<Scalars['Float']>;
  maxTrips?: Maybe<Scalars['Int']>;
  maxWeight?: Maybe<Scalars['Float']>;
  maximumDriverPay?: Maybe<Scalars['Money']>;
  maximumPrice?: Maybe<Scalars['Money']>;
  minMiles?: Maybe<Scalars['Float']>;
  minTrips?: Maybe<Scalars['Int']>;
  minWeight?: Maybe<Scalars['Float']>;
  minimumPrice: Scalars['Money'];
  origin?: Maybe<Scalars['String']>;
  originDisplay: Scalars['String'];
  originType?: Maybe<PricingBoundaryType>;
  packageType?: Maybe<PackageType>;
  pricePerHour?: Maybe<Scalars['Money']>;
  pricePerLbs?: Maybe<Scalars['Money']>;
  pricePerMile: Scalars['Money'];
  pricingList?: Maybe<PricingList>;
  pricingListId?: Maybe<Scalars['ID']>;
  returnTripMultiplier?: Maybe<Scalars['Money']>;
  scope: PriceScope;
  serviceType?: Maybe<ServiceType>;
  serviceTypeId?: Maybe<Scalars['String']>;
  timeScheduleSpecificAmounts?: Maybe<TimeScheduleSpecificAmounts>;
  vehicleType?: Maybe<VehicleType>;
  vehicleTypeId?: Maybe<Scalars['ID']>;
  /**
   * Which weight this rule prices against. Set per rule on create/update;
   * `Courier.defaultWeightBasis` seeds the form default in the UI.
   */
  weightBasis: WeightBasis;
};

export type PricingRuleAdvancedMultiplier = {
  __typename?: 'PricingRuleAdvancedMultiplier';
  packageCountBasedMultipliers: Array<PackageCountBasedMultiplier>;
};

export type PricingRuleAdvancedMultiplierInput = {
  packageCountBasedMultipliers: Array<PackageCountBasedMultiplierInput>;
};

/** PricingRule Connection */
export type PricingRuleConnection = {
  __typename?: 'PricingRuleConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<PricingRuleEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type PricingRuleCreate = {
  basePrice?: InputMaybe<Scalars['Money']>;
  commissionableBaseFixed?: InputMaybe<Scalars['Money']>;
  commissionableBasePercent?: InputMaybe<Scalars['Money']>;
  courierId: Scalars['ID'];
  destinationCircleZoneId?: InputMaybe<Scalars['ID']>;
  destinationCity?: InputMaybe<CityStateCountryCreate>;
  destinationType?: InputMaybe<PricingBoundaryType>;
  destinationZip?: InputMaybe<Scalars['String']>;
  destinationZipGroupId?: InputMaybe<Scalars['ID']>;
  destinationZoneId?: InputMaybe<Scalars['ID']>;
  driverCommission?: InputMaybe<Scalars['Money']>;
  driverPayFixed?: InputMaybe<Scalars['Money']>;
  forReturnTripOnly?: InputMaybe<Scalars['Boolean']>;
  freeMiles?: InputMaybe<Scalars['Float']>;
  isReciprocal?: InputMaybe<Scalars['Boolean']>;
  maxMiles?: InputMaybe<Scalars['Float']>;
  maxTrips?: InputMaybe<Scalars['Int']>;
  maxWeight?: InputMaybe<Scalars['Float']>;
  maximumDriverPay?: InputMaybe<Scalars['Money']>;
  maximumPrice?: InputMaybe<Scalars['Money']>;
  minMiles?: InputMaybe<Scalars['Float']>;
  minTrips?: InputMaybe<Scalars['Int']>;
  minWeight?: InputMaybe<Scalars['Float']>;
  minimumPrice?: InputMaybe<Scalars['Money']>;
  originCircleZoneId?: InputMaybe<Scalars['ID']>;
  originCity?: InputMaybe<CityStateCountryCreate>;
  originType?: InputMaybe<PricingBoundaryType>;
  originZip?: InputMaybe<Scalars['String']>;
  originZipGroupId?: InputMaybe<Scalars['ID']>;
  originZoneId?: InputMaybe<Scalars['ID']>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  pricePerHour?: InputMaybe<Scalars['Money']>;
  pricePerLbs?: InputMaybe<Scalars['Money']>;
  pricePerMile?: InputMaybe<Scalars['Money']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  returnTripMultiplier?: InputMaybe<Scalars['Money']>;
  scope?: InputMaybe<PriceScope>;
  serviceTypeId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
  weightBasis?: InputMaybe<WeightBasis>;
};

/** PricingRule Edge */
export type PricingRuleEdge = {
  __typename?: 'PricingRuleEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<PricingRule>;
};

export type PricingRuleFullUpdate = {
  basePrice: Scalars['Money'];
  commissionableBaseFixed?: InputMaybe<Scalars['Money']>;
  commissionableBasePercent?: InputMaybe<Scalars['Money']>;
  driverCommission?: InputMaybe<Scalars['Money']>;
  driverPayFixed?: InputMaybe<Scalars['Money']>;
  forReturnTripOnly?: InputMaybe<Scalars['Boolean']>;
  freeMiles?: InputMaybe<Scalars['Float']>;
  /** Null keeps the rule's current value. */
  isReciprocal?: InputMaybe<Scalars['Boolean']>;
  maximumDriverPay?: InputMaybe<Scalars['Money']>;
  maximumPrice?: InputMaybe<Scalars['Money']>;
  minimumPrice: Scalars['Money'];
  pricePerHour?: InputMaybe<Scalars['Money']>;
  pricePerLbs?: InputMaybe<Scalars['Money']>;
  pricePerMile: Scalars['Money'];
  pricingRuleId: Scalars['ID'];
  returnTripMultiplier?: InputMaybe<Scalars['Money']>;
  scope?: InputMaybe<PriceScope>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
  weightBasis?: InputMaybe<WeightBasis>;
};

export type PricingRulesCsvFile = {
  __typename?: 'PricingRulesCsvFile';
  url: Scalars['String'];
};

export enum PricingRulesSortField {
  BasePrice = 'BASE_PRICE',
  CreatedAt = 'CREATED_AT',
  DestinationName = 'DESTINATION_NAME',
  MaxMiles = 'MAX_MILES',
  MaxTrips = 'MAX_TRIPS',
  MinimumPrice = 'MINIMUM_PRICE',
  MinMiles = 'MIN_MILES',
  MinTrips = 'MIN_TRIPS',
  OriginName = 'ORIGIN_NAME',
  PricePerMile = 'PRICE_PER_MILE',
  ServiceTypeName = 'SERVICE_TYPE_NAME'
}

export type PricingRulesSorting = {
  direction: SortingDirection;
  field: PricingRulesSortField;
};

export type PromptAction = {
  __typename?: 'PromptAction';
  action: PromptActionType;
  endCustomerId: Scalars['ID'];
  endUserId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  type: PromptType;
};

export enum PromptActionType {
  Accepted = 'ACCEPTED',
  Dismissed = 'DISMISSED'
}

export enum PromptType {
  InviteColleaguePrompt = 'INVITE_COLLEAGUE_PROMPT'
}

export type QualityReview = {
  __typename?: 'QualityReview';
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  items: Array<QualityReviewItem>;
  jobStatus: QualityReviewJobStatus;
  overallVerdict?: Maybe<QualityReviewVerdict>;
  /** # additional fields */
  price?: Maybe<OrderPrice>;
  shipmentId: Scalars['ID'];
};

export type QualityReviewAgentSetting = {
  __typename?: 'QualityReviewAgentSetting';
  closeGoodQualityOrdersAutomatically: Scalars['Boolean'];
  otherReview?: Maybe<OtherReviewSetting>;
  photoReview?: Maybe<PhotoReviewSetting>;
  pricingReview?: Maybe<PricingReviewSetting>;
};

export type QualityReviewAgentSettingInput = {
  closeGoodQualityOrdersAutomatically?: InputMaybe<Scalars['Boolean']>;
  otherReview?: InputMaybe<OtherReviewSettingInput>;
  photoReview?: InputMaybe<PhotoReviewSettingInput>;
  pricingReview?: InputMaybe<PricingReviewSettingInput>;
};

export enum QualityReviewAspect {
  Other = 'OTHER',
  PodPhoto = 'POD_PHOTO',
  Pricing = 'PRICING'
}

export type QualityReviewItem = {
  __typename?: 'QualityReviewItem';
  /** # additional fields can be added here as needed */
  artifact?: Maybe<Artifact>;
  createdAt?: Maybe<Scalars['Timestamp']>;
  entityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  issues?: Maybe<Array<Scalars['String']>>;
  qualityReviewId: Scalars['ID'];
  resultStructured?: Maybe<QualityReviewResultStructured>;
  reviewAspect: QualityReviewAspect;
  suggestions?: Maybe<Array<Scalars['String']>>;
  verdict?: Maybe<QualityReviewVerdict>;
};

export enum QualityReviewJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type QualityReviewResultStructured = {
  __typename?: 'QualityReviewResultStructured';
  otherResult?: Maybe<OtherQualityReviewResult>;
  podResult?: Maybe<PodResult>;
  pricingResult?: Maybe<PricingResult>;
};

export enum QualityReviewVerdict {
  Bad = 'BAD',
  Good = 'GOOD',
  Warning = 'WARNING'
}

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  activities: ActivitiesResult;
  addressBookEntries?: Maybe<AddressBookEntryConnection>;
  agents: Array<Agent>;
  allPermissions: Array<Scalars['String']>;
  analyticsDashboards: Array<AnalyticsDashboard>;
  availableCreditTotal: Scalars['Money'];
  availableCredits: CreditConnection;
  /**
   * Billable items for a courier.
   *
   * When endCustomerIdFilter is given, only items actively linked to that end customer
   * are returned -- the same set assignBillableItemToOrder accepts, so an assignment
   * picker can offer exactly the choices that will succeed.
   */
  billableItemsPaginated: BillableItemConnection;
  breadcrumb: DriverBreadcrumb;
  circleZones: Array<CircleZone>;
  costCenters: Array<CostCenter>;
  courier?: Maybe<Courier>;
  courierBrands: Array<CourierBrand>;
  courierByPath?: Maybe<Courier>;
  courierHolidays: Array<CourierHoliday>;
  /**
   * A courier's offline replay waiver policy. Resolves to all-VALIDATE when
   * the courier has no settings row (the strict default — no row is created).
   */
  courierOfflineSettings: CourierOfflineSettings;
  courierTerms: Array<CourierTerm>;
  couriers: Array<Courier>;
  /** Returns the courier's serviceable coverage areas. Empty list means no coverage enforcement. */
  coverageAreas: Array<CoverageArea>;
  credits: CreditConnection;
  /**
   * The courier's current EIA fuel rate — a plain data lookup with no opinion about
   * surcharges, so it also serves e.g. a courier fuel-rate dashboard. Fuel type is
   * resolved server-side from the vehicle type (same rule as pricing: no vehicleTypeId,
   * or one without a fuel type, falls back to GAS).
   *
   * Whether the rate is worth *showing* is the client's call: check
   * PricingBreakDownItem.surchargePricingRule.amountType for a DYNAMIC_FUEL_* rule and
   * skip this query when the price has none.
   *
   * Null only when the courier is unknown or no rate data covers today. (CRI-112)
   */
  currentEiaFuelRate?: Maybe<EiaFuelRate>;
  customDeductions: Array<DriverPayDeduction>;
  customFields: Array<CustomField>;
  customRoles: Array<CustomRole>;
  defaultPermissionsForRole: Array<Scalars['String']>;
  dispatchPreviews: Array<DispatchPreview>;
  dispatchPreviewsByDriverId: Array<DispatchPreview>;
  driverAnnouncements: Array<DriverAnnouncement>;
  driverAnswersByShipmentIds: Array<StopDriverAnswers>;
  driverById: Driver;
  driverComplianceCheck: Array<OrderDriverComplianceStatus>;
  driverCompliancePolicies: Array<DriverCompliancePolicy>;
  driverDefaultRoutingConfigurations: Array<DriverDefaultRoutingConfiguration>;
  driverDocuments: DriverDocumentConnection;
  /**
   *  Read-only, paginated list of driver pay entries filtered by status, with
   *  explicit per-boundary date filters on the entry's start/end dates. No
   *  generation. Used by the driver portal "Pay Statements" list.
   *  Overlap with [from, to] = maxStartDate: to, minEndDate: from.
   *  Fully contained in [from, to] = minStartDate: from, maxEndDate: to.
   */
  driverPayEntriesPaginated: DriverPayEntryConnection;
  driverQuestionLists: Array<DriverQuestionList>;
  driverQuestionsInList: Array<DriverQuestion>;
  driverReportItems: Array<DriverReportItem>;
  driverScheduleForDateRange: DriverSchedulesResult;
  driverTimeEvents: Array<DriverTimeEvent>;
  drivers?: Maybe<DriverConnection>;
  /**
   * The EIA rate context for an order's dynamic fuel surcharge lines, one entry per
   * fuel rule applied to the order. Empty when the order has no dynamic fuel lines
   * or no rate data covers the order's rate date. (CRI-112)
   */
  eiaFuelRateLines: Array<EiaFuelRateLine>;
  emailTemplateGroups: Array<EmailTemplateGroup>;
  emailTemplates: Array<EmailTemplate>;
  emailVariables: Array<EmailVariable>;
  emailsPaginated: EmailRecordConnection;
  endCustomers: EndCustomerConnection;
  endCustomersByLoginEmail: Array<EndCustomer>;
  endCustomersOverview: EndCustomersOverview;
  endUsers: Array<EndUser>;
  exceptionReasonEndCustomerOverridesPaginated: ExceptionReasonEndCustomerOverrideConnection;
  exceptionReasonsPaginated: ExceptionReasonConnection;
  feeTransfersPaginated: FeeTransferConnection;
  /**
   * The courier's saved fuel surcharge grids, or just the default grid when it has none
   * (see `FuelSurchargeGrid.isDefault`); empty when neither exists. A courier has at most
   * one grid today, but more are planned, so treat this as a list. Pricing does not use
   * saved grids yet; it switches to them in a later release. (CRI-9)
   */
  fuelSurchargeGrids: Array<FuelSurchargeGrid>;
  getInvoicePdfTemplateSkeleton: InvoicePdfTemplate;
  getNextDriverTimeEventPrompt?: Maybe<DriverTimeEventPrompt>;
  getSalesCommissionsByEndCustomers: Array<SalesCommission>;
  getVisibleColumns?: Maybe<VisibleColumnsConfig>;
  holidayScheduleBehaviors: Array<HolidayScheduleBehavior>;
  holidaySchedules: Array<HolidaySchedule>;
  invoiceBalances: Array<InvoiceBalance>;
  invoiceByDisplayId: Invoice;
  invoiceByOrderId?: Maybe<Invoice>;
  invoiceExtendedDetail: InvoiceExtendedDetail;
  invoiceManualPayments: InvoiceManualPaymentConnection;
  invoicePdfTemplatesPaginated: InvoicePdfTemplateConnection;
  invoicesOverview: InvoicesOverview;
  invoicesPaginated: InvoiceConnection;
  labels: Array<Label>;
  linkedAccounts: Array<LinkedAccount>;
  liveRoutesPaginated: LiveRouteConnection;
  locationScanCodesPaginated: LocationScanCodeConnection;
  memorizations: MemorizationResult;
  memorizedDays: Array<Scalars['Date']>;
  metabaseJwtToken: Scalars['String'];
  /**
   * Loads an order's full additional information key-value pairs on demand.
   *
   * Deliberately a separate query rather than a field on Order: additional_info holds
   * integration payloads that can be hundreds or thousands of entries, and the shipments
   * query response is already large. Loading the full array inline for every order would
   * bloat that payload, so it is fetched only when the user opens the Additional Information
   * modal for a single order. Order exposes the lightweight additionalInfoCount instead to
   * drive the UI affordance.
   */
  orderAdditionalInfo: Array<KeyValuePair>;
  orderAutomationRulesPaginated: OrderAutomationConnection;
  /**
   * The courier's builders that apply while an order is being booked, one per kind of
   * order (orderEntryAutoApply). Empty when none is set up. Web and portal show the Return
   * trip card when the list has an AUTO_APPLY_ON_ROUND_TRIP builder.
   */
  orderEntryAutoApplyOrderGroupBuilders: Array<OrderGroupBuilder>;
  /**
   * One order group and every order still in it, for the order group view.
   *
   * Null when the group does not exist, was deleted, or belongs to another courier.
   */
  orderGroup?: Maybe<OrderGroupDetail>;
  orderGroupBuildersPaginated: OrderGroupBuilderConnection;
  /**  Deprecated. Use orderPayBreakDownWithAllocations instead. */
  orderPayBreakDown?: Maybe<OrderPayBreakDown>;
  orderPayBreakDownWithAllocations: OrderPayBreakDownWithAllocationResult;
  /**
   *  Batched version of orderPayBreakDownWithAllocations (max 250 orderIds). Orders that do not
   *  exist or belong to another courier are left out of the result instead of failing the request.
   */
  orderPayBreakDownsWithAllocations: Array<OrderPayBreakDownWithAllocationEntry>;
  orderPrice: OrderPrice;
  packageEventTypes: Array<PackageEventType>;
  packageEventTypesByDriverId: Array<PackageEventTypeForDriver>;
  packageMovementsPaginated: PackageMovementConnection;
  /** Raw override rows for configure UI (includes DISABLED, custom names, and dimension/weight overrides). */
  packageTypeOverrides: Array<PackageTypeOverride>;
  packageTypes: Array<PackageType>;
  /**
   * The packages (and, through `events`, the scans) on one shipment, for the customer portal's
   * Scans section (CRI-191). Denied unless the shipment belongs to the courier and its order belongs
   * to one of `endCustomerIds`, trusted the same way `shipments(endCustomerIdsFilter:)` is.
   */
  packagesByShipmentId: Array<Package>;
  packagesPaginated?: Maybe<PackageConnection>;
  partners: Array<Partner>;
  payPeriods: Array<PayPeriod>;
  paymentAdditionalFeeRules: Array<PaymentAdditionalFeeRule>;
  paymentAuthorizationsPaginated: PaymentAuthorizationConnection;
  paymentInstruments: Array<PaymentInstrument>;
  paymentSettlementsPaginated: PaymentSettlementConnection;
  paymentTransfersPaginated: PaymentTransferConnection;
  payrollDeductionRules: Array<PayrollDeductionRule>;
  payrollDeductionRulesPaginated: PayrollDeductionRuleConnection;
  payrollSettings: PayrollSetting;
  previewEtaForRoute?: Maybe<PreviewEtaForRouteResult>;
  previewEtaForRoutingVehicle: Array<RoutingNodeEta>;
  previewRecurringOrderPrice: PreviewPriceResult;
  pricingLists: Array<PricingList>;
  pricingRules: Array<PricingRule>;
  pricingRulesPaginated: PricingRuleConnection;
  promptActions: Array<PromptAction>;
  qualityReviewsByShipmentIds: Array<QualityReview>;
  quickbookCustomer?: Maybe<QuickbookCustomer>;
  quickbookVendor?: Maybe<QuickbookVendor>;
  quotesPaginated: QuoteConnection;
  routeTemplatesPaginated: RouteTemplateConnection;
  routingJobById: RoutingJob;
  routingJobs: RoutingJobConnection;
  salesItemsPaginated?: Maybe<SalesItemConnection>;
  salesOverview: SalesOverview;
  salesTerms: Array<SalesTerm>;
  savedViews: Array<SavedView>;
  scheduledTransfersForShipment: Array<ScheduledTransfer>;
  searchCallerContacts: Array<CallerContact>;
  searchEndCustomer: Array<EndCustomer>;
  searchFromAddressBook: Array<AddressBookEntry>;
  serviceTypes: Array<ServiceType>;
  shipmentById: Shipment;
  shipmentByTrackingNumber?: Maybe<Shipment>;
  shipmentDistances: Array<ShipmentDistance>;
  shipmentTemplateById: ShipmentTemplate;
  shipmentTemplateDistances: Array<ShipmentTemplateDistance>;
  shipmentTemplatesPaginated?: Maybe<ShipmentTemplateConnection>;
  shipments?: Maybe<ShipmentConnection>;
  shipmentsOverview: ShipmentsOverview;
  shipmentsWithoutPagination: Array<Shipment>;
  surchargePricingRules: Array<SurchargePricingRule>;
  surchargePricingRulesPaginated: SurchargePricingRuleConnection;
  taskById: Task;
  tripDistanceOverridesPaginated: TripDistanceOverrideConnection;
  uniqueStopDates: Array<Scalars['Date']>;
  userStores: Array<UserStore>;
  users: CourieUserConnection;
  vehicleTypes: Array<VehicleType>;
  webhookSubscriptions: Array<WebhookSubscription>;
  zipGroups: Array<ZipGroup>;
  zones: Array<Zone>;
};


export type QueryActivitiesArgs = {
  courierId: Scalars['ID'];
  entityId: Scalars['ID'];
};


export type QueryAddressBookEntriesArgs = {
  after?: InputMaybe<Scalars['Int']>;
  companyNameSearch?: InputMaybe<Scalars['String']>;
  contactNameSearch?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  phoneSearch?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<AddressBookSorting>>;
  streetAddressSearch?: InputMaybe<Scalars['String']>;
};


export type QueryAgentsArgs = {
  courierId: Scalars['ID'];
};


export type QueryAnalyticsDashboardsArgs = {
  courierId: Scalars['ID'];
};


export type QueryAvailableCreditTotalArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type QueryAvailableCreditsArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryBillableItemsPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  endCustomerIdFilter?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryBreadcrumbArgs = {
  courierId: Scalars['ID'];
  date?: InputMaybe<Scalars['Date']>;
  driverId: Scalars['ID'];
  maxTime?: InputMaybe<Scalars['Timestamp']>;
  minTime?: InputMaybe<Scalars['Timestamp']>;
};


export type QueryCircleZonesArgs = {
  courierId: Scalars['ID'];
};


export type QueryCostCentersArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerIds: Array<Scalars['ID']>;
};


export type QueryCourierArgs = {
  courierId: Scalars['ID'];
};


export type QueryCourierBrandsArgs = {
  courierId: Scalars['ID'];
};


export type QueryCourierByPathArgs = {
  customerPortalPath: Scalars['String'];
};


export type QueryCourierHolidaysArgs = {
  courierId: Scalars['ID'];
};


export type QueryCourierOfflineSettingsArgs = {
  courierId: Scalars['ID'];
};


export type QueryCourierTermsArgs = {
  courierId: Scalars['ID'];
};


export type QueryCoverageAreasArgs = {
  courierId: Scalars['ID'];
};


export type QueryCreditsArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCurrentEiaFuelRateArgs = {
  courierId: Scalars['ID'];
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};


export type QueryCustomDeductionsArgs = {
  courierId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
};


export type QueryCustomFieldsArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  visibleToSelectedEndCustomerOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCustomRolesArgs = {
  courierId: Scalars['String'];
};


export type QueryDefaultPermissionsForRoleArgs = {
  role: UserRoleType;
};


export type QueryDispatchPreviewsArgs = {
  additionalFilters?: InputMaybe<DispatchAdditionalFilters>;
  courierId: Scalars['ID'];
  driverLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  shipmentId: Scalars['ID'];
  workType?: InputMaybe<DriverWorkType>;
};


export type QueryDispatchPreviewsByDriverIdArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  readyStatus: DispatchPreviewReadyStatus;
  targetDate: Scalars['Date'];
};


export type QueryDriverAnnouncementsArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  targetDate: Scalars['Date'];
};


export type QueryDriverAnswersByShipmentIdsArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type QueryDriverByIdArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
};


export type QueryDriverComplianceCheckArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type QueryDriverCompliancePoliciesArgs = {
  courierId: Scalars['ID'];
  entityIds: Array<Scalars['ID']>;
};


export type QueryDriverDefaultRoutingConfigurationsArgs = {
  courierId: Scalars['ID'];
  dates: Array<Scalars['Date']>;
  driverIds: Array<Scalars['ID']>;
};


export type QueryDriverDocumentsArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  documentTypes?: InputMaybe<Array<DocumentType>>;
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  expiresInDaysMax?: InputMaybe<Scalars['Int']>;
  expiresInDaysMin?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  sortFields?: InputMaybe<Array<DriverDocumentSorting>>;
};


export type QueryDriverPayEntriesPaginatedArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  maxEndDate?: InputMaybe<Scalars['Date']>;
  maxStartDate?: InputMaybe<Scalars['Date']>;
  minEndDate?: InputMaybe<Scalars['Date']>;
  minStartDate?: InputMaybe<Scalars['Date']>;
  offset?: InputMaybe<Scalars['Int']>;
  statusList: Array<DriverPayStatus>;
};


export type QueryDriverQuestionListsArgs = {
  courierId: Scalars['ID'];
};


export type QueryDriverQuestionsInListArgs = {
  courierId: Scalars['ID'];
  listId: Scalars['ID'];
};


export type QueryDriverReportItemsArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  driverWorkTypes?: InputMaybe<Array<DriverWorkType>>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryDriverScheduleForDateRangeArgs = {
  courierId: Scalars['ID'];
  driverLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endDate: Scalars['Date'];
  orderNameSearchTerm?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Date'];
};


export type QueryDriverTimeEventsArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryDriversArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
  isLateFilter?: InputMaybe<Scalars['Boolean']>;
  isLateSoonFilter?: InputMaybe<Scalars['Boolean']>;
  isLikelyLateFilter?: InputMaybe<Scalars['Boolean']>;
  labelIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<DriverSorting>>;
};


export type QueryEiaFuelRateLinesArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryEmailTemplateGroupsArgs = {
  courierId: Scalars['ID'];
};


export type QueryEmailTemplatesArgs = {
  courierId: Scalars['ID'];
  emailTemplateGroupId: Scalars['ID'];
};


export type QueryEmailVariablesArgs = {
  courierId: Scalars['ID'];
  emailTypeId: Scalars['String'];
  previewOrderId?: InputMaybe<Scalars['ID']>;
};


export type QueryEmailsPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  emailTypeIds?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<EmailDeliveryStatus>>;
  toEmail?: InputMaybe<Scalars['String']>;
};


export type QueryEndCustomersArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  labelIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<EndCustomerSorting>>;
};


export type QueryEndCustomersByLoginEmailArgs = {
  courierId: Scalars['ID'];
  email: Scalars['String'];
};


export type QueryEndCustomersOverviewArgs = {
  courierId: Scalars['ID'];
};


export type QueryEndUsersArgs = {
  courierId: Scalars['String'];
  endCustomerIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryExceptionReasonEndCustomerOverridesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  exceptionReasonId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryExceptionReasonsPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryFeeTransfersPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  settlementIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryFuelSurchargeGridsArgs = {
  courierId: Scalars['ID'];
};


export type QueryGetInvoicePdfTemplateSkeletonArgs = {
  courierId: Scalars['String'];
};


export type QueryGetNextDriverTimeEventPromptArgs = {
  date: Scalars['Date'];
  driverId: Scalars['ID'];
};


export type QueryGetSalesCommissionsByEndCustomersArgs = {
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']>;
};


export type QueryGetVisibleColumnsArgs = {
  courierId: Scalars['String'];
  userOrEmployeeId: Scalars['String'];
};


export type QueryHolidayScheduleBehaviorsArgs = {
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
};


export type QueryHolidaySchedulesArgs = {
  courierId: Scalars['ID'];
};


export type QueryInvoiceBalancesArgs = {
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']>;
};


export type QueryInvoiceByDisplayIdArgs = {
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryInvoiceByOrderIdArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryInvoiceExtendedDetailArgs = {
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type QueryInvoiceManualPaymentsArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryInvoicePdfTemplatesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryInvoicesOverviewArgs = {
  courierId: Scalars['String'];
};


export type QueryInvoicesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  costCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  courierId: Scalars['String'];
  displayIds?: InputMaybe<Array<Scalars['Int']>>;
  endCustomerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endCustomerLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  invoicingFrequency?: InputMaybe<Array<InputMaybe<InvoicingFrequency>>>;
  limit?: InputMaybe<Scalars['Int']>;
  maxApprovedAt?: InputMaybe<Scalars['Timestamp']>;
  maxEndDate?: InputMaybe<Scalars['Date']>;
  minApprovedAt?: InputMaybe<Scalars['Timestamp']>;
  minEndDate?: InputMaybe<Scalars['Date']>;
  paymentStatuses?: InputMaybe<Array<InputMaybe<InvoicePaymentStatus>>>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']>>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  sortFields?: InputMaybe<Array<InvoiceSorting>>;
  statuses?: InputMaybe<Array<InputMaybe<InvoiceStatus>>>;
  trackingNumbers?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryLabelsArgs = {
  courierId: Scalars['ID'];
  entityType?: InputMaybe<LabelEntityType>;
};


export type QueryLinkedAccountsArgs = {
  courierId: Scalars['ID'];
};


export type QueryLiveRoutesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
  orderLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<LiveRoutesSorting>>;
};


export type QueryLocationScanCodesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  requirementTypeFilter?: InputMaybe<LocationScanRequirement>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<LocationScanCodesSorting>>;
};


export type QueryMemorizationsArgs = {
  courierId: Scalars['ID'];
  dayOfWeeks?: InputMaybe<Array<DayOfTheWeek>>;
  days?: InputMaybe<Array<Scalars['Date']>>;
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryMemorizedDaysArgs = {
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  minDay?: InputMaybe<Scalars['Date']>;
  offset: Scalars['Int'];
};


export type QueryMetabaseJwtTokenArgs = {
  courierId: Scalars['ID'];
};


export type QueryOrderAdditionalInfoArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryOrderAutomationRulesPaginatedArgs = {
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderEntryAutoApplyOrderGroupBuildersArgs = {
  courierId: Scalars['ID'];
};


export type QueryOrderGroupArgs = {
  courierId: Scalars['ID'];
  orderGroupId: Scalars['ID'];
};


export type QueryOrderGroupBuildersPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderPayBreakDownArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryOrderPayBreakDownWithAllocationsArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryOrderPayBreakDownsWithAllocationsArgs = {
  courierId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type QueryOrderPriceArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
};


export type QueryPackageEventTypesArgs = {
  courierId: Scalars['ID'];
};


export type QueryPackageEventTypesByDriverIdArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
};


export type QueryPackageMovementsPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryPackageTypeOverridesArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type QueryPackageTypesArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
};


export type QueryPackagesByShipmentIdArgs = {
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']>;
  shipmentId: Scalars['ID'];
};


export type QueryPackagesPaginatedArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderDisplayIds?: InputMaybe<Array<Scalars['Int']>>;
  references?: InputMaybe<Array<Scalars['String']>>;
  shipmentIds?: InputMaybe<Array<Scalars['ID']>>;
  start?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<PackageStatus>>;
};


export type QueryPayPeriodsArgs = {
  courierId: Scalars['ID'];
  maxDate: Scalars['Date'];
  minDate: Scalars['Date'];
};


export type QueryPaymentAdditionalFeeRulesArgs = {
  courierId: Scalars['ID'];
};


export type QueryPaymentAuthorizationsPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  statusFilter?: InputMaybe<Array<PaymentAuthorizationStatus>>;
};


export type QueryPaymentInstrumentsArgs = {
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']>;
};


export type QueryPaymentSettlementsPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
};


export type QueryPaymentTransfersPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  invoiceIds?: InputMaybe<Array<Scalars['ID']>>;
  limit: Scalars['Int'];
  refundTypes?: InputMaybe<Array<PaymentTransferRefundType>>;
  settlementIds?: InputMaybe<Array<Scalars['ID']>>;
  statusFilter?: InputMaybe<Array<PaymentTransferStatus>>;
};


export type QueryPayrollDeductionRulesArgs = {
  courierId: Scalars['ID'];
};


export type QueryPayrollDeductionRulesPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  sortFields?: InputMaybe<Array<PayrollDeductionRuleSorting>>;
};


export type QueryPayrollSettingsArgs = {
  courierId: Scalars['ID'];
};


export type QueryPreviewEtaForRouteArgs = {
  baseTime?: InputMaybe<Scalars['Timestamp']>;
  driverId: Scalars['ID'];
  stopIds: Array<Scalars['ID']>;
};


export type QueryPreviewEtaForRoutingVehicleArgs = {
  courierId: Scalars['ID'];
  routingVehicleId: Scalars['ID'];
};


export type QueryPreviewRecurringOrderPriceArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
};


export type QueryPricingListsArgs = {
  courierId: Scalars['ID'];
};


export type QueryPricingRulesArgs = {
  courierId: Scalars['ID'];
  defaultOnly?: InputMaybe<Scalars['Boolean']>;
  locationBasedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPricingRulesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  defaultOnly?: InputMaybe<Scalars['Boolean']>;
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  destinationCircleZoneIdFilter?: InputMaybe<Scalars['ID']>;
  destinationCityFilter?: InputMaybe<CityStateCountryCreate>;
  destinationZipFilter?: InputMaybe<Scalars['String']>;
  destinationZipGroupIdFilter?: InputMaybe<Scalars['ID']>;
  destinationZoneIdFilter?: InputMaybe<Scalars['ID']>;
  distanceBasedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationBasedOnly?: InputMaybe<Scalars['Boolean']>;
  originCircleZoneIdFilter?: InputMaybe<Scalars['ID']>;
  originCityFilter?: InputMaybe<CityStateCountryCreate>;
  originZipFilter?: InputMaybe<Scalars['String']>;
  originZipGroupIdFilter?: InputMaybe<Scalars['ID']>;
  originZoneIdFilter?: InputMaybe<Scalars['ID']>;
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  serviceTypeIdsFilter?: InputMaybe<Array<Scalars['String']>>;
  sortFields?: InputMaybe<Array<PricingRulesSorting>>;
  tripBasedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPromptActionsArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  endUserId?: InputMaybe<Scalars['ID']>;
  promptType?: InputMaybe<PromptType>;
};


export type QueryQualityReviewsByShipmentIdsArgs = {
  shipmentIds: Array<Scalars['ID']>;
};


export type QueryQuickbookCustomerArgs = {
  courierId: Scalars['ID'];
  remoteId: Scalars['ID'];
};


export type QueryQuickbookVendorArgs = {
  courierId: Scalars['ID'];
  remoteId: Scalars['ID'];
};


export type QueryQuotesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  maxExpirationDate?: InputMaybe<Scalars['Date']>;
  minExpirationDate?: InputMaybe<Scalars['Date']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryRouteTemplatesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<RouteTemplatesSorting>>;
};


export type QueryRoutingJobByIdArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryRoutingJobsArgs = {
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};


export type QuerySalesItemsPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  maxDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
};


export type QuerySalesOverviewArgs = {
  courierId: Scalars['ID'];
  maxDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
};


export type QuerySalesTermsArgs = {
  courierId: Scalars['ID'];
};


export type QuerySavedViewsArgs = {
  courierId: Scalars['ID'];
  page: SavedViewPage;
  userOrEmployeeId: Scalars['ID'];
};


export type QueryScheduledTransfersForShipmentArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type QuerySearchCallerContactsArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  nameSearch?: InputMaybe<Scalars['String']>;
  phoneSearch?: InputMaybe<Scalars['String']>;
};


export type QuerySearchEndCustomerArgs = {
  courierId: Scalars['ID'];
  searchTerm: Scalars['String'];
};


export type QuerySearchFromAddressBookArgs = {
  companyNameSearch?: InputMaybe<Scalars['String']>;
  contactNameSearch?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerIdBias?: InputMaybe<Scalars['ID']>;
  googlePlaceIds?: InputMaybe<Array<Scalars['String']>>;
  phoneSearch?: InputMaybe<Scalars['String']>;
  streetAddressSearch?: InputMaybe<Scalars['String']>;
};


export type QueryServiceTypesArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  includeInternalOnly?: InputMaybe<Scalars['Boolean']>;
  showForEndCustomer?: InputMaybe<Scalars['Boolean']>;
};


export type QueryShipmentByIdArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type QueryShipmentByTrackingNumberArgs = {
  courierId: Scalars['ID'];
  trackingNumber: Scalars['String'];
};


export type QueryShipmentDistancesArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type QueryShipmentTemplateByIdArgs = {
  courierId: Scalars['ID'];
  shipmentTemplateId: Scalars['ID'];
};


export type QueryShipmentTemplateDistancesArgs = {
  courierId: Scalars['ID'];
  dayOfWeek: DayOfTheWeek;
  shipmentTemplateIds: Array<Scalars['ID']>;
};


export type QueryShipmentTemplatesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  driverLabelIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerLabelIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  orderLabelIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<ShipmentTemplatesSorting>>;
};


export type QueryShipmentsArgs = {
  acquisitionTypes?: InputMaybe<Array<OrderAcquisitionType>>;
  after?: InputMaybe<Scalars['Int']>;
  branchIds?: InputMaybe<Array<Scalars['ID']>>;
  courierBrandIds?: InputMaybe<Array<Scalars['ID']>>;
  courierId: Scalars['ID'];
  dateFilter?: InputMaybe<Scalars['Date']>;
  dispatchableTypes?: InputMaybe<Array<DispatchableType>>;
  displayIdsFilter?: InputMaybe<Array<Scalars['Int']>>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  driverVehicleTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  dropOffZoneIds?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeWordsFromNote?: InputMaybe<Array<Scalars['String']>>;
  hasDriverNoteOnly?: InputMaybe<Scalars['Boolean']>;
  hasMultipleDriverPayOnly?: InputMaybe<Scalars['Boolean']>;
  hasOrderInternalNote?: InputMaybe<Scalars['Boolean']>;
  hasUnapprovedDriverPackageReportOnly?: InputMaybe<Scalars['Boolean']>;
  hasWaitTimeOrOverride?: InputMaybe<Scalars['Boolean']>;
  holdStatusFilter?: InputMaybe<HoldStatus>;
  includeThirdPartyBilling?: InputMaybe<Scalars['Boolean']>;
  isAssignedFilter?: InputMaybe<Scalars['Boolean']>;
  isAttempted?: InputMaybe<Scalars['Boolean']>;
  isClosedFilter?: InputMaybe<Scalars['Boolean']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDeliveredOnTime?: InputMaybe<Scalars['Boolean']>;
  lateByFilter?: InputMaybe<Scalars['Timestamp']>;
  likelyLateOnlyFilter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxCompletedDate?: InputMaybe<Scalars['Date']>;
  maxExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  maxWeightInPounds?: InputMaybe<Scalars['Float']>;
  minClosingTimeFilter?: InputMaybe<Scalars['Timestamp']>;
  minCompletedDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  minShipmentDate?: InputMaybe<Scalars['Date']>;
  minWeightInPounds?: InputMaybe<Scalars['Float']>;
  orderLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  orderNameSearch?: InputMaybe<Scalars['String']>;
  orderVehicleTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  packageTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  pickupZoneIds?: InputMaybe<Array<Scalars['ID']>>;
  recurrenceTypes?: InputMaybe<Array<RecurrenceType>>;
  routeTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<ShipmentsSorting>>;
  statusFilter?: InputMaybe<ShipmentStatus>;
  statusListFilter?: InputMaybe<Array<ShipmentStatus>>;
  trackingNumbersFilter?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryShipmentsOverviewArgs = {
  acquisitionTypes?: InputMaybe<Array<OrderAcquisitionType>>;
  branchIds?: InputMaybe<Array<Scalars['ID']>>;
  courierBrandIds?: InputMaybe<Array<Scalars['ID']>>;
  courierId: Scalars['ID'];
  dateFilter?: InputMaybe<Scalars['Date']>;
  displayIdsFilter?: InputMaybe<Array<Scalars['Int']>>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  driverVehicleTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  dropOffZoneIds?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeWordsFromNote?: InputMaybe<Array<Scalars['String']>>;
  hasDriverNoteOnly?: InputMaybe<Scalars['Boolean']>;
  hasMultipleDriverPayOnly?: InputMaybe<Scalars['Boolean']>;
  hasOrderInternalNote?: InputMaybe<Scalars['Boolean']>;
  hasUnapprovedDriverPackageReportOnly?: InputMaybe<Scalars['Boolean']>;
  hasWaitTimeOrOverride?: InputMaybe<Scalars['Boolean']>;
  includeThirdPartyBilling?: InputMaybe<Scalars['Boolean']>;
  isAttempted?: InputMaybe<Scalars['Boolean']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDeliveredOnTime?: InputMaybe<Scalars['Boolean']>;
  maxCompletedDate?: InputMaybe<Scalars['Date']>;
  maxExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  maxWeightInPounds?: InputMaybe<Scalars['Float']>;
  minCompletedDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  minShipmentDate?: InputMaybe<Scalars['Date']>;
  minWeightInPounds?: InputMaybe<Scalars['Float']>;
  orderLabelIds?: InputMaybe<Array<Scalars['ID']>>;
  orderNameSearch?: InputMaybe<Scalars['String']>;
  orderVehicleTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  packageTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  pickupZoneIds?: InputMaybe<Array<Scalars['ID']>>;
  recurrenceTypes?: InputMaybe<Array<RecurrenceType>>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  trackingNumbersFilter?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryShipmentsWithoutPaginationArgs = {
  courierId: Scalars['ID'];
  invoiceId?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};


export type QuerySurchargePricingRulesArgs = {
  amountTypes?: InputMaybe<Array<SurchargeAmountType>>;
  applyType?: InputMaybe<SurchargeApplyType>;
  courierId: Scalars['ID'];
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  pricingListIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vehicleTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySurchargePricingRulesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  sortFields?: InputMaybe<Array<SurchargePricingRuleSorting>>;
};


export type QueryTaskByIdArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  taskId: Scalars['ID'];
};


export type QueryTripDistanceOverridesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryUniqueStopDatesArgs = {
  courierId: Scalars['ID'];
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  shipmentStatusFilter?: InputMaybe<Array<ShipmentStatus>>;
};


export type QueryUserStoresArgs = {
  courierId: Scalars['ID'];
  keysFilter?: InputMaybe<Array<Scalars['ID']>>;
  userOrEmployeeId: Scalars['ID'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryVehicleTypesArgs = {
  courierId: Scalars['ID'];
};


export type QueryWebhookSubscriptionsArgs = {
  courierId?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['String'];
};


export type QueryZipGroupsArgs = {
  courierId: Scalars['ID'];
};


export type QueryZonesArgs = {
  courierId: Scalars['ID'];
  type?: InputMaybe<ZoneType>;
};

export type QuickbookCustomer = {
  __typename?: 'QuickbookCustomer';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type QuickbookVendor = {
  __typename?: 'QuickbookVendor';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type Quote = {
  __typename?: 'Quote';
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  expirationDate: Scalars['Date'];
  id: Scalars['ID'];
  numPackages?: Maybe<Scalars['Int']>;
  order: Order;
  orderId: Scalars['ID'];
  packageDescription?: Maybe<Scalars['String']>;
  packageItems?: Maybe<Array<PackageItem>>;
  packageSize?: Maybe<PackageSize>;
  packageTypeId?: Maybe<Scalars['ID']>;
  packageWeightInPounds?: Maybe<Scalars['Float']>;
  quoteStops: Array<QuoteStop>;
  /** The date the customer asked for. Set on quotes that came in through the partner API. */
  requestedDate?: Maybe<Scalars['Date']>;
  vehicleTypeId?: Maybe<Scalars['ID']>;
};

/** Quote Connection */
export type QuoteConnection = {
  __typename?: 'QuoteConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<QuoteEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** Quote Edge */
export type QuoteEdge = {
  __typename?: 'QuoteEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<Quote>;
};

export type QuoteOrderPriceInput = {
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  priceOverride?: InputMaybe<Scalars['Money']>;
  priceOverrideBreakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput>>;
  pricingBreakDown: QuotePricingBreakDownInput;
  tripPrices: Array<QuoteTripPriceInput>;
};

export type QuotePricingBreakDownInput = {
  items: Array<QuotePricingBreakDownItemInput>;
};

export type QuotePricingBreakDownItemInput = {
  amount: Scalars['Money'];
  description?: InputMaybe<Scalars['String']>;
  isAdjustmentOverride: Scalars['Boolean'];
  isBasePrice?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  surchargePricingRuleId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<PricingAdjustmentType>;
};

export type QuoteResult = {
  __typename?: 'QuoteResult';
  order: Order;
};

export type QuoteShipmentFullUpdate = {
  id: Scalars['ID'];
  numPackages?: InputMaybe<Scalars['Int']>;
  packageDescription?: InputMaybe<Scalars['String']>;
  packageItems?: InputMaybe<Array<PackageItemInput>>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  shipmentDate: Scalars['Date'];
  stopIdsToDelete?: InputMaybe<Array<Scalars['ID']>>;
  stops: Array<QuoteStopFullUpdate>;
  stopsToCreate?: InputMaybe<Array<StopCreateInput>>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export type QuoteStop = {
  __typename?: 'QuoteStop';
  closeSecondsSinceMidnightUtc?: Maybe<Scalars['Int']>;
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  location: Location;
  locationId: Scalars['ID'];
  numDaysAfterShipmentDate?: Maybe<Scalars['Int']>;
  openSecondsSinceMidnightUtc?: Maybe<Scalars['Int']>;
  orderId: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  quoteShipmentId: Scalars['ID'];
  suite?: Maybe<Scalars['String']>;
  type: ShipmentStopType;
};

export type QuoteStopFullUpdate = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  stopDate?: InputMaybe<Scalars['Date']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowInput;
  type: ShipmentStopType;
};

export type QuoteTripPriceInput = {
  amount: Scalars['Money'];
  durationsInSeconds?: InputMaybe<Scalars['Int']>;
  miles: Scalars['Float'];
  packageWeightInLbs?: InputMaybe<Scalars['Float']>;
  pricingMultiplier?: InputMaybe<Scalars['Money']>;
  pricingRuleDisplay: Scalars['String'];
  readyTimeList?: InputMaybe<Array<Scalars['Timestamp']>>;
  selectedPricingRuleId?: InputMaybe<Scalars['ID']>;
  unfreeMiles?: InputMaybe<Scalars['Float']>;
};

export type RecordOrderClickInput = {
  clickedBy: Scalars['ID'];
  orderId: Scalars['ID'];
};

export type RecordPromptActionInput = {
  action: PromptActionType;
  endCustomerId: Scalars['ID'];
  endUserId?: InputMaybe<Scalars['ID']>;
  type: PromptType;
};

export type RecurrenceDetail = {
  __typename?: 'RecurrenceDetail';
  biweeklySchedule?: Maybe<BiWeeklySchedule>;
  endDate?: Maybe<Scalars['Date']>;
  endDateISO8601?: Maybe<Scalars['String']>;
  everyNWeeksSchedule?: Maybe<EveryNWeeksSchedule>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  scheduleType: RecurrenceScheduleType;
  startDate?: Maybe<Scalars['Date']>;
  startDateISO8601?: Maybe<Scalars['String']>;
  weeklySchedule?: Maybe<WeeklySchedule>;
};

export type RecurrenceDetailInput = {
  biweeklySchedule?: InputMaybe<BiWeeklyScheduleInput>;
  endDateISO8601?: InputMaybe<Scalars['String']>;
  everyNWeeksSchedule?: InputMaybe<EveryNWeeksScheduleInput>;
  monthlySchedule?: InputMaybe<MonthlyScheduleInput>;
  scheduleType: RecurrenceScheduleType;
  startDateISO8601?: InputMaybe<Scalars['String']>;
  /**  At most one of the following is present */
  weeklySchedule?: InputMaybe<WeeklyScheduleInput>;
};

export enum RecurrenceScheduleType {
  Biweekly = 'BIWEEKLY',
  CustomDaysOfTheMonth = 'CUSTOM_DAYS_OF_THE_MONTH',
  CustomDaysOfTheWeek = 'CUSTOM_DAYS_OF_THE_WEEK',
  Daily = 'DAILY',
  EveryNWeeks = 'EVERY_N_WEEKS',
  FollowRouteSchedule = 'FOLLOW_ROUTE_SCHEDULE',
  ManualOnly = 'MANUAL_ONLY',
  MonthlyOnFifthWeek = 'MONTHLY_ON_FIFTH_WEEK',
  MonthlyOnFirst = 'MONTHLY_ON_FIRST',
  MonthlyOnFourth = 'MONTHLY_ON_FOURTH',
  MonthlyOnLast = 'MONTHLY_ON_LAST',
  MonthlyOnSecond = 'MONTHLY_ON_SECOND',
  MonthlyOnThird = 'MONTHLY_ON_THIRD'
}

export enum RecurrenceType {
  OneOff = 'ONE_OFF',
  QuoteHolding = 'QUOTE_HOLDING',
  RecurringInstance = 'RECURRING_INSTANCE',
  RecurringTemplate = 'RECURRING_TEMPLATE'
}

export type RefreshDispatchPreviewsResult = {
  __typename?: 'RefreshDispatchPreviewsResult';
  numDispatchPreviews: Scalars['Int'];
};

export type RemoteEntity = {
  __typename?: 'RemoteEntity';
  courierId: Scalars['ID'];
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalId: Scalars['ID'];
  provider: ApiProvider;
  remoteId: Scalars['ID'];
  type: EntityType;
};

export type RemoteEntityLinkageUpsert = {
  courierId: Scalars['ID'];
  internalId: Scalars['ID'];
  provider: ApiProvider;
  remoteId: Scalars['ID'];
  type: EntityType;
};

export enum RoundingStrategy {
  Ceiling = 'CEILING',
  Floor = 'FLOOR',
  HalfUp = 'HALF_UP'
}

/**  Severity of a route status, mirrors ActivityInfoType used by activities. */
export enum RouteInfoType {
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export enum RouteOptimizationObjectiveType {
  Distance = 'DISTANCE',
  DistanceAndOnTime = 'DISTANCE_AND_ON_TIME',
  OnTime = 'ON_TIME'
}

export enum RouteOptimizationVehicleDistributionType {
  BalancedDistribution = 'BALANCED_DISTRIBUTION',
  BalancedDistributionByStopsCount = 'BALANCED_DISTRIBUTION_BY_STOPS_COUNT',
  None = 'NONE'
}

export type RouteOverview = {
  __typename?: 'RouteOverview';
  distanceTotalInMeters: Scalars['Float'];
  durationTotalInSeconds: Scalars['Float'];
};

export type RouteStatus = {
  __typename?: 'RouteStatus';
  title: Scalars['String'];
  type: RouteInfoType;
};

export type RouteTemplate = {
  __typename?: 'RouteTemplate';
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  enabledCommunicationTypes: Array<CommunicationTypeId>;
  id: Scalars['ID'];
  name: Scalars['String'];
  schedule?: Maybe<RouteTemplateScheduleList>;
  /** # extra fields */
  stopTemplatesInSequence: Array<StopTemplateWithSequence>;
};

/** RouteTemplate Connection */
export type RouteTemplateConnection = {
  __typename?: 'RouteTemplateConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<RouteTemplateEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** RouteTemplate Edge */
export type RouteTemplateEdge = {
  __typename?: 'RouteTemplateEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<RouteTemplate>;
};

export type RouteTemplateSchedule = {
  __typename?: 'RouteTemplateSchedule';
  detail: RecurrenceDetail;
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars['ID']>;
};

export type RouteTemplateScheduleInput = {
  detail: RecurrenceDetailInput;
  driverId?: InputMaybe<Scalars['ID']>;
};

export type RouteTemplateScheduleList = {
  __typename?: 'RouteTemplateScheduleList';
  schedules: Array<RouteTemplateSchedule>;
};

export type RouteTemplateScheduleListInput = {
  schedules: Array<RouteTemplateScheduleInput>;
};

export enum RouteTemplatesSortField {
  Name = 'NAME'
}

export type RouteTemplatesSorting = {
  direction: SortingDirection;
  field: RouteTemplatesSortField;
};

export type RoutingDayResult = {
  __typename?: 'RoutingDayResult';
  date: Scalars['Date'];
  jobId: Scalars['ID'];
  vehicles: Array<RoutingVehicle>;
};

export type RoutingJob = {
  __typename?: 'RoutingJob';
  cancelDescription?: Maybe<Scalars['String']>;
  canceledBy?: Maybe<Scalars['String']>;
  courierId: Scalars['ID'];
  dateCreated: Scalars['Date'];
  displayId: Scalars['Int'];
  driverIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
  objectiveType: RouteOptimizationObjectiveType;
  /**
   * # one result per each day
   * # null when pending state
   */
  results?: Maybe<Array<RoutingDayResult>>;
  shipmentIds: Array<Scalars['ID']>;
  status: RoutingJobStatus;
  vehicleDistributionType: RouteOptimizationVehicleDistributionType;
};

/** RoutingJob Connection */
export type RoutingJobConnection = {
  __typename?: 'RoutingJobConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<RoutingJobEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type RoutingJobCreate = {
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  /** # Ranges from 0 to 10 */
  earlyPenaltyLevel: Scalars['Int'];
  ignoreEarlinessOfFirstNode?: InputMaybe<Scalars['Boolean']>;
  /** # Ranges from 0 to 10 */
  latePenaltyLevel: Scalars['Int'];
  objectiveType?: InputMaybe<RouteOptimizationObjectiveType>;
  preserveExistingRouteOrder?: InputMaybe<Scalars['Boolean']>;
  respectReadyTimeAsDeparture?: InputMaybe<Scalars['Boolean']>;
  shipmentIds: Array<Scalars['ID']>;
  shipmentSelector?: InputMaybe<RoutingJobShipmentSelector>;
  vehicleDistributionType?: InputMaybe<RouteOptimizationVehicleDistributionType>;
  workflowType?: InputMaybe<RoutingWorkflowType>;
};

/** RoutingJob Edge */
export type RoutingJobEdge = {
  __typename?: 'RoutingJobEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<RoutingJob>;
};

export type RoutingJobShipmentSelector = {
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  type: RoutingJobShipmentSelectorType;
};

export enum RoutingJobShipmentSelectorType {
  Unassigned = 'UNASSIGNED'
}

export enum RoutingJobStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  OptimizationFailed = 'OPTIMIZATION_FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export type RoutingNode = {
  __typename?: 'RoutingNode';
  assignedRouteSequenceNumber?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isNewAssignment: Scalars['Boolean'];
  jobId: Scalars['ID'];
  stop?: Maybe<Stop>;
};

export type RoutingNodeEta = {
  __typename?: 'RoutingNodeEta';
  eta: Scalars['Timestamp'];
  isLikelyEarly: Scalars['Boolean'];
  isLikelyLate: Scalars['Boolean'];
  likelyEarlyByInMinutes?: Maybe<Scalars['Int']>;
  likelyLateByInMinutes?: Maybe<Scalars['Int']>;
  routingNodeId: Scalars['ID'];
};

export type RoutingVehicle = {
  __typename?: 'RoutingVehicle';
  driver: Driver;
  endLocation?: Maybe<Location>;
  endTime?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  nodes: Array<RoutingNode>;
  startLocation?: Maybe<Location>;
  startTime?: Maybe<Scalars['Timestamp']>;
  useDriverCurrentLocationAtStart: Scalars['Boolean'];
};

export type RoutingVehicleCreate = {
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  driverSpeed: Scalars['Float'];
  endLocationId?: InputMaybe<Scalars['ID']>;
  endTime?: InputMaybe<Scalars['Timestamp']>;
  startLocationId?: InputMaybe<Scalars['ID']>;
  startTime?: InputMaybe<Scalars['Timestamp']>;
  useCurrentLocationIdAtStart: Scalars['Boolean'];
};

export enum RoutingWorkflowType {
  HighVolume = 'HIGH_VOLUME',
  QuickDispatchWithMinimalOptimization = 'QUICK_DISPATCH_WITH_MINIMAL_OPTIMIZATION',
  SingleDriverSync = 'SINGLE_DRIVER_SYNC'
}

export type SalesCommission = {
  __typename?: 'SalesCommission';
  commissionPercentage: Scalars['Money'];
  endCustomerId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type SalesCommissionInput = {
  commissionPercentage: Scalars['Money'];
  userId: Scalars['ID'];
};

export type SalesItem = {
  __typename?: 'SalesItem';
  amount: Scalars['Money'];
  customerDisplay: Scalars['String'];
  customerDisplayId: Scalars['String'];
  destination: Scalars['String'];
  displayId: Scalars['ID'];
  driverName?: Maybe<Scalars['String']>;
  origin: Scalars['String'];
  pricingListDisplayName: Scalars['String'];
  shipmentDate: Scalars['Date'];
  trackingNumber: Scalars['String'];
};

/** SalesItem Connection */
export type SalesItemConnection = {
  __typename?: 'SalesItemConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<SalesItemEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** SalesItem Edge */
export type SalesItemEdge = {
  __typename?: 'SalesItemEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<SalesItem>;
};

export type SalesOverview = {
  __typename?: 'SalesOverview';
  amountForCompletedShipments: Scalars['Money'];
  amountTotal: Scalars['Money'];
  courierId: Scalars['ID'];
  maxDate?: Maybe<Scalars['Date']>;
  minDate?: Maybe<Scalars['Date']>;
  numShipmentsCompleted: Scalars['Int'];
  numShipmentsTotal: Scalars['Int'];
};

export enum SalesReportColumnId {
  BasePrice = 'BASE_PRICE',
  Brand = 'BRAND',
  CostCenters = 'COST_CENTERS',
  CustomerDisplayName = 'CUSTOMER_DISPLAY_NAME',
  CustomFields = 'CUSTOM_FIELDS',
  DeliverBy = 'DELIVER_BY',
  Destination = 'DESTINATION',
  DispatcherNote = 'DISPATCHER_NOTE',
  Distance = 'DISTANCE',
  DriverCompensation = 'DRIVER_COMPENSATION',
  DriverName = 'DRIVER_NAME',
  DriverNote = 'DRIVER_NOTE',
  EndCustomerReferenceNumber = 'END_CUSTOMER_REFERENCE_NUMBER',
  Instructions = 'INSTRUCTIONS',
  NonTaxableTotal = 'NON_TAXABLE_TOTAL',
  OnTimeStatus = 'ON_TIME_STATUS',
  OrderDisplayId = 'ORDER_DISPLAY_ID',
  OrderName = 'ORDER_NAME',
  Origin = 'ORIGIN',
  Package = 'PACKAGE',
  Pod = 'POD',
  ReadyTime = 'READY_TIME',
  ServiceType = 'SERVICE_TYPE',
  ShipmentDate = 'SHIPMENT_DATE',
  SignedBy = 'SIGNED_BY',
  Status = 'STATUS',
  Surcharges = 'SURCHARGES',
  TaxableTotal = 'TAXABLE_TOTAL',
  TotalPrice = 'TOTAL_PRICE',
  TrackingNumber = 'TRACKING_NUMBER',
  VehicleType = 'VEHICLE_TYPE',
  WaitTime = 'WAIT_TIME'
}

export type SalesReportFile = {
  __typename?: 'SalesReportFile';
  url: Scalars['String'];
};

export type SalesTerm = {
  __typename?: 'SalesTerm';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SavedView = {
  __typename?: 'SavedView';
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  filters: Array<SavedViewFilter>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  page: SavedViewPage;
  primaryFilter?: Maybe<Scalars['String']>;
  sortFields: Array<SavedViewSort>;
  userOrEmployeeId: Scalars['ID'];
};

export type SavedViewFilter = {
  __typename?: 'SavedViewFilter';
  key: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type SavedViewFilterInput = {
  key: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum SavedViewPage {
  Orders = 'ORDERS',
  Routes = 'ROUTES'
}

export type SavedViewSort = {
  __typename?: 'SavedViewSort';
  direction: SortingDirection;
  sortBy: Scalars['String'];
};

export type SavedViewSortInput = {
  direction: SortingDirection;
  sortBy: Scalars['String'];
};

export type ScanCreateValue = {
  scanType: ScanType;
  value: Scalars['String'];
};

export enum ScanRequirement {
  MustScanAllAssociatedPackages = 'MUST_SCAN_ALL_ASSOCIATED_PACKAGES',
  None = 'NONE',
  OptionalButMustMatchShippingLabel = 'OPTIONAL_BUT_MUST_MATCH_SHIPPING_LABEL',
  PickUpAndDropOff = 'PICK_UP_AND_DROP_OFF',
  PickUpAndDropOffMustMatchShippingLabel = 'PICK_UP_AND_DROP_OFF_MUST_MATCH_SHIPPING_LABEL'
}

export enum ScanType {
  BarCode = 'BAR_CODE',
  QrCode = 'QR_CODE'
}

export type ScheduledStopTemplateSequenceNumber = {
  __typename?: 'ScheduledStopTemplateSequenceNumber';
  courierId: Scalars['ID'];
  day?: Maybe<Scalars['Date']>;
  dayOfWeek?: Maybe<DayOfTheWeek>;
  id: Scalars['ID'];
  sequenceNumber?: Maybe<Scalars['Int']>;
  stopTemplate: StopTemplate;
  stopTemplateId: Scalars['ID'];
};

export type ScheduledStopTemplateSequenceNumberUpsert = {
  courierId: Scalars['ID'];
  day?: InputMaybe<Scalars['Date']>;
  dayOfWeek?: InputMaybe<DayOfTheWeek>;
  stopSequenceNumber?: InputMaybe<Scalars['Int']>;
  stopTemplateId: Scalars['ID'];
};

export type ScheduledTransfer = {
  __typename?: 'ScheduledTransfer';
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  createdBy?: Maybe<Scalars['ID']>;
  executedAt?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  shipmentId: Scalars['ID'];
  status: ScheduledTransferStatus;
  targetDriver?: Maybe<Driver>;
  targetDriverId: Scalars['ID'];
  triggerStop?: Maybe<Stop>;
  triggerStopId: Scalars['ID'];
};

export enum ScheduledTransferStatus {
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum SeparateInvoiceGenerationType {
  ByCostCenter = 'BY_COST_CENTER',
  ByEachOrder = 'BY_EACH_ORDER',
  ByReferenceNumber = 'BY_REFERENCE_NUMBER',
  None = 'NONE'
}

export type ServiceType = {
  __typename?: 'ServiceType';
  allowOrdersWith: Scalars['Boolean'];
  businessHoursSchedule?: Maybe<TimeSchedule>;
  color?: Maybe<Scalars['String']>;
  courierId: Scalars['ID'];
  customMessage?: Maybe<Scalars['String']>;
  defaultVehicleTypeId?: Maybe<Scalars['ID']>;
  deliveryRoutedDaysAfter: Scalars['Int'];
  deliveryTimeInMinutes?: Maybe<Scalars['Int']>;
  displayId: Scalars['Int'];
  dueTimeInBusinessDaysAfter?: Maybe<Scalars['Int']>;
  dueTimeInDaysAfter?: Maybe<Scalars['Int']>;
  dueTimeSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  dueTimeType: ServiceTypeDueTimeType;
  externalId?: Maybe<Scalars['String']>;
  extraSecondsPerMilePastLimit?: Maybe<Scalars['Float']>;
  freeWaitTimeInSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  milesLimit?: Maybe<Scalars['Float']>;
  multiplier?: Maybe<Scalars['Money']>;
  multiplierMode: ServiceTypeMultiplierMode;
  name: Scalars['String'];
  orderingSequenceNumber?: Maybe<Scalars['Int']>;
  pickupCloseTimeInBusinessDaysAfter?: Maybe<Scalars['Int']>;
  pickupCloseTimeInDaysAfter?: Maybe<Scalars['Int']>;
  pickupCloseTimeInMinutes?: Maybe<Scalars['Int']>;
  pickupCloseTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  pickupCloseType?: Maybe<ServiceTypeDueTimeType>;
  readyTimeSchedule?: Maybe<TimeSchedule>;
  visibilityType: ServiceTypeVisibilityType;
  visibleVehicleTypeIds?: Maybe<Array<Scalars['String']>>;
};


export type ServiceTypeAllowOrdersWithArgs = {
  readyTime?: InputMaybe<Scalars['Timestamp']>;
};

export enum ServiceTypeDueTimeType {
  Fixed = 'FIXED',
  RelativeToPickup = 'RELATIVE_TO_PICKUP'
}

export type ServiceTypeFullUpdate = {
  color?: InputMaybe<Scalars['String']>;
  customMessage?: InputMaybe<Scalars['String']>;
  deliveryRoutedDaysAfter?: InputMaybe<Scalars['Int']>;
  deliveryTimeInMinutes?: InputMaybe<Scalars['Int']>;
  dueTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  dueTimeInDaysAfter?: InputMaybe<Scalars['Int']>;
  dueTimeSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  dueTimeType?: InputMaybe<ServiceTypeDueTimeType>;
  extraSecondsPerMilePastLimit?: InputMaybe<Scalars['Float']>;
  freeWaitTimeInSeconds?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  milesLimit?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  orderingSequenceNumber?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInDaysAfter?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInMinutes?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  pickupCloseType?: InputMaybe<ServiceTypeDueTimeType>;
  visibilityType?: InputMaybe<ServiceTypeVisibilityType>;
  visibleVehicleTypeIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum ServiceTypeMultiplierMode {
  Multiply = 'MULTIPLY',
  OverrideCustomerMultiplier = 'OVERRIDE_CUSTOMER_MULTIPLIER'
}

export enum ServiceTypeVisibilityType {
  ConfiguredForCustomer = 'CONFIGURED_FOR_CUSTOMER',
  InternalOnly = 'INTERNAL_ONLY',
  Public = 'PUBLIC'
}

export enum SettlementStatus {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Pending = 'PENDING'
}

export type Shipment = {
  __typename?: 'Shipment';
  /**
   *  Distinct dates the dispatch panel must optimize for: the shipment's own pending stops, plus its
   *  assignment-group siblings' when it is in one. Never includes billing-only orders.
   */
  allStopDatesForGroupDispatch: Array<Scalars['Date']>;
  artifacts: Array<Artifact>;
  assignedAt?: Maybe<Scalars['Timestamp']>;
  branchId?: Maybe<Scalars['ID']>;
  closedAt?: Maybe<Scalars['Timestamp']>;
  completedDate?: Maybe<Scalars['Date']>;
  completedDateOverriddenBy?: Maybe<Scalars['ID']>;
  completionReason?: Maybe<ShipmentCompletionReason>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  deliveredAtOverride?: Maybe<Scalars['Timestamp']>;
  /**
   * Total dimensional weight of all `packageItems` (sum of `(L*W*H)/courier.dimFactor` per piece).
   * Null when the courier has no `dimFactor` configured, when there are no pieces, or when no
   * piece has all three dimensions populated. Display-only — pricing reads this via
   * `DimWeightCalculator` directly, not through GraphQL.
   */
  dimWeightInLbs?: Maybe<Scalars['Float']>;
  /**
   * # At the moment, this is only relevant for Quick Delivery to prevent dispatch for orders sent to Alternative
   * # Courier for a period of time, to give Alternative Courier first dibs.
   */
  dispatchDelaySecs?: Maybe<Scalars['Int']>;
  dispatchedByUser?: Maybe<CourieUser>;
  /** # User friendly display statuses for packages */
  displayPackageStatuses?: Maybe<Array<Scalars['String']>>;
  distancesInMeters: Scalars['Float'];
  driver?: Maybe<Driver>;
  driverConfirmedAt?: Maybe<Scalars['Timestamp']>;
  driverId?: Maybe<Scalars['ID']>;
  driverPayAllocations: Array<DriverPayAllocation>;
  driverReportedWaitTimeInMinutes?: Maybe<Scalars['Float']>;
  firstEffectiveStopDate: Scalars['Date'];
  hasCompletedDateOverride: Scalars['Boolean'];
  holdStatus?: Maybe<HoldStatus>;
  id: Scalars['ID'];
  internalNote?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['Date']>;
  isClosed: Scalars['Boolean'];
  isForceCompleted: Scalars['Boolean'];
  numPackages?: Maybe<Scalars['Int']>;
  order: Order;
  packageDescription?: Maybe<Scalars['String']>;
  packageItems?: Maybe<Array<PackageItem>>;
  packageSize?: Maybe<PackageSize>;
  packageType?: Maybe<PackageType>;
  /**
   * Every package type this shipment and its `packageItems` use, named as the order's end customer
   * sees them (their custom name, else the courier's). Unlike `packageType`, includes deleted types.
   */
  packageTypes: Array<ShipmentPackageTypeDisplay>;
  packageWeightInPounds?: Maybe<Scalars['Float']>;
  proposedNumPackages?: Maybe<Scalars['Int']>;
  proposedPackageWeightInPounds?: Maybe<Scalars['Float']>;
  /** # Quality Reviews associated with this shipment */
  qualityReviews?: Maybe<Array<QualityReview>>;
  routingJob?: Maybe<RoutingJob>;
  routingJobId?: Maybe<Scalars['ID']>;
  shipmentDate: Scalars['Date'];
  shipmentTemplate?: Maybe<ShipmentTemplate>;
  signedByOverride?: Maybe<Scalars['String']>;
  status: ShipmentStatus;
  stops: Array<Stop>;
  trackingNumber: Scalars['String'];
  type: ShipmentType;
  /** # additional fields */
  vehicleType?: Maybe<VehicleType>;
  waitTimeInMinutes?: Maybe<Scalars['Float']>;
  waitTimeUnfreeMinutesOverride?: Maybe<Scalars['Float']>;
};

export type ShipmentArrivalOverrideInput = {
  arrivalOverrides: Array<TaskArrivalInput>;
  shipmentId: Scalars['ID'];
  waitTimeUnfreeMinutesOverride?: InputMaybe<Scalars['Float']>;
};

export enum ShipmentCompletionReason {
  Attempted = 'ATTEMPTED',
  Completed = 'COMPLETED',
  PartialCompleted = 'PARTIAL_COMPLETED'
}

/** Shipment Connection */
export type ShipmentConnection = {
  __typename?: 'ShipmentConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<ShipmentEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type ShipmentCreateInput = {
  numPackages?: InputMaybe<Scalars['Int']>;
  packageDescription?: InputMaybe<Scalars['String']>;
  packageItems?: InputMaybe<Array<PackageItemInput>>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  shipmentDate: Scalars['Date'];
  stops: Array<StopCreateInput>;
  transportationTypeRequirement?: InputMaybe<TransportationType>;
  type?: InputMaybe<ShipmentType>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export type ShipmentDistance = {
  __typename?: 'ShipmentDistance';
  distanceMeters: Scalars['Float'];
  shipmentId: Scalars['ID'];
  stopTripDistances: Array<StopTripDistance>;
};

/** Shipment Edge */
export type ShipmentEdge = {
  __typename?: 'ShipmentEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<Shipment>;
};

export type ShipmentFullUpdate = {
  id: Scalars['ID'];
  numPackages?: InputMaybe<Scalars['Int']>;
  packageDescription?: InputMaybe<Scalars['String']>;
  packageItems?: InputMaybe<Array<PackageItemInput>>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  shipmentDate: Scalars['Date'];
  stopIdsToDelete?: InputMaybe<Array<Scalars['ID']>>;
  stops: Array<StopFullUpdate>;
  stopsToCreate?: InputMaybe<Array<StopCreateInput>>;
  type?: InputMaybe<ShipmentType>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export type ShipmentPackageTypeDisplay = {
  __typename?: 'ShipmentPackageTypeDisplay';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum ShipmentStatus {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
  Paused = 'PAUSED',
  Routed = 'ROUTED'
}

export enum ShipmentStopType {
  DropOff = 'DROP_OFF',
  PickUp = 'PICK_UP',
  Return = 'RETURN'
}

export type ShipmentTemplate = {
  __typename?: 'ShipmentTemplate';
  courierId: Scalars['ID'];
  driver?: Maybe<Driver>;
  driverAssignments: Array<ShipmentTemplateDriverAssignment>;
  id: Scalars['ID'];
  numPackages?: Maybe<Scalars['Int']>;
  order: Order;
  orderId: Scalars['ID'];
  packageDescription?: Maybe<Scalars['String']>;
  packageSize?: Maybe<PackageSize>;
  packageType?: Maybe<PackageType>;
  packageTypeId?: Maybe<Scalars['ID']>;
  packageWeightInPounds?: Maybe<Scalars['Float']>;
  stopTemplates: Array<StopTemplate>;
  type: ShipmentType;
  vehicleType?: Maybe<VehicleType>;
  vehicleTypeId?: Maybe<Scalars['ID']>;
};

/** ShipmentTemplate Connection */
export type ShipmentTemplateConnection = {
  __typename?: 'ShipmentTemplateConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<ShipmentTemplateEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type ShipmentTemplateCreateInput = {
  driverId?: InputMaybe<Scalars['ID']>;
  numPackages?: InputMaybe<Scalars['Int']>;
  packageDescription?: InputMaybe<Scalars['String']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  stopTemplates: Array<StopTemplateCreateInput>;
  transportationTypeRequirement?: InputMaybe<TransportationType>;
  type?: InputMaybe<ShipmentType>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export type ShipmentTemplateDistance = {
  __typename?: 'ShipmentTemplateDistance';
  distanceMeters: Scalars['Float'];
  shipmentTemplateId: Scalars['ID'];
  stopTemplateTripDistances: Array<StopTemplateTripDistance>;
};

export type ShipmentTemplateDriverAssignment = {
  __typename?: 'ShipmentTemplateDriverAssignment';
  dayOfWeek: DayOfTheWeek;
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  shipmentTemplateId: Scalars['ID'];
};

export type ShipmentTemplateDriverAssignmentUpsertInput = {
  dayOfWeek: DayOfTheWeek;
  driverId?: InputMaybe<Scalars['ID']>;
  shipmentTemplateId: Scalars['ID'];
};

/** ShipmentTemplate Edge */
export type ShipmentTemplateEdge = {
  __typename?: 'ShipmentTemplateEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<ShipmentTemplate>;
};

export type ShipmentTemplateFullUpdate = {
  driverId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  numPackages?: InputMaybe<Scalars['Int']>;
  packageDescription?: InputMaybe<Scalars['String']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  stopTemplateFullUpdates: Array<StopTemplateFullUpdate>;
  stopTemplateIdsToDelete?: InputMaybe<Array<Scalars['ID']>>;
  stopTemplatesToCreate?: InputMaybe<Array<StopTemplateCreateInput>>;
  type?: InputMaybe<ShipmentType>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export enum ShipmentTemplatesSortField {
  CreatedTime = 'CREATED_TIME',
  DestinationCity = 'DESTINATION_CITY',
  DestinationStreetAddress = 'DESTINATION_STREET_ADDRESS',
  DriverName = 'DRIVER_NAME',
  DropOffCompanyName = 'DROP_OFF_COMPANY_NAME',
  DropOffDueTime = 'DROP_OFF_DUE_TIME',
  DropOffReadyTime = 'DROP_OFF_READY_TIME',
  EndCustomerName = 'END_CUSTOMER_NAME',
  OrderDisplayId = 'ORDER_DISPLAY_ID',
  OriginCity = 'ORIGIN_CITY',
  OriginStreetAddress = 'ORIGIN_STREET_ADDRESS',
  PickUpCompanyName = 'PICK_UP_COMPANY_NAME',
  PickUpDueTime = 'PICK_UP_DUE_TIME',
  PickUpReadyTime = 'PICK_UP_READY_TIME'
}

export type ShipmentTemplatesSorting = {
  direction: SortingDirection;
  field: ShipmentTemplatesSortField;
};

export enum ShipmentType {
  MultiDropOff = 'MULTI_DROP_OFF',
  MultiDropOffRoundTrip = 'MULTI_DROP_OFF_ROUND_TRIP',
  MultiPickUp = 'MULTI_PICK_UP',
  RoundTrip = 'ROUND_TRIP',
  Simple = 'SIMPLE',
  SingleStop = 'SINGLE_STOP'
}

export type ShipmentsCustomFilter = {
  __typename?: 'ShipmentsCustomFilter';
  driverIds?: Maybe<Array<Scalars['ID']>>;
  endCustomerIds?: Maybe<Array<Scalars['ID']>>;
  excludeWordsFromNote?: Maybe<Array<Scalars['String']>>;
  isAttempted?: Maybe<Scalars['Boolean']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recurrenceTypes?: Maybe<Array<RecurrenceType>>;
  serviceTypeIds?: Maybe<Array<Scalars['ID']>>;
  shipmentStatuses?: Maybe<Array<ShipmentStatus>>;
};

export type ShipmentsCustomFilterInput = {
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeWordsFromNote?: InputMaybe<Array<Scalars['String']>>;
  isAttempted?: InputMaybe<Scalars['Boolean']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recurrenceTypes?: InputMaybe<Array<RecurrenceType>>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  shipmentStatuses?: InputMaybe<Array<ShipmentStatus>>;
};

export type ShipmentsCustomFilters = {
  __typename?: 'ShipmentsCustomFilters';
  filters: Array<ShipmentsCustomFilter>;
};

export type ShipmentsOverview = {
  __typename?: 'ShipmentsOverview';
  customFilterOverviews: Array<CustomFilterOverview>;
  numActive?: Maybe<Scalars['Int']>;
  numAssigned?: Maybe<Scalars['Int']>;
  numClosed?: Maybe<Scalars['Int']>;
  numDelivered?: Maybe<Scalars['Int']>;
  numLateBy?: Maybe<Scalars['Int']>;
  numLikelyLate?: Maybe<Scalars['Int']>;
  numOnHold?: Maybe<Scalars['Int']>;
  numUnassigned?: Maybe<Scalars['Int']>;
};


export type ShipmentsOverviewNumLateByArgs = {
  lateBy: Scalars['Timestamp'];
  minClosingTime?: InputMaybe<Scalars['Timestamp']>;
};


export type ShipmentsOverviewNumLikelyLateArgs = {
  minClosingTime?: InputMaybe<Scalars['Timestamp']>;
};

export enum ShipmentsSortField {
  BasePrice = 'BASE_PRICE',
  CreatedTime = 'CREATED_TIME',
  DestinationCity = 'DESTINATION_CITY',
  DestinationDispatchZone = 'DESTINATION_DISPATCH_ZONE',
  DestinationStreetAddress = 'DESTINATION_STREET_ADDRESS',
  DestinationZip = 'DESTINATION_ZIP',
  DriverName = 'DRIVER_NAME',
  DropOffCompanyName = 'DROP_OFF_COMPANY_NAME',
  DropOffDueTime = 'DROP_OFF_DUE_TIME',
  DropOffReadyTime = 'DROP_OFF_READY_TIME',
  EndCustomerName = 'END_CUSTOMER_NAME',
  IsCompleted = 'IS_COMPLETED',
  OrderDisplayId = 'ORDER_DISPLAY_ID',
  OrderName = 'ORDER_NAME',
  OriginCity = 'ORIGIN_CITY',
  OriginDispatchZone = 'ORIGIN_DISPATCH_ZONE',
  OriginStreetAddress = 'ORIGIN_STREET_ADDRESS',
  OriginZip = 'ORIGIN_ZIP',
  PickUpCompanyName = 'PICK_UP_COMPANY_NAME',
  PickUpDueTime = 'PICK_UP_DUE_TIME',
  PickUpReadyTime = 'PICK_UP_READY_TIME',
  ServiceTypeName = 'SERVICE_TYPE_NAME',
  ShipmentId = 'SHIPMENT_ID',
  Status = 'STATUS',
  TotalPrice = 'TOTAL_PRICE',
  VehicleTypeName = 'VEHICLE_TYPE_NAME'
}

export type ShipmentsSorting = {
  direction: SortingDirection;
  field: ShipmentsSortField;
};

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StationaryStop = {
  __typename?: 'StationaryStop';
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  suite?: Maybe<Scalars['String']>;
};

export type StationaryStopInput = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
};

export type Stop = {
  __typename?: 'Stop';
  additionalDriverQuestionListId?: Maybe<Scalars['ID']>;
  artifacts: Array<Artifact>;
  assignedLabels: Array<Label>;
  attempts: Array<StopAttempt>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Timestamp']>;
  completionReason?: Maybe<StopCompletionReason>;
  contactName?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  dispatchZone?: Maybe<Scalars['String']>;
  dispatchZoneLine2?: Maybe<Scalars['String']>;
  driverNote?: Maybe<Scalars['String']>;
  effectiveStopDate: Scalars['Date'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  lngLat: LngLat;
  locationId: Scalars['String'];
  /**
   * Every location scan code accepted at this stop, as the scan path and task completion resolve
   * them: the courier's live codes within 10 m of the stop's location, scoped to the order's end
   * customer and to the stop's suite (codes for that suite and codes with no suite), oldest
   * first. Completion demands the REQUIRED code whose suite matches the stop's suite, else the
   * first REQUIRED code with no suite. Empty when none apply.
   */
  locationScanCodes: Array<LocationScanCode>;
  /**
   * Whether this stop's coordinate really points at its address. FAKE_COORDINATE means the
   * address could not be found and the stop sits at a 0,0 placeholder until someone fixes it.
   */
  locationValidityType: LocationValidityType;
  orderEntrySequenceNumber?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  plannedSequenceNumber?: Maybe<Scalars['Int']>;
  shipment: Shipment;
  shipmentId: Scalars['ID'];
  state: Scalars['String'];
  /**
   * Per-shipment consistent sorting key for displaying stops: stopSequenceNumber when every stop
   * of the shipment has one, else orderEntrySequenceNumber when every stop has one, else null.
   * The two numbering spaces are never mixed within one shipment.
   */
  stopConsolidatedSortingNumber?: Maybe<Scalars['Int']>;
  stopDate?: Maybe<Scalars['Date']>;
  stopSequenceNumber?: Maybe<Scalars['Int']>;
  streetAddress: Scalars['String'];
  suite?: Maybe<Scalars['String']>;
  tasks: Array<Task>;
  timeStatus?: Maybe<StopTimeStatus>;
  timeWindow: TimeWindow;
  type: ShipmentStopType;
  wasLateByInMinutes?: Maybe<Scalars['Int']>;
  zipCode: Scalars['String'];
};

/**
 * A recorded delivery attempt at a stop. `reason` is null when the exception reason has
 * since been deleted; `finalState` is null while re-attempts remain.
 */
export type StopAttempt = {
  __typename?: 'StopAttempt';
  date: Scalars['Date'];
  finalState?: Maybe<ExceptionReasonFinalState>;
  reason?: Maybe<ExceptionReason>;
};

export type StopCompletedTimeOverride = {
  completedAt: Scalars['Timestamp'];
  stopId: Scalars['ID'];
};

export enum StopCompletionGuard {
  AllowBeforeReadyTime = 'ALLOW_BEFORE_READY_TIME',
  BlockBeforeReadyTime = 'BLOCK_BEFORE_READY_TIME'
}

export enum StopCompletionReason {
  Attempted = 'ATTEMPTED',
  Completed = 'COMPLETED'
}

export type StopCreateInput = {
  additionalDriverQuestionListId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  orderEntrySequenceNumber?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stopDate?: InputMaybe<Scalars['Date']>;
  stopTemplateId?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowInput;
  type: ShipmentStopType;
};

export type StopDriverAnswers = {
  __typename?: 'StopDriverAnswers';
  answers: Array<DriverAnswer>;
  stop: Stop;
};

export type StopEta = {
  __typename?: 'StopEta';
  eta: Scalars['Timestamp'];
  isLikelyLate: Scalars['Boolean'];
  likelyLateByInMinutes?: Maybe<Scalars['Float']>;
  stopId: Scalars['ID'];
};

export enum StopEtaCoercionType {
  CoerceAtLeastReadyTime = 'COERCE_AT_LEAST_READY_TIME',
  None = 'NONE'
}

export type StopFullUpdate = {
  additionalDriverQuestionListId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  orderEntrySequenceNumber?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  stopDate?: InputMaybe<Scalars['Date']>;
  stopSequenceNumber?: InputMaybe<Scalars['Int']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowInput;
  type: ShipmentStopType;
};

export type StopTemplate = {
  __typename?: 'StopTemplate';
  assignedLabels: Array<Label>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  dispatchZone?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  lngLat: LngLat;
  numDaysAfterShipmentDate?: Maybe<Scalars['Int']>;
  packageMovements: Array<PackageMovement>;
  phone?: Maybe<Scalars['String']>;
  sequenceNumberInsideShipment?: Maybe<Scalars['Int']>;
  shipmentTemplate: ShipmentTemplate;
  shipmentTemplateId: Scalars['ID'];
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  suite?: Maybe<Scalars['String']>;
  timeWindow: TimeWindowTimeOfDay;
  timeZoneId?: Maybe<Scalars['String']>;
  type: ShipmentStopType;
  zipCode: Scalars['String'];
};

export type StopTemplateCreateInput = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  googlePlaceId: Scalars['String'];
  instruction?: InputMaybe<Scalars['String']>;
  numDaysAfterShipmentDate?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowTemplateInput;
  timeZoneId?: InputMaybe<Scalars['String']>;
  type: ShipmentStopType;
};

export type StopTemplateFullUpdate = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  googlePlaceId: Scalars['String'];
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  numDaysAfterShipmentDate?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowTemplateInput;
  timeZoneId?: InputMaybe<Scalars['String']>;
  type: ShipmentStopType;
};

export type StopTemplateTripDistance = {
  __typename?: 'StopTemplateTripDistance';
  destinationStopTemplate: StopTemplate;
  destinationStopTemplateId: Scalars['ID'];
  sourceStopTemplate: StopTemplate;
  sourceStopTemplateId: Scalars['ID'];
  tripDistance: TripDistance;
};

export type StopTemplateWithSequence = {
  __typename?: 'StopTemplateWithSequence';
  sequenceNumber: Scalars['Int'];
  /** # extra fields */
  stopTemplate: StopTemplate;
  stopTemplateId: Scalars['ID'];
};

/**
 * # See more details at
 * # https://www.notion.so/courie/MVP-Engineering-Design-Overview-d147ddfa1d46463b9d8fcb1463610a3e?pvs=4#ca8b7c9d0a19420d8a0cfafa2c2adcb0
 */
export enum StopTimeStatus {
  Completed = 'COMPLETED',
  Late = 'LATE',
  LateSoon = 'LATE_SOON',
  LikelyLate = 'LIKELY_LATE',
  NotReady = 'NOT_READY',
  OnTime = 'ON_TIME'
}

export type StopTripDistance = {
  __typename?: 'StopTripDistance';
  destinationStop: Stop;
  destinationStopId: Scalars['ID'];
  sourceStop: Stop;
  sourceStopId: Scalars['ID'];
  tripDistance: TripDistance;
};

export type StorageFile = {
  __typename?: 'StorageFile';
  bucketName: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['ID'];
  initialUrl?: Maybe<Scalars['String']>;
  isPublic: Scalars['Boolean'];
};

/**
 *  A Customer Support (Vapi) call, and which customer it is for. The assistant's MCP tools read the
 *  customer from here, never from the browser.
 */
export type SupportCall = {
  __typename?: 'SupportCall';
  endCustomerId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  vapiCallId: Scalars['String'];
};

export enum SurchargeAmountType {
  CustomAmount = 'CUSTOM_AMOUNT',
  DynamicFuelPercentageOnTotalExceptSpecifiedSurcharges = 'DYNAMIC_FUEL_PERCENTAGE_ON_TOTAL_EXCEPT_SPECIFIED_SURCHARGES',
  DynamicFuelSurchargeBasedOnEiaRate = 'DYNAMIC_FUEL_SURCHARGE_BASED_ON_EIA_RATE',
  Fixed = 'FIXED',
  PercentageOnMilesCharge = 'PERCENTAGE_ON_MILES_CHARGE',
  PercentageOnTotalExceptSpecifiedSurcharges = 'PERCENTAGE_ON_TOTAL_EXCEPT_SPECIFIED_SURCHARGES',
  PerCustomFieldUnit = 'PER_CUSTOM_FIELD_UNIT',
  PerMile = 'PER_MILE',
  PerMilesFromOrToDepotDependingOnZone = 'PER_MILES_FROM_OR_TO_DEPOT_DEPENDING_ON_ZONE',
  PerMilesOutOfPerimeter = 'PER_MILES_OUT_OF_PERIMETER',
  PerPackageLbs = 'PER_PACKAGE_LBS',
  PerPackagePiece = 'PER_PACKAGE_PIECE',
  PerSkidSpace = 'PER_SKID_SPACE',
  PerWaitTimeMinutes = 'PER_WAIT_TIME_MINUTES'
}

export enum SurchargeApplyType {
  Always = 'ALWAYS',
  CustomFieldMultipleChoiceExactMatch = 'CUSTOM_FIELD_MULTIPLE_CHOICE_EXACT_MATCH',
  CustomFieldNumberInRange = 'CUSTOM_FIELD_NUMBER_IN_RANGE',
  DeliveryTime = 'DELIVERY_TIME',
  DeliverByTime = 'DELIVER_BY_TIME',
  InPerimeter = 'IN_PERIMETER',
  ManualOnly = 'MANUAL_ONLY',
  MileageBased = 'MILEAGE_BASED',
  OrderSource = 'ORDER_SOURCE',
  OutOfPerimeter = 'OUT_OF_PERIMETER',
  PackageCount = 'PACKAGE_COUNT',
  PackageSize = 'PACKAGE_SIZE',
  PackageType = 'PACKAGE_TYPE',
  PackageWeightInLbs = 'PACKAGE_WEIGHT_IN_LBS',
  PackageWeightInLbsPerUnit = 'PACKAGE_WEIGHT_IN_LBS_PER_UNIT',
  ReadyTime = 'READY_TIME',
  ReadyTimeHoliday = 'READY_TIME_HOLIDAY',
  VehicleType = 'VEHICLE_TYPE',
  ZoneToZone = 'ZONE_TO_ZONE'
}

export type SurchargePackageCountBasedMultiplier = {
  __typename?: 'SurchargePackageCountBasedMultiplier';
  maxPackageCount?: Maybe<Scalars['Int']>;
  minPackageCount?: Maybe<Scalars['Int']>;
  multiplier: Scalars['Money'];
};

export type SurchargePackageCountBasedMultiplierInput = {
  maxPackageCount?: InputMaybe<Scalars['Int']>;
  minPackageCount?: InputMaybe<Scalars['Int']>;
  multiplier: Scalars['Money'];
};

export type SurchargePricingRule = {
  __typename?: 'SurchargePricingRule';
  advancedMultiplier?: Maybe<SurchargePricingRuleAdvancedMultiplier>;
  amount: Scalars['Money'];
  amountDisplay: Scalars['String'];
  amountType: SurchargeAmountType;
  applicableStopTypes?: Maybe<Array<ShipmentStopType>>;
  applyType: SurchargeApplyType;
  courierId: Scalars['ID'];
  customField?: Maybe<CustomField>;
  customFieldForApplyType?: Maybe<CustomField>;
  customFieldId?: Maybe<Scalars['ID']>;
  customFieldIdForApplyType?: Maybe<Scalars['ID']>;
  customFieldMaxValue?: Maybe<Scalars['Float']>;
  customFieldMinValue?: Maybe<Scalars['Float']>;
  customFieldValueExactMatch?: Maybe<Scalars['String']>;
  daysOfTheWeek?: Maybe<Array<DayOfTheWeek>>;
  depotLocation?: Maybe<Location>;
  depotLocationId?: Maybe<Scalars['ID']>;
  destinationZone?: Maybe<Zone>;
  destinationZoneId?: Maybe<Scalars['ID']>;
  driverCommission?: Maybe<Scalars['Money']>;
  freeMiles?: Maybe<Scalars['Float']>;
  freePackageCount?: Maybe<Scalars['Int']>;
  freeSkidSpaces?: Maybe<Scalars['Int']>;
  freeWaitTimeOverrideSeconds?: Maybe<Scalars['Int']>;
  freeWeight?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  internalNote?: Maybe<Scalars['String']>;
  invoiceSummaryGroup?: Maybe<Scalars['String']>;
  maxDeliverByTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  maxDeliveryTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  maxMiles?: Maybe<Scalars['Int']>;
  maxPackageCount?: Maybe<Scalars['Int']>;
  maxReadyTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  maxWeight?: Maybe<Scalars['Float']>;
  maximumAmount?: Maybe<Scalars['Money']>;
  maximumDriverPay?: Maybe<Scalars['Money']>;
  minDeliverByTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  minDeliveryTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  minMiles?: Maybe<Scalars['Int']>;
  minPackageCount?: Maybe<Scalars['Int']>;
  minReadyTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  minWeight?: Maybe<Scalars['Float']>;
  minimumAmount?: Maybe<Scalars['Money']>;
  name: Scalars['String'];
  numPerUnit?: Maybe<Scalars['Int']>;
  numPerUnitRoundingStrategy: RoundingStrategy;
  /** Set only when applyType is ORDER_SOURCE: order acquisition types this surcharge matches. */
  orderAcquisitionTypes?: Maybe<Array<OrderAcquisitionType>>;
  originZone?: Maybe<Zone>;
  originZoneId?: Maybe<Scalars['ID']>;
  packageSize?: Maybe<PackageSize>;
  packageType?: Maybe<PackageType>;
  packageTypeId?: Maybe<Scalars['ID']>;
  percent: Scalars['Float'];
  perimeterZone?: Maybe<Zone>;
  /** # additional fields */
  pricingList?: Maybe<PricingList>;
  pricingListId?: Maybe<Scalars['ID']>;
  readyTimeHolidaySchedule?: Maybe<HolidaySchedule>;
  readyTimeHolidayScheduleId?: Maybe<Scalars['ID']>;
  scope?: Maybe<SurchargeScope>;
  /** @deprecated Use serviceTypes instead */
  serviceType?: Maybe<ServiceType>;
  serviceTypes?: Maybe<Array<ServiceType>>;
  shouldMultiplyByPackageCount?: Maybe<Scalars['Boolean']>;
  showInInvoice: Scalars['Boolean'];
  surchargePricingRuleIdsToExclude?: Maybe<Array<Scalars['ID']>>;
  surchargePricingRulesToExclude?: Maybe<Array<SurchargePricingRule>>;
  taxableStatus: SurchargeTaxStatus;
  timeZoneId?: Maybe<Scalars['String']>;
  vehicleType?: Maybe<VehicleType>;
  vehicleTypeId?: Maybe<Scalars['ID']>;
  vehicleTypes?: Maybe<Array<VehicleType>>;
  waiveBelowAmount?: Maybe<Scalars['Money']>;
  /**
   * Which weight this surcharge prices against. Set per surcharge on
   * create/update; `Courier.defaultWeightBasis` seeds the form default
   * in the UI.
   */
  weightBasis: WeightBasis;
  zoneForInPerimeterApplyType?: Maybe<Zone>;
  zoneForOutOfPerimeterApplyType?: Maybe<Zone>;
  zoneForPerMilesFromOrToDepotAmountType?: Maybe<Zone>;
  zoneIdForInPerimeterApplyType?: Maybe<Scalars['ID']>;
  zoneIdForOutOfPerimeterApplyType?: Maybe<Scalars['ID']>;
  zoneIdForPerMilesFromOrToDepotAmountType?: Maybe<Scalars['ID']>;
};

export type SurchargePricingRuleAdvancedMultiplier = {
  __typename?: 'SurchargePricingRuleAdvancedMultiplier';
  packageCountBasedMultipliers: Array<SurchargePackageCountBasedMultiplier>;
};

export type SurchargePricingRuleAdvancedMultiplierInput = {
  packageCountBasedMultipliers: Array<SurchargePackageCountBasedMultiplierInput>;
};

export type SurchargePricingRuleAdvancedSettingsInput = {
  shouldMultiplyByPackageCount: Scalars['Boolean'];
  surchargePricingRuleId: Scalars['ID'];
};

/** SurchargePricingRule Connection */
export type SurchargePricingRuleConnection = {
  __typename?: 'SurchargePricingRuleConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<SurchargePricingRuleEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

export type SurchargePricingRuleCreate = {
  amount?: InputMaybe<Scalars['Money']>;
  amountType: SurchargeAmountType;
  applicableStopTypes?: InputMaybe<Array<ShipmentStopType>>;
  applyType: SurchargeApplyType;
  courierId: Scalars['ID'];
  customFieldId?: InputMaybe<Scalars['ID']>;
  customFieldIdForApplyType?: InputMaybe<Scalars['ID']>;
  customFieldMaxValue?: InputMaybe<Scalars['Float']>;
  customFieldMinValue?: InputMaybe<Scalars['Float']>;
  customFieldValueExactMatch?: InputMaybe<Scalars['String']>;
  daysOfTheWeek?: InputMaybe<Array<DayOfTheWeek>>;
  depotLocationId?: InputMaybe<Scalars['ID']>;
  destinationZoneId?: InputMaybe<Scalars['ID']>;
  driverCommission?: InputMaybe<Scalars['Money']>;
  freeMiles?: InputMaybe<Scalars['Float']>;
  freePackageCount?: InputMaybe<Scalars['Int']>;
  freeSkidSpaces?: InputMaybe<Scalars['Int']>;
  freeWaitTimeOverrideSeconds?: InputMaybe<Scalars['Int']>;
  freeWeight?: InputMaybe<Scalars['Float']>;
  internalNote?: InputMaybe<Scalars['String']>;
  maxDeliverByTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  maxDeliveryTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  maxMiles?: InputMaybe<Scalars['Int']>;
  maxPackageCount?: InputMaybe<Scalars['Int']>;
  maxReadyTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  maxWeight?: InputMaybe<Scalars['Float']>;
  maximumAmount?: InputMaybe<Scalars['Money']>;
  maximumDriverPay?: InputMaybe<Scalars['Money']>;
  minDeliverByTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  minDeliveryTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  minMiles?: InputMaybe<Scalars['Int']>;
  minPackageCount?: InputMaybe<Scalars['Int']>;
  minReadyTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  minWeight?: InputMaybe<Scalars['Float']>;
  minimumAmount?: InputMaybe<Scalars['Money']>;
  name: Scalars['String'];
  numPerUnit?: InputMaybe<Scalars['Int']>;
  numPerUnitRoundingStrategy?: InputMaybe<RoundingStrategy>;
  /** Set only when applyType is ORDER_SOURCE: order acquisition types this surcharge matches. */
  orderAcquisitionTypes?: InputMaybe<Array<OrderAcquisitionType>>;
  originZoneId?: InputMaybe<Scalars['ID']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  percent?: InputMaybe<Scalars['Float']>;
  perimeterZoneId?: InputMaybe<Scalars['ID']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  readyTimeHolidayScheduleId?: InputMaybe<Scalars['ID']>;
  scope?: InputMaybe<SurchargeScope>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  showInInvoice?: InputMaybe<Scalars['Boolean']>;
  surchargePricingRuleIdsToExclude?: InputMaybe<Array<Scalars['ID']>>;
  timeZoneId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
  vehicleTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  waiveBelowAmount?: InputMaybe<Scalars['Money']>;
  weightBasis?: InputMaybe<WeightBasis>;
  zoneIdForInPerimeterApplyType?: InputMaybe<Scalars['ID']>;
  zoneIdForOutOfPerimeterApplyType?: InputMaybe<Scalars['ID']>;
  zoneIdForPerMilesFromOrToDepotAmountType?: InputMaybe<Scalars['ID']>;
};

/** SurchargePricingRule Edge */
export type SurchargePricingRuleEdge = {
  __typename?: 'SurchargePricingRuleEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<SurchargePricingRule>;
};

export type SurchargePricingRuleFullUpdate = {
  amount?: InputMaybe<Scalars['Money']>;
  amountType: SurchargeAmountType;
  applicableStopTypes?: InputMaybe<Array<ShipmentStopType>>;
  applyType: SurchargeApplyType;
  customFieldId?: InputMaybe<Scalars['ID']>;
  customFieldIdForApplyType?: InputMaybe<Scalars['ID']>;
  customFieldMaxValue?: InputMaybe<Scalars['Float']>;
  customFieldMinValue?: InputMaybe<Scalars['Float']>;
  customFieldValueExactMatch?: InputMaybe<Scalars['String']>;
  daysOfTheWeek?: InputMaybe<Array<DayOfTheWeek>>;
  depotLocationId?: InputMaybe<Scalars['ID']>;
  destinationZoneId?: InputMaybe<Scalars['ID']>;
  driverCommission?: InputMaybe<Scalars['Money']>;
  freeMiles?: InputMaybe<Scalars['Float']>;
  freePackageCount?: InputMaybe<Scalars['Int']>;
  freeSkidSpaces?: InputMaybe<Scalars['Int']>;
  freeWaitTimeOverrideSeconds?: InputMaybe<Scalars['Int']>;
  freeWeight?: InputMaybe<Scalars['Float']>;
  internalNote?: InputMaybe<Scalars['String']>;
  maxDeliverByTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  maxDeliveryTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  maxMiles?: InputMaybe<Scalars['Int']>;
  maxPackageCount?: InputMaybe<Scalars['Int']>;
  maxReadyTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  maxWeight?: InputMaybe<Scalars['Float']>;
  maximumAmount?: InputMaybe<Scalars['Money']>;
  maximumDriverPay?: InputMaybe<Scalars['Money']>;
  minDeliverByTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  minDeliveryTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  minMiles?: InputMaybe<Scalars['Int']>;
  minPackageCount?: InputMaybe<Scalars['Int']>;
  minReadyTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  minWeight?: InputMaybe<Scalars['Float']>;
  minimumAmount?: InputMaybe<Scalars['Money']>;
  name: Scalars['String'];
  numPerUnit?: InputMaybe<Scalars['Int']>;
  numPerUnitRoundingStrategy?: InputMaybe<RoundingStrategy>;
  /** Set only when applyType is ORDER_SOURCE: order acquisition types this surcharge matches. */
  orderAcquisitionTypes?: InputMaybe<Array<OrderAcquisitionType>>;
  originZoneId?: InputMaybe<Scalars['ID']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  percent?: InputMaybe<Scalars['Float']>;
  perimeterZoneId?: InputMaybe<Scalars['ID']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  readyTimeHolidayScheduleId?: InputMaybe<Scalars['ID']>;
  scope?: InputMaybe<SurchargeScope>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  showInInvoice?: InputMaybe<Scalars['Boolean']>;
  surchargePricingRuleId: Scalars['ID'];
  surchargePricingRuleIdsToExclude?: InputMaybe<Array<Scalars['ID']>>;
  timeZoneId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
  vehicleTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  waiveBelowAmount?: InputMaybe<Scalars['Money']>;
  weightBasis?: InputMaybe<WeightBasis>;
  zoneIdForInPerimeterApplyType?: InputMaybe<Scalars['ID']>;
  zoneIdForOutOfPerimeterApplyType?: InputMaybe<Scalars['ID']>;
  zoneIdForPerMilesFromOrToDepotAmountType?: InputMaybe<Scalars['ID']>;
};

export enum SurchargePricingRuleSortField {
  Name = 'NAME'
}

export type SurchargePricingRuleSorting = {
  direction: SortingDirection;
  field: SurchargePricingRuleSortField;
};

export type SurchargeRulesCsvFile = {
  __typename?: 'SurchargeRulesCsvFile';
  url: Scalars['String'];
};

/** Controls the level at which a surcharge rule aggregates quantities and free allowances. */
export enum SurchargeScope {
  /** Default: surcharge fires once for the whole order. */
  PerOrder = 'PER_ORDER',
  /** Surcharge fires per delivery stop. Valid for FIXED and PER_MILE amount types. */
  PerStop = 'PER_STOP',
  /** Surcharge fires per package item. Valid for PER_PACKAGE_LBS and PER_SKID_SPACE amount types. */
  PerUnit = 'PER_UNIT'
}

export enum SurchargeTaxStatus {
  NonTaxable = 'NON_TAXABLE',
  Taxable = 'TAXABLE'
}

export enum SyncDriverWithFirebaseError {
  DriverDeactivated = 'DRIVER_DEACTIVATED',
  DriverNotFound = 'DRIVER_NOT_FOUND'
}

export type SyncDriverWithFirebaseResult = {
  __typename?: 'SyncDriverWithFirebaseResult';
  driver?: Maybe<Driver>;
  error?: Maybe<SyncDriverWithFirebaseError>;
};

export enum SyncEndCustomerWithFirebaseError {
  EndCustomerNotFound = 'END_CUSTOMER_NOT_FOUND'
}

export type SyncEndCustomerWithFirebaseResult = {
  __typename?: 'SyncEndCustomerWithFirebaseResult';
  endCustomer?: Maybe<EndCustomer>;
  endUser?: Maybe<EndUser>;
  error?: Maybe<SyncEndCustomerWithFirebaseError>;
};

export enum SyncUserWithFirebaseError {
  UserNotFound = 'USER_NOT_FOUND'
}

export type SyncUserWithFirebaseResult = {
  __typename?: 'SyncUserWithFirebaseResult';
  employeeId?: Maybe<Scalars['ID']>;
  error?: Maybe<SyncUserWithFirebaseError>;
  isEmployee: Scalars['Boolean'];
  user?: Maybe<CourieUser>;
};

export type Task = {
  __typename?: 'Task';
  answers: Array<DriverAnswer>;
  arrivedAt?: Maybe<Scalars['Timestamp']>;
  arrivedByGps?: Maybe<Scalars['Timestamp']>;
  arrivedMarkedManuallyAt?: Maybe<Scalars['Timestamp']>;
  artifacts: Array<Artifact>;
  bundleType: TaskBundleType;
  bundledTasks: Array<Task>;
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  /** Photo minimum task completion will enforce for this task; null when none applies. The driver app checks it before queueing an offline completion. */
  endCustomerMinimumPhotoSettings?: Maybe<EndCustomerMinimumPhotoPodSettings>;
  etaEpochSeconds?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  questions: Array<DriverQuestion>;
  sequenceNumber: Scalars['Float'];
  status: TaskStatus;
  stop: Stop;
};

export type TaskArrivalInput = {
  arrivalOverride: Scalars['Timestamp'];
  taskId: Scalars['ID'];
};

export enum TaskBundleType {
  BundleFollower = 'BUNDLE_FOLLOWER',
  BundleLead = 'BUNDLE_LEAD',
  None = 'NONE'
}

export enum TaskStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Started = 'STARTED'
}

export enum TimeFormatPreference {
  TwelveHour = 'TWELVE_HOUR',
  TwentyFourHour = 'TWENTY_FOUR_HOUR'
}

export type TimeSchedule = {
  __typename?: 'TimeSchedule';
  weekDailyList?: Maybe<Array<Maybe<TimeScheduleWeekDaily>>>;
};

export type TimeScheduleInput = {
  weekDailyList: Array<TimeScheduleWeekDailyInput>;
};

export type TimeScheduleSpecificAmounts = {
  __typename?: 'TimeScheduleSpecificAmounts';
  schedules: Array<TimeScheduleWeekDailyAmounts>;
};

export type TimeScheduleSpecificAmountsInput = {
  schedules: Array<TimeScheduleWeekDailyAmountsInput>;
};

export type TimeScheduleWeekDaily = {
  __typename?: 'TimeScheduleWeekDaily';
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type TimeScheduleWeekDailyAmounts = {
  __typename?: 'TimeScheduleWeekDailyAmounts';
  baseAmount?: Maybe<Scalars['Money']>;
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  minimumAmount: Scalars['Money'];
  pricePerMileAmount?: Maybe<Scalars['Money']>;
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type TimeScheduleWeekDailyAmountsInput = {
  baseAmount?: InputMaybe<Scalars['Money']>;
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  minimumAmount: Scalars['Money'];
  pricePerMileAmount?: InputMaybe<Scalars['Money']>;
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type TimeScheduleWeekDailyInput = {
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type TimeWindow = {
  __typename?: 'TimeWindow';
  close?: Maybe<Scalars['Timestamp']>;
  open?: Maybe<Scalars['Timestamp']>;
};

export type TimeWindowInput = {
  close?: InputMaybe<Scalars['Timestamp']>;
  open?: InputMaybe<Scalars['Timestamp']>;
};

export enum TimeWindowSetting {
  AllTimeWindowSettings = 'ALL_TIME_WINDOW_SETTINGS',
  BothDropOffReadyAndDueTime = 'BOTH_DROP_OFF_READY_AND_DUE_TIME',
  BothPickUpAndDropOffDueTime = 'BOTH_PICK_UP_AND_DROP_OFF_DUE_TIME',
  DropOffDueTime = 'DROP_OFF_DUE_TIME'
}

export type TimeWindowTemplateInput = {
  closeSecondsSinceMidnightUtc?: InputMaybe<Scalars['Int']>;
  openSecondsSinceMidnightUtc?: InputMaybe<Scalars['Int']>;
};

export type TimeWindowTimeOfDay = {
  __typename?: 'TimeWindowTimeOfDay';
  closeSecondsSinceMidnightUtc?: Maybe<Scalars['Int']>;
  openSecondsSinceMidnightUtc?: Maybe<Scalars['Int']>;
};

export enum TransportationType {
  Bike = 'BIKE',
  Car = 'CAR',
  Other = 'OTHER',
  PublicTransportation = 'PUBLIC_TRANSPORTATION',
  Truck = 'TRUCK',
  Van = 'VAN',
  Walking = 'WALKING'
}

export type TripDistance = {
  __typename?: 'TripDistance';
  destinationLocationId: Scalars['ID'];
  distanceInMeters: Scalars['Float'];
  durationInSeconds?: Maybe<Scalars['Float']>;
  isOverridden: Scalars['Boolean'];
  sourceLocationId: Scalars['ID'];
};

export type TripDistanceOverride = {
  __typename?: 'TripDistanceOverride';
  courierId: Scalars['ID'];
  createdAt: Scalars['String'];
  destinationLocation: Location;
  destinationLocationId: Scalars['ID'];
  distanceInMeters: Scalars['Float'];
  durationInSeconds?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  originLocation: Location;
  overriddenBy: Scalars['String'];
  sourceLocationId: Scalars['ID'];
  updatedAt: Scalars['String'];
};

/** TripDistanceOverride Connection */
export type TripDistanceOverrideConnection = {
  __typename?: 'TripDistanceOverrideConnection';
  /** Field edges */
  edges?: Maybe<Array<Maybe<TripDistanceOverrideEdge>>>;
  /** Field pageInfo */
  pageInfo: PageInfo;
};

/** TripDistanceOverride Edge */
export type TripDistanceOverrideEdge = {
  __typename?: 'TripDistanceOverrideEdge';
  /** Field cursor */
  cursor?: Maybe<Scalars['String']>;
  /** Field node */
  node?: Maybe<TripDistanceOverride>;
};

export type UnassignedShipmentsForDate = {
  __typename?: 'UnassignedShipmentsForDate';
  date: Scalars['Date'];
  shipmentTemplates: Array<ShipmentTemplate>;
  shipments: Array<Shipment>;
};

export type UploadFuelSurchargeGridCsvResult = {
  __typename?: 'UploadFuelSurchargeGridCsvResult';
  /** Every problem found, by CSV row. Empty when the upload succeeded. */
  errors: Array<UploadFuelSurchargeGridCsvRowError>;
  /** The courier's new grid. Null when the file had problems and nothing was saved. */
  fuelSurchargeGrid?: Maybe<FuelSurchargeGrid>;
};

export type UploadFuelSurchargeGridCsvRowError = {
  __typename?: 'UploadFuelSurchargeGridCsvRowError';
  messages: Array<Scalars['String']>;
  /** 1-based, counting the header as row 1, as in the other pricing CSV uploads. */
  rowNumber: Scalars['Int'];
};

export type UploadZonesFromKmzResult = {
  __typename?: 'UploadZonesFromKmzResult';
  warnings: Array<Scalars['String']>;
  zonesUpserted: Scalars['Int'];
};

export enum UserRoleType {
  Administrator = 'ADMINISTRATOR',
  Csr = 'CSR',
  Custom = 'CUSTOM',
  Dispatcher = 'DISPATCHER'
}

export type UserStore = {
  __typename?: 'UserStore';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  color?: Maybe<Scalars['String']>;
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  licensePlate?: Maybe<Scalars['String']>;
  licensePlateState?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  transportationType: TransportationType;
  year?: Maybe<Scalars['Int']>;
};

export type VehicleType = {
  __typename?: 'VehicleType';
  allowOrdersWith: Scalars['Boolean'];
  courierId: Scalars['ID'];
  fuelType: FuelType;
  id: Scalars['ID'];
  maxPackageHeight?: Maybe<Scalars['Float']>;
  maxPackageLength?: Maybe<Scalars['Float']>;
  maxPackageWidth?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  readyTimeSchedule?: Maybe<TimeSchedule>;
  shortCode: Scalars['String'];
  visiblePackageTypeIds?: Maybe<Array<Scalars['String']>>;
};


export type VehicleTypeAllowOrdersWithArgs = {
  readyTime?: InputMaybe<Scalars['Timestamp']>;
};

export type VisibleColumnsConfig = {
  __typename?: 'VisibleColumnsConfig';
  driverReportColumnIds?: Maybe<Array<DriverReportColumnId>>;
  id: Scalars['ID'];
  salesReportColumnIds?: Maybe<Array<SalesReportColumnId>>;
  userOrEmployeeId: Scalars['String'];
};

export enum WebhookEventName {
  OrderAttempted = 'ORDER_ATTEMPTED',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderCreated = 'ORDER_CREATED',
  ScanCreated = 'SCAN_CREATED',
  ShipmentArrivedAtDropoff = 'SHIPMENT_ARRIVED_AT_DROPOFF',
  ShipmentArrivedAtPickup = 'SHIPMENT_ARRIVED_AT_PICKUP',
  ShipmentAssigned = 'SHIPMENT_ASSIGNED',
  ShipmentDelivered = 'SHIPMENT_DELIVERED',
  ShipmentPickedUp = 'SHIPMENT_PICKED_UP'
}

export type WebhookHeader = {
  __typename?: 'WebhookHeader';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type WebhookHeaderInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type WebhookSubscription = {
  __typename?: 'WebhookSubscription';
  additionalHeaders?: Maybe<Array<WebhookHeader>>;
  courierId: Scalars['String'];
  endCustomerScope: EndCustomerScope;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  partnerId: Scalars['String'];
  scopedEndCustomerIds?: Maybe<Array<Scalars['String']>>;
  subscribedEvents: Array<WebhookEventName>;
  url: Scalars['String'];
};

export type WeeklySchedule = {
  __typename?: 'WeeklySchedule';
  weekDays: Array<DayOfTheWeek>;
};

export type WeeklyScheduleInput = {
  weekDays: Array<DayOfTheWeek>;
};

/**
 * Controls which weight is used when evaluating a pricing rule or surcharge.
 *
 * Set per rule and per surcharge. `Courier.defaultWeightBasis` is the option
 * the courier-settings UI pre-selects in the rule/surcharge forms; pricing
 * reads only the rule's own `weightBasis` today. A future "fall back to
 * courier default" mode is deferred until needed. See
 * `cube/docs/outlines/2026-05-16_dimWeight-02a_config-crud.md`.
 */
export enum WeightBasis {
  /** original behavior: price against `shipment.packageWeightInPounds`. */
  ActualOnly = 'ACTUAL_ONLY',
  /** Price against `max(actual, dim)`. Requires the courier to have `dimFactor` set. */
  MaxOfActualAndDim = 'MAX_OF_ACTUAL_AND_DIM'
}

export enum WeightUnit {
  Kg = 'KG',
  Lbs = 'LBS'
}

export type ZipGroup = {
  __typename?: 'ZipGroup';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']>;
};

export type Zone = {
  __typename?: 'Zone';
  assignedLabels?: Maybe<Array<Label>>;
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  polygon: Polygon;
  type: ZoneType;
};

export type ZoneCreate = {
  name: Scalars['String'];
  polygon: PolygonInput;
  type: ZoneType;
};

export enum ZoneType {
  Dispatch = 'DISPATCH',
  Pricing = 'PRICING'
}

export type ZoneUpdate = {
  id: Scalars['ID'];
  name: Scalars['String'];
  polygon: PolygonInput;
  type: ZoneType;
};

export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String'];
};

export type ActivityFragmentFragment = { __typename?: 'Activity', id: string, courierId: string, entityId: string, entityType: ActivityEntityType, infoType: ActivityInfoType, description?: string | null, time: any, date: any, imageUrl?: string | null, offlineMode: OfflineMode, createdAt: any, updatedByEmail?: string | null };

export type ActivitySnapshotFragmentFragment = { __typename?: 'ActivitySnapshot', value?: string | null, entries?: Array<{ __typename?: 'ActivitySnapshotEntry', key: string, value: string } | null> | null };

export type ActivitySnapshotEntryFragmentFragment = { __typename?: 'ActivitySnapshotEntry', key: string, value: string };

export type ActivitiesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  entityId: Scalars['ID'];
}>;


export type ActivitiesQuery = { __typename?: 'Query', activities: { __typename?: 'ActivitiesResult', activities: Array<{ __typename?: 'Activity', id: string, courierId: string, entityId: string, entityType: ActivityEntityType, infoType: ActivityInfoType, description?: string | null, time: any, date: any, imageUrl?: string | null, offlineMode: OfflineMode, createdAt: any, updatedByEmail?: string | null, change?: { __typename?: 'ActivityChangeDetail', old?: { __typename?: 'ActivitySnapshot', value?: string | null, entries?: Array<{ __typename?: 'ActivitySnapshotEntry', key: string, value: string } | null> | null } | null, new?: { __typename?: 'ActivitySnapshot', value?: string | null, entries?: Array<{ __typename?: 'ActivitySnapshotEntry', key: string, value: string } | null> | null } | null } | null, updatedByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } | null, updatedByEndCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } | null, updatedByEndUser?: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null, role: EndUserRoleType } | null, updatedByDriver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null }> } };

export type AddressBookFragmentFragment = { __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, emailRecipients?: Array<string> | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type CreateAddressBookMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  emailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateAddressBookMutation = { __typename?: 'Mutation', createAddressBook: { __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, emailRecipients?: Array<string> | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } } };

export type FullUpdateAddressBookMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  emailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FullUpdateAddressBookMutation = { __typename?: 'Mutation', fullUpdateAddressBook: { __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, emailRecipients?: Array<string> | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } } };

export type DeleteAddressBookMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteAddressBookMutation = { __typename?: 'Mutation', deleteAddressBook?: boolean | null };

export type BulkUploadAddressBookMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type BulkUploadAddressBookMutation = { __typename?: 'Mutation', bulkUploadAddressBook?: { __typename?: 'BulkUploadAddressBookResult', numSuccess: number, isAsynchronous?: boolean | null, errors?: Array<{ __typename?: 'BulkUploadAddressBookRowError', rowNumber: number, messages: Array<string> }> | null } | null };

export type BulkDeleteAddressBookMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BulkDeleteAddressBookMutation = { __typename?: 'Mutation', bulkDeleteAddressBook?: boolean | null };

export type SearchFromAddressBookQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerIdBias?: InputMaybe<Scalars['ID']>;
  contactNameSearch?: InputMaybe<Scalars['String']>;
  companyNameSearch?: InputMaybe<Scalars['String']>;
  phoneSearch?: InputMaybe<Scalars['String']>;
  streetAddressSearch?: InputMaybe<Scalars['String']>;
  googlePlaceIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SearchFromAddressBookQuery = { __typename?: 'Query', searchFromAddressBook: Array<{ __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, emailRecipients?: Array<string> | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } }> };

export type AddressBookEntriesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  contactNameSearch?: InputMaybe<Scalars['String']>;
  companyNameSearch?: InputMaybe<Scalars['String']>;
  phoneSearch?: InputMaybe<Scalars['String']>;
  streetAddressSearch?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<AddressBookSorting> | AddressBookSorting>;
}>;


export type AddressBookEntriesQuery = { __typename?: 'Query', addressBookEntries?: { __typename?: 'AddressBookEntryConnection', edges?: Array<{ __typename?: 'AddressBookEntryEdge', node?: { __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, emailRecipients?: Array<string> | null, endCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type PhotoReviewSettingFragmentFragment = { __typename?: 'PhotoReviewSetting', checkPhotoClarity: boolean, checkPackageVisibility: boolean, checkDeliveryConfirmation: boolean, checkInappropriateContent: boolean, userPrompt?: string | null };

export type PricingReviewSettingFragmentFragment = { __typename?: 'PricingReviewSetting', ignoreOverriddenPrices: boolean, checkZeroMainPrice: boolean, checkMissingSurcharges: boolean, checkMissingWaitTimeSurcharge: boolean, checkIncorrectInformation: boolean, userPrompt?: string | null };

export type OtherReviewSettingFragmentFragment = { __typename?: 'OtherReviewSetting', userPrompt?: string | null };

export type QualityReviewAgentSettingFragmentFragment = { __typename?: 'QualityReviewAgentSetting', closeGoodQualityOrdersAutomatically: boolean, photoReview?: { __typename?: 'PhotoReviewSetting', checkPhotoClarity: boolean, checkPackageVisibility: boolean, checkDeliveryConfirmation: boolean, checkInappropriateContent: boolean, userPrompt?: string | null } | null, pricingReview?: { __typename?: 'PricingReviewSetting', ignoreOverriddenPrices: boolean, checkZeroMainPrice: boolean, checkMissingSurcharges: boolean, checkMissingWaitTimeSurcharge: boolean, checkIncorrectInformation: boolean, userPrompt?: string | null } | null, otherReview?: { __typename?: 'OtherReviewSetting', userPrompt?: string | null } | null };

export type CustomerSupportAgentSettingFragmentFragment = { __typename?: 'CustomerSupportAgentSetting', orderingEnabled: boolean, cancelEnabled: boolean, updateEnabled: boolean, generalInformation?: string | null, orderEntryInstruction?: string | null, generalInstruction?: string | null, frequentlyAskedQuestions?: Array<{ __typename?: 'CustomerSupportFrequentlyAskedQuestion', question: string, answer: string }> | null };

export type AgentDetailsFragmentFragment = { __typename?: 'AgentDetails', qualityReviewAgentDetails?: { __typename?: 'QualityReviewAgentSetting', closeGoodQualityOrdersAutomatically: boolean, photoReview?: { __typename?: 'PhotoReviewSetting', checkPhotoClarity: boolean, checkPackageVisibility: boolean, checkDeliveryConfirmation: boolean, checkInappropriateContent: boolean, userPrompt?: string | null } | null, pricingReview?: { __typename?: 'PricingReviewSetting', ignoreOverriddenPrices: boolean, checkZeroMainPrice: boolean, checkMissingSurcharges: boolean, checkMissingWaitTimeSurcharge: boolean, checkIncorrectInformation: boolean, userPrompt?: string | null } | null, otherReview?: { __typename?: 'OtherReviewSetting', userPrompt?: string | null } | null } | null, customerSupportAgentDetails?: { __typename?: 'CustomerSupportAgentSetting', orderingEnabled: boolean, cancelEnabled: boolean, updateEnabled: boolean, generalInformation?: string | null, orderEntryInstruction?: string | null, generalInstruction?: string | null, frequentlyAskedQuestions?: Array<{ __typename?: 'CustomerSupportFrequentlyAskedQuestion', question: string, answer: string }> | null } | null };

export type AgentFragmentFragment = { __typename?: 'Agent', id: string, courierId: string, agentType: AgentType, optedIn: boolean, details?: { __typename?: 'AgentDetails', qualityReviewAgentDetails?: { __typename?: 'QualityReviewAgentSetting', closeGoodQualityOrdersAutomatically: boolean, photoReview?: { __typename?: 'PhotoReviewSetting', checkPhotoClarity: boolean, checkPackageVisibility: boolean, checkDeliveryConfirmation: boolean, checkInappropriateContent: boolean, userPrompt?: string | null } | null, pricingReview?: { __typename?: 'PricingReviewSetting', ignoreOverriddenPrices: boolean, checkZeroMainPrice: boolean, checkMissingSurcharges: boolean, checkMissingWaitTimeSurcharge: boolean, checkIncorrectInformation: boolean, userPrompt?: string | null } | null, otherReview?: { __typename?: 'OtherReviewSetting', userPrompt?: string | null } | null } | null, customerSupportAgentDetails?: { __typename?: 'CustomerSupportAgentSetting', orderingEnabled: boolean, cancelEnabled: boolean, updateEnabled: boolean, generalInformation?: string | null, orderEntryInstruction?: string | null, generalInstruction?: string | null, frequentlyAskedQuestions?: Array<{ __typename?: 'CustomerSupportFrequentlyAskedQuestion', question: string, answer: string }> | null } | null } | null };

export type CreateAgentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  create: AgentCreate;
}>;


export type CreateAgentMutation = { __typename?: 'Mutation', createAgent: { __typename?: 'Agent', id: string, courierId: string, agentType: AgentType, optedIn: boolean, details?: { __typename?: 'AgentDetails', qualityReviewAgentDetails?: { __typename?: 'QualityReviewAgentSetting', closeGoodQualityOrdersAutomatically: boolean, photoReview?: { __typename?: 'PhotoReviewSetting', checkPhotoClarity: boolean, checkPackageVisibility: boolean, checkDeliveryConfirmation: boolean, checkInappropriateContent: boolean, userPrompt?: string | null } | null, pricingReview?: { __typename?: 'PricingReviewSetting', ignoreOverriddenPrices: boolean, checkZeroMainPrice: boolean, checkMissingSurcharges: boolean, checkMissingWaitTimeSurcharge: boolean, checkIncorrectInformation: boolean, userPrompt?: string | null } | null, otherReview?: { __typename?: 'OtherReviewSetting', userPrompt?: string | null } | null } | null, customerSupportAgentDetails?: { __typename?: 'CustomerSupportAgentSetting', orderingEnabled: boolean, cancelEnabled: boolean, updateEnabled: boolean, generalInformation?: string | null, orderEntryInstruction?: string | null, generalInstruction?: string | null, frequentlyAskedQuestions?: Array<{ __typename?: 'CustomerSupportFrequentlyAskedQuestion', question: string, answer: string }> | null } | null } | null } };

export type FullUpdateAgentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  fullUpdate: AgentFullUpdate;
}>;


export type FullUpdateAgentMutation = { __typename?: 'Mutation', fullUpdateAgent: { __typename?: 'Agent', id: string, courierId: string, agentType: AgentType, optedIn: boolean, details?: { __typename?: 'AgentDetails', qualityReviewAgentDetails?: { __typename?: 'QualityReviewAgentSetting', closeGoodQualityOrdersAutomatically: boolean, photoReview?: { __typename?: 'PhotoReviewSetting', checkPhotoClarity: boolean, checkPackageVisibility: boolean, checkDeliveryConfirmation: boolean, checkInappropriateContent: boolean, userPrompt?: string | null } | null, pricingReview?: { __typename?: 'PricingReviewSetting', ignoreOverriddenPrices: boolean, checkZeroMainPrice: boolean, checkMissingSurcharges: boolean, checkMissingWaitTimeSurcharge: boolean, checkIncorrectInformation: boolean, userPrompt?: string | null } | null, otherReview?: { __typename?: 'OtherReviewSetting', userPrompt?: string | null } | null } | null, customerSupportAgentDetails?: { __typename?: 'CustomerSupportAgentSetting', orderingEnabled: boolean, cancelEnabled: boolean, updateEnabled: boolean, generalInformation?: string | null, orderEntryInstruction?: string | null, generalInstruction?: string | null, frequentlyAskedQuestions?: Array<{ __typename?: 'CustomerSupportFrequentlyAskedQuestion', question: string, answer: string }> | null } | null } | null } };

export type UpdateOptedInMutationVariables = Exact<{
  agentId: Scalars['ID'];
  optedIn: Scalars['Boolean'];
}>;


export type UpdateOptedInMutation = { __typename?: 'Mutation', updateOptedIn: boolean };

export type GetAgentsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetAgentsQuery = { __typename?: 'Query', agents: Array<{ __typename?: 'Agent', id: string, courierId: string, agentType: AgentType, optedIn: boolean, details?: { __typename?: 'AgentDetails', qualityReviewAgentDetails?: { __typename?: 'QualityReviewAgentSetting', closeGoodQualityOrdersAutomatically: boolean, photoReview?: { __typename?: 'PhotoReviewSetting', checkPhotoClarity: boolean, checkPackageVisibility: boolean, checkDeliveryConfirmation: boolean, checkInappropriateContent: boolean, userPrompt?: string | null } | null, pricingReview?: { __typename?: 'PricingReviewSetting', ignoreOverriddenPrices: boolean, checkZeroMainPrice: boolean, checkMissingSurcharges: boolean, checkMissingWaitTimeSurcharge: boolean, checkIncorrectInformation: boolean, userPrompt?: string | null } | null, otherReview?: { __typename?: 'OtherReviewSetting', userPrompt?: string | null } | null } | null, customerSupportAgentDetails?: { __typename?: 'CustomerSupportAgentSetting', orderingEnabled: boolean, cancelEnabled: boolean, updateEnabled: boolean, generalInformation?: string | null, orderEntryInstruction?: string | null, generalInstruction?: string | null, frequentlyAskedQuestions?: Array<{ __typename?: 'CustomerSupportFrequentlyAskedQuestion', question: string, answer: string }> | null } | null } | null }> };

export type ArtifactFragmentFragment = { __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any };

export type MarkArtifactAsDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  artifactId: Scalars['ID'];
}>;


export type MarkArtifactAsDeletedMutation = { __typename?: 'Mutation', markArtifactAsDeleted: { __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any } };

export type GenerateResetPasswordLinkMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type GenerateResetPasswordLinkMutation = { __typename?: 'Mutation', generateResetPasswordLink: { __typename?: 'GenerateResetPasswordLinkResult', link?: string | null } };

export type SendPasswordResetEmailMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  endUserIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail?: number | null };

export type BulkUploadOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type BulkUploadOrdersMutation = { __typename?: 'Mutation', bulkUploadOrders: { __typename?: 'BulkUploadOrdersResult', numSuccess: number, isAsynchronous?: boolean | null, error?: { __typename?: 'CsvValidationError', errorMessages: Array<string>, lineErrors: Array<{ __typename?: 'CsvValidationLineError', lineNumber: number, cellErrors: Array<{ __typename?: 'CsvValidationCellError', columnName?: string | null, errorMessage: string }> }> } | null } };

export type BulkUploadEndCustomersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  ignoreInvalidAddresses?: InputMaybe<Scalars['Boolean']>;
  ignoreInvalidPricingLists?: InputMaybe<Scalars['Boolean']>;
  ignoreInvalidInvoiceFrequencies?: InputMaybe<Scalars['Boolean']>;
  onlyOverrideExistingEndCustomers?: InputMaybe<Scalars['Boolean']>;
  skipExistingEndCustomers?: InputMaybe<Scalars['Boolean']>;
}>;


export type BulkUploadEndCustomersMutation = { __typename?: 'Mutation', bulkUploadEndCustomers: { __typename?: 'BulkUploadEndCustomersResult', numSuccess: number, isAsynchronous: boolean, errors?: Array<{ __typename?: 'BulkUploadEndCustomersRowError', rowNumber: number, messages: Array<string> }> | null } };

export type BulkUploadRecurringOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  onlyUpdateExistingRecurringOrders?: InputMaybe<Scalars['Boolean']>;
}>;


export type BulkUploadRecurringOrdersMutation = { __typename?: 'Mutation', bulkUploadRecurringOrders: { __typename?: 'BulkUploadRecurringOrdersResult', numSuccess: number, isAsynchronous?: boolean | null, error?: { __typename?: 'CsvValidationError', errorMessages: Array<string>, lineErrors: Array<{ __typename?: 'CsvValidationLineError', lineNumber: number, cellErrors: Array<{ __typename?: 'CsvValidationCellError', columnName?: string | null, errorMessage: string }> }> } | null } };

export type BulkUploadPackageMovementsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type BulkUploadPackageMovementsMutation = { __typename?: 'Mutation', bulkUploadPackageMovements: { __typename?: 'BulkUploadPackageMovementsResult', numSuccess: number, errors: Array<{ __typename?: 'BulkUploadPackageMovementsRowError', rowNumber: number, messages: Array<string> }> } };

export type BulkUploadCallerContactsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type BulkUploadCallerContactsMutation = { __typename?: 'Mutation', bulkUploadCallerContacts: { __typename?: 'BulkUploadCallerContactsResult', numSuccess: number, isAsynchronous: boolean, errors?: Array<{ __typename?: 'BulkUploadCallerContactsRowError', rowNumber: number, messages: Array<string> }> | null } };

export type CostCenterFragmentFragment = { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null };

export type CreateCostCenterMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  name: Scalars['String'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type CreateCostCenterMutation = { __typename?: 'Mutation', createCostCenter: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type FullUpdateCostCenterMutationVariables = Exact<{
  courierId: Scalars['ID'];
  costCenterId: Scalars['ID'];
  name: Scalars['String'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type FullUpdateCostCenterMutation = { __typename?: 'Mutation', fullUpdateCostCenter: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type MarkCostCenterDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  costCenterId: Scalars['ID'];
}>;


export type MarkCostCenterDeletedMutation = { __typename?: 'Mutation', markCostCenterDeleted?: boolean | null };

export type GetCostCentersQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetCostCentersQuery = { __typename?: 'Query', costCenters: Array<{ __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type CourierFragmentFragment = { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null };

export type CourierBrandFragmentFragment = { __typename?: 'CourierBrand', id: string, courierId: string, name: string, logoUrl?: string | null, email: string, phone?: string | null, streetAddress: string, city: string, state: string, country: string, replyToEmails?: Array<string> | null, ccEmails?: Array<string> | null };

export type UpdateCourierSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  logoFile?: InputMaybe<Scalars['Upload']>;
  clearLogo?: InputMaybe<Scalars['Boolean']>;
  displayName: Scalars['String'];
  defaultTimeZoneId: Scalars['String'];
  primaryPhoneNumber: Scalars['String'];
  primaryEmail: Scalars['String'];
  primaryAddressLocationId: Scalars['ID'];
  billingStreetAddress?: InputMaybe<Scalars['String']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingZip?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCourierSettingsMutation = { __typename?: 'Mutation', updateCourierSettings?: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } | null };

export type UpdateDeliverySettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pickupPodRequirementType: PodRequirementAtStop;
  dropOffPodRequirementType: PodRequirementAtStop;
  returnPodRequirementType: PodRequirementAtStop;
}>;


export type UpdateDeliverySettingsMutation = { __typename?: 'Mutation', updateDeliverySettings?: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } | null };

export type UpdateDispatchSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  estimatedDwellTimeInSeconds: Scalars['Int'];
  additionalRequiredFields: Array<DispatcherOrderEntryAdditionalField> | DispatcherOrderEntryAdditionalField;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
  addressBookAutoFillType?: InputMaybe<AddressBookAutoFillType>;
  orderEntryDefaultAddressAutoFillType?: InputMaybe<OrderEntryDefaultAddressAutoFillType>;
  addressBookSavingType?: InputMaybe<AddressBookSavingType>;
  locationIdentifyTypesPickUp?: InputMaybe<Array<LocationIdentifyType> | LocationIdentifyType>;
  locationIdentifyTypesDropOff?: InputMaybe<Array<LocationIdentifyType> | LocationIdentifyType>;
  multiStopsOptimizationType?: InputMaybe<MultiStopsOptimizationType>;
  liveRouteSequencingType?: InputMaybe<LiveRouteSequencingType>;
  orderIdentifierColumnType?: InputMaybe<OrderIdentifierColumnType>;
}>;


export type UpdateDispatchSettingsMutation = { __typename?: 'Mutation', updateDispatchSettings?: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } | null };

export type UpdatePortalSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  priceVisibilityType: EndCustomerPriceVisibilityType;
  orderEntryType: CustomerPortalOrderEntryType;
  additionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields> | CustomerPortalAdditionalRequiredFields;
  customerPortalNewCustomerPaymentMethodPromptType?: InputMaybe<CustomerPortalNewCustomerPaymentMethodPromptType>;
  customerPortalDeliverByTimeVisibility?: InputMaybe<CustomerPortalDeliverByTimeVisibility>;
  customerPortalNotice?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePortalSettingsMutation = { __typename?: 'Mutation', updatePortalSettings?: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } | null };

export type UpdateDriverSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  priceVisibilityType: DriverPriceVisibilityType;
  taskVisibilityType: DriverTaskVisibilityType;
  stopCompletionGuard: StopCompletionGuard;
  gpsRestrictionType?: InputMaybe<GpsRestrictionType>;
  maxDistanceToCompleteTaskInMeters?: InputMaybe<Scalars['Int']>;
  driverPayStatementVisibility?: InputMaybe<DriverPayStatementVisibility>;
}>;


export type UpdateDriverSettingsMutation = { __typename?: 'Mutation', updateDriverSettings?: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } | null };

export type UpdatePricingSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceCycleStartDate?: InputMaybe<Scalars['Date']>;
  defaultInvoicingFrequency?: InputMaybe<InvoicingFrequency>;
  defaultInvoiceTaxCodeName?: InputMaybe<Scalars['String']>;
  defaultCurrency?: InputMaybe<Scalars['String']>;
  freeWaitTimeInSeconds: Scalars['Int'];
  minimumTimeRequiredForWaitTimeSurchargeInSeconds?: InputMaybe<Scalars['Int']>;
  defaultSalesTermId?: InputMaybe<Scalars['ID']>;
  defaultPreAuthorizeAmountMinimum?: InputMaybe<Scalars['Money']>;
  defaultPreAuthorizeAmountMultiplier?: InputMaybe<Scalars['Money']>;
  orderPriceTaxDisplayType?: InputMaybe<OrderPriceTaxDisplayType>;
  multiStopPricingSequenceType?: InputMaybe<MultiStopPricingSequenceType>;
  invoiceApprovalPreconditionType?: InputMaybe<InvoiceApprovalPreconditionType>;
  invoiceOrdersInclusionType?: InputMaybe<InvoiceOrdersInclusionType>;
  dimFactor?: InputMaybe<Scalars['Float']>;
  defaultWeightBasis?: InputMaybe<WeightBasis>;
}>;


export type UpdatePricingSettingsMutation = { __typename?: 'Mutation', updatePricingSettings?: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } | null };

export type UpdateEnabledCourierCommunicationsTypesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  enabledCommunicationTypeIds: Array<CommunicationTypeId> | CommunicationTypeId;
}>;


export type UpdateEnabledCourierCommunicationsTypesMutation = { __typename?: 'Mutation', updateEnabledCourierCommunicationsTypes: Array<CommunicationTypeId | null> };

export type UpdateCourierDistanceSourceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingDistanceSource: MapApi;
}>;


export type UpdateCourierDistanceSourceMutation = { __typename?: 'Mutation', updateCourierDistanceSource: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } };

export type EnableCourierMetabaseMutationVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type EnableCourierMetabaseMutation = { __typename?: 'Mutation', enableCourierMetabase: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } };

export type CreateCourierBrandMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  logoFile?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  replyToEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  ccEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateCourierBrandMutation = { __typename?: 'Mutation', createCourierBrand: { __typename?: 'CourierBrand', id: string, courierId: string, name: string, logoUrl?: string | null, email: string, phone?: string | null, streetAddress: string, city: string, state: string, country: string, replyToEmails?: Array<string> | null, ccEmails?: Array<string> | null } };

export type FullUpdateCourierBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  courierId: Scalars['ID'];
  name: Scalars['String'];
  logoFile?: InputMaybe<Scalars['Upload']>;
  clearLogo?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  replyToEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  ccEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FullUpdateCourierBrandMutation = { __typename?: 'Mutation', fullUpdateCourierBrand: { __typename?: 'CourierBrand', id: string, courierId: string, name: string, logoUrl?: string | null, email: string, phone?: string | null, streetAddress: string, city: string, state: string, country: string, replyToEmails?: Array<string> | null, ccEmails?: Array<string> | null } };

export type DeleteCourierBrandMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteCourierBrandMutation = { __typename?: 'Mutation', deleteCourierBrand: boolean };

export type UpdateShipmentsCustomFiltersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  filters: Array<ShipmentsCustomFilterInput> | ShipmentsCustomFilterInput;
}>;


export type UpdateShipmentsCustomFiltersMutation = { __typename?: 'Mutation', updateShipmentsCustomFilters: { __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } };

export type GetCourierQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetCourierQuery = { __typename?: 'Query', courier?: { __typename?: 'Courier', enabledCommunicationTypes: Array<CommunicationTypeId>, id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, packageTypes: Array<{ __typename?: 'PackageType', id: string, courierId: string, name: string, defaultLength?: number | null, defaultWidth?: number | null, defaultHeight?: number | null, defaultWeight?: number | null, defaultWeightApplication: PackageTypeDefaultWeightApplication, category: PackageTypeCategory, enabled: boolean }>, vehicleTypes: Array<{ __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null }>, holidaySchedules: Array<{ __typename?: 'HolidaySchedule', id: string, name: string }>, customFields: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null }>, primaryLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, defaultSalesTerm?: { __typename?: 'SalesTerm', id: string, courierId: string, name: string } | null, salesTerms: Array<{ __typename?: 'SalesTerm', id: string, courierId: string, name: string }>, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null } | null };

export type GetCouriersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCouriersQuery = { __typename?: 'Query', couriers: Array<{ __typename?: 'Courier', id: string, name: string, displayName: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, isTestAccount: boolean, startDate?: any | null, customerPortalPath?: string | null, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, currencyDisplay: string, distanceUnit: DistanceUnit, weightUnit: WeightUnit, dimFactor?: number | null, defaultWeightBasis: WeightBasis, driverTaskVisibilityType: DriverTaskVisibilityType, driverPriceVisibilityType: DriverPriceVisibilityType, driverPayStatementVisibility: DriverPayStatementVisibility, customerPortalOrderEntryType: CustomerPortalOrderEntryType, endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>, estimatedDwellTimeAtStopInSeconds?: number | null, pricingDistanceSource: MapApi, pickupPodRequirementType: PodRequirementAtStop, dropOffPodRequirementType: PodRequirementAtStop, returnPodRequirementType: PodRequirementAtStop, invoiceCycleStartDate?: any | null, defaultInvoicingFrequency?: InvoicingFrequency | null, defaultPricingListId?: string | null, defaultPreAuthorizeAmountMinimum?: any | null, defaultPreAuthorizeAmountMultiplier?: any | null, defaultInvoiceTaxCodeName?: string | null, freeWaitTimeInSeconds: number, minimumTimeRequiredForWaitTimeSurchargeInSeconds?: number | null, customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, customerPortalNotice?: string | null, timeFormatPreference: TimeFormatPreference, stopCompletionGuard: StopCompletionGuard, gpsRestrictionType: GpsRestrictionType, addressBookAutoFillType: AddressBookAutoFillType, orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, addressBookSavingType: AddressBookSavingType, locationIdentifyTypesPickUp: Array<LocationIdentifyType>, locationIdentifyTypesDropOff: Array<LocationIdentifyType>, pickupCloseTimesSetting: TimeWindowSetting, maxDistanceToCompleteTaskInMeters?: number | null, orderPriceTaxDisplayType?: OrderPriceTaxDisplayType | null, multiStopPricingSequenceType: MultiStopPricingSequenceType, multiStopsOptimizationType: MultiStopsOptimizationType, liveRouteSequencingType: LiveRouteSequencingType, orderIdentifierColumnType: OrderIdentifierColumnType, invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, invoiceOrdersInclusionType: InvoiceOrdersInclusionType, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, shipmentsCustomFilters?: { __typename?: 'ShipmentsCustomFilters', filters: Array<{ __typename?: 'ShipmentsCustomFilter', name: string, endCustomerIds?: Array<string> | null, serviceTypeIds?: Array<string> | null, shipmentStatuses?: Array<ShipmentStatus> | null, excludeWordsFromNote?: Array<string> | null, driverIds?: Array<string> | null, isConfirmed?: boolean | null, isAttempted?: boolean | null, recurrenceTypes?: Array<RecurrenceType> | null }> } | null }> };

export type GetCourierBrandsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetCourierBrandsQuery = { __typename?: 'Query', courierBrands: Array<{ __typename?: 'CourierBrand', id: string, courierId: string, name: string, logoUrl?: string | null, email: string, phone?: string | null, streetAddress: string, city: string, state: string, country: string, replyToEmails?: Array<string> | null, ccEmails?: Array<string> | null }> };

export type CreateCourierTermMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  content: Scalars['String'];
}>;


export type CreateCourierTermMutation = { __typename?: 'Mutation', createCourierTerm: { __typename?: 'CourierTerm', id: string, courierId: string, name: string, content: string } };

export type GetCourierTermsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetCourierTermsQuery = { __typename?: 'Query', courierTerms: Array<{ __typename?: 'CourierTerm', id: string, name: string, content: string }> };

export type CustomRoleFragmentFragment = { __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> };

export type CreateCustomRoleMutationVariables = Exact<{
  courierId: Scalars['String'];
  name: Scalars['String'];
  parentRole: UserRoleType;
}>;


export type CreateCustomRoleMutation = { __typename?: 'Mutation', createCustomRole: { __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> } };

export type UpdateCustomRoleOverridesMutationVariables = Exact<{
  courierId: Scalars['String'];
  customRoleId: Scalars['String'];
  overrides: Array<PermissionOverrideInput> | PermissionOverrideInput;
}>;


export type UpdateCustomRoleOverridesMutation = { __typename?: 'Mutation', updateCustomRoleOverrides: { __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> } };

export type DeleteCustomRoleMutationVariables = Exact<{
  courierId: Scalars['String'];
  customRoleId: Scalars['String'];
}>;


export type DeleteCustomRoleMutation = { __typename?: 'Mutation', deleteCustomRole: boolean };

export type GetCustomRolesQueryVariables = Exact<{
  courierId: Scalars['String'];
}>;


export type GetCustomRolesQuery = { __typename?: 'Query', customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> };

export type GetAllPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPermissionsQuery = { __typename?: 'Query', allPermissions: Array<string> };

export type GetDefaultPermissionsForRoleQueryVariables = Exact<{
  role: UserRoleType;
}>;


export type GetDefaultPermissionsForRoleQuery = { __typename?: 'Query', defaultPermissionsForRole: Array<string> };

export type CustomFieldFragmentFragment = { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null };

export type CustomFieldValueFragmentFragment = { __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, valueNumber?: number | null, valueInteger?: number | null };

export type CreateCustomFieldMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  type: CustomFieldType;
  visibilityType?: InputMaybe<CustomFieldCustomerVisibilityType>;
  customerSpecificityType?: InputMaybe<CustomFieldCustomerSpecificity>;
  requirementType?: InputMaybe<CustomFieldCustomerRequirementType>;
  isVisibleToDrivers?: InputMaybe<Scalars['Boolean']>;
  choices?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderingSequenceNumber?: InputMaybe<Scalars['Int']>;
  defaultOptionIndex?: InputMaybe<Scalars['Int']>;
  minValue?: InputMaybe<Scalars['Float']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  terms?: InputMaybe<CustomFieldTermsConfigInput>;
  helperText?: InputMaybe<Scalars['String']>;
}>;


export type CreateCustomFieldMutation = { __typename?: 'Mutation', createCustomField: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } };

export type FullUpdateCustomFieldMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  visibilityType: CustomFieldCustomerVisibilityType;
  customerSpecificityType: CustomFieldCustomerSpecificity;
  requirementType: CustomFieldCustomerRequirementType;
  isVisibleToDrivers?: InputMaybe<Scalars['Boolean']>;
  choices?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderingSequenceNumber?: InputMaybe<Scalars['Int']>;
  defaultOptionIndex?: InputMaybe<Scalars['Int']>;
  minValue?: InputMaybe<Scalars['Float']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  terms?: InputMaybe<CustomFieldTermsConfigInput>;
  helperText?: InputMaybe<Scalars['String']>;
}>;


export type FullUpdateCustomFieldMutation = { __typename?: 'Mutation', fullUpdateCustomField: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } };

export type MarkCustomFieldAsDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type MarkCustomFieldAsDeletedMutation = { __typename?: 'Mutation', markCustomFieldAsDeleted: boolean };

export type GetCustomFieldsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  visibleToSelectedEndCustomerOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCustomFieldsQuery = { __typename?: 'Query', customFields: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null }> };

export type DispatchPreviewFragmentFragment = { __typename?: 'DispatchPreview', shipmentId: string, shipmentDate: any, distanceInMeters?: number | null, durationInSeconds?: number | null, distanceAdditionalInMeters?: number | null, durationAdditionalInSeconds?: number | null, remainingWorkloadInSeconds?: number | null, numCurrentTasks: number, tags: Array<DispatchPreviewTag> };

export type DispatchDriverForShipmentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  driverId: Scalars['ID'];
  orderingAlgorithmType?: InputMaybe<OrderingAlgorithmType>;
  stopIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DispatchDriverForShipmentMutation = { __typename?: 'Mutation', dispatchDriverForShipment?: string | null };

export type OptimizeRouteForDispatchMutationVariables = Exact<{
  courierId: Scalars['ID'];
  newShipmentId: Scalars['ID'];
  driverId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  stopDate?: InputMaybe<Scalars['Date']>;
  baseTime?: InputMaybe<Scalars['Timestamp']>;
  startLocationId?: InputMaybe<Scalars['ID']>;
  endLocationId?: InputMaybe<Scalars['ID']>;
  dispatchScope?: InputMaybe<DispatchScope>;
}>;


export type OptimizeRouteForDispatchMutation = { __typename?: 'Mutation', optimizeRouteForDispatch: { __typename?: 'OptimizeRouteForDispatchResult', allShipmentIdsForGroupDispatch?: Array<string> | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, shipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }> } };

export type DispatchDriverForShipmentMultiDayMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  driverId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  days: Array<DispatchStopsOnDayInput> | DispatchStopsOnDayInput;
  dispatchSource?: InputMaybe<DispatchSource>;
  dispatchPreviewSortingType?: InputMaybe<Scalars['String']>;
  dispatchPreviewSection?: InputMaybe<Scalars['String']>;
  driverRank?: InputMaybe<Scalars['Int']>;
  dispatchPreviews?: InputMaybe<Array<DispatchPreviewSaveInput> | DispatchPreviewSaveInput>;
  dispatchPageType?: InputMaybe<DispatchPageType>;
  dispatchScope?: InputMaybe<DispatchScope>;
}>;


export type DispatchDriverForShipmentMultiDayMutation = { __typename?: 'Mutation', dispatchDriverForShipmentMultiDay?: string | null };

export type BulkDispatchDriverForShipmentsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
  driverId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  dispatchedBy?: InputMaybe<Scalars['ID']>;
}>;


export type BulkDispatchDriverForShipmentsMutation = { __typename?: 'Mutation', bulkDispatchDriverForShipments: { __typename?: 'BulkDispatchResults', succeededShipmentIds: Array<string>, failedShipmentIds: Array<string> } };

export type HandOverDriverDayMutationVariables = Exact<{
  courierId: Scalars['ID'];
  sourceDriverId: Scalars['ID'];
  targetDriverId: Scalars['ID'];
  date: Scalars['Date'];
  placement: HandOverPlacement;
}>;


export type HandOverDriverDayMutation = { __typename?: 'Mutation', handOverDriverDay: { __typename?: 'HandOverResult', movedShipmentCount: number } };

export type GetDispatchPreviewsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  taskStatusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
  shipmentDate: Scalars['Date'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  workType?: InputMaybe<DriverWorkType>;
  additionalFilters?: InputMaybe<DispatchAdditionalFilters>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  payMinDate?: Scalars['Date'];
  payMaxDate?: Scalars['Date'];
  payShipmentStatuses?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  shouldFetchDriverPay?: Scalars['Boolean'];
  dailyPayMinDate?: Scalars['Date'];
  dailyPayMaxDate?: Scalars['Date'];
  dailyPayShipmentStatuses?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  shouldFetchDailyEarnings?: Scalars['Boolean'];
}>;


export type GetDispatchPreviewsQuery = { __typename?: 'Query', dispatchPreviews: Array<{ __typename?: 'DispatchPreview', shipmentId: string, shipmentDate: any, distanceInMeters?: number | null, durationInSeconds?: number | null, distanceAdditionalInMeters?: number | null, durationAdditionalInSeconds?: number | null, remainingWorkloadInSeconds?: number | null, numCurrentTasks: number, tags: Array<DispatchPreviewTag>, driver: { __typename?: 'Driver', workType: DriverWorkType, id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, shipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } } | null }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> } }>, vehicle?: { __typename?: 'Vehicle', id: string, driverId: string, transportationType: TransportationType } | null, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, driverPaySummary?: { __typename?: 'DriverPaySummary', numOrders: number, totalPay: any }, dailyEarnings: { __typename?: 'DriverPaySummary', numOrders: number, totalPay: any }, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } }> };

export type DispatchPreviewsByDriverIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  targetDate: Scalars['Date'];
  readyStatus: DispatchPreviewReadyStatus;
}>;


export type DispatchPreviewsByDriverIdQuery = { __typename?: 'Query', dispatchPreviewsByDriverId: Array<{ __typename?: 'DispatchPreview', shipmentId: string, shipmentDate: any, distanceInMeters?: number | null, durationInSeconds?: number | null, distanceAdditionalInMeters?: number | null, durationAdditionalInSeconds?: number | null, remainingWorkloadInSeconds?: number | null, numCurrentTasks: number, tags: Array<DispatchPreviewTag>, shipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, orderGroupOverview?: { __typename?: 'OrderGroupOverview', assignmentGroupId?: string | null } | null, createdByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } | null, createdByEndCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } | null, createdByEndUser?: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null, role: EndUserRoleType } | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } } }> };

export type GetShipmentAllStopDatesForGroupDispatchQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
}>;


export type GetShipmentAllStopDatesForGroupDispatchQuery = { __typename?: 'Query', shipmentById: { __typename?: 'Shipment', id: string, allStopDatesForGroupDispatch: Array<any> } };

export type DriverDailyWorkFragmentFragment = { __typename?: 'DriverDailyWork', date: any, workDurationInMinutes: number, isConsistentEvents: boolean, milesByOdometer: number, dailyRegularWorkDuration: number, dailyOvertimeWorkDuration: number };

export type DriverReportItemFragmentFragment = { __typename?: 'DriverReportItem', driverId: string, startDate: any, endDate: any, regularHourlyRate: any, overtimeHourlyRate: any, reimbursementPerMile: any, totalMilesByGPS: number, mileageReimbursementMethod: DriversMileageReimbursementMethod, numCompletedOrder: number, totalCommission: any, totalMilesByOdometer: number, totalWorkDurationInMinutes: number, regularDailyCalculatedWorkDurationInMinutes: number, overtimeDailyCalculatedWorkDurationInMinutes: number, totalWorkDurationInHours: number, regularDailyCalculatedWorkDurationInHours: number, overtimeDailyCalculatedWorkDurationInHours: number, numDaysWorked: number, wageRegular: any, wageOvertime: any, wageTotal: any, mileageReimbursement: any, wageTotalWithMileageReimbursement: any, totalPay: any, totalRevenue: any, suggestedBonus: any, workDurations: Array<{ __typename?: 'DriverDailyWork', date: any, workDurationInMinutes: number, isConsistentEvents: boolean, milesByOdometer: number, dailyRegularWorkDuration: number, dailyOvertimeWorkDuration: number }>, deductions: Array<{ __typename?: 'PayrollDeductionAmount', name: string, amountTotal: any }> };

export type DriversReportFileFragmentFragment = { __typename?: 'DriversReportFile', url: string };

export type GenerateDriversReportCsvMutationVariables = Exact<{
  courierId: Scalars['ID'];
  minDate: Scalars['Date'];
  maxDate: Scalars['Date'];
  granularity?: InputMaybe<DriverReportGranularity>;
  driverWorkTypes?: InputMaybe<Array<DriverWorkType> | DriverWorkType>;
}>;


export type GenerateDriversReportCsvMutation = { __typename?: 'Mutation', generateDriversReportCsv?: { __typename?: 'DriversReportFile', url: string } | null };

export type GenerateDriverHoursWorkedReportMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds: Array<Scalars['ID']> | Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type GenerateDriverHoursWorkedReportMutation = { __typename?: 'Mutation', generateDriverHoursWorkedReport?: { __typename?: 'DriversReportFile', url: string } | null };

export type DriverReportItemsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type DriverReportItemsQuery = { __typename?: 'Query', driverReportItems: Array<{ __typename?: 'DriverReportItem', driverId: string, startDate: any, endDate: any, regularHourlyRate: any, overtimeHourlyRate: any, reimbursementPerMile: any, totalMilesByGPS: number, mileageReimbursementMethod: DriversMileageReimbursementMethod, numCompletedOrder: number, totalCommission: any, totalMilesByOdometer: number, totalWorkDurationInMinutes: number, regularDailyCalculatedWorkDurationInMinutes: number, overtimeDailyCalculatedWorkDurationInMinutes: number, totalWorkDurationInHours: number, regularDailyCalculatedWorkDurationInHours: number, overtimeDailyCalculatedWorkDurationInHours: number, numDaysWorked: number, wageRegular: any, wageOvertime: any, wageTotal: any, mileageReimbursement: any, wageTotalWithMileageReimbursement: any, totalPay: any, totalRevenue: any, suggestedBonus: any, driver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null }, workDurations: Array<{ __typename?: 'DriverDailyWork', date: any, workDurationInMinutes: number, isConsistentEvents: boolean, milesByOdometer: number, dailyRegularWorkDuration: number, dailyOvertimeWorkDuration: number }>, deductions: Array<{ __typename?: 'PayrollDeductionAmount', name: string, amountTotal: any }> }> };

export type DriverFragmentFragment = { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null };

export type VehicleFragmentFragment = { __typename?: 'Vehicle', id: string, driverId: string, transportationType: TransportationType };

export type DriverLocationFragmentFragment = { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } };

export type BreadcrumbCurveFragmentFragment = { __typename?: 'DriverBreadcrumbCurve', locations: Array<{ __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }> };

export type DriverScheduleForDateFragmentFragment = { __typename?: 'DriverScheduleForDate', driverId: string, date: any, labels: Array<string>, emailSentAt?: any | null, confirmedAt?: any | null, hasWorkloadChanged?: boolean | null };

export type DriverScheduleTimeBlockFragmentFragment = { __typename?: 'DriverScheduleTimeBlock', start: any, end: any };

export type DriverTimeEventFragmentFragment = { __typename?: 'DriverTimeEvent', id: string, date: any, driverId: string, courierId: string, eventType: DriverTimeEventType, reason?: DriverTimeEventReason | null, odometerInMiles?: number | null, updatedBy: string, eventAt: any };

export type AssignDriverVehicleTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type AssignDriverVehicleTypeMutation = { __typename?: 'Mutation', assignDriverVehicleType?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null };

export type CreateDriverMutationVariables = Exact<{
  courierId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  speed?: InputMaybe<Scalars['Float']>;
  homeLocationId?: InputMaybe<Scalars['ID']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
  weightCapacityInPounds?: InputMaybe<Scalars['Float']>;
}>;


export type CreateDriverMutation = { __typename?: 'Mutation', createDriver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type FullUpdateDriverMutationVariables = Exact<{
  courierId: Scalars['ID'];
  fullUpdate: DriverFullUpdate;
}>;


export type FullUpdateDriverMutation = { __typename?: 'Mutation', fullUpdateDriver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type DeleteDriverMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
}>;


export type DeleteDriverMutation = { __typename?: 'Mutation', deleteDriver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type UpdateDriverAvailabilityV1MutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  isAvailable: Scalars['Boolean'];
}>;


export type UpdateDriverAvailabilityV1Mutation = { __typename?: 'Mutation', updateDriverAvailabilityV1: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type UpdateDriverBaseWorkScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  workSchedule: DriverWorkScheduleInput;
}>;


export type UpdateDriverBaseWorkScheduleMutation = { __typename?: 'Mutation', updateDriverBaseWorkSchedule: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type SetDriverScheduleOverrideMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  date: Scalars['Date'];
  isDayOff: Scalars['Boolean'];
  timeBlocks: Array<DriverScheduleTimeBlockInput> | DriverScheduleTimeBlockInput;
  labels: Array<Scalars['String']> | Scalars['String'];
}>;


export type SetDriverScheduleOverrideMutation = { __typename?: 'Mutation', setDriverScheduleOverride: { __typename?: 'DriverScheduleForDate', driverId: string, date: any, labels: Array<string>, emailSentAt?: any | null, confirmedAt?: any | null, hasWorkloadChanged?: boolean | null, timeBlocks: Array<{ __typename?: 'DriverScheduleTimeBlock', start: any, end: any }> } };

export type ModifyDriverTimeEventsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  updates: Array<DriverTimeEventUpdateInput> | DriverTimeEventUpdateInput;
  newEvent?: InputMaybe<DriverTimeEventCreateInput>;
  eventIdsToDelete: Array<Scalars['ID']> | Scalars['ID'];
  updatedBy: Scalars['ID'];
}>;


export type ModifyDriverTimeEventsMutation = { __typename?: 'Mutation', modifyDriverTimeEvents: Array<{ __typename?: 'DriverTimeEvent', id: string, date: any, driverId: string, courierId: string, eventType: DriverTimeEventType, reason?: DriverTimeEventReason | null, odometerInMiles?: number | null, updatedBy: string, eventAt: any }> };

export type SendDriverScheduleConfirmationEmailsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
  includeEmptyDrivers?: InputMaybe<Scalars['Boolean']>;
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SendDriverScheduleConfirmationEmailsMutation = { __typename?: 'Mutation', sendDriverScheduleConfirmationEmails: Array<string> };

export type UpdateDriverCompensationMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  employmentType: DriverEmploymentType;
  compensation: DriverCompensation;
  payrollPricingListId?: InputMaybe<Scalars['ID']>;
  icCompanyName?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  dontChangeTaxId?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateDriverCompensationMutation = { __typename?: 'Mutation', updateDriverCompensation: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type ChangePasswordDriverMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  password: Scalars['String'];
}>;


export type ChangePasswordDriverMutation = { __typename?: 'Mutation', changePasswordDriver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type GenerateCsvForDriversMutationVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GenerateCsvForDriversMutation = { __typename?: 'Mutation', generateCsvForDrivers: { __typename?: 'DriversCsvFile', url: string } };

export type GetBreadcrumbByDriverIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  minTime?: InputMaybe<Scalars['Timestamp']>;
  maxTime?: InputMaybe<Scalars['Timestamp']>;
  date?: InputMaybe<Scalars['Date']>;
}>;


export type GetBreadcrumbByDriverIdQuery = { __typename?: 'Query', breadcrumb: { __typename?: 'DriverBreadcrumb', driverId: string, curves: Array<{ __typename?: 'DriverBreadcrumbCurve', locations: Array<{ __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }> }> } };

export type GetDriverTasksByDriverIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  date: Scalars['Date'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
}>;


export type GetDriverTasksByDriverIdQuery = { __typename?: 'Query', driverById: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', plannedSequenceNumber?: number | null, id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, shipment: { __typename?: 'Shipment', id: string, status: ShipmentStatus, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null } | null }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> } }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type GetDriversQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<DriverSorting> | DriverSorting>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDriversQuery = { __typename?: 'Query', drivers?: { __typename?: 'DriverConnection', edges?: Array<{ __typename?: 'DriverEdge', node?: { __typename?: 'Driver', homeLocationId?: string | null, id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, baseWorkSchedule?: { __typename?: 'DriverWorkSchedule', weekDailyList: Array<{ __typename?: 'DriverScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number }> } | null, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetFleetQueryQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
  labelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  simpleSearch?: InputMaybe<Scalars['String']>;
}>;


export type GetFleetQueryQuery = { __typename?: 'Query', drivers?: { __typename?: 'DriverConnection', edges?: Array<{ __typename?: 'DriverEdge', node?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', plannedSequenceNumber?: number | null, id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> } }>, outOfOrderTasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null } | null> | null } | null };

export type GetDriverByIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  date: Scalars['Date'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
}>;


export type GetDriverByIdQuery = { __typename?: 'Query', driverById: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', completedAt?: any | null, plannedSequenceNumber?: number | null, id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, shipment: { __typename?: 'Shipment', id: string, status: ShipmentStatus, shipmentDate: any, trackingNumber: string, stops: Array<{ __typename?: 'Stop', id: string, effectiveStopDate: any }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } } | null }, artifacts: Array<{ __typename?: 'Artifact', id: string, type: ArtifactType, publicUrl?: string | null, value?: string | null, createdAt: any }>, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> } }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type FetchDriverTasksByDateAndStatusQueryVariables = Exact<{
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  payMinDate?: Scalars['Date'];
  payMaxDate?: Scalars['Date'];
  payShipmentStatuses?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  shouldFetchDriverPay?: Scalars['Boolean'];
  dailyPayMinDate?: Scalars['Date'];
  dailyPayMaxDate?: Scalars['Date'];
  dailyPayShipmentStatuses?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  shouldFetchDailyEarnings?: Scalars['Boolean'];
}>;


export type FetchDriverTasksByDateAndStatusQuery = { __typename?: 'Query', drivers?: { __typename?: 'DriverConnection', edges?: Array<{ __typename?: 'DriverEdge', node?: { __typename?: 'Driver', homeLocationId?: string | null, numRecurringStops: number, id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', completedAt?: any | null, id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, shipment: { __typename?: 'Shipment', id: string, status: ShipmentStatus }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> } }>, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, driverPaySummary?: { __typename?: 'DriverPaySummary', numOrders: number, totalPay: any }, dailyEarnings: { __typename?: 'DriverPaySummary', numOrders: number, totalPay: any }, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null } | null> | null } | null };

export type GetDriverCurrentLocationQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
}>;


export type GetDriverCurrentLocationQuery = { __typename?: 'Query', driverById: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type GetDriverTasksOnlyByDriverIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
  minDate?: InputMaybe<Scalars['Date']>;
  maxDate?: InputMaybe<Scalars['Date']>;
}>;


export type GetDriverTasksOnlyByDriverIdQuery = { __typename?: 'Query', driverById: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type GetDriverDefaultRoutingConfigurationsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds: Array<Scalars['ID']> | Scalars['ID'];
  dates: Array<Scalars['Date']> | Scalars['Date'];
}>;


export type GetDriverDefaultRoutingConfigurationsQuery = { __typename?: 'Query', driverDefaultRoutingConfigurations: Array<{ __typename?: 'DriverDefaultRoutingConfiguration', driverId: string, date: any, startLocationId?: string | null, endLocationId?: string | null, useCurrentLocationAtStart?: boolean | null, startTime?: any | null, endTime?: any | null, isWorkDay?: boolean | null, startLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, endLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type GetDriverScheduleForDateRangeQueryVariables = Exact<{
  courierId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  orderNameSearchTerm?: InputMaybe<Scalars['String']>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetDriverScheduleForDateRangeQuery = { __typename?: 'Query', driverScheduleForDateRange: { __typename?: 'DriverSchedulesResult', driverSchedules: Array<{ __typename?: 'DriverScheduleForDates', driver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null }, schedule: Array<{ __typename?: 'DriverScheduleForDate', driverId: string, date: any, labels: Array<string>, emailSentAt?: any | null, confirmedAt?: any | null, hasWorkloadChanged?: boolean | null, timeBlocks: Array<{ __typename?: 'DriverScheduleTimeBlock', start: any, end: any }>, shipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, shipmentTemplate?: { __typename?: 'ShipmentTemplate', order: { __typename?: 'Order', displayId: number, name?: string | null } } | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }> }>, completedShipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, shipmentTemplate?: { __typename?: 'ShipmentTemplate', order: { __typename?: 'Order', displayId: number, name?: string | null } } | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }> }>, shipmentTemplates: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, stopTemplates: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }>, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null }> }> }>, unassignedShipments: Array<{ __typename?: 'UnassignedShipmentsForDate', date: any, shipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } }>, shipmentTemplates: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, valueNumber?: number | null, valueInteger?: number | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null, stopTemplates: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }> }> }> } };

export type GetDriverWorkingTimesForDateQueryVariables = Exact<{
  courierId: Scalars['ID'];
  date: Scalars['Date'];
}>;


export type GetDriverWorkingTimesForDateQuery = { __typename?: 'Query', driverScheduleForDateRange: { __typename?: 'DriverSchedulesResult', driverSchedules: Array<{ __typename?: 'DriverScheduleForDates', driver: { __typename?: 'Driver', id: string }, schedule: Array<{ __typename?: 'DriverScheduleForDate', date: any, timeBlocks: Array<{ __typename?: 'DriverScheduleTimeBlock', start: any, end: any }> }> }> } };

export type GetDriverTimeEventsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type GetDriverTimeEventsQuery = { __typename?: 'Query', driverTimeEvents: Array<{ __typename?: 'DriverTimeEvent', id: string, date: any, driverId: string, courierId: string, eventType: DriverTimeEventType, reason?: DriverTimeEventReason | null, odometerInMiles?: number | null, updatedBy: string, eventAt: any }> };

export type GetDriversBasicQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetDriversBasicQuery = { __typename?: 'Query', drivers?: { __typename?: 'DriverConnection', edges?: Array<{ __typename?: 'DriverEdge', node?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, avatarDisplay?: string | null, isActive: boolean } | null } | null> | null } | null };

export type EmailTemplateGroupFragmentFragment = { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean };

export type EmailTemplateFragmentFragment = { __typename?: 'EmailTemplate', id: string, subject: string, body: string, emailTypeId: string };

export type CreateEmailTemplateGroupMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type CreateEmailTemplateGroupMutation = { __typename?: 'Mutation', createEmailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null };

export type FullUpdateEmailTemplateGroupMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type FullUpdateEmailTemplateGroupMutation = { __typename?: 'Mutation', fullUpdateEmailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null };

export type DeleteEmailTemplateGroupMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteEmailTemplateGroupMutation = { __typename?: 'Mutation', deleteEmailTemplateGroup?: boolean | null };

export type CreateEmailTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  createInput: CreateEmailTemplateInput;
}>;


export type CreateEmailTemplateMutation = { __typename?: 'Mutation', createEmailTemplate?: { __typename?: 'EmailTemplate', id: string, subject: string, body: string, emailTypeId: string } | null };

export type DeleteEmailTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteEmailTemplateMutation = { __typename?: 'Mutation', deleteEmailTemplate?: boolean | null };

export type FullUpdateEmailTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  subject: Scalars['String'];
  body: Scalars['String'];
}>;


export type FullUpdateEmailTemplateMutation = { __typename?: 'Mutation', fullUpdateEmailTemplate?: { __typename?: 'EmailTemplate', id: string, subject: string, body: string, emailTypeId: string } | null };

export type SetEmailTemplateGroupAsDefaultMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type SetEmailTemplateGroupAsDefaultMutation = { __typename?: 'Mutation', setEmailTemplateGroupAsDefault?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null };

export type UnsetDefaultEmailTemplateGroupMutationVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type UnsetDefaultEmailTemplateGroupMutation = { __typename?: 'Mutation', unsetDefaultEmailTemplateGroup?: boolean | null };

export type GetEmailTemplateGroupsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetEmailTemplateGroupsQuery = { __typename?: 'Query', emailTemplateGroups: Array<{ __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean }> };

export type GetEmailTemplatesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  emailTemplateGroupId: Scalars['ID'];
}>;


export type GetEmailTemplatesQuery = { __typename?: 'Query', emailTemplates: Array<{ __typename?: 'EmailTemplate', id: string, subject: string, body: string, emailTypeId: string }> };

export type GetEmailVariablesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  emailTypeId: Scalars['String'];
  previewOrderId?: InputMaybe<Scalars['ID']>;
}>;


export type GetEmailVariablesQuery = { __typename?: 'Query', emailVariables: Array<{ __typename?: 'EmailVariable', key: string, value: string }> };

export type EndUserFragmentFragment = { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null, role: EndUserRoleType };

export type CreateEndUserMutationVariables = Exact<{
  courierId: Scalars['String'];
  endCustomerId: Scalars['String'];
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type CreateEndUserMutation = { __typename?: 'Mutation', createEndUser: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null, role: EndUserRoleType } };

export type MarkEndUserAsDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endUserId: Scalars['ID'];
}>;


export type MarkEndUserAsDeletedMutation = { __typename?: 'Mutation', markEndUserAsDeleted: string };

export type ChangePasswordEndUserMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endUserId: Scalars['ID'];
  password: Scalars['String'];
}>;


export type ChangePasswordEndUserMutation = { __typename?: 'Mutation', changePasswordEndUser: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null, role: EndUserRoleType } };

export type GetEndUsersQueryVariables = Exact<{
  courierId: Scalars['String'];
  endCustomerIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetEndUsersQuery = { __typename?: 'Query', endUsers: Array<{ __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null, role: EndUserRoleType }> };

export type EndCustomerCommunicationFragmentFragment = { __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any };

export type SendCommunicationToEndCustomerMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId?: InputMaybe<Scalars['ID']>;
  stopId?: InputMaybe<Scalars['ID']>;
  communicationTypeId?: InputMaybe<CommunicationTypeId>;
  emailRecipientsCommaSeparated?: InputMaybe<Scalars['String']>;
}>;


export type SendCommunicationToEndCustomerMutation = { __typename?: 'Mutation', sendCommunicationToEndCustomer?: { __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any } | null };

export type SendInvoiceEmailMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceEmailSendInput: InvoiceEmailSendInput;
}>;


export type SendInvoiceEmailMutation = { __typename?: 'Mutation', sendInvoiceEmail?: { __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any } | null };

export type SendInvoiceEmailsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceEmailSendInputs: Array<InvoiceEmailSendInput> | InvoiceEmailSendInput;
}>;


export type SendInvoiceEmailsMutation = { __typename?: 'Mutation', sendInvoiceEmails?: { __typename?: 'BulkInvoiceEmailSendResults', successes?: Array<{ __typename?: 'InvoiceIdAndEmailSendPair', invoiceId: string, endCustomerCommunication: { __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any } }> | null, failures?: Array<{ __typename?: 'InvoiceIdAndEmailSendErrorPair', invoiceId: string, error?: string | null }> | null } | null };

export type SendPaymentReminderEmailsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SendPaymentReminderEmailsMutation = { __typename?: 'Mutation', sendBulkPaymentReminderEmails: { __typename?: 'BulkPaymentReminderEmailResults', successes: Array<{ __typename?: 'BulkPaymentReminderEmailSuccess', endCustomerId: string }>, failures: Array<{ __typename?: 'BulkPaymentReminderEmailFailure', endCustomerId: string, error?: string | null }>, optedOut: Array<{ __typename?: 'BulkPaymentReminderEmailOptedOut', endCustomerId: string }> } };

export type EndCustomerFragmentFragment = { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null };

export type EndCustomerListItemFragmentFragment = { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, createdAt: any, courier: { __typename?: 'Courier', id: string }, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null };

export type AssignHolidayScheduleToEndCustomerMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  holidayScheduleId?: InputMaybe<Scalars['ID']>;
}>;


export type AssignHolidayScheduleToEndCustomerMutation = { __typename?: 'Mutation', assignHolidayScheduleToEndCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type CreateEndCustomerMutationVariables = Exact<{
  courierId: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber: Scalars['String'];
  contactEmail: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  pricingListId?: InputMaybe<Scalars['ID']>;
  payrollPricingListId?: InputMaybe<Scalars['ID']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  endCustomerCreatedSource?: InputMaybe<EndCustomerCreatedSource>;
  invoicingFrequency?: InputMaybe<InvoicingFrequency>;
}>;


export type CreateEndCustomerMutation = { __typename?: 'Mutation', createEndCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type FullUpdateEndCustomerMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber: Scalars['String'];
  contactEmail: Scalars['String'];
  billingEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  payrollPricingListId?: InputMaybe<Scalars['ID']>;
  suite?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  invoicingFrequency: InvoicingFrequency;
  taxCode?: InputMaybe<Scalars['String']>;
  totalPricingMultiplier?: InputMaybe<Scalars['Money']>;
  invoicePdfTemplateId?: InputMaybe<Scalars['ID']>;
  scanRequirementType?: InputMaybe<ScanRequirement>;
  emailTemplateGroupId?: InputMaybe<Scalars['ID']>;
  preAuthorizeAmountMinimum?: InputMaybe<Scalars['Money']>;
  preAuthorizeAmountMultiplier?: InputMaybe<Scalars['Money']>;
  stopCompletionGuard?: InputMaybe<StopCompletionGuard>;
  invoiceCycleStartDate?: InputMaybe<Scalars['Date']>;
  driverQuestionListId?: InputMaybe<Scalars['ID']>;
  courierBrandId?: InputMaybe<Scalars['ID']>;
  billingStreetAddress?: InputMaybe<Scalars['String']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingZip?: InputMaybe<Scalars['String']>;
  excludeConvenienceFees?: InputMaybe<Scalars['Boolean']>;
  portalPriceVisibilityOverride?: InputMaybe<EndCustomerPriceVisibilityType>;
}>;


export type FullUpdateEndCustomerMutation = { __typename?: 'Mutation', fullUpdateEndCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, courierBrand?: { __typename?: 'CourierBrand', id: string, courierId: string, name: string, logoUrl?: string | null, email: string, phone?: string | null, streetAddress: string, city: string, state: string, country: string, replyToEmails?: Array<string> | null, ccEmails?: Array<string> | null } | null, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type UpdateEndCustomerVisibleServiceTypeIdsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  visibleServiceTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  defaultServiceTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateEndCustomerVisibleServiceTypeIdsMutation = { __typename?: 'Mutation', updateEndCustomerVisibleServiceTypeIds: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type UpdatePodEmailsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  podEmails?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdatePodEmailsMutation = { __typename?: 'Mutation', updatePodEmails: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type MergeEndCustomersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  sourceEndCustomerId: Scalars['ID'];
  targetEndCustomerId: Scalars['ID'];
}>;


export type MergeEndCustomersMutation = { __typename?: 'Mutation', mergeEndCustomers: { __typename?: 'EndCustomer', id: string } };

export type ChangePasswordEndCustomerMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  password: Scalars['String'];
}>;


export type ChangePasswordEndCustomerMutation = { __typename?: 'Mutation', changePasswordEndCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type MarkEndCustomerConfirmedAsNewMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
}>;


export type MarkEndCustomerConfirmedAsNewMutation = { __typename?: 'Mutation', markEndCustomerConfirmedAsNew: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type UpdateEnabledEndCustomerCommunicationsTypesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  enabledCommunicationTypeIds: Array<CommunicationTypeId> | CommunicationTypeId;
}>;


export type UpdateEnabledEndCustomerCommunicationsTypesMutation = { __typename?: 'Mutation', updateEnabledEndCustomerCommunicationsTypes: Array<CommunicationTypeId | null> };

export type MarkEndCustomerDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
}>;


export type MarkEndCustomerDeletedMutation = { __typename?: 'Mutation', markEndCustomerDeleted?: boolean | null };

export type UpdateEndCustomerCustomFieldsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  customFieldIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateEndCustomerCustomFieldsMutation = { __typename?: 'Mutation', updateEndCustomerCustomFields: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type UpdateEndCustomerNoteMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEndCustomerNoteMutation = { __typename?: 'Mutation', updateEndCustomerNote: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type SetEndCustomerRequiredFieldsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  additionalFields: Array<CustomerPortalAdditionalRequiredFields> | CustomerPortalAdditionalRequiredFields;
  dispatchAdditionalFields: Array<DispatcherOrderEntryAdditionalField> | DispatcherOrderEntryAdditionalField;
}>;


export type SetEndCustomerRequiredFieldsMutation = { __typename?: 'Mutation', setEndCustomerRequiredFields: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type GetOrCreateEndCustomerAccountNumberMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
}>;


export type GetOrCreateEndCustomerAccountNumberMutation = { __typename?: 'Mutation', getOrCreateEndCustomerAccountNumber?: string | null };

export type GenerateCsvForEndCustomersMutationVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GenerateCsvForEndCustomersMutation = { __typename?: 'Mutation', generateCsvForEndCustomers: { __typename?: 'EndCustomersCsvFile', url: string } };

export type BulkDeleteEndCustomersMutationVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type BulkDeleteEndCustomersMutation = { __typename?: 'Mutation', bulkDeleteEndCustomers: number };

export type UpdateEndCustomerPodRequirementMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  pickupPodRequirement?: InputMaybe<PodRequirementAtStop>;
  dropoffPodRequirement?: InputMaybe<PodRequirementAtStop>;
  returnPodRequirement?: InputMaybe<PodRequirementAtStop>;
}>;


export type UpdateEndCustomerPodRequirementMutation = { __typename?: 'Mutation', updateEndCustomerPodRequirement: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type UpdateSalesTermsForEndCustomersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: Array<EndCustomerSalesTermUpdate> | EndCustomerSalesTermUpdate;
}>;


export type UpdateSalesTermsForEndCustomersMutation = { __typename?: 'Mutation', updateSalesTermsForEndCustomers: Array<{ __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }> };

export type UpdateEndCustomerAccountStatusMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  accountStatus: EndCustomerAccountStatus;
}>;


export type UpdateEndCustomerAccountStatusMutation = { __typename?: 'Mutation', updateEndCustomerAccountStatus: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } };

export type SearchEndCustomerQueryVariables = Exact<{
  courierId: Scalars['ID'];
  searchTerm: Scalars['String'];
}>;


export type SearchEndCustomerQuery = { __typename?: 'Query', searchEndCustomer: Array<{ __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, costCenters: Array<{ __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }>, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }> };

export type GetEndCustomersQueryVariables = Exact<{
  courierId: Scalars['ID'];
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<EndCustomerSorting> | EndCustomerSorting>;
  labelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetEndCustomersQuery = { __typename?: 'Query', endCustomers: { __typename?: 'EndCustomerConnection', edges?: Array<{ __typename?: 'EndCustomerEdge', node?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, costCenters: Array<{ __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }>, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, customFields?: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null }> | null, holidaySchedule?: { __typename?: 'HolidaySchedule', id: string, name: string } | null, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, createdAt: any, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode?: string | null, institutionNumber?: string | null, transitNumber?: string | null } | null }>, courierBrand?: { __typename?: 'CourierBrand', id: string, courierId: string, name: string, logoUrl?: string | null, email: string, phone?: string | null, streetAddress: string, city: string, state: string, country: string, replyToEmails?: Array<string> | null, ccEmails?: Array<string> | null } | null, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type GetEndCustomersLengthQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetEndCustomersLengthQuery = { __typename?: 'Query', endCustomers: { __typename?: 'EndCustomerConnection', edges?: Array<{ __typename?: 'EndCustomerEdge', node?: { __typename?: 'EndCustomer', id: string } | null } | null> | null } };

export type GetEndCustomersOverviewQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetEndCustomersOverviewQuery = { __typename?: 'Query', endCustomersOverview: { __typename?: 'EndCustomersOverview', numUnconfirmedCustomerPortalEndCustomers: number } };

export type CourierHolidayFragmentFragment = { __typename?: 'CourierHoliday', id: string, name: string, recurrenceRule: string };

export type HolidayScheduleFragmentFragment = { __typename?: 'HolidaySchedule', id: string, name: string };

export type HolidayScheduleBehaviorFragmentFragment = { __typename?: 'HolidayScheduleBehavior', holidayScheduleId: string, courierHolidayId: string, behavior: HolidayBehavior, name: string, recurrenceRule: string };

export type CreateCourierHolidayMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  recurrenceRule: Scalars['String'];
}>;


export type CreateCourierHolidayMutation = { __typename?: 'Mutation', createCourierHoliday: { __typename?: 'CourierHoliday', id: string, name: string, recurrenceRule: string } };

export type UpdateCourierHolidayMutationVariables = Exact<{
  courierId: Scalars['ID'];
  courierHolidayId: Scalars['ID'];
  name: Scalars['String'];
  recurrenceRule: Scalars['String'];
}>;


export type UpdateCourierHolidayMutation = { __typename?: 'Mutation', updateCourierHoliday: { __typename?: 'CourierHoliday', id: string, name: string, recurrenceRule: string } };

export type DeleteCourierHolidayMutationVariables = Exact<{
  courierId: Scalars['ID'];
  courierHolidayId: Scalars['ID'];
}>;


export type DeleteCourierHolidayMutation = { __typename?: 'Mutation', deleteCourierHoliday: boolean };

export type CreateHolidayScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type CreateHolidayScheduleMutation = { __typename?: 'Mutation', createHolidaySchedule: { __typename?: 'HolidaySchedule', id: string, name: string } };

export type DeleteHolidayScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
}>;


export type DeleteHolidayScheduleMutation = { __typename?: 'Mutation', deleteHolidaySchedule: boolean };

export type DeleteHolidayScheduleBehaviorMutationVariables = Exact<{
  courierId: Scalars['ID'];
  courierHolidayId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
}>;


export type DeleteHolidayScheduleBehaviorMutation = { __typename?: 'Mutation', deleteHolidayScheduleBehavior: boolean };

export type UpdateHolidayScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type UpdateHolidayScheduleMutation = { __typename?: 'Mutation', updateHolidaySchedule: boolean };

export type UpsertHolidayScheduleBehaviorMutationVariables = Exact<{
  courierId: Scalars['ID'];
  courierHolidayId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
  holidayBehavior: HolidayBehavior;
}>;


export type UpsertHolidayScheduleBehaviorMutation = { __typename?: 'Mutation', upsertHolidayScheduleBehavior: boolean };

export type GetCourierHolidaysQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetCourierHolidaysQuery = { __typename?: 'Query', courierHolidays: Array<{ __typename?: 'CourierHoliday', id: string, name: string, recurrenceRule: string }> };

export type GetHolidaySchedulesQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetHolidaySchedulesQuery = { __typename?: 'Query', holidaySchedules: Array<{ __typename?: 'HolidaySchedule', id: string, name: string }> };

export type GetHolidayScheduleBehaviorsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
}>;


export type GetHolidayScheduleBehaviorsQuery = { __typename?: 'Query', holidayScheduleBehaviors: Array<{ __typename?: 'HolidayScheduleBehavior', holidayScheduleId: string, courierHolidayId: string, behavior: HolidayBehavior, name: string, recurrenceRule: string }> };

export type InvoiceFragmentFragment = { __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null };

export type InvoiceDocumentFragmentFragment = { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string };

export type InvoicePdfTemplateFragmentFragment = { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> };

export type ApproveInvoiceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type ApproveInvoiceMutation = { __typename?: 'Mutation', approveInvoice: { __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null } };

export type SyncInvoiceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type SyncInvoiceMutation = { __typename?: 'Mutation', syncInvoice: { __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null } };

export type ApproveInvoicesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ApproveInvoicesMutation = { __typename?: 'Mutation', approveInvoices: { __typename?: 'BulkInvoiceApprovalResult', approved: Array<{ __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null }>, failures: Array<{ __typename?: 'BulkInvoiceApprovalFailure', invoiceId: string, message: string }> } };

export type ForceGenerateInvoicesMutationVariables = Exact<{
  courierId: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  endCustomerIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  invoiceFrequency?: InputMaybe<InvoicingFrequency>;
  endCustomerLabelFilter?: InputMaybe<Scalars['String']>;
}>;


export type ForceGenerateInvoicesMutation = { __typename?: 'Mutation', forceGenerateInvoices: Array<{ __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null }> };

export type VoidInvoicesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type VoidInvoicesMutation = { __typename?: 'Mutation', voidInvoices: Array<{ __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null }> };

export type GenerateCsvForInvoicesMutationVariables = Exact<{
  courierId: Scalars['String'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GenerateCsvForInvoicesMutation = { __typename?: 'Mutation', generateCsvForInvoices: string };

export type GenerateAccountStatementCsvMutationVariables = Exact<{
  courierId: Scalars['String'];
  endCustomerId: Scalars['ID'];
}>;


export type GenerateAccountStatementCsvMutation = { __typename?: 'Mutation', generateAccountStatementCsv: string };

export type MarkInvoiceAsPaidManuallyMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
  markedBy: Scalars['String'];
}>;


export type MarkInvoiceAsPaidManuallyMutation = { __typename?: 'Mutation', markInvoiceAsPaidManually: Array<{ __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null }> };

export type GeneratePdfForInvoiceMutationVariables = Exact<{
  courierId: Scalars['String'];
  invoiceId: Scalars['ID'];
}>;


export type GeneratePdfForInvoiceMutation = { __typename?: 'Mutation', generatePdfForInvoice: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string } };

export type GeneratePdfForInvoicesMutationVariables = Exact<{
  courierId: Scalars['String'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GeneratePdfForInvoicesMutation = { __typename?: 'Mutation', generatePdfForInvoices: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string } };

export type PreviewInvoicePdfFromCreateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  template: InvoicePdfTemplateCreateInput;
}>;


export type PreviewInvoicePdfFromCreateMutation = { __typename?: 'Mutation', previewInvoicePdfFromCreate: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string } };

export type PreviewInvoicePdfFromUpdateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  template: InvoicePdfTemplateUpdateInput;
}>;


export type PreviewInvoicePdfFromUpdateMutation = { __typename?: 'Mutation', previewInvoicePdfFromUpdate: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string } };

export type CreateInvoicePdfTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: InvoicePdfTemplateCreateInput;
  updatedBy: Scalars['String'];
}>;


export type CreateInvoicePdfTemplateMutation = { __typename?: 'Mutation', createInvoicePdfTemplate: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } };

export type FullUpdateInvoicePdfTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: InvoicePdfTemplateUpdateInput;
  updatedBy: Scalars['String'];
}>;


export type FullUpdateInvoicePdfTemplateMutation = { __typename?: 'Mutation', fullUpdateInvoicePdfTemplate: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } };

export type DeleteInvoicePdfTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoicePdfTemplateId: Scalars['ID'];
  deletedBy: Scalars['String'];
}>;


export type DeleteInvoicePdfTemplateMutation = { __typename?: 'Mutation', deleteInvoicePdfTemplate: boolean };

export type MarkInvoicePdfTemplateAsDefaultMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoicePdfTemplateId: Scalars['ID'];
  updatedBy: Scalars['String'];
}>;


export type MarkInvoicePdfTemplateAsDefaultMutation = { __typename?: 'Mutation', markInvoicePdfTemplateAsDefault: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } };

export type GetInvoicesPaginatedQueryVariables = Exact<{
  courierId: Scalars['String'];
  endCustomerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  minEndDate?: InputMaybe<Scalars['Date']>;
  maxEndDate?: InputMaybe<Scalars['Date']>;
  minApprovedAt?: InputMaybe<Scalars['Timestamp']>;
  maxApprovedAt?: InputMaybe<Scalars['Timestamp']>;
  invoicingFrequency?: InputMaybe<Array<InputMaybe<InvoicingFrequency>> | InputMaybe<InvoicingFrequency>>;
  statuses?: InputMaybe<Array<InputMaybe<InvoiceStatus>> | InputMaybe<InvoiceStatus>>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InvoiceSorting> | InvoiceSorting>;
  paymentStatuses?: InputMaybe<Array<InputMaybe<InvoicePaymentStatus>> | InputMaybe<InvoicePaymentStatus>>;
  endCustomerLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  trackingNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  displayIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  refunded?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetInvoicesPaginatedQuery = { __typename?: 'Query', invoicesPaginated: { __typename?: 'InvoiceConnection', edges?: Array<{ __typename?: 'InvoiceEdge', node?: { __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, communications: Array<{ __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any, email?: { __typename?: 'EmailRecord', status: EmailDeliveryStatus, statusReason?: string | null } | null }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type GetInvoiceExtendedDetailQueryVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type GetInvoiceExtendedDetailQuery = { __typename?: 'Query', invoiceExtendedDetail: { __typename?: 'InvoiceExtendedDetail', amountTotal: any, invoice: { __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null }, shipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, artifacts: Array<{ __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, price: { __typename?: 'OrderPrice', total: any, taxableTotal: any, nonTaxableTotal: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, totalAfterTax: any, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, taxBreakDown?: { __typename?: 'OrderPriceTaxBreakdown', totalTaxAmount: any, taxItems: Array<{ __typename?: 'OrderPriceTaxItem', name: string, amount: any }> } | null, tripPrices: Array<{ __typename?: 'OrderPriceTripPrice', scope: PriceScope, pricingRuleDisplay: string, miles: number, amount: any }> }, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } }> } };

export type InvoicesOverviewQueryVariables = Exact<{
  courierId: Scalars['String'];
}>;


export type InvoicesOverviewQuery = { __typename?: 'Query', invoicesOverview: { __typename?: 'InvoicesOverview', numToReview: number, numUnpaid: number, numPaymentProcessing: number, numPartialPaid: number, numRefunded: number } };

export type GetInvoicePdfTemplatesPaginatedQueryVariables = Exact<{
  courierId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
}>;


export type GetInvoicePdfTemplatesPaginatedQuery = { __typename?: 'Query', invoicePdfTemplatesPaginated: { __typename?: 'InvoicePdfTemplateConnection', edges?: Array<{ __typename?: 'InvoicePdfTemplateEdge', node?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, subtotalGroupedByCustomField?: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type GetInvoicePdfTemplateSkeletonQueryVariables = Exact<{
  courierId: Scalars['String'];
}>;


export type GetInvoicePdfTemplateSkeletonQuery = { __typename?: 'Query', getInvoicePdfTemplateSkeleton: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, orderCombinationType: OrderCombinationType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, subtotalGroupedByCustomField?: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } };

export type InitiateInvoicePaymentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
  paymentInstrumentId: Scalars['ID'];
  amount: Scalars['Money'];
  idempotencyToken: Scalars['String'];
  fraudSessionId?: InputMaybe<Scalars['String']>;
  createdBy: Scalars['String'];
  emailRecipients: Array<Scalars['String']> | Scalars['String'];
}>;


export type InitiateInvoicePaymentMutation = { __typename?: 'Mutation', initiateInvoicePayment: { __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any, invoice: { __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null } } };

export type InitiateInvoicePaymentsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
  createdBy: Scalars['String'];
  baseIdempotencyToken: Scalars['String'];
}>;


export type InitiateInvoicePaymentsMutation = { __typename?: 'Mutation', initiateInvoicePayments?: { __typename?: 'BulkInvoicePaymentResult', errors?: Array<string> | null, processedPayments?: Array<{ __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any, invoice: { __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null } }> | null } | null };

export type CreateMultiInvoiceManualPaymentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  allocations: Array<InvoiceManualBulkPaymentAllocationInput> | InvoiceManualBulkPaymentAllocationInput;
  paidOn: Scalars['Date'];
  note?: InputMaybe<Scalars['String']>;
  createdBy: Scalars['String'];
}>;


export type CreateMultiInvoiceManualPaymentMutation = { __typename?: 'Mutation', createMultiInvoiceManualPayment: { __typename?: 'InvoiceManualBulkPayment', id: string, courierId: string, paidOn: any, amount: any } };

export type CreateInvoiceManualPaymentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
  amount: Scalars['Money'];
  paidOn: Scalars['Date'];
  note?: InputMaybe<Scalars['String']>;
  createdBy: Scalars['String'];
}>;


export type CreateInvoiceManualPaymentMutation = { __typename?: 'Mutation', createInvoiceManualPayment: { __typename?: 'InvoiceManualPayment', id: string, courierId: string, invoiceId: string, amount: any, paidOn: any, note?: string | null } };

export type InvoiceBalancesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type InvoiceBalancesQuery = { __typename?: 'Query', invoiceBalances: Array<{ __typename?: 'InvoiceBalance', invoiceId: string, remainingBalance: any, transfers: Array<{ __typename?: 'PaymentTransfer', id: string, displayId: number, courierId: string, endCustomerId?: string | null, amount: any, currency: string, status: PaymentTransferStatus, failureCode?: string | null, failureMessage?: string | null, refundType: PaymentTransferRefundType, createdAt: any, sourcePaymentInstrument?: { __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, createdAt: any, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode?: string | null, institutionNumber?: string | null, transitNumber?: string | null } | null } | null }>, manualPaymentsForInvoice: Array<{ __typename?: 'InvoiceManualPayment', id: string, courierId: string, invoiceId: string, amount: any, paidOn: any, note?: string | null }> }> };

export type LabelFragmentFragment = { __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null };

export type CreateLabelMutationVariables = Exact<{
  courierId: Scalars['ID'];
  entityType: LabelEntityType;
  name: Scalars['String'];
}>;


export type CreateLabelMutation = { __typename?: 'Mutation', createLabel: { __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null } };

export type AssignLabelsToEntitiesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  entityType: LabelEntityType;
  labelIds: Array<Scalars['ID']> | Scalars['ID'];
  entityIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AssignLabelsToEntitiesMutation = { __typename?: 'Mutation', assignLabelsToEntities: number };

export type UnassignLabelsFromEntityMutationVariables = Exact<{
  courierId: Scalars['ID'];
  entityType: LabelEntityType;
  labelIds: Array<Scalars['ID']> | Scalars['ID'];
  entityId: Scalars['ID'];
}>;


export type UnassignLabelsFromEntityMutation = { __typename?: 'Mutation', unassignLabelsFromEntity: number };

export type GetLabelsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  entityType: LabelEntityType;
}>;


export type GetLabelsQuery = { __typename?: 'Query', labels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> };

export type LinkedAccountFragmentFragment = { __typename?: 'LinkedAccount', id: string, courierId: string, remoteId: string, name?: string | null, provider: ApiProvider, accountExpiresAt?: any | null, isValid: boolean };

export type UpsertLinkedAccountMutationVariables = Exact<{
  courierId: Scalars['ID'];
  remoteId: Scalars['String'];
  provider: ApiProvider;
  refreshToken?: InputMaybe<Scalars['String']>;
  accessToken: Scalars['String'];
  accessTokenExpiresInSeconds?: InputMaybe<Scalars['Int']>;
  refreshTokenExpiresInSeconds?: InputMaybe<Scalars['Int']>;
}>;


export type UpsertLinkedAccountMutation = { __typename?: 'Mutation', upsertLinkedAccount: { __typename?: 'LinkedAccount', id: string, courierId: string, remoteId: string, name?: string | null, provider: ApiProvider, accountExpiresAt?: any | null, isValid: boolean } };

export type DeleteLinkedAccountMutationVariables = Exact<{
  courierId: Scalars['String'];
  id: Scalars['ID'];
}>;


export type DeleteLinkedAccountMutation = { __typename?: 'Mutation', deleteLinkedAccount: boolean };

export type GetLinkedAccountsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetLinkedAccountsQuery = { __typename?: 'Query', linkedAccounts: Array<{ __typename?: 'LinkedAccount', isValidAndFresh: boolean, id: string, courierId: string, remoteId: string, name?: string | null, provider: ApiProvider, accountExpiresAt?: any | null, isValid: boolean }> };

export type LinkedAccountsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type LinkedAccountsQuery = { __typename?: 'Query', linkedAccounts: Array<{ __typename?: 'LinkedAccount', isValidAndFresh: boolean, id: string, courierId: string, remoteId: string, name?: string | null, provider: ApiProvider, accountExpiresAt?: any | null, isValid: boolean }> };

export type AssignShipmentsToLiveRouteMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
  targetRouteTemplateId: Scalars['ID'];
  targetDate: Scalars['Date'];
}>;


export type AssignShipmentsToLiveRouteMutation = { __typename?: 'Mutation', assignShipmentsToLiveRoute: { __typename?: 'LiveRoute', id: string, courierId: string, date: any, routeTemplateId?: string | null, driverId?: string | null } };

export type LngLatFragmentFragment = { __typename?: 'LngLat', lng?: number | null, lat?: number | null };

export type LocationFragmentFragment = { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } };

export type TripDistanceOverrideFragmentFragment = { __typename?: 'TripDistanceOverride', id: string, courierId: string, sourceLocationId: string, destinationLocationId: string, distanceInMeters: number, durationInSeconds?: number | null, overriddenBy: string, createdAt: string, updatedAt: string, originLocation: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }, destinationLocation: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type GetOrCreateLocationsMutationVariables = Exact<{
  googlePlaceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetOrCreateLocationsMutation = { __typename?: 'Mutation', getOrCreateLocations: Array<{ __typename?: 'LocationResult', location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type GetOrCreateLocationsWithOverviewMutationVariables = Exact<{
  googlePlaceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetOrCreateLocationsWithOverviewMutation = { __typename?: 'Mutation', getOrCreateLocationsWithOverview: { __typename?: 'LocationsResultOverview', totalDistanceInMiles?: number | null, locations: Array<{ __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }> } };

export type GetOrCreateLocationFromCoordinateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  lngLat: LngLatInput;
  createdBy: Scalars['String'];
}>;


export type GetOrCreateLocationFromCoordinateMutation = { __typename?: 'Mutation', getOrCreateLocationFromCoordinate: { __typename?: 'LocationResult', location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type FullUpdateLocationMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  streetAddress: Scalars['String'];
  city: Scalars['String'];
}>;


export type FullUpdateLocationMutation = { __typename?: 'Mutation', fullUpdateLocation: { __typename?: 'LocationResult', location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type OverrideTripDistanceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  sourceLocationId: Scalars['ID'];
  destinationLocationId: Scalars['ID'];
  distanceInMeters: Scalars['Float'];
  durationInSeconds?: InputMaybe<Scalars['Float']>;
}>;


export type OverrideTripDistanceMutation = { __typename?: 'Mutation', overrideTripDistance: { __typename?: 'TripDistanceOverride', id: string, courierId: string, sourceLocationId: string, destinationLocationId: string, distanceInMeters: number, durationInSeconds?: number | null, overriddenBy: string, createdAt: string, updatedAt: string, originLocation: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }, destinationLocation: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } } };

export type RemoveTripDistanceOverrideMutationVariables = Exact<{
  courierId: Scalars['ID'];
  sourceLocationId: Scalars['ID'];
  destinationLocationId: Scalars['ID'];
}>;


export type RemoveTripDistanceOverrideMutation = { __typename?: 'Mutation', removeTripDistanceOverride: boolean };

export type TripDistanceOverridesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  after?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TripDistanceOverridesPaginatedQuery = { __typename?: 'Query', tripDistanceOverridesPaginated: { __typename?: 'TripDistanceOverrideConnection', edges?: Array<{ __typename?: 'TripDistanceOverrideEdge', node?: { __typename?: 'TripDistanceOverride', id: string, courierId: string, sourceLocationId: string, destinationLocationId: string, distanceInMeters: number, durationInSeconds?: number | null, overriddenBy: string, createdAt: string, updatedAt: string, originLocation: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }, destinationLocation: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type RoutingNodeFragmentFragment = { __typename?: 'RoutingNode', id: string, jobId: string, isNewAssignment: boolean, assignedRouteSequenceNumber?: number | null };

export type RoutingVehicleFragmentFragment = { __typename?: 'RoutingVehicle', id: string, jobId: string, startTime?: any | null, endTime?: any | null, useDriverCurrentLocationAtStart: boolean, startLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, endLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null };

export type RoutingDayResultFragmentFragment = { __typename?: 'RoutingDayResult', date: any, jobId: string, vehicles: Array<{ __typename?: 'RoutingVehicle', id: string, jobId: string, startTime?: any | null, endTime?: any | null, useDriverCurrentLocationAtStart: boolean, startLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, endLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type RoutingJobFragmentFragment = { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string>, canceledBy?: string | null, cancelDescription?: string | null };

export type RoutingNodeEtaFragmentFragment = { __typename?: 'RoutingNodeEta', routingNodeId: string, eta: any, isLikelyLate: boolean, isLikelyEarly: boolean, likelyLateByInMinutes?: number | null, likelyEarlyByInMinutes?: number | null };

export type CreateRoutingJobMutationVariables = Exact<{
  courierId: Scalars['ID'];
  jobCreate: RoutingJobCreate;
  vehicleCreates: Array<RoutingVehicleCreate> | RoutingVehicleCreate;
}>;


export type CreateRoutingJobMutation = { __typename?: 'Mutation', createRoutingJob: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string>, canceledBy?: string | null, cancelDescription?: string | null } };

export type ApproveRoutingJobMutationVariables = Exact<{
  courierId: Scalars['ID'];
  jobId: Scalars['ID'];
  approvedBy: Scalars['String'];
}>;


export type ApproveRoutingJobMutation = { __typename?: 'Mutation', approveRoutingJob: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string>, canceledBy?: string | null, cancelDescription?: string | null } };

export type CancelRoutingJobMutationVariables = Exact<{
  courierId: Scalars['ID'];
  jobId: Scalars['ID'];
  canceledBy: Scalars['String'];
}>;


export type CancelRoutingJobMutation = { __typename?: 'Mutation', cancelRoutingJob: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string>, canceledBy?: string | null, cancelDescription?: string | null } };

export type ReplaceRoutingVehicleSequenceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  routingVehicleId: Scalars['ID'];
  routingNodeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReplaceRoutingVehicleSequenceMutation = { __typename?: 'Mutation', replaceRoutingVehicleSequence: Array<{ __typename?: 'RoutingNode', id: string, jobId: string, isNewAssignment: boolean, assignedRouteSequenceNumber?: number | null }> };

export type TransferShipmentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  targetDriverId: Scalars['ID'];
  routingJobId: Scalars['ID'];
}>;


export type TransferShipmentMutation = { __typename?: 'Mutation', transferShipment: Array<{ __typename?: 'RoutingNode', id: string, jobId: string, isNewAssignment: boolean, assignedRouteSequenceNumber?: number | null }> };

export type RoutingJobsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type RoutingJobsQuery = { __typename?: 'Query', routingJobs: { __typename?: 'RoutingJobConnection', edges?: Array<{ __typename?: 'RoutingJobEdge', node?: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string>, canceledBy?: string | null, cancelDescription?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type RoutingJobByIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type RoutingJobByIdQuery = { __typename?: 'Query', routingJobById: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string>, canceledBy?: string | null, cancelDescription?: string | null, results?: Array<{ __typename?: 'RoutingDayResult', date: any, jobId: string, vehicles: Array<{ __typename?: 'RoutingVehicle', id: string, jobId: string, startTime?: any | null, endTime?: any | null, useDriverCurrentLocationAtStart: boolean, driver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null }, nodes: Array<{ __typename?: 'RoutingNode', id: string, jobId: string, isNewAssignment: boolean, assignedRouteSequenceNumber?: number | null, stop?: { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, shipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, order: { __typename?: 'Order', id: string } }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> } | null }>, startLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, endLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> }> | null } };

export type PreviewEtaForRoutingVehicleQueryVariables = Exact<{
  courierId: Scalars['ID'];
  routingVehicleId: Scalars['ID'];
}>;


export type PreviewEtaForRoutingVehicleQuery = { __typename?: 'Query', previewEtaForRoutingVehicle: Array<{ __typename?: 'RoutingNodeEta', routingNodeId: string, eta: any, isLikelyLate: boolean, isLikelyEarly: boolean, likelyLateByInMinutes?: number | null, likelyEarlyByInMinutes?: number | null }> };

export type OrderAttachmentFragmentFragment = { __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string };

export type CreateOrderAttachmentsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderAttachmentUploads: Array<OrderAttachmentCreate> | OrderAttachmentCreate;
}>;


export type CreateOrderAttachmentsMutation = { __typename?: 'Mutation', createOrderAttachments: Array<{ __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string }> };

export type AttachAnswerPhotoToOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  driverAnswerId: Scalars['ID'];
}>;


export type AttachAnswerPhotoToOrderMutation = { __typename?: 'Mutation', attachAnswerPhotoToOrder: { __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string } };

export type BuildOrderGroupsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderGroupBuilderId: Scalars['ID'];
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  assignmentGroups?: InputMaybe<Array<OrderGroupAssignmentGroupInput> | OrderGroupAssignmentGroupInput>;
}>;


export type BuildOrderGroupsMutation = { __typename?: 'Mutation', buildOrderGroups: Array<{ __typename?: 'OrderGroup', id: string, displayId: number }> };

export type GetOrderGroupQueryVariables = Exact<{
  courierId: Scalars['ID'];
  orderGroupId: Scalars['ID'];
}>;


export type GetOrderGroupQuery = { __typename?: 'Query', orderGroup?: { __typename?: 'OrderGroupDetail', isSequenced: boolean, orderGroup: { __typename?: 'OrderGroup', id: string, displayId: number, createdAt: any }, orderGroupBuilder?: { __typename?: 'OrderGroupBuilder', id: string, name: string } | null, members: Array<{ __typename?: 'OrderGroupMemberDetail', label: string, sequenceNumber?: number | null, membershipType: OrderGroupMembershipType, assignmentGroupId?: string | null, order: { __typename?: 'Order', id: string, displayId: number, dispatchableType: DispatchableType, billableType: BillableType, endCustomer: { __typename?: 'EndCustomer', id: string, companyName?: string | null, contactEmail: string, firstName?: string | null }, shipment?: { __typename?: 'Shipment', id: string, trackingNumber: string, status: ShipmentStatus, isClosed: boolean, isForceCompleted: boolean, driverConfirmedAt?: any | null, completionReason?: ShipmentCompletionReason | null, holdStatus?: HoldStatus | null, routingJobId?: string | null, routingJob?: { __typename?: 'RoutingJob', id: string, status: RoutingJobStatus } | null, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string } | null, stops: Array<{ __typename?: 'Stop', id: string, type: ShipmentStopType, streetAddress: string }> } | null } }> } | null };

export type OrderFragmentFragment = { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null };

export type AssignHolidayScheduleToRecurringOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  holidayScheduleId?: InputMaybe<Scalars['ID']>;
}>;


export type AssignHolidayScheduleToRecurringOrderMutation = { __typename?: 'Mutation', assignHolidayScheduleToRecurringOrder?: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } | null };

export type OverrideOrderLegDistanceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  originStopId: Scalars['ID'];
  destinationStopId: Scalars['ID'];
  distanceInMeters: Scalars['Float'];
}>;


export type OverrideOrderLegDistanceMutation = { __typename?: 'Mutation', overrideOrderLegDistance: { __typename?: 'TripDistanceOverride', id: string, sourceLocationId: string, destinationLocationId: string, distanceInMeters: number } };

export type ClearOrderLegDistanceOverrideMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  originStopId: Scalars['ID'];
  destinationStopId: Scalars['ID'];
}>;


export type ClearOrderLegDistanceOverrideMutation = { __typename?: 'Mutation', clearOrderLegDistanceOverride: boolean };

export type FullUpdateOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  shipmentUpdates: Array<ShipmentFullUpdate> | ShipmentFullUpdate;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  caller?: InputMaybe<Scalars['String']>;
  callerPhone?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  customFieldValuesToReplace?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  updatedBy?: InputMaybe<Scalars['String']>;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requiredDocumentTypes?: InputMaybe<Array<DocumentType> | DocumentType>;
  warnedDocumentTypes?: InputMaybe<Array<DocumentType> | DocumentType>;
}>;


export type FullUpdateOrderMutation = { __typename?: 'Mutation', fullUpdateOrder: { __typename?: 'Order', id: string, courierId: string, displayId: number, recurrenceType: RecurrenceType, endCustomerReferenceNumber?: string | null, caller?: string | null, costCenterId?: string | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type CreateRecurringOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderTypeId?: InputMaybe<Scalars['ID']>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  acquisitionType: OrderAcquisitionType;
  recurrenceDetail: RecurrenceDetailInput;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  caller?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  shipmentTemplates: Array<ShipmentTemplateCreateInput> | ShipmentTemplateCreateInput;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  name?: InputMaybe<Scalars['String']>;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateRecurringOrderMutation = { __typename?: 'Mutation', createRecurringOrder?: string | null };

export type FullUpdateRecurringOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  recurrenceDetail: RecurrenceDetailInput;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  shipmentTemplateUpdates: Array<ShipmentTemplateFullUpdate> | ShipmentTemplateFullUpdate;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  customFieldValuesToReplace?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
}>;


export type FullUpdateRecurringOrderMutation = { __typename?: 'Mutation', fullUpdateRecurringOrder: { __typename?: 'Order', id: string } };

export type ForceInstantiateRecurringOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
  targetDate: Scalars['Date'];
}>;


export type ForceInstantiateRecurringOrdersMutation = { __typename?: 'Mutation', forceInstantiateRecurringOrders: Array<{ __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }> };

export type GetOrForceInstantiateRecurringOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
  targetDate: Scalars['Date'];
  shouldUseTemplateDriver: Scalars['Boolean'];
}>;


export type GetOrForceInstantiateRecurringOrdersMutation = { __typename?: 'Mutation', getOrForceInstantiateRecurringOrders: Array<{ __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, shipment?: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }> };

export type GenerateOrdersPdfMutationVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  numPackages?: InputMaybe<Scalars['Int']>;
  useOrderNumPackages?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateOrdersPdfMutation = { __typename?: 'Mutation', generateOrdersPdf: { __typename?: 'OrdersFile', url: string } };

export type RecordOrderClickMutationVariables = Exact<{
  input: RecordOrderClickInput;
}>;


export type RecordOrderClickMutation = { __typename?: 'Mutation', recordOrderClick: boolean };

export type CreateLiveOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  branchId?: InputMaybe<Scalars['ID']>;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  acquisitionType: OrderAcquisitionType;
  shipments: Array<ShipmentCreateInput> | ShipmentCreateInput;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  caller?: InputMaybe<Scalars['String']>;
  callerPhone?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  pricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  priceOverride?: InputMaybe<Scalars['Money']>;
  priceOverrideBreakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput> | PriceOverrideBreakdownItemInput>;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  endUserId?: InputMaybe<Scalars['ID']>;
  originalOrderId?: InputMaybe<Scalars['ID']>;
  paymentInstrumentId?: InputMaybe<Scalars['ID']>;
  fraudSessionId?: InputMaybe<Scalars['String']>;
  requiredDocumentTypes?: InputMaybe<Array<DocumentType> | DocumentType>;
  warnedDocumentTypes?: InputMaybe<Array<DocumentType> | DocumentType>;
  orderGroupBuildDetail?: InputMaybe<OrderGroupBuildDetailInput>;
}>;


export type CreateLiveOrderMutation = { __typename?: 'Mutation', createLiveOrder: { __typename?: 'Order', endCustomer: { __typename?: 'EndCustomer', companyName?: string | null }, shipment?: { __typename?: 'Shipment', id: string, trackingNumber: string } | null } };

export type FinalizeOrderPricingMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type FinalizeOrderPricingMutation = { __typename?: 'Mutation', finalizeOrderPricing: number };

export type UnfinalizeOrderPricingMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type UnfinalizeOrderPricingMutation = { __typename?: 'Mutation', unfinalizeOrderPricing: number };

export type GenerateBillOfLadingPdfMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GenerateBillOfLadingPdfMutation = { __typename?: 'Mutation', generateBillOfLadingPdf: Array<{ __typename?: 'BillOfLadingDoc', pdfUrl: string, fileId?: string | null, orderId: string }> };

export type TriggerRecurringOrderGenerationMutationVariables = Exact<{
  courierId: Scalars['ID'];
  minDate: Scalars['Date'];
  maxDate: Scalars['Date'];
}>;


export type TriggerRecurringOrderGenerationMutation = { __typename?: 'Mutation', triggerRecurringOrderGeneration: string };

export type GenerateCsvForRecurringOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GenerateCsvForRecurringOrdersMutation = { __typename?: 'Mutation', generateCsvForRecurringOrders: { __typename?: 'OrdersCsvFile', url: string } };

export type MergeOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MergeOrdersMutation = { __typename?: 'Mutation', mergeOrders: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, shipment?: { __typename?: 'Shipment', id: string, trackingNumber: string } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } };

export type UpdateOrderLabelsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  addLabelIds: Array<Scalars['ID']> | Scalars['ID'];
  removeLabelIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateOrderLabelsMutation = { __typename?: 'Mutation', updateOrderLabels: number };

export type UpdateOrderInvoiceDateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  invoiceDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateOrderInvoiceDateMutation = { __typename?: 'Mutation', updateOrderInvoiceDate: { __typename?: 'Order', id: string } };

export type BulkUpdateOrderInvoiceDateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  invoiceDate?: InputMaybe<Scalars['Date']>;
}>;


export type BulkUpdateOrderInvoiceDateMutation = { __typename?: 'Mutation', bulkUpdateOrderInvoiceDate: Array<{ __typename?: 'Order', id: string }> };

export type GetOrderAdditionalInfoQueryVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type GetOrderAdditionalInfoQuery = { __typename?: 'Query', orderAdditionalInfo: Array<{ __typename?: 'KeyValuePair', key: string, value: string }> };

export type PackageTypeFragmentFragment = { __typename?: 'PackageType', id: string, courierId: string, name: string, defaultLength?: number | null, defaultWidth?: number | null, defaultHeight?: number | null, defaultWeight?: number | null, defaultWeightApplication: PackageTypeDefaultWeightApplication, category: PackageTypeCategory, enabled: boolean };

export type FullUpdatePackageTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  defaultLength?: InputMaybe<Scalars['Float']>;
  defaultWidth?: InputMaybe<Scalars['Float']>;
  defaultHeight?: InputMaybe<Scalars['Float']>;
  defaultWeight?: InputMaybe<Scalars['Float']>;
  defaultWeightApplication?: InputMaybe<PackageTypeDefaultWeightApplication>;
  category?: InputMaybe<PackageTypeCategory>;
  enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type FullUpdatePackageTypeMutation = { __typename?: 'Mutation', fullUpdatePackageType: { __typename?: 'PackageType', id: string, courierId: string, name: string, defaultLength?: number | null, defaultWidth?: number | null, defaultHeight?: number | null, defaultWeight?: number | null, defaultWeightApplication: PackageTypeDefaultWeightApplication, category: PackageTypeCategory, enabled: boolean } };

export type CreatePackageTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  defaultLength?: InputMaybe<Scalars['Float']>;
  defaultWidth?: InputMaybe<Scalars['Float']>;
  defaultHeight?: InputMaybe<Scalars['Float']>;
  defaultWeight?: InputMaybe<Scalars['Float']>;
  defaultWeightApplication?: InputMaybe<PackageTypeDefaultWeightApplication>;
  category?: InputMaybe<PackageTypeCategory>;
  enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreatePackageTypeMutation = { __typename?: 'Mutation', createPackageType: { __typename?: 'PackageType', id: string, courierId: string, name: string, defaultLength?: number | null, defaultWidth?: number | null, defaultHeight?: number | null, defaultWeight?: number | null, defaultWeightApplication: PackageTypeDefaultWeightApplication, category: PackageTypeCategory, enabled: boolean } };

export type DeletePackageTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeletePackageTypeMutation = { __typename?: 'Mutation', deletePackageType: { __typename?: 'PackageType', id: string, courierId: string, name: string, defaultLength?: number | null, defaultWidth?: number | null, defaultHeight?: number | null, defaultWeight?: number | null, defaultWeightApplication: PackageTypeDefaultWeightApplication, category: PackageTypeCategory, enabled: boolean } };

export type PageInfoFragmentFragment = { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null };

export type PaymentTransferFragmentFragment = { __typename?: 'PaymentTransfer', id: string, displayId: number, courierId: string, endCustomerId?: string | null, amount: any, currency: string, status: PaymentTransferStatus, failureCode?: string | null, failureMessage?: string | null, refundType: PaymentTransferRefundType, createdAt: any };

export type PaymentInstrumentFragmentFragment = { __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, createdAt: any, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode?: string | null, institutionNumber?: string | null, transitNumber?: string | null } | null };

export type CreditCardDetailFragmentFragment = { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string };

export type BankAccountDetailFragmentFragment = { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode?: string | null, institutionNumber?: string | null, transitNumber?: string | null };

export type InvoicePaymentFragmentFragment = { __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any };

export type PaymentSettlementFragmentFragment = { __typename?: 'PaymentSettlement', id: string, remoteId: string, courierId: string, merchantId: string, status: SettlementStatus, providerCreatedAt: any, netAmount: any, totalAmount: any, totalFee: any, totalFeeIncludingSubscriptionBilling: any, type: string };

export type InvoiceManualPaymentFragmentFragment = { __typename?: 'InvoiceManualPayment', id: string, courierId: string, invoiceId: string, amount: any, paidOn: any, note?: string | null };

export type FeeTransferFragmentFragment = { __typename?: 'FeeTransfer', id: string, parentPaymentTransferId?: string | null, courierId: string, amount: any, currency: string, remoteId?: string | null, remoteState?: string | null, remoteParentTransferId?: string | null, settlementId?: string | null, createdAt: any };

export type PaymentAdditionalFeeFragmentFragment = { __typename?: 'PaymentAdditionalFee', id: string, courierId: string, paymentTransferId: string, paymentAdditionalFeeRuleId: string, amount: any, status: PaymentAdditionalFeeStatus, createdAt: any };

export type CreatePaymentInstrumentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  token: Scalars['String'];
  source: PaymentInstrumentAcquisitionSource;
  createdBy: Scalars['String'];
}>;


export type CreatePaymentInstrumentMutation = { __typename?: 'Mutation', createPaymentInstrument: { __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, createdAt: any, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode?: string | null, institutionNumber?: string | null, transitNumber?: string | null } | null } };

export type DeletePaymentInstrumentMutationVariables = Exact<{
  paymentInstrumentId: Scalars['ID'];
  courierId: Scalars['ID'];
}>;


export type DeletePaymentInstrumentMutation = { __typename?: 'Mutation', deletePaymentInstrument: boolean };

export type UpdatePaymentInstrumentIsDefaultMutationVariables = Exact<{
  courierId: Scalars['ID'];
  paymentInstrumentId: Scalars['ID'];
  isDefault: Scalars['Boolean'];
}>;


export type UpdatePaymentInstrumentIsDefaultMutation = { __typename?: 'Mutation', updatePaymentInstrumentIsDefault: { __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, createdAt: any, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode?: string | null, institutionNumber?: string | null, transitNumber?: string | null } | null } };

export type ForceSendReceiptMutationVariables = Exact<{
  courierId: Scalars['ID'];
  paymentTransferId: Scalars['ID'];
  emailRecipients: Array<Scalars['String']> | Scalars['String'];
}>;


export type ForceSendReceiptMutation = { __typename?: 'Mutation', forceSendReceipt: string };

export type PaymentTransfersPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  statusFilter?: InputMaybe<Array<PaymentTransferStatus> | PaymentTransferStatus>;
  refundTypes?: InputMaybe<Array<PaymentTransferRefundType> | PaymentTransferRefundType>;
  invoiceIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  settlementIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit: Scalars['Int'];
  after: Scalars['Int'];
}>;


export type PaymentTransfersPaginatedQuery = { __typename?: 'Query', paymentTransfersPaginated: { __typename?: 'PaymentTransferConnection', edges?: Array<{ __typename?: 'PaymentTransferEdge', node?: { __typename?: 'PaymentTransfer', id: string, displayId: number, courierId: string, endCustomerId?: string | null, amount: any, currency: string, status: PaymentTransferStatus, failureCode?: string | null, failureMessage?: string | null, refundType: PaymentTransferRefundType, createdAt: any, sourcePaymentInstrument?: { __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, createdAt: any, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode?: string | null, institutionNumber?: string | null, transitNumber?: string | null } | null } | null, invoicePayments: Array<{ __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any, invoice: { __typename?: 'Invoice', id: string, displayId: number, invoiceNumber: string, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, approvedAt?: any | null, createdAt: any, refundedAt?: any | null } }>, parentPaymentTransfer?: { __typename?: 'PaymentTransfer', id: string, displayId: number, courierId: string, endCustomerId?: string | null, amount: any, currency: string, status: PaymentTransferStatus, failureCode?: string | null, failureMessage?: string | null, refundType: PaymentTransferRefundType, createdAt: any } | null, endCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null } | null, paymentAdditionalFees: Array<{ __typename?: 'PaymentAdditionalFee', id: string, courierId: string, paymentTransferId: string, paymentAdditionalFeeRuleId: string, amount: any, status: PaymentAdditionalFeeStatus, createdAt: any }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PaymentInstrumentsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PaymentInstrumentsQuery = { __typename?: 'Query', paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, createdAt: any, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode?: string | null, institutionNumber?: string | null, transitNumber?: string | null } | null }> };

export type PaymentSettlementsPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  after: Scalars['Int'];
}>;


export type PaymentSettlementsPaginatedQuery = { __typename?: 'Query', paymentSettlementsPaginated: { __typename?: 'PaymentSettlementConnection', edges?: Array<{ __typename?: 'PaymentSettlementEdge', node?: { __typename?: 'PaymentSettlement', id: string, remoteId: string, courierId: string, merchantId: string, status: SettlementStatus, providerCreatedAt: any, netAmount: any, totalAmount: any, totalFee: any, totalFeeIncludingSubscriptionBilling: any, type: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type FeeTransfersPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  settlementIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit: Scalars['Int'];
  after: Scalars['Int'];
}>;


export type FeeTransfersPaginatedQuery = { __typename?: 'Query', feeTransfersPaginated: { __typename?: 'FeeTransferConnection', edges?: Array<{ __typename?: 'FeeTransferEdge', node?: { __typename?: 'FeeTransfer', id: string, parentPaymentTransferId?: string | null, courierId: string, amount: any, currency: string, remoteId?: string | null, remoteState?: string | null, remoteParentTransferId?: string | null, settlementId?: string | null, createdAt: any, parentPaymentTransfer?: { __typename?: 'PaymentTransfer', id: string, displayId: number, courierId: string, endCustomerId?: string | null, amount: any, currency: string, status: PaymentTransferStatus, failureCode?: string | null, failureMessage?: string | null, refundType: PaymentTransferRefundType, createdAt: any } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type InvoicePaymentFieldsFragment = { __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any };

export type InvoiceBalanceFieldsFragment = { __typename?: 'InvoiceBalance', invoiceId: string, remainingBalance: any };

export type InitiateInvoiceRefundMutationVariables = Exact<{
  courierId: Scalars['ID'];
  parentPaymentTransferId: Scalars['ID'];
  amount: Scalars['Money'];
  idempotencyToken: Scalars['String'];
  createdBy: Scalars['String'];
}>;


export type InitiateInvoiceRefundMutation = { __typename?: 'Mutation', initiateInvoiceRefund: { __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any } };

export type GetInvoiceBalancesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetInvoiceBalancesQuery = { __typename?: 'Query', invoiceBalances: Array<{ __typename?: 'InvoiceBalance', invoiceId: string, remainingBalance: any }> };

export type DriverPayEntryFragmentFragment = { __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus };

export type PayPeriodFragmentFragment = { __typename?: 'PayPeriod', startDate: any, endDate: any };

export type PayrollReportFileFragmentFragment = { __typename?: 'PayrollReportFile', url: string };

export type PayrollSettingFragmentFragment = { __typename?: 'PayrollSetting', courierId: string, defaultCommission: any, payPeriodType: PayPeriodType, payPeriodStartDate?: any | null, ordersInclusionType: PayrollOrdersInclusionType, driverPayExportType: DriverPayExportType };

export type OrderPayBreakDownFragmentFragment = { __typename?: 'OrderPayBreakDown', total: any };

export type OrderPayBreakDownItemFragmentFragment = { __typename?: 'OrderPayBreakDownItem', name: string, description?: string | null, amount: any };

export type PayrollDeductionRuleFragmentFragment = { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, startDate?: any | null, endDate?: any | null, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> };

export type UpsertPayrollSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  defaultCommission: Scalars['Float'];
  payPeriodType: PayPeriodType;
  payPeriodStartDate?: InputMaybe<Scalars['Date']>;
  ordersInclusionType?: InputMaybe<PayrollOrdersInclusionType>;
  driverPayExportType?: InputMaybe<DriverPayExportType>;
}>;


export type UpsertPayrollSettingsMutation = { __typename?: 'Mutation', upsertPayrollSettings: { __typename?: 'PayrollSetting', courierId: string, defaultCommission: any, payPeriodType: PayPeriodType, payPeriodStartDate?: any | null, ordersInclusionType: PayrollOrdersInclusionType, driverPayExportType: DriverPayExportType } };

export type GetOrGenerateDriverPayEntriesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  driverSearch?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<DriverPayrollSorting> | DriverPayrollSorting>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetOrGenerateDriverPayEntriesMutation = { __typename?: 'Mutation', getOrGenerateDriverPayEntries: Array<{ __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus, driver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null }, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }> }> };

export type GeneratePayrollReportMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type GeneratePayrollReportMutation = { __typename?: 'Mutation', generatePayrollReport?: { __typename?: 'PayrollReportFile', url: string } | null };

export type SendEmailToDriversMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
  recipients: Array<Scalars['String']> | Scalars['String'];
}>;


export type SendEmailToDriversMutation = { __typename?: 'Mutation', sendEmailToDrivers: { __typename?: 'PayrollEmail', id: string, driverPayEntryId: string, driverId: string, fileId: string, recipients: Array<string>, emailId?: string | null } };

export type ApproveDriverPayMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
}>;


export type ApproveDriverPayMutation = { __typename?: 'Mutation', approveDriverPay: { __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus } };

export type BulkApproveDriverPaysMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverPayEntryIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkApproveDriverPaysMutation = { __typename?: 'Mutation', bulkApproveDriverPays: { __typename?: 'BulkApproveDriverPaysResults', approvedEntries: Array<{ __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus }>, failures: Array<{ __typename?: 'BulkApproveDriverPaysFailure', id: string, failure: string }> } };

export type ModifyDriverPayDeductionsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
  deductionsToAdd: Array<DriverPayDeductionValueInput> | DriverPayDeductionValueInput;
  deductionIdsToRemove: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ModifyDriverPayDeductionsMutation = { __typename?: 'Mutation', modifyDriverPayDeductions: { __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus } };

export type ForceExportDriverPayMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
  provider: ApiProvider;
}>;


export type ForceExportDriverPayMutation = { __typename?: 'Mutation', forceExportDriverPay: { __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus } };

export type CreatePayrollDeductionRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  amount: Scalars['Money'];
  amountType: PayrollDeductionAmountType;
  ruleType: PayrollDeductionRuleType;
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type CreatePayrollDeductionRuleMutation = { __typename?: 'Mutation', createPayrollDeductionRule: { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, startDate?: any | null, endDate?: any | null, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> } };

export type FullUpdatePayrollDeductionRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  amount: Scalars['Money'];
  amountType: PayrollDeductionAmountType;
  ruleType: PayrollDeductionRuleType;
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type FullUpdatePayrollDeductionRuleMutation = { __typename?: 'Mutation', fullUpdatePayrollDeductionRule: { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, startDate?: any | null, endDate?: any | null, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> } };

export type DeletePayrollDeductionRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeletePayrollDeductionRuleMutation = { __typename?: 'Mutation', deletePayrollDeductionRule: { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, startDate?: any | null, endDate?: any | null, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> } };

export type GetPayPeriodsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  minDate: Scalars['Date'];
  maxDate: Scalars['Date'];
}>;


export type GetPayPeriodsQuery = { __typename?: 'Query', payPeriods: Array<{ __typename?: 'PayPeriod', startDate: any, endDate: any }> };

export type GetPayrollSettingsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetPayrollSettingsQuery = { __typename?: 'Query', payrollSettings: { __typename?: 'PayrollSetting', courierId: string, defaultCommission: any, payPeriodType: PayPeriodType, payPeriodStartDate?: any | null, ordersInclusionType: PayrollOrdersInclusionType, driverPayExportType: DriverPayExportType } };

export type CustomDeductionsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
}>;


export type CustomDeductionsQuery = { __typename?: 'Query', customDeductions: Array<{ __typename?: 'DriverPayDeduction', id: string, name: string, amount: any }> };

export type PayrollDeductionRulesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  after: Scalars['Int'];
  sortFields?: InputMaybe<Array<PayrollDeductionRuleSorting> | PayrollDeductionRuleSorting>;
}>;


export type PayrollDeductionRulesPaginatedQuery = { __typename?: 'Query', payrollDeductionRulesPaginated: { __typename?: 'PayrollDeductionRuleConnection', edges?: Array<{ __typename?: 'PayrollDeductionRuleEdge', node?: { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, startDate?: any | null, endDate?: any | null, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type OrderPayBreakDownWithAllocationsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type OrderPayBreakDownWithAllocationsQuery = { __typename?: 'Query', orderPayBreakDownWithAllocations: { __typename?: 'OrderPayBreakDownWithAllocationResult', isOverride: boolean, total: any, allocations: Array<{ __typename?: 'OrderPayBreakDownWithAllocation', driverId?: string | null, allocationRate?: any | null, allocationAmount?: any | null, breakdown: { __typename?: 'OrderPayBreakDown', total: any, items: Array<{ __typename?: 'OrderPayBreakDownItem', name: string, description?: string | null, amount: any }> }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string } | null }> } };

export type PricingListFragmentFragment = { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean };

export type PricingRuleFragmentFragment = { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, maximumPrice?: any | null, pricePerMile: any, pricePerLbs?: any | null, pricePerHour?: any | null, returnTripMultiplier?: any | null, driverPayFixed?: any | null, driverCommission?: any | null, maximumDriverPay?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, forReturnTripOnly: boolean, weightBasis: WeightBasis, scope: PriceScope, timeScheduleSpecificAmounts?: { __typename?: 'TimeScheduleSpecificAmounts', schedules: Array<{ __typename?: 'TimeScheduleWeekDailyAmounts', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number, minimumAmount: any, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, holidaySchedulePricingAmounts?: { __typename?: 'HolidaySchedulePricingAmountList', schedules: Array<{ __typename?: 'HolidaySchedulePricingAmount', holidayScheduleId: string, minimumAmount?: any | null, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, advancedMultiplier?: { __typename?: 'PricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'PackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null };

export type SurchargePricingRuleFragmentFragment = { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null };

export type OrderPriceFragmentFragment = { __typename?: 'OrderPrice', total: any, taxableTotal: any, nonTaxableTotal: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, totalAfterTax: any, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, taxBreakDown?: { __typename?: 'OrderPriceTaxBreakdown', totalTaxAmount: any, taxItems: Array<{ __typename?: 'OrderPriceTaxItem', name: string, amount: any }> } | null, tripPrices: Array<{ __typename?: 'OrderPriceTripPrice', scope: PriceScope, pricingRuleDisplay: string, miles: number, amount: any }> };

export type EiaFuelRateFragmentFragment = { __typename?: 'EiaFuelRate', ratePerGallon: any, percent: number, fuelType: FuelType, ratePeriod: any };

export type PricingBreakDownFragmentFragment = { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> };

export type ZipGroupFragmentFragment = { __typename?: 'ZipGroup', id: string, courierId: string, name: string, zipCodes: Array<string> };

export type PricingAdjustmentFragmentFragment = { __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null };

export type PriceOverrideBreakdownItemFragmentFragment = { __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null };

export type PreviewPriceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  googlePlaceIds: Array<Scalars['String']> | Scalars['String'];
  serviceTypeId?: InputMaybe<Scalars['String']>;
  requestedPricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  shipmentType?: InputMaybe<ShipmentType>;
  packageSize?: InputMaybe<PackageSize>;
  packageWeight?: InputMaybe<Scalars['Float']>;
  packageCount?: InputMaybe<Scalars['Int']>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
  shipmentDate?: InputMaybe<Scalars['Date']>;
  timeWindows?: InputMaybe<Array<TimeWindowInput> | TimeWindowInput>;
  packageItems?: InputMaybe<Array<PackageItemInput> | PackageItemInput>;
  orderAcquisitionType?: InputMaybe<OrderAcquisitionType>;
  stopTypes?: InputMaybe<Array<ShipmentStopType> | ShipmentStopType>;
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  priceOverride?: InputMaybe<Scalars['Money']>;
}>;


export type PreviewPriceMutation = { __typename?: 'Mutation', previewPrice: { __typename?: 'PreviewPriceResult', totalAfterTax: any, total: any, pricingListId?: string | null, taxBreakDown?: { __typename?: 'OrderPriceTaxBreakdown', totalTaxAmount: any, taxItems: Array<{ __typename?: 'OrderPriceTaxItem', name: string, amount: any }> } | null, breakdown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> }, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, orderPrice?: { __typename?: 'OrderPrice', tripPrices: Array<{ __typename?: 'OrderPriceTripPrice', amount: any, durationsInSeconds: number, miles: number, packageWeightInLbs?: number | null, pricingMultiplier: any, pricingRuleDisplay: string, readyTimeList: Array<any>, selectedPricingRuleId?: string | null, unfreeMiles: number }>, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, isAdjustmentOverride: boolean, isBasePrice?: boolean | null, surchargePricingRuleId?: string | null }> } } | null } };

export type CreatePricingRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingRuleCreate: PricingRuleCreate;
}>;


export type CreatePricingRuleMutation = { __typename?: 'Mutation', createPricingRule: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, maximumPrice?: any | null, pricePerMile: any, pricePerLbs?: any | null, pricePerHour?: any | null, returnTripMultiplier?: any | null, driverPayFixed?: any | null, driverCommission?: any | null, maximumDriverPay?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, forReturnTripOnly: boolean, weightBasis: WeightBasis, scope: PriceScope, timeScheduleSpecificAmounts?: { __typename?: 'TimeScheduleSpecificAmounts', schedules: Array<{ __typename?: 'TimeScheduleWeekDailyAmounts', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number, minimumAmount: any, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, holidaySchedulePricingAmounts?: { __typename?: 'HolidaySchedulePricingAmountList', schedules: Array<{ __typename?: 'HolidaySchedulePricingAmount', holidayScheduleId: string, minimumAmount?: any | null, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, advancedMultiplier?: { __typename?: 'PricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'PackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } };

export type CreateSurchargePricingRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  surchargePricingRuleCreate: SurchargePricingRuleCreate;
}>;


export type CreateSurchargePricingRuleMutation = { __typename?: 'Mutation', createSurchargePricingRule: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } };

export type DeletePricingRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingRuleId: Scalars['ID'];
}>;


export type DeletePricingRuleMutation = { __typename?: 'Mutation', deletePricingRule: boolean };

export type DeleteSurchargePricingRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  surchargePricingRuleId: Scalars['ID'];
}>;


export type DeleteSurchargePricingRuleMutation = { __typename?: 'Mutation', deleteSurchargePricingRule: boolean };

export type CreatePricingListMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  copyBasePricingRules?: InputMaybe<Scalars['Boolean']>;
  pricingListIdToCopyFrom?: InputMaybe<Scalars['ID']>;
  pricingRulesValueMultiplier?: InputMaybe<Scalars['Float']>;
  fallbackToBasePricingList?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreatePricingListMutation = { __typename?: 'Mutation', createPricingList: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } };

export type DeletePricingListMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingListId: Scalars['ID'];
}>;


export type DeletePricingListMutation = { __typename?: 'Mutation', deletePricingList: boolean };

export type FullUpdatePriceListMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingListId: Scalars['ID'];
  name: Scalars['String'];
  fallbackToBasePricingList: Scalars['Boolean'];
}>;


export type FullUpdatePriceListMutation = { __typename?: 'Mutation', fullUpdatePriceList: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } };

export type FullUpdatePricingRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingRuleFullUpdate: PricingRuleFullUpdate;
}>;


export type FullUpdatePricingRuleMutation = { __typename?: 'Mutation', fullUpdatePricingRule: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, maximumPrice?: any | null, pricePerMile: any, pricePerLbs?: any | null, pricePerHour?: any | null, returnTripMultiplier?: any | null, driverPayFixed?: any | null, driverCommission?: any | null, maximumDriverPay?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, forReturnTripOnly: boolean, weightBasis: WeightBasis, scope: PriceScope, timeScheduleSpecificAmounts?: { __typename?: 'TimeScheduleSpecificAmounts', schedules: Array<{ __typename?: 'TimeScheduleWeekDailyAmounts', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number, minimumAmount: any, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, holidaySchedulePricingAmounts?: { __typename?: 'HolidaySchedulePricingAmountList', schedules: Array<{ __typename?: 'HolidaySchedulePricingAmount', holidayScheduleId: string, minimumAmount?: any | null, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, advancedMultiplier?: { __typename?: 'PricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'PackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } };

export type FullUpdateSurchargePricingRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  surchargePricingRuleFullUpdate: SurchargePricingRuleFullUpdate;
}>;


export type FullUpdateSurchargePricingRuleMutation = { __typename?: 'Mutation', fullUpdateSurchargePricingRule: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, amountDisplay: string, minMiles?: number | null, maxMiles?: number | null, applicableStopTypes?: Array<ShipmentStopType> | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null } };

export type UpdateSurchargePricingRuleAdvancedSettingMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: SurchargePricingRuleAdvancedSettingsInput;
}>;


export type UpdateSurchargePricingRuleAdvancedSettingMutation = { __typename?: 'Mutation', updateSurchargePricingRuleAdvancedSetting: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } };

export type ModifyOrderPricingMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  adjustmentIdsToRemove?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  priceOverride?: InputMaybe<Scalars['Money']>;
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  adjustmentOverrides?: InputMaybe<Array<AdjustmentOverrideInput> | AdjustmentOverrideInput>;
  updatedBy?: InputMaybe<Scalars['String']>;
  priceOverrideBreakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput> | PriceOverrideBreakdownItemInput>;
}>;


export type ModifyOrderPricingMutation = { __typename?: 'Mutation', modifyOrderPricing: { __typename?: 'OrderPrice', total: any, taxableTotal: any, nonTaxableTotal: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, totalAfterTax: any, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, taxBreakDown?: { __typename?: 'OrderPriceTaxBreakdown', totalTaxAmount: any, taxItems: Array<{ __typename?: 'OrderPriceTaxItem', name: string, amount: any }> } | null, tripPrices: Array<{ __typename?: 'OrderPriceTripPrice', scope: PriceScope, pricingRuleDisplay: string, miles: number, amount: any }> } };

export type PreviewOrderPricingModificationMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  adjustmentsToAdd: Array<PricingAdjustmentCreate> | PricingAdjustmentCreate;
  adjustmentIdsToRemove: Array<Scalars['ID']> | Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
}>;


export type PreviewOrderPricingModificationMutation = { __typename?: 'Mutation', previewOrderPricingModification: { __typename?: 'PreviewOrderPricingModificationResult', total: any } };

export type UpdatePriceOverrideForRecurringOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  breakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput> | PriceOverrideBreakdownItemInput>;
}>;


export type UpdatePriceOverrideForRecurringOrderMutation = { __typename?: 'Mutation', updatePriceOverrideForRecurringOrder: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } };

export type UpdateDriverPayOverrideMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  driverPayOverride?: InputMaybe<Scalars['Money']>;
  driverPayPercent?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDriverPayOverrideMutation = { __typename?: 'Mutation', updateDriverPayOverride: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } };

export type UpdateCommissionableBaseMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  commissionableBaseFixed?: InputMaybe<Scalars['Money']>;
  commissionableBasePercent?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCommissionableBaseMutation = { __typename?: 'Mutation', updateCommissionableBase: { __typename?: 'Order', id: string, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null } };

export type UpdateBasePriceOverrideMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBasePriceOverrideMutation = { __typename?: 'Mutation', updateBasePriceOverride: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } };

export type CreateZipGroupMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateZipGroupMutation = { __typename?: 'Mutation', createZipGroup: { __typename?: 'ZipGroup', id: string, name: string, zipCodes: Array<string> } };

export type FullUpdateZipGroupMutationVariables = Exact<{
  courierId: Scalars['ID'];
  zipGroupId: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type FullUpdateZipGroupMutation = { __typename?: 'Mutation', fullUpdateZipGroup: { __typename?: 'ZipGroup', id: string, name: string, zipCodes: Array<string> } };

export type OverrideAdjustmentAmountMutationVariables = Exact<{
  courierId: Scalars['ID'];
  adjustmentId: Scalars['ID'];
  amountOverride?: InputMaybe<Scalars['Money']>;
}>;


export type OverrideAdjustmentAmountMutation = { __typename?: 'Mutation', overrideAdjustmentAmount: { __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null } };

export type BulkUploadPricingRulesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  overrideExistingPricingRules?: InputMaybe<Scalars['Boolean']>;
}>;


export type BulkUploadPricingRulesMutation = { __typename?: 'Mutation', bulkUploadPricingRules: { __typename?: 'BulkUploadPricingRulesResult', numSuccess: number, numSkipped?: number | null, isAsynchronous?: boolean | null, errors?: Array<{ __typename?: 'BulkUploadPricingRulesRowError', rowNumber: number, messages: Array<string> }> | null } };

export type BulkUploadPricingListsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type BulkUploadPricingListsMutation = { __typename?: 'Mutation', bulkUploadPricingLists: { __typename?: 'BulkUploadPricingListsResult', numSuccess: number, errors?: Array<{ __typename?: 'BulkUploadPricingListsRowError', rowNumber: number, messages: Array<string> }> | null } };

export type BulkMultiplyPricingRulesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingListId?: InputMaybe<Scalars['ID']>;
  multiplier: Scalars['Float'];
  isBasePricingList: Scalars['Boolean'];
}>;


export type BulkMultiplyPricingRulesMutation = { __typename?: 'Mutation', bulkMultiplyPricingRules: { __typename?: 'BulkMultiplyPricingRulesResult', numSuccess: number } };

export type BulkDeletePricingRulesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  isBasePricingListOnly: Scalars['Boolean'];
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  serviceTypeIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BulkDeletePricingRulesMutation = { __typename?: 'Mutation', bulkDeletePricingRules: number };

export type UpdatePricingRuleTimeScheduleSpecificAmountsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingRuleId: Scalars['ID'];
  timeScheduleSpecificAmounts: TimeScheduleSpecificAmountsInput;
}>;


export type UpdatePricingRuleTimeScheduleSpecificAmountsMutation = { __typename?: 'Mutation', updatePricingRuleTimeScheduleSpecificAmounts: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, maximumPrice?: any | null, pricePerMile: any, pricePerLbs?: any | null, pricePerHour?: any | null, returnTripMultiplier?: any | null, driverPayFixed?: any | null, driverCommission?: any | null, maximumDriverPay?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, forReturnTripOnly: boolean, weightBasis: WeightBasis, scope: PriceScope, timeScheduleSpecificAmounts?: { __typename?: 'TimeScheduleSpecificAmounts', schedules: Array<{ __typename?: 'TimeScheduleWeekDailyAmounts', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number, minimumAmount: any, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, holidaySchedulePricingAmounts?: { __typename?: 'HolidaySchedulePricingAmountList', schedules: Array<{ __typename?: 'HolidaySchedulePricingAmount', holidayScheduleId: string, minimumAmount?: any | null, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, advancedMultiplier?: { __typename?: 'PricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'PackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } };

export type UpdatePricingRuleHolidaySchedulePricingAmountsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingRuleId: Scalars['ID'];
  holidaySchedulePricingAmounts: HolidaySchedulePricingAmountListInput;
}>;


export type UpdatePricingRuleHolidaySchedulePricingAmountsMutation = { __typename?: 'Mutation', updatePricingRuleHolidaySchedulePricingAmounts: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, maximumPrice?: any | null, pricePerMile: any, pricePerLbs?: any | null, pricePerHour?: any | null, returnTripMultiplier?: any | null, driverPayFixed?: any | null, driverCommission?: any | null, maximumDriverPay?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, forReturnTripOnly: boolean, weightBasis: WeightBasis, scope: PriceScope, timeScheduleSpecificAmounts?: { __typename?: 'TimeScheduleSpecificAmounts', schedules: Array<{ __typename?: 'TimeScheduleWeekDailyAmounts', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number, minimumAmount: any, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, holidaySchedulePricingAmounts?: { __typename?: 'HolidaySchedulePricingAmountList', schedules: Array<{ __typename?: 'HolidaySchedulePricingAmount', holidayScheduleId: string, minimumAmount?: any | null, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, advancedMultiplier?: { __typename?: 'PricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'PackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } };

export type UpdatePricingRuleAdvancedMultipliersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingRuleId: Scalars['ID'];
  advancedMultiplier?: InputMaybe<PricingRuleAdvancedMultiplierInput>;
}>;


export type UpdatePricingRuleAdvancedMultipliersMutation = { __typename?: 'Mutation', updatePricingRuleAdvancedMultipliers: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, maximumPrice?: any | null, pricePerMile: any, pricePerLbs?: any | null, pricePerHour?: any | null, returnTripMultiplier?: any | null, driverPayFixed?: any | null, driverCommission?: any | null, maximumDriverPay?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, forReturnTripOnly: boolean, weightBasis: WeightBasis, scope: PriceScope, timeScheduleSpecificAmounts?: { __typename?: 'TimeScheduleSpecificAmounts', schedules: Array<{ __typename?: 'TimeScheduleWeekDailyAmounts', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number, minimumAmount: any, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, holidaySchedulePricingAmounts?: { __typename?: 'HolidaySchedulePricingAmountList', schedules: Array<{ __typename?: 'HolidaySchedulePricingAmount', holidayScheduleId: string, minimumAmount?: any | null, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, advancedMultiplier?: { __typename?: 'PricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'PackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } };

export type UpdateSurchargePricingRuleAdvancedMultipliersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  surchargePricingRuleId: Scalars['ID'];
  advancedMultiplier?: InputMaybe<SurchargePricingRuleAdvancedMultiplierInput>;
}>;


export type UpdateSurchargePricingRuleAdvancedMultipliersMutation = { __typename?: 'Mutation', updateSurchargePricingRuleAdvancedMultipliers: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } };

export type UpdateSurchargePricingRuleInvoiceSummaryGroupMutationVariables = Exact<{
  courierId: Scalars['ID'];
  surchargePricingRuleId: Scalars['ID'];
  invoiceSummaryGroup?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSurchargePricingRuleInvoiceSummaryGroupMutation = { __typename?: 'Mutation', updateSurchargePricingRuleInvoiceSummaryGroup: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } };

export type UpdateSurchargePricingRuleTaxableStatusMutationVariables = Exact<{
  courierId: Scalars['ID'];
  surchargePricingRuleId: Scalars['ID'];
  taxableStatus: SurchargeTaxStatus;
}>;


export type UpdateSurchargePricingRuleTaxableStatusMutation = { __typename?: 'Mutation', updateSurchargePricingRuleTaxableStatus: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } };

export type CreateBulkRerateJobMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: BulkRerateJobInput;
}>;


export type CreateBulkRerateJobMutation = { __typename?: 'Mutation', createBulkRerateJob: { __typename?: 'BulkRerateJobResult', jobId: string, message: string } };

export type ExportPricingRulesCsvMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingListId?: InputMaybe<Scalars['ID']>;
  isBasePricingList: Scalars['Boolean'];
}>;


export type ExportPricingRulesCsvMutation = { __typename?: 'Mutation', exportPricingRulesCsv: { __typename?: 'PricingRulesCsvFile', url: string } };

export type ExportSurchargeRulesCsvMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingListId?: InputMaybe<Scalars['ID']>;
  isBasePricingList: Scalars['Boolean'];
}>;


export type ExportSurchargeRulesCsvMutation = { __typename?: 'Mutation', exportSurchargeRulesCsv: { __typename?: 'SurchargeRulesCsvFile', url: string } };

export type GetOrderPriceQueryVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type GetOrderPriceQuery = { __typename?: 'Query', orderPrice: { __typename?: 'OrderPrice', total: any, taxableTotal: any, nonTaxableTotal: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, totalAfterTax: any, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, taxBreakDown?: { __typename?: 'OrderPriceTaxBreakdown', totalTaxAmount: any, taxItems: Array<{ __typename?: 'OrderPriceTaxItem', name: string, amount: any }> } | null, tripPrices: Array<{ __typename?: 'OrderPriceTripPrice', scope: PriceScope, pricingRuleDisplay: string, miles: number, amount: any }> } };

export type GetCurrentEiaFuelRateQueryVariables = Exact<{
  courierId: Scalars['ID'];
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type GetCurrentEiaFuelRateQuery = { __typename?: 'Query', currentEiaFuelRate?: { __typename?: 'EiaFuelRate', ratePerGallon: any, percent: number, fuelType: FuelType, ratePeriod: any } | null };

export type GetEiaFuelRateLinesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type GetEiaFuelRateLinesQuery = { __typename?: 'Query', eiaFuelRateLines: Array<{ __typename?: 'EiaFuelRateLine', surchargePricingRuleId: string, eiaFuelRate: { __typename?: 'EiaFuelRate', ratePerGallon: any, percent: number, fuelType: FuelType, ratePeriod: any } }> };

export type GetPricingRulesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  defaultOnly?: InputMaybe<Scalars['Boolean']>;
  locationBasedOnly?: InputMaybe<Scalars['Boolean']>;
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  distanceBasedOnly?: InputMaybe<Scalars['Boolean']>;
  tripBasedOnly?: InputMaybe<Scalars['Boolean']>;
  sortFields?: InputMaybe<Array<PricingRulesSorting> | PricingRulesSorting>;
  originZoneIdFilter?: InputMaybe<Scalars['ID']>;
  originCityFilter?: InputMaybe<CityStateCountryCreate>;
  originZipFilter?: InputMaybe<Scalars['String']>;
  originZipGroupIdFilter?: InputMaybe<Scalars['ID']>;
  originCircleZoneIdFilter?: InputMaybe<Scalars['ID']>;
  destinationZoneIdFilter?: InputMaybe<Scalars['ID']>;
  destinationCityFilter?: InputMaybe<CityStateCountryCreate>;
  destinationZipFilter?: InputMaybe<Scalars['String']>;
  destinationZipGroupIdFilter?: InputMaybe<Scalars['ID']>;
  destinationCircleZoneIdFilter?: InputMaybe<Scalars['ID']>;
  serviceTypeIdsFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
}>;


export type GetPricingRulesPaginatedQuery = { __typename?: 'Query', pricingRulesPaginated: { __typename?: 'PricingRuleConnection', edges?: Array<{ __typename?: 'PricingRuleEdge', node?: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, maximumPrice?: any | null, pricePerMile: any, pricePerLbs?: any | null, pricePerHour?: any | null, returnTripMultiplier?: any | null, driverPayFixed?: any | null, driverCommission?: any | null, maximumDriverPay?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, forReturnTripOnly: boolean, weightBasis: WeightBasis, scope: PriceScope, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, timeScheduleSpecificAmounts?: { __typename?: 'TimeScheduleSpecificAmounts', schedules: Array<{ __typename?: 'TimeScheduleWeekDailyAmounts', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number, minimumAmount: any, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, holidaySchedulePricingAmounts?: { __typename?: 'HolidaySchedulePricingAmountList', schedules: Array<{ __typename?: 'HolidaySchedulePricingAmount', holidayScheduleId: string, minimumAmount?: any | null, baseAmount?: any | null, pricePerMileAmount?: any | null }> } | null, advancedMultiplier?: { __typename?: 'PricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'PackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type GetSurchargePricingRuleQueryVariables = Exact<{
  courierId: Scalars['ID'];
  surchargeApplyType?: InputMaybe<SurchargeApplyType>;
  pricingListIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  amountTypes?: InputMaybe<Array<SurchargeAmountType> | SurchargeAmountType>;
}>;


export type GetSurchargePricingRuleQuery = { __typename?: 'Query', surchargePricingRules: Array<{ __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, surchargePricingRulesToExclude?: Array<{ __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null }> | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null }> };

export type GetSurchargePricingRulesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<SurchargePricingRuleSorting> | SurchargePricingRuleSorting>;
  limit: Scalars['Int'];
  after: Scalars['Int'];
}>;


export type GetSurchargePricingRulesPaginatedQuery = { __typename?: 'Query', surchargePricingRulesPaginated: { __typename?: 'SurchargePricingRuleConnection', edges?: Array<{ __typename?: 'SurchargePricingRuleEdge', node?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, surchargePricingRulesToExclude?: Array<{ __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null }> | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, serviceTypes?: Array<{ __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null }> | null, vehicleTypes?: Array<{ __typename?: 'VehicleType', id: string, name: string }> | null, depotLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, zoneForOutOfPerimeterApplyType?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null } | null, zoneForInPerimeterApplyType?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null } | null, zoneForPerMilesFromOrToDepotAmountType?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null } | null, originZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null } | null, destinationZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null } | null, readyTimeHolidaySchedule?: { __typename?: 'HolidaySchedule', id: string, name: string } | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type GetPricingListsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetPricingListsQuery = { __typename?: 'Query', pricingLists: Array<{ __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean }> };

export type GetZipGroupsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetZipGroupsQuery = { __typename?: 'Query', zipGroups: Array<{ __typename?: 'ZipGroup', id: string, courierId: string, name: string, zipCodes: Array<string> }> };

export type PreviewRecurringOrderPriceQueryVariables = Exact<{
  courierId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
}>;


export type PreviewRecurringOrderPriceQuery = { __typename?: 'Query', previewRecurringOrderPrice: { __typename?: 'PreviewPriceResult', total: any, totalAfterTax: any, breakdown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> }, taxBreakDown?: { __typename?: 'OrderPriceTaxBreakdown', totalTaxAmount: any, taxItems: Array<{ __typename?: 'OrderPriceTaxItem', name: string, amount: any }> } | null } };

export type QualityReviewFragmentFragment = { __typename?: 'QualityReview', id: string, courierId: string, shipmentId: string, jobStatus: QualityReviewJobStatus, overallVerdict?: QualityReviewVerdict | null, createdAt: any };

export type QualityReviewItemFragmentFragment = { __typename?: 'QualityReviewItem', id: string, qualityReviewId: string, reviewAspect: QualityReviewAspect, entityId?: string | null, verdict?: QualityReviewVerdict | null, issues?: Array<string> | null, suggestions?: Array<string> | null, createdAt?: any | null, resultStructured?: { __typename?: 'QualityReviewResultStructured', podResult?: { __typename?: 'PodResult', verdict: string, issues: Array<{ __typename?: 'PodIssue', tag: string, description: string, suggestions: Array<string> }> } | null, pricingResult?: { __typename?: 'PricingResult', verdict: string, issues: Array<{ __typename?: 'PricingIssue', tag: string, description: string, suggestions: Array<string>, suggestedSurchargeAdd?: { __typename?: 'PricingReviewSuggestedSurchargeAdd', surchargeIdToAdd: string, reason: string, suggestedAmount?: number | null } | null }> } | null, otherResult?: { __typename?: 'OtherQualityReviewResult', verdict: string, issues: Array<{ __typename?: 'IssueWithSuggestions', tag: string, description: string, suggestions: Array<string> }> } | null } | null };

export type QualityReviewsByShipmentIdsQueryVariables = Exact<{
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type QualityReviewsByShipmentIdsQuery = { __typename?: 'Query', qualityReviewsByShipmentIds: Array<{ __typename?: 'QualityReview', id: string, courierId: string, shipmentId: string, jobStatus: QualityReviewJobStatus, overallVerdict?: QualityReviewVerdict | null, createdAt: any, items: Array<{ __typename?: 'QualityReviewItem', id: string, qualityReviewId: string, reviewAspect: QualityReviewAspect, entityId?: string | null, verdict?: QualityReviewVerdict | null, issues?: Array<string> | null, suggestions?: Array<string> | null, createdAt?: any | null, artifact?: { __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any } | null, resultStructured?: { __typename?: 'QualityReviewResultStructured', pricingResult?: { __typename?: 'PricingResult', verdict: string, issues: Array<{ __typename?: 'PricingIssue', tag: string, description: string, suggestions: Array<string>, suggestedSurchargeAdd?: { __typename?: 'PricingReviewSuggestedSurchargeAdd', surchargeIdToAdd: string, reason: string, suggestedAmount?: number | null, surchargeRule: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } } | null }> } | null, podResult?: { __typename?: 'PodResult', verdict: string, issues: Array<{ __typename?: 'PodIssue', tag: string, description: string, suggestions: Array<string> }> } | null, otherResult?: { __typename?: 'OtherQualityReviewResult', verdict: string, issues: Array<{ __typename?: 'IssueWithSuggestions', tag: string, description: string, suggestions: Array<string> }> } | null } | null }>, price?: { __typename?: 'OrderPrice', total: any, taxableTotal: any, nonTaxableTotal: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, totalAfterTax: any, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, taxBreakDown?: { __typename?: 'OrderPriceTaxBreakdown', totalTaxAmount: any, taxItems: Array<{ __typename?: 'OrderPriceTaxItem', name: string, amount: any }> } | null, tripPrices: Array<{ __typename?: 'OrderPriceTripPrice', scope: PriceScope, pricingRuleDisplay: string, miles: number, amount: any }> } | null }> };

export type RemoteEntityFragmentFragment = { __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null };

export type UpsertRemoteEntityLinkageMutationVariables = Exact<{
  courierId: Scalars['ID'];
  upsert: RemoteEntityLinkageUpsert;
}>;


export type UpsertRemoteEntityLinkageMutation = { __typename?: 'Mutation', upsertRemoteEntityLinkage: { __typename?: 'RemoteEntity', id: string, externalUrl?: string | null } };

export type QuickbookCustomerQueryVariables = Exact<{
  courierId: Scalars['ID'];
  remoteId: Scalars['ID'];
}>;


export type QuickbookCustomerQuery = { __typename?: 'Query', quickbookCustomer?: { __typename?: 'QuickbookCustomer', id: string, name: string, email?: string | null, phone?: string | null } | null };

export type QuickbookVendorQueryVariables = Exact<{
  courierId: Scalars['ID'];
  remoteId: Scalars['ID'];
}>;


export type QuickbookVendorQuery = { __typename?: 'Query', quickbookVendor?: { __typename?: 'QuickbookVendor', id: string, name: string, email?: string | null, phone?: string | null } | null };

export type SalesReportFileFragmentFragment = { __typename?: 'SalesReportFile', url: string };

export type SalesOverviewFragmentFragment = { __typename?: 'SalesOverview', courierId: string, minDate?: any | null, maxDate?: any | null, amountTotal: any, amountForCompletedShipments: any, numShipmentsTotal: number, numShipmentsCompleted: number };

export type GenerateSalesReportCsvMutationVariables = Exact<{
  courierId: Scalars['ID'];
  minDate?: InputMaybe<Scalars['Date']>;
  maxDate?: InputMaybe<Scalars['Date']>;
  minCompletedDate?: InputMaybe<Scalars['Date']>;
  maxCompletedDate?: InputMaybe<Scalars['Date']>;
  includeAllSurcharge?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateSalesReportCsvMutation = { __typename?: 'Mutation', generateSalesReportCsv?: { __typename?: 'SalesReportFile', url: string } | null };

export type SalesOverviewQueryVariables = Exact<{
  courierId: Scalars['ID'];
  minDate: Scalars['Date'];
  maxDate: Scalars['Date'];
}>;


export type SalesOverviewQuery = { __typename?: 'Query', salesOverview: { __typename?: 'SalesOverview', courierId: string, minDate?: any | null, maxDate?: any | null, amountTotal: any, amountForCompletedShipments: any, numShipmentsTotal: number, numShipmentsCompleted: number } };

export type SalesTermFragmentFragment = { __typename?: 'SalesTerm', id: string, courierId: string, name: string };

export type ServiceTypeFragmentFragment = { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null };

export type CreateServiceTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  deliveryTimeInMinutes?: InputMaybe<Scalars['Int']>;
  dueTimeType?: InputMaybe<ServiceTypeDueTimeType>;
  dueTimeSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  dueTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  dueTimeInDaysAfter?: InputMaybe<Scalars['Int']>;
  deliveryRoutedDaysAfter?: InputMaybe<Scalars['Int']>;
  milesLimit?: InputMaybe<Scalars['Float']>;
  extraSecondsPerMilePastLimit?: InputMaybe<Scalars['Float']>;
  pickupCloseType?: InputMaybe<ServiceTypeDueTimeType>;
  pickupCloseTimeInMinutes?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInDaysAfter?: InputMaybe<Scalars['Int']>;
  orderingSequenceNumber?: InputMaybe<Scalars['Int']>;
  freeWaitTimeInSeconds?: InputMaybe<Scalars['Int']>;
}>;


export type CreateServiceTypeMutation = { __typename?: 'Mutation', createServiceType: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type FullUpdateServiceTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  deliveryTimeInMinutes?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['String']>;
  visibilityType?: InputMaybe<ServiceTypeVisibilityType>;
  dueTimeType?: InputMaybe<ServiceTypeDueTimeType>;
  dueTimeSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  dueTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  dueTimeInDaysAfter?: InputMaybe<Scalars['Int']>;
  deliveryRoutedDaysAfter?: InputMaybe<Scalars['Int']>;
  customMessage?: InputMaybe<Scalars['String']>;
  milesLimit?: InputMaybe<Scalars['Float']>;
  extraSecondsPerMilePastLimit?: InputMaybe<Scalars['Float']>;
  pickupCloseType?: InputMaybe<ServiceTypeDueTimeType>;
  pickupCloseTimeInMinutes?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  pickupCloseTimeInDaysAfter?: InputMaybe<Scalars['Int']>;
  orderingSequenceNumber?: InputMaybe<Scalars['Int']>;
  freeWaitTimeInSeconds?: InputMaybe<Scalars['Int']>;
}>;


export type FullUpdateServiceTypeMutation = { __typename?: 'Mutation', fullUpdateServiceType: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type UpdateServiceTypeReadyTimeScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  serviceTypeId: Scalars['ID'];
  readyTimeSchedule: TimeScheduleInput;
}>;


export type UpdateServiceTypeReadyTimeScheduleMutation = { __typename?: 'Mutation', updateServiceTypeReadyTimeSchedule: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type UpdateServiceTypeBusinessHoursScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  serviceTypeId: Scalars['ID'];
  businessHoursSchedule?: InputMaybe<TimeScheduleInput>;
}>;


export type UpdateServiceTypeBusinessHoursScheduleMutation = { __typename?: 'Mutation', updateServiceTypeBusinessHoursSchedule: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type UpdateServiceTypeVisibleVehicleTypesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  serviceTypeId: Scalars['ID'];
  visibleVehicleTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  defaultVehicleTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateServiceTypeVisibleVehicleTypesMutation = { __typename?: 'Mutation', updateServiceTypeVisibleVehicleTypes: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type DeleteServiceTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  serviceTypeId: Scalars['ID'];
}>;


export type DeleteServiceTypeMutation = { __typename?: 'Mutation', deleteServiceType: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  serviceTypeId: Scalars['ID'];
  googlePlaceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation = { __typename?: 'Mutation', calculateExtraSecondsFromMilesOverLimitForServiceType?: number | null };

export type UpdateServiceTypePricingMultiplierMutationVariables = Exact<{
  courierId: Scalars['ID'];
  serviceTypeId: Scalars['ID'];
  multiplier?: InputMaybe<Scalars['Money']>;
  multiplierMode: ServiceTypeMultiplierMode;
}>;


export type UpdateServiceTypePricingMultiplierMutation = { __typename?: 'Mutation', updateServiceTypePricingMultiplier: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type GetServiceTypesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  showForEndCustomer?: InputMaybe<Scalars['Boolean']>;
  includeInternalOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetServiceTypesQuery = { __typename?: 'Query', serviceTypes: Array<{ __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null }> };

export type ShipmentFragmentFragment = { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null };

export type ShipmentTemplateFragmentFragment = { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null };

export type DriverPayAllocationFragmentFragment = { __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate?: any | null, allocationAmount?: any | null };

export type ShipmentTemplateDriverAssignmentFragmentFragment = { __typename?: 'ShipmentTemplateDriverAssignment', id: string, shipmentTemplateId: string, driverId: string, dayOfWeek: DayOfTheWeek };

export type UnassignDriverFromShipmentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
}>;


export type UnassignDriverFromShipmentMutation = { __typename?: 'Mutation', unassignDriverFromShipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type MarkShipmentAsFailedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
}>;


export type MarkShipmentAsFailedMutation = { __typename?: 'Mutation', markShipmentAsFailed: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type MarkShipmentAsDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
}>;


export type MarkShipmentAsDeletedMutation = { __typename?: 'Mutation', markShipmentAsDeleted: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type MarkShipmentsAsDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkShipmentsAsDeletedMutation = { __typename?: 'Mutation', markShipmentsAsDeleted: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null }> };

export type MarkShipmentAsClosedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
}>;


export type MarkShipmentAsClosedMutation = { __typename?: 'Mutation', markShipmentAsClosed: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type ResetShipmentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  resetBy: Scalars['String'];
}>;


export type ResetShipmentMutation = { __typename?: 'Mutation', resetShipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type UncloseShipmentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
}>;


export type UncloseShipmentMutation = { __typename?: 'Mutation', uncloseShipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type ForceCompleteShipmentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  completedBy: Scalars['String'];
  completeAtOverride?: InputMaybe<Scalars['Timestamp']>;
}>;


export type ForceCompleteShipmentMutation = { __typename?: 'Mutation', forceCompleteShipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type BulkForceCompleteShipmentsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
  completedBy: Scalars['String'];
  completeAtOverride?: InputMaybe<Scalars['Timestamp']>;
  stopIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BulkForceCompleteShipmentsMutation = { __typename?: 'Mutation', bulkForceCompleteShipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null }> };

export type UpdateInternalNoteMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  internalNote: Scalars['String'];
  updatedBy: Scalars['String'];
}>;


export type UpdateInternalNoteMutation = { __typename?: 'Mutation', updateInternalNote: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type AssignDriverForShipmentTemplatesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
  driverId?: InputMaybe<Scalars['ID']>;
}>;


export type AssignDriverForShipmentTemplatesMutation = { __typename?: 'Mutation', assignDriverForShipmentTemplates: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null }> };

export type OverridePodMetadataMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
  signedBy?: InputMaybe<Scalars['String']>;
  deliveredAt?: InputMaybe<Scalars['Timestamp']>;
}>;


export type OverridePodMetadataMutation = { __typename?: 'Mutation', overridePodMetadata: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type OverridePricingDetailMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  unfreeWaitTimeInMinutes?: InputMaybe<Scalars['Float']>;
  adjustmentUpdates?: InputMaybe<Array<PricingAdjustmentUpdate> | PricingAdjustmentUpdate>;
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  updatedBy?: InputMaybe<Scalars['String']>;
}>;


export type OverridePricingDetailMutation = { __typename?: 'Mutation', overridePricingDetail: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type MarkShipmentTemplatesAsDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkShipmentTemplatesAsDeletedMutation = { __typename?: 'Mutation', markShipmentTemplatesAsDeleted: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null }> };

export type ReplaceAllocationMutationVariables = Exact<{
  courierId: Scalars['ID'];
  replacement: DriverPayAllocationReplacement;
}>;


export type ReplaceAllocationMutation = { __typename?: 'Mutation', replaceAllocation: Array<{ __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate?: any | null, allocationAmount?: any | null }> };

export type BulkUnassignDriversFromShipmentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkUnassignDriversFromShipmentMutation = { __typename?: 'Mutation', bulkUnassignDriversFromShipment: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null }> };

export type MarkShipmentsAsClosedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
  closedBy?: InputMaybe<Scalars['String']>;
}>;


export type MarkShipmentsAsClosedMutation = { __typename?: 'Mutation', markShipmentsAsClosed: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null }> };

export type UncloseShipmentsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UncloseShipmentsMutation = { __typename?: 'Mutation', uncloseShipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null }> };

export type ApproveShipmentDetailsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
}>;


export type ApproveShipmentDetailsMutation = { __typename?: 'Mutation', approveShipmentDetails: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type UpsertShipmentTemplateDriverAssignmentsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  upserts: Array<ShipmentTemplateDriverAssignmentUpsertInput> | ShipmentTemplateDriverAssignmentUpsertInput;
}>;


export type UpsertShipmentTemplateDriverAssignmentsMutation = { __typename?: 'Mutation', upsertShipmentTemplateDriverAssignments: Array<{ __typename?: 'ShipmentTemplateDriverAssignment', id: string, shipmentTemplateId: string, driverId: string, dayOfWeek: DayOfTheWeek }> };

export type MarkAsHoldMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkAsHoldMutation = { __typename?: 'Mutation', markAsHold: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null }> };

export type ClearHoldStatusMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ClearHoldStatusMutation = { __typename?: 'Mutation', clearHoldStatus: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null }> };

export type GetShipmentsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  isAssignedFilter?: InputMaybe<Scalars['Boolean']>;
  statusFilter?: InputMaybe<ShipmentStatus>;
  statusListFilter?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  lateByFilter?: InputMaybe<Scalars['Timestamp']>;
  minClosingTimeFilter?: InputMaybe<Scalars['Timestamp']>;
  likelyLateOnlyFilter?: InputMaybe<Scalars['Boolean']>;
  isClosedFilter?: InputMaybe<Scalars['Boolean']>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  endCustomerLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courierBrandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  acquisitionTypes?: InputMaybe<Array<OrderAcquisitionType> | OrderAcquisitionType>;
  dispatchableTypes?: InputMaybe<Array<DispatchableType> | DispatchableType>;
  recurrenceTypes?: InputMaybe<Array<RecurrenceType> | RecurrenceType>;
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  trackingNumbersFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  displayIdsFilter?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  minShipmentDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minCompletedDate?: InputMaybe<Scalars['Date']>;
  maxCompletedDate?: InputMaybe<Scalars['Date']>;
  pickupZoneIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dropOffZoneIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sortFields?: InputMaybe<Array<ShipmentsSorting> | ShipmentsSorting>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  excludeWordsFromNote?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  packageTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderVehicleTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverVehicleTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isAttempted?: InputMaybe<Scalars['Boolean']>;
  minWeightInPounds?: InputMaybe<Scalars['Float']>;
  maxWeightInPounds?: InputMaybe<Scalars['Float']>;
  routeTemplateIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  holdStatusFilter?: InputMaybe<HoldStatus>;
}>;


export type GetShipmentsQuery = { __typename?: 'Query', shipments?: { __typename?: 'ShipmentConnection', edges?: Array<{ __typename?: 'ShipmentEdge', node?: { __typename?: 'Shipment', displayPackageStatuses?: Array<string> | null, id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, dispatchedByUser?: { __typename?: 'CourieUser', id: string, email: string } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null, packageItems?: Array<{ __typename?: 'PackageItem', width?: number | null, height?: number | null, length?: number | null, weight?: number | null, packageTypeId?: string | null, quantity?: number | null }> | null, routingJob?: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string>, canceledBy?: string | null, cancelDescription?: string | null } | null, qualityReviews?: Array<{ __typename?: 'QualityReview', id: string, courierId: string, shipmentId: string, jobStatus: QualityReviewJobStatus, overallVerdict?: QualityReviewVerdict | null, createdAt: any }> | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }>, shipment: { __typename?: 'Shipment', status: ShipmentStatus, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, name: string, color?: string | null } | null }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null, order: { __typename?: 'Order', id: string, name?: string | null, serviceType?: { __typename?: 'ServiceType', id: string, name: string, color?: string | null } | null } } | null }, artifacts: Array<{ __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any }>, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }>, order: { __typename?: 'Order', userHasClicked: boolean, acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, orderGroupOverview?: { __typename?: 'OrderGroupOverview', orderGroupId: string, orderGroupDisplayId: number, label: string, assignmentGroupId?: string | null } | null, createdByUser?: { __typename?: 'CourieUser', id: string, email: string } | null, createdByEndCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, createdByEndUser?: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null, role: EndUserRoleType } | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, createdAt: any, courierBrand?: { __typename?: 'CourierBrand', id: string, courierId: string, name: string, logoUrl?: string | null, email: string, phone?: string | null, streetAddress: string, city: string, state: string, country: string, replyToEmails?: Array<string> | null, ccEmails?: Array<string> | null } | null, courier: { __typename?: 'Courier', id: string }, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, valueNumber?: number | null, valueInteger?: number | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } }>, orderAttachments: Array<{ __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string }>, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, avatarDisplay?: string | null, phone: string, email?: string | null, isActive: boolean } | null, driverPayAllocations: Array<{ __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate?: any | null, allocationAmount?: any | null }>, shipmentTemplate?: { __typename?: 'ShipmentTemplate', order: { __typename?: 'Order', name?: string | null } } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetShipmentCountsForFiltersQueryVariables = Exact<{
  courierId: Scalars['ID'];
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  minShipmentDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minCompletedDate?: InputMaybe<Scalars['Date']>;
  maxCompletedDate?: InputMaybe<Scalars['Date']>;
  now: Scalars['Timestamp'];
  in15Minutes: Scalars['Timestamp'];
  in30Minutes: Scalars['Timestamp'];
  in60Minutes: Scalars['Timestamp'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  trackingNumbersFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  displayIdsFilter?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  orderNameSearch?: InputMaybe<Scalars['String']>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  endCustomerLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courierBrandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  acquisitionTypes?: InputMaybe<Array<OrderAcquisitionType> | OrderAcquisitionType>;
  recurrenceTypes?: InputMaybe<Array<RecurrenceType> | RecurrenceType>;
  pickupZoneIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dropOffZoneIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  packageTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderVehicleTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverVehicleTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  minWeightInPounds?: InputMaybe<Scalars['Float']>;
  maxWeightInPounds?: InputMaybe<Scalars['Float']>;
  hasOrderInternalNote?: InputMaybe<Scalars['Boolean']>;
  hasDriverNoteOnly?: InputMaybe<Scalars['Boolean']>;
  hasWaitTimeOrOverride?: InputMaybe<Scalars['Boolean']>;
  hasMultipleDriverPayOnly?: InputMaybe<Scalars['Boolean']>;
  hasUnapprovedDriverPackageReportOnly?: InputMaybe<Scalars['Boolean']>;
  isDeliveredOnTime?: InputMaybe<Scalars['Boolean']>;
  isAttempted?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetShipmentCountsForFiltersQuery = { __typename?: 'Query', shipmentsOverview: { __typename?: 'ShipmentsOverview', numActive?: number | null, numUnassigned?: number | null, numAssigned?: number | null, numDelivered?: number | null, numClosed?: number | null, numOnHold?: number | null, numLate?: number | null, numLateIn15Minutes?: number | null, numLateIn30Minutes?: number | null, numLateIn60Minutes?: number | null, numLikelyLate?: number | null, customFilterOverviews: Array<{ __typename?: 'CustomFilterOverview', name: string, count: number }> } };

export type ShipmentTemplatesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<ShipmentTemplatesSorting> | ShipmentTemplatesSorting>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverLabelIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  endCustomerLabelIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderLabelIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  simpleSearch?: InputMaybe<Scalars['String']>;
}>;


export type ShipmentTemplatesPaginatedQuery = { __typename?: 'Query', shipmentTemplatesPaginated?: { __typename?: 'ShipmentTemplateConnection', edges?: Array<{ __typename?: 'ShipmentTemplateEdge', node?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null, stopTemplates: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }>, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, customFields?: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null }> | null, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, valueNumber?: number | null, valueInteger?: number | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } }>, holidaySchedule?: { __typename?: 'HolidaySchedule', id: string, name: string } | null, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null, driverAssignments: Array<{ __typename?: 'ShipmentTemplateDriverAssignment', id: string, shipmentTemplateId: string, driverId: string, dayOfWeek: DayOfTheWeek }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ShipmentByIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
}>;


export type ShipmentByIdQuery = { __typename?: 'Query', shipmentById: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, artifacts: Array<{ __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any }>, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, valueNumber?: number | null, valueInteger?: number | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, dispatchedByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } | null, driverPayAllocations: Array<{ __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate?: any | null, allocationAmount?: any | null }> } };

export type GetShipmentsForSalesReportQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  isAssignedFilter?: InputMaybe<Scalars['Boolean']>;
  statusFilter?: InputMaybe<ShipmentStatus>;
  statusListFilter?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  lateByFilter?: InputMaybe<Scalars['Timestamp']>;
  minClosingTimeFilter?: InputMaybe<Scalars['Timestamp']>;
  likelyLateOnlyFilter?: InputMaybe<Scalars['Boolean']>;
  isClosedFilter?: InputMaybe<Scalars['Boolean']>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  endCustomerLabelIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courierBrandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  acquisitionTypes?: InputMaybe<Array<OrderAcquisitionType> | OrderAcquisitionType>;
  recurrenceTypes?: InputMaybe<Array<RecurrenceType> | RecurrenceType>;
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  trackingNumbersFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  displayIdsFilter?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  minShipmentDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minCompletedDate?: InputMaybe<Scalars['Date']>;
  maxCompletedDate?: InputMaybe<Scalars['Date']>;
  sortFields?: InputMaybe<Array<ShipmentsSorting> | ShipmentsSorting>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  serviceTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  excludeWordsFromNote?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  packageTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderVehicleTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverVehicleTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  pickupZoneIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dropOffZoneIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId: Scalars['ID'];
  hasOrderInternalNote?: InputMaybe<Scalars['Boolean']>;
  hasDriverNoteOnly?: InputMaybe<Scalars['Boolean']>;
  hasWaitTimeOrOverride?: InputMaybe<Scalars['Boolean']>;
  hasMultipleDriverPayOnly?: InputMaybe<Scalars['Boolean']>;
  hasUnapprovedDriverPackageReportOnly?: InputMaybe<Scalars['Boolean']>;
  isDeliveredOnTime?: InputMaybe<Scalars['Boolean']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isAttempted?: InputMaybe<Scalars['Boolean']>;
  orderNameSearch?: InputMaybe<Scalars['String']>;
  minWeightInPounds?: InputMaybe<Scalars['Float']>;
  maxWeightInPounds?: InputMaybe<Scalars['Float']>;
  routeTemplateIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  holdStatusFilter?: InputMaybe<HoldStatus>;
}>;


export type GetShipmentsForSalesReportQuery = { __typename?: 'Query', shipments?: { __typename?: 'ShipmentConnection', edges?: Array<{ __typename?: 'ShipmentEdge', node?: { __typename?: 'Shipment', distancesInMeters: number, id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null, packageItems?: Array<{ __typename?: 'PackageItem', width?: number | null, height?: number | null, length?: number | null, weight?: number | null, packageTypeId?: string | null, quantity?: number | null }> | null, stops: Array<{ __typename?: 'Stop', wasLateByInMinutes?: number | null, id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }>, shipment: { __typename?: 'Shipment', status: ShipmentStatus, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, name: string, color?: string | null } | null } }, artifacts: Array<{ __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any }>, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }>, order: { __typename?: 'Order', userHasClicked: boolean, acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, orderGroupOverview?: { __typename?: 'OrderGroupOverview', orderGroupId: string, orderGroupDisplayId: number, label: string, assignmentGroupId?: string | null } | null, orderPayBreakDownWithAllocation?: { __typename?: 'OrderPayBreakDownWithAllocationResult', isOverride: boolean, total: any, allocations: Array<{ __typename?: 'OrderPayBreakDownWithAllocation', driverId?: string | null, allocationRate?: any | null, breakdown: { __typename?: 'OrderPayBreakDown', total: any, items: Array<{ __typename?: 'OrderPayBreakDownItem', name: string, description?: string | null, amount: any }> }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, avatarDisplay?: string | null, phone: string, email?: string | null, isActive: boolean } | null }> } | null, createdByEndCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, createdAt: any, courier: { __typename?: 'Courier', id: string }, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null } | null, createdByEndUser?: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null, role: EndUserRoleType } | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, createdAt: any, courierBrand?: { __typename?: 'CourierBrand', id: string, courierId: string, name: string, logoUrl?: string | null, email: string, phone?: string | null, streetAddress: string, city: string, state: string, country: string, replyToEmails?: Array<string> | null, ccEmails?: Array<string> | null } | null, courier: { __typename?: 'Courier', id: string }, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, orderAttachments: Array<{ __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string }>, price: { __typename?: 'OrderPrice', total: any, taxableTotal: any, nonTaxableTotal: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, totalAfterTax: any, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean, surchargePricingRuleId?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, amountType: SurchargeAmountType } | null }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, orderAcquisitionTypes?: Array<OrderAcquisitionType> | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, minDeliveryTimeInSecondsSinceMidnight?: number | null, maxDeliveryTimeInSecondsSinceMidnight?: number | null, minDeliverByTimeInSecondsSinceMidnight?: number | null, maxDeliverByTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, freeSkidSpaces?: number | null, weightBasis: WeightBasis, surchargePricingRuleIdsToExclude?: Array<string> | null, shouldMultiplyByPackageCount?: boolean | null, readyTimeHolidayScheduleId?: string | null, customFieldIdForApplyType?: string | null, customFieldValueExactMatch?: string | null, customFieldMinValue?: number | null, customFieldMaxValue?: number | null, minimumAmount?: any | null, maximumAmount?: any | null, maximumDriverPay?: any | null, waiveBelowAmount?: any | null, numPerUnit?: number | null, numPerUnitRoundingStrategy: RoundingStrategy, freeWaitTimeOverrideSeconds?: number | null, internalNote?: string | null, applicableStopTypes?: Array<ShipmentStopType> | null, invoiceSummaryGroup?: string | null, taxableStatus: SurchargeTaxStatus, scope?: SurchargeScope | null, advancedMultiplier?: { __typename?: 'SurchargePricingRuleAdvancedMultiplier', packageCountBasedMultipliers: Array<{ __typename?: 'SurchargePackageCountBasedMultiplier', minPackageCount?: number | null, maxPackageCount?: number | null, multiplier: any }> } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null, customField?: { __typename?: 'CustomField', id: string, name: string } | null, customFieldForApplyType?: { __typename?: 'CustomField', id: string, name: string, choices?: Array<string> | null } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, taxBreakDown?: { __typename?: 'OrderPriceTaxBreakdown', totalTaxAmount: any, taxItems: Array<{ __typename?: 'OrderPriceTaxItem', name: string, amount: any }> } | null, tripPrices: Array<{ __typename?: 'OrderPriceTripPrice', scope: PriceScope, pricingRuleDisplay: string, miles: number, amount: any }> }, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, valueNumber?: number | null, valueInteger?: number | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType, isVisibleToDrivers: boolean, choices?: Array<string> | null, orderingSequenceNumber?: number | null, defaultOptionIndex?: number | null, minValue?: number | null, maxValue?: number | null, helperText?: string | null, terms?: { __typename?: 'CustomFieldTermsConfig', triggerChoice: number, courierTermId: string } | null, courierTerm?: { __typename?: 'CourierTerm', id: string, name: string } | null } }>, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', order: { __typename?: 'Order', name?: string | null }, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null, driverPayAllocations: Array<{ __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate?: any | null, allocationAmount?: any | null }>, dispatchedByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetShipmentDistancesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetShipmentDistancesQuery = { __typename?: 'Query', shipmentDistances: Array<{ __typename?: 'ShipmentDistance', shipmentId: string, distanceMeters: number, stopTripDistances: Array<{ __typename?: 'StopTripDistance', sourceStopId: string, destinationStopId: string, sourceStop: { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }, destinationStop: { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }, tripDistance: { __typename?: 'TripDistance', sourceLocationId: string, destinationLocationId: string, distanceInMeters: number, durationInSeconds?: number | null, isOverridden: boolean } }> }> };

export type GetShipmentTemplateDistancesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
  dayOfWeek: DayOfTheWeek;
}>;


export type GetShipmentTemplateDistancesQuery = { __typename?: 'Query', shipmentTemplateDistances: Array<{ __typename?: 'ShipmentTemplateDistance', shipmentTemplateId: string, distanceMeters: number, stopTemplateTripDistances: Array<{ __typename?: 'StopTemplateTripDistance', sourceStopTemplateId: string, destinationStopTemplateId: string, sourceStopTemplate: { __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }, destinationStopTemplate: { __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }, tripDistance: { __typename?: 'TripDistance', sourceLocationId: string, destinationLocationId: string, distanceInMeters: number, durationInSeconds?: number | null } }> }> };

export type StopFragmentFragment = { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, locationValidityType: LocationValidityType, stopSequenceNumber?: number | null, stopConsolidatedSortingNumber?: number | null, orderEntrySequenceNumber?: number | null, completionReason?: StopCompletionReason | null, additionalDriverQuestionListId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> };

export type StopTemplateFragmentFragment = { __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> };

export type UpsertStopTemplateSequenceNumbersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  upserts: Array<ScheduledStopTemplateSequenceNumberUpsert> | ScheduledStopTemplateSequenceNumberUpsert;
}>;


export type UpsertStopTemplateSequenceNumbersMutation = { __typename?: 'Mutation', upsertStopTemplateSequenceNumbers: Array<{ __typename?: 'ScheduledStopTemplateSequenceNumber', id: string, courierId: string, stopTemplateId: string, dayOfWeek?: DayOfTheWeek | null, sequenceNumber?: number | null, stopTemplate: { __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> } }> };

export type ForceCompleteStopsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  stopIds: Array<Scalars['ID']> | Scalars['ID'];
  completedBy: Scalars['String'];
}>;


export type ForceCompleteStopsMutation = { __typename?: 'Mutation', forceCompleteStops: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, invoiceDate?: any | null, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, completionReason?: ShipmentCompletionReason | null, dispatchDelaySecs?: number | null, holdStatus?: HoldStatus | null } };

export type MarkStopTemplatesAsFixedSequenceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentTemplateId: Scalars['ID'];
  stopTemplateIdsInSequence: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkStopTemplatesAsFixedSequenceMutation = { __typename?: 'Mutation', markStopTemplatesAsFixedSequence: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, sequenceNumberInsideShipment?: number | null }> };

export type PrintMemorizationsPdfMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  dayOfWeek: DayOfTheWeek;
}>;


export type PrintMemorizationsPdfMutation = { __typename?: 'Mutation', printMemorizationsPdf: { __typename?: 'StorageFile', id: string, fileName: string, initialUrl?: string | null } };

export type PrintLiveRoutePdfMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  targetDate: Scalars['Date'];
}>;


export type PrintLiveRoutePdfMutation = { __typename?: 'Mutation', printLiveRoutePdf: { __typename?: 'StorageFile', id: string, fileName: string, initialUrl?: string | null } };

export type RevertStopCompletionMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  stopIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RevertStopCompletionMutation = { __typename?: 'Mutation', revertStopCompletion: { __typename?: 'Shipment', id: string } };

export type OverrideStopCompletedTimesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  overrides: Array<StopCompletedTimeOverride> | StopCompletedTimeOverride;
}>;


export type OverrideStopCompletedTimesMutation = { __typename?: 'Mutation', overrideStopCompletedTimes: Array<{ __typename?: 'Stop', id: string }> };

export type CopyMemorizationsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  fromDayOfWeek: DayOfTheWeek;
  toDayOfTheWeeks: Array<DayOfTheWeek> | DayOfTheWeek;
  toDays?: InputMaybe<Array<Scalars['Date']> | Scalars['Date']>;
}>;


export type CopyMemorizationsMutation = { __typename?: 'Mutation', copyMemorizations: Array<{ __typename?: 'MemorizationOnDay', dayOfWeek?: DayOfTheWeek | null }> };

export type MemorizationsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dayOfWeeks?: InputMaybe<Array<DayOfTheWeek> | DayOfTheWeek>;
  days?: InputMaybe<Array<Scalars['Date']> | Scalars['Date']>;
}>;


export type MemorizationsQuery = { __typename?: 'Query', memorizations: { __typename?: 'MemorizationResult', days: Array<{ __typename?: 'MemorizationOnDay', dayOfWeek?: DayOfTheWeek | null, stopTemplateSequenceNumbers: Array<{ __typename?: 'ScheduledStopTemplateSequenceNumber', id: string, courierId: string, stopTemplateId: string, dayOfWeek?: DayOfTheWeek | null, day?: any | null, sequenceNumber?: number | null, stopTemplate: { __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, shipmentTemplate: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> } }>, unmemorizedStopTemplates: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, sequenceNumberInsideShipment?: number | null, shipmentTemplate: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, packageDescription?: string | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, dispatchableType: DispatchableType, billableType: BillableType, caller?: string | null, callerPhone?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, driverPayPercent?: any | null, commissionableBaseFixed?: any | null, commissionableBasePercent?: any | null, endCustomerReferenceNumber?: string | null, id: string, milesOverride?: number | null, priceOverride?: any | null, basePriceOverride?: any | null, taxCodeOverride?: string | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, additionalInfoCount: number, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any, quantity?: number | null }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, everyNWeeksSchedule?: { __typename?: 'EveryNWeeksSchedule', intervalWeeks: number, weekDays: Array<DayOfTheWeek>, startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null }, assignedLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }> }> } };

export type UniqueStopDatesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentStatusFilter?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
}>;


export type UniqueStopDatesQuery = { __typename?: 'Query', uniqueStopDates: Array<any> };

export type MemorizedDaysQueryVariables = Exact<{
  courierId: Scalars['ID'];
  minDay?: InputMaybe<Scalars['Date']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type MemorizedDaysQuery = { __typename?: 'Query', memorizedDays: Array<any> };

export type TaskFragmentFragment = { __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any };

export type StopEtaFragmentFragment = { __typename?: 'StopEta', stopId: string, eta: any, isLikelyLate: boolean, likelyLateByInMinutes?: number | null };

export type ReplaceRouteMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  newStopIds: Array<Scalars['ID']> | Scalars['ID'];
  shipmentDate: Scalars['Date'];
  replacedBy?: InputMaybe<Scalars['String']>;
  orderingAlgorithmType?: InputMaybe<OrderingAlgorithmType>;
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dispatchSource?: InputMaybe<DispatchSource>;
}>;


export type ReplaceRouteMutation = { __typename?: 'Mutation', replaceRoute: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }> };

export type RefreshEtaStaleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
}>;


export type RefreshEtaStaleMutation = { __typename?: 'Mutation', refreshEtaStale: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type UploadFileV1MutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  type: FileType;
  taskId?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
}>;


export type UploadFileV1Mutation = { __typename?: 'Mutation', uploadFileV1: { __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any } };

export type PreviewEtaForRouteQueryVariables = Exact<{
  driverId: Scalars['ID'];
  stopIds: Array<Scalars['ID']> | Scalars['ID'];
  baseTime?: InputMaybe<Scalars['Timestamp']>;
}>;


export type PreviewEtaForRouteQuery = { __typename?: 'Query', previewEtaForRoute?: { __typename?: 'PreviewEtaForRouteResult', stopEtas: Array<{ __typename?: 'StopEta', stopId: string, eta: any, isLikelyLate: boolean, likelyLateByInMinutes?: number | null }> } | null };

export type VisibleColumnsConfigFragmentFragment = { __typename?: 'VisibleColumnsConfig', id: string, salesReportColumnIds?: Array<SalesReportColumnId> | null, driverReportColumnIds?: Array<DriverReportColumnId> | null, userOrEmployeeId: string };

export type UserStoreFragmentFragment = { __typename?: 'UserStore', key: string, value: string };

export type SparseUpdateColumnVisibilityMutationVariables = Exact<{
  courierId: Scalars['String'];
  salesReportColumnIds?: InputMaybe<Array<SalesReportColumnId> | SalesReportColumnId>;
  driverReportColumnIds?: InputMaybe<Array<DriverReportColumnId> | DriverReportColumnId>;
  userOrEmployeeId: Scalars['String'];
  updatedBy: Scalars['String'];
}>;


export type SparseUpdateColumnVisibilityMutation = { __typename?: 'Mutation', sparseUpdateColumnVisibility: { __typename?: 'VisibleColumnsConfig', id: string, salesReportColumnIds?: Array<SalesReportColumnId> | null, driverReportColumnIds?: Array<DriverReportColumnId> | null, userOrEmployeeId: string } };

export type UpsertUserStoreMutationVariables = Exact<{
  courierId: Scalars['ID'];
  userOrEmployeeId: Scalars['ID'];
  key: Scalars['String'];
  value: Scalars['String'];
}>;


export type UpsertUserStoreMutation = { __typename?: 'Mutation', upsertUserStore: { __typename?: 'UserStore', key: string, value: string } };

export type GetVisibleColumnsQueryVariables = Exact<{
  courierId: Scalars['String'];
  userOrEmployeeId: Scalars['String'];
}>;


export type GetVisibleColumnsQuery = { __typename?: 'Query', getVisibleColumns?: { __typename?: 'VisibleColumnsConfig', id: string, salesReportColumnIds?: Array<SalesReportColumnId> | null, driverReportColumnIds?: Array<DriverReportColumnId> | null, userOrEmployeeId: string } | null };

export type GetUserStoresQueryVariables = Exact<{
  courierId: Scalars['ID'];
  userOrEmployeeId: Scalars['ID'];
  keysFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetUserStoresQuery = { __typename?: 'Query', userStores: Array<{ __typename?: 'UserStore', key: string, value: string }> };

export type CourieUserFragmentFragment = { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> };

export type SyncUserWithFirebaseMutationVariables = Exact<{
  email: Scalars['String'];
  firebaseUid: Scalars['String'];
}>;


export type SyncUserWithFirebaseMutation = { __typename?: 'Mutation', syncUserWithFirebase: { __typename?: 'SyncUserWithFirebaseResult', error?: SyncUserWithFirebaseError | null, employeeId?: string | null, user?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } | null } };

export type CreateUserMutationVariables = Exact<{
  courierId: Scalars['String'];
  email: Scalars['String'];
  roleType: UserRoleType;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } };

export type FullUpdateUserMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  email: Scalars['String'];
  roleType: UserRoleType;
  customRoleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FullUpdateUserMutation = { __typename?: 'Mutation', fullUpdateUser: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } };

export type MarkUserAsDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type MarkUserAsDeletedMutation = { __typename?: 'Mutation', markUserAsDeleted: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } };

export type UpdateUserNotificationSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  userId: Scalars['ID'];
  enabledNotificationTypes: Array<NotificationType> | NotificationType;
}>;


export type UpdateUserNotificationSettingsMutation = { __typename?: 'Mutation', updateUserNotificationSettings: Array<NotificationType> };

export type ChangePasswordUserMutationVariables = Exact<{
  courierId: Scalars['ID'];
  userId: Scalars['ID'];
  password: Scalars['String'];
}>;


export type ChangePasswordUserMutation = { __typename?: 'Mutation', changePasswordUser: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } };

export type GetUsersQueryVariables = Exact<{
  courierId: Scalars['ID'];
  after: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'CourieUserConnection', edges?: Array<{ __typename?: 'CourieUserEdge', node?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null, roleType: UserRoleType, enabledNotifications: Array<NotificationType>, computedPermissions: Array<string>, customRoles: Array<{ __typename?: 'CustomRole', id: string, courierId: string, name: string, parentRole: UserRoleType, overrides: Array<{ __typename?: 'PermissionOverride', permission: string, overrideType: OverrideType }> }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type VehicleTypeFragmentFragment = { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null };

export type FullUpdateVehicleTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shortCode: Scalars['String'];
  fuelType?: InputMaybe<FuelType>;
  maxPackageLength?: InputMaybe<Scalars['Float']>;
  maxPackageWidth?: InputMaybe<Scalars['Float']>;
  maxPackageHeight?: InputMaybe<Scalars['Float']>;
}>;


export type FullUpdateVehicleTypeMutation = { __typename?: 'Mutation', fullUpdateVehicleType: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type CreateVehicleTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  shortCode: Scalars['String'];
  fuelType?: InputMaybe<FuelType>;
  maxPackageLength?: InputMaybe<Scalars['Float']>;
  maxPackageWidth?: InputMaybe<Scalars['Float']>;
  maxPackageHeight?: InputMaybe<Scalars['Float']>;
}>;


export type CreateVehicleTypeMutation = { __typename?: 'Mutation', createVehicleType: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type DeleteVehicleTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteVehicleTypeMutation = { __typename?: 'Mutation', deleteVehicleType: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type UpdateVehicleTypeVisiblePackageTypesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  vehicleTypeId: Scalars['ID'];
  visiblePackageTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateVehicleTypeVisiblePackageTypesMutation = { __typename?: 'Mutation', updateVehicleTypeVisiblePackageTypes: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type UpdateVehicleTypeReadyTimeScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  vehicleTypeId: Scalars['ID'];
  readyTimeSchedule: TimeScheduleInput;
}>;


export type UpdateVehicleTypeReadyTimeScheduleMutation = { __typename?: 'Mutation', updateVehicleTypeReadyTimeSchedule: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type GetVehicleTypesQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetVehicleTypesQuery = { __typename?: 'Query', vehicleTypes: Array<{ __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null }> };

export type ZoneFragmentFragment = { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null };

export type CircleZoneFragmentFragment = { __typename?: 'CircleZone', id: string, courierId: string, name: string, minRadiusInMeters: number, maxRadiusInMeters: number, center: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } };

export type CreateZonesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  zones: Array<ZoneCreate> | ZoneCreate;
}>;


export type CreateZonesMutation = { __typename?: 'Mutation', createZones: Array<{ __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null }> };

export type UpdateZonesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  zones: Array<ZoneUpdate> | ZoneUpdate;
}>;


export type UpdateZonesMutation = { __typename?: 'Mutation', updateZones: Array<{ __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null }> };

export type CreateCircleZoneMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  center: LngLatInput;
  minRadiusInMeters: Scalars['Float'];
  maxRadiusInMeters: Scalars['Float'];
}>;


export type CreateCircleZoneMutation = { __typename?: 'Mutation', createCircleZone: { __typename?: 'CircleZone', id: string, courierId: string, name: string, minRadiusInMeters: number, maxRadiusInMeters: number, center: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type UpdateCircleZoneMutationVariables = Exact<{
  id: Scalars['ID'];
  courierId: Scalars['ID'];
  name: Scalars['String'];
  center: LngLatInput;
  minRadiusInMeters: Scalars['Float'];
  maxRadiusInMeters: Scalars['Float'];
}>;


export type UpdateCircleZoneMutation = { __typename?: 'Mutation', updateCircleZone: { __typename?: 'CircleZone', id: string, courierId: string, name: string, minRadiusInMeters: number, maxRadiusInMeters: number, center: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type DeleteCircleZoneMutationVariables = Exact<{
  id: Scalars['ID'];
  courierId: Scalars['ID'];
}>;


export type DeleteCircleZoneMutation = { __typename?: 'Mutation', deleteCircleZone: boolean };

export type UploadZonesFromKmzMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type UploadZonesFromKmzMutation = { __typename?: 'Mutation', uploadZonesFromKmz: { __typename?: 'UploadZonesFromKmzResult', zonesUpserted: number, warnings: Array<string> } };

export type ZonesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  type: ZoneType;
}>;


export type ZonesQuery = { __typename?: 'Query', zones: Array<{ __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> }, assignedLabels?: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> | null }> };

export type CircleZonesQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type CircleZonesQuery = { __typename?: 'Query', circleZones: Array<{ __typename?: 'CircleZone', id: string, courierId: string, name: string, minRadiusInMeters: number, maxRadiusInMeters: number, center: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }> };

export type AnalyticsDashboardFragmentFragment = { __typename?: 'AnalyticsDashboard', id: string, name: string, metabaseDashboardId: string };

export type AddCourierAnalyticsDashboardMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  metabaseDashboardId: Scalars['String'];
}>;


export type AddCourierAnalyticsDashboardMutation = { __typename?: 'Mutation', addCourierAnalyticsDashboard: { __typename?: 'AnalyticsDashboard', id: string, name: string, metabaseDashboardId: string } };

export type GetAnalyticsDashboardsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetAnalyticsDashboardsQuery = { __typename?: 'Query', analyticsDashboards: Array<{ __typename?: 'AnalyticsDashboard', id: string, name: string, metabaseDashboardId: string }> };

export type GetMetabaseJwtTokenQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetMetabaseJwtTokenQuery = { __typename?: 'Query', metabaseJwtToken: string };

export type DriverQuestionListFragmentFragment = { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean };

export type DriverQuestionFragmentFragment = { __typename?: 'DriverQuestion', id: string, courierId: string, question: string, type: DriverQuestionType, requirementType: DriverQuestionRequirementType, customerVisibility: DriverQuestionCustomerVisibility, stopTypes?: Array<ShipmentStopType> | null, sequenceNumber: number, choices?: Array<string> | null, serviceTypeIds?: Array<string> | null, packageTypeIds?: Array<string> | null, stopLabelIds?: Array<string> | null };

export type CreateDriverQuestionListMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  inAdditionToBase?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateDriverQuestionListMutation = { __typename?: 'Mutation', createDriverQuestionList: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } };

export type FullUpdateDriverQuestionListMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  inAdditionToBase?: InputMaybe<Scalars['Boolean']>;
}>;


export type FullUpdateDriverQuestionListMutation = { __typename?: 'Mutation', fullUpdateDriverQuestionList: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } };

export type DeleteDriverQuestionListMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteDriverQuestionListMutation = { __typename?: 'Mutation', deleteDriverQuestionList: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } };

export type MarkDriverQuestionListAsBaseMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  isBase: Scalars['Boolean'];
}>;


export type MarkDriverQuestionListAsBaseMutation = { __typename?: 'Mutation', markDriverQuestionListAsBase: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } };

export type CreateDriverQuestionMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: DriverQuestionCreate;
}>;


export type CreateDriverQuestionMutation = { __typename?: 'Mutation', createDriverQuestion: { __typename?: 'DriverQuestion', id: string, courierId: string, question: string, type: DriverQuestionType, requirementType: DriverQuestionRequirementType, customerVisibility: DriverQuestionCustomerVisibility, stopTypes?: Array<ShipmentStopType> | null, sequenceNumber: number, choices?: Array<string> | null, serviceTypeIds?: Array<string> | null, packageTypeIds?: Array<string> | null, stopLabelIds?: Array<string> | null } };

export type FullUpdateDriverQuestionMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: DriverQuestionUpdate;
}>;


export type FullUpdateDriverQuestionMutation = { __typename?: 'Mutation', fullUpdateDriverQuestion: { __typename?: 'DriverQuestion', id: string, courierId: string, question: string, type: DriverQuestionType, requirementType: DriverQuestionRequirementType, customerVisibility: DriverQuestionCustomerVisibility, stopTypes?: Array<ShipmentStopType> | null, sequenceNumber: number, choices?: Array<string> | null, serviceTypeIds?: Array<string> | null, packageTypeIds?: Array<string> | null, stopLabelIds?: Array<string> | null } };

export type DeleteDriverQuestionMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteDriverQuestionMutation = { __typename?: 'Mutation', deleteDriverQuestion: { __typename?: 'DriverQuestion', id: string, courierId: string, question: string, type: DriverQuestionType, requirementType: DriverQuestionRequirementType, customerVisibility: DriverQuestionCustomerVisibility, stopTypes?: Array<ShipmentStopType> | null, sequenceNumber: number, choices?: Array<string> | null, serviceTypeIds?: Array<string> | null, packageTypeIds?: Array<string> | null, stopLabelIds?: Array<string> | null } };

export type SetDriverQuestionsSequenceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  questionIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetDriverQuestionsSequenceMutation = { __typename?: 'Mutation', setDriverQuestionsSequence: Array<{ __typename?: 'DriverQuestion', id: string, courierId: string, question: string, type: DriverQuestionType, requirementType: DriverQuestionRequirementType, customerVisibility: DriverQuestionCustomerVisibility, stopTypes?: Array<ShipmentStopType> | null, sequenceNumber: number, choices?: Array<string> | null, serviceTypeIds?: Array<string> | null, packageTypeIds?: Array<string> | null, stopLabelIds?: Array<string> | null }> };

export type DriverAnswersByShipmentIdsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DriverAnswersByShipmentIdsQuery = { __typename?: 'Query', driverAnswersByShipmentIds: Array<{ __typename?: 'StopDriverAnswers', stop: { __typename?: 'Stop', id: string, type: ShipmentStopType, streetAddress: string }, answers: Array<{ __typename?: 'DriverAnswer', id: string, answerText?: string | null, answerNumber?: number | null, answerPhotoUrl?: string | null, question: { __typename?: 'DriverQuestion', id: string, question: string, type: DriverQuestionType } }> }> };

export type DriverQuestionListsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type DriverQuestionListsQuery = { __typename?: 'Query', driverQuestionLists: Array<{ __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean }> };

export type DriverQuestionsInListQueryVariables = Exact<{
  courierId: Scalars['ID'];
  listId: Scalars['ID'];
}>;


export type DriverQuestionsInListQuery = { __typename?: 'Query', driverQuestionsInList: Array<{ __typename?: 'DriverQuestion', id: string, courierId: string, question: string, type: DriverQuestionType, requirementType: DriverQuestionRequirementType, customerVisibility: DriverQuestionCustomerVisibility, stopTypes?: Array<ShipmentStopType> | null, sequenceNumber: number, choices?: Array<string> | null, serviceTypeIds?: Array<string> | null, packageTypeIds?: Array<string> | null, stopLabelIds?: Array<string> | null, serviceTypes: Array<{ __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, externalId?: string | null, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, dueTimeInDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, visibleVehicleTypeIds?: Array<string> | null, defaultVehicleTypeId?: string | null, milesLimit?: number | null, extraSecondsPerMilePastLimit?: number | null, pickupCloseType?: ServiceTypeDueTimeType | null, pickupCloseTimeInMinutes?: number | null, pickupCloseTimeInSecondsSinceMidnight?: number | null, pickupCloseTimeInBusinessDaysAfter?: number | null, pickupCloseTimeInDaysAfter?: number | null, orderingSequenceNumber?: number | null, freeWaitTimeInSeconds?: number | null, multiplier?: any | null, multiplierMode: ServiceTypeMultiplierMode, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null, businessHoursSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null }>, packageTypes: Array<{ __typename?: 'PackageType', id: string, courierId: string, name: string, defaultLength?: number | null, defaultWidth?: number | null, defaultHeight?: number | null, defaultWeight?: number | null, defaultWeightApplication: PackageTypeDefaultWeightApplication, category: PackageTypeCategory, enabled: boolean }>, stopLabels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> }> };

export type FullUpdateLabelMutationVariables = Exact<{
  courierId: Scalars['ID'];
  labelId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type FullUpdateLabelMutation = { __typename?: 'Mutation', fullUpdateLabel: { __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null } };

export type DeleteLabelMutationVariables = Exact<{
  courierId: Scalars['ID'];
  labelId: Scalars['ID'];
}>;


export type DeleteLabelMutation = { __typename?: 'Mutation', deleteLabel: boolean };

export type GetAllLabelsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetAllLabelsQuery = { __typename?: 'Query', labels: Array<{ __typename?: 'Label', id: string, courierId: string, entityType: LabelEntityType, name: string, color?: string | null }> };

export type LocationScanCodeFragmentFragment = { __typename?: 'LocationScanCode', id: string, courierId: string, code: string, addressDisplay: string, referenceLocationId?: string | null, suite?: string | null, requirementType: LocationScanRequirement, description?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } };

export type CreateLocationScanCodeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  code: Scalars['String'];
  locationId: Scalars['ID'];
  suite?: InputMaybe<Scalars['String']>;
  requirementType?: InputMaybe<LocationScanRequirement>;
  description?: InputMaybe<Scalars['String']>;
  createdBy: Scalars['String'];
}>;


export type CreateLocationScanCodeMutation = { __typename?: 'Mutation', createLocationScanCode: { __typename?: 'LocationScanCode', id: string, courierId: string, code: string, addressDisplay: string, referenceLocationId?: string | null, suite?: string | null, requirementType: LocationScanRequirement, description?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type FullUpdateLocationScanCodeMutationVariables = Exact<{
  courierId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  code: Scalars['String'];
  locationId: Scalars['ID'];
  suite?: InputMaybe<Scalars['String']>;
  requirementType?: InputMaybe<LocationScanRequirement>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type FullUpdateLocationScanCodeMutation = { __typename?: 'Mutation', fullUpdateLocationScanCode: { __typename?: 'LocationScanCode', id: string, courierId: string, code: string, addressDisplay: string, referenceLocationId?: string | null, suite?: string | null, requirementType: LocationScanRequirement, description?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type DeleteLocationScanCodeMutationVariables = Exact<{
  courierId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
}>;


export type DeleteLocationScanCodeMutation = { __typename?: 'Mutation', deleteLocationScanCode: { __typename?: 'LocationScanCode', id: string, courierId: string, code: string, addressDisplay: string, referenceLocationId?: string | null, suite?: string | null, requirementType: LocationScanRequirement, description?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type UpdateLocationScanCodeEndCustomerIdsMutationVariables = Exact<{
  courierId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateLocationScanCodeEndCustomerIdsMutation = { __typename?: 'Mutation', updateLocationScanCodeEndCustomerIds: { __typename?: 'LocationScanCode', id: string, courierId: string, code: string, addressDisplay: string, referenceLocationId?: string | null, suite?: string | null, requirementType: LocationScanRequirement, description?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type LocationScanCodesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  after?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  requirementTypeFilter?: InputMaybe<LocationScanRequirement>;
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sortFields?: InputMaybe<Array<LocationScanCodesSorting> | LocationScanCodesSorting>;
}>;


export type LocationScanCodesPaginatedQuery = { __typename?: 'Query', locationScanCodesPaginated: { __typename?: 'LocationScanCodeConnection', edges: Array<{ __typename?: 'LocationScanCodeEdge', node: { __typename?: 'LocationScanCode', id: string, courierId: string, code: string, addressDisplay: string, referenceLocationId?: string | null, suite?: string | null, requirementType: LocationScanRequirement, description?: string | null, endCustomers: Array<{ __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, externalId?: string | null, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, payrollPricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, defaultServiceTypeId?: string | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, accountStatus: EndCustomerAccountStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, billingStreetAddress?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingZip?: string | null, note?: string | null, scanRequirementType: ScanRequirement, holidayScheduleId?: string | null, additionalRequiredFields?: Array<CustomerPortalAdditionalRequiredFields> | null, dispatcherOrderEntryAdditionalFields?: Array<DispatcherOrderEntryAdditionalField> | null, preAuthorizeAmountMinimum?: any | null, preAuthorizeAmountMultiplier?: any | null, stopCompletionGuard?: StopCompletionGuard | null, invoiceCycleStartDate?: any | null, pickupPodRequirement?: PodRequirementAtStop | null, dropoffPodRequirement?: PodRequirementAtStop | null, returnPodRequirement?: PodRequirementAtStop | null, salesTermId?: string | null, excludeConvenienceFees: boolean, portalPriceVisibilityOverride?: EndCustomerPriceVisibilityType | null, billingCustomerId?: string | null, createdAt: any, billingCustomer?: { __typename?: 'EndCustomer', id: string, companyName?: string | null } | null, courier: { __typename?: 'Courier', id: string }, accountComments: Array<{ __typename?: 'EndCustomerComment', id: string, text: string, createdAt: any, createdBy: string }>, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, payrollPricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string, fallbackToBasePricingList: boolean } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, emailTemplateGroup?: { __typename?: 'EmailTemplateGroup', id: string, name: string, isDefault: boolean } | null, driverQuestionList?: { __typename?: 'DriverQuestionList', id: string, courierId: string, name: string, isBase: boolean, inAdditionToBase: boolean } | null }>, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type OverrideOrderMilesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
  milesOverride?: InputMaybe<Scalars['Float']>;
}>;


export type OverrideOrderMilesMutation = { __typename?: 'Mutation', overrideOrderMiles: { __typename?: 'Order', id: string, milesOverride?: number | null } };

export type PackageFragmentFragment = { __typename?: 'Package', id: string, courierId: string, reference: string, status: PackageStatus, createdAt: any };

export type PackageEventFragmentFragment = { __typename?: 'PackageEvent', id: string, courierId: string, packageId: string, packageEventTypeId?: string | null, action: PackageEventPostAction, packageStatus: PackageStatus, fromParty?: string | null, toParty?: string | null, deviceTime?: string | null, deviceId?: string | null, eventBy: string, createdAt: string, eventTypeName: string, lngLat?: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } | null };

export type GetPackagesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  statuses?: InputMaybe<Array<PackageStatus> | PackageStatus>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPackagesPaginatedQuery = { __typename?: 'Query', packagesPaginated?: { __typename?: 'PackageConnection', edges?: Array<{ __typename?: 'PackageEdge', node?: { __typename?: 'Package', id: string, courierId: string, reference: string, status: PackageStatus, createdAt: any, events: Array<{ __typename?: 'PackageEvent', id: string, courierId: string, packageId: string, packageEventTypeId?: string | null, action: PackageEventPostAction, packageStatus: PackageStatus, fromParty?: string | null, toParty?: string | null, deviceTime?: string | null, deviceId?: string | null, eventBy: string, createdAt: string, eventTypeName: string, eventByDriver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null, packageEventType?: { __typename?: 'PackageEventType', id: string, name: string, action: PackageEventPostAction, packageScanNewPackageHandleType: PackageScanNewPackageHandleType, reassignDriverId?: string | null, driverAssignmentValidationType: DriverAssignmentValidationType } | null, lngLat?: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } | null }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type CreatePartnerMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
  associatedCourierIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreatePartnerMutation = { __typename?: 'Mutation', createPartner: { __typename?: 'Partner', id: string, name: string, apiKey?: string | null } };

export type PartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnersQuery = { __typename?: 'Query', partners: Array<{ __typename?: 'Partner', id: string, name: string, apiKey?: string | null, courierIds: Array<string> }> };

export type GetCouriersForPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCouriersForPartnersQuery = { __typename?: 'Query', couriers: Array<{ __typename?: 'Courier', id: string, name: string, externalId?: string | null }> };

export type PackageEventTypeFragmentFragment = { __typename?: 'PackageEventType', id: string, name: string, action: PackageEventPostAction, packageScanNewPackageHandleType: PackageScanNewPackageHandleType, reassignDriverId?: string | null, driverAssignmentValidationType: DriverAssignmentValidationType };

export type CreatePackageEventTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  action: PackageEventPostAction;
  packageScanNewPackageHandleType: PackageScanNewPackageHandleType;
  reassignDriverId?: InputMaybe<Scalars['ID']>;
  driverAssignmentValidationType?: InputMaybe<DriverAssignmentValidationType>;
}>;


export type CreatePackageEventTypeMutation = { __typename?: 'Mutation', createPackageEventType: { __typename?: 'PackageEventType', id: string, name: string, action: PackageEventPostAction, packageScanNewPackageHandleType: PackageScanNewPackageHandleType, reassignDriverId?: string | null, driverAssignmentValidationType: DriverAssignmentValidationType } };

export type FullUpdatePackageEventTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  action: PackageEventPostAction;
  packageScanNewPackageHandleType: PackageScanNewPackageHandleType;
  reassignDriverId?: InputMaybe<Scalars['ID']>;
  driverAssignmentValidationType?: InputMaybe<DriverAssignmentValidationType>;
}>;


export type FullUpdatePackageEventTypeMutation = { __typename?: 'Mutation', fullUpdatePackageEventType: { __typename?: 'PackageEventType', id: string, name: string, action: PackageEventPostAction, packageScanNewPackageHandleType: PackageScanNewPackageHandleType, reassignDriverId?: string | null, driverAssignmentValidationType: DriverAssignmentValidationType } };

export type DeletePackageEventTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeletePackageEventTypeMutation = { __typename?: 'Mutation', deletePackageEventType: { __typename?: 'PackageEventType', id: string, name: string, action: PackageEventPostAction, packageScanNewPackageHandleType: PackageScanNewPackageHandleType, reassignDriverId?: string | null, driverAssignmentValidationType: DriverAssignmentValidationType } };

export type GetPackageEventTypesQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetPackageEventTypesQuery = { __typename?: 'Query', packageEventTypes: Array<{ __typename?: 'PackageEventType', id: string, name: string, action: PackageEventPostAction, packageScanNewPackageHandleType: PackageScanNewPackageHandleType, reassignDriverId?: string | null, driverAssignmentValidationType: DriverAssignmentValidationType, reassignDriver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, avatarDisplay?: string | null, appVersion?: string | null, weightCapacityInPounds?: number | null, icCompanyName?: string | null, hasTaxId: boolean, odometerRequirement: OdometerRequirementType, deactivatedAt?: any | null, deactivationScheduledAt?: any | null, dailyEarningTarget?: any | null, displayStreetAddress?: string | null, displayCity?: string | null, displayState?: string | null, displayZip?: string | null, displayCountry?: string | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, locationValidityType: LocationValidityType, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string, allowOrdersWith: boolean, fuelType: FuelType, visiblePackageTypeIds?: Array<string> | null, maxPackageLength?: number | null, maxPackageWidth?: number | null, maxPackageHeight?: number | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } | null }> };

export type CourierOfflineSettingsFragmentFragment = { __typename?: 'CourierOfflineSettings', podValidation: OfflineValidationMode, scanValidation: OfflineValidationMode, gpsValidation: OfflineValidationMode, locationScanValidation: OfflineValidationMode, questionValidation: OfflineValidationMode };

export type UpsertCourierOfflineSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  podValidation: OfflineValidationMode;
  scanValidation: OfflineValidationMode;
  gpsValidation: OfflineValidationMode;
  locationScanValidation: OfflineValidationMode;
  questionValidation: OfflineValidationMode;
}>;


export type UpsertCourierOfflineSettingsMutation = { __typename?: 'Mutation', upsertCourierOfflineSettings: { __typename?: 'CourierOfflineSettings', podValidation: OfflineValidationMode, scanValidation: OfflineValidationMode, gpsValidation: OfflineValidationMode, locationScanValidation: OfflineValidationMode, questionValidation: OfflineValidationMode } };

export type CourierOfflineSettingsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type CourierOfflineSettingsQuery = { __typename?: 'Query', courierOfflineSettings: { __typename?: 'CourierOfflineSettings', podValidation: OfflineValidationMode, scanValidation: OfflineValidationMode, gpsValidation: OfflineValidationMode, locationScanValidation: OfflineValidationMode, questionValidation: OfflineValidationMode } };

export const ActivityFragmentFragmentDoc = gql`
    fragment ActivityFragment on Activity {
  id
  courierId
  entityId
  entityType
  infoType
  description
  time
  date
  imageUrl
  offlineMode
  createdAt
  updatedByEmail
}
    `;
export const ActivitySnapshotEntryFragmentFragmentDoc = gql`
    fragment ActivitySnapshotEntryFragment on ActivitySnapshotEntry {
  key
  value
}
    `;
export const ActivitySnapshotFragmentFragmentDoc = gql`
    fragment ActivitySnapshotFragment on ActivitySnapshot {
  value
  entries {
    ...ActivitySnapshotEntryFragment
  }
}
    ${ActivitySnapshotEntryFragmentFragmentDoc}`;
export const LngLatFragmentFragmentDoc = gql`
    fragment LngLatFragment on LngLat {
  lng
  lat
}
    `;
export const LocationFragmentFragmentDoc = gql`
    fragment LocationFragment on Location {
  id
  streetAddress
  city
  state
  zipCode
  country
  lngLat {
    ...LngLatFragment
  }
  googlePlaceId
  locationValidityType
}
    ${LngLatFragmentFragmentDoc}`;
export const AddressBookFragmentFragmentDoc = gql`
    fragment AddressBookFragment on AddressBookEntry {
  id
  endCustomerId
  contactName
  companyName
  phone
  suite
  location {
    ...LocationFragment
  }
  instruction
  emailRecipients
}
    ${LocationFragmentFragmentDoc}`;
export const PhotoReviewSettingFragmentFragmentDoc = gql`
    fragment PhotoReviewSettingFragment on PhotoReviewSetting {
  checkPhotoClarity
  checkPackageVisibility
  checkDeliveryConfirmation
  checkInappropriateContent
  userPrompt
}
    `;
export const PricingReviewSettingFragmentFragmentDoc = gql`
    fragment PricingReviewSettingFragment on PricingReviewSetting {
  ignoreOverriddenPrices
  checkZeroMainPrice
  checkMissingSurcharges
  checkMissingWaitTimeSurcharge
  checkIncorrectInformation
  userPrompt
}
    `;
export const OtherReviewSettingFragmentFragmentDoc = gql`
    fragment OtherReviewSettingFragment on OtherReviewSetting {
  userPrompt
}
    `;
export const QualityReviewAgentSettingFragmentFragmentDoc = gql`
    fragment QualityReviewAgentSettingFragment on QualityReviewAgentSetting {
  closeGoodQualityOrdersAutomatically
  photoReview {
    ...PhotoReviewSettingFragment
  }
  pricingReview {
    ...PricingReviewSettingFragment
  }
  otherReview {
    ...OtherReviewSettingFragment
  }
}
    ${PhotoReviewSettingFragmentFragmentDoc}
${PricingReviewSettingFragmentFragmentDoc}
${OtherReviewSettingFragmentFragmentDoc}`;
export const CustomerSupportAgentSettingFragmentFragmentDoc = gql`
    fragment CustomerSupportAgentSettingFragment on CustomerSupportAgentSetting {
  orderingEnabled
  cancelEnabled
  updateEnabled
  generalInformation
  frequentlyAskedQuestions {
    question
    answer
  }
  orderEntryInstruction
  generalInstruction
}
    `;
export const AgentDetailsFragmentFragmentDoc = gql`
    fragment AgentDetailsFragment on AgentDetails {
  qualityReviewAgentDetails {
    ...QualityReviewAgentSettingFragment
  }
  customerSupportAgentDetails {
    ...CustomerSupportAgentSettingFragment
  }
}
    ${QualityReviewAgentSettingFragmentFragmentDoc}
${CustomerSupportAgentSettingFragmentFragmentDoc}`;
export const AgentFragmentFragmentDoc = gql`
    fragment AgentFragment on Agent {
  id
  courierId
  agentType
  optedIn
  details {
    ...AgentDetailsFragment
  }
}
    ${AgentDetailsFragmentFragmentDoc}`;
export const ArtifactFragmentFragmentDoc = gql`
    fragment ArtifactFragment on Artifact {
  id
  value
  courierId
  stopId
  taskId
  type
  publicUrl
  createdAt
}
    `;
export const CostCenterFragmentFragmentDoc = gql`
    fragment CostCenterFragment on CostCenter {
  id
  endCustomerId
  name
  locationId
  suite
  email
  phone
}
    `;
export const CourierFragmentFragmentDoc = gql`
    fragment CourierFragment on Courier {
  id
  name
  displayName
  primaryPhoneNumber
  primaryEmail
  isTestAccount
  startDate
  customerPortalPath
  logoUrl
  timeZoneId
  finixMerchantId
  defaultCurrency
  currencyDisplay
  distanceUnit
  weightUnit
  dimFactor
  defaultWeightBasis
  driverTaskVisibilityType
  driverPriceVisibilityType
  driverPayStatementVisibility
  customerPortalOrderEntryType
  endCustomerPriceVisibilityType
  dispatcherOrderEntryAdditionalFields
  customerPortalAdditionalRequiredFields
  estimatedDwellTimeAtStopInSeconds
  pricingDistanceSource
  pickupPodRequirementType
  dropOffPodRequirementType
  returnPodRequirementType
  invoiceCycleStartDate
  defaultInvoicingFrequency
  defaultPricingListId
  defaultPreAuthorizeAmountMinimum
  defaultPreAuthorizeAmountMultiplier
  defaultInvoiceTaxCodeName
  freeWaitTimeInSeconds
  minimumTimeRequiredForWaitTimeSurchargeInSeconds
  customerPortalNewCustomerPaymentMethodPromptType
  customerPortalDeliverByTimeVisibility
  customerPortalNotice
  timeFormatPreference
  stopCompletionGuard
  gpsRestrictionType
  addressBookAutoFillType
  orderEntryDefaultAddressAutoFillType
  addressBookSavingType
  locationIdentifyTypesPickUp
  locationIdentifyTypesDropOff
  pickupCloseTimesSetting
  maxDistanceToCompleteTaskInMeters
  orderPriceTaxDisplayType
  multiStopPricingSequenceType
  multiStopsOptimizationType
  liveRouteSequencingType
  orderIdentifierColumnType
  invoiceApprovalPreconditionType
  invoiceOrdersInclusionType
  billingStreetAddress
  billingCity
  billingState
  billingCountry
  billingZip
  shipmentsCustomFilters {
    filters {
      name
      endCustomerIds
      serviceTypeIds
      shipmentStatuses
      excludeWordsFromNote
      driverIds
      isConfirmed
      isAttempted
      recurrenceTypes
    }
  }
}
    `;
export const CourierBrandFragmentFragmentDoc = gql`
    fragment CourierBrandFragment on CourierBrand {
  id
  courierId
  name
  logoUrl
  email
  phone
  streetAddress
  city
  state
  country
  replyToEmails
  ccEmails
}
    `;
export const CustomFieldFragmentFragmentDoc = gql`
    fragment CustomFieldFragment on CustomField {
  id
  name
  type
  customerVisibilityType
  customerSpecificityType
  requirementType
  isVisibleToDrivers
  choices
  orderingSequenceNumber
  defaultOptionIndex
  minValue
  maxValue
  helperText
  terms {
    triggerChoice
    courierTermId
  }
  courierTerm {
    id
    name
  }
}
    `;
export const CustomFieldValueFragmentFragmentDoc = gql`
    fragment CustomFieldValueFragment on CustomFieldValue {
  fieldId
  entityId
  courierId
  valueDisplay
  valueText
  valueNumber
  valueInteger
}
    `;
export const DispatchPreviewFragmentFragmentDoc = gql`
    fragment DispatchPreviewFragment on DispatchPreview {
  shipmentId
  shipmentDate
  distanceInMeters
  durationInSeconds
  distanceAdditionalInMeters
  durationAdditionalInSeconds
  remainingWorkloadInSeconds
  numCurrentTasks
  tags
}
    `;
export const DriverDailyWorkFragmentFragmentDoc = gql`
    fragment DriverDailyWorkFragment on DriverDailyWork {
  date
  workDurationInMinutes
  isConsistentEvents
  milesByOdometer
  dailyRegularWorkDuration
  dailyOvertimeWorkDuration
}
    `;
export const DriverReportItemFragmentFragmentDoc = gql`
    fragment DriverReportItemFragment on DriverReportItem {
  driverId
  startDate
  endDate
  workDurations {
    ...DriverDailyWorkFragment
  }
  regularHourlyRate
  overtimeHourlyRate
  reimbursementPerMile
  totalMilesByGPS
  mileageReimbursementMethod
  numCompletedOrder
  deductions {
    name
    amountTotal
  }
  totalCommission
  totalMilesByOdometer
  totalWorkDurationInMinutes
  regularDailyCalculatedWorkDurationInMinutes
  overtimeDailyCalculatedWorkDurationInMinutes
  totalWorkDurationInHours
  regularDailyCalculatedWorkDurationInHours
  overtimeDailyCalculatedWorkDurationInHours
  numDaysWorked
  wageRegular
  wageOvertime
  wageTotal
  mileageReimbursement
  wageTotalWithMileageReimbursement
  totalPay
  totalRevenue
  suggestedBonus
}
    ${DriverDailyWorkFragmentFragmentDoc}`;
export const DriversReportFileFragmentFragmentDoc = gql`
    fragment DriversReportFileFragment on DriversReportFile {
  url
}
    `;
export const VehicleTypeFragmentFragmentDoc = gql`
    fragment VehicleTypeFragment on VehicleType {
  id
  courierId
  name
  shortCode
  allowOrdersWith
  fuelType
  visiblePackageTypeIds
  maxPackageLength
  maxPackageWidth
  maxPackageHeight
  readyTimeSchedule {
    weekDailyList {
      days
      startTimeSecondsSinceMidnight
      endTimeSecondsSinceMidnight
    }
  }
}
    `;
export const DriverFragmentFragmentDoc = gql`
    fragment DriverFragment on Driver {
  id
  firstName
  lastName
  photoUrl
  phone
  email
  isActive
  commission
  workType
  selfRoutingType
  speed
  employmentType
  hourlyRateRegular
  hourlyRateOvertime
  mileageRate
  avatarDisplay
  appVersion
  weightCapacityInPounds
  icCompanyName
  hasTaxId
  odometerRequirement
  deactivatedAt
  deactivationScheduledAt
  dailyEarningTarget
  displayStreetAddress
  displayCity
  displayState
  displayZip
  displayCountry
  homeLocation {
    ...LocationFragment
  }
  vehicleType {
    ...VehicleTypeFragment
  }
}
    ${LocationFragmentFragmentDoc}
${VehicleTypeFragmentFragmentDoc}`;
export const VehicleFragmentFragmentDoc = gql`
    fragment VehicleFragment on Vehicle {
  id
  driverId
  transportationType
}
    `;
export const DriverLocationFragmentFragmentDoc = gql`
    fragment DriverLocationFragment on DriverLocation {
  lastReportedTime
  lngLat {
    ...LngLatFragment
  }
}
    ${LngLatFragmentFragmentDoc}`;
export const BreadcrumbCurveFragmentFragmentDoc = gql`
    fragment BreadcrumbCurveFragment on DriverBreadcrumbCurve {
  locations {
    ...DriverLocationFragment
  }
}
    ${DriverLocationFragmentFragmentDoc}`;
export const DriverScheduleForDateFragmentFragmentDoc = gql`
    fragment DriverScheduleForDateFragment on DriverScheduleForDate {
  driverId
  date
  labels
  emailSentAt
  confirmedAt
  hasWorkloadChanged
}
    `;
export const DriverScheduleTimeBlockFragmentFragmentDoc = gql`
    fragment DriverScheduleTimeBlockFragment on DriverScheduleTimeBlock {
  start
  end
}
    `;
export const DriverTimeEventFragmentFragmentDoc = gql`
    fragment DriverTimeEventFragment on DriverTimeEvent {
  id
  date
  driverId
  courierId
  eventType
  reason
  odometerInMiles
  updatedBy
  eventAt
}
    `;
export const EmailTemplateFragmentFragmentDoc = gql`
    fragment EmailTemplateFragment on EmailTemplate {
  id
  subject
  body
  emailTypeId
}
    `;
export const EndUserFragmentFragmentDoc = gql`
    fragment EndUserFragment on EndUser {
  id
  courierId
  endCustomerId
  email
  phone
  firstName
  lastName
  firebaseUid
  role
}
    `;
export const EndCustomerCommunicationFragmentFragmentDoc = gql`
    fragment EndCustomerCommunicationFragment on EndCustomerCommunication {
  id
  courierId
  endCustomerId
  orderId
  shipmentId
  stopId
  communicationTypeId
  emailId
  idempotencyToken
  createdAt
  dateCreated
}
    `;
export const PricingListFragmentFragmentDoc = gql`
    fragment PricingListFragment on PricingList {
  id
  displayId
  courierId
  name
  fallbackToBasePricingList
}
    `;
export const EmailTemplateGroupFragmentFragmentDoc = gql`
    fragment EmailTemplateGroupFragment on EmailTemplateGroup {
  id
  name
  isDefault
}
    `;
export const DriverQuestionListFragmentFragmentDoc = gql`
    fragment DriverQuestionListFragment on DriverQuestionList {
  id
  courierId
  name
  isBase
  inAdditionToBase
}
    `;
export const EndCustomerFragmentFragmentDoc = gql`
    fragment EndCustomerFragment on EndCustomer {
  id
  courierId
  companyName
  contactPhoneNumber
  contactEmail
  firstName
  lastName
  displayId
  externalId
  suite
  invoicingFrequency
  pricingListId
  payrollPricingListId
  visibleServiceTypeIds
  defaultServiceTypeId
  podEmails
  firebaseUid
  taxCode
  newCustomerConfirmationStatus
  accountStatus
  endCustomerCreatedSource
  enabledCommunicationTypes
  totalPricingMultiplier
  billingEmails
  billingStreetAddress
  billingCity
  billingState
  billingCountry
  billingZip
  note
  scanRequirementType
  holidayScheduleId
  additionalRequiredFields
  dispatcherOrderEntryAdditionalFields
  preAuthorizeAmountMinimum
  preAuthorizeAmountMultiplier
  stopCompletionGuard
  invoiceCycleStartDate
  pickupPodRequirement
  dropoffPodRequirement
  returnPodRequirement
  salesTermId
  excludeConvenienceFees
  portalPriceVisibilityOverride
  billingCustomerId
  billingCustomer {
    id
    companyName
  }
  createdAt
  courier {
    id
  }
  accountComments {
    id
    text
    createdAt
    createdBy
  }
  pricingList {
    ...PricingListFragment
  }
  payrollPricingList {
    ...PricingListFragment
  }
  location {
    ...LocationFragment
  }
  emailTemplateGroup {
    ...EmailTemplateGroupFragment
  }
  driverQuestionList {
    ...DriverQuestionListFragment
  }
}
    ${PricingListFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${EmailTemplateGroupFragmentFragmentDoc}
${DriverQuestionListFragmentFragmentDoc}`;
export const EndCustomerListItemFragmentFragmentDoc = gql`
    fragment EndCustomerListItemFragment on EndCustomer {
  id
  courierId
  companyName
  contactPhoneNumber
  contactEmail
  firstName
  lastName
  displayId
  externalId
  suite
  invoicingFrequency
  pricingListId
  payrollPricingListId
  visibleServiceTypeIds
  defaultServiceTypeId
  podEmails
  firebaseUid
  taxCode
  newCustomerConfirmationStatus
  accountStatus
  endCustomerCreatedSource
  enabledCommunicationTypes
  totalPricingMultiplier
  billingEmails
  note
  scanRequirementType
  holidayScheduleId
  additionalRequiredFields
  dispatcherOrderEntryAdditionalFields
  preAuthorizeAmountMinimum
  preAuthorizeAmountMultiplier
  stopCompletionGuard
  invoiceCycleStartDate
  pickupPodRequirement
  dropoffPodRequirement
  returnPodRequirement
  salesTermId
  portalPriceVisibilityOverride
  createdAt
  courier {
    id
  }
  pricingList {
    ...PricingListFragment
  }
  payrollPricingList {
    ...PricingListFragment
  }
}
    ${PricingListFragmentFragmentDoc}`;
export const CourierHolidayFragmentFragmentDoc = gql`
    fragment CourierHolidayFragment on CourierHoliday {
  id
  name
  recurrenceRule
}
    `;
export const HolidayScheduleFragmentFragmentDoc = gql`
    fragment HolidayScheduleFragment on HolidaySchedule {
  id
  name
}
    `;
export const HolidayScheduleBehaviorFragmentFragmentDoc = gql`
    fragment HolidayScheduleBehaviorFragment on HolidayScheduleBehavior {
  holidayScheduleId
  courierHolidayId
  behavior
  name
  recurrenceRule
}
    `;
export const InvoiceFragmentFragmentDoc = gql`
    fragment InvoiceFragment on Invoice {
  id
  displayId
  invoiceNumber
  courierId
  endCustomerId
  costCenterId
  startDate
  endDate
  status
  amountTotal
  isForceGenerated
  invoicePaymentStatus
  paymentSource
  separateGenerationType
  separateGenerationKey
  endCustomerPayLink
  approvedAt
  createdAt
  refundedAt
}
    `;
export const InvoiceDocumentFragmentFragmentDoc = gql`
    fragment InvoiceDocumentFragment on InvoiceDocument {
  id
  invoiceId
  invoicePdfTemplateId
  url
}
    `;
export const InvoicePdfTemplateFragmentFragmentDoc = gql`
    fragment InvoicePdfTemplateFragment on InvoicePdfTemplate {
  id
  courierId
  name
  isDefault
  separateGenerationType
  subtotalGroupedByType
  subtotalGroupedByCustomFieldId
  subtotalPageBreakType
  summaryDisplayType
  columnsWithWidth {
    column
    widthPercentage
  }
  detailColumnFields
  returnSlipType
  orderCombinationType
  marginLeft
  tableContentFontSize
  largeTextFontSize
  smallTextFontSize
  showTableBorder
  brandColor
  labelColor
  borderSize
  finalMessage
}
    `;
export const LinkedAccountFragmentFragmentDoc = gql`
    fragment LinkedAccountFragment on LinkedAccount {
  id
  courierId
  remoteId
  name
  provider
  accountExpiresAt
  isValid
}
    `;
export const TripDistanceOverrideFragmentFragmentDoc = gql`
    fragment TripDistanceOverrideFragment on TripDistanceOverride {
  id
  courierId
  sourceLocationId
  destinationLocationId
  distanceInMeters
  durationInSeconds
  overriddenBy
  createdAt
  updatedAt
  originLocation {
    ...LocationFragment
  }
  destinationLocation {
    ...LocationFragment
  }
}
    ${LocationFragmentFragmentDoc}`;
export const RoutingNodeFragmentFragmentDoc = gql`
    fragment RoutingNodeFragment on RoutingNode {
  id
  jobId
  isNewAssignment
  assignedRouteSequenceNumber
}
    `;
export const RoutingVehicleFragmentFragmentDoc = gql`
    fragment RoutingVehicleFragment on RoutingVehicle {
  id
  jobId
  startLocation {
    ...LocationFragment
  }
  endLocation {
    ...LocationFragment
  }
  startTime
  endTime
  useDriverCurrentLocationAtStart
}
    ${LocationFragmentFragmentDoc}`;
export const RoutingDayResultFragmentFragmentDoc = gql`
    fragment RoutingDayResultFragment on RoutingDayResult {
  date
  jobId
  vehicles {
    ...RoutingVehicleFragment
  }
}
    ${RoutingVehicleFragmentFragmentDoc}`;
export const RoutingJobFragmentFragmentDoc = gql`
    fragment RoutingJobFragment on RoutingJob {
  id
  courierId
  displayId
  status
  dateCreated
  shipmentIds
  driverIds
  canceledBy
  cancelDescription
}
    `;
export const RoutingNodeEtaFragmentFragmentDoc = gql`
    fragment RoutingNodeEtaFragment on RoutingNodeEta {
  routingNodeId
  eta
  isLikelyLate
  isLikelyEarly
  likelyLateByInMinutes
  likelyEarlyByInMinutes
}
    `;
export const OrderAttachmentFragmentFragmentDoc = gql`
    fragment OrderAttachmentFragment on OrderAttachment {
  id
  fileName
  publicUrl
}
    `;
export const PriceOverrideBreakdownItemFragmentFragmentDoc = gql`
    fragment PriceOverrideBreakdownItemFragment on PriceOverrideBreakdownItem {
  description
  amount
  quantity
}
    `;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  acquisitionType
  dispatchableType
  billableType
  caller
  callerPhone
  costCenterId
  courierId
  displayId
  driverPayOverride
  driverPayPercent
  commissionableBaseFixed
  commissionableBasePercent
  endCustomerReferenceNumber
  id
  milesOverride
  priceOverride
  basePriceOverride
  taxCodeOverride
  priceOverrideBreakdown {
    ...PriceOverrideBreakdownItemFragment
  }
  recurrenceDetail {
    biweeklySchedule {
      startDateISO8601
    }
    endDateISO8601
    everyNWeeksSchedule {
      intervalWeeks
      weekDays
      startDateISO8601
    }
    monthlySchedule {
      days
    }
    scheduleType
    startDateISO8601
    weeklySchedule {
      weekDays
    }
  }
  recurrenceType
  name
  pricingStopIds
  additionalEmailRecipients
  additionalInfoCount
}
    ${PriceOverrideBreakdownItemFragmentFragmentDoc}`;
export const PackageTypeFragmentFragmentDoc = gql`
    fragment PackageTypeFragment on PackageType {
  id
  courierId
  name
  defaultLength
  defaultWidth
  defaultHeight
  defaultWeight
  defaultWeightApplication
  category
  enabled
}
    `;
export const PageInfoFragmentFragmentDoc = gql`
    fragment PageInfoFragment on PageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
}
    `;
export const PaymentTransferFragmentFragmentDoc = gql`
    fragment PaymentTransferFragment on PaymentTransfer {
  id
  displayId
  courierId
  endCustomerId
  amount
  currency
  status
  failureCode
  failureMessage
  refundType
  createdAt
}
    `;
export const CreditCardDetailFragmentFragmentDoc = gql`
    fragment CreditCardDetailFragment on CreditCardDetail {
  name
  lastFour
  expirationMonth
  expirationYear
  brand
}
    `;
export const BankAccountDetailFragmentFragmentDoc = gql`
    fragment BankAccountDetailFragment on BankAccountDetail {
  name
  maskedAccountNumber
  bankCode
  institutionNumber
  transitNumber
}
    `;
export const PaymentInstrumentFragmentFragmentDoc = gql`
    fragment PaymentInstrumentFragment on PaymentInstrument {
  id
  courierId
  endCustomerId
  costCenterId
  paymentInstrumentType
  isDefault
  creditCardDetail {
    ...CreditCardDetailFragment
  }
  bankAccountDetail {
    ...BankAccountDetailFragment
  }
  createdAt
}
    ${CreditCardDetailFragmentFragmentDoc}
${BankAccountDetailFragmentFragmentDoc}`;
export const InvoicePaymentFragmentFragmentDoc = gql`
    fragment InvoicePaymentFragment on InvoicePayment {
  id
  courierId
  invoiceId
  paymentTransferId
  allocatedAmount
}
    `;
export const PaymentSettlementFragmentFragmentDoc = gql`
    fragment PaymentSettlementFragment on PaymentSettlement {
  id
  remoteId
  courierId
  merchantId
  status
  providerCreatedAt
  netAmount
  totalAmount
  totalFee
  totalFeeIncludingSubscriptionBilling
  type
}
    `;
export const InvoiceManualPaymentFragmentFragmentDoc = gql`
    fragment InvoiceManualPaymentFragment on InvoiceManualPayment {
  id
  courierId
  invoiceId
  amount
  paidOn
  note
}
    `;
export const FeeTransferFragmentFragmentDoc = gql`
    fragment FeeTransferFragment on FeeTransfer {
  id
  parentPaymentTransferId
  courierId
  amount
  currency
  remoteId
  remoteState
  remoteParentTransferId
  settlementId
  createdAt
}
    `;
export const PaymentAdditionalFeeFragmentFragmentDoc = gql`
    fragment PaymentAdditionalFeeFragment on PaymentAdditionalFee {
  id
  courierId
  paymentTransferId
  paymentAdditionalFeeRuleId
  amount
  status
  createdAt
}
    `;
export const InvoicePaymentFieldsFragmentDoc = gql`
    fragment InvoicePaymentFields on InvoicePayment {
  id
  courierId
  invoiceId
  paymentTransferId
  allocatedAmount
}
    `;
export const InvoiceBalanceFieldsFragmentDoc = gql`
    fragment InvoiceBalanceFields on InvoiceBalance {
  invoiceId
  remainingBalance
}
    `;
export const DriverPayEntryFragmentFragmentDoc = gql`
    fragment DriverPayEntryFragment on DriverPayEntry {
  id
  driverId
  startDate
  endDate
  amountTotal
  ordersCount
  status
}
    `;
export const PayPeriodFragmentFragmentDoc = gql`
    fragment PayPeriodFragment on PayPeriod {
  startDate
  endDate
}
    `;
export const PayrollReportFileFragmentFragmentDoc = gql`
    fragment PayrollReportFileFragment on PayrollReportFile {
  url
}
    `;
export const PayrollSettingFragmentFragmentDoc = gql`
    fragment PayrollSettingFragment on PayrollSetting {
  courierId
  defaultCommission
  payPeriodType
  payPeriodStartDate
  ordersInclusionType
  driverPayExportType
}
    `;
export const OrderPayBreakDownFragmentFragmentDoc = gql`
    fragment OrderPayBreakDownFragment on OrderPayBreakDown {
  total
}
    `;
export const OrderPayBreakDownItemFragmentFragmentDoc = gql`
    fragment OrderPayBreakDownItemFragment on OrderPayBreakDownItem {
  name
  description
  amount
}
    `;
export const PayrollDeductionRuleFragmentFragmentDoc = gql`
    fragment PayrollDeductionRuleFragment on PayrollDeductionRule {
  id
  name
  amount
  amountType
  ruleType
  drivers {
    id
    firstName
    lastName
  }
  startDate
  endDate
}
    `;
export const PricingRuleFragmentFragmentDoc = gql`
    fragment PricingRuleFragment on PricingRule {
  id
  courierId
  pricingListId
  origin
  originDisplay
  originType
  destination
  destinationDisplay
  destinationType
  minMiles
  maxMiles
  minWeight
  maxWeight
  serviceTypeId
  basePrice
  minimumPrice
  maximumPrice
  pricePerMile
  pricePerLbs
  pricePerHour
  returnTripMultiplier
  driverPayFixed
  driverCommission
  maximumDriverPay
  commissionableBaseFixed
  commissionableBasePercent
  freeMiles
  minTrips
  maxTrips
  forReturnTripOnly
  weightBasis
  timeScheduleSpecificAmounts {
    schedules {
      days
      startTimeSecondsSinceMidnight
      endTimeSecondsSinceMidnight
      minimumAmount
      baseAmount
      pricePerMileAmount
    }
  }
  holidaySchedulePricingAmounts {
    schedules {
      holidayScheduleId
      minimumAmount
      baseAmount
      pricePerMileAmount
    }
  }
  advancedMultiplier {
    packageCountBasedMultipliers {
      minPackageCount
      maxPackageCount
      multiplier
    }
  }
  packageType {
    id
    courierId
    name
  }
  scope
}
    `;
export const PricingBreakDownFragmentFragmentDoc = gql`
    fragment PricingBreakDownFragment on PricingBreakDown {
  items {
    name
    amount
    description
    adjustmentId
    isAdjustmentOverride
    surchargePricingRuleId
    surchargePricingRule {
      id
      amountType
    }
  }
}
    `;
export const SurchargePricingRuleFragmentFragmentDoc = gql`
    fragment SurchargePricingRuleFragment on SurchargePricingRule {
  id
  courierId
  pricingListId
  name
  amount
  amountDisplay
  percent
  amountType
  applyType
  minMiles
  maxMiles
  minWeight
  maxWeight
  minPackageCount
  maxPackageCount
  orderAcquisitionTypes
  packageSize
  driverCommission
  showInInvoice
  minReadyTimeInSecondsSinceMidnight
  maxReadyTimeInSecondsSinceMidnight
  minDeliveryTimeInSecondsSinceMidnight
  maxDeliveryTimeInSecondsSinceMidnight
  minDeliverByTimeInSecondsSinceMidnight
  maxDeliverByTimeInSecondsSinceMidnight
  timeZoneId
  daysOfTheWeek
  freeMiles
  freePackageCount
  freeWeight
  freeSkidSpaces
  weightBasis
  surchargePricingRuleIdsToExclude
  shouldMultiplyByPackageCount
  readyTimeHolidayScheduleId
  customFieldIdForApplyType
  customFieldValueExactMatch
  customFieldMinValue
  customFieldMaxValue
  minimumAmount
  maximumAmount
  maximumDriverPay
  waiveBelowAmount
  numPerUnit
  numPerUnitRoundingStrategy
  freeWaitTimeOverrideSeconds
  internalNote
  applicableStopTypes
  invoiceSummaryGroup
  taxableStatus
  scope
  advancedMultiplier {
    packageCountBasedMultipliers {
      minPackageCount
      maxPackageCount
      multiplier
    }
  }
  perimeterZone {
    id
    courierId
    displayId
    type
    name
  }
  customField {
    id
    name
  }
  customFieldForApplyType {
    id
    name
    choices
  }
}
    `;
export const PricingAdjustmentFragmentFragmentDoc = gql`
    fragment PricingAdjustmentFragment on PricingAdjustment {
  id
  orderId
  surchargePricingRuleId
  type
  amount
  note
  surchargePricingRule {
    ...SurchargePricingRuleFragment
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;
export const OrderPriceFragmentFragmentDoc = gql`
    fragment OrderPriceFragment on OrderPrice {
  total
  taxableTotal
  nonTaxableTotal
  isPriceOverride
  isBasePriceOverride
  priceOverride
  basePriceOverride
  pricingBreakDown {
    ...PricingBreakDownFragment
  }
  customSurchargeAdjustments {
    ...PricingAdjustmentFragment
  }
  isFinalized
  priceOverrideBreakdown {
    ...PriceOverrideBreakdownItemFragment
  }
  taxBreakDown {
    taxItems {
      name
      amount
    }
    totalTaxAmount
  }
  totalAfterTax
  tripPrices {
    scope
    pricingRuleDisplay
    miles
    amount
  }
}
    ${PricingBreakDownFragmentFragmentDoc}
${PricingAdjustmentFragmentFragmentDoc}
${PriceOverrideBreakdownItemFragmentFragmentDoc}`;
export const EiaFuelRateFragmentFragmentDoc = gql`
    fragment EiaFuelRateFragment on EiaFuelRate {
  ratePerGallon
  percent
  fuelType
  ratePeriod
}
    `;
export const ZipGroupFragmentFragmentDoc = gql`
    fragment ZipGroupFragment on ZipGroup {
  id
  courierId
  name
  zipCodes
}
    `;
export const QualityReviewFragmentFragmentDoc = gql`
    fragment QualityReviewFragment on QualityReview {
  id
  courierId
  shipmentId
  jobStatus
  overallVerdict
  createdAt
}
    `;
export const QualityReviewItemFragmentFragmentDoc = gql`
    fragment QualityReviewItemFragment on QualityReviewItem {
  id
  qualityReviewId
  reviewAspect
  entityId
  verdict
  issues
  suggestions
  createdAt
  resultStructured {
    podResult {
      verdict
      issues {
        tag
        description
        suggestions
      }
    }
    pricingResult {
      verdict
      issues {
        tag
        description
        suggestions
        suggestedSurchargeAdd {
          surchargeIdToAdd
          reason
          suggestedAmount
        }
      }
    }
    otherResult {
      verdict
      issues {
        tag
        description
        suggestions
      }
    }
  }
}
    `;
export const RemoteEntityFragmentFragmentDoc = gql`
    fragment RemoteEntityFragment on RemoteEntity {
  id
  courierId
  provider
  remoteId
  internalId
  type
  externalUrl
}
    `;
export const SalesReportFileFragmentFragmentDoc = gql`
    fragment SalesReportFileFragment on SalesReportFile {
  url
}
    `;
export const SalesOverviewFragmentFragmentDoc = gql`
    fragment SalesOverviewFragment on SalesOverview {
  courierId
  minDate
  maxDate
  amountTotal
  amountForCompletedShipments
  numShipmentsTotal
  numShipmentsCompleted
}
    `;
export const SalesTermFragmentFragmentDoc = gql`
    fragment SalesTermFragment on SalesTerm {
  id
  courierId
  name
}
    `;
export const ServiceTypeFragmentFragmentDoc = gql`
    fragment ServiceTypeFragment on ServiceType {
  id
  courierId
  name
  displayId
  externalId
  deliveryTimeInMinutes
  color
  visibilityType
  dueTimeType
  dueTimeSecondsSinceMidnight
  dueTimeInBusinessDaysAfter
  dueTimeInDaysAfter
  readyTimeSchedule {
    weekDailyList {
      days
      startTimeSecondsSinceMidnight
      endTimeSecondsSinceMidnight
    }
  }
  businessHoursSchedule {
    weekDailyList {
      days
      startTimeSecondsSinceMidnight
      endTimeSecondsSinceMidnight
    }
  }
  deliveryRoutedDaysAfter
  customMessage
  visibleVehicleTypeIds
  defaultVehicleTypeId
  milesLimit
  extraSecondsPerMilePastLimit
  pickupCloseType
  pickupCloseTimeInMinutes
  pickupCloseTimeInSecondsSinceMidnight
  pickupCloseTimeInBusinessDaysAfter
  pickupCloseTimeInDaysAfter
  orderingSequenceNumber
  freeWaitTimeInSeconds
  multiplier
  multiplierMode
}
    `;
export const ShipmentFragmentFragmentDoc = gql`
    fragment ShipmentFragment on Shipment {
  id
  courierId
  shipmentDate
  driverId
  status
  packageSize
  packageWeightInPounds
  numPackages
  trackingNumber
  isClosed
  isForceCompleted
  type
  internalNote
  assignedAt
  createdAt
  driverConfirmedAt
  signedByOverride
  deliveredAtOverride
  waitTimeInMinutes
  packageDescription
  routingJobId
  firstEffectiveStopDate
  driverReportedWaitTimeInMinutes
  waitTimeUnfreeMinutesOverride
  completedDate
  completedDateOverriddenBy
  hasCompletedDateOverride
  invoiceDate
  proposedNumPackages
  proposedPackageWeightInPounds
  completionReason
  dispatchDelaySecs
  holdStatus
}
    `;
export const ShipmentTemplateFragmentFragmentDoc = gql`
    fragment ShipmentTemplateFragment on ShipmentTemplate {
  id
  courierId
  orderId
  packageSize
  packageWeightInPounds
  type
  numPackages
  packageTypeId
  vehicleTypeId
  packageDescription
}
    `;
export const DriverPayAllocationFragmentFragmentDoc = gql`
    fragment DriverPayAllocationFragment on DriverPayAllocation {
  id
  driverId
  shipmentId
  allocationRate
  allocationAmount
}
    `;
export const ShipmentTemplateDriverAssignmentFragmentFragmentDoc = gql`
    fragment ShipmentTemplateDriverAssignmentFragment on ShipmentTemplateDriverAssignment {
  id
  shipmentTemplateId
  driverId
  dayOfWeek
}
    `;
export const LabelFragmentFragmentDoc = gql`
    fragment LabelFragment on Label {
  id
  courierId
  entityType
  name
  color
}
    `;
export const StopFragmentFragmentDoc = gql`
    fragment StopFragment on Stop {
  id
  shipmentId
  type
  streetAddress
  googlePlaceId
  suite
  city
  state
  country
  dispatchZone
  driverNote
  zipCode
  contactName
  companyName
  phone
  instruction
  timeStatus
  completedAt
  stopDate
  lngLat {
    lng
    lat
  }
  timeWindow {
    open
    close
  }
  dispatchZoneLine2
  effectiveStopDate
  locationId
  locationValidityType
  stopSequenceNumber
  stopConsolidatedSortingNumber
  orderEntrySequenceNumber
  completionReason
  assignedLabels {
    ...LabelFragment
  }
  additionalDriverQuestionListId
}
    ${LabelFragmentFragmentDoc}`;
export const StopTemplateFragmentFragmentDoc = gql`
    fragment StopTemplateFragment on StopTemplate {
  id
  shipmentTemplateId
  type
  streetAddress
  suite
  city
  state
  country
  zipCode
  lngLat {
    lng
    lat
  }
  googlePlaceId
  contactName
  companyName
  phone
  instruction
  dispatchZone
  timeWindow {
    openSecondsSinceMidnightUtc
    closeSecondsSinceMidnightUtc
  }
  timeZoneId
  sequenceNumberInsideShipment
  assignedLabels {
    ...LabelFragment
  }
}
    ${LabelFragmentFragmentDoc}`;
export const TaskFragmentFragmentDoc = gql`
    fragment TaskFragment on Task {
  id
  driverId
  sequenceNumber
  status
  arrivedAt
  etaEpochSeconds
  date
}
    `;
export const StopEtaFragmentFragmentDoc = gql`
    fragment StopEtaFragment on StopEta {
  stopId
  eta
  isLikelyLate
  likelyLateByInMinutes
}
    `;
export const VisibleColumnsConfigFragmentFragmentDoc = gql`
    fragment VisibleColumnsConfigFragment on VisibleColumnsConfig {
  id
  salesReportColumnIds
  driverReportColumnIds
  userOrEmployeeId
}
    `;
export const UserStoreFragmentFragmentDoc = gql`
    fragment UserStoreFragment on UserStore {
  key
  value
}
    `;
export const CustomRoleFragmentFragmentDoc = gql`
    fragment CustomRoleFragment on CustomRole {
  id
  courierId
  name
  parentRole
  overrides {
    permission
    overrideType
  }
}
    `;
export const CourieUserFragmentFragmentDoc = gql`
    fragment CourieUserFragment on CourieUser {
  id
  email
  courierId
  firebaseUid
  profilePhotoUrl
  roleType
  enabledNotifications
  computedPermissions
  customRoles {
    ...CustomRoleFragment
  }
}
    ${CustomRoleFragmentFragmentDoc}`;
export const ZoneFragmentFragmentDoc = gql`
    fragment ZoneFragment on Zone {
  id
  courierId
  displayId
  type
  name
  polygon {
    points {
      lng
      lat
    }
  }
  assignedLabels {
    ...LabelFragment
  }
}
    ${LabelFragmentFragmentDoc}`;
export const CircleZoneFragmentFragmentDoc = gql`
    fragment CircleZoneFragment on CircleZone {
  id
  courierId
  name
  center {
    lng
    lat
  }
  minRadiusInMeters
  maxRadiusInMeters
}
    `;
export const AnalyticsDashboardFragmentFragmentDoc = gql`
    fragment AnalyticsDashboardFragment on AnalyticsDashboard {
  id
  name
  metabaseDashboardId
}
    `;
export const DriverQuestionFragmentFragmentDoc = gql`
    fragment DriverQuestionFragment on DriverQuestion {
  id
  courierId
  question
  type
  requirementType
  customerVisibility
  stopTypes
  sequenceNumber
  choices
  serviceTypeIds
  packageTypeIds
  stopLabelIds
}
    `;
export const LocationScanCodeFragmentFragmentDoc = gql`
    fragment LocationScanCodeFragment on LocationScanCode {
  id
  courierId
  code
  addressDisplay
  lngLat {
    ...LngLatFragment
  }
  referenceLocationId
  suite
  requirementType
  description
}
    ${LngLatFragmentFragmentDoc}`;
export const PackageFragmentFragmentDoc = gql`
    fragment PackageFragment on Package {
  id
  courierId
  reference
  status
  createdAt
}
    `;
export const PackageEventFragmentFragmentDoc = gql`
    fragment PackageEventFragment on PackageEvent {
  id
  courierId
  packageId
  packageEventTypeId
  action
  packageStatus
  lngLat {
    lng
    lat
  }
  fromParty
  toParty
  deviceTime
  deviceId
  eventBy
  createdAt
  eventTypeName
}
    `;
export const PackageEventTypeFragmentFragmentDoc = gql`
    fragment PackageEventTypeFragment on PackageEventType {
  id
  name
  action
  packageScanNewPackageHandleType
  reassignDriverId
  driverAssignmentValidationType
}
    `;
export const CourierOfflineSettingsFragmentFragmentDoc = gql`
    fragment CourierOfflineSettingsFragment on CourierOfflineSettings {
  podValidation
  scanValidation
  gpsValidation
  locationScanValidation
  questionValidation
}
    `;
export const ActivitiesDocument = gql`
    query Activities($courierId: ID!, $entityId: ID!) {
  activities(courierId: $courierId, entityId: $entityId) {
    activities {
      ...ActivityFragment
      change {
        old {
          ...ActivitySnapshotFragment
        }
        new {
          ...ActivitySnapshotFragment
        }
      }
      updatedByUser {
        ...CourieUserFragment
      }
      updatedByEndCustomer {
        ...EndCustomerFragment
      }
      updatedByEndUser {
        ...EndUserFragment
      }
      updatedByDriver {
        ...DriverFragment
      }
    }
  }
}
    ${ActivityFragmentFragmentDoc}
${ActivitySnapshotFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${EndUserFragmentFragmentDoc}
${DriverFragmentFragmentDoc}`;

/**
 * __useActivitiesQuery__
 *
 * To run a query within a React component, call `useActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useActivitiesQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, options);
      }
export function useActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, options);
        }
export type ActivitiesQueryHookResult = ReturnType<typeof useActivitiesQuery>;
export type ActivitiesLazyQueryHookResult = ReturnType<typeof useActivitiesLazyQuery>;
export type ActivitiesQueryResult = Apollo.QueryResult<ActivitiesQuery, ActivitiesQueryVariables>;
export const CreateAddressBookDocument = gql`
    mutation CreateAddressBook($courierId: ID!, $endCustomerId: ID, $contactName: String, $companyName: String, $phone: String, $suite: String, $instruction: String, $locationId: ID!, $emailRecipients: [String!]) {
  createAddressBook(
    courierId: $courierId
    endCustomerId: $endCustomerId
    contactName: $contactName
    companyName: $companyName
    phone: $phone
    suite: $suite
    instruction: $instruction
    locationId: $locationId
    emailRecipients: $emailRecipients
  ) {
    ...AddressBookFragment
  }
}
    ${AddressBookFragmentFragmentDoc}`;
export type CreateAddressBookMutationFn = Apollo.MutationFunction<CreateAddressBookMutation, CreateAddressBookMutationVariables>;

/**
 * __useCreateAddressBookMutation__
 *
 * To run a mutation, you first call `useCreateAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressBookMutation, { data, loading, error }] = useCreateAddressBookMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      contactName: // value for 'contactName'
 *      companyName: // value for 'companyName'
 *      phone: // value for 'phone'
 *      suite: // value for 'suite'
 *      instruction: // value for 'instruction'
 *      locationId: // value for 'locationId'
 *      emailRecipients: // value for 'emailRecipients'
 *   },
 * });
 */
export function useCreateAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressBookMutation, CreateAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressBookMutation, CreateAddressBookMutationVariables>(CreateAddressBookDocument, options);
      }
export type CreateAddressBookMutationHookResult = ReturnType<typeof useCreateAddressBookMutation>;
export type CreateAddressBookMutationResult = Apollo.MutationResult<CreateAddressBookMutation>;
export type CreateAddressBookMutationOptions = Apollo.BaseMutationOptions<CreateAddressBookMutation, CreateAddressBookMutationVariables>;
export const FullUpdateAddressBookDocument = gql`
    mutation FullUpdateAddressBook($courierId: ID!, $id: ID!, $endCustomerId: ID, $contactName: String, $companyName: String, $phone: String, $suite: String, $instruction: String, $locationId: ID!, $emailRecipients: [String!]) {
  fullUpdateAddressBook(
    courierId: $courierId
    id: $id
    endCustomerId: $endCustomerId
    contactName: $contactName
    companyName: $companyName
    phone: $phone
    suite: $suite
    instruction: $instruction
    locationId: $locationId
    emailRecipients: $emailRecipients
  ) {
    ...AddressBookFragment
  }
}
    ${AddressBookFragmentFragmentDoc}`;
export type FullUpdateAddressBookMutationFn = Apollo.MutationFunction<FullUpdateAddressBookMutation, FullUpdateAddressBookMutationVariables>;

/**
 * __useFullUpdateAddressBookMutation__
 *
 * To run a mutation, you first call `useFullUpdateAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateAddressBookMutation, { data, loading, error }] = useFullUpdateAddressBookMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      endCustomerId: // value for 'endCustomerId'
 *      contactName: // value for 'contactName'
 *      companyName: // value for 'companyName'
 *      phone: // value for 'phone'
 *      suite: // value for 'suite'
 *      instruction: // value for 'instruction'
 *      locationId: // value for 'locationId'
 *      emailRecipients: // value for 'emailRecipients'
 *   },
 * });
 */
export function useFullUpdateAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateAddressBookMutation, FullUpdateAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateAddressBookMutation, FullUpdateAddressBookMutationVariables>(FullUpdateAddressBookDocument, options);
      }
export type FullUpdateAddressBookMutationHookResult = ReturnType<typeof useFullUpdateAddressBookMutation>;
export type FullUpdateAddressBookMutationResult = Apollo.MutationResult<FullUpdateAddressBookMutation>;
export type FullUpdateAddressBookMutationOptions = Apollo.BaseMutationOptions<FullUpdateAddressBookMutation, FullUpdateAddressBookMutationVariables>;
export const DeleteAddressBookDocument = gql`
    mutation DeleteAddressBook($courierId: ID!, $id: ID!) {
  deleteAddressBook(courierId: $courierId, id: $id)
}
    `;
export type DeleteAddressBookMutationFn = Apollo.MutationFunction<DeleteAddressBookMutation, DeleteAddressBookMutationVariables>;

/**
 * __useDeleteAddressBookMutation__
 *
 * To run a mutation, you first call `useDeleteAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressBookMutation, { data, loading, error }] = useDeleteAddressBookMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAddressBookMutation, DeleteAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAddressBookMutation, DeleteAddressBookMutationVariables>(DeleteAddressBookDocument, options);
      }
export type DeleteAddressBookMutationHookResult = ReturnType<typeof useDeleteAddressBookMutation>;
export type DeleteAddressBookMutationResult = Apollo.MutationResult<DeleteAddressBookMutation>;
export type DeleteAddressBookMutationOptions = Apollo.BaseMutationOptions<DeleteAddressBookMutation, DeleteAddressBookMutationVariables>;
export const BulkUploadAddressBookDocument = gql`
    mutation BulkUploadAddressBook($courierId: ID!, $file: Upload!) {
  bulkUploadAddressBook(courierId: $courierId, file: $file) {
    numSuccess
    isAsynchronous
    errors {
      rowNumber
      messages
    }
  }
}
    `;
export type BulkUploadAddressBookMutationFn = Apollo.MutationFunction<BulkUploadAddressBookMutation, BulkUploadAddressBookMutationVariables>;

/**
 * __useBulkUploadAddressBookMutation__
 *
 * To run a mutation, you first call `useBulkUploadAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadAddressBookMutation, { data, loading, error }] = useBulkUploadAddressBookMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkUploadAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadAddressBookMutation, BulkUploadAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadAddressBookMutation, BulkUploadAddressBookMutationVariables>(BulkUploadAddressBookDocument, options);
      }
export type BulkUploadAddressBookMutationHookResult = ReturnType<typeof useBulkUploadAddressBookMutation>;
export type BulkUploadAddressBookMutationResult = Apollo.MutationResult<BulkUploadAddressBookMutation>;
export type BulkUploadAddressBookMutationOptions = Apollo.BaseMutationOptions<BulkUploadAddressBookMutation, BulkUploadAddressBookMutationVariables>;
export const BulkDeleteAddressBookDocument = gql`
    mutation BulkDeleteAddressBook($courierId: ID!, $endCustomerIdsFilter: [ID!]) {
  bulkDeleteAddressBook(
    courierId: $courierId
    endCustomerIdsFilter: $endCustomerIdsFilter
  )
}
    `;
export type BulkDeleteAddressBookMutationFn = Apollo.MutationFunction<BulkDeleteAddressBookMutation, BulkDeleteAddressBookMutationVariables>;

/**
 * __useBulkDeleteAddressBookMutation__
 *
 * To run a mutation, you first call `useBulkDeleteAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteAddressBookMutation, { data, loading, error }] = useBulkDeleteAddressBookMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *   },
 * });
 */
export function useBulkDeleteAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteAddressBookMutation, BulkDeleteAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteAddressBookMutation, BulkDeleteAddressBookMutationVariables>(BulkDeleteAddressBookDocument, options);
      }
export type BulkDeleteAddressBookMutationHookResult = ReturnType<typeof useBulkDeleteAddressBookMutation>;
export type BulkDeleteAddressBookMutationResult = Apollo.MutationResult<BulkDeleteAddressBookMutation>;
export type BulkDeleteAddressBookMutationOptions = Apollo.BaseMutationOptions<BulkDeleteAddressBookMutation, BulkDeleteAddressBookMutationVariables>;
export const SearchFromAddressBookDocument = gql`
    query SearchFromAddressBook($courierId: ID!, $endCustomerId: ID, $endCustomerIdBias: ID, $contactNameSearch: String, $companyNameSearch: String, $phoneSearch: String, $streetAddressSearch: String, $googlePlaceIds: [String!]) {
  searchFromAddressBook(
    courierId: $courierId
    endCustomerId: $endCustomerId
    endCustomerIdBias: $endCustomerIdBias
    contactNameSearch: $contactNameSearch
    companyNameSearch: $companyNameSearch
    phoneSearch: $phoneSearch
    streetAddressSearch: $streetAddressSearch
    googlePlaceIds: $googlePlaceIds
  ) {
    ...AddressBookFragment
  }
}
    ${AddressBookFragmentFragmentDoc}`;

/**
 * __useSearchFromAddressBookQuery__
 *
 * To run a query within a React component, call `useSearchFromAddressBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFromAddressBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFromAddressBookQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      endCustomerIdBias: // value for 'endCustomerIdBias'
 *      contactNameSearch: // value for 'contactNameSearch'
 *      companyNameSearch: // value for 'companyNameSearch'
 *      phoneSearch: // value for 'phoneSearch'
 *      streetAddressSearch: // value for 'streetAddressSearch'
 *      googlePlaceIds: // value for 'googlePlaceIds'
 *   },
 * });
 */
export function useSearchFromAddressBookQuery(baseOptions: Apollo.QueryHookOptions<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>(SearchFromAddressBookDocument, options);
      }
export function useSearchFromAddressBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>(SearchFromAddressBookDocument, options);
        }
export type SearchFromAddressBookQueryHookResult = ReturnType<typeof useSearchFromAddressBookQuery>;
export type SearchFromAddressBookLazyQueryHookResult = ReturnType<typeof useSearchFromAddressBookLazyQuery>;
export type SearchFromAddressBookQueryResult = Apollo.QueryResult<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>;
export const AddressBookEntriesDocument = gql`
    query AddressBookEntries($courierId: ID!, $endCustomerIds: [ID!], $contactNameSearch: String, $companyNameSearch: String, $phoneSearch: String, $streetAddressSearch: String, $limit: Int, $after: Int, $sortFields: [AddressBookSorting!]) {
  addressBookEntries(
    courierId: $courierId
    endCustomerIds: $endCustomerIds
    contactNameSearch: $contactNameSearch
    companyNameSearch: $companyNameSearch
    phoneSearch: $phoneSearch
    streetAddressSearch: $streetAddressSearch
    limit: $limit
    after: $after
    sortFields: $sortFields
  ) {
    edges {
      node {
        ...AddressBookFragment
        endCustomer {
          ...EndCustomerFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${AddressBookFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useAddressBookEntriesQuery__
 *
 * To run a query within a React component, call `useAddressBookEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressBookEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressBookEntriesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *      contactNameSearch: // value for 'contactNameSearch'
 *      companyNameSearch: // value for 'companyNameSearch'
 *      phoneSearch: // value for 'phoneSearch'
 *      streetAddressSearch: // value for 'streetAddressSearch'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useAddressBookEntriesQuery(baseOptions: Apollo.QueryHookOptions<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>(AddressBookEntriesDocument, options);
      }
export function useAddressBookEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>(AddressBookEntriesDocument, options);
        }
export type AddressBookEntriesQueryHookResult = ReturnType<typeof useAddressBookEntriesQuery>;
export type AddressBookEntriesLazyQueryHookResult = ReturnType<typeof useAddressBookEntriesLazyQuery>;
export type AddressBookEntriesQueryResult = Apollo.QueryResult<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>;
export const CreateAgentDocument = gql`
    mutation CreateAgent($courierId: ID!, $create: AgentCreate!) {
  createAgent(courierId: $courierId, create: $create) {
    ...AgentFragment
  }
}
    ${AgentFragmentFragmentDoc}`;
export type CreateAgentMutationFn = Apollo.MutationFunction<CreateAgentMutation, CreateAgentMutationVariables>;

/**
 * __useCreateAgentMutation__
 *
 * To run a mutation, you first call `useCreateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentMutation, { data, loading, error }] = useCreateAgentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      create: // value for 'create'
 *   },
 * });
 */
export function useCreateAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentMutation, CreateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentMutation, CreateAgentMutationVariables>(CreateAgentDocument, options);
      }
export type CreateAgentMutationHookResult = ReturnType<typeof useCreateAgentMutation>;
export type CreateAgentMutationResult = Apollo.MutationResult<CreateAgentMutation>;
export type CreateAgentMutationOptions = Apollo.BaseMutationOptions<CreateAgentMutation, CreateAgentMutationVariables>;
export const FullUpdateAgentDocument = gql`
    mutation FullUpdateAgent($courierId: ID!, $fullUpdate: AgentFullUpdate!) {
  fullUpdateAgent(courierId: $courierId, fullUpdate: $fullUpdate) {
    ...AgentFragment
  }
}
    ${AgentFragmentFragmentDoc}`;
export type FullUpdateAgentMutationFn = Apollo.MutationFunction<FullUpdateAgentMutation, FullUpdateAgentMutationVariables>;

/**
 * __useFullUpdateAgentMutation__
 *
 * To run a mutation, you first call `useFullUpdateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateAgentMutation, { data, loading, error }] = useFullUpdateAgentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      fullUpdate: // value for 'fullUpdate'
 *   },
 * });
 */
export function useFullUpdateAgentMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateAgentMutation, FullUpdateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateAgentMutation, FullUpdateAgentMutationVariables>(FullUpdateAgentDocument, options);
      }
export type FullUpdateAgentMutationHookResult = ReturnType<typeof useFullUpdateAgentMutation>;
export type FullUpdateAgentMutationResult = Apollo.MutationResult<FullUpdateAgentMutation>;
export type FullUpdateAgentMutationOptions = Apollo.BaseMutationOptions<FullUpdateAgentMutation, FullUpdateAgentMutationVariables>;
export const UpdateOptedInDocument = gql`
    mutation UpdateOptedIn($agentId: ID!, $optedIn: Boolean!) {
  updateOptedIn(agentId: $agentId, optedIn: $optedIn)
}
    `;
export type UpdateOptedInMutationFn = Apollo.MutationFunction<UpdateOptedInMutation, UpdateOptedInMutationVariables>;

/**
 * __useUpdateOptedInMutation__
 *
 * To run a mutation, you first call `useUpdateOptedInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptedInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptedInMutation, { data, loading, error }] = useUpdateOptedInMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      optedIn: // value for 'optedIn'
 *   },
 * });
 */
export function useUpdateOptedInMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOptedInMutation, UpdateOptedInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOptedInMutation, UpdateOptedInMutationVariables>(UpdateOptedInDocument, options);
      }
export type UpdateOptedInMutationHookResult = ReturnType<typeof useUpdateOptedInMutation>;
export type UpdateOptedInMutationResult = Apollo.MutationResult<UpdateOptedInMutation>;
export type UpdateOptedInMutationOptions = Apollo.BaseMutationOptions<UpdateOptedInMutation, UpdateOptedInMutationVariables>;
export const GetAgentsDocument = gql`
    query GetAgents($courierId: ID!) {
  agents(courierId: $courierId) {
    ...AgentFragment
  }
}
    ${AgentFragmentFragmentDoc}`;

/**
 * __useGetAgentsQuery__
 *
 * To run a query within a React component, call `useGetAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetAgentsQuery(baseOptions: Apollo.QueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
      }
export function useGetAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
        }
export type GetAgentsQueryHookResult = ReturnType<typeof useGetAgentsQuery>;
export type GetAgentsLazyQueryHookResult = ReturnType<typeof useGetAgentsLazyQuery>;
export type GetAgentsQueryResult = Apollo.QueryResult<GetAgentsQuery, GetAgentsQueryVariables>;
export const MarkArtifactAsDeletedDocument = gql`
    mutation markArtifactAsDeleted($courierId: ID!, $artifactId: ID!) {
  markArtifactAsDeleted(courierId: $courierId, artifactId: $artifactId) {
    ...ArtifactFragment
  }
}
    ${ArtifactFragmentFragmentDoc}`;
export type MarkArtifactAsDeletedMutationFn = Apollo.MutationFunction<MarkArtifactAsDeletedMutation, MarkArtifactAsDeletedMutationVariables>;

/**
 * __useMarkArtifactAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkArtifactAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkArtifactAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markArtifactAsDeletedMutation, { data, loading, error }] = useMarkArtifactAsDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useMarkArtifactAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkArtifactAsDeletedMutation, MarkArtifactAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkArtifactAsDeletedMutation, MarkArtifactAsDeletedMutationVariables>(MarkArtifactAsDeletedDocument, options);
      }
export type MarkArtifactAsDeletedMutationHookResult = ReturnType<typeof useMarkArtifactAsDeletedMutation>;
export type MarkArtifactAsDeletedMutationResult = Apollo.MutationResult<MarkArtifactAsDeletedMutation>;
export type MarkArtifactAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkArtifactAsDeletedMutation, MarkArtifactAsDeletedMutationVariables>;
export const GenerateResetPasswordLinkDocument = gql`
    mutation GenerateResetPasswordLink($email: String!) {
  generateResetPasswordLink(email: $email) {
    link
  }
}
    `;
export type GenerateResetPasswordLinkMutationFn = Apollo.MutationFunction<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>;

/**
 * __useGenerateResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useGenerateResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateResetPasswordLinkMutation, { data, loading, error }] = useGenerateResetPasswordLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGenerateResetPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>(GenerateResetPasswordLinkDocument, options);
      }
export type GenerateResetPasswordLinkMutationHookResult = ReturnType<typeof useGenerateResetPasswordLinkMutation>;
export type GenerateResetPasswordLinkMutationResult = Apollo.MutationResult<GenerateResetPasswordLinkMutation>;
export type GenerateResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail($courierId: ID!, $endCustomerIds: [ID!], $driverIds: [ID!], $endUserIds: [ID!], $userIds: [ID!], $emails: [String!]) {
  sendPasswordResetEmail(
    courierId: $courierId
    endCustomerIds: $endCustomerIds
    driverIds: $driverIds
    endUserIds: $endUserIds
    userIds: $userIds
    emails: $emails
  )
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *      driverIds: // value for 'driverIds'
 *      endUserIds: // value for 'endUserIds'
 *      userIds: // value for 'userIds'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const BulkUploadOrdersDocument = gql`
    mutation BulkUploadOrders($courierId: ID!, $file: Upload!) {
  bulkUploadOrders(courierId: $courierId, file: $file) {
    numSuccess
    isAsynchronous
    error {
      errorMessages
      lineErrors {
        lineNumber
        cellErrors {
          columnName
          errorMessage
        }
      }
    }
  }
}
    `;
export type BulkUploadOrdersMutationFn = Apollo.MutationFunction<BulkUploadOrdersMutation, BulkUploadOrdersMutationVariables>;

/**
 * __useBulkUploadOrdersMutation__
 *
 * To run a mutation, you first call `useBulkUploadOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadOrdersMutation, { data, loading, error }] = useBulkUploadOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkUploadOrdersMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadOrdersMutation, BulkUploadOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadOrdersMutation, BulkUploadOrdersMutationVariables>(BulkUploadOrdersDocument, options);
      }
export type BulkUploadOrdersMutationHookResult = ReturnType<typeof useBulkUploadOrdersMutation>;
export type BulkUploadOrdersMutationResult = Apollo.MutationResult<BulkUploadOrdersMutation>;
export type BulkUploadOrdersMutationOptions = Apollo.BaseMutationOptions<BulkUploadOrdersMutation, BulkUploadOrdersMutationVariables>;
export const BulkUploadEndCustomersDocument = gql`
    mutation BulkUploadEndCustomers($courierId: ID!, $file: Upload!, $ignoreInvalidAddresses: Boolean, $ignoreInvalidPricingLists: Boolean, $ignoreInvalidInvoiceFrequencies: Boolean, $onlyOverrideExistingEndCustomers: Boolean, $skipExistingEndCustomers: Boolean) {
  bulkUploadEndCustomers(
    courierId: $courierId
    file: $file
    ignoreInvalidAddresses: $ignoreInvalidAddresses
    ignoreInvalidPricingLists: $ignoreInvalidPricingLists
    ignoreInvalidInvoiceFrequencies: $ignoreInvalidInvoiceFrequencies
    onlyOverrideExistingEndCustomers: $onlyOverrideExistingEndCustomers
    skipExistingEndCustomers: $skipExistingEndCustomers
  ) {
    numSuccess
    isAsynchronous
    errors {
      rowNumber
      messages
    }
  }
}
    `;
export type BulkUploadEndCustomersMutationFn = Apollo.MutationFunction<BulkUploadEndCustomersMutation, BulkUploadEndCustomersMutationVariables>;

/**
 * __useBulkUploadEndCustomersMutation__
 *
 * To run a mutation, you first call `useBulkUploadEndCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadEndCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadEndCustomersMutation, { data, loading, error }] = useBulkUploadEndCustomersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *      ignoreInvalidAddresses: // value for 'ignoreInvalidAddresses'
 *      ignoreInvalidPricingLists: // value for 'ignoreInvalidPricingLists'
 *      ignoreInvalidInvoiceFrequencies: // value for 'ignoreInvalidInvoiceFrequencies'
 *      onlyOverrideExistingEndCustomers: // value for 'onlyOverrideExistingEndCustomers'
 *      skipExistingEndCustomers: // value for 'skipExistingEndCustomers'
 *   },
 * });
 */
export function useBulkUploadEndCustomersMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadEndCustomersMutation, BulkUploadEndCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadEndCustomersMutation, BulkUploadEndCustomersMutationVariables>(BulkUploadEndCustomersDocument, options);
      }
export type BulkUploadEndCustomersMutationHookResult = ReturnType<typeof useBulkUploadEndCustomersMutation>;
export type BulkUploadEndCustomersMutationResult = Apollo.MutationResult<BulkUploadEndCustomersMutation>;
export type BulkUploadEndCustomersMutationOptions = Apollo.BaseMutationOptions<BulkUploadEndCustomersMutation, BulkUploadEndCustomersMutationVariables>;
export const BulkUploadRecurringOrdersDocument = gql`
    mutation BulkUploadRecurringOrders($courierId: ID!, $file: Upload!, $onlyUpdateExistingRecurringOrders: Boolean) {
  bulkUploadRecurringOrders(
    courierId: $courierId
    file: $file
    onlyUpdateExistingRecurringOrders: $onlyUpdateExistingRecurringOrders
  ) {
    numSuccess
    isAsynchronous
    error {
      errorMessages
      lineErrors {
        lineNumber
        cellErrors {
          columnName
          errorMessage
        }
      }
    }
  }
}
    `;
export type BulkUploadRecurringOrdersMutationFn = Apollo.MutationFunction<BulkUploadRecurringOrdersMutation, BulkUploadRecurringOrdersMutationVariables>;

/**
 * __useBulkUploadRecurringOrdersMutation__
 *
 * To run a mutation, you first call `useBulkUploadRecurringOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadRecurringOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadRecurringOrdersMutation, { data, loading, error }] = useBulkUploadRecurringOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *      onlyUpdateExistingRecurringOrders: // value for 'onlyUpdateExistingRecurringOrders'
 *   },
 * });
 */
export function useBulkUploadRecurringOrdersMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadRecurringOrdersMutation, BulkUploadRecurringOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadRecurringOrdersMutation, BulkUploadRecurringOrdersMutationVariables>(BulkUploadRecurringOrdersDocument, options);
      }
export type BulkUploadRecurringOrdersMutationHookResult = ReturnType<typeof useBulkUploadRecurringOrdersMutation>;
export type BulkUploadRecurringOrdersMutationResult = Apollo.MutationResult<BulkUploadRecurringOrdersMutation>;
export type BulkUploadRecurringOrdersMutationOptions = Apollo.BaseMutationOptions<BulkUploadRecurringOrdersMutation, BulkUploadRecurringOrdersMutationVariables>;
export const BulkUploadPackageMovementsDocument = gql`
    mutation BulkUploadPackageMovements($courierId: ID!, $file: Upload!) {
  bulkUploadPackageMovements(courierId: $courierId, file: $file) {
    numSuccess
    errors {
      rowNumber
      messages
    }
  }
}
    `;
export type BulkUploadPackageMovementsMutationFn = Apollo.MutationFunction<BulkUploadPackageMovementsMutation, BulkUploadPackageMovementsMutationVariables>;

/**
 * __useBulkUploadPackageMovementsMutation__
 *
 * To run a mutation, you first call `useBulkUploadPackageMovementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadPackageMovementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadPackageMovementsMutation, { data, loading, error }] = useBulkUploadPackageMovementsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkUploadPackageMovementsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadPackageMovementsMutation, BulkUploadPackageMovementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadPackageMovementsMutation, BulkUploadPackageMovementsMutationVariables>(BulkUploadPackageMovementsDocument, options);
      }
export type BulkUploadPackageMovementsMutationHookResult = ReturnType<typeof useBulkUploadPackageMovementsMutation>;
export type BulkUploadPackageMovementsMutationResult = Apollo.MutationResult<BulkUploadPackageMovementsMutation>;
export type BulkUploadPackageMovementsMutationOptions = Apollo.BaseMutationOptions<BulkUploadPackageMovementsMutation, BulkUploadPackageMovementsMutationVariables>;
export const BulkUploadCallerContactsDocument = gql`
    mutation BulkUploadCallerContacts($courierId: ID!, $file: Upload!) {
  bulkUploadCallerContacts(courierId: $courierId, file: $file) {
    numSuccess
    isAsynchronous
    errors {
      rowNumber
      messages
    }
  }
}
    `;
export type BulkUploadCallerContactsMutationFn = Apollo.MutationFunction<BulkUploadCallerContactsMutation, BulkUploadCallerContactsMutationVariables>;

/**
 * __useBulkUploadCallerContactsMutation__
 *
 * To run a mutation, you first call `useBulkUploadCallerContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadCallerContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadCallerContactsMutation, { data, loading, error }] = useBulkUploadCallerContactsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkUploadCallerContactsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadCallerContactsMutation, BulkUploadCallerContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadCallerContactsMutation, BulkUploadCallerContactsMutationVariables>(BulkUploadCallerContactsDocument, options);
      }
export type BulkUploadCallerContactsMutationHookResult = ReturnType<typeof useBulkUploadCallerContactsMutation>;
export type BulkUploadCallerContactsMutationResult = Apollo.MutationResult<BulkUploadCallerContactsMutation>;
export type BulkUploadCallerContactsMutationOptions = Apollo.BaseMutationOptions<BulkUploadCallerContactsMutation, BulkUploadCallerContactsMutationVariables>;
export const CreateCostCenterDocument = gql`
    mutation CreateCostCenter($courierId: ID!, $endCustomerId: ID!, $name: String!, $googlePlaceId: String, $suite: String, $email: String, $phone: String) {
  createCostCenter(
    courierId: $courierId
    costCenterCreate: {endCustomerId: $endCustomerId, name: $name, googlePlaceId: $googlePlaceId, suite: $suite, email: $email, phone: $phone}
  ) {
    ...CostCenterFragment
    location {
      ...LocationFragment
    }
  }
}
    ${CostCenterFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;
export type CreateCostCenterMutationFn = Apollo.MutationFunction<CreateCostCenterMutation, CreateCostCenterMutationVariables>;

/**
 * __useCreateCostCenterMutation__
 *
 * To run a mutation, you first call `useCreateCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCostCenterMutation, { data, loading, error }] = useCreateCostCenterMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      name: // value for 'name'
 *      googlePlaceId: // value for 'googlePlaceId'
 *      suite: // value for 'suite'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCreateCostCenterMutation(baseOptions?: Apollo.MutationHookOptions<CreateCostCenterMutation, CreateCostCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCostCenterMutation, CreateCostCenterMutationVariables>(CreateCostCenterDocument, options);
      }
export type CreateCostCenterMutationHookResult = ReturnType<typeof useCreateCostCenterMutation>;
export type CreateCostCenterMutationResult = Apollo.MutationResult<CreateCostCenterMutation>;
export type CreateCostCenterMutationOptions = Apollo.BaseMutationOptions<CreateCostCenterMutation, CreateCostCenterMutationVariables>;
export const FullUpdateCostCenterDocument = gql`
    mutation FullUpdateCostCenter($courierId: ID!, $costCenterId: ID!, $name: String!, $googlePlaceId: String, $suite: String, $email: String, $phone: String) {
  fullUpdateCostCenter(
    courierId: $courierId
    costCenterFullUpdate: {id: $costCenterId, name: $name, googlePlaceId: $googlePlaceId, suite: $suite, email: $email, phone: $phone}
  ) {
    ...CostCenterFragment
    location {
      ...LocationFragment
    }
  }
}
    ${CostCenterFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;
export type FullUpdateCostCenterMutationFn = Apollo.MutationFunction<FullUpdateCostCenterMutation, FullUpdateCostCenterMutationVariables>;

/**
 * __useFullUpdateCostCenterMutation__
 *
 * To run a mutation, you first call `useFullUpdateCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateCostCenterMutation, { data, loading, error }] = useFullUpdateCostCenterMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      costCenterId: // value for 'costCenterId'
 *      name: // value for 'name'
 *      googlePlaceId: // value for 'googlePlaceId'
 *      suite: // value for 'suite'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useFullUpdateCostCenterMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateCostCenterMutation, FullUpdateCostCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateCostCenterMutation, FullUpdateCostCenterMutationVariables>(FullUpdateCostCenterDocument, options);
      }
export type FullUpdateCostCenterMutationHookResult = ReturnType<typeof useFullUpdateCostCenterMutation>;
export type FullUpdateCostCenterMutationResult = Apollo.MutationResult<FullUpdateCostCenterMutation>;
export type FullUpdateCostCenterMutationOptions = Apollo.BaseMutationOptions<FullUpdateCostCenterMutation, FullUpdateCostCenterMutationVariables>;
export const MarkCostCenterDeletedDocument = gql`
    mutation MarkCostCenterDeleted($courierId: ID!, $costCenterId: ID!) {
  markCostCenterDeleted(courierId: $courierId, costCenterId: $costCenterId)
}
    `;
export type MarkCostCenterDeletedMutationFn = Apollo.MutationFunction<MarkCostCenterDeletedMutation, MarkCostCenterDeletedMutationVariables>;

/**
 * __useMarkCostCenterDeletedMutation__
 *
 * To run a mutation, you first call `useMarkCostCenterDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCostCenterDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCostCenterDeletedMutation, { data, loading, error }] = useMarkCostCenterDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      costCenterId: // value for 'costCenterId'
 *   },
 * });
 */
export function useMarkCostCenterDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkCostCenterDeletedMutation, MarkCostCenterDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCostCenterDeletedMutation, MarkCostCenterDeletedMutationVariables>(MarkCostCenterDeletedDocument, options);
      }
export type MarkCostCenterDeletedMutationHookResult = ReturnType<typeof useMarkCostCenterDeletedMutation>;
export type MarkCostCenterDeletedMutationResult = Apollo.MutationResult<MarkCostCenterDeletedMutation>;
export type MarkCostCenterDeletedMutationOptions = Apollo.BaseMutationOptions<MarkCostCenterDeletedMutation, MarkCostCenterDeletedMutationVariables>;
export const GetCostCentersDocument = gql`
    query GetCostCenters($courierId: ID!, $endCustomerIds: [ID!]!) {
  costCenters(courierId: $courierId, endCustomerIds: $endCustomerIds) {
    ...CostCenterFragment
    location {
      ...LocationFragment
    }
  }
}
    ${CostCenterFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;

/**
 * __useGetCostCentersQuery__
 *
 * To run a query within a React component, call `useGetCostCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostCentersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *   },
 * });
 */
export function useGetCostCentersQuery(baseOptions: Apollo.QueryHookOptions<GetCostCentersQuery, GetCostCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostCentersQuery, GetCostCentersQueryVariables>(GetCostCentersDocument, options);
      }
export function useGetCostCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostCentersQuery, GetCostCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostCentersQuery, GetCostCentersQueryVariables>(GetCostCentersDocument, options);
        }
export type GetCostCentersQueryHookResult = ReturnType<typeof useGetCostCentersQuery>;
export type GetCostCentersLazyQueryHookResult = ReturnType<typeof useGetCostCentersLazyQuery>;
export type GetCostCentersQueryResult = Apollo.QueryResult<GetCostCentersQuery, GetCostCentersQueryVariables>;
export const UpdateCourierSettingsDocument = gql`
    mutation UpdateCourierSettings($courierId: ID!, $logoFile: Upload, $clearLogo: Boolean, $displayName: String!, $defaultTimeZoneId: String!, $primaryPhoneNumber: String!, $primaryEmail: String!, $primaryAddressLocationId: ID!, $billingStreetAddress: String, $billingCity: String, $billingState: String, $billingCountry: String, $billingZip: String) {
  updateCourierSettings(
    courierId: $courierId
    logoFile: $logoFile
    clearLogo: $clearLogo
    displayName: $displayName
    defaultTimeZoneId: $defaultTimeZoneId
    primaryPhoneNumber: $primaryPhoneNumber
    primaryEmail: $primaryEmail
    primaryAddressLocationId: $primaryAddressLocationId
    billingStreetAddress: $billingStreetAddress
    billingCity: $billingCity
    billingState: $billingState
    billingCountry: $billingCountry
    billingZip: $billingZip
  ) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type UpdateCourierSettingsMutationFn = Apollo.MutationFunction<UpdateCourierSettingsMutation, UpdateCourierSettingsMutationVariables>;

/**
 * __useUpdateCourierSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCourierSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourierSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourierSettingsMutation, { data, loading, error }] = useUpdateCourierSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      logoFile: // value for 'logoFile'
 *      clearLogo: // value for 'clearLogo'
 *      displayName: // value for 'displayName'
 *      defaultTimeZoneId: // value for 'defaultTimeZoneId'
 *      primaryPhoneNumber: // value for 'primaryPhoneNumber'
 *      primaryEmail: // value for 'primaryEmail'
 *      primaryAddressLocationId: // value for 'primaryAddressLocationId'
 *      billingStreetAddress: // value for 'billingStreetAddress'
 *      billingCity: // value for 'billingCity'
 *      billingState: // value for 'billingState'
 *      billingCountry: // value for 'billingCountry'
 *      billingZip: // value for 'billingZip'
 *   },
 * });
 */
export function useUpdateCourierSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourierSettingsMutation, UpdateCourierSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourierSettingsMutation, UpdateCourierSettingsMutationVariables>(UpdateCourierSettingsDocument, options);
      }
export type UpdateCourierSettingsMutationHookResult = ReturnType<typeof useUpdateCourierSettingsMutation>;
export type UpdateCourierSettingsMutationResult = Apollo.MutationResult<UpdateCourierSettingsMutation>;
export type UpdateCourierSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCourierSettingsMutation, UpdateCourierSettingsMutationVariables>;
export const UpdateDeliverySettingsDocument = gql`
    mutation UpdateDeliverySettings($courierId: ID!, $pickupPodRequirementType: PodRequirementAtStop!, $dropOffPodRequirementType: PodRequirementAtStop!, $returnPodRequirementType: PodRequirementAtStop!) {
  updateDeliverySettings(
    courierId: $courierId
    pickupPodRequirementType: $pickupPodRequirementType
    dropOffPodRequirementType: $dropOffPodRequirementType
    returnPodRequirementType: $returnPodRequirementType
  ) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type UpdateDeliverySettingsMutationFn = Apollo.MutationFunction<UpdateDeliverySettingsMutation, UpdateDeliverySettingsMutationVariables>;

/**
 * __useUpdateDeliverySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDeliverySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliverySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliverySettingsMutation, { data, loading, error }] = useUpdateDeliverySettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pickupPodRequirementType: // value for 'pickupPodRequirementType'
 *      dropOffPodRequirementType: // value for 'dropOffPodRequirementType'
 *      returnPodRequirementType: // value for 'returnPodRequirementType'
 *   },
 * });
 */
export function useUpdateDeliverySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliverySettingsMutation, UpdateDeliverySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliverySettingsMutation, UpdateDeliverySettingsMutationVariables>(UpdateDeliverySettingsDocument, options);
      }
export type UpdateDeliverySettingsMutationHookResult = ReturnType<typeof useUpdateDeliverySettingsMutation>;
export type UpdateDeliverySettingsMutationResult = Apollo.MutationResult<UpdateDeliverySettingsMutation>;
export type UpdateDeliverySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDeliverySettingsMutation, UpdateDeliverySettingsMutationVariables>;
export const UpdateDispatchSettingsDocument = gql`
    mutation UpdateDispatchSettings($courierId: ID!, $estimatedDwellTimeInSeconds: Int!, $additionalRequiredFields: [DispatcherOrderEntryAdditionalField!]!, $timeFormatPreference: TimeFormatPreference, $addressBookAutoFillType: AddressBookAutoFillType, $orderEntryDefaultAddressAutoFillType: OrderEntryDefaultAddressAutoFillType, $addressBookSavingType: AddressBookSavingType, $locationIdentifyTypesPickUp: [LocationIdentifyType!], $locationIdentifyTypesDropOff: [LocationIdentifyType!], $multiStopsOptimizationType: MultiStopsOptimizationType, $liveRouteSequencingType: LiveRouteSequencingType, $orderIdentifierColumnType: OrderIdentifierColumnType) {
  updateDispatchSettings(
    courierId: $courierId
    estimatedDwellTimeInSeconds: $estimatedDwellTimeInSeconds
    additionalRequiredFields: $additionalRequiredFields
    timeFormatPreference: $timeFormatPreference
    addressBookAutoFillType: $addressBookAutoFillType
    orderEntryDefaultAddressAutoFillType: $orderEntryDefaultAddressAutoFillType
    addressBookSavingType: $addressBookSavingType
    locationIdentifyTypesPickUp: $locationIdentifyTypesPickUp
    locationIdentifyTypesDropOff: $locationIdentifyTypesDropOff
    multiStopsOptimizationType: $multiStopsOptimizationType
    liveRouteSequencingType: $liveRouteSequencingType
    orderIdentifierColumnType: $orderIdentifierColumnType
  ) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type UpdateDispatchSettingsMutationFn = Apollo.MutationFunction<UpdateDispatchSettingsMutation, UpdateDispatchSettingsMutationVariables>;

/**
 * __useUpdateDispatchSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDispatchSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDispatchSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDispatchSettingsMutation, { data, loading, error }] = useUpdateDispatchSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      estimatedDwellTimeInSeconds: // value for 'estimatedDwellTimeInSeconds'
 *      additionalRequiredFields: // value for 'additionalRequiredFields'
 *      timeFormatPreference: // value for 'timeFormatPreference'
 *      addressBookAutoFillType: // value for 'addressBookAutoFillType'
 *      orderEntryDefaultAddressAutoFillType: // value for 'orderEntryDefaultAddressAutoFillType'
 *      addressBookSavingType: // value for 'addressBookSavingType'
 *      locationIdentifyTypesPickUp: // value for 'locationIdentifyTypesPickUp'
 *      locationIdentifyTypesDropOff: // value for 'locationIdentifyTypesDropOff'
 *      multiStopsOptimizationType: // value for 'multiStopsOptimizationType'
 *      liveRouteSequencingType: // value for 'liveRouteSequencingType'
 *      orderIdentifierColumnType: // value for 'orderIdentifierColumnType'
 *   },
 * });
 */
export function useUpdateDispatchSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDispatchSettingsMutation, UpdateDispatchSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDispatchSettingsMutation, UpdateDispatchSettingsMutationVariables>(UpdateDispatchSettingsDocument, options);
      }
export type UpdateDispatchSettingsMutationHookResult = ReturnType<typeof useUpdateDispatchSettingsMutation>;
export type UpdateDispatchSettingsMutationResult = Apollo.MutationResult<UpdateDispatchSettingsMutation>;
export type UpdateDispatchSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDispatchSettingsMutation, UpdateDispatchSettingsMutationVariables>;
export const UpdatePortalSettingsDocument = gql`
    mutation UpdatePortalSettings($courierId: ID!, $priceVisibilityType: EndCustomerPriceVisibilityType!, $orderEntryType: CustomerPortalOrderEntryType!, $additionalRequiredFields: [CustomerPortalAdditionalRequiredFields!]!, $customerPortalNewCustomerPaymentMethodPromptType: CustomerPortalNewCustomerPaymentMethodPromptType, $customerPortalDeliverByTimeVisibility: CustomerPortalDeliverByTimeVisibility, $customerPortalNotice: String) {
  updatePortalSettings(
    courierId: $courierId
    priceVisibilityType: $priceVisibilityType
    orderEntryType: $orderEntryType
    additionalRequiredFields: $additionalRequiredFields
    customerPortalNewCustomerPaymentMethodPromptType: $customerPortalNewCustomerPaymentMethodPromptType
    customerPortalDeliverByTimeVisibility: $customerPortalDeliverByTimeVisibility
    customerPortalNotice: $customerPortalNotice
  ) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type UpdatePortalSettingsMutationFn = Apollo.MutationFunction<UpdatePortalSettingsMutation, UpdatePortalSettingsMutationVariables>;

/**
 * __useUpdatePortalSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePortalSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortalSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortalSettingsMutation, { data, loading, error }] = useUpdatePortalSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      priceVisibilityType: // value for 'priceVisibilityType'
 *      orderEntryType: // value for 'orderEntryType'
 *      additionalRequiredFields: // value for 'additionalRequiredFields'
 *      customerPortalNewCustomerPaymentMethodPromptType: // value for 'customerPortalNewCustomerPaymentMethodPromptType'
 *      customerPortalDeliverByTimeVisibility: // value for 'customerPortalDeliverByTimeVisibility'
 *      customerPortalNotice: // value for 'customerPortalNotice'
 *   },
 * });
 */
export function useUpdatePortalSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortalSettingsMutation, UpdatePortalSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortalSettingsMutation, UpdatePortalSettingsMutationVariables>(UpdatePortalSettingsDocument, options);
      }
export type UpdatePortalSettingsMutationHookResult = ReturnType<typeof useUpdatePortalSettingsMutation>;
export type UpdatePortalSettingsMutationResult = Apollo.MutationResult<UpdatePortalSettingsMutation>;
export type UpdatePortalSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePortalSettingsMutation, UpdatePortalSettingsMutationVariables>;
export const UpdateDriverSettingsDocument = gql`
    mutation UpdateDriverSettings($courierId: ID!, $priceVisibilityType: DriverPriceVisibilityType!, $taskVisibilityType: DriverTaskVisibilityType!, $stopCompletionGuard: StopCompletionGuard!, $gpsRestrictionType: GpsRestrictionType, $maxDistanceToCompleteTaskInMeters: Int, $driverPayStatementVisibility: DriverPayStatementVisibility) {
  updateDriverSettings(
    courierId: $courierId
    priceVisibilityType: $priceVisibilityType
    taskVisibilityType: $taskVisibilityType
    stopCompletionGuard: $stopCompletionGuard
    gpsRestrictionType: $gpsRestrictionType
    maxDistanceToCompleteTaskInMeters: $maxDistanceToCompleteTaskInMeters
    driverPayStatementVisibility: $driverPayStatementVisibility
  ) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type UpdateDriverSettingsMutationFn = Apollo.MutationFunction<UpdateDriverSettingsMutation, UpdateDriverSettingsMutationVariables>;

/**
 * __useUpdateDriverSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDriverSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverSettingsMutation, { data, loading, error }] = useUpdateDriverSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      priceVisibilityType: // value for 'priceVisibilityType'
 *      taskVisibilityType: // value for 'taskVisibilityType'
 *      stopCompletionGuard: // value for 'stopCompletionGuard'
 *      gpsRestrictionType: // value for 'gpsRestrictionType'
 *      maxDistanceToCompleteTaskInMeters: // value for 'maxDistanceToCompleteTaskInMeters'
 *      driverPayStatementVisibility: // value for 'driverPayStatementVisibility'
 *   },
 * });
 */
export function useUpdateDriverSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverSettingsMutation, UpdateDriverSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverSettingsMutation, UpdateDriverSettingsMutationVariables>(UpdateDriverSettingsDocument, options);
      }
export type UpdateDriverSettingsMutationHookResult = ReturnType<typeof useUpdateDriverSettingsMutation>;
export type UpdateDriverSettingsMutationResult = Apollo.MutationResult<UpdateDriverSettingsMutation>;
export type UpdateDriverSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDriverSettingsMutation, UpdateDriverSettingsMutationVariables>;
export const UpdatePricingSettingsDocument = gql`
    mutation UpdatePricingSettings($courierId: ID!, $invoiceCycleStartDate: Date, $defaultInvoicingFrequency: InvoicingFrequency, $defaultInvoiceTaxCodeName: String, $defaultCurrency: String, $freeWaitTimeInSeconds: Int!, $minimumTimeRequiredForWaitTimeSurchargeInSeconds: Int, $defaultSalesTermId: ID, $defaultPreAuthorizeAmountMinimum: Money, $defaultPreAuthorizeAmountMultiplier: Money, $orderPriceTaxDisplayType: OrderPriceTaxDisplayType, $multiStopPricingSequenceType: MultiStopPricingSequenceType, $invoiceApprovalPreconditionType: InvoiceApprovalPreconditionType, $invoiceOrdersInclusionType: InvoiceOrdersInclusionType, $dimFactor: Float, $defaultWeightBasis: WeightBasis) {
  updatePricingSettings(
    courierId: $courierId
    invoiceCycleStartDate: $invoiceCycleStartDate
    defaultInvoicingFrequency: $defaultInvoicingFrequency
    defaultInvoiceTaxCodeName: $defaultInvoiceTaxCodeName
    defaultCurrency: $defaultCurrency
    freeWaitTimeInSeconds: $freeWaitTimeInSeconds
    minimumTimeRequiredForWaitTimeSurchargeInSeconds: $minimumTimeRequiredForWaitTimeSurchargeInSeconds
    defaultSalesTermId: $defaultSalesTermId
    defaultPreAuthorizeAmountMinimum: $defaultPreAuthorizeAmountMinimum
    defaultPreAuthorizeAmountMultiplier: $defaultPreAuthorizeAmountMultiplier
    orderPriceTaxDisplayType: $orderPriceTaxDisplayType
    multiStopPricingSequenceType: $multiStopPricingSequenceType
    invoiceApprovalPreconditionType: $invoiceApprovalPreconditionType
    invoiceOrdersInclusionType: $invoiceOrdersInclusionType
    dimFactor: $dimFactor
    defaultWeightBasis: $defaultWeightBasis
  ) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type UpdatePricingSettingsMutationFn = Apollo.MutationFunction<UpdatePricingSettingsMutation, UpdatePricingSettingsMutationVariables>;

/**
 * __useUpdatePricingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePricingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePricingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePricingSettingsMutation, { data, loading, error }] = useUpdatePricingSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceCycleStartDate: // value for 'invoiceCycleStartDate'
 *      defaultInvoicingFrequency: // value for 'defaultInvoicingFrequency'
 *      defaultInvoiceTaxCodeName: // value for 'defaultInvoiceTaxCodeName'
 *      defaultCurrency: // value for 'defaultCurrency'
 *      freeWaitTimeInSeconds: // value for 'freeWaitTimeInSeconds'
 *      minimumTimeRequiredForWaitTimeSurchargeInSeconds: // value for 'minimumTimeRequiredForWaitTimeSurchargeInSeconds'
 *      defaultSalesTermId: // value for 'defaultSalesTermId'
 *      defaultPreAuthorizeAmountMinimum: // value for 'defaultPreAuthorizeAmountMinimum'
 *      defaultPreAuthorizeAmountMultiplier: // value for 'defaultPreAuthorizeAmountMultiplier'
 *      orderPriceTaxDisplayType: // value for 'orderPriceTaxDisplayType'
 *      multiStopPricingSequenceType: // value for 'multiStopPricingSequenceType'
 *      invoiceApprovalPreconditionType: // value for 'invoiceApprovalPreconditionType'
 *      invoiceOrdersInclusionType: // value for 'invoiceOrdersInclusionType'
 *      dimFactor: // value for 'dimFactor'
 *      defaultWeightBasis: // value for 'defaultWeightBasis'
 *   },
 * });
 */
export function useUpdatePricingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePricingSettingsMutation, UpdatePricingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePricingSettingsMutation, UpdatePricingSettingsMutationVariables>(UpdatePricingSettingsDocument, options);
      }
export type UpdatePricingSettingsMutationHookResult = ReturnType<typeof useUpdatePricingSettingsMutation>;
export type UpdatePricingSettingsMutationResult = Apollo.MutationResult<UpdatePricingSettingsMutation>;
export type UpdatePricingSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePricingSettingsMutation, UpdatePricingSettingsMutationVariables>;
export const UpdateEnabledCourierCommunicationsTypesDocument = gql`
    mutation UpdateEnabledCourierCommunicationsTypes($courierId: ID!, $enabledCommunicationTypeIds: [CommunicationTypeId!]!) {
  updateEnabledCourierCommunicationsTypes(
    courierId: $courierId
    enabledCommunicationTypeIds: $enabledCommunicationTypeIds
  )
}
    `;
export type UpdateEnabledCourierCommunicationsTypesMutationFn = Apollo.MutationFunction<UpdateEnabledCourierCommunicationsTypesMutation, UpdateEnabledCourierCommunicationsTypesMutationVariables>;

/**
 * __useUpdateEnabledCourierCommunicationsTypesMutation__
 *
 * To run a mutation, you first call `useUpdateEnabledCourierCommunicationsTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnabledCourierCommunicationsTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnabledCourierCommunicationsTypesMutation, { data, loading, error }] = useUpdateEnabledCourierCommunicationsTypesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      enabledCommunicationTypeIds: // value for 'enabledCommunicationTypeIds'
 *   },
 * });
 */
export function useUpdateEnabledCourierCommunicationsTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnabledCourierCommunicationsTypesMutation, UpdateEnabledCourierCommunicationsTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnabledCourierCommunicationsTypesMutation, UpdateEnabledCourierCommunicationsTypesMutationVariables>(UpdateEnabledCourierCommunicationsTypesDocument, options);
      }
export type UpdateEnabledCourierCommunicationsTypesMutationHookResult = ReturnType<typeof useUpdateEnabledCourierCommunicationsTypesMutation>;
export type UpdateEnabledCourierCommunicationsTypesMutationResult = Apollo.MutationResult<UpdateEnabledCourierCommunicationsTypesMutation>;
export type UpdateEnabledCourierCommunicationsTypesMutationOptions = Apollo.BaseMutationOptions<UpdateEnabledCourierCommunicationsTypesMutation, UpdateEnabledCourierCommunicationsTypesMutationVariables>;
export const UpdateCourierDistanceSourceDocument = gql`
    mutation UpdateCourierDistanceSource($courierId: ID!, $pricingDistanceSource: MapApi!) {
  updateCourierDistanceSource(
    courierId: $courierId
    pricingDistanceSource: $pricingDistanceSource
  ) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type UpdateCourierDistanceSourceMutationFn = Apollo.MutationFunction<UpdateCourierDistanceSourceMutation, UpdateCourierDistanceSourceMutationVariables>;

/**
 * __useUpdateCourierDistanceSourceMutation__
 *
 * To run a mutation, you first call `useUpdateCourierDistanceSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourierDistanceSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourierDistanceSourceMutation, { data, loading, error }] = useUpdateCourierDistanceSourceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingDistanceSource: // value for 'pricingDistanceSource'
 *   },
 * });
 */
export function useUpdateCourierDistanceSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourierDistanceSourceMutation, UpdateCourierDistanceSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourierDistanceSourceMutation, UpdateCourierDistanceSourceMutationVariables>(UpdateCourierDistanceSourceDocument, options);
      }
export type UpdateCourierDistanceSourceMutationHookResult = ReturnType<typeof useUpdateCourierDistanceSourceMutation>;
export type UpdateCourierDistanceSourceMutationResult = Apollo.MutationResult<UpdateCourierDistanceSourceMutation>;
export type UpdateCourierDistanceSourceMutationOptions = Apollo.BaseMutationOptions<UpdateCourierDistanceSourceMutation, UpdateCourierDistanceSourceMutationVariables>;
export const EnableCourierMetabaseDocument = gql`
    mutation EnableCourierMetabase($courierId: ID!) {
  enableCourierMetabase(courierId: $courierId) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type EnableCourierMetabaseMutationFn = Apollo.MutationFunction<EnableCourierMetabaseMutation, EnableCourierMetabaseMutationVariables>;

/**
 * __useEnableCourierMetabaseMutation__
 *
 * To run a mutation, you first call `useEnableCourierMetabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableCourierMetabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableCourierMetabaseMutation, { data, loading, error }] = useEnableCourierMetabaseMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useEnableCourierMetabaseMutation(baseOptions?: Apollo.MutationHookOptions<EnableCourierMetabaseMutation, EnableCourierMetabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableCourierMetabaseMutation, EnableCourierMetabaseMutationVariables>(EnableCourierMetabaseDocument, options);
      }
export type EnableCourierMetabaseMutationHookResult = ReturnType<typeof useEnableCourierMetabaseMutation>;
export type EnableCourierMetabaseMutationResult = Apollo.MutationResult<EnableCourierMetabaseMutation>;
export type EnableCourierMetabaseMutationOptions = Apollo.BaseMutationOptions<EnableCourierMetabaseMutation, EnableCourierMetabaseMutationVariables>;
export const CreateCourierBrandDocument = gql`
    mutation CreateCourierBrand($courierId: ID!, $name: String!, $logoFile: Upload, $email: String!, $phone: String, $streetAddress: String!, $city: String!, $state: String!, $country: String!, $replyToEmails: [String!], $ccEmails: [String!]) {
  createCourierBrand(
    courierId: $courierId
    name: $name
    logoFile: $logoFile
    email: $email
    phone: $phone
    streetAddress: $streetAddress
    city: $city
    state: $state
    country: $country
    replyToEmails: $replyToEmails
    ccEmails: $ccEmails
  ) {
    ...CourierBrandFragment
  }
}
    ${CourierBrandFragmentFragmentDoc}`;
export type CreateCourierBrandMutationFn = Apollo.MutationFunction<CreateCourierBrandMutation, CreateCourierBrandMutationVariables>;

/**
 * __useCreateCourierBrandMutation__
 *
 * To run a mutation, you first call `useCreateCourierBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourierBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourierBrandMutation, { data, loading, error }] = useCreateCourierBrandMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      logoFile: // value for 'logoFile'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      streetAddress: // value for 'streetAddress'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      replyToEmails: // value for 'replyToEmails'
 *      ccEmails: // value for 'ccEmails'
 *   },
 * });
 */
export function useCreateCourierBrandMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourierBrandMutation, CreateCourierBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourierBrandMutation, CreateCourierBrandMutationVariables>(CreateCourierBrandDocument, options);
      }
export type CreateCourierBrandMutationHookResult = ReturnType<typeof useCreateCourierBrandMutation>;
export type CreateCourierBrandMutationResult = Apollo.MutationResult<CreateCourierBrandMutation>;
export type CreateCourierBrandMutationOptions = Apollo.BaseMutationOptions<CreateCourierBrandMutation, CreateCourierBrandMutationVariables>;
export const FullUpdateCourierBrandDocument = gql`
    mutation FullUpdateCourierBrand($id: ID!, $courierId: ID!, $name: String!, $logoFile: Upload, $clearLogo: Boolean, $email: String!, $phone: String, $streetAddress: String!, $city: String!, $state: String!, $country: String!, $replyToEmails: [String!], $ccEmails: [String!]) {
  fullUpdateCourierBrand(
    id: $id
    courierId: $courierId
    name: $name
    logoFile: $logoFile
    clearLogo: $clearLogo
    email: $email
    phone: $phone
    streetAddress: $streetAddress
    city: $city
    state: $state
    country: $country
    replyToEmails: $replyToEmails
    ccEmails: $ccEmails
  ) {
    ...CourierBrandFragment
  }
}
    ${CourierBrandFragmentFragmentDoc}`;
export type FullUpdateCourierBrandMutationFn = Apollo.MutationFunction<FullUpdateCourierBrandMutation, FullUpdateCourierBrandMutationVariables>;

/**
 * __useFullUpdateCourierBrandMutation__
 *
 * To run a mutation, you first call `useFullUpdateCourierBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateCourierBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateCourierBrandMutation, { data, loading, error }] = useFullUpdateCourierBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      logoFile: // value for 'logoFile'
 *      clearLogo: // value for 'clearLogo'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      streetAddress: // value for 'streetAddress'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      replyToEmails: // value for 'replyToEmails'
 *      ccEmails: // value for 'ccEmails'
 *   },
 * });
 */
export function useFullUpdateCourierBrandMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateCourierBrandMutation, FullUpdateCourierBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateCourierBrandMutation, FullUpdateCourierBrandMutationVariables>(FullUpdateCourierBrandDocument, options);
      }
export type FullUpdateCourierBrandMutationHookResult = ReturnType<typeof useFullUpdateCourierBrandMutation>;
export type FullUpdateCourierBrandMutationResult = Apollo.MutationResult<FullUpdateCourierBrandMutation>;
export type FullUpdateCourierBrandMutationOptions = Apollo.BaseMutationOptions<FullUpdateCourierBrandMutation, FullUpdateCourierBrandMutationVariables>;
export const DeleteCourierBrandDocument = gql`
    mutation DeleteCourierBrand($courierId: ID!, $id: ID!) {
  deleteCourierBrand(courierId: $courierId, id: $id)
}
    `;
export type DeleteCourierBrandMutationFn = Apollo.MutationFunction<DeleteCourierBrandMutation, DeleteCourierBrandMutationVariables>;

/**
 * __useDeleteCourierBrandMutation__
 *
 * To run a mutation, you first call `useDeleteCourierBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourierBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourierBrandMutation, { data, loading, error }] = useDeleteCourierBrandMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCourierBrandMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourierBrandMutation, DeleteCourierBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourierBrandMutation, DeleteCourierBrandMutationVariables>(DeleteCourierBrandDocument, options);
      }
export type DeleteCourierBrandMutationHookResult = ReturnType<typeof useDeleteCourierBrandMutation>;
export type DeleteCourierBrandMutationResult = Apollo.MutationResult<DeleteCourierBrandMutation>;
export type DeleteCourierBrandMutationOptions = Apollo.BaseMutationOptions<DeleteCourierBrandMutation, DeleteCourierBrandMutationVariables>;
export const UpdateShipmentsCustomFiltersDocument = gql`
    mutation UpdateShipmentsCustomFilters($courierId: ID!, $filters: [ShipmentsCustomFilterInput!]!) {
  updateShipmentsCustomFilters(courierId: $courierId, filters: $filters) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;
export type UpdateShipmentsCustomFiltersMutationFn = Apollo.MutationFunction<UpdateShipmentsCustomFiltersMutation, UpdateShipmentsCustomFiltersMutationVariables>;

/**
 * __useUpdateShipmentsCustomFiltersMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentsCustomFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentsCustomFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentsCustomFiltersMutation, { data, loading, error }] = useUpdateShipmentsCustomFiltersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUpdateShipmentsCustomFiltersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShipmentsCustomFiltersMutation, UpdateShipmentsCustomFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShipmentsCustomFiltersMutation, UpdateShipmentsCustomFiltersMutationVariables>(UpdateShipmentsCustomFiltersDocument, options);
      }
export type UpdateShipmentsCustomFiltersMutationHookResult = ReturnType<typeof useUpdateShipmentsCustomFiltersMutation>;
export type UpdateShipmentsCustomFiltersMutationResult = Apollo.MutationResult<UpdateShipmentsCustomFiltersMutation>;
export type UpdateShipmentsCustomFiltersMutationOptions = Apollo.BaseMutationOptions<UpdateShipmentsCustomFiltersMutation, UpdateShipmentsCustomFiltersMutationVariables>;
export const GetCourierDocument = gql`
    query GetCourier($courierId: ID!) {
  courier(courierId: $courierId) {
    ...CourierFragment
    packageTypes {
      id
      courierId
      name
      defaultLength
      defaultWidth
      defaultHeight
      defaultWeight
      defaultWeightApplication
      category
      enabled
    }
    vehicleTypes {
      ...VehicleTypeFragment
    }
    holidaySchedules {
      ...HolidayScheduleFragment
    }
    customFields {
      ...CustomFieldFragment
    }
    enabledCommunicationTypes
    primaryLocation {
      ...LocationFragment
    }
    defaultSalesTerm {
      ...SalesTermFragment
    }
    salesTerms {
      ...SalesTermFragment
    }
  }
}
    ${CourierFragmentFragmentDoc}
${VehicleTypeFragmentFragmentDoc}
${HolidayScheduleFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${SalesTermFragmentFragmentDoc}`;

/**
 * __useGetCourierQuery__
 *
 * To run a query within a React component, call `useGetCourierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetCourierQuery(baseOptions: Apollo.QueryHookOptions<GetCourierQuery, GetCourierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierQuery, GetCourierQueryVariables>(GetCourierDocument, options);
      }
export function useGetCourierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierQuery, GetCourierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierQuery, GetCourierQueryVariables>(GetCourierDocument, options);
        }
export type GetCourierQueryHookResult = ReturnType<typeof useGetCourierQuery>;
export type GetCourierLazyQueryHookResult = ReturnType<typeof useGetCourierLazyQuery>;
export type GetCourierQueryResult = Apollo.QueryResult<GetCourierQuery, GetCourierQueryVariables>;
export const GetCouriersDocument = gql`
    query GetCouriers {
  couriers {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;

/**
 * __useGetCouriersQuery__
 *
 * To run a query within a React component, call `useGetCouriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCouriersQuery(baseOptions?: Apollo.QueryHookOptions<GetCouriersQuery, GetCouriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouriersQuery, GetCouriersQueryVariables>(GetCouriersDocument, options);
      }
export function useGetCouriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouriersQuery, GetCouriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouriersQuery, GetCouriersQueryVariables>(GetCouriersDocument, options);
        }
export type GetCouriersQueryHookResult = ReturnType<typeof useGetCouriersQuery>;
export type GetCouriersLazyQueryHookResult = ReturnType<typeof useGetCouriersLazyQuery>;
export type GetCouriersQueryResult = Apollo.QueryResult<GetCouriersQuery, GetCouriersQueryVariables>;
export const GetCourierBrandsDocument = gql`
    query GetCourierBrands($courierId: ID!) {
  courierBrands(courierId: $courierId) {
    ...CourierBrandFragment
  }
}
    ${CourierBrandFragmentFragmentDoc}`;

/**
 * __useGetCourierBrandsQuery__
 *
 * To run a query within a React component, call `useGetCourierBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierBrandsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetCourierBrandsQuery(baseOptions: Apollo.QueryHookOptions<GetCourierBrandsQuery, GetCourierBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierBrandsQuery, GetCourierBrandsQueryVariables>(GetCourierBrandsDocument, options);
      }
export function useGetCourierBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierBrandsQuery, GetCourierBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierBrandsQuery, GetCourierBrandsQueryVariables>(GetCourierBrandsDocument, options);
        }
export type GetCourierBrandsQueryHookResult = ReturnType<typeof useGetCourierBrandsQuery>;
export type GetCourierBrandsLazyQueryHookResult = ReturnType<typeof useGetCourierBrandsLazyQuery>;
export type GetCourierBrandsQueryResult = Apollo.QueryResult<GetCourierBrandsQuery, GetCourierBrandsQueryVariables>;
export const CreateCourierTermDocument = gql`
    mutation createCourierTerm($courierId: ID!, $name: String!, $content: String!) {
  createCourierTerm(courierId: $courierId, name: $name, content: $content) {
    id
    courierId
    name
    content
  }
}
    `;
export type CreateCourierTermMutationFn = Apollo.MutationFunction<CreateCourierTermMutation, CreateCourierTermMutationVariables>;

/**
 * __useCreateCourierTermMutation__
 *
 * To run a mutation, you first call `useCreateCourierTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourierTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourierTermMutation, { data, loading, error }] = useCreateCourierTermMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateCourierTermMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourierTermMutation, CreateCourierTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourierTermMutation, CreateCourierTermMutationVariables>(CreateCourierTermDocument, options);
      }
export type CreateCourierTermMutationHookResult = ReturnType<typeof useCreateCourierTermMutation>;
export type CreateCourierTermMutationResult = Apollo.MutationResult<CreateCourierTermMutation>;
export type CreateCourierTermMutationOptions = Apollo.BaseMutationOptions<CreateCourierTermMutation, CreateCourierTermMutationVariables>;
export const GetCourierTermsDocument = gql`
    query getCourierTerms($courierId: ID!) {
  courierTerms(courierId: $courierId) {
    id
    name
    content
  }
}
    `;

/**
 * __useGetCourierTermsQuery__
 *
 * To run a query within a React component, call `useGetCourierTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierTermsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetCourierTermsQuery(baseOptions: Apollo.QueryHookOptions<GetCourierTermsQuery, GetCourierTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierTermsQuery, GetCourierTermsQueryVariables>(GetCourierTermsDocument, options);
      }
export function useGetCourierTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierTermsQuery, GetCourierTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierTermsQuery, GetCourierTermsQueryVariables>(GetCourierTermsDocument, options);
        }
export type GetCourierTermsQueryHookResult = ReturnType<typeof useGetCourierTermsQuery>;
export type GetCourierTermsLazyQueryHookResult = ReturnType<typeof useGetCourierTermsLazyQuery>;
export type GetCourierTermsQueryResult = Apollo.QueryResult<GetCourierTermsQuery, GetCourierTermsQueryVariables>;
export const CreateCustomRoleDocument = gql`
    mutation CreateCustomRole($courierId: String!, $name: String!, $parentRole: UserRoleType!) {
  createCustomRole(courierId: $courierId, name: $name, parentRole: $parentRole) {
    ...CustomRoleFragment
  }
}
    ${CustomRoleFragmentFragmentDoc}`;
export type CreateCustomRoleMutationFn = Apollo.MutationFunction<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>;

/**
 * __useCreateCustomRoleMutation__
 *
 * To run a mutation, you first call `useCreateCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomRoleMutation, { data, loading, error }] = useCreateCustomRoleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      parentRole: // value for 'parentRole'
 *   },
 * });
 */
export function useCreateCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>(CreateCustomRoleDocument, options);
      }
export type CreateCustomRoleMutationHookResult = ReturnType<typeof useCreateCustomRoleMutation>;
export type CreateCustomRoleMutationResult = Apollo.MutationResult<CreateCustomRoleMutation>;
export type CreateCustomRoleMutationOptions = Apollo.BaseMutationOptions<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>;
export const UpdateCustomRoleOverridesDocument = gql`
    mutation UpdateCustomRoleOverrides($courierId: String!, $customRoleId: String!, $overrides: [PermissionOverrideInput!]!) {
  updateCustomRoleOverrides(
    courierId: $courierId
    customRoleId: $customRoleId
    overrides: $overrides
  ) {
    ...CustomRoleFragment
  }
}
    ${CustomRoleFragmentFragmentDoc}`;
export type UpdateCustomRoleOverridesMutationFn = Apollo.MutationFunction<UpdateCustomRoleOverridesMutation, UpdateCustomRoleOverridesMutationVariables>;

/**
 * __useUpdateCustomRoleOverridesMutation__
 *
 * To run a mutation, you first call `useUpdateCustomRoleOverridesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomRoleOverridesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomRoleOverridesMutation, { data, loading, error }] = useUpdateCustomRoleOverridesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      customRoleId: // value for 'customRoleId'
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useUpdateCustomRoleOverridesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomRoleOverridesMutation, UpdateCustomRoleOverridesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomRoleOverridesMutation, UpdateCustomRoleOverridesMutationVariables>(UpdateCustomRoleOverridesDocument, options);
      }
export type UpdateCustomRoleOverridesMutationHookResult = ReturnType<typeof useUpdateCustomRoleOverridesMutation>;
export type UpdateCustomRoleOverridesMutationResult = Apollo.MutationResult<UpdateCustomRoleOverridesMutation>;
export type UpdateCustomRoleOverridesMutationOptions = Apollo.BaseMutationOptions<UpdateCustomRoleOverridesMutation, UpdateCustomRoleOverridesMutationVariables>;
export const DeleteCustomRoleDocument = gql`
    mutation DeleteCustomRole($courierId: String!, $customRoleId: String!) {
  deleteCustomRole(courierId: $courierId, customRoleId: $customRoleId)
}
    `;
export type DeleteCustomRoleMutationFn = Apollo.MutationFunction<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>;

/**
 * __useDeleteCustomRoleMutation__
 *
 * To run a mutation, you first call `useDeleteCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomRoleMutation, { data, loading, error }] = useDeleteCustomRoleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      customRoleId: // value for 'customRoleId'
 *   },
 * });
 */
export function useDeleteCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>(DeleteCustomRoleDocument, options);
      }
export type DeleteCustomRoleMutationHookResult = ReturnType<typeof useDeleteCustomRoleMutation>;
export type DeleteCustomRoleMutationResult = Apollo.MutationResult<DeleteCustomRoleMutation>;
export type DeleteCustomRoleMutationOptions = Apollo.BaseMutationOptions<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>;
export const GetCustomRolesDocument = gql`
    query GetCustomRoles($courierId: String!) {
  customRoles(courierId: $courierId) {
    ...CustomRoleFragment
  }
}
    ${CustomRoleFragmentFragmentDoc}`;

/**
 * __useGetCustomRolesQuery__
 *
 * To run a query within a React component, call `useGetCustomRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomRolesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetCustomRolesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomRolesQuery, GetCustomRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomRolesQuery, GetCustomRolesQueryVariables>(GetCustomRolesDocument, options);
      }
export function useGetCustomRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomRolesQuery, GetCustomRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomRolesQuery, GetCustomRolesQueryVariables>(GetCustomRolesDocument, options);
        }
export type GetCustomRolesQueryHookResult = ReturnType<typeof useGetCustomRolesQuery>;
export type GetCustomRolesLazyQueryHookResult = ReturnType<typeof useGetCustomRolesLazyQuery>;
export type GetCustomRolesQueryResult = Apollo.QueryResult<GetCustomRolesQuery, GetCustomRolesQueryVariables>;
export const GetAllPermissionsDocument = gql`
    query GetAllPermissions {
  allPermissions
}
    `;

/**
 * __useGetAllPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAllPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPermissionsQuery, GetAllPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPermissionsQuery, GetAllPermissionsQueryVariables>(GetAllPermissionsDocument, options);
      }
export function useGetAllPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPermissionsQuery, GetAllPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPermissionsQuery, GetAllPermissionsQueryVariables>(GetAllPermissionsDocument, options);
        }
export type GetAllPermissionsQueryHookResult = ReturnType<typeof useGetAllPermissionsQuery>;
export type GetAllPermissionsLazyQueryHookResult = ReturnType<typeof useGetAllPermissionsLazyQuery>;
export type GetAllPermissionsQueryResult = Apollo.QueryResult<GetAllPermissionsQuery, GetAllPermissionsQueryVariables>;
export const GetDefaultPermissionsForRoleDocument = gql`
    query GetDefaultPermissionsForRole($role: UserRoleType!) {
  defaultPermissionsForRole(role: $role)
}
    `;

/**
 * __useGetDefaultPermissionsForRoleQuery__
 *
 * To run a query within a React component, call `useGetDefaultPermissionsForRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultPermissionsForRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultPermissionsForRoleQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetDefaultPermissionsForRoleQuery(baseOptions: Apollo.QueryHookOptions<GetDefaultPermissionsForRoleQuery, GetDefaultPermissionsForRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultPermissionsForRoleQuery, GetDefaultPermissionsForRoleQueryVariables>(GetDefaultPermissionsForRoleDocument, options);
      }
export function useGetDefaultPermissionsForRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultPermissionsForRoleQuery, GetDefaultPermissionsForRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultPermissionsForRoleQuery, GetDefaultPermissionsForRoleQueryVariables>(GetDefaultPermissionsForRoleDocument, options);
        }
export type GetDefaultPermissionsForRoleQueryHookResult = ReturnType<typeof useGetDefaultPermissionsForRoleQuery>;
export type GetDefaultPermissionsForRoleLazyQueryHookResult = ReturnType<typeof useGetDefaultPermissionsForRoleLazyQuery>;
export type GetDefaultPermissionsForRoleQueryResult = Apollo.QueryResult<GetDefaultPermissionsForRoleQuery, GetDefaultPermissionsForRoleQueryVariables>;
export const CreateCustomFieldDocument = gql`
    mutation createCustomField($courierId: ID!, $name: String!, $type: CustomFieldType!, $visibilityType: CustomFieldCustomerVisibilityType, $customerSpecificityType: CustomFieldCustomerSpecificity, $requirementType: CustomFieldCustomerRequirementType, $isVisibleToDrivers: Boolean, $choices: [String!], $orderingSequenceNumber: Int, $defaultOptionIndex: Int, $minValue: Float, $maxValue: Float, $terms: CustomFieldTermsConfigInput, $helperText: String) {
  createCustomField(
    courierId: $courierId
    name: $name
    type: $type
    visibilityType: $visibilityType
    customerSpecificityType: $customerSpecificityType
    requirementType: $requirementType
    isVisibleToDrivers: $isVisibleToDrivers
    choices: $choices
    orderingSequenceNumber: $orderingSequenceNumber
    defaultOptionIndex: $defaultOptionIndex
    minValue: $minValue
    maxValue: $maxValue
    terms: $terms
    helperText: $helperText
  ) {
    ...CustomFieldFragment
  }
}
    ${CustomFieldFragmentFragmentDoc}`;
export type CreateCustomFieldMutationFn = Apollo.MutationFunction<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;

/**
 * __useCreateCustomFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFieldMutation, { data, loading, error }] = useCreateCustomFieldMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      visibilityType: // value for 'visibilityType'
 *      customerSpecificityType: // value for 'customerSpecificityType'
 *      requirementType: // value for 'requirementType'
 *      isVisibleToDrivers: // value for 'isVisibleToDrivers'
 *      choices: // value for 'choices'
 *      orderingSequenceNumber: // value for 'orderingSequenceNumber'
 *      defaultOptionIndex: // value for 'defaultOptionIndex'
 *      minValue: // value for 'minValue'
 *      maxValue: // value for 'maxValue'
 *      terms: // value for 'terms'
 *      helperText: // value for 'helperText'
 *   },
 * });
 */
export function useCreateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>(CreateCustomFieldDocument, options);
      }
export type CreateCustomFieldMutationHookResult = ReturnType<typeof useCreateCustomFieldMutation>;
export type CreateCustomFieldMutationResult = Apollo.MutationResult<CreateCustomFieldMutation>;
export type CreateCustomFieldMutationOptions = Apollo.BaseMutationOptions<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;
export const FullUpdateCustomFieldDocument = gql`
    mutation fullUpdateCustomField($courierId: ID!, $id: ID!, $name: String!, $visibilityType: CustomFieldCustomerVisibilityType!, $customerSpecificityType: CustomFieldCustomerSpecificity!, $requirementType: CustomFieldCustomerRequirementType!, $isVisibleToDrivers: Boolean, $choices: [String!], $orderingSequenceNumber: Int, $defaultOptionIndex: Int, $minValue: Float, $maxValue: Float, $terms: CustomFieldTermsConfigInput, $helperText: String) {
  fullUpdateCustomField(
    courierId: $courierId
    id: $id
    name: $name
    visibilityType: $visibilityType
    customerSpecificityType: $customerSpecificityType
    requirementType: $requirementType
    isVisibleToDrivers: $isVisibleToDrivers
    choices: $choices
    orderingSequenceNumber: $orderingSequenceNumber
    defaultOptionIndex: $defaultOptionIndex
    minValue: $minValue
    maxValue: $maxValue
    terms: $terms
    helperText: $helperText
  ) {
    ...CustomFieldFragment
  }
}
    ${CustomFieldFragmentFragmentDoc}`;
export type FullUpdateCustomFieldMutationFn = Apollo.MutationFunction<FullUpdateCustomFieldMutation, FullUpdateCustomFieldMutationVariables>;

/**
 * __useFullUpdateCustomFieldMutation__
 *
 * To run a mutation, you first call `useFullUpdateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateCustomFieldMutation, { data, loading, error }] = useFullUpdateCustomFieldMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      visibilityType: // value for 'visibilityType'
 *      customerSpecificityType: // value for 'customerSpecificityType'
 *      requirementType: // value for 'requirementType'
 *      isVisibleToDrivers: // value for 'isVisibleToDrivers'
 *      choices: // value for 'choices'
 *      orderingSequenceNumber: // value for 'orderingSequenceNumber'
 *      defaultOptionIndex: // value for 'defaultOptionIndex'
 *      minValue: // value for 'minValue'
 *      maxValue: // value for 'maxValue'
 *      terms: // value for 'terms'
 *      helperText: // value for 'helperText'
 *   },
 * });
 */
export function useFullUpdateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateCustomFieldMutation, FullUpdateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateCustomFieldMutation, FullUpdateCustomFieldMutationVariables>(FullUpdateCustomFieldDocument, options);
      }
export type FullUpdateCustomFieldMutationHookResult = ReturnType<typeof useFullUpdateCustomFieldMutation>;
export type FullUpdateCustomFieldMutationResult = Apollo.MutationResult<FullUpdateCustomFieldMutation>;
export type FullUpdateCustomFieldMutationOptions = Apollo.BaseMutationOptions<FullUpdateCustomFieldMutation, FullUpdateCustomFieldMutationVariables>;
export const MarkCustomFieldAsDeletedDocument = gql`
    mutation markCustomFieldAsDeleted($courierId: ID!, $id: ID!) {
  markCustomFieldAsDeleted(courierId: $courierId, id: $id)
}
    `;
export type MarkCustomFieldAsDeletedMutationFn = Apollo.MutationFunction<MarkCustomFieldAsDeletedMutation, MarkCustomFieldAsDeletedMutationVariables>;

/**
 * __useMarkCustomFieldAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkCustomFieldAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCustomFieldAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCustomFieldAsDeletedMutation, { data, loading, error }] = useMarkCustomFieldAsDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkCustomFieldAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkCustomFieldAsDeletedMutation, MarkCustomFieldAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCustomFieldAsDeletedMutation, MarkCustomFieldAsDeletedMutationVariables>(MarkCustomFieldAsDeletedDocument, options);
      }
export type MarkCustomFieldAsDeletedMutationHookResult = ReturnType<typeof useMarkCustomFieldAsDeletedMutation>;
export type MarkCustomFieldAsDeletedMutationResult = Apollo.MutationResult<MarkCustomFieldAsDeletedMutation>;
export type MarkCustomFieldAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkCustomFieldAsDeletedMutation, MarkCustomFieldAsDeletedMutationVariables>;
export const GetCustomFieldsDocument = gql`
    query getCustomFields($courierId: ID!, $endCustomerId: ID, $visibleToSelectedEndCustomerOnly: Boolean) {
  customFields(
    courierId: $courierId
    endCustomerId: $endCustomerId
    visibleToSelectedEndCustomerOnly: $visibleToSelectedEndCustomerOnly
  ) {
    ...CustomFieldFragment
  }
}
    ${CustomFieldFragmentFragmentDoc}`;

/**
 * __useGetCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFieldsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      visibleToSelectedEndCustomerOnly: // value for 'visibleToSelectedEndCustomerOnly'
 *   },
 * });
 */
export function useGetCustomFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(GetCustomFieldsDocument, options);
      }
export function useGetCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(GetCustomFieldsDocument, options);
        }
export type GetCustomFieldsQueryHookResult = ReturnType<typeof useGetCustomFieldsQuery>;
export type GetCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetCustomFieldsLazyQuery>;
export type GetCustomFieldsQueryResult = Apollo.QueryResult<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>;
export const DispatchDriverForShipmentDocument = gql`
    mutation DispatchDriverForShipment($courierId: ID!, $shipmentId: ID!, $driverId: ID!, $orderingAlgorithmType: OrderingAlgorithmType, $stopIds: [ID!], $dispatchedBy: ID, $autoRoutedStopIds: [ID!]) {
  dispatchDriverForShipment(
    courierId: $courierId
    shipmentId: $shipmentId
    driverId: $driverId
    orderingAlgorithmType: $orderingAlgorithmType
    stopIds: $stopIds
    dispatchedBy: $dispatchedBy
    autoRoutedStopIds: $autoRoutedStopIds
  )
}
    `;
export type DispatchDriverForShipmentMutationFn = Apollo.MutationFunction<DispatchDriverForShipmentMutation, DispatchDriverForShipmentMutationVariables>;

/**
 * __useDispatchDriverForShipmentMutation__
 *
 * To run a mutation, you first call `useDispatchDriverForShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchDriverForShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchDriverForShipmentMutation, { data, loading, error }] = useDispatchDriverForShipmentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      driverId: // value for 'driverId'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      stopIds: // value for 'stopIds'
 *      dispatchedBy: // value for 'dispatchedBy'
 *      autoRoutedStopIds: // value for 'autoRoutedStopIds'
 *   },
 * });
 */
export function useDispatchDriverForShipmentMutation(baseOptions?: Apollo.MutationHookOptions<DispatchDriverForShipmentMutation, DispatchDriverForShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispatchDriverForShipmentMutation, DispatchDriverForShipmentMutationVariables>(DispatchDriverForShipmentDocument, options);
      }
export type DispatchDriverForShipmentMutationHookResult = ReturnType<typeof useDispatchDriverForShipmentMutation>;
export type DispatchDriverForShipmentMutationResult = Apollo.MutationResult<DispatchDriverForShipmentMutation>;
export type DispatchDriverForShipmentMutationOptions = Apollo.BaseMutationOptions<DispatchDriverForShipmentMutation, DispatchDriverForShipmentMutationVariables>;
export const OptimizeRouteForDispatchDocument = gql`
    mutation OptimizeRouteForDispatch($courierId: ID!, $newShipmentId: ID!, $driverId: ID!, $orderingAlgorithmType: OrderingAlgorithmType!, $stopDate: Date, $baseTime: Timestamp, $startLocationId: ID, $endLocationId: ID, $dispatchScope: DispatchScope) {
  optimizeRouteForDispatch(
    courierId: $courierId
    newShipmentId: $newShipmentId
    driverId: $driverId
    orderingAlgorithmType: $orderingAlgorithmType
    stopDate: $stopDate
    baseTime: $baseTime
    startLocationId: $startLocationId
    endLocationId: $endLocationId
    dispatchScope: $dispatchScope
  ) {
    stops {
      ...StopFragment
      shipment {
        ...ShipmentFragment
        order {
          ...OrderFragment
          serviceType {
            ...ServiceTypeFragment
          }
          endCustomer {
            ...EndCustomerFragment
          }
        }
      }
    }
    allShipmentIdsForGroupDispatch
  }
}
    ${StopFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}`;
export type OptimizeRouteForDispatchMutationFn = Apollo.MutationFunction<OptimizeRouteForDispatchMutation, OptimizeRouteForDispatchMutationVariables>;

/**
 * __useOptimizeRouteForDispatchMutation__
 *
 * To run a mutation, you first call `useOptimizeRouteForDispatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptimizeRouteForDispatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optimizeRouteForDispatchMutation, { data, loading, error }] = useOptimizeRouteForDispatchMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      newShipmentId: // value for 'newShipmentId'
 *      driverId: // value for 'driverId'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      stopDate: // value for 'stopDate'
 *      baseTime: // value for 'baseTime'
 *      startLocationId: // value for 'startLocationId'
 *      endLocationId: // value for 'endLocationId'
 *      dispatchScope: // value for 'dispatchScope'
 *   },
 * });
 */
export function useOptimizeRouteForDispatchMutation(baseOptions?: Apollo.MutationHookOptions<OptimizeRouteForDispatchMutation, OptimizeRouteForDispatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptimizeRouteForDispatchMutation, OptimizeRouteForDispatchMutationVariables>(OptimizeRouteForDispatchDocument, options);
      }
export type OptimizeRouteForDispatchMutationHookResult = ReturnType<typeof useOptimizeRouteForDispatchMutation>;
export type OptimizeRouteForDispatchMutationResult = Apollo.MutationResult<OptimizeRouteForDispatchMutation>;
export type OptimizeRouteForDispatchMutationOptions = Apollo.BaseMutationOptions<OptimizeRouteForDispatchMutation, OptimizeRouteForDispatchMutationVariables>;
export const DispatchDriverForShipmentMultiDayDocument = gql`
    mutation DispatchDriverForShipmentMultiDay($courierId: ID!, $shipmentId: ID!, $driverId: ID!, $orderingAlgorithmType: OrderingAlgorithmType!, $dispatchedBy: ID, $days: [DispatchStopsOnDayInput!]!, $dispatchSource: DispatchSource, $dispatchPreviewSortingType: String, $dispatchPreviewSection: String, $driverRank: Int, $dispatchPreviews: [DispatchPreviewSaveInput!], $dispatchPageType: DispatchPageType, $dispatchScope: DispatchScope) {
  dispatchDriverForShipmentMultiDay(
    courierId: $courierId
    shipmentId: $shipmentId
    driverId: $driverId
    orderingAlgorithmType: $orderingAlgorithmType
    dispatchedBy: $dispatchedBy
    days: $days
    dispatchSource: $dispatchSource
    dispatchPreviewSortingType: $dispatchPreviewSortingType
    dispatchPreviewSection: $dispatchPreviewSection
    driverRank: $driverRank
    dispatchPreviews: $dispatchPreviews
    dispatchPageType: $dispatchPageType
    dispatchScope: $dispatchScope
  )
}
    `;
export type DispatchDriverForShipmentMultiDayMutationFn = Apollo.MutationFunction<DispatchDriverForShipmentMultiDayMutation, DispatchDriverForShipmentMultiDayMutationVariables>;

/**
 * __useDispatchDriverForShipmentMultiDayMutation__
 *
 * To run a mutation, you first call `useDispatchDriverForShipmentMultiDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchDriverForShipmentMultiDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchDriverForShipmentMultiDayMutation, { data, loading, error }] = useDispatchDriverForShipmentMultiDayMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      driverId: // value for 'driverId'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      dispatchedBy: // value for 'dispatchedBy'
 *      days: // value for 'days'
 *      dispatchSource: // value for 'dispatchSource'
 *      dispatchPreviewSortingType: // value for 'dispatchPreviewSortingType'
 *      dispatchPreviewSection: // value for 'dispatchPreviewSection'
 *      driverRank: // value for 'driverRank'
 *      dispatchPreviews: // value for 'dispatchPreviews'
 *      dispatchPageType: // value for 'dispatchPageType'
 *      dispatchScope: // value for 'dispatchScope'
 *   },
 * });
 */
export function useDispatchDriverForShipmentMultiDayMutation(baseOptions?: Apollo.MutationHookOptions<DispatchDriverForShipmentMultiDayMutation, DispatchDriverForShipmentMultiDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispatchDriverForShipmentMultiDayMutation, DispatchDriverForShipmentMultiDayMutationVariables>(DispatchDriverForShipmentMultiDayDocument, options);
      }
export type DispatchDriverForShipmentMultiDayMutationHookResult = ReturnType<typeof useDispatchDriverForShipmentMultiDayMutation>;
export type DispatchDriverForShipmentMultiDayMutationResult = Apollo.MutationResult<DispatchDriverForShipmentMultiDayMutation>;
export type DispatchDriverForShipmentMultiDayMutationOptions = Apollo.BaseMutationOptions<DispatchDriverForShipmentMultiDayMutation, DispatchDriverForShipmentMultiDayMutationVariables>;
export const BulkDispatchDriverForShipmentsDocument = gql`
    mutation BulkDispatchDriverForShipments($courierId: ID!, $shipmentIds: [ID!]!, $driverId: ID!, $orderingAlgorithmType: OrderingAlgorithmType!, $dispatchedBy: ID) {
  bulkDispatchDriverForShipments(
    courierId: $courierId
    shipmentIds: $shipmentIds
    driverId: $driverId
    orderingAlgorithmType: $orderingAlgorithmType
    dispatchedBy: $dispatchedBy
  ) {
    succeededShipmentIds
    failedShipmentIds
  }
}
    `;
export type BulkDispatchDriverForShipmentsMutationFn = Apollo.MutationFunction<BulkDispatchDriverForShipmentsMutation, BulkDispatchDriverForShipmentsMutationVariables>;

/**
 * __useBulkDispatchDriverForShipmentsMutation__
 *
 * To run a mutation, you first call `useBulkDispatchDriverForShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDispatchDriverForShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDispatchDriverForShipmentsMutation, { data, loading, error }] = useBulkDispatchDriverForShipmentsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *      driverId: // value for 'driverId'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      dispatchedBy: // value for 'dispatchedBy'
 *   },
 * });
 */
export function useBulkDispatchDriverForShipmentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkDispatchDriverForShipmentsMutation, BulkDispatchDriverForShipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDispatchDriverForShipmentsMutation, BulkDispatchDriverForShipmentsMutationVariables>(BulkDispatchDriverForShipmentsDocument, options);
      }
export type BulkDispatchDriverForShipmentsMutationHookResult = ReturnType<typeof useBulkDispatchDriverForShipmentsMutation>;
export type BulkDispatchDriverForShipmentsMutationResult = Apollo.MutationResult<BulkDispatchDriverForShipmentsMutation>;
export type BulkDispatchDriverForShipmentsMutationOptions = Apollo.BaseMutationOptions<BulkDispatchDriverForShipmentsMutation, BulkDispatchDriverForShipmentsMutationVariables>;
export const HandOverDriverDayDocument = gql`
    mutation HandOverDriverDay($courierId: ID!, $sourceDriverId: ID!, $targetDriverId: ID!, $date: Date!, $placement: HandOverPlacement!) {
  handOverDriverDay(
    courierId: $courierId
    sourceDriverId: $sourceDriverId
    targetDriverId: $targetDriverId
    date: $date
    placement: $placement
  ) {
    movedShipmentCount
  }
}
    `;
export type HandOverDriverDayMutationFn = Apollo.MutationFunction<HandOverDriverDayMutation, HandOverDriverDayMutationVariables>;

/**
 * __useHandOverDriverDayMutation__
 *
 * To run a mutation, you first call `useHandOverDriverDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandOverDriverDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handOverDriverDayMutation, { data, loading, error }] = useHandOverDriverDayMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      sourceDriverId: // value for 'sourceDriverId'
 *      targetDriverId: // value for 'targetDriverId'
 *      date: // value for 'date'
 *      placement: // value for 'placement'
 *   },
 * });
 */
export function useHandOverDriverDayMutation(baseOptions?: Apollo.MutationHookOptions<HandOverDriverDayMutation, HandOverDriverDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandOverDriverDayMutation, HandOverDriverDayMutationVariables>(HandOverDriverDayDocument, options);
      }
export type HandOverDriverDayMutationHookResult = ReturnType<typeof useHandOverDriverDayMutation>;
export type HandOverDriverDayMutationResult = Apollo.MutationResult<HandOverDriverDayMutation>;
export type HandOverDriverDayMutationOptions = Apollo.BaseMutationOptions<HandOverDriverDayMutation, HandOverDriverDayMutationVariables>;
export const GetDispatchPreviewsDocument = gql`
    query GetDispatchPreviews($courierId: ID!, $shipmentId: ID!, $taskStatusFilter: [TaskStatus!], $shipmentDate: Date!, $isActive: Boolean, $workType: DriverWorkType, $additionalFilters: DispatchAdditionalFilters, $driverLabelIds: [ID!], $payMinDate: Date! = "1970-01-01", $payMaxDate: Date! = "1970-01-01", $payShipmentStatuses: [ShipmentStatus!], $shouldFetchDriverPay: Boolean! = false, $dailyPayMinDate: Date! = "1970-01-01", $dailyPayMaxDate: Date! = "1970-01-01", $dailyPayShipmentStatuses: [ShipmentStatus!], $shouldFetchDailyEarnings: Boolean! = false) {
  dispatchPreviews(
    courierId: $courierId
    shipmentId: $shipmentId
    isActive: $isActive
    workType: $workType
    additionalFilters: $additionalFilters
    driverLabelIds: $driverLabelIds
  ) {
    driver {
      ...DriverFragment
      lastReportedLocation {
        ...DriverLocationFragment
      }
      workType
      tasks(statusFilter: $taskStatusFilter, date: $shipmentDate) {
        ...TaskFragment
        stop {
          ...StopFragment
          shipment {
            ...ShipmentFragment
            order {
              ...OrderFragment
              serviceType {
                ...ServiceTypeFragment
              }
              endCustomer {
                ...EndCustomerFragment
              }
            }
            shipmentTemplate {
              ...ShipmentTemplateFragment
              order {
                id
                serviceType {
                  ...ServiceTypeFragment
                }
              }
            }
          }
        }
      }
      vehicle {
        ...VehicleFragment
      }
      assignedLabels {
        ...LabelFragment
      }
      driverPaySummary(
        minDate: $payMinDate
        maxDate: $payMaxDate
        shipmentStatuses: $payShipmentStatuses
      ) @include(if: $shouldFetchDriverPay) {
        numOrders
        totalPay
      }
      dailyEarnings: driverPaySummary(
        minDate: $dailyPayMinDate
        maxDate: $dailyPayMaxDate
        shipmentStatuses: $dailyPayShipmentStatuses
      ) @include(if: $shouldFetchDailyEarnings) {
        numOrders
        totalPay
      }
    }
    ...DispatchPreviewFragment
  }
}
    ${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}
${VehicleFragmentFragmentDoc}
${LabelFragmentFragmentDoc}
${DispatchPreviewFragmentFragmentDoc}`;

/**
 * __useGetDispatchPreviewsQuery__
 *
 * To run a query within a React component, call `useGetDispatchPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispatchPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispatchPreviewsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      taskStatusFilter: // value for 'taskStatusFilter'
 *      shipmentDate: // value for 'shipmentDate'
 *      isActive: // value for 'isActive'
 *      workType: // value for 'workType'
 *      additionalFilters: // value for 'additionalFilters'
 *      driverLabelIds: // value for 'driverLabelIds'
 *      payMinDate: // value for 'payMinDate'
 *      payMaxDate: // value for 'payMaxDate'
 *      payShipmentStatuses: // value for 'payShipmentStatuses'
 *      shouldFetchDriverPay: // value for 'shouldFetchDriverPay'
 *      dailyPayMinDate: // value for 'dailyPayMinDate'
 *      dailyPayMaxDate: // value for 'dailyPayMaxDate'
 *      dailyPayShipmentStatuses: // value for 'dailyPayShipmentStatuses'
 *      shouldFetchDailyEarnings: // value for 'shouldFetchDailyEarnings'
 *   },
 * });
 */
export function useGetDispatchPreviewsQuery(baseOptions: Apollo.QueryHookOptions<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>(GetDispatchPreviewsDocument, options);
      }
export function useGetDispatchPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>(GetDispatchPreviewsDocument, options);
        }
export type GetDispatchPreviewsQueryHookResult = ReturnType<typeof useGetDispatchPreviewsQuery>;
export type GetDispatchPreviewsLazyQueryHookResult = ReturnType<typeof useGetDispatchPreviewsLazyQuery>;
export type GetDispatchPreviewsQueryResult = Apollo.QueryResult<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>;
export const DispatchPreviewsByDriverIdDocument = gql`
    query DispatchPreviewsByDriverId($courierId: ID!, $driverId: ID!, $targetDate: Date!, $readyStatus: DispatchPreviewReadyStatus!) {
  dispatchPreviewsByDriverId(
    courierId: $courierId
    driverId: $driverId
    targetDate: $targetDate
    readyStatus: $readyStatus
  ) {
    ...DispatchPreviewFragment
    shipment {
      ...ShipmentFragment
      stops {
        ...StopFragment
      }
      order {
        ...OrderFragment
        orderGroupOverview {
          assignmentGroupId
        }
        createdByUser {
          ...CourieUserFragment
        }
        createdByEndCustomer {
          ...EndCustomerFragment
        }
        createdByEndUser {
          ...EndUserFragment
        }
        costCenter {
          ...CostCenterFragment
        }
        endCustomer {
          ...EndCustomerFragment
        }
        serviceType {
          ...ServiceTypeFragment
        }
      }
    }
  }
}
    ${DispatchPreviewFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${EndUserFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}`;

/**
 * __useDispatchPreviewsByDriverIdQuery__
 *
 * To run a query within a React component, call `useDispatchPreviewsByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispatchPreviewsByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispatchPreviewsByDriverIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      targetDate: // value for 'targetDate'
 *      readyStatus: // value for 'readyStatus'
 *   },
 * });
 */
export function useDispatchPreviewsByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>(DispatchPreviewsByDriverIdDocument, options);
      }
export function useDispatchPreviewsByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>(DispatchPreviewsByDriverIdDocument, options);
        }
export type DispatchPreviewsByDriverIdQueryHookResult = ReturnType<typeof useDispatchPreviewsByDriverIdQuery>;
export type DispatchPreviewsByDriverIdLazyQueryHookResult = ReturnType<typeof useDispatchPreviewsByDriverIdLazyQuery>;
export type DispatchPreviewsByDriverIdQueryResult = Apollo.QueryResult<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>;
export const GetShipmentAllStopDatesForGroupDispatchDocument = gql`
    query GetShipmentAllStopDatesForGroupDispatch($courierId: ID!, $shipmentId: ID!) {
  shipmentById(courierId: $courierId, shipmentId: $shipmentId) {
    id
    allStopDatesForGroupDispatch
  }
}
    `;

/**
 * __useGetShipmentAllStopDatesForGroupDispatchQuery__
 *
 * To run a query within a React component, call `useGetShipmentAllStopDatesForGroupDispatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentAllStopDatesForGroupDispatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentAllStopDatesForGroupDispatchQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useGetShipmentAllStopDatesForGroupDispatchQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentAllStopDatesForGroupDispatchQuery, GetShipmentAllStopDatesForGroupDispatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentAllStopDatesForGroupDispatchQuery, GetShipmentAllStopDatesForGroupDispatchQueryVariables>(GetShipmentAllStopDatesForGroupDispatchDocument, options);
      }
export function useGetShipmentAllStopDatesForGroupDispatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentAllStopDatesForGroupDispatchQuery, GetShipmentAllStopDatesForGroupDispatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentAllStopDatesForGroupDispatchQuery, GetShipmentAllStopDatesForGroupDispatchQueryVariables>(GetShipmentAllStopDatesForGroupDispatchDocument, options);
        }
export type GetShipmentAllStopDatesForGroupDispatchQueryHookResult = ReturnType<typeof useGetShipmentAllStopDatesForGroupDispatchQuery>;
export type GetShipmentAllStopDatesForGroupDispatchLazyQueryHookResult = ReturnType<typeof useGetShipmentAllStopDatesForGroupDispatchLazyQuery>;
export type GetShipmentAllStopDatesForGroupDispatchQueryResult = Apollo.QueryResult<GetShipmentAllStopDatesForGroupDispatchQuery, GetShipmentAllStopDatesForGroupDispatchQueryVariables>;
export const GenerateDriversReportCsvDocument = gql`
    mutation GenerateDriversReportCsv($courierId: ID!, $minDate: Date!, $maxDate: Date!, $granularity: DriverReportGranularity, $driverWorkTypes: [DriverWorkType!]) {
  generateDriversReportCsv(
    courierId: $courierId
    minDate: $minDate
    maxDate: $maxDate
    granularity: $granularity
    driverWorkTypes: $driverWorkTypes
  ) {
    ...DriversReportFileFragment
  }
}
    ${DriversReportFileFragmentFragmentDoc}`;
export type GenerateDriversReportCsvMutationFn = Apollo.MutationFunction<GenerateDriversReportCsvMutation, GenerateDriversReportCsvMutationVariables>;

/**
 * __useGenerateDriversReportCsvMutation__
 *
 * To run a mutation, you first call `useGenerateDriversReportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDriversReportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDriversReportCsvMutation, { data, loading, error }] = useGenerateDriversReportCsvMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      granularity: // value for 'granularity'
 *      driverWorkTypes: // value for 'driverWorkTypes'
 *   },
 * });
 */
export function useGenerateDriversReportCsvMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDriversReportCsvMutation, GenerateDriversReportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDriversReportCsvMutation, GenerateDriversReportCsvMutationVariables>(GenerateDriversReportCsvDocument, options);
      }
export type GenerateDriversReportCsvMutationHookResult = ReturnType<typeof useGenerateDriversReportCsvMutation>;
export type GenerateDriversReportCsvMutationResult = Apollo.MutationResult<GenerateDriversReportCsvMutation>;
export type GenerateDriversReportCsvMutationOptions = Apollo.BaseMutationOptions<GenerateDriversReportCsvMutation, GenerateDriversReportCsvMutationVariables>;
export const GenerateDriverHoursWorkedReportDocument = gql`
    mutation GenerateDriverHoursWorkedReport($courierId: ID!, $driverIds: [ID!]!, $startDate: Date!, $endDate: Date!) {
  generateDriverHoursWorkedReport(
    courierId: $courierId
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...DriversReportFileFragment
  }
}
    ${DriversReportFileFragmentFragmentDoc}`;
export type GenerateDriverHoursWorkedReportMutationFn = Apollo.MutationFunction<GenerateDriverHoursWorkedReportMutation, GenerateDriverHoursWorkedReportMutationVariables>;

/**
 * __useGenerateDriverHoursWorkedReportMutation__
 *
 * To run a mutation, you first call `useGenerateDriverHoursWorkedReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDriverHoursWorkedReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDriverHoursWorkedReportMutation, { data, loading, error }] = useGenerateDriverHoursWorkedReportMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGenerateDriverHoursWorkedReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDriverHoursWorkedReportMutation, GenerateDriverHoursWorkedReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDriverHoursWorkedReportMutation, GenerateDriverHoursWorkedReportMutationVariables>(GenerateDriverHoursWorkedReportDocument, options);
      }
export type GenerateDriverHoursWorkedReportMutationHookResult = ReturnType<typeof useGenerateDriverHoursWorkedReportMutation>;
export type GenerateDriverHoursWorkedReportMutationResult = Apollo.MutationResult<GenerateDriverHoursWorkedReportMutation>;
export type GenerateDriverHoursWorkedReportMutationOptions = Apollo.BaseMutationOptions<GenerateDriverHoursWorkedReportMutation, GenerateDriverHoursWorkedReportMutationVariables>;
export const DriverReportItemsDocument = gql`
    query DriverReportItems($courierId: ID!, $driverIds: [ID!], $startDate: Date!, $endDate: Date!) {
  driverReportItems(
    courierId: $courierId
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...DriverReportItemFragment
    driver {
      ...DriverFragment
    }
  }
}
    ${DriverReportItemFragmentFragmentDoc}
${DriverFragmentFragmentDoc}`;

/**
 * __useDriverReportItemsQuery__
 *
 * To run a query within a React component, call `useDriverReportItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverReportItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverReportItemsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useDriverReportItemsQuery(baseOptions: Apollo.QueryHookOptions<DriverReportItemsQuery, DriverReportItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverReportItemsQuery, DriverReportItemsQueryVariables>(DriverReportItemsDocument, options);
      }
export function useDriverReportItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverReportItemsQuery, DriverReportItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverReportItemsQuery, DriverReportItemsQueryVariables>(DriverReportItemsDocument, options);
        }
export type DriverReportItemsQueryHookResult = ReturnType<typeof useDriverReportItemsQuery>;
export type DriverReportItemsLazyQueryHookResult = ReturnType<typeof useDriverReportItemsLazyQuery>;
export type DriverReportItemsQueryResult = Apollo.QueryResult<DriverReportItemsQuery, DriverReportItemsQueryVariables>;
export const AssignDriverVehicleTypeDocument = gql`
    mutation assignDriverVehicleType($courierId: ID!, $driverId: ID!, $vehicleTypeId: ID) {
  assignDriverVehicleType(
    courierId: $courierId
    driverId: $driverId
    vehicleTypeId: $vehicleTypeId
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type AssignDriverVehicleTypeMutationFn = Apollo.MutationFunction<AssignDriverVehicleTypeMutation, AssignDriverVehicleTypeMutationVariables>;

/**
 * __useAssignDriverVehicleTypeMutation__
 *
 * To run a mutation, you first call `useAssignDriverVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDriverVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDriverVehicleTypeMutation, { data, loading, error }] = useAssignDriverVehicleTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *   },
 * });
 */
export function useAssignDriverVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<AssignDriverVehicleTypeMutation, AssignDriverVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignDriverVehicleTypeMutation, AssignDriverVehicleTypeMutationVariables>(AssignDriverVehicleTypeDocument, options);
      }
export type AssignDriverVehicleTypeMutationHookResult = ReturnType<typeof useAssignDriverVehicleTypeMutation>;
export type AssignDriverVehicleTypeMutationResult = Apollo.MutationResult<AssignDriverVehicleTypeMutation>;
export type AssignDriverVehicleTypeMutationOptions = Apollo.BaseMutationOptions<AssignDriverVehicleTypeMutation, AssignDriverVehicleTypeMutationVariables>;
export const CreateDriverDocument = gql`
    mutation createDriver($courierId: ID!, $firstName: String!, $lastName: String!, $middleName: String, $photoUrl: String, $phone: String!, $email: String, $speed: Float, $homeLocationId: ID, $vehicleTypeId: ID, $weightCapacityInPounds: Float) {
  createDriver(
    courierId: $courierId
    firstName: $firstName
    lastName: $lastName
    middleName: $middleName
    photoUrl: $photoUrl
    phone: $phone
    email: $email
    speed: $speed
    homeLocationId: $homeLocationId
    vehicleTypeId: $vehicleTypeId
    weightCapacityInPounds: $weightCapacityInPounds
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type CreateDriverMutationFn = Apollo.MutationFunction<CreateDriverMutation, CreateDriverMutationVariables>;

/**
 * __useCreateDriverMutation__
 *
 * To run a mutation, you first call `useCreateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverMutation, { data, loading, error }] = useCreateDriverMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      middleName: // value for 'middleName'
 *      photoUrl: // value for 'photoUrl'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      speed: // value for 'speed'
 *      homeLocationId: // value for 'homeLocationId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      weightCapacityInPounds: // value for 'weightCapacityInPounds'
 *   },
 * });
 */
export function useCreateDriverMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverMutation, CreateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverMutation, CreateDriverMutationVariables>(CreateDriverDocument, options);
      }
export type CreateDriverMutationHookResult = ReturnType<typeof useCreateDriverMutation>;
export type CreateDriverMutationResult = Apollo.MutationResult<CreateDriverMutation>;
export type CreateDriverMutationOptions = Apollo.BaseMutationOptions<CreateDriverMutation, CreateDriverMutationVariables>;
export const FullUpdateDriverDocument = gql`
    mutation fullUpdateDriver($courierId: ID!, $fullUpdate: DriverFullUpdate!) {
  fullUpdateDriver(courierId: $courierId, fullUpdate: $fullUpdate) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type FullUpdateDriverMutationFn = Apollo.MutationFunction<FullUpdateDriverMutation, FullUpdateDriverMutationVariables>;

/**
 * __useFullUpdateDriverMutation__
 *
 * To run a mutation, you first call `useFullUpdateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateDriverMutation, { data, loading, error }] = useFullUpdateDriverMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      fullUpdate: // value for 'fullUpdate'
 *   },
 * });
 */
export function useFullUpdateDriverMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateDriverMutation, FullUpdateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateDriverMutation, FullUpdateDriverMutationVariables>(FullUpdateDriverDocument, options);
      }
export type FullUpdateDriverMutationHookResult = ReturnType<typeof useFullUpdateDriverMutation>;
export type FullUpdateDriverMutationResult = Apollo.MutationResult<FullUpdateDriverMutation>;
export type FullUpdateDriverMutationOptions = Apollo.BaseMutationOptions<FullUpdateDriverMutation, FullUpdateDriverMutationVariables>;
export const DeleteDriverDocument = gql`
    mutation deleteDriver($courierId: ID!, $driverId: ID!) {
  deleteDriver(courierId: $courierId, driverId: $driverId) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type DeleteDriverMutationFn = Apollo.MutationFunction<DeleteDriverMutation, DeleteDriverMutationVariables>;

/**
 * __useDeleteDriverMutation__
 *
 * To run a mutation, you first call `useDeleteDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriverMutation, { data, loading, error }] = useDeleteDriverMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useDeleteDriverMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDriverMutation, DeleteDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDriverMutation, DeleteDriverMutationVariables>(DeleteDriverDocument, options);
      }
export type DeleteDriverMutationHookResult = ReturnType<typeof useDeleteDriverMutation>;
export type DeleteDriverMutationResult = Apollo.MutationResult<DeleteDriverMutation>;
export type DeleteDriverMutationOptions = Apollo.BaseMutationOptions<DeleteDriverMutation, DeleteDriverMutationVariables>;
export const UpdateDriverAvailabilityV1Document = gql`
    mutation UpdateDriverAvailabilityV1($courierId: ID!, $driverId: ID!, $isAvailable: Boolean!) {
  updateDriverAvailabilityV1(
    courierId: $courierId
    driverId: $driverId
    isAvailable: $isAvailable
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type UpdateDriverAvailabilityV1MutationFn = Apollo.MutationFunction<UpdateDriverAvailabilityV1Mutation, UpdateDriverAvailabilityV1MutationVariables>;

/**
 * __useUpdateDriverAvailabilityV1Mutation__
 *
 * To run a mutation, you first call `useUpdateDriverAvailabilityV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverAvailabilityV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverAvailabilityV1Mutation, { data, loading, error }] = useUpdateDriverAvailabilityV1Mutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      isAvailable: // value for 'isAvailable'
 *   },
 * });
 */
export function useUpdateDriverAvailabilityV1Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverAvailabilityV1Mutation, UpdateDriverAvailabilityV1MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverAvailabilityV1Mutation, UpdateDriverAvailabilityV1MutationVariables>(UpdateDriverAvailabilityV1Document, options);
      }
export type UpdateDriverAvailabilityV1MutationHookResult = ReturnType<typeof useUpdateDriverAvailabilityV1Mutation>;
export type UpdateDriverAvailabilityV1MutationResult = Apollo.MutationResult<UpdateDriverAvailabilityV1Mutation>;
export type UpdateDriverAvailabilityV1MutationOptions = Apollo.BaseMutationOptions<UpdateDriverAvailabilityV1Mutation, UpdateDriverAvailabilityV1MutationVariables>;
export const UpdateDriverBaseWorkScheduleDocument = gql`
    mutation UpdateDriverBaseWorkSchedule($courierId: ID!, $driverId: ID!, $workSchedule: DriverWorkScheduleInput!) {
  updateDriverBaseWorkSchedule(
    courierId: $courierId
    driverId: $driverId
    workSchedule: $workSchedule
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type UpdateDriverBaseWorkScheduleMutationFn = Apollo.MutationFunction<UpdateDriverBaseWorkScheduleMutation, UpdateDriverBaseWorkScheduleMutationVariables>;

/**
 * __useUpdateDriverBaseWorkScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateDriverBaseWorkScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverBaseWorkScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverBaseWorkScheduleMutation, { data, loading, error }] = useUpdateDriverBaseWorkScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      workSchedule: // value for 'workSchedule'
 *   },
 * });
 */
export function useUpdateDriverBaseWorkScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverBaseWorkScheduleMutation, UpdateDriverBaseWorkScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverBaseWorkScheduleMutation, UpdateDriverBaseWorkScheduleMutationVariables>(UpdateDriverBaseWorkScheduleDocument, options);
      }
export type UpdateDriverBaseWorkScheduleMutationHookResult = ReturnType<typeof useUpdateDriverBaseWorkScheduleMutation>;
export type UpdateDriverBaseWorkScheduleMutationResult = Apollo.MutationResult<UpdateDriverBaseWorkScheduleMutation>;
export type UpdateDriverBaseWorkScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateDriverBaseWorkScheduleMutation, UpdateDriverBaseWorkScheduleMutationVariables>;
export const SetDriverScheduleOverrideDocument = gql`
    mutation setDriverScheduleOverride($courierId: ID!, $driverId: ID!, $date: Date!, $isDayOff: Boolean!, $timeBlocks: [DriverScheduleTimeBlockInput!]!, $labels: [String!]!) {
  setDriverScheduleOverride(
    courierId: $courierId
    driverId: $driverId
    date: $date
    isDayOff: $isDayOff
    timeBlocks: $timeBlocks
    labels: $labels
  ) {
    ...DriverScheduleForDateFragment
    timeBlocks {
      ...DriverScheduleTimeBlockFragment
    }
  }
}
    ${DriverScheduleForDateFragmentFragmentDoc}
${DriverScheduleTimeBlockFragmentFragmentDoc}`;
export type SetDriverScheduleOverrideMutationFn = Apollo.MutationFunction<SetDriverScheduleOverrideMutation, SetDriverScheduleOverrideMutationVariables>;

/**
 * __useSetDriverScheduleOverrideMutation__
 *
 * To run a mutation, you first call `useSetDriverScheduleOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDriverScheduleOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDriverScheduleOverrideMutation, { data, loading, error }] = useSetDriverScheduleOverrideMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      date: // value for 'date'
 *      isDayOff: // value for 'isDayOff'
 *      timeBlocks: // value for 'timeBlocks'
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useSetDriverScheduleOverrideMutation(baseOptions?: Apollo.MutationHookOptions<SetDriverScheduleOverrideMutation, SetDriverScheduleOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDriverScheduleOverrideMutation, SetDriverScheduleOverrideMutationVariables>(SetDriverScheduleOverrideDocument, options);
      }
export type SetDriverScheduleOverrideMutationHookResult = ReturnType<typeof useSetDriverScheduleOverrideMutation>;
export type SetDriverScheduleOverrideMutationResult = Apollo.MutationResult<SetDriverScheduleOverrideMutation>;
export type SetDriverScheduleOverrideMutationOptions = Apollo.BaseMutationOptions<SetDriverScheduleOverrideMutation, SetDriverScheduleOverrideMutationVariables>;
export const ModifyDriverTimeEventsDocument = gql`
    mutation modifyDriverTimeEvents($courierId: ID!, $updates: [DriverTimeEventUpdateInput!]!, $newEvent: DriverTimeEventCreateInput, $eventIdsToDelete: [ID!]!, $updatedBy: ID!) {
  modifyDriverTimeEvents(
    courierId: $courierId
    updates: $updates
    newEvent: $newEvent
    eventIdsToDelete: $eventIdsToDelete
    updatedBy: $updatedBy
  ) {
    ...DriverTimeEventFragment
  }
}
    ${DriverTimeEventFragmentFragmentDoc}`;
export type ModifyDriverTimeEventsMutationFn = Apollo.MutationFunction<ModifyDriverTimeEventsMutation, ModifyDriverTimeEventsMutationVariables>;

/**
 * __useModifyDriverTimeEventsMutation__
 *
 * To run a mutation, you first call `useModifyDriverTimeEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyDriverTimeEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyDriverTimeEventsMutation, { data, loading, error }] = useModifyDriverTimeEventsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      updates: // value for 'updates'
 *      newEvent: // value for 'newEvent'
 *      eventIdsToDelete: // value for 'eventIdsToDelete'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useModifyDriverTimeEventsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyDriverTimeEventsMutation, ModifyDriverTimeEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyDriverTimeEventsMutation, ModifyDriverTimeEventsMutationVariables>(ModifyDriverTimeEventsDocument, options);
      }
export type ModifyDriverTimeEventsMutationHookResult = ReturnType<typeof useModifyDriverTimeEventsMutation>;
export type ModifyDriverTimeEventsMutationResult = Apollo.MutationResult<ModifyDriverTimeEventsMutation>;
export type ModifyDriverTimeEventsMutationOptions = Apollo.BaseMutationOptions<ModifyDriverTimeEventsMutation, ModifyDriverTimeEventsMutationVariables>;
export const SendDriverScheduleConfirmationEmailsDocument = gql`
    mutation SendDriverScheduleConfirmationEmails($courierId: ID!, $startDate: Date!, $endDate: Date!, $forceSend: Boolean, $includeEmptyDrivers: Boolean, $driverIds: [ID!]) {
  sendDriverScheduleConfirmationEmails(
    courierId: $courierId
    startDate: $startDate
    endDate: $endDate
    forceSend: $forceSend
    includeEmptyDrivers: $includeEmptyDrivers
    driverIds: $driverIds
  )
}
    `;
export type SendDriverScheduleConfirmationEmailsMutationFn = Apollo.MutationFunction<SendDriverScheduleConfirmationEmailsMutation, SendDriverScheduleConfirmationEmailsMutationVariables>;

/**
 * __useSendDriverScheduleConfirmationEmailsMutation__
 *
 * To run a mutation, you first call `useSendDriverScheduleConfirmationEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDriverScheduleConfirmationEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDriverScheduleConfirmationEmailsMutation, { data, loading, error }] = useSendDriverScheduleConfirmationEmailsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      forceSend: // value for 'forceSend'
 *      includeEmptyDrivers: // value for 'includeEmptyDrivers'
 *      driverIds: // value for 'driverIds'
 *   },
 * });
 */
export function useSendDriverScheduleConfirmationEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SendDriverScheduleConfirmationEmailsMutation, SendDriverScheduleConfirmationEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDriverScheduleConfirmationEmailsMutation, SendDriverScheduleConfirmationEmailsMutationVariables>(SendDriverScheduleConfirmationEmailsDocument, options);
      }
export type SendDriverScheduleConfirmationEmailsMutationHookResult = ReturnType<typeof useSendDriverScheduleConfirmationEmailsMutation>;
export type SendDriverScheduleConfirmationEmailsMutationResult = Apollo.MutationResult<SendDriverScheduleConfirmationEmailsMutation>;
export type SendDriverScheduleConfirmationEmailsMutationOptions = Apollo.BaseMutationOptions<SendDriverScheduleConfirmationEmailsMutation, SendDriverScheduleConfirmationEmailsMutationVariables>;
export const UpdateDriverCompensationDocument = gql`
    mutation UpdateDriverCompensation($courierId: ID!, $driverId: ID!, $employmentType: DriverEmploymentType!, $compensation: DriverCompensation!, $payrollPricingListId: ID, $icCompanyName: String, $taxId: String, $dontChangeTaxId: Boolean) {
  updateDriverCompensation(
    courierId: $courierId
    driverId: $driverId
    employmentType: $employmentType
    compensation: $compensation
    payrollPricingListId: $payrollPricingListId
    icCompanyName: $icCompanyName
    taxId: $taxId
    dontChangeTaxId: $dontChangeTaxId
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type UpdateDriverCompensationMutationFn = Apollo.MutationFunction<UpdateDriverCompensationMutation, UpdateDriverCompensationMutationVariables>;

/**
 * __useUpdateDriverCompensationMutation__
 *
 * To run a mutation, you first call `useUpdateDriverCompensationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverCompensationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverCompensationMutation, { data, loading, error }] = useUpdateDriverCompensationMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      employmentType: // value for 'employmentType'
 *      compensation: // value for 'compensation'
 *      payrollPricingListId: // value for 'payrollPricingListId'
 *      icCompanyName: // value for 'icCompanyName'
 *      taxId: // value for 'taxId'
 *      dontChangeTaxId: // value for 'dontChangeTaxId'
 *   },
 * });
 */
export function useUpdateDriverCompensationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverCompensationMutation, UpdateDriverCompensationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverCompensationMutation, UpdateDriverCompensationMutationVariables>(UpdateDriverCompensationDocument, options);
      }
export type UpdateDriverCompensationMutationHookResult = ReturnType<typeof useUpdateDriverCompensationMutation>;
export type UpdateDriverCompensationMutationResult = Apollo.MutationResult<UpdateDriverCompensationMutation>;
export type UpdateDriverCompensationMutationOptions = Apollo.BaseMutationOptions<UpdateDriverCompensationMutation, UpdateDriverCompensationMutationVariables>;
export const ChangePasswordDriverDocument = gql`
    mutation changePasswordDriver($courierId: ID!, $driverId: ID!, $password: String!) {
  changePasswordDriver(
    courierId: $courierId
    driverId: $driverId
    password: $password
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type ChangePasswordDriverMutationFn = Apollo.MutationFunction<ChangePasswordDriverMutation, ChangePasswordDriverMutationVariables>;

/**
 * __useChangePasswordDriverMutation__
 *
 * To run a mutation, you first call `useChangePasswordDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordDriverMutation, { data, loading, error }] = useChangePasswordDriverMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordDriverMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordDriverMutation, ChangePasswordDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordDriverMutation, ChangePasswordDriverMutationVariables>(ChangePasswordDriverDocument, options);
      }
export type ChangePasswordDriverMutationHookResult = ReturnType<typeof useChangePasswordDriverMutation>;
export type ChangePasswordDriverMutationResult = Apollo.MutationResult<ChangePasswordDriverMutation>;
export type ChangePasswordDriverMutationOptions = Apollo.BaseMutationOptions<ChangePasswordDriverMutation, ChangePasswordDriverMutationVariables>;
export const GenerateCsvForDriversDocument = gql`
    mutation GenerateCsvForDrivers($courierId: ID!) {
  generateCsvForDrivers(courierId: $courierId) {
    url
  }
}
    `;
export type GenerateCsvForDriversMutationFn = Apollo.MutationFunction<GenerateCsvForDriversMutation, GenerateCsvForDriversMutationVariables>;

/**
 * __useGenerateCsvForDriversMutation__
 *
 * To run a mutation, you first call `useGenerateCsvForDriversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCsvForDriversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCsvForDriversMutation, { data, loading, error }] = useGenerateCsvForDriversMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGenerateCsvForDriversMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCsvForDriversMutation, GenerateCsvForDriversMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCsvForDriversMutation, GenerateCsvForDriversMutationVariables>(GenerateCsvForDriversDocument, options);
      }
export type GenerateCsvForDriversMutationHookResult = ReturnType<typeof useGenerateCsvForDriversMutation>;
export type GenerateCsvForDriversMutationResult = Apollo.MutationResult<GenerateCsvForDriversMutation>;
export type GenerateCsvForDriversMutationOptions = Apollo.BaseMutationOptions<GenerateCsvForDriversMutation, GenerateCsvForDriversMutationVariables>;
export const GetBreadcrumbByDriverIdDocument = gql`
    query GetBreadcrumbByDriverId($courierId: ID!, $driverId: ID!, $minTime: Timestamp, $maxTime: Timestamp, $date: Date) {
  breadcrumb(
    courierId: $courierId
    driverId: $driverId
    minTime: $minTime
    maxTime: $maxTime
    date: $date
  ) {
    driverId
    curves {
      ...BreadcrumbCurveFragment
    }
  }
}
    ${BreadcrumbCurveFragmentFragmentDoc}`;

/**
 * __useGetBreadcrumbByDriverIdQuery__
 *
 * To run a query within a React component, call `useGetBreadcrumbByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreadcrumbByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreadcrumbByDriverIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      minTime: // value for 'minTime'
 *      maxTime: // value for 'maxTime'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetBreadcrumbByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>(GetBreadcrumbByDriverIdDocument, options);
      }
export function useGetBreadcrumbByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>(GetBreadcrumbByDriverIdDocument, options);
        }
export type GetBreadcrumbByDriverIdQueryHookResult = ReturnType<typeof useGetBreadcrumbByDriverIdQuery>;
export type GetBreadcrumbByDriverIdLazyQueryHookResult = ReturnType<typeof useGetBreadcrumbByDriverIdLazyQuery>;
export type GetBreadcrumbByDriverIdQueryResult = Apollo.QueryResult<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>;
export const GetDriverTasksByDriverIdDocument = gql`
    query GetDriverTasksByDriverId($courierId: ID!, $driverId: ID!, $date: Date!, $statusFilter: [TaskStatus!]) {
  driverById(courierId: $courierId, driverId: $driverId) {
    ...DriverFragment
    tasks(date: $date, statusFilter: $statusFilter) {
      ...TaskFragment
      stop {
        ...StopFragment
        shipment {
          id
          status
          order {
            id
            serviceType {
              ...ServiceTypeFragment
            }
            endCustomer {
              ...EndCustomerFragment
              invoicePdfTemplate {
                ...InvoicePdfTemplateFragment
              }
            }
          }
          shipmentTemplate {
            ...ShipmentTemplateFragment
          }
        }
        plannedSequenceNumber
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}`;

/**
 * __useGetDriverTasksByDriverIdQuery__
 *
 * To run a query within a React component, call `useGetDriverTasksByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverTasksByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverTasksByDriverIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      date: // value for 'date'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetDriverTasksByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>(GetDriverTasksByDriverIdDocument, options);
      }
export function useGetDriverTasksByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>(GetDriverTasksByDriverIdDocument, options);
        }
export type GetDriverTasksByDriverIdQueryHookResult = ReturnType<typeof useGetDriverTasksByDriverIdQuery>;
export type GetDriverTasksByDriverIdLazyQueryHookResult = ReturnType<typeof useGetDriverTasksByDriverIdLazyQuery>;
export type GetDriverTasksByDriverIdQueryResult = Apollo.QueryResult<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>;
export const GetDriversDocument = gql`
    query GetDrivers($courierId: ID!, $limit: Int, $after: Int, $sortFields: [DriverSorting!], $simpleSearch: String, $includeDeactivated: Boolean) {
  drivers(
    courierId: $courierId
    limit: $limit
    after: $after
    sortFields: $sortFields
    simpleSearch: $simpleSearch
    includeDeactivated: $includeDeactivated
  ) {
    edges {
      node {
        ...DriverFragment
        homeLocationId
        homeLocation {
          ...LocationFragment
        }
        baseWorkSchedule {
          weekDailyList {
            days
            startTimeSecondsSinceMidnight
            endTimeSecondsSinceMidnight
          }
        }
        remoteEntities {
          ...RemoteEntityFragment
        }
        payrollPricingList {
          ...PricingListFragment
        }
        assignedLabels {
          ...LabelFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${DriverFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}
${LabelFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetDriversQuery__
 *
 * To run a query within a React component, call `useGetDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *      simpleSearch: // value for 'simpleSearch'
 *      includeDeactivated: // value for 'includeDeactivated'
 *   },
 * });
 */
export function useGetDriversQuery(baseOptions: Apollo.QueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
      }
export function useGetDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
        }
export type GetDriversQueryHookResult = ReturnType<typeof useGetDriversQuery>;
export type GetDriversLazyQueryHookResult = ReturnType<typeof useGetDriversLazyQuery>;
export type GetDriversQueryResult = Apollo.QueryResult<GetDriversQuery, GetDriversQueryVariables>;
export const GetFleetQueryDocument = gql`
    query GetFleetQuery($courierId: ID!, $limit: Int, $after: Int, $date: Date!, $statusFilter: [TaskStatus!], $labelIds: [ID!], $simpleSearch: String) {
  drivers(
    courierId: $courierId
    limit: $limit
    after: $after
    labelIds: $labelIds
    simpleSearch: $simpleSearch
  ) {
    edges {
      node {
        ...DriverFragment
        assignedLabels {
          ...LabelFragment
        }
        lastReportedLocation {
          ...DriverLocationFragment
        }
        tasks(date: $date, statusFilter: $statusFilter) {
          ...TaskFragment
          stop {
            ...StopFragment
            plannedSequenceNumber
          }
        }
        outOfOrderTasks(date: $date) {
          ...TaskFragment
        }
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${LabelFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}`;

/**
 * __useGetFleetQueryQuery__
 *
 * To run a query within a React component, call `useGetFleetQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFleetQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFleetQueryQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      date: // value for 'date'
 *      statusFilter: // value for 'statusFilter'
 *      labelIds: // value for 'labelIds'
 *      simpleSearch: // value for 'simpleSearch'
 *   },
 * });
 */
export function useGetFleetQueryQuery(baseOptions: Apollo.QueryHookOptions<GetFleetQueryQuery, GetFleetQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFleetQueryQuery, GetFleetQueryQueryVariables>(GetFleetQueryDocument, options);
      }
export function useGetFleetQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFleetQueryQuery, GetFleetQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFleetQueryQuery, GetFleetQueryQueryVariables>(GetFleetQueryDocument, options);
        }
export type GetFleetQueryQueryHookResult = ReturnType<typeof useGetFleetQueryQuery>;
export type GetFleetQueryLazyQueryHookResult = ReturnType<typeof useGetFleetQueryLazyQuery>;
export type GetFleetQueryQueryResult = Apollo.QueryResult<GetFleetQueryQuery, GetFleetQueryQueryVariables>;
export const GetDriverByIdDocument = gql`
    query getDriverById($courierId: ID!, $driverId: ID!, $date: Date!, $statusFilter: [TaskStatus!]) {
  driverById(courierId: $courierId, driverId: $driverId) {
    ...DriverFragment
    lastReportedLocation {
      ...DriverLocationFragment
    }
    tasks(date: $date, statusFilter: $statusFilter) {
      ...TaskFragment
      stop {
        ...StopFragment
        completedAt
        shipment {
          id
          status
          shipmentDate
          trackingNumber
          stops {
            id
            effectiveStopDate
          }
          order {
            ...OrderFragment
            serviceType {
              ...ServiceTypeFragment
            }
            endCustomer {
              ...EndCustomerFragment
              invoicePdfTemplate {
                ...InvoicePdfTemplateFragment
              }
            }
          }
          shipmentTemplate {
            ...ShipmentTemplateFragment
            order {
              id
              serviceType {
                ...ServiceTypeFragment
              }
            }
          }
        }
        artifacts {
          id
          type
          publicUrl
          value
          createdAt
        }
        plannedSequenceNumber
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}`;

/**
 * __useGetDriverByIdQuery__
 *
 * To run a query within a React component, call `useGetDriverByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverByIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      date: // value for 'date'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetDriverByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
      }
export function useGetDriverByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
        }
export type GetDriverByIdQueryHookResult = ReturnType<typeof useGetDriverByIdQuery>;
export type GetDriverByIdLazyQueryHookResult = ReturnType<typeof useGetDriverByIdLazyQuery>;
export type GetDriverByIdQueryResult = Apollo.QueryResult<GetDriverByIdQuery, GetDriverByIdQueryVariables>;
export const FetchDriverTasksByDateAndStatusDocument = gql`
    query FetchDriverTasksByDateAndStatus($courierId: ID!, $date: Date!, $statusFilter: [TaskStatus!], $limit: Int, $payMinDate: Date! = "1970-01-01", $payMaxDate: Date! = "1970-01-01", $payShipmentStatuses: [ShipmentStatus!], $shouldFetchDriverPay: Boolean! = false, $dailyPayMinDate: Date! = "1970-01-01", $dailyPayMaxDate: Date! = "1970-01-01", $dailyPayShipmentStatuses: [ShipmentStatus!], $shouldFetchDailyEarnings: Boolean! = false) {
  drivers(courierId: $courierId, limit: $limit) {
    edges {
      node {
        ...DriverFragment
        homeLocationId
        homeLocation {
          ...LocationFragment
        }
        tasks(date: $date, statusFilter: $statusFilter) {
          ...TaskFragment
          stop {
            ...StopFragment
            completedAt
            shipment {
              id
              status
            }
          }
        }
        numRecurringStops(date: $date)
        assignedLabels {
          ...LabelFragment
        }
        driverPaySummary(
          minDate: $payMinDate
          maxDate: $payMaxDate
          shipmentStatuses: $payShipmentStatuses
        ) @include(if: $shouldFetchDriverPay) {
          numOrders
          totalPay
        }
        dailyEarnings: driverPaySummary(
          minDate: $dailyPayMinDate
          maxDate: $dailyPayMaxDate
          shipmentStatuses: $dailyPayShipmentStatuses
        ) @include(if: $shouldFetchDailyEarnings) {
          numOrders
          totalPay
        }
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${LabelFragmentFragmentDoc}`;

/**
 * __useFetchDriverTasksByDateAndStatusQuery__
 *
 * To run a query within a React component, call `useFetchDriverTasksByDateAndStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDriverTasksByDateAndStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDriverTasksByDateAndStatusQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      date: // value for 'date'
 *      statusFilter: // value for 'statusFilter'
 *      limit: // value for 'limit'
 *      payMinDate: // value for 'payMinDate'
 *      payMaxDate: // value for 'payMaxDate'
 *      payShipmentStatuses: // value for 'payShipmentStatuses'
 *      shouldFetchDriverPay: // value for 'shouldFetchDriverPay'
 *      dailyPayMinDate: // value for 'dailyPayMinDate'
 *      dailyPayMaxDate: // value for 'dailyPayMaxDate'
 *      dailyPayShipmentStatuses: // value for 'dailyPayShipmentStatuses'
 *      shouldFetchDailyEarnings: // value for 'shouldFetchDailyEarnings'
 *   },
 * });
 */
export function useFetchDriverTasksByDateAndStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>(FetchDriverTasksByDateAndStatusDocument, options);
      }
export function useFetchDriverTasksByDateAndStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>(FetchDriverTasksByDateAndStatusDocument, options);
        }
export type FetchDriverTasksByDateAndStatusQueryHookResult = ReturnType<typeof useFetchDriverTasksByDateAndStatusQuery>;
export type FetchDriverTasksByDateAndStatusLazyQueryHookResult = ReturnType<typeof useFetchDriverTasksByDateAndStatusLazyQuery>;
export type FetchDriverTasksByDateAndStatusQueryResult = Apollo.QueryResult<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>;
export const GetDriverCurrentLocationDocument = gql`
    query GetDriverCurrentLocation($courierId: ID!, $driverId: ID!) {
  driverById(courierId: $courierId, driverId: $driverId) {
    ...DriverFragment
    lastReportedLocation {
      ...DriverLocationFragment
    }
  }
}
    ${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}`;

/**
 * __useGetDriverCurrentLocationQuery__
 *
 * To run a query within a React component, call `useGetDriverCurrentLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverCurrentLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverCurrentLocationQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useGetDriverCurrentLocationQuery(baseOptions: Apollo.QueryHookOptions<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>(GetDriverCurrentLocationDocument, options);
      }
export function useGetDriverCurrentLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>(GetDriverCurrentLocationDocument, options);
        }
export type GetDriverCurrentLocationQueryHookResult = ReturnType<typeof useGetDriverCurrentLocationQuery>;
export type GetDriverCurrentLocationLazyQueryHookResult = ReturnType<typeof useGetDriverCurrentLocationLazyQuery>;
export type GetDriverCurrentLocationQueryResult = Apollo.QueryResult<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>;
export const GetDriverTasksOnlyByDriverIdDocument = gql`
    query GetDriverTasksOnlyByDriverId($courierId: ID!, $driverId: ID!, $statusFilter: [TaskStatus!], $minDate: Date, $maxDate: Date) {
  driverById(courierId: $courierId, driverId: $driverId) {
    ...DriverFragment
    tasks(statusFilter: $statusFilter, minDate: $minDate, maxDate: $maxDate) {
      ...TaskFragment
    }
  }
}
    ${DriverFragmentFragmentDoc}
${TaskFragmentFragmentDoc}`;

/**
 * __useGetDriverTasksOnlyByDriverIdQuery__
 *
 * To run a query within a React component, call `useGetDriverTasksOnlyByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverTasksOnlyByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverTasksOnlyByDriverIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      statusFilter: // value for 'statusFilter'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetDriverTasksOnlyByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>(GetDriverTasksOnlyByDriverIdDocument, options);
      }
export function useGetDriverTasksOnlyByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>(GetDriverTasksOnlyByDriverIdDocument, options);
        }
export type GetDriverTasksOnlyByDriverIdQueryHookResult = ReturnType<typeof useGetDriverTasksOnlyByDriverIdQuery>;
export type GetDriverTasksOnlyByDriverIdLazyQueryHookResult = ReturnType<typeof useGetDriverTasksOnlyByDriverIdLazyQuery>;
export type GetDriverTasksOnlyByDriverIdQueryResult = Apollo.QueryResult<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>;
export const GetDriverDefaultRoutingConfigurationsDocument = gql`
    query GetDriverDefaultRoutingConfigurations($courierId: ID!, $driverIds: [ID!]!, $dates: [Date!]!) {
  driverDefaultRoutingConfigurations(
    courierId: $courierId
    driverIds: $driverIds
    dates: $dates
  ) {
    driverId
    date
    startLocationId
    endLocationId
    useCurrentLocationAtStart
    startTime
    endTime
    isWorkDay
    startLocation {
      ...LocationFragment
    }
    endLocation {
      ...LocationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}`;

/**
 * __useGetDriverDefaultRoutingConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetDriverDefaultRoutingConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverDefaultRoutingConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverDefaultRoutingConfigurationsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useGetDriverDefaultRoutingConfigurationsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>(GetDriverDefaultRoutingConfigurationsDocument, options);
      }
export function useGetDriverDefaultRoutingConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>(GetDriverDefaultRoutingConfigurationsDocument, options);
        }
export type GetDriverDefaultRoutingConfigurationsQueryHookResult = ReturnType<typeof useGetDriverDefaultRoutingConfigurationsQuery>;
export type GetDriverDefaultRoutingConfigurationsLazyQueryHookResult = ReturnType<typeof useGetDriverDefaultRoutingConfigurationsLazyQuery>;
export type GetDriverDefaultRoutingConfigurationsQueryResult = Apollo.QueryResult<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>;
export const GetDriverScheduleForDateRangeDocument = gql`
    query GetDriverScheduleForDateRange($courierId: ID!, $startDate: Date!, $endDate: Date!, $endCustomerId: ID, $orderNameSearchTerm: String, $driverLabelIds: [ID!]) {
  driverScheduleForDateRange(
    courierId: $courierId
    startDate: $startDate
    endDate: $endDate
    endCustomerId: $endCustomerId
    orderNameSearchTerm: $orderNameSearchTerm
    driverLabelIds: $driverLabelIds
  ) {
    driverSchedules {
      driver {
        ...DriverFragment
      }
      schedule {
        ...DriverScheduleForDateFragment
        timeBlocks {
          ...DriverScheduleTimeBlockFragment
        }
        shipments {
          ...ShipmentFragment
          shipmentTemplate {
            order {
              displayId
              name
            }
          }
          order {
            ...OrderFragment
            endCustomer {
              ...EndCustomerFragment
            }
            serviceType {
              ...ServiceTypeFragment
            }
          }
          stops {
            ...StopFragment
          }
        }
        completedShipments {
          ...ShipmentFragment
          shipmentTemplate {
            order {
              displayId
              name
            }
          }
          order {
            ...OrderFragment
            endCustomer {
              ...EndCustomerFragment
            }
            serviceType {
              ...ServiceTypeFragment
            }
          }
          stops {
            ...StopFragment
          }
        }
        shipmentTemplates {
          ...ShipmentTemplateFragment
          order {
            ...OrderFragment
            endCustomer {
              ...EndCustomerFragment
            }
            serviceType {
              ...ServiceTypeFragment
            }
          }
          stopTemplates {
            ...StopTemplateFragment
          }
          driver {
            ...DriverFragment
          }
        }
      }
    }
    unassignedShipments {
      date
      shipments {
        ...ShipmentFragment
        stops {
          ...StopFragment
        }
        order {
          ...OrderFragment
          endCustomer {
            ...EndCustomerFragment
          }
          serviceType {
            ...ServiceTypeFragment
          }
        }
      }
      shipmentTemplates {
        ...ShipmentTemplateFragment
        order {
          ...OrderFragment
          costCenter {
            ...CostCenterFragment
          }
          endCustomer {
            ...EndCustomerFragment
          }
          serviceType {
            ...ServiceTypeFragment
          }
          customFieldValues {
            ...CustomFieldValueFragment
            field {
              ...CustomFieldFragment
            }
          }
        }
        driver {
          ...DriverFragment
        }
        stopTemplates {
          ...StopTemplateFragment
        }
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${DriverScheduleForDateFragmentFragmentDoc}
${DriverScheduleTimeBlockFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}
${StopTemplateFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}`;

/**
 * __useGetDriverScheduleForDateRangeQuery__
 *
 * To run a query within a React component, call `useGetDriverScheduleForDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverScheduleForDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverScheduleForDateRangeQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      endCustomerId: // value for 'endCustomerId'
 *      orderNameSearchTerm: // value for 'orderNameSearchTerm'
 *      driverLabelIds: // value for 'driverLabelIds'
 *   },
 * });
 */
export function useGetDriverScheduleForDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>(GetDriverScheduleForDateRangeDocument, options);
      }
export function useGetDriverScheduleForDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>(GetDriverScheduleForDateRangeDocument, options);
        }
export type GetDriverScheduleForDateRangeQueryHookResult = ReturnType<typeof useGetDriverScheduleForDateRangeQuery>;
export type GetDriverScheduleForDateRangeLazyQueryHookResult = ReturnType<typeof useGetDriverScheduleForDateRangeLazyQuery>;
export type GetDriverScheduleForDateRangeQueryResult = Apollo.QueryResult<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>;
export const GetDriverWorkingTimesForDateDocument = gql`
    query GetDriverWorkingTimesForDate($courierId: ID!, $date: Date!) {
  driverScheduleForDateRange(
    courierId: $courierId
    startDate: $date
    endDate: $date
  ) {
    driverSchedules {
      driver {
        id
      }
      schedule {
        date
        timeBlocks {
          start
          end
        }
      }
    }
  }
}
    `;

/**
 * __useGetDriverWorkingTimesForDateQuery__
 *
 * To run a query within a React component, call `useGetDriverWorkingTimesForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverWorkingTimesForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverWorkingTimesForDateQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetDriverWorkingTimesForDateQuery(baseOptions: Apollo.QueryHookOptions<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>(GetDriverWorkingTimesForDateDocument, options);
      }
export function useGetDriverWorkingTimesForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>(GetDriverWorkingTimesForDateDocument, options);
        }
export type GetDriverWorkingTimesForDateQueryHookResult = ReturnType<typeof useGetDriverWorkingTimesForDateQuery>;
export type GetDriverWorkingTimesForDateLazyQueryHookResult = ReturnType<typeof useGetDriverWorkingTimesForDateLazyQuery>;
export type GetDriverWorkingTimesForDateQueryResult = Apollo.QueryResult<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>;
export const GetDriverTimeEventsDocument = gql`
    query GetDriverTimeEvents($courierId: ID!, $driverIds: [ID!], $startDate: Date!, $endDate: Date!) {
  driverTimeEvents(
    courierId: $courierId
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...DriverTimeEventFragment
  }
}
    ${DriverTimeEventFragmentFragmentDoc}`;

/**
 * __useGetDriverTimeEventsQuery__
 *
 * To run a query within a React component, call `useGetDriverTimeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverTimeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverTimeEventsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDriverTimeEventsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>(GetDriverTimeEventsDocument, options);
      }
export function useGetDriverTimeEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>(GetDriverTimeEventsDocument, options);
        }
export type GetDriverTimeEventsQueryHookResult = ReturnType<typeof useGetDriverTimeEventsQuery>;
export type GetDriverTimeEventsLazyQueryHookResult = ReturnType<typeof useGetDriverTimeEventsLazyQuery>;
export type GetDriverTimeEventsQueryResult = Apollo.QueryResult<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>;
export const GetDriversBasicDocument = gql`
    query GetDriversBasic($courierId: ID!, $limit: Int) {
  drivers(courierId: $courierId, limit: $limit) {
    edges {
      node {
        id
        firstName
        lastName
        photoUrl
        avatarDisplay
        isActive
      }
    }
  }
}
    `;

/**
 * __useGetDriversBasicQuery__
 *
 * To run a query within a React component, call `useGetDriversBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversBasicQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDriversBasicQuery(baseOptions: Apollo.QueryHookOptions<GetDriversBasicQuery, GetDriversBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversBasicQuery, GetDriversBasicQueryVariables>(GetDriversBasicDocument, options);
      }
export function useGetDriversBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversBasicQuery, GetDriversBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversBasicQuery, GetDriversBasicQueryVariables>(GetDriversBasicDocument, options);
        }
export type GetDriversBasicQueryHookResult = ReturnType<typeof useGetDriversBasicQuery>;
export type GetDriversBasicLazyQueryHookResult = ReturnType<typeof useGetDriversBasicLazyQuery>;
export type GetDriversBasicQueryResult = Apollo.QueryResult<GetDriversBasicQuery, GetDriversBasicQueryVariables>;
export const CreateEmailTemplateGroupDocument = gql`
    mutation createEmailTemplateGroup($courierId: ID!, $name: String!) {
  createEmailTemplateGroup(courierId: $courierId, name: $name) {
    ...EmailTemplateGroupFragment
  }
}
    ${EmailTemplateGroupFragmentFragmentDoc}`;
export type CreateEmailTemplateGroupMutationFn = Apollo.MutationFunction<CreateEmailTemplateGroupMutation, CreateEmailTemplateGroupMutationVariables>;

/**
 * __useCreateEmailTemplateGroupMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTemplateGroupMutation, { data, loading, error }] = useCreateEmailTemplateGroupMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateEmailTemplateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailTemplateGroupMutation, CreateEmailTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailTemplateGroupMutation, CreateEmailTemplateGroupMutationVariables>(CreateEmailTemplateGroupDocument, options);
      }
export type CreateEmailTemplateGroupMutationHookResult = ReturnType<typeof useCreateEmailTemplateGroupMutation>;
export type CreateEmailTemplateGroupMutationResult = Apollo.MutationResult<CreateEmailTemplateGroupMutation>;
export type CreateEmailTemplateGroupMutationOptions = Apollo.BaseMutationOptions<CreateEmailTemplateGroupMutation, CreateEmailTemplateGroupMutationVariables>;
export const FullUpdateEmailTemplateGroupDocument = gql`
    mutation fullUpdateEmailTemplateGroup($courierId: ID!, $id: ID!, $name: String!) {
  fullUpdateEmailTemplateGroup(courierId: $courierId, id: $id, name: $name) {
    ...EmailTemplateGroupFragment
  }
}
    ${EmailTemplateGroupFragmentFragmentDoc}`;
export type FullUpdateEmailTemplateGroupMutationFn = Apollo.MutationFunction<FullUpdateEmailTemplateGroupMutation, FullUpdateEmailTemplateGroupMutationVariables>;

/**
 * __useFullUpdateEmailTemplateGroupMutation__
 *
 * To run a mutation, you first call `useFullUpdateEmailTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateEmailTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateEmailTemplateGroupMutation, { data, loading, error }] = useFullUpdateEmailTemplateGroupMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFullUpdateEmailTemplateGroupMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateEmailTemplateGroupMutation, FullUpdateEmailTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateEmailTemplateGroupMutation, FullUpdateEmailTemplateGroupMutationVariables>(FullUpdateEmailTemplateGroupDocument, options);
      }
export type FullUpdateEmailTemplateGroupMutationHookResult = ReturnType<typeof useFullUpdateEmailTemplateGroupMutation>;
export type FullUpdateEmailTemplateGroupMutationResult = Apollo.MutationResult<FullUpdateEmailTemplateGroupMutation>;
export type FullUpdateEmailTemplateGroupMutationOptions = Apollo.BaseMutationOptions<FullUpdateEmailTemplateGroupMutation, FullUpdateEmailTemplateGroupMutationVariables>;
export const DeleteEmailTemplateGroupDocument = gql`
    mutation deleteEmailTemplateGroup($courierId: ID!, $id: ID!) {
  deleteEmailTemplateGroup(courierId: $courierId, id: $id)
}
    `;
export type DeleteEmailTemplateGroupMutationFn = Apollo.MutationFunction<DeleteEmailTemplateGroupMutation, DeleteEmailTemplateGroupMutationVariables>;

/**
 * __useDeleteEmailTemplateGroupMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailTemplateGroupMutation, { data, loading, error }] = useDeleteEmailTemplateGroupMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailTemplateGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailTemplateGroupMutation, DeleteEmailTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailTemplateGroupMutation, DeleteEmailTemplateGroupMutationVariables>(DeleteEmailTemplateGroupDocument, options);
      }
export type DeleteEmailTemplateGroupMutationHookResult = ReturnType<typeof useDeleteEmailTemplateGroupMutation>;
export type DeleteEmailTemplateGroupMutationResult = Apollo.MutationResult<DeleteEmailTemplateGroupMutation>;
export type DeleteEmailTemplateGroupMutationOptions = Apollo.BaseMutationOptions<DeleteEmailTemplateGroupMutation, DeleteEmailTemplateGroupMutationVariables>;
export const CreateEmailTemplateDocument = gql`
    mutation createEmailTemplate($courierId: ID!, $createInput: CreateEmailTemplateInput!) {
  createEmailTemplate(courierId: $courierId, createInput: $createInput) {
    ...EmailTemplateFragment
  }
}
    ${EmailTemplateFragmentFragmentDoc}`;
export type CreateEmailTemplateMutationFn = Apollo.MutationFunction<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;

/**
 * __useCreateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTemplateMutation, { data, loading, error }] = useCreateEmailTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>(CreateEmailTemplateDocument, options);
      }
export type CreateEmailTemplateMutationHookResult = ReturnType<typeof useCreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationResult = Apollo.MutationResult<CreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;
export const DeleteEmailTemplateDocument = gql`
    mutation deleteEmailTemplate($courierId: ID!, $id: ID!) {
  deleteEmailTemplate(courierId: $courierId, id: $id)
}
    `;
export type DeleteEmailTemplateMutationFn = Apollo.MutationFunction<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;

/**
 * __useDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailTemplateMutation, { data, loading, error }] = useDeleteEmailTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>(DeleteEmailTemplateDocument, options);
      }
export type DeleteEmailTemplateMutationHookResult = ReturnType<typeof useDeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationResult = Apollo.MutationResult<DeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;
export const FullUpdateEmailTemplateDocument = gql`
    mutation fullUpdateEmailTemplate($courierId: ID!, $id: ID!, $subject: String!, $body: String!) {
  fullUpdateEmailTemplate(
    courierId: $courierId
    id: $id
    subject: $subject
    body: $body
  ) {
    ...EmailTemplateFragment
  }
}
    ${EmailTemplateFragmentFragmentDoc}`;
export type FullUpdateEmailTemplateMutationFn = Apollo.MutationFunction<FullUpdateEmailTemplateMutation, FullUpdateEmailTemplateMutationVariables>;

/**
 * __useFullUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useFullUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateEmailTemplateMutation, { data, loading, error }] = useFullUpdateEmailTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useFullUpdateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateEmailTemplateMutation, FullUpdateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateEmailTemplateMutation, FullUpdateEmailTemplateMutationVariables>(FullUpdateEmailTemplateDocument, options);
      }
export type FullUpdateEmailTemplateMutationHookResult = ReturnType<typeof useFullUpdateEmailTemplateMutation>;
export type FullUpdateEmailTemplateMutationResult = Apollo.MutationResult<FullUpdateEmailTemplateMutation>;
export type FullUpdateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<FullUpdateEmailTemplateMutation, FullUpdateEmailTemplateMutationVariables>;
export const SetEmailTemplateGroupAsDefaultDocument = gql`
    mutation setEmailTemplateGroupAsDefault($courierId: ID!, $id: ID!) {
  setEmailTemplateGroupAsDefault(courierId: $courierId, id: $id) {
    ...EmailTemplateGroupFragment
  }
}
    ${EmailTemplateGroupFragmentFragmentDoc}`;
export type SetEmailTemplateGroupAsDefaultMutationFn = Apollo.MutationFunction<SetEmailTemplateGroupAsDefaultMutation, SetEmailTemplateGroupAsDefaultMutationVariables>;

/**
 * __useSetEmailTemplateGroupAsDefaultMutation__
 *
 * To run a mutation, you first call `useSetEmailTemplateGroupAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEmailTemplateGroupAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEmailTemplateGroupAsDefaultMutation, { data, loading, error }] = useSetEmailTemplateGroupAsDefaultMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetEmailTemplateGroupAsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<SetEmailTemplateGroupAsDefaultMutation, SetEmailTemplateGroupAsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEmailTemplateGroupAsDefaultMutation, SetEmailTemplateGroupAsDefaultMutationVariables>(SetEmailTemplateGroupAsDefaultDocument, options);
      }
export type SetEmailTemplateGroupAsDefaultMutationHookResult = ReturnType<typeof useSetEmailTemplateGroupAsDefaultMutation>;
export type SetEmailTemplateGroupAsDefaultMutationResult = Apollo.MutationResult<SetEmailTemplateGroupAsDefaultMutation>;
export type SetEmailTemplateGroupAsDefaultMutationOptions = Apollo.BaseMutationOptions<SetEmailTemplateGroupAsDefaultMutation, SetEmailTemplateGroupAsDefaultMutationVariables>;
export const UnsetDefaultEmailTemplateGroupDocument = gql`
    mutation unsetDefaultEmailTemplateGroup($courierId: ID!) {
  unsetDefaultEmailTemplateGroup(courierId: $courierId)
}
    `;
export type UnsetDefaultEmailTemplateGroupMutationFn = Apollo.MutationFunction<UnsetDefaultEmailTemplateGroupMutation, UnsetDefaultEmailTemplateGroupMutationVariables>;

/**
 * __useUnsetDefaultEmailTemplateGroupMutation__
 *
 * To run a mutation, you first call `useUnsetDefaultEmailTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsetDefaultEmailTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsetDefaultEmailTemplateGroupMutation, { data, loading, error }] = useUnsetDefaultEmailTemplateGroupMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useUnsetDefaultEmailTemplateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UnsetDefaultEmailTemplateGroupMutation, UnsetDefaultEmailTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsetDefaultEmailTemplateGroupMutation, UnsetDefaultEmailTemplateGroupMutationVariables>(UnsetDefaultEmailTemplateGroupDocument, options);
      }
export type UnsetDefaultEmailTemplateGroupMutationHookResult = ReturnType<typeof useUnsetDefaultEmailTemplateGroupMutation>;
export type UnsetDefaultEmailTemplateGroupMutationResult = Apollo.MutationResult<UnsetDefaultEmailTemplateGroupMutation>;
export type UnsetDefaultEmailTemplateGroupMutationOptions = Apollo.BaseMutationOptions<UnsetDefaultEmailTemplateGroupMutation, UnsetDefaultEmailTemplateGroupMutationVariables>;
export const GetEmailTemplateGroupsDocument = gql`
    query GetEmailTemplateGroups($courierId: ID!) {
  emailTemplateGroups(courierId: $courierId) {
    ...EmailTemplateGroupFragment
  }
}
    ${EmailTemplateGroupFragmentFragmentDoc}`;

/**
 * __useGetEmailTemplateGroupsQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateGroupsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetEmailTemplateGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplateGroupsQuery, GetEmailTemplateGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplateGroupsQuery, GetEmailTemplateGroupsQueryVariables>(GetEmailTemplateGroupsDocument, options);
      }
export function useGetEmailTemplateGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplateGroupsQuery, GetEmailTemplateGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplateGroupsQuery, GetEmailTemplateGroupsQueryVariables>(GetEmailTemplateGroupsDocument, options);
        }
export type GetEmailTemplateGroupsQueryHookResult = ReturnType<typeof useGetEmailTemplateGroupsQuery>;
export type GetEmailTemplateGroupsLazyQueryHookResult = ReturnType<typeof useGetEmailTemplateGroupsLazyQuery>;
export type GetEmailTemplateGroupsQueryResult = Apollo.QueryResult<GetEmailTemplateGroupsQuery, GetEmailTemplateGroupsQueryVariables>;
export const GetEmailTemplatesDocument = gql`
    query GetEmailTemplates($courierId: ID!, $emailTemplateGroupId: ID!) {
  emailTemplates(
    courierId: $courierId
    emailTemplateGroupId: $emailTemplateGroupId
  ) {
    ...EmailTemplateFragment
  }
}
    ${EmailTemplateFragmentFragmentDoc}`;

/**
 * __useGetEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      emailTemplateGroupId: // value for 'emailTemplateGroupId'
 *   },
 * });
 */
export function useGetEmailTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
      }
export function useGetEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
        }
export type GetEmailTemplatesQueryHookResult = ReturnType<typeof useGetEmailTemplatesQuery>;
export type GetEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetEmailTemplatesLazyQuery>;
export type GetEmailTemplatesQueryResult = Apollo.QueryResult<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>;
export const GetEmailVariablesDocument = gql`
    query GetEmailVariables($courierId: ID!, $emailTypeId: String!, $previewOrderId: ID) {
  emailVariables(
    courierId: $courierId
    emailTypeId: $emailTypeId
    previewOrderId: $previewOrderId
  ) {
    key
    value
  }
}
    `;

/**
 * __useGetEmailVariablesQuery__
 *
 * To run a query within a React component, call `useGetEmailVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailVariablesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      emailTypeId: // value for 'emailTypeId'
 *      previewOrderId: // value for 'previewOrderId'
 *   },
 * });
 */
export function useGetEmailVariablesQuery(baseOptions: Apollo.QueryHookOptions<GetEmailVariablesQuery, GetEmailVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailVariablesQuery, GetEmailVariablesQueryVariables>(GetEmailVariablesDocument, options);
      }
export function useGetEmailVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailVariablesQuery, GetEmailVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailVariablesQuery, GetEmailVariablesQueryVariables>(GetEmailVariablesDocument, options);
        }
export type GetEmailVariablesQueryHookResult = ReturnType<typeof useGetEmailVariablesQuery>;
export type GetEmailVariablesLazyQueryHookResult = ReturnType<typeof useGetEmailVariablesLazyQuery>;
export type GetEmailVariablesQueryResult = Apollo.QueryResult<GetEmailVariablesQuery, GetEmailVariablesQueryVariables>;
export const CreateEndUserDocument = gql`
    mutation CreateEndUser($courierId: String!, $endCustomerId: String!, $email: String!, $phone: String, $firstName: String, $lastName: String) {
  createEndUser(
    courierId: $courierId
    endCustomerId: $endCustomerId
    email: $email
    phone: $phone
    firstName: $firstName
    lastName: $lastName
  ) {
    ...EndUserFragment
  }
}
    ${EndUserFragmentFragmentDoc}`;
export type CreateEndUserMutationFn = Apollo.MutationFunction<CreateEndUserMutation, CreateEndUserMutationVariables>;

/**
 * __useCreateEndUserMutation__
 *
 * To run a mutation, you first call `useCreateEndUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEndUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEndUserMutation, { data, loading, error }] = useCreateEndUserMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useCreateEndUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateEndUserMutation, CreateEndUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEndUserMutation, CreateEndUserMutationVariables>(CreateEndUserDocument, options);
      }
export type CreateEndUserMutationHookResult = ReturnType<typeof useCreateEndUserMutation>;
export type CreateEndUserMutationResult = Apollo.MutationResult<CreateEndUserMutation>;
export type CreateEndUserMutationOptions = Apollo.BaseMutationOptions<CreateEndUserMutation, CreateEndUserMutationVariables>;
export const MarkEndUserAsDeletedDocument = gql`
    mutation MarkEndUserAsDeleted($courierId: ID!, $endUserId: ID!) {
  markEndUserAsDeleted(courierId: $courierId, endUserId: $endUserId)
}
    `;
export type MarkEndUserAsDeletedMutationFn = Apollo.MutationFunction<MarkEndUserAsDeletedMutation, MarkEndUserAsDeletedMutationVariables>;

/**
 * __useMarkEndUserAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkEndUserAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEndUserAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEndUserAsDeletedMutation, { data, loading, error }] = useMarkEndUserAsDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endUserId: // value for 'endUserId'
 *   },
 * });
 */
export function useMarkEndUserAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkEndUserAsDeletedMutation, MarkEndUserAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEndUserAsDeletedMutation, MarkEndUserAsDeletedMutationVariables>(MarkEndUserAsDeletedDocument, options);
      }
export type MarkEndUserAsDeletedMutationHookResult = ReturnType<typeof useMarkEndUserAsDeletedMutation>;
export type MarkEndUserAsDeletedMutationResult = Apollo.MutationResult<MarkEndUserAsDeletedMutation>;
export type MarkEndUserAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkEndUserAsDeletedMutation, MarkEndUserAsDeletedMutationVariables>;
export const ChangePasswordEndUserDocument = gql`
    mutation changePasswordEndUser($courierId: ID!, $endUserId: ID!, $password: String!) {
  changePasswordEndUser(
    courierId: $courierId
    endUserId: $endUserId
    password: $password
  ) {
    ...EndUserFragment
  }
}
    ${EndUserFragmentFragmentDoc}`;
export type ChangePasswordEndUserMutationFn = Apollo.MutationFunction<ChangePasswordEndUserMutation, ChangePasswordEndUserMutationVariables>;

/**
 * __useChangePasswordEndUserMutation__
 *
 * To run a mutation, you first call `useChangePasswordEndUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordEndUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordEndUserMutation, { data, loading, error }] = useChangePasswordEndUserMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endUserId: // value for 'endUserId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordEndUserMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordEndUserMutation, ChangePasswordEndUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordEndUserMutation, ChangePasswordEndUserMutationVariables>(ChangePasswordEndUserDocument, options);
      }
export type ChangePasswordEndUserMutationHookResult = ReturnType<typeof useChangePasswordEndUserMutation>;
export type ChangePasswordEndUserMutationResult = Apollo.MutationResult<ChangePasswordEndUserMutation>;
export type ChangePasswordEndUserMutationOptions = Apollo.BaseMutationOptions<ChangePasswordEndUserMutation, ChangePasswordEndUserMutationVariables>;
export const GetEndUsersDocument = gql`
    query GetEndUsers($courierId: String!, $endCustomerIds: [String!]) {
  endUsers(courierId: $courierId, endCustomerIds: $endCustomerIds) {
    ...EndUserFragment
  }
}
    ${EndUserFragmentFragmentDoc}`;

/**
 * __useGetEndUsersQuery__
 *
 * To run a query within a React component, call `useGetEndUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndUsersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *   },
 * });
 */
export function useGetEndUsersQuery(baseOptions: Apollo.QueryHookOptions<GetEndUsersQuery, GetEndUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndUsersQuery, GetEndUsersQueryVariables>(GetEndUsersDocument, options);
      }
export function useGetEndUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndUsersQuery, GetEndUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndUsersQuery, GetEndUsersQueryVariables>(GetEndUsersDocument, options);
        }
export type GetEndUsersQueryHookResult = ReturnType<typeof useGetEndUsersQuery>;
export type GetEndUsersLazyQueryHookResult = ReturnType<typeof useGetEndUsersLazyQuery>;
export type GetEndUsersQueryResult = Apollo.QueryResult<GetEndUsersQuery, GetEndUsersQueryVariables>;
export const SendCommunicationToEndCustomerDocument = gql`
    mutation sendCommunicationToEndCustomer($courierId: ID!, $shipmentId: ID, $stopId: ID, $communicationTypeId: CommunicationTypeId, $emailRecipientsCommaSeparated: String) {
  sendCommunicationToEndCustomer(
    courierId: $courierId
    shipmentId: $shipmentId
    stopId: $stopId
    communicationTypeId: $communicationTypeId
    emailRecipientsCommaSeparated: $emailRecipientsCommaSeparated
  ) {
    ...EndCustomerCommunicationFragment
  }
}
    ${EndCustomerCommunicationFragmentFragmentDoc}`;
export type SendCommunicationToEndCustomerMutationFn = Apollo.MutationFunction<SendCommunicationToEndCustomerMutation, SendCommunicationToEndCustomerMutationVariables>;

/**
 * __useSendCommunicationToEndCustomerMutation__
 *
 * To run a mutation, you first call `useSendCommunicationToEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCommunicationToEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCommunicationToEndCustomerMutation, { data, loading, error }] = useSendCommunicationToEndCustomerMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      stopId: // value for 'stopId'
 *      communicationTypeId: // value for 'communicationTypeId'
 *      emailRecipientsCommaSeparated: // value for 'emailRecipientsCommaSeparated'
 *   },
 * });
 */
export function useSendCommunicationToEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SendCommunicationToEndCustomerMutation, SendCommunicationToEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCommunicationToEndCustomerMutation, SendCommunicationToEndCustomerMutationVariables>(SendCommunicationToEndCustomerDocument, options);
      }
export type SendCommunicationToEndCustomerMutationHookResult = ReturnType<typeof useSendCommunicationToEndCustomerMutation>;
export type SendCommunicationToEndCustomerMutationResult = Apollo.MutationResult<SendCommunicationToEndCustomerMutation>;
export type SendCommunicationToEndCustomerMutationOptions = Apollo.BaseMutationOptions<SendCommunicationToEndCustomerMutation, SendCommunicationToEndCustomerMutationVariables>;
export const SendInvoiceEmailDocument = gql`
    mutation SendInvoiceEmail($courierId: ID!, $invoiceEmailSendInput: InvoiceEmailSendInput!) {
  sendInvoiceEmail(
    courierId: $courierId
    invoiceEmailSendInput: $invoiceEmailSendInput
  ) {
    ...EndCustomerCommunicationFragment
  }
}
    ${EndCustomerCommunicationFragmentFragmentDoc}`;
export type SendInvoiceEmailMutationFn = Apollo.MutationFunction<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>;

/**
 * __useSendInvoiceEmailMutation__
 *
 * To run a mutation, you first call `useSendInvoiceEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceEmailMutation, { data, loading, error }] = useSendInvoiceEmailMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceEmailSendInput: // value for 'invoiceEmailSendInput'
 *   },
 * });
 */
export function useSendInvoiceEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>(SendInvoiceEmailDocument, options);
      }
export type SendInvoiceEmailMutationHookResult = ReturnType<typeof useSendInvoiceEmailMutation>;
export type SendInvoiceEmailMutationResult = Apollo.MutationResult<SendInvoiceEmailMutation>;
export type SendInvoiceEmailMutationOptions = Apollo.BaseMutationOptions<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>;
export const SendInvoiceEmailsDocument = gql`
    mutation SendInvoiceEmails($courierId: ID!, $invoiceEmailSendInputs: [InvoiceEmailSendInput!]!) {
  sendInvoiceEmails(
    courierId: $courierId
    invoiceEmailSendInputs: $invoiceEmailSendInputs
  ) {
    successes {
      invoiceId
      endCustomerCommunication {
        ...EndCustomerCommunicationFragment
      }
    }
    failures {
      invoiceId
      error
    }
  }
}
    ${EndCustomerCommunicationFragmentFragmentDoc}`;
export type SendInvoiceEmailsMutationFn = Apollo.MutationFunction<SendInvoiceEmailsMutation, SendInvoiceEmailsMutationVariables>;

/**
 * __useSendInvoiceEmailsMutation__
 *
 * To run a mutation, you first call `useSendInvoiceEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceEmailsMutation, { data, loading, error }] = useSendInvoiceEmailsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceEmailSendInputs: // value for 'invoiceEmailSendInputs'
 *   },
 * });
 */
export function useSendInvoiceEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SendInvoiceEmailsMutation, SendInvoiceEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvoiceEmailsMutation, SendInvoiceEmailsMutationVariables>(SendInvoiceEmailsDocument, options);
      }
export type SendInvoiceEmailsMutationHookResult = ReturnType<typeof useSendInvoiceEmailsMutation>;
export type SendInvoiceEmailsMutationResult = Apollo.MutationResult<SendInvoiceEmailsMutation>;
export type SendInvoiceEmailsMutationOptions = Apollo.BaseMutationOptions<SendInvoiceEmailsMutation, SendInvoiceEmailsMutationVariables>;
export const SendPaymentReminderEmailsDocument = gql`
    mutation SendPaymentReminderEmails($courierId: ID!, $invoiceIds: [ID!]!) {
  sendBulkPaymentReminderEmails(courierId: $courierId, invoiceIds: $invoiceIds) {
    successes {
      endCustomerId
    }
    failures {
      endCustomerId
      error
    }
    optedOut {
      endCustomerId
    }
  }
}
    `;
export type SendPaymentReminderEmailsMutationFn = Apollo.MutationFunction<SendPaymentReminderEmailsMutation, SendPaymentReminderEmailsMutationVariables>;

/**
 * __useSendPaymentReminderEmailsMutation__
 *
 * To run a mutation, you first call `useSendPaymentReminderEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentReminderEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentReminderEmailsMutation, { data, loading, error }] = useSendPaymentReminderEmailsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useSendPaymentReminderEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SendPaymentReminderEmailsMutation, SendPaymentReminderEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPaymentReminderEmailsMutation, SendPaymentReminderEmailsMutationVariables>(SendPaymentReminderEmailsDocument, options);
      }
export type SendPaymentReminderEmailsMutationHookResult = ReturnType<typeof useSendPaymentReminderEmailsMutation>;
export type SendPaymentReminderEmailsMutationResult = Apollo.MutationResult<SendPaymentReminderEmailsMutation>;
export type SendPaymentReminderEmailsMutationOptions = Apollo.BaseMutationOptions<SendPaymentReminderEmailsMutation, SendPaymentReminderEmailsMutationVariables>;
export const AssignHolidayScheduleToEndCustomerDocument = gql`
    mutation assignHolidayScheduleToEndCustomer($courierId: ID!, $endCustomerId: ID!, $holidayScheduleId: ID) {
  assignHolidayScheduleToEndCustomer(
    courierId: $courierId
    endCustomerId: $endCustomerId
    holidayScheduleId: $holidayScheduleId
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type AssignHolidayScheduleToEndCustomerMutationFn = Apollo.MutationFunction<AssignHolidayScheduleToEndCustomerMutation, AssignHolidayScheduleToEndCustomerMutationVariables>;

/**
 * __useAssignHolidayScheduleToEndCustomerMutation__
 *
 * To run a mutation, you first call `useAssignHolidayScheduleToEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignHolidayScheduleToEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignHolidayScheduleToEndCustomerMutation, { data, loading, error }] = useAssignHolidayScheduleToEndCustomerMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *   },
 * });
 */
export function useAssignHolidayScheduleToEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<AssignHolidayScheduleToEndCustomerMutation, AssignHolidayScheduleToEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignHolidayScheduleToEndCustomerMutation, AssignHolidayScheduleToEndCustomerMutationVariables>(AssignHolidayScheduleToEndCustomerDocument, options);
      }
export type AssignHolidayScheduleToEndCustomerMutationHookResult = ReturnType<typeof useAssignHolidayScheduleToEndCustomerMutation>;
export type AssignHolidayScheduleToEndCustomerMutationResult = Apollo.MutationResult<AssignHolidayScheduleToEndCustomerMutation>;
export type AssignHolidayScheduleToEndCustomerMutationOptions = Apollo.BaseMutationOptions<AssignHolidayScheduleToEndCustomerMutation, AssignHolidayScheduleToEndCustomerMutationVariables>;
export const CreateEndCustomerDocument = gql`
    mutation CreateEndCustomer($courierId: ID!, $companyName: String, $contactPhoneNumber: String!, $contactEmail: String!, $firstName: String, $lastName: String!, $pricingListId: ID, $payrollPricingListId: ID, $googlePlaceId: String, $suite: String, $endCustomerCreatedSource: EndCustomerCreatedSource, $invoicingFrequency: InvoicingFrequency) {
  createEndCustomer(
    courierId: $courierId
    companyName: $companyName
    contactPhoneNumber: $contactPhoneNumber
    contactEmail: $contactEmail
    firstName: $firstName
    lastName: $lastName
    pricingListId: $pricingListId
    payrollPricingListId: $payrollPricingListId
    googlePlaceId: $googlePlaceId
    suite: $suite
    endCustomerCreatedSource: $endCustomerCreatedSource
    invoicingFrequency: $invoicingFrequency
  ) {
    ...EndCustomerFragment
    location {
      ...LocationFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;
export type CreateEndCustomerMutationFn = Apollo.MutationFunction<CreateEndCustomerMutation, CreateEndCustomerMutationVariables>;

/**
 * __useCreateEndCustomerMutation__
 *
 * To run a mutation, you first call `useCreateEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEndCustomerMutation, { data, loading, error }] = useCreateEndCustomerMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      companyName: // value for 'companyName'
 *      contactPhoneNumber: // value for 'contactPhoneNumber'
 *      contactEmail: // value for 'contactEmail'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      pricingListId: // value for 'pricingListId'
 *      payrollPricingListId: // value for 'payrollPricingListId'
 *      googlePlaceId: // value for 'googlePlaceId'
 *      suite: // value for 'suite'
 *      endCustomerCreatedSource: // value for 'endCustomerCreatedSource'
 *      invoicingFrequency: // value for 'invoicingFrequency'
 *   },
 * });
 */
export function useCreateEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateEndCustomerMutation, CreateEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEndCustomerMutation, CreateEndCustomerMutationVariables>(CreateEndCustomerDocument, options);
      }
export type CreateEndCustomerMutationHookResult = ReturnType<typeof useCreateEndCustomerMutation>;
export type CreateEndCustomerMutationResult = Apollo.MutationResult<CreateEndCustomerMutation>;
export type CreateEndCustomerMutationOptions = Apollo.BaseMutationOptions<CreateEndCustomerMutation, CreateEndCustomerMutationVariables>;
export const FullUpdateEndCustomerDocument = gql`
    mutation FullUpdateEndCustomer($courierId: ID!, $id: ID!, $companyName: String, $contactPhoneNumber: String!, $contactEmail: String!, $billingEmails: [String!], $firstName: String, $lastName: String, $pricingListId: ID, $payrollPricingListId: ID, $suite: String, $googlePlaceId: String, $invoicingFrequency: InvoicingFrequency!, $taxCode: String, $totalPricingMultiplier: Money, $invoicePdfTemplateId: ID, $scanRequirementType: ScanRequirement, $emailTemplateGroupId: ID, $preAuthorizeAmountMinimum: Money, $preAuthorizeAmountMultiplier: Money, $stopCompletionGuard: StopCompletionGuard, $invoiceCycleStartDate: Date, $driverQuestionListId: ID, $courierBrandId: ID, $billingStreetAddress: String, $billingCity: String, $billingState: String, $billingCountry: String, $billingZip: String, $excludeConvenienceFees: Boolean, $portalPriceVisibilityOverride: EndCustomerPriceVisibilityType) {
  fullUpdateEndCustomer(
    courierId: $courierId
    fullUpdate: {id: $id, companyName: $companyName, contactPhoneNumber: $contactPhoneNumber, contactEmail: $contactEmail, billingEmails: $billingEmails, firstName: $firstName, lastName: $lastName, pricingListId: $pricingListId, payrollPricingListId: $payrollPricingListId, suite: $suite, googlePlaceId: $googlePlaceId, invoicingFrequency: $invoicingFrequency, taxCode: $taxCode, totalPricingMultiplier: $totalPricingMultiplier, invoicePdfTemplateId: $invoicePdfTemplateId, scanRequirementType: $scanRequirementType, emailTemplateGroupId: $emailTemplateGroupId, preAuthorizeAmountMinimum: $preAuthorizeAmountMinimum, preAuthorizeAmountMultiplier: $preAuthorizeAmountMultiplier, stopCompletionGuard: $stopCompletionGuard, invoiceCycleStartDate: $invoiceCycleStartDate, driverQuestionListId: $driverQuestionListId, courierBrandId: $courierBrandId, billingStreetAddress: $billingStreetAddress, billingCity: $billingCity, billingState: $billingState, billingCountry: $billingCountry, billingZip: $billingZip, excludeConvenienceFees: $excludeConvenienceFees, portalPriceVisibilityOverride: $portalPriceVisibilityOverride}
  ) {
    ...EndCustomerFragment
    invoicePdfTemplate {
      ...InvoicePdfTemplateFragment
    }
    courierBrand {
      ...CourierBrandFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}
${CourierBrandFragmentFragmentDoc}`;
export type FullUpdateEndCustomerMutationFn = Apollo.MutationFunction<FullUpdateEndCustomerMutation, FullUpdateEndCustomerMutationVariables>;

/**
 * __useFullUpdateEndCustomerMutation__
 *
 * To run a mutation, you first call `useFullUpdateEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateEndCustomerMutation, { data, loading, error }] = useFullUpdateEndCustomerMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      companyName: // value for 'companyName'
 *      contactPhoneNumber: // value for 'contactPhoneNumber'
 *      contactEmail: // value for 'contactEmail'
 *      billingEmails: // value for 'billingEmails'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      pricingListId: // value for 'pricingListId'
 *      payrollPricingListId: // value for 'payrollPricingListId'
 *      suite: // value for 'suite'
 *      googlePlaceId: // value for 'googlePlaceId'
 *      invoicingFrequency: // value for 'invoicingFrequency'
 *      taxCode: // value for 'taxCode'
 *      totalPricingMultiplier: // value for 'totalPricingMultiplier'
 *      invoicePdfTemplateId: // value for 'invoicePdfTemplateId'
 *      scanRequirementType: // value for 'scanRequirementType'
 *      emailTemplateGroupId: // value for 'emailTemplateGroupId'
 *      preAuthorizeAmountMinimum: // value for 'preAuthorizeAmountMinimum'
 *      preAuthorizeAmountMultiplier: // value for 'preAuthorizeAmountMultiplier'
 *      stopCompletionGuard: // value for 'stopCompletionGuard'
 *      invoiceCycleStartDate: // value for 'invoiceCycleStartDate'
 *      driverQuestionListId: // value for 'driverQuestionListId'
 *      courierBrandId: // value for 'courierBrandId'
 *      billingStreetAddress: // value for 'billingStreetAddress'
 *      billingCity: // value for 'billingCity'
 *      billingState: // value for 'billingState'
 *      billingCountry: // value for 'billingCountry'
 *      billingZip: // value for 'billingZip'
 *      excludeConvenienceFees: // value for 'excludeConvenienceFees'
 *      portalPriceVisibilityOverride: // value for 'portalPriceVisibilityOverride'
 *   },
 * });
 */
export function useFullUpdateEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateEndCustomerMutation, FullUpdateEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateEndCustomerMutation, FullUpdateEndCustomerMutationVariables>(FullUpdateEndCustomerDocument, options);
      }
export type FullUpdateEndCustomerMutationHookResult = ReturnType<typeof useFullUpdateEndCustomerMutation>;
export type FullUpdateEndCustomerMutationResult = Apollo.MutationResult<FullUpdateEndCustomerMutation>;
export type FullUpdateEndCustomerMutationOptions = Apollo.BaseMutationOptions<FullUpdateEndCustomerMutation, FullUpdateEndCustomerMutationVariables>;
export const UpdateEndCustomerVisibleServiceTypeIdsDocument = gql`
    mutation UpdateEndCustomerVisibleServiceTypeIds($courierId: ID!, $endCustomerId: ID!, $visibleServiceTypeIds: [ID!], $defaultServiceTypeId: ID) {
  updateEndCustomerVisibleServiceTypeIds(
    courierId: $courierId
    endCustomerId: $endCustomerId
    visibleServiceTypeIds: $visibleServiceTypeIds
    defaultServiceTypeId: $defaultServiceTypeId
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateEndCustomerVisibleServiceTypeIdsMutationFn = Apollo.MutationFunction<UpdateEndCustomerVisibleServiceTypeIdsMutation, UpdateEndCustomerVisibleServiceTypeIdsMutationVariables>;

/**
 * __useUpdateEndCustomerVisibleServiceTypeIdsMutation__
 *
 * To run a mutation, you first call `useUpdateEndCustomerVisibleServiceTypeIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndCustomerVisibleServiceTypeIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndCustomerVisibleServiceTypeIdsMutation, { data, loading, error }] = useUpdateEndCustomerVisibleServiceTypeIdsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      visibleServiceTypeIds: // value for 'visibleServiceTypeIds'
 *      defaultServiceTypeId: // value for 'defaultServiceTypeId'
 *   },
 * });
 */
export function useUpdateEndCustomerVisibleServiceTypeIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndCustomerVisibleServiceTypeIdsMutation, UpdateEndCustomerVisibleServiceTypeIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndCustomerVisibleServiceTypeIdsMutation, UpdateEndCustomerVisibleServiceTypeIdsMutationVariables>(UpdateEndCustomerVisibleServiceTypeIdsDocument, options);
      }
export type UpdateEndCustomerVisibleServiceTypeIdsMutationHookResult = ReturnType<typeof useUpdateEndCustomerVisibleServiceTypeIdsMutation>;
export type UpdateEndCustomerVisibleServiceTypeIdsMutationResult = Apollo.MutationResult<UpdateEndCustomerVisibleServiceTypeIdsMutation>;
export type UpdateEndCustomerVisibleServiceTypeIdsMutationOptions = Apollo.BaseMutationOptions<UpdateEndCustomerVisibleServiceTypeIdsMutation, UpdateEndCustomerVisibleServiceTypeIdsMutationVariables>;
export const UpdatePodEmailsDocument = gql`
    mutation UpdatePodEmails($courierId: ID!, $endCustomerId: ID!, $podEmails: [ID!]) {
  updatePodEmails(
    courierId: $courierId
    endCustomerId: $endCustomerId
    podEmails: $podEmails
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdatePodEmailsMutationFn = Apollo.MutationFunction<UpdatePodEmailsMutation, UpdatePodEmailsMutationVariables>;

/**
 * __useUpdatePodEmailsMutation__
 *
 * To run a mutation, you first call `useUpdatePodEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePodEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePodEmailsMutation, { data, loading, error }] = useUpdatePodEmailsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      podEmails: // value for 'podEmails'
 *   },
 * });
 */
export function useUpdatePodEmailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePodEmailsMutation, UpdatePodEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePodEmailsMutation, UpdatePodEmailsMutationVariables>(UpdatePodEmailsDocument, options);
      }
export type UpdatePodEmailsMutationHookResult = ReturnType<typeof useUpdatePodEmailsMutation>;
export type UpdatePodEmailsMutationResult = Apollo.MutationResult<UpdatePodEmailsMutation>;
export type UpdatePodEmailsMutationOptions = Apollo.BaseMutationOptions<UpdatePodEmailsMutation, UpdatePodEmailsMutationVariables>;
export const MergeEndCustomersDocument = gql`
    mutation MergeEndCustomers($courierId: ID!, $sourceEndCustomerId: ID!, $targetEndCustomerId: ID!) {
  mergeEndCustomers(
    courierId: $courierId
    sourceEndCustomerId: $sourceEndCustomerId
    targetEndCustomerId: $targetEndCustomerId
  ) {
    id
  }
}
    `;
export type MergeEndCustomersMutationFn = Apollo.MutationFunction<MergeEndCustomersMutation, MergeEndCustomersMutationVariables>;

/**
 * __useMergeEndCustomersMutation__
 *
 * To run a mutation, you first call `useMergeEndCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeEndCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeEndCustomersMutation, { data, loading, error }] = useMergeEndCustomersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      sourceEndCustomerId: // value for 'sourceEndCustomerId'
 *      targetEndCustomerId: // value for 'targetEndCustomerId'
 *   },
 * });
 */
export function useMergeEndCustomersMutation(baseOptions?: Apollo.MutationHookOptions<MergeEndCustomersMutation, MergeEndCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeEndCustomersMutation, MergeEndCustomersMutationVariables>(MergeEndCustomersDocument, options);
      }
export type MergeEndCustomersMutationHookResult = ReturnType<typeof useMergeEndCustomersMutation>;
export type MergeEndCustomersMutationResult = Apollo.MutationResult<MergeEndCustomersMutation>;
export type MergeEndCustomersMutationOptions = Apollo.BaseMutationOptions<MergeEndCustomersMutation, MergeEndCustomersMutationVariables>;
export const ChangePasswordEndCustomerDocument = gql`
    mutation ChangePasswordEndCustomer($courierId: ID!, $endCustomerId: ID!, $password: String!) {
  changePasswordEndCustomer(
    courierId: $courierId
    endCustomerId: $endCustomerId
    password: $password
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type ChangePasswordEndCustomerMutationFn = Apollo.MutationFunction<ChangePasswordEndCustomerMutation, ChangePasswordEndCustomerMutationVariables>;

/**
 * __useChangePasswordEndCustomerMutation__
 *
 * To run a mutation, you first call `useChangePasswordEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordEndCustomerMutation, { data, loading, error }] = useChangePasswordEndCustomerMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordEndCustomerMutation, ChangePasswordEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordEndCustomerMutation, ChangePasswordEndCustomerMutationVariables>(ChangePasswordEndCustomerDocument, options);
      }
export type ChangePasswordEndCustomerMutationHookResult = ReturnType<typeof useChangePasswordEndCustomerMutation>;
export type ChangePasswordEndCustomerMutationResult = Apollo.MutationResult<ChangePasswordEndCustomerMutation>;
export type ChangePasswordEndCustomerMutationOptions = Apollo.BaseMutationOptions<ChangePasswordEndCustomerMutation, ChangePasswordEndCustomerMutationVariables>;
export const MarkEndCustomerConfirmedAsNewDocument = gql`
    mutation MarkEndCustomerConfirmedAsNew($courierId: ID!, $endCustomerId: ID!) {
  markEndCustomerConfirmedAsNew(
    courierId: $courierId
    endCustomerId: $endCustomerId
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type MarkEndCustomerConfirmedAsNewMutationFn = Apollo.MutationFunction<MarkEndCustomerConfirmedAsNewMutation, MarkEndCustomerConfirmedAsNewMutationVariables>;

/**
 * __useMarkEndCustomerConfirmedAsNewMutation__
 *
 * To run a mutation, you first call `useMarkEndCustomerConfirmedAsNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEndCustomerConfirmedAsNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEndCustomerConfirmedAsNewMutation, { data, loading, error }] = useMarkEndCustomerConfirmedAsNewMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useMarkEndCustomerConfirmedAsNewMutation(baseOptions?: Apollo.MutationHookOptions<MarkEndCustomerConfirmedAsNewMutation, MarkEndCustomerConfirmedAsNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEndCustomerConfirmedAsNewMutation, MarkEndCustomerConfirmedAsNewMutationVariables>(MarkEndCustomerConfirmedAsNewDocument, options);
      }
export type MarkEndCustomerConfirmedAsNewMutationHookResult = ReturnType<typeof useMarkEndCustomerConfirmedAsNewMutation>;
export type MarkEndCustomerConfirmedAsNewMutationResult = Apollo.MutationResult<MarkEndCustomerConfirmedAsNewMutation>;
export type MarkEndCustomerConfirmedAsNewMutationOptions = Apollo.BaseMutationOptions<MarkEndCustomerConfirmedAsNewMutation, MarkEndCustomerConfirmedAsNewMutationVariables>;
export const UpdateEnabledEndCustomerCommunicationsTypesDocument = gql`
    mutation UpdateEnabledEndCustomerCommunicationsTypes($courierId: ID!, $endCustomerId: ID!, $enabledCommunicationTypeIds: [CommunicationTypeId!]!) {
  updateEnabledEndCustomerCommunicationsTypes(
    courierId: $courierId
    endCustomerId: $endCustomerId
    enabledCommunicationTypeIds: $enabledCommunicationTypeIds
  )
}
    `;
export type UpdateEnabledEndCustomerCommunicationsTypesMutationFn = Apollo.MutationFunction<UpdateEnabledEndCustomerCommunicationsTypesMutation, UpdateEnabledEndCustomerCommunicationsTypesMutationVariables>;

/**
 * __useUpdateEnabledEndCustomerCommunicationsTypesMutation__
 *
 * To run a mutation, you first call `useUpdateEnabledEndCustomerCommunicationsTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnabledEndCustomerCommunicationsTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnabledEndCustomerCommunicationsTypesMutation, { data, loading, error }] = useUpdateEnabledEndCustomerCommunicationsTypesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      enabledCommunicationTypeIds: // value for 'enabledCommunicationTypeIds'
 *   },
 * });
 */
export function useUpdateEnabledEndCustomerCommunicationsTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnabledEndCustomerCommunicationsTypesMutation, UpdateEnabledEndCustomerCommunicationsTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnabledEndCustomerCommunicationsTypesMutation, UpdateEnabledEndCustomerCommunicationsTypesMutationVariables>(UpdateEnabledEndCustomerCommunicationsTypesDocument, options);
      }
export type UpdateEnabledEndCustomerCommunicationsTypesMutationHookResult = ReturnType<typeof useUpdateEnabledEndCustomerCommunicationsTypesMutation>;
export type UpdateEnabledEndCustomerCommunicationsTypesMutationResult = Apollo.MutationResult<UpdateEnabledEndCustomerCommunicationsTypesMutation>;
export type UpdateEnabledEndCustomerCommunicationsTypesMutationOptions = Apollo.BaseMutationOptions<UpdateEnabledEndCustomerCommunicationsTypesMutation, UpdateEnabledEndCustomerCommunicationsTypesMutationVariables>;
export const MarkEndCustomerDeletedDocument = gql`
    mutation MarkEndCustomerDeleted($courierId: ID!, $endCustomerId: ID!) {
  markEndCustomerDeleted(courierId: $courierId, endCustomerId: $endCustomerId)
}
    `;
export type MarkEndCustomerDeletedMutationFn = Apollo.MutationFunction<MarkEndCustomerDeletedMutation, MarkEndCustomerDeletedMutationVariables>;

/**
 * __useMarkEndCustomerDeletedMutation__
 *
 * To run a mutation, you first call `useMarkEndCustomerDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEndCustomerDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEndCustomerDeletedMutation, { data, loading, error }] = useMarkEndCustomerDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useMarkEndCustomerDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkEndCustomerDeletedMutation, MarkEndCustomerDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEndCustomerDeletedMutation, MarkEndCustomerDeletedMutationVariables>(MarkEndCustomerDeletedDocument, options);
      }
export type MarkEndCustomerDeletedMutationHookResult = ReturnType<typeof useMarkEndCustomerDeletedMutation>;
export type MarkEndCustomerDeletedMutationResult = Apollo.MutationResult<MarkEndCustomerDeletedMutation>;
export type MarkEndCustomerDeletedMutationOptions = Apollo.BaseMutationOptions<MarkEndCustomerDeletedMutation, MarkEndCustomerDeletedMutationVariables>;
export const UpdateEndCustomerCustomFieldsDocument = gql`
    mutation UpdateEndCustomerCustomFields($courierId: ID!, $endCustomerId: ID!, $customFieldIds: [ID!]!) {
  updateEndCustomerCustomFields(
    courierId: $courierId
    endCustomerId: $endCustomerId
    customFieldIds: $customFieldIds
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateEndCustomerCustomFieldsMutationFn = Apollo.MutationFunction<UpdateEndCustomerCustomFieldsMutation, UpdateEndCustomerCustomFieldsMutationVariables>;

/**
 * __useUpdateEndCustomerCustomFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateEndCustomerCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndCustomerCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndCustomerCustomFieldsMutation, { data, loading, error }] = useUpdateEndCustomerCustomFieldsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      customFieldIds: // value for 'customFieldIds'
 *   },
 * });
 */
export function useUpdateEndCustomerCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndCustomerCustomFieldsMutation, UpdateEndCustomerCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndCustomerCustomFieldsMutation, UpdateEndCustomerCustomFieldsMutationVariables>(UpdateEndCustomerCustomFieldsDocument, options);
      }
export type UpdateEndCustomerCustomFieldsMutationHookResult = ReturnType<typeof useUpdateEndCustomerCustomFieldsMutation>;
export type UpdateEndCustomerCustomFieldsMutationResult = Apollo.MutationResult<UpdateEndCustomerCustomFieldsMutation>;
export type UpdateEndCustomerCustomFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateEndCustomerCustomFieldsMutation, UpdateEndCustomerCustomFieldsMutationVariables>;
export const UpdateEndCustomerNoteDocument = gql`
    mutation UpdateEndCustomerNote($courierId: ID!, $endCustomerId: ID!, $note: String) {
  updateEndCustomerNote(
    courierId: $courierId
    endCustomerId: $endCustomerId
    note: $note
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateEndCustomerNoteMutationFn = Apollo.MutationFunction<UpdateEndCustomerNoteMutation, UpdateEndCustomerNoteMutationVariables>;

/**
 * __useUpdateEndCustomerNoteMutation__
 *
 * To run a mutation, you first call `useUpdateEndCustomerNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndCustomerNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndCustomerNoteMutation, { data, loading, error }] = useUpdateEndCustomerNoteMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateEndCustomerNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndCustomerNoteMutation, UpdateEndCustomerNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndCustomerNoteMutation, UpdateEndCustomerNoteMutationVariables>(UpdateEndCustomerNoteDocument, options);
      }
export type UpdateEndCustomerNoteMutationHookResult = ReturnType<typeof useUpdateEndCustomerNoteMutation>;
export type UpdateEndCustomerNoteMutationResult = Apollo.MutationResult<UpdateEndCustomerNoteMutation>;
export type UpdateEndCustomerNoteMutationOptions = Apollo.BaseMutationOptions<UpdateEndCustomerNoteMutation, UpdateEndCustomerNoteMutationVariables>;
export const SetEndCustomerRequiredFieldsDocument = gql`
    mutation SetEndCustomerRequiredFields($courierId: ID!, $endCustomerId: ID!, $additionalFields: [CustomerPortalAdditionalRequiredFields!]!, $dispatchAdditionalFields: [DispatcherOrderEntryAdditionalField!]!) {
  setEndCustomerRequiredFields(
    courierId: $courierId
    endCustomerId: $endCustomerId
    additionalFields: $additionalFields
    dispatchAdditionalFields: $dispatchAdditionalFields
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type SetEndCustomerRequiredFieldsMutationFn = Apollo.MutationFunction<SetEndCustomerRequiredFieldsMutation, SetEndCustomerRequiredFieldsMutationVariables>;

/**
 * __useSetEndCustomerRequiredFieldsMutation__
 *
 * To run a mutation, you first call `useSetEndCustomerRequiredFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEndCustomerRequiredFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEndCustomerRequiredFieldsMutation, { data, loading, error }] = useSetEndCustomerRequiredFieldsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      additionalFields: // value for 'additionalFields'
 *      dispatchAdditionalFields: // value for 'dispatchAdditionalFields'
 *   },
 * });
 */
export function useSetEndCustomerRequiredFieldsMutation(baseOptions?: Apollo.MutationHookOptions<SetEndCustomerRequiredFieldsMutation, SetEndCustomerRequiredFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEndCustomerRequiredFieldsMutation, SetEndCustomerRequiredFieldsMutationVariables>(SetEndCustomerRequiredFieldsDocument, options);
      }
export type SetEndCustomerRequiredFieldsMutationHookResult = ReturnType<typeof useSetEndCustomerRequiredFieldsMutation>;
export type SetEndCustomerRequiredFieldsMutationResult = Apollo.MutationResult<SetEndCustomerRequiredFieldsMutation>;
export type SetEndCustomerRequiredFieldsMutationOptions = Apollo.BaseMutationOptions<SetEndCustomerRequiredFieldsMutation, SetEndCustomerRequiredFieldsMutationVariables>;
export const GetOrCreateEndCustomerAccountNumberDocument = gql`
    mutation GetOrCreateEndCustomerAccountNumber($courierId: ID!, $endCustomerId: ID!) {
  getOrCreateEndCustomerAccountNumber(
    courierId: $courierId
    endCustomerId: $endCustomerId
  )
}
    `;
export type GetOrCreateEndCustomerAccountNumberMutationFn = Apollo.MutationFunction<GetOrCreateEndCustomerAccountNumberMutation, GetOrCreateEndCustomerAccountNumberMutationVariables>;

/**
 * __useGetOrCreateEndCustomerAccountNumberMutation__
 *
 * To run a mutation, you first call `useGetOrCreateEndCustomerAccountNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateEndCustomerAccountNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateEndCustomerAccountNumberMutation, { data, loading, error }] = useGetOrCreateEndCustomerAccountNumberMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useGetOrCreateEndCustomerAccountNumberMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateEndCustomerAccountNumberMutation, GetOrCreateEndCustomerAccountNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateEndCustomerAccountNumberMutation, GetOrCreateEndCustomerAccountNumberMutationVariables>(GetOrCreateEndCustomerAccountNumberDocument, options);
      }
export type GetOrCreateEndCustomerAccountNumberMutationHookResult = ReturnType<typeof useGetOrCreateEndCustomerAccountNumberMutation>;
export type GetOrCreateEndCustomerAccountNumberMutationResult = Apollo.MutationResult<GetOrCreateEndCustomerAccountNumberMutation>;
export type GetOrCreateEndCustomerAccountNumberMutationOptions = Apollo.BaseMutationOptions<GetOrCreateEndCustomerAccountNumberMutation, GetOrCreateEndCustomerAccountNumberMutationVariables>;
export const GenerateCsvForEndCustomersDocument = gql`
    mutation GenerateCsvForEndCustomers($courierId: ID!) {
  generateCsvForEndCustomers(courierId: $courierId) {
    url
  }
}
    `;
export type GenerateCsvForEndCustomersMutationFn = Apollo.MutationFunction<GenerateCsvForEndCustomersMutation, GenerateCsvForEndCustomersMutationVariables>;

/**
 * __useGenerateCsvForEndCustomersMutation__
 *
 * To run a mutation, you first call `useGenerateCsvForEndCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCsvForEndCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCsvForEndCustomersMutation, { data, loading, error }] = useGenerateCsvForEndCustomersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGenerateCsvForEndCustomersMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCsvForEndCustomersMutation, GenerateCsvForEndCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCsvForEndCustomersMutation, GenerateCsvForEndCustomersMutationVariables>(GenerateCsvForEndCustomersDocument, options);
      }
export type GenerateCsvForEndCustomersMutationHookResult = ReturnType<typeof useGenerateCsvForEndCustomersMutation>;
export type GenerateCsvForEndCustomersMutationResult = Apollo.MutationResult<GenerateCsvForEndCustomersMutation>;
export type GenerateCsvForEndCustomersMutationOptions = Apollo.BaseMutationOptions<GenerateCsvForEndCustomersMutation, GenerateCsvForEndCustomersMutationVariables>;
export const BulkDeleteEndCustomersDocument = gql`
    mutation BulkDeleteEndCustomers($courierId: ID!) {
  bulkDeleteEndCustomers(courierId: $courierId)
}
    `;
export type BulkDeleteEndCustomersMutationFn = Apollo.MutationFunction<BulkDeleteEndCustomersMutation, BulkDeleteEndCustomersMutationVariables>;

/**
 * __useBulkDeleteEndCustomersMutation__
 *
 * To run a mutation, you first call `useBulkDeleteEndCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteEndCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteEndCustomersMutation, { data, loading, error }] = useBulkDeleteEndCustomersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useBulkDeleteEndCustomersMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteEndCustomersMutation, BulkDeleteEndCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteEndCustomersMutation, BulkDeleteEndCustomersMutationVariables>(BulkDeleteEndCustomersDocument, options);
      }
export type BulkDeleteEndCustomersMutationHookResult = ReturnType<typeof useBulkDeleteEndCustomersMutation>;
export type BulkDeleteEndCustomersMutationResult = Apollo.MutationResult<BulkDeleteEndCustomersMutation>;
export type BulkDeleteEndCustomersMutationOptions = Apollo.BaseMutationOptions<BulkDeleteEndCustomersMutation, BulkDeleteEndCustomersMutationVariables>;
export const UpdateEndCustomerPodRequirementDocument = gql`
    mutation UpdateEndCustomerPodRequirement($courierId: ID!, $endCustomerId: ID!, $pickupPodRequirement: PodRequirementAtStop, $dropoffPodRequirement: PodRequirementAtStop, $returnPodRequirement: PodRequirementAtStop) {
  updateEndCustomerPodRequirement(
    courierId: $courierId
    endCustomerId: $endCustomerId
    pickupPodRequirement: $pickupPodRequirement
    dropoffPodRequirement: $dropoffPodRequirement
    returnPodRequirement: $returnPodRequirement
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateEndCustomerPodRequirementMutationFn = Apollo.MutationFunction<UpdateEndCustomerPodRequirementMutation, UpdateEndCustomerPodRequirementMutationVariables>;

/**
 * __useUpdateEndCustomerPodRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateEndCustomerPodRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndCustomerPodRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndCustomerPodRequirementMutation, { data, loading, error }] = useUpdateEndCustomerPodRequirementMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      pickupPodRequirement: // value for 'pickupPodRequirement'
 *      dropoffPodRequirement: // value for 'dropoffPodRequirement'
 *      returnPodRequirement: // value for 'returnPodRequirement'
 *   },
 * });
 */
export function useUpdateEndCustomerPodRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndCustomerPodRequirementMutation, UpdateEndCustomerPodRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndCustomerPodRequirementMutation, UpdateEndCustomerPodRequirementMutationVariables>(UpdateEndCustomerPodRequirementDocument, options);
      }
export type UpdateEndCustomerPodRequirementMutationHookResult = ReturnType<typeof useUpdateEndCustomerPodRequirementMutation>;
export type UpdateEndCustomerPodRequirementMutationResult = Apollo.MutationResult<UpdateEndCustomerPodRequirementMutation>;
export type UpdateEndCustomerPodRequirementMutationOptions = Apollo.BaseMutationOptions<UpdateEndCustomerPodRequirementMutation, UpdateEndCustomerPodRequirementMutationVariables>;
export const UpdateSalesTermsForEndCustomersDocument = gql`
    mutation UpdateSalesTermsForEndCustomers($courierId: ID!, $input: [EndCustomerSalesTermUpdate!]!) {
  updateSalesTermsForEndCustomers(courierId: $courierId, input: $input) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateSalesTermsForEndCustomersMutationFn = Apollo.MutationFunction<UpdateSalesTermsForEndCustomersMutation, UpdateSalesTermsForEndCustomersMutationVariables>;

/**
 * __useUpdateSalesTermsForEndCustomersMutation__
 *
 * To run a mutation, you first call `useUpdateSalesTermsForEndCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesTermsForEndCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesTermsForEndCustomersMutation, { data, loading, error }] = useUpdateSalesTermsForEndCustomersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSalesTermsForEndCustomersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesTermsForEndCustomersMutation, UpdateSalesTermsForEndCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesTermsForEndCustomersMutation, UpdateSalesTermsForEndCustomersMutationVariables>(UpdateSalesTermsForEndCustomersDocument, options);
      }
export type UpdateSalesTermsForEndCustomersMutationHookResult = ReturnType<typeof useUpdateSalesTermsForEndCustomersMutation>;
export type UpdateSalesTermsForEndCustomersMutationResult = Apollo.MutationResult<UpdateSalesTermsForEndCustomersMutation>;
export type UpdateSalesTermsForEndCustomersMutationOptions = Apollo.BaseMutationOptions<UpdateSalesTermsForEndCustomersMutation, UpdateSalesTermsForEndCustomersMutationVariables>;
export const UpdateEndCustomerAccountStatusDocument = gql`
    mutation UpdateEndCustomerAccountStatus($courierId: ID!, $endCustomerId: ID!, $accountStatus: EndCustomerAccountStatus!) {
  updateEndCustomerAccountStatus(
    courierId: $courierId
    endCustomerId: $endCustomerId
    accountStatus: $accountStatus
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateEndCustomerAccountStatusMutationFn = Apollo.MutationFunction<UpdateEndCustomerAccountStatusMutation, UpdateEndCustomerAccountStatusMutationVariables>;

/**
 * __useUpdateEndCustomerAccountStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEndCustomerAccountStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndCustomerAccountStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndCustomerAccountStatusMutation, { data, loading, error }] = useUpdateEndCustomerAccountStatusMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      accountStatus: // value for 'accountStatus'
 *   },
 * });
 */
export function useUpdateEndCustomerAccountStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndCustomerAccountStatusMutation, UpdateEndCustomerAccountStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndCustomerAccountStatusMutation, UpdateEndCustomerAccountStatusMutationVariables>(UpdateEndCustomerAccountStatusDocument, options);
      }
export type UpdateEndCustomerAccountStatusMutationHookResult = ReturnType<typeof useUpdateEndCustomerAccountStatusMutation>;
export type UpdateEndCustomerAccountStatusMutationResult = Apollo.MutationResult<UpdateEndCustomerAccountStatusMutation>;
export type UpdateEndCustomerAccountStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEndCustomerAccountStatusMutation, UpdateEndCustomerAccountStatusMutationVariables>;
export const SearchEndCustomerDocument = gql`
    query SearchEndCustomer($courierId: ID!, $searchTerm: String!) {
  searchEndCustomer(courierId: $courierId, searchTerm: $searchTerm) {
    ...EndCustomerFragment
    remoteEntities {
      ...RemoteEntityFragment
    }
    costCenters {
      ...CostCenterFragment
      location {
        ...LocationFragment
      }
    }
    location {
      ...LocationFragment
    }
    pricingList {
      ...PricingListFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}`;

/**
 * __useSearchEndCustomerQuery__
 *
 * To run a query within a React component, call `useSearchEndCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEndCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEndCustomerQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchEndCustomerQuery(baseOptions: Apollo.QueryHookOptions<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>(SearchEndCustomerDocument, options);
      }
export function useSearchEndCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>(SearchEndCustomerDocument, options);
        }
export type SearchEndCustomerQueryHookResult = ReturnType<typeof useSearchEndCustomerQuery>;
export type SearchEndCustomerLazyQueryHookResult = ReturnType<typeof useSearchEndCustomerLazyQuery>;
export type SearchEndCustomerQueryResult = Apollo.QueryResult<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>;
export const GetEndCustomersDocument = gql`
    query GetEndCustomers($courierId: ID!, $ids: [ID!], $limit: Int, $after: Int, $sortFields: [EndCustomerSorting!], $labelIds: [ID!]) {
  endCustomers(
    courierId: $courierId
    ids: $ids
    limit: $limit
    after: $after
    sortFields: $sortFields
    labelIds: $labelIds
  ) {
    edges {
      node {
        ...EndCustomerFragment
        assignedLabels {
          ...LabelFragment
        }
        pricingList {
          ...PricingListFragment
        }
        location {
          ...LocationFragment
        }
        remoteEntities {
          ...RemoteEntityFragment
        }
        costCenters {
          ...CostCenterFragment
          location {
            ...LocationFragment
          }
        }
        invoicePdfTemplate {
          ...InvoicePdfTemplateFragment
        }
        customFields {
          ...CustomFieldFragment
        }
        holidaySchedule {
          ...HolidayScheduleFragment
        }
        paymentInstruments {
          ...PaymentInstrumentFragment
        }
        courierBrand {
          ...CourierBrandFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${LabelFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${HolidayScheduleFragmentFragmentDoc}
${PaymentInstrumentFragmentFragmentDoc}
${CourierBrandFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetEndCustomersQuery__
 *
 * To run a query within a React component, call `useGetEndCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndCustomersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useGetEndCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetEndCustomersQuery, GetEndCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndCustomersQuery, GetEndCustomersQueryVariables>(GetEndCustomersDocument, options);
      }
export function useGetEndCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndCustomersQuery, GetEndCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndCustomersQuery, GetEndCustomersQueryVariables>(GetEndCustomersDocument, options);
        }
export type GetEndCustomersQueryHookResult = ReturnType<typeof useGetEndCustomersQuery>;
export type GetEndCustomersLazyQueryHookResult = ReturnType<typeof useGetEndCustomersLazyQuery>;
export type GetEndCustomersQueryResult = Apollo.QueryResult<GetEndCustomersQuery, GetEndCustomersQueryVariables>;
export const GetEndCustomersLengthDocument = gql`
    query GetEndCustomersLength($courierId: ID!) {
  endCustomers(courierId: $courierId) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useGetEndCustomersLengthQuery__
 *
 * To run a query within a React component, call `useGetEndCustomersLengthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndCustomersLengthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndCustomersLengthQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetEndCustomersLengthQuery(baseOptions: Apollo.QueryHookOptions<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>(GetEndCustomersLengthDocument, options);
      }
export function useGetEndCustomersLengthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>(GetEndCustomersLengthDocument, options);
        }
export type GetEndCustomersLengthQueryHookResult = ReturnType<typeof useGetEndCustomersLengthQuery>;
export type GetEndCustomersLengthLazyQueryHookResult = ReturnType<typeof useGetEndCustomersLengthLazyQuery>;
export type GetEndCustomersLengthQueryResult = Apollo.QueryResult<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>;
export const GetEndCustomersOverviewDocument = gql`
    query getEndCustomersOverview($courierId: ID!) {
  endCustomersOverview(courierId: $courierId) {
    numUnconfirmedCustomerPortalEndCustomers
  }
}
    `;

/**
 * __useGetEndCustomersOverviewQuery__
 *
 * To run a query within a React component, call `useGetEndCustomersOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndCustomersOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndCustomersOverviewQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetEndCustomersOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>(GetEndCustomersOverviewDocument, options);
      }
export function useGetEndCustomersOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>(GetEndCustomersOverviewDocument, options);
        }
export type GetEndCustomersOverviewQueryHookResult = ReturnType<typeof useGetEndCustomersOverviewQuery>;
export type GetEndCustomersOverviewLazyQueryHookResult = ReturnType<typeof useGetEndCustomersOverviewLazyQuery>;
export type GetEndCustomersOverviewQueryResult = Apollo.QueryResult<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>;
export const CreateCourierHolidayDocument = gql`
    mutation createCourierHoliday($courierId: ID!, $name: String!, $recurrenceRule: String!) {
  createCourierHoliday(
    courierId: $courierId
    name: $name
    recurrenceRule: $recurrenceRule
  ) {
    ...CourierHolidayFragment
  }
}
    ${CourierHolidayFragmentFragmentDoc}`;
export type CreateCourierHolidayMutationFn = Apollo.MutationFunction<CreateCourierHolidayMutation, CreateCourierHolidayMutationVariables>;

/**
 * __useCreateCourierHolidayMutation__
 *
 * To run a mutation, you first call `useCreateCourierHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourierHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourierHolidayMutation, { data, loading, error }] = useCreateCourierHolidayMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      recurrenceRule: // value for 'recurrenceRule'
 *   },
 * });
 */
export function useCreateCourierHolidayMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourierHolidayMutation, CreateCourierHolidayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourierHolidayMutation, CreateCourierHolidayMutationVariables>(CreateCourierHolidayDocument, options);
      }
export type CreateCourierHolidayMutationHookResult = ReturnType<typeof useCreateCourierHolidayMutation>;
export type CreateCourierHolidayMutationResult = Apollo.MutationResult<CreateCourierHolidayMutation>;
export type CreateCourierHolidayMutationOptions = Apollo.BaseMutationOptions<CreateCourierHolidayMutation, CreateCourierHolidayMutationVariables>;
export const UpdateCourierHolidayDocument = gql`
    mutation updateCourierHoliday($courierId: ID!, $courierHolidayId: ID!, $name: String!, $recurrenceRule: String!) {
  updateCourierHoliday(
    courierId: $courierId
    courierHolidayId: $courierHolidayId
    name: $name
    recurrenceRule: $recurrenceRule
  ) {
    ...CourierHolidayFragment
  }
}
    ${CourierHolidayFragmentFragmentDoc}`;
export type UpdateCourierHolidayMutationFn = Apollo.MutationFunction<UpdateCourierHolidayMutation, UpdateCourierHolidayMutationVariables>;

/**
 * __useUpdateCourierHolidayMutation__
 *
 * To run a mutation, you first call `useUpdateCourierHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourierHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourierHolidayMutation, { data, loading, error }] = useUpdateCourierHolidayMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      courierHolidayId: // value for 'courierHolidayId'
 *      name: // value for 'name'
 *      recurrenceRule: // value for 'recurrenceRule'
 *   },
 * });
 */
export function useUpdateCourierHolidayMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourierHolidayMutation, UpdateCourierHolidayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourierHolidayMutation, UpdateCourierHolidayMutationVariables>(UpdateCourierHolidayDocument, options);
      }
export type UpdateCourierHolidayMutationHookResult = ReturnType<typeof useUpdateCourierHolidayMutation>;
export type UpdateCourierHolidayMutationResult = Apollo.MutationResult<UpdateCourierHolidayMutation>;
export type UpdateCourierHolidayMutationOptions = Apollo.BaseMutationOptions<UpdateCourierHolidayMutation, UpdateCourierHolidayMutationVariables>;
export const DeleteCourierHolidayDocument = gql`
    mutation deleteCourierHoliday($courierId: ID!, $courierHolidayId: ID!) {
  deleteCourierHoliday(courierId: $courierId, courierHolidayId: $courierHolidayId)
}
    `;
export type DeleteCourierHolidayMutationFn = Apollo.MutationFunction<DeleteCourierHolidayMutation, DeleteCourierHolidayMutationVariables>;

/**
 * __useDeleteCourierHolidayMutation__
 *
 * To run a mutation, you first call `useDeleteCourierHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourierHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourierHolidayMutation, { data, loading, error }] = useDeleteCourierHolidayMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      courierHolidayId: // value for 'courierHolidayId'
 *   },
 * });
 */
export function useDeleteCourierHolidayMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourierHolidayMutation, DeleteCourierHolidayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourierHolidayMutation, DeleteCourierHolidayMutationVariables>(DeleteCourierHolidayDocument, options);
      }
export type DeleteCourierHolidayMutationHookResult = ReturnType<typeof useDeleteCourierHolidayMutation>;
export type DeleteCourierHolidayMutationResult = Apollo.MutationResult<DeleteCourierHolidayMutation>;
export type DeleteCourierHolidayMutationOptions = Apollo.BaseMutationOptions<DeleteCourierHolidayMutation, DeleteCourierHolidayMutationVariables>;
export const CreateHolidayScheduleDocument = gql`
    mutation createHolidaySchedule($courierId: ID!, $name: String!) {
  createHolidaySchedule(courierId: $courierId, name: $name) {
    ...HolidayScheduleFragment
  }
}
    ${HolidayScheduleFragmentFragmentDoc}`;
export type CreateHolidayScheduleMutationFn = Apollo.MutationFunction<CreateHolidayScheduleMutation, CreateHolidayScheduleMutationVariables>;

/**
 * __useCreateHolidayScheduleMutation__
 *
 * To run a mutation, you first call `useCreateHolidayScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHolidayScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHolidayScheduleMutation, { data, loading, error }] = useCreateHolidayScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateHolidayScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateHolidayScheduleMutation, CreateHolidayScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHolidayScheduleMutation, CreateHolidayScheduleMutationVariables>(CreateHolidayScheduleDocument, options);
      }
export type CreateHolidayScheduleMutationHookResult = ReturnType<typeof useCreateHolidayScheduleMutation>;
export type CreateHolidayScheduleMutationResult = Apollo.MutationResult<CreateHolidayScheduleMutation>;
export type CreateHolidayScheduleMutationOptions = Apollo.BaseMutationOptions<CreateHolidayScheduleMutation, CreateHolidayScheduleMutationVariables>;
export const DeleteHolidayScheduleDocument = gql`
    mutation deleteHolidaySchedule($courierId: ID!, $holidayScheduleId: ID!) {
  deleteHolidaySchedule(
    courierId: $courierId
    holidayScheduleId: $holidayScheduleId
  )
}
    `;
export type DeleteHolidayScheduleMutationFn = Apollo.MutationFunction<DeleteHolidayScheduleMutation, DeleteHolidayScheduleMutationVariables>;

/**
 * __useDeleteHolidayScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteHolidayScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHolidayScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHolidayScheduleMutation, { data, loading, error }] = useDeleteHolidayScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *   },
 * });
 */
export function useDeleteHolidayScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHolidayScheduleMutation, DeleteHolidayScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHolidayScheduleMutation, DeleteHolidayScheduleMutationVariables>(DeleteHolidayScheduleDocument, options);
      }
export type DeleteHolidayScheduleMutationHookResult = ReturnType<typeof useDeleteHolidayScheduleMutation>;
export type DeleteHolidayScheduleMutationResult = Apollo.MutationResult<DeleteHolidayScheduleMutation>;
export type DeleteHolidayScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteHolidayScheduleMutation, DeleteHolidayScheduleMutationVariables>;
export const DeleteHolidayScheduleBehaviorDocument = gql`
    mutation deleteHolidayScheduleBehavior($courierId: ID!, $courierHolidayId: ID!, $holidayScheduleId: ID!) {
  deleteHolidayScheduleBehavior(
    courierId: $courierId
    courierHolidayId: $courierHolidayId
    holidayScheduleId: $holidayScheduleId
  )
}
    `;
export type DeleteHolidayScheduleBehaviorMutationFn = Apollo.MutationFunction<DeleteHolidayScheduleBehaviorMutation, DeleteHolidayScheduleBehaviorMutationVariables>;

/**
 * __useDeleteHolidayScheduleBehaviorMutation__
 *
 * To run a mutation, you first call `useDeleteHolidayScheduleBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHolidayScheduleBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHolidayScheduleBehaviorMutation, { data, loading, error }] = useDeleteHolidayScheduleBehaviorMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      courierHolidayId: // value for 'courierHolidayId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *   },
 * });
 */
export function useDeleteHolidayScheduleBehaviorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHolidayScheduleBehaviorMutation, DeleteHolidayScheduleBehaviorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHolidayScheduleBehaviorMutation, DeleteHolidayScheduleBehaviorMutationVariables>(DeleteHolidayScheduleBehaviorDocument, options);
      }
export type DeleteHolidayScheduleBehaviorMutationHookResult = ReturnType<typeof useDeleteHolidayScheduleBehaviorMutation>;
export type DeleteHolidayScheduleBehaviorMutationResult = Apollo.MutationResult<DeleteHolidayScheduleBehaviorMutation>;
export type DeleteHolidayScheduleBehaviorMutationOptions = Apollo.BaseMutationOptions<DeleteHolidayScheduleBehaviorMutation, DeleteHolidayScheduleBehaviorMutationVariables>;
export const UpdateHolidayScheduleDocument = gql`
    mutation updateHolidaySchedule($courierId: ID!, $holidayScheduleId: ID!, $name: String!) {
  updateHolidaySchedule(
    courierId: $courierId
    holidayScheduleId: $holidayScheduleId
    name: $name
  )
}
    `;
export type UpdateHolidayScheduleMutationFn = Apollo.MutationFunction<UpdateHolidayScheduleMutation, UpdateHolidayScheduleMutationVariables>;

/**
 * __useUpdateHolidayScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateHolidayScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHolidayScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHolidayScheduleMutation, { data, loading, error }] = useUpdateHolidayScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateHolidayScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHolidayScheduleMutation, UpdateHolidayScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHolidayScheduleMutation, UpdateHolidayScheduleMutationVariables>(UpdateHolidayScheduleDocument, options);
      }
export type UpdateHolidayScheduleMutationHookResult = ReturnType<typeof useUpdateHolidayScheduleMutation>;
export type UpdateHolidayScheduleMutationResult = Apollo.MutationResult<UpdateHolidayScheduleMutation>;
export type UpdateHolidayScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateHolidayScheduleMutation, UpdateHolidayScheduleMutationVariables>;
export const UpsertHolidayScheduleBehaviorDocument = gql`
    mutation upsertHolidayScheduleBehavior($courierId: ID!, $courierHolidayId: ID!, $holidayScheduleId: ID!, $holidayBehavior: HolidayBehavior!) {
  upsertHolidayScheduleBehavior(
    courierId: $courierId
    courierHolidayId: $courierHolidayId
    holidayScheduleId: $holidayScheduleId
    holidayBehavior: $holidayBehavior
  )
}
    `;
export type UpsertHolidayScheduleBehaviorMutationFn = Apollo.MutationFunction<UpsertHolidayScheduleBehaviorMutation, UpsertHolidayScheduleBehaviorMutationVariables>;

/**
 * __useUpsertHolidayScheduleBehaviorMutation__
 *
 * To run a mutation, you first call `useUpsertHolidayScheduleBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHolidayScheduleBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHolidayScheduleBehaviorMutation, { data, loading, error }] = useUpsertHolidayScheduleBehaviorMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      courierHolidayId: // value for 'courierHolidayId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *      holidayBehavior: // value for 'holidayBehavior'
 *   },
 * });
 */
export function useUpsertHolidayScheduleBehaviorMutation(baseOptions?: Apollo.MutationHookOptions<UpsertHolidayScheduleBehaviorMutation, UpsertHolidayScheduleBehaviorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertHolidayScheduleBehaviorMutation, UpsertHolidayScheduleBehaviorMutationVariables>(UpsertHolidayScheduleBehaviorDocument, options);
      }
export type UpsertHolidayScheduleBehaviorMutationHookResult = ReturnType<typeof useUpsertHolidayScheduleBehaviorMutation>;
export type UpsertHolidayScheduleBehaviorMutationResult = Apollo.MutationResult<UpsertHolidayScheduleBehaviorMutation>;
export type UpsertHolidayScheduleBehaviorMutationOptions = Apollo.BaseMutationOptions<UpsertHolidayScheduleBehaviorMutation, UpsertHolidayScheduleBehaviorMutationVariables>;
export const GetCourierHolidaysDocument = gql`
    query GetCourierHolidays($courierId: ID!) {
  courierHolidays(courierId: $courierId) {
    ...CourierHolidayFragment
  }
}
    ${CourierHolidayFragmentFragmentDoc}`;

/**
 * __useGetCourierHolidaysQuery__
 *
 * To run a query within a React component, call `useGetCourierHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierHolidaysQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetCourierHolidaysQuery(baseOptions: Apollo.QueryHookOptions<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>(GetCourierHolidaysDocument, options);
      }
export function useGetCourierHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>(GetCourierHolidaysDocument, options);
        }
export type GetCourierHolidaysQueryHookResult = ReturnType<typeof useGetCourierHolidaysQuery>;
export type GetCourierHolidaysLazyQueryHookResult = ReturnType<typeof useGetCourierHolidaysLazyQuery>;
export type GetCourierHolidaysQueryResult = Apollo.QueryResult<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>;
export const GetHolidaySchedulesDocument = gql`
    query GetHolidaySchedules($courierId: ID!) {
  holidaySchedules(courierId: $courierId) {
    ...HolidayScheduleFragment
  }
}
    ${HolidayScheduleFragmentFragmentDoc}`;

/**
 * __useGetHolidaySchedulesQuery__
 *
 * To run a query within a React component, call `useGetHolidaySchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidaySchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidaySchedulesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetHolidaySchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>(GetHolidaySchedulesDocument, options);
      }
export function useGetHolidaySchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>(GetHolidaySchedulesDocument, options);
        }
export type GetHolidaySchedulesQueryHookResult = ReturnType<typeof useGetHolidaySchedulesQuery>;
export type GetHolidaySchedulesLazyQueryHookResult = ReturnType<typeof useGetHolidaySchedulesLazyQuery>;
export type GetHolidaySchedulesQueryResult = Apollo.QueryResult<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>;
export const GetHolidayScheduleBehaviorsDocument = gql`
    query GetHolidayScheduleBehaviors($courierId: ID!, $holidayScheduleId: ID!) {
  holidayScheduleBehaviors(
    courierId: $courierId
    holidayScheduleId: $holidayScheduleId
  ) {
    ...HolidayScheduleBehaviorFragment
  }
}
    ${HolidayScheduleBehaviorFragmentFragmentDoc}`;

/**
 * __useGetHolidayScheduleBehaviorsQuery__
 *
 * To run a query within a React component, call `useGetHolidayScheduleBehaviorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidayScheduleBehaviorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidayScheduleBehaviorsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *   },
 * });
 */
export function useGetHolidayScheduleBehaviorsQuery(baseOptions: Apollo.QueryHookOptions<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>(GetHolidayScheduleBehaviorsDocument, options);
      }
export function useGetHolidayScheduleBehaviorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>(GetHolidayScheduleBehaviorsDocument, options);
        }
export type GetHolidayScheduleBehaviorsQueryHookResult = ReturnType<typeof useGetHolidayScheduleBehaviorsQuery>;
export type GetHolidayScheduleBehaviorsLazyQueryHookResult = ReturnType<typeof useGetHolidayScheduleBehaviorsLazyQuery>;
export type GetHolidayScheduleBehaviorsQueryResult = Apollo.QueryResult<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>;
export const ApproveInvoiceDocument = gql`
    mutation approveInvoice($courierId: ID!, $invoiceId: ID!) {
  approveInvoice(courierId: $courierId, invoiceId: $invoiceId) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type ApproveInvoiceMutationFn = Apollo.MutationFunction<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>;

/**
 * __useApproveInvoiceMutation__
 *
 * To run a mutation, you first call `useApproveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInvoiceMutation, { data, loading, error }] = useApproveInvoiceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useApproveInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>(ApproveInvoiceDocument, options);
      }
export type ApproveInvoiceMutationHookResult = ReturnType<typeof useApproveInvoiceMutation>;
export type ApproveInvoiceMutationResult = Apollo.MutationResult<ApproveInvoiceMutation>;
export type ApproveInvoiceMutationOptions = Apollo.BaseMutationOptions<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>;
export const SyncInvoiceDocument = gql`
    mutation syncInvoice($courierId: ID!, $invoiceId: ID!) {
  syncInvoice(courierId: $courierId, invoiceId: $invoiceId) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type SyncInvoiceMutationFn = Apollo.MutationFunction<SyncInvoiceMutation, SyncInvoiceMutationVariables>;

/**
 * __useSyncInvoiceMutation__
 *
 * To run a mutation, you first call `useSyncInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncInvoiceMutation, { data, loading, error }] = useSyncInvoiceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useSyncInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<SyncInvoiceMutation, SyncInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncInvoiceMutation, SyncInvoiceMutationVariables>(SyncInvoiceDocument, options);
      }
export type SyncInvoiceMutationHookResult = ReturnType<typeof useSyncInvoiceMutation>;
export type SyncInvoiceMutationResult = Apollo.MutationResult<SyncInvoiceMutation>;
export type SyncInvoiceMutationOptions = Apollo.BaseMutationOptions<SyncInvoiceMutation, SyncInvoiceMutationVariables>;
export const ApproveInvoicesDocument = gql`
    mutation approveInvoices($courierId: ID!, $invoiceIds: [ID!]!) {
  approveInvoices(courierId: $courierId, invoiceIds: $invoiceIds) {
    approved {
      ...InvoiceFragment
    }
    failures {
      invoiceId
      message
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type ApproveInvoicesMutationFn = Apollo.MutationFunction<ApproveInvoicesMutation, ApproveInvoicesMutationVariables>;

/**
 * __useApproveInvoicesMutation__
 *
 * To run a mutation, you first call `useApproveInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInvoicesMutation, { data, loading, error }] = useApproveInvoicesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useApproveInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ApproveInvoicesMutation, ApproveInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveInvoicesMutation, ApproveInvoicesMutationVariables>(ApproveInvoicesDocument, options);
      }
export type ApproveInvoicesMutationHookResult = ReturnType<typeof useApproveInvoicesMutation>;
export type ApproveInvoicesMutationResult = Apollo.MutationResult<ApproveInvoicesMutation>;
export type ApproveInvoicesMutationOptions = Apollo.BaseMutationOptions<ApproveInvoicesMutation, ApproveInvoicesMutationVariables>;
export const ForceGenerateInvoicesDocument = gql`
    mutation ForceGenerateInvoices($courierId: String!, $startDate: Date!, $endDate: Date!, $endCustomerIdsFilter: [String], $invoiceFrequency: InvoicingFrequency, $endCustomerLabelFilter: String) {
  forceGenerateInvoices(
    courierId: $courierId
    startDate: $startDate
    endDate: $endDate
    endCustomerIdsFilter: $endCustomerIdsFilter
    invoiceFrequency: $invoiceFrequency
    endCustomerLabelFilter: $endCustomerLabelFilter
  ) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type ForceGenerateInvoicesMutationFn = Apollo.MutationFunction<ForceGenerateInvoicesMutation, ForceGenerateInvoicesMutationVariables>;

/**
 * __useForceGenerateInvoicesMutation__
 *
 * To run a mutation, you first call `useForceGenerateInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceGenerateInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceGenerateInvoicesMutation, { data, loading, error }] = useForceGenerateInvoicesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      invoiceFrequency: // value for 'invoiceFrequency'
 *      endCustomerLabelFilter: // value for 'endCustomerLabelFilter'
 *   },
 * });
 */
export function useForceGenerateInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ForceGenerateInvoicesMutation, ForceGenerateInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceGenerateInvoicesMutation, ForceGenerateInvoicesMutationVariables>(ForceGenerateInvoicesDocument, options);
      }
export type ForceGenerateInvoicesMutationHookResult = ReturnType<typeof useForceGenerateInvoicesMutation>;
export type ForceGenerateInvoicesMutationResult = Apollo.MutationResult<ForceGenerateInvoicesMutation>;
export type ForceGenerateInvoicesMutationOptions = Apollo.BaseMutationOptions<ForceGenerateInvoicesMutation, ForceGenerateInvoicesMutationVariables>;
export const VoidInvoicesDocument = gql`
    mutation voidInvoices($courierId: ID!, $invoiceIds: [ID!]!) {
  voidInvoices(courierId: $courierId, invoiceIds: $invoiceIds) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type VoidInvoicesMutationFn = Apollo.MutationFunction<VoidInvoicesMutation, VoidInvoicesMutationVariables>;

/**
 * __useVoidInvoicesMutation__
 *
 * To run a mutation, you first call `useVoidInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidInvoicesMutation, { data, loading, error }] = useVoidInvoicesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useVoidInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<VoidInvoicesMutation, VoidInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidInvoicesMutation, VoidInvoicesMutationVariables>(VoidInvoicesDocument, options);
      }
export type VoidInvoicesMutationHookResult = ReturnType<typeof useVoidInvoicesMutation>;
export type VoidInvoicesMutationResult = Apollo.MutationResult<VoidInvoicesMutation>;
export type VoidInvoicesMutationOptions = Apollo.BaseMutationOptions<VoidInvoicesMutation, VoidInvoicesMutationVariables>;
export const GenerateCsvForInvoicesDocument = gql`
    mutation generateCsvForInvoices($courierId: String!, $invoiceIds: [ID!]!) {
  generateCsvForInvoices(courierId: $courierId, invoiceIds: $invoiceIds)
}
    `;
export type GenerateCsvForInvoicesMutationFn = Apollo.MutationFunction<GenerateCsvForInvoicesMutation, GenerateCsvForInvoicesMutationVariables>;

/**
 * __useGenerateCsvForInvoicesMutation__
 *
 * To run a mutation, you first call `useGenerateCsvForInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCsvForInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCsvForInvoicesMutation, { data, loading, error }] = useGenerateCsvForInvoicesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useGenerateCsvForInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCsvForInvoicesMutation, GenerateCsvForInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCsvForInvoicesMutation, GenerateCsvForInvoicesMutationVariables>(GenerateCsvForInvoicesDocument, options);
      }
export type GenerateCsvForInvoicesMutationHookResult = ReturnType<typeof useGenerateCsvForInvoicesMutation>;
export type GenerateCsvForInvoicesMutationResult = Apollo.MutationResult<GenerateCsvForInvoicesMutation>;
export type GenerateCsvForInvoicesMutationOptions = Apollo.BaseMutationOptions<GenerateCsvForInvoicesMutation, GenerateCsvForInvoicesMutationVariables>;
export const GenerateAccountStatementCsvDocument = gql`
    mutation GenerateAccountStatementCsv($courierId: String!, $endCustomerId: ID!) {
  generateAccountStatementCsv(
    courierId: $courierId
    endCustomerId: $endCustomerId
  )
}
    `;
export type GenerateAccountStatementCsvMutationFn = Apollo.MutationFunction<GenerateAccountStatementCsvMutation, GenerateAccountStatementCsvMutationVariables>;

/**
 * __useGenerateAccountStatementCsvMutation__
 *
 * To run a mutation, you first call `useGenerateAccountStatementCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAccountStatementCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAccountStatementCsvMutation, { data, loading, error }] = useGenerateAccountStatementCsvMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useGenerateAccountStatementCsvMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAccountStatementCsvMutation, GenerateAccountStatementCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAccountStatementCsvMutation, GenerateAccountStatementCsvMutationVariables>(GenerateAccountStatementCsvDocument, options);
      }
export type GenerateAccountStatementCsvMutationHookResult = ReturnType<typeof useGenerateAccountStatementCsvMutation>;
export type GenerateAccountStatementCsvMutationResult = Apollo.MutationResult<GenerateAccountStatementCsvMutation>;
export type GenerateAccountStatementCsvMutationOptions = Apollo.BaseMutationOptions<GenerateAccountStatementCsvMutation, GenerateAccountStatementCsvMutationVariables>;
export const MarkInvoiceAsPaidManuallyDocument = gql`
    mutation markInvoiceAsPaidManually($courierId: ID!, $invoiceIds: [ID!]!, $markedBy: String!) {
  markInvoiceAsPaidManually(
    courierId: $courierId
    invoiceIds: $invoiceIds
    markedBy: $markedBy
  ) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type MarkInvoiceAsPaidManuallyMutationFn = Apollo.MutationFunction<MarkInvoiceAsPaidManuallyMutation, MarkInvoiceAsPaidManuallyMutationVariables>;

/**
 * __useMarkInvoiceAsPaidManuallyMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsPaidManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsPaidManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsPaidManuallyMutation, { data, loading, error }] = useMarkInvoiceAsPaidManuallyMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *      markedBy: // value for 'markedBy'
 *   },
 * });
 */
export function useMarkInvoiceAsPaidManuallyMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsPaidManuallyMutation, MarkInvoiceAsPaidManuallyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsPaidManuallyMutation, MarkInvoiceAsPaidManuallyMutationVariables>(MarkInvoiceAsPaidManuallyDocument, options);
      }
export type MarkInvoiceAsPaidManuallyMutationHookResult = ReturnType<typeof useMarkInvoiceAsPaidManuallyMutation>;
export type MarkInvoiceAsPaidManuallyMutationResult = Apollo.MutationResult<MarkInvoiceAsPaidManuallyMutation>;
export type MarkInvoiceAsPaidManuallyMutationOptions = Apollo.BaseMutationOptions<MarkInvoiceAsPaidManuallyMutation, MarkInvoiceAsPaidManuallyMutationVariables>;
export const GeneratePdfForInvoiceDocument = gql`
    mutation generatePdfForInvoice($courierId: String!, $invoiceId: ID!) {
  generatePdfForInvoice(courierId: $courierId, invoiceId: $invoiceId) {
    ...InvoiceDocumentFragment
  }
}
    ${InvoiceDocumentFragmentFragmentDoc}`;
export type GeneratePdfForInvoiceMutationFn = Apollo.MutationFunction<GeneratePdfForInvoiceMutation, GeneratePdfForInvoiceMutationVariables>;

/**
 * __useGeneratePdfForInvoiceMutation__
 *
 * To run a mutation, you first call `useGeneratePdfForInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePdfForInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePdfForInvoiceMutation, { data, loading, error }] = useGeneratePdfForInvoiceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGeneratePdfForInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePdfForInvoiceMutation, GeneratePdfForInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePdfForInvoiceMutation, GeneratePdfForInvoiceMutationVariables>(GeneratePdfForInvoiceDocument, options);
      }
export type GeneratePdfForInvoiceMutationHookResult = ReturnType<typeof useGeneratePdfForInvoiceMutation>;
export type GeneratePdfForInvoiceMutationResult = Apollo.MutationResult<GeneratePdfForInvoiceMutation>;
export type GeneratePdfForInvoiceMutationOptions = Apollo.BaseMutationOptions<GeneratePdfForInvoiceMutation, GeneratePdfForInvoiceMutationVariables>;
export const GeneratePdfForInvoicesDocument = gql`
    mutation generatePdfForInvoices($courierId: String!, $invoiceIds: [ID!]!) {
  generatePdfForInvoices(courierId: $courierId, invoiceIds: $invoiceIds) {
    ...InvoiceDocumentFragment
  }
}
    ${InvoiceDocumentFragmentFragmentDoc}`;
export type GeneratePdfForInvoicesMutationFn = Apollo.MutationFunction<GeneratePdfForInvoicesMutation, GeneratePdfForInvoicesMutationVariables>;

/**
 * __useGeneratePdfForInvoicesMutation__
 *
 * To run a mutation, you first call `useGeneratePdfForInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePdfForInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePdfForInvoicesMutation, { data, loading, error }] = useGeneratePdfForInvoicesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useGeneratePdfForInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePdfForInvoicesMutation, GeneratePdfForInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePdfForInvoicesMutation, GeneratePdfForInvoicesMutationVariables>(GeneratePdfForInvoicesDocument, options);
      }
export type GeneratePdfForInvoicesMutationHookResult = ReturnType<typeof useGeneratePdfForInvoicesMutation>;
export type GeneratePdfForInvoicesMutationResult = Apollo.MutationResult<GeneratePdfForInvoicesMutation>;
export type GeneratePdfForInvoicesMutationOptions = Apollo.BaseMutationOptions<GeneratePdfForInvoicesMutation, GeneratePdfForInvoicesMutationVariables>;
export const PreviewInvoicePdfFromCreateDocument = gql`
    mutation previewInvoicePdfFromCreate($courierId: ID!, $template: InvoicePdfTemplateCreateInput!) {
  previewInvoicePdfFromCreate(courierId: $courierId, template: $template) {
    ...InvoiceDocumentFragment
  }
}
    ${InvoiceDocumentFragmentFragmentDoc}`;
export type PreviewInvoicePdfFromCreateMutationFn = Apollo.MutationFunction<PreviewInvoicePdfFromCreateMutation, PreviewInvoicePdfFromCreateMutationVariables>;

/**
 * __usePreviewInvoicePdfFromCreateMutation__
 *
 * To run a mutation, you first call `usePreviewInvoicePdfFromCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewInvoicePdfFromCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewInvoicePdfFromCreateMutation, { data, loading, error }] = usePreviewInvoicePdfFromCreateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      template: // value for 'template'
 *   },
 * });
 */
export function usePreviewInvoicePdfFromCreateMutation(baseOptions?: Apollo.MutationHookOptions<PreviewInvoicePdfFromCreateMutation, PreviewInvoicePdfFromCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewInvoicePdfFromCreateMutation, PreviewInvoicePdfFromCreateMutationVariables>(PreviewInvoicePdfFromCreateDocument, options);
      }
export type PreviewInvoicePdfFromCreateMutationHookResult = ReturnType<typeof usePreviewInvoicePdfFromCreateMutation>;
export type PreviewInvoicePdfFromCreateMutationResult = Apollo.MutationResult<PreviewInvoicePdfFromCreateMutation>;
export type PreviewInvoicePdfFromCreateMutationOptions = Apollo.BaseMutationOptions<PreviewInvoicePdfFromCreateMutation, PreviewInvoicePdfFromCreateMutationVariables>;
export const PreviewInvoicePdfFromUpdateDocument = gql`
    mutation previewInvoicePdfFromUpdate($courierId: ID!, $template: InvoicePdfTemplateUpdateInput!) {
  previewInvoicePdfFromUpdate(courierId: $courierId, template: $template) {
    ...InvoiceDocumentFragment
  }
}
    ${InvoiceDocumentFragmentFragmentDoc}`;
export type PreviewInvoicePdfFromUpdateMutationFn = Apollo.MutationFunction<PreviewInvoicePdfFromUpdateMutation, PreviewInvoicePdfFromUpdateMutationVariables>;

/**
 * __usePreviewInvoicePdfFromUpdateMutation__
 *
 * To run a mutation, you first call `usePreviewInvoicePdfFromUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewInvoicePdfFromUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewInvoicePdfFromUpdateMutation, { data, loading, error }] = usePreviewInvoicePdfFromUpdateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      template: // value for 'template'
 *   },
 * });
 */
export function usePreviewInvoicePdfFromUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PreviewInvoicePdfFromUpdateMutation, PreviewInvoicePdfFromUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewInvoicePdfFromUpdateMutation, PreviewInvoicePdfFromUpdateMutationVariables>(PreviewInvoicePdfFromUpdateDocument, options);
      }
export type PreviewInvoicePdfFromUpdateMutationHookResult = ReturnType<typeof usePreviewInvoicePdfFromUpdateMutation>;
export type PreviewInvoicePdfFromUpdateMutationResult = Apollo.MutationResult<PreviewInvoicePdfFromUpdateMutation>;
export type PreviewInvoicePdfFromUpdateMutationOptions = Apollo.BaseMutationOptions<PreviewInvoicePdfFromUpdateMutation, PreviewInvoicePdfFromUpdateMutationVariables>;
export const CreateInvoicePdfTemplateDocument = gql`
    mutation createInvoicePdfTemplate($courierId: ID!, $input: InvoicePdfTemplateCreateInput!, $updatedBy: String!) {
  createInvoicePdfTemplate(
    courierId: $courierId
    input: $input
    updatedBy: $updatedBy
  ) {
    ...InvoicePdfTemplateFragment
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}`;
export type CreateInvoicePdfTemplateMutationFn = Apollo.MutationFunction<CreateInvoicePdfTemplateMutation, CreateInvoicePdfTemplateMutationVariables>;

/**
 * __useCreateInvoicePdfTemplateMutation__
 *
 * To run a mutation, you first call `useCreateInvoicePdfTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoicePdfTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoicePdfTemplateMutation, { data, loading, error }] = useCreateInvoicePdfTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useCreateInvoicePdfTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoicePdfTemplateMutation, CreateInvoicePdfTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoicePdfTemplateMutation, CreateInvoicePdfTemplateMutationVariables>(CreateInvoicePdfTemplateDocument, options);
      }
export type CreateInvoicePdfTemplateMutationHookResult = ReturnType<typeof useCreateInvoicePdfTemplateMutation>;
export type CreateInvoicePdfTemplateMutationResult = Apollo.MutationResult<CreateInvoicePdfTemplateMutation>;
export type CreateInvoicePdfTemplateMutationOptions = Apollo.BaseMutationOptions<CreateInvoicePdfTemplateMutation, CreateInvoicePdfTemplateMutationVariables>;
export const FullUpdateInvoicePdfTemplateDocument = gql`
    mutation fullUpdateInvoicePdfTemplate($courierId: ID!, $input: InvoicePdfTemplateUpdateInput!, $updatedBy: String!) {
  fullUpdateInvoicePdfTemplate(
    courierId: $courierId
    input: $input
    updatedBy: $updatedBy
  ) {
    ...InvoicePdfTemplateFragment
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}`;
export type FullUpdateInvoicePdfTemplateMutationFn = Apollo.MutationFunction<FullUpdateInvoicePdfTemplateMutation, FullUpdateInvoicePdfTemplateMutationVariables>;

/**
 * __useFullUpdateInvoicePdfTemplateMutation__
 *
 * To run a mutation, you first call `useFullUpdateInvoicePdfTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateInvoicePdfTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateInvoicePdfTemplateMutation, { data, loading, error }] = useFullUpdateInvoicePdfTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useFullUpdateInvoicePdfTemplateMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateInvoicePdfTemplateMutation, FullUpdateInvoicePdfTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateInvoicePdfTemplateMutation, FullUpdateInvoicePdfTemplateMutationVariables>(FullUpdateInvoicePdfTemplateDocument, options);
      }
export type FullUpdateInvoicePdfTemplateMutationHookResult = ReturnType<typeof useFullUpdateInvoicePdfTemplateMutation>;
export type FullUpdateInvoicePdfTemplateMutationResult = Apollo.MutationResult<FullUpdateInvoicePdfTemplateMutation>;
export type FullUpdateInvoicePdfTemplateMutationOptions = Apollo.BaseMutationOptions<FullUpdateInvoicePdfTemplateMutation, FullUpdateInvoicePdfTemplateMutationVariables>;
export const DeleteInvoicePdfTemplateDocument = gql`
    mutation deleteInvoicePdfTemplate($courierId: ID!, $invoicePdfTemplateId: ID!, $deletedBy: String!) {
  deleteInvoicePdfTemplate(
    courierId: $courierId
    invoicePdfTemplateId: $invoicePdfTemplateId
    deletedBy: $deletedBy
  )
}
    `;
export type DeleteInvoicePdfTemplateMutationFn = Apollo.MutationFunction<DeleteInvoicePdfTemplateMutation, DeleteInvoicePdfTemplateMutationVariables>;

/**
 * __useDeleteInvoicePdfTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteInvoicePdfTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoicePdfTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoicePdfTemplateMutation, { data, loading, error }] = useDeleteInvoicePdfTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoicePdfTemplateId: // value for 'invoicePdfTemplateId'
 *      deletedBy: // value for 'deletedBy'
 *   },
 * });
 */
export function useDeleteInvoicePdfTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoicePdfTemplateMutation, DeleteInvoicePdfTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoicePdfTemplateMutation, DeleteInvoicePdfTemplateMutationVariables>(DeleteInvoicePdfTemplateDocument, options);
      }
export type DeleteInvoicePdfTemplateMutationHookResult = ReturnType<typeof useDeleteInvoicePdfTemplateMutation>;
export type DeleteInvoicePdfTemplateMutationResult = Apollo.MutationResult<DeleteInvoicePdfTemplateMutation>;
export type DeleteInvoicePdfTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteInvoicePdfTemplateMutation, DeleteInvoicePdfTemplateMutationVariables>;
export const MarkInvoicePdfTemplateAsDefaultDocument = gql`
    mutation markInvoicePdfTemplateAsDefault($courierId: ID!, $invoicePdfTemplateId: ID!, $updatedBy: String!) {
  markInvoicePdfTemplateAsDefault(
    courierId: $courierId
    invoicePdfTemplateId: $invoicePdfTemplateId
    updatedBy: $updatedBy
  ) {
    ...InvoicePdfTemplateFragment
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}`;
export type MarkInvoicePdfTemplateAsDefaultMutationFn = Apollo.MutationFunction<MarkInvoicePdfTemplateAsDefaultMutation, MarkInvoicePdfTemplateAsDefaultMutationVariables>;

/**
 * __useMarkInvoicePdfTemplateAsDefaultMutation__
 *
 * To run a mutation, you first call `useMarkInvoicePdfTemplateAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoicePdfTemplateAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoicePdfTemplateAsDefaultMutation, { data, loading, error }] = useMarkInvoicePdfTemplateAsDefaultMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoicePdfTemplateId: // value for 'invoicePdfTemplateId'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useMarkInvoicePdfTemplateAsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoicePdfTemplateAsDefaultMutation, MarkInvoicePdfTemplateAsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoicePdfTemplateAsDefaultMutation, MarkInvoicePdfTemplateAsDefaultMutationVariables>(MarkInvoicePdfTemplateAsDefaultDocument, options);
      }
export type MarkInvoicePdfTemplateAsDefaultMutationHookResult = ReturnType<typeof useMarkInvoicePdfTemplateAsDefaultMutation>;
export type MarkInvoicePdfTemplateAsDefaultMutationResult = Apollo.MutationResult<MarkInvoicePdfTemplateAsDefaultMutation>;
export type MarkInvoicePdfTemplateAsDefaultMutationOptions = Apollo.BaseMutationOptions<MarkInvoicePdfTemplateAsDefaultMutation, MarkInvoicePdfTemplateAsDefaultMutationVariables>;
export const GetInvoicesPaginatedDocument = gql`
    query GetInvoicesPaginated($courierId: String!, $endCustomerIds: [String], $costCenterIds: [String], $minEndDate: Date, $maxEndDate: Date, $minApprovedAt: Timestamp, $maxApprovedAt: Timestamp, $invoicingFrequency: [InvoicingFrequency], $statuses: [InvoiceStatus], $limit: Int, $after: Int, $sortFields: [InvoiceSorting!], $paymentStatuses: [InvoicePaymentStatus], $endCustomerLabelIds: [ID!], $trackingNumbers: [String!], $referenceNumbers: [String!], $displayIds: [Int!], $refunded: Boolean) {
  invoicesPaginated(
    courierId: $courierId
    endCustomerIds: $endCustomerIds
    costCenterIds: $costCenterIds
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    minApprovedAt: $minApprovedAt
    maxApprovedAt: $maxApprovedAt
    invoicingFrequency: $invoicingFrequency
    statuses: $statuses
    paymentStatuses: $paymentStatuses
    limit: $limit
    after: $after
    sortFields: $sortFields
    endCustomerLabelIds: $endCustomerLabelIds
    trackingNumbers: $trackingNumbers
    referenceNumbers: $referenceNumbers
    displayIds: $displayIds
    refunded: $refunded
  ) {
    edges {
      node {
        ...InvoiceFragment
        remoteEntities {
          ...RemoteEntityFragment
        }
        endCustomer {
          ...EndCustomerFragment
          assignedLabels {
            ...LabelFragment
          }
        }
        costCenter {
          ...CostCenterFragment
        }
        communications {
          ...EndCustomerCommunicationFragment
          email {
            status
            statusReason
          }
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${LabelFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${EndCustomerCommunicationFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetInvoicesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetInvoicesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *      costCenterIds: // value for 'costCenterIds'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      minApprovedAt: // value for 'minApprovedAt'
 *      maxApprovedAt: // value for 'maxApprovedAt'
 *      invoicingFrequency: // value for 'invoicingFrequency'
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *      paymentStatuses: // value for 'paymentStatuses'
 *      endCustomerLabelIds: // value for 'endCustomerLabelIds'
 *      trackingNumbers: // value for 'trackingNumbers'
 *      referenceNumbers: // value for 'referenceNumbers'
 *      displayIds: // value for 'displayIds'
 *      refunded: // value for 'refunded'
 *   },
 * });
 */
export function useGetInvoicesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>(GetInvoicesPaginatedDocument, options);
      }
export function useGetInvoicesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>(GetInvoicesPaginatedDocument, options);
        }
export type GetInvoicesPaginatedQueryHookResult = ReturnType<typeof useGetInvoicesPaginatedQuery>;
export type GetInvoicesPaginatedLazyQueryHookResult = ReturnType<typeof useGetInvoicesPaginatedLazyQuery>;
export type GetInvoicesPaginatedQueryResult = Apollo.QueryResult<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>;
export const GetInvoiceExtendedDetailDocument = gql`
    query GetInvoiceExtendedDetail($courierId: ID!, $invoiceId: ID!) {
  invoiceExtendedDetail(courierId: $courierId, invoiceId: $invoiceId) {
    amountTotal
    invoice {
      ...InvoiceFragment
      remoteEntities {
        ...RemoteEntityFragment
      }
      endCustomer {
        ...EndCustomerFragment
      }
      costCenter {
        ...CostCenterFragment
      }
    }
    shipments {
      ...ShipmentFragment
      artifacts {
        ...ArtifactFragment
      }
      order {
        ...OrderFragment
        endCustomer {
          ...EndCustomerFragment
        }
        price {
          ...OrderPriceFragment
        }
      }
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${OrderPriceFragmentFragmentDoc}`;

/**
 * __useGetInvoiceExtendedDetailQuery__
 *
 * To run a query within a React component, call `useGetInvoiceExtendedDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceExtendedDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceExtendedDetailQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceExtendedDetailQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>(GetInvoiceExtendedDetailDocument, options);
      }
export function useGetInvoiceExtendedDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>(GetInvoiceExtendedDetailDocument, options);
        }
export type GetInvoiceExtendedDetailQueryHookResult = ReturnType<typeof useGetInvoiceExtendedDetailQuery>;
export type GetInvoiceExtendedDetailLazyQueryHookResult = ReturnType<typeof useGetInvoiceExtendedDetailLazyQuery>;
export type GetInvoiceExtendedDetailQueryResult = Apollo.QueryResult<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>;
export const InvoicesOverviewDocument = gql`
    query InvoicesOverview($courierId: String!) {
  invoicesOverview(courierId: $courierId) {
    numToReview
    numUnpaid
    numPaymentProcessing
    numPartialPaid
    numRefunded
  }
}
    `;

/**
 * __useInvoicesOverviewQuery__
 *
 * To run a query within a React component, call `useInvoicesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesOverviewQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useInvoicesOverviewQuery(baseOptions: Apollo.QueryHookOptions<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>(InvoicesOverviewDocument, options);
      }
export function useInvoicesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>(InvoicesOverviewDocument, options);
        }
export type InvoicesOverviewQueryHookResult = ReturnType<typeof useInvoicesOverviewQuery>;
export type InvoicesOverviewLazyQueryHookResult = ReturnType<typeof useInvoicesOverviewLazyQuery>;
export type InvoicesOverviewQueryResult = Apollo.QueryResult<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>;
export const GetInvoicePdfTemplatesPaginatedDocument = gql`
    query GetInvoicePdfTemplatesPaginated($courierId: String!, $limit: Int, $after: Int) {
  invoicePdfTemplatesPaginated(
    courierId: $courierId
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...InvoicePdfTemplateFragment
        subtotalGroupedByCustomField {
          ...CustomFieldFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetInvoicePdfTemplatesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetInvoicePdfTemplatesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfTemplatesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfTemplatesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInvoicePdfTemplatesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>(GetInvoicePdfTemplatesPaginatedDocument, options);
      }
export function useGetInvoicePdfTemplatesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>(GetInvoicePdfTemplatesPaginatedDocument, options);
        }
export type GetInvoicePdfTemplatesPaginatedQueryHookResult = ReturnType<typeof useGetInvoicePdfTemplatesPaginatedQuery>;
export type GetInvoicePdfTemplatesPaginatedLazyQueryHookResult = ReturnType<typeof useGetInvoicePdfTemplatesPaginatedLazyQuery>;
export type GetInvoicePdfTemplatesPaginatedQueryResult = Apollo.QueryResult<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>;
export const GetInvoicePdfTemplateSkeletonDocument = gql`
    query GetInvoicePdfTemplateSkeleton($courierId: String!) {
  getInvoicePdfTemplateSkeleton(courierId: $courierId) {
    ...InvoicePdfTemplateFragment
    subtotalGroupedByCustomField {
      ...CustomFieldFragment
    }
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}`;

/**
 * __useGetInvoicePdfTemplateSkeletonQuery__
 *
 * To run a query within a React component, call `useGetInvoicePdfTemplateSkeletonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfTemplateSkeletonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfTemplateSkeletonQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetInvoicePdfTemplateSkeletonQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>(GetInvoicePdfTemplateSkeletonDocument, options);
      }
export function useGetInvoicePdfTemplateSkeletonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>(GetInvoicePdfTemplateSkeletonDocument, options);
        }
export type GetInvoicePdfTemplateSkeletonQueryHookResult = ReturnType<typeof useGetInvoicePdfTemplateSkeletonQuery>;
export type GetInvoicePdfTemplateSkeletonLazyQueryHookResult = ReturnType<typeof useGetInvoicePdfTemplateSkeletonLazyQuery>;
export type GetInvoicePdfTemplateSkeletonQueryResult = Apollo.QueryResult<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>;
export const InitiateInvoicePaymentDocument = gql`
    mutation InitiateInvoicePayment($courierId: ID!, $invoiceId: ID!, $paymentInstrumentId: ID!, $amount: Money!, $idempotencyToken: String!, $fraudSessionId: String, $createdBy: String!, $emailRecipients: [String!]!) {
  initiateInvoicePayment(
    courierId: $courierId
    invoiceId: $invoiceId
    paymentInstrumentId: $paymentInstrumentId
    amount: $amount
    idempotencyToken: $idempotencyToken
    fraudSessionId: $fraudSessionId
    createdBy: $createdBy
    emailRecipients: $emailRecipients
  ) {
    id
    courierId
    invoiceId
    paymentTransferId
    allocatedAmount
    invoice {
      ...InvoiceFragment
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InitiateInvoicePaymentMutationFn = Apollo.MutationFunction<InitiateInvoicePaymentMutation, InitiateInvoicePaymentMutationVariables>;

/**
 * __useInitiateInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useInitiateInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateInvoicePaymentMutation, { data, loading, error }] = useInitiateInvoicePaymentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceId: // value for 'invoiceId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      amount: // value for 'amount'
 *      idempotencyToken: // value for 'idempotencyToken'
 *      fraudSessionId: // value for 'fraudSessionId'
 *      createdBy: // value for 'createdBy'
 *      emailRecipients: // value for 'emailRecipients'
 *   },
 * });
 */
export function useInitiateInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiateInvoicePaymentMutation, InitiateInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateInvoicePaymentMutation, InitiateInvoicePaymentMutationVariables>(InitiateInvoicePaymentDocument, options);
      }
export type InitiateInvoicePaymentMutationHookResult = ReturnType<typeof useInitiateInvoicePaymentMutation>;
export type InitiateInvoicePaymentMutationResult = Apollo.MutationResult<InitiateInvoicePaymentMutation>;
export type InitiateInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<InitiateInvoicePaymentMutation, InitiateInvoicePaymentMutationVariables>;
export const InitiateInvoicePaymentsDocument = gql`
    mutation InitiateInvoicePayments($courierId: ID!, $invoiceIds: [ID!]!, $createdBy: String!, $baseIdempotencyToken: String!) {
  initiateInvoicePayments(
    courierId: $courierId
    invoiceIds: $invoiceIds
    createdBy: $createdBy
    baseIdempotencyToken: $baseIdempotencyToken
  ) {
    processedPayments {
      id
      courierId
      invoiceId
      paymentTransferId
      allocatedAmount
      invoice {
        ...InvoiceFragment
      }
    }
    errors
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InitiateInvoicePaymentsMutationFn = Apollo.MutationFunction<InitiateInvoicePaymentsMutation, InitiateInvoicePaymentsMutationVariables>;

/**
 * __useInitiateInvoicePaymentsMutation__
 *
 * To run a mutation, you first call `useInitiateInvoicePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateInvoicePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateInvoicePaymentsMutation, { data, loading, error }] = useInitiateInvoicePaymentsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *      createdBy: // value for 'createdBy'
 *      baseIdempotencyToken: // value for 'baseIdempotencyToken'
 *   },
 * });
 */
export function useInitiateInvoicePaymentsMutation(baseOptions?: Apollo.MutationHookOptions<InitiateInvoicePaymentsMutation, InitiateInvoicePaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateInvoicePaymentsMutation, InitiateInvoicePaymentsMutationVariables>(InitiateInvoicePaymentsDocument, options);
      }
export type InitiateInvoicePaymentsMutationHookResult = ReturnType<typeof useInitiateInvoicePaymentsMutation>;
export type InitiateInvoicePaymentsMutationResult = Apollo.MutationResult<InitiateInvoicePaymentsMutation>;
export type InitiateInvoicePaymentsMutationOptions = Apollo.BaseMutationOptions<InitiateInvoicePaymentsMutation, InitiateInvoicePaymentsMutationVariables>;
export const CreateMultiInvoiceManualPaymentDocument = gql`
    mutation CreateMultiInvoiceManualPayment($courierId: ID!, $allocations: [InvoiceManualBulkPaymentAllocationInput!]!, $paidOn: Date!, $note: String, $createdBy: String!) {
  createMultiInvoiceManualPayment(
    courierId: $courierId
    allocations: $allocations
    paidOn: $paidOn
    note: $note
    createdBy: $createdBy
  ) {
    id
    courierId
    paidOn
    amount
  }
}
    `;
export type CreateMultiInvoiceManualPaymentMutationFn = Apollo.MutationFunction<CreateMultiInvoiceManualPaymentMutation, CreateMultiInvoiceManualPaymentMutationVariables>;

/**
 * __useCreateMultiInvoiceManualPaymentMutation__
 *
 * To run a mutation, you first call `useCreateMultiInvoiceManualPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiInvoiceManualPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiInvoiceManualPaymentMutation, { data, loading, error }] = useCreateMultiInvoiceManualPaymentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      allocations: // value for 'allocations'
 *      paidOn: // value for 'paidOn'
 *      note: // value for 'note'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreateMultiInvoiceManualPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiInvoiceManualPaymentMutation, CreateMultiInvoiceManualPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiInvoiceManualPaymentMutation, CreateMultiInvoiceManualPaymentMutationVariables>(CreateMultiInvoiceManualPaymentDocument, options);
      }
export type CreateMultiInvoiceManualPaymentMutationHookResult = ReturnType<typeof useCreateMultiInvoiceManualPaymentMutation>;
export type CreateMultiInvoiceManualPaymentMutationResult = Apollo.MutationResult<CreateMultiInvoiceManualPaymentMutation>;
export type CreateMultiInvoiceManualPaymentMutationOptions = Apollo.BaseMutationOptions<CreateMultiInvoiceManualPaymentMutation, CreateMultiInvoiceManualPaymentMutationVariables>;
export const CreateInvoiceManualPaymentDocument = gql`
    mutation CreateInvoiceManualPayment($courierId: ID!, $invoiceId: ID!, $amount: Money!, $paidOn: Date!, $note: String, $createdBy: String!) {
  createInvoiceManualPayment(
    courierId: $courierId
    invoiceId: $invoiceId
    amount: $amount
    paidOn: $paidOn
    note: $note
    createdBy: $createdBy
  ) {
    id
    courierId
    invoiceId
    amount
    paidOn
    note
  }
}
    `;
export type CreateInvoiceManualPaymentMutationFn = Apollo.MutationFunction<CreateInvoiceManualPaymentMutation, CreateInvoiceManualPaymentMutationVariables>;

/**
 * __useCreateInvoiceManualPaymentMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceManualPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceManualPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceManualPaymentMutation, { data, loading, error }] = useCreateInvoiceManualPaymentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceId: // value for 'invoiceId'
 *      amount: // value for 'amount'
 *      paidOn: // value for 'paidOn'
 *      note: // value for 'note'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreateInvoiceManualPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceManualPaymentMutation, CreateInvoiceManualPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceManualPaymentMutation, CreateInvoiceManualPaymentMutationVariables>(CreateInvoiceManualPaymentDocument, options);
      }
export type CreateInvoiceManualPaymentMutationHookResult = ReturnType<typeof useCreateInvoiceManualPaymentMutation>;
export type CreateInvoiceManualPaymentMutationResult = Apollo.MutationResult<CreateInvoiceManualPaymentMutation>;
export type CreateInvoiceManualPaymentMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceManualPaymentMutation, CreateInvoiceManualPaymentMutationVariables>;
export const InvoiceBalancesDocument = gql`
    query InvoiceBalances($courierId: ID!, $invoiceIds: [ID!]!) {
  invoiceBalances(courierId: $courierId, invoiceIds: $invoiceIds) {
    invoiceId
    remainingBalance
    transfers {
      ...PaymentTransferFragment
      sourcePaymentInstrument {
        ...PaymentInstrumentFragment
      }
    }
    manualPaymentsForInvoice {
      ...InvoiceManualPaymentFragment
    }
  }
}
    ${PaymentTransferFragmentFragmentDoc}
${PaymentInstrumentFragmentFragmentDoc}
${InvoiceManualPaymentFragmentFragmentDoc}`;

/**
 * __useInvoiceBalancesQuery__
 *
 * To run a query within a React component, call `useInvoiceBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceBalancesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useInvoiceBalancesQuery(baseOptions: Apollo.QueryHookOptions<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>(InvoiceBalancesDocument, options);
      }
export function useInvoiceBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>(InvoiceBalancesDocument, options);
        }
export type InvoiceBalancesQueryHookResult = ReturnType<typeof useInvoiceBalancesQuery>;
export type InvoiceBalancesLazyQueryHookResult = ReturnType<typeof useInvoiceBalancesLazyQuery>;
export type InvoiceBalancesQueryResult = Apollo.QueryResult<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>;
export const CreateLabelDocument = gql`
    mutation CreateLabel($courierId: ID!, $entityType: LabelEntityType!, $name: String!) {
  createLabel(courierId: $courierId, entityType: $entityType, name: $name) {
    ...LabelFragment
  }
}
    ${LabelFragmentFragmentDoc}`;
export type CreateLabelMutationFn = Apollo.MutationFunction<CreateLabelMutation, CreateLabelMutationVariables>;

/**
 * __useCreateLabelMutation__
 *
 * To run a mutation, you first call `useCreateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabelMutation, { data, loading, error }] = useCreateLabelMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      entityType: // value for 'entityType'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabelMutation, CreateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabelMutation, CreateLabelMutationVariables>(CreateLabelDocument, options);
      }
export type CreateLabelMutationHookResult = ReturnType<typeof useCreateLabelMutation>;
export type CreateLabelMutationResult = Apollo.MutationResult<CreateLabelMutation>;
export type CreateLabelMutationOptions = Apollo.BaseMutationOptions<CreateLabelMutation, CreateLabelMutationVariables>;
export const AssignLabelsToEntitiesDocument = gql`
    mutation AssignLabelsToEntities($courierId: ID!, $entityType: LabelEntityType!, $labelIds: [ID!]!, $entityIds: [ID!]!) {
  assignLabelsToEntities(
    courierId: $courierId
    entityType: $entityType
    labelIds: $labelIds
    entityIds: $entityIds
  )
}
    `;
export type AssignLabelsToEntitiesMutationFn = Apollo.MutationFunction<AssignLabelsToEntitiesMutation, AssignLabelsToEntitiesMutationVariables>;

/**
 * __useAssignLabelsToEntitiesMutation__
 *
 * To run a mutation, you first call `useAssignLabelsToEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignLabelsToEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignLabelsToEntitiesMutation, { data, loading, error }] = useAssignLabelsToEntitiesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      entityType: // value for 'entityType'
 *      labelIds: // value for 'labelIds'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useAssignLabelsToEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<AssignLabelsToEntitiesMutation, AssignLabelsToEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignLabelsToEntitiesMutation, AssignLabelsToEntitiesMutationVariables>(AssignLabelsToEntitiesDocument, options);
      }
export type AssignLabelsToEntitiesMutationHookResult = ReturnType<typeof useAssignLabelsToEntitiesMutation>;
export type AssignLabelsToEntitiesMutationResult = Apollo.MutationResult<AssignLabelsToEntitiesMutation>;
export type AssignLabelsToEntitiesMutationOptions = Apollo.BaseMutationOptions<AssignLabelsToEntitiesMutation, AssignLabelsToEntitiesMutationVariables>;
export const UnassignLabelsFromEntityDocument = gql`
    mutation UnassignLabelsFromEntity($courierId: ID!, $entityType: LabelEntityType!, $labelIds: [ID!]!, $entityId: ID!) {
  unassignLabelsFromEntity(
    courierId: $courierId
    entityType: $entityType
    labelIds: $labelIds
    entityId: $entityId
  )
}
    `;
export type UnassignLabelsFromEntityMutationFn = Apollo.MutationFunction<UnassignLabelsFromEntityMutation, UnassignLabelsFromEntityMutationVariables>;

/**
 * __useUnassignLabelsFromEntityMutation__
 *
 * To run a mutation, you first call `useUnassignLabelsFromEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignLabelsFromEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignLabelsFromEntityMutation, { data, loading, error }] = useUnassignLabelsFromEntityMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      entityType: // value for 'entityType'
 *      labelIds: // value for 'labelIds'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useUnassignLabelsFromEntityMutation(baseOptions?: Apollo.MutationHookOptions<UnassignLabelsFromEntityMutation, UnassignLabelsFromEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignLabelsFromEntityMutation, UnassignLabelsFromEntityMutationVariables>(UnassignLabelsFromEntityDocument, options);
      }
export type UnassignLabelsFromEntityMutationHookResult = ReturnType<typeof useUnassignLabelsFromEntityMutation>;
export type UnassignLabelsFromEntityMutationResult = Apollo.MutationResult<UnassignLabelsFromEntityMutation>;
export type UnassignLabelsFromEntityMutationOptions = Apollo.BaseMutationOptions<UnassignLabelsFromEntityMutation, UnassignLabelsFromEntityMutationVariables>;
export const GetLabelsDocument = gql`
    query GetLabels($courierId: ID!, $entityType: LabelEntityType!) {
  labels(courierId: $courierId, entityType: $entityType) {
    ...LabelFragment
  }
}
    ${LabelFragmentFragmentDoc}`;

/**
 * __useGetLabelsQuery__
 *
 * To run a query within a React component, call `useGetLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetLabelsQuery(baseOptions: Apollo.QueryHookOptions<GetLabelsQuery, GetLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabelsQuery, GetLabelsQueryVariables>(GetLabelsDocument, options);
      }
export function useGetLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabelsQuery, GetLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabelsQuery, GetLabelsQueryVariables>(GetLabelsDocument, options);
        }
export type GetLabelsQueryHookResult = ReturnType<typeof useGetLabelsQuery>;
export type GetLabelsLazyQueryHookResult = ReturnType<typeof useGetLabelsLazyQuery>;
export type GetLabelsQueryResult = Apollo.QueryResult<GetLabelsQuery, GetLabelsQueryVariables>;
export const UpsertLinkedAccountDocument = gql`
    mutation UpsertLinkedAccount($courierId: ID!, $remoteId: String!, $provider: ApiProvider!, $refreshToken: String, $accessToken: String!, $accessTokenExpiresInSeconds: Int, $refreshTokenExpiresInSeconds: Int) {
  upsertLinkedAccount(
    linkedAccountCreate: {courierId: $courierId, remoteId: $remoteId, provider: $provider, refreshToken: $refreshToken, accessToken: $accessToken, accessTokenExpiresInSeconds: $accessTokenExpiresInSeconds, refreshTokenExpiresInSeconds: $refreshTokenExpiresInSeconds}
  ) {
    ...LinkedAccountFragment
  }
}
    ${LinkedAccountFragmentFragmentDoc}`;
export type UpsertLinkedAccountMutationFn = Apollo.MutationFunction<UpsertLinkedAccountMutation, UpsertLinkedAccountMutationVariables>;

/**
 * __useUpsertLinkedAccountMutation__
 *
 * To run a mutation, you first call `useUpsertLinkedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLinkedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLinkedAccountMutation, { data, loading, error }] = useUpsertLinkedAccountMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      remoteId: // value for 'remoteId'
 *      provider: // value for 'provider'
 *      refreshToken: // value for 'refreshToken'
 *      accessToken: // value for 'accessToken'
 *      accessTokenExpiresInSeconds: // value for 'accessTokenExpiresInSeconds'
 *      refreshTokenExpiresInSeconds: // value for 'refreshTokenExpiresInSeconds'
 *   },
 * });
 */
export function useUpsertLinkedAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLinkedAccountMutation, UpsertLinkedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLinkedAccountMutation, UpsertLinkedAccountMutationVariables>(UpsertLinkedAccountDocument, options);
      }
export type UpsertLinkedAccountMutationHookResult = ReturnType<typeof useUpsertLinkedAccountMutation>;
export type UpsertLinkedAccountMutationResult = Apollo.MutationResult<UpsertLinkedAccountMutation>;
export type UpsertLinkedAccountMutationOptions = Apollo.BaseMutationOptions<UpsertLinkedAccountMutation, UpsertLinkedAccountMutationVariables>;
export const DeleteLinkedAccountDocument = gql`
    mutation DeleteLinkedAccount($courierId: String!, $id: ID!) {
  deleteLinkedAccount(courierId: $courierId, id: $id)
}
    `;
export type DeleteLinkedAccountMutationFn = Apollo.MutationFunction<DeleteLinkedAccountMutation, DeleteLinkedAccountMutationVariables>;

/**
 * __useDeleteLinkedAccountMutation__
 *
 * To run a mutation, you first call `useDeleteLinkedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLinkedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLinkedAccountMutation, { data, loading, error }] = useDeleteLinkedAccountMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLinkedAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLinkedAccountMutation, DeleteLinkedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLinkedAccountMutation, DeleteLinkedAccountMutationVariables>(DeleteLinkedAccountDocument, options);
      }
export type DeleteLinkedAccountMutationHookResult = ReturnType<typeof useDeleteLinkedAccountMutation>;
export type DeleteLinkedAccountMutationResult = Apollo.MutationResult<DeleteLinkedAccountMutation>;
export type DeleteLinkedAccountMutationOptions = Apollo.BaseMutationOptions<DeleteLinkedAccountMutation, DeleteLinkedAccountMutationVariables>;
export const GetLinkedAccountsDocument = gql`
    query GetLinkedAccounts($courierId: ID!) {
  linkedAccounts(courierId: $courierId) {
    ...LinkedAccountFragment
    isValidAndFresh
  }
}
    ${LinkedAccountFragmentFragmentDoc}`;

/**
 * __useGetLinkedAccountsQuery__
 *
 * To run a query within a React component, call `useGetLinkedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedAccountsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetLinkedAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>(GetLinkedAccountsDocument, options);
      }
export function useGetLinkedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>(GetLinkedAccountsDocument, options);
        }
export type GetLinkedAccountsQueryHookResult = ReturnType<typeof useGetLinkedAccountsQuery>;
export type GetLinkedAccountsLazyQueryHookResult = ReturnType<typeof useGetLinkedAccountsLazyQuery>;
export type GetLinkedAccountsQueryResult = Apollo.QueryResult<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>;
export const LinkedAccountsDocument = gql`
    query LinkedAccounts($courierId: ID!) {
  linkedAccounts(courierId: $courierId) {
    ...LinkedAccountFragment
    isValidAndFresh
  }
}
    ${LinkedAccountFragmentFragmentDoc}`;

/**
 * __useLinkedAccountsQuery__
 *
 * To run a query within a React component, call `useLinkedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAccountsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useLinkedAccountsQuery(baseOptions: Apollo.QueryHookOptions<LinkedAccountsQuery, LinkedAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedAccountsQuery, LinkedAccountsQueryVariables>(LinkedAccountsDocument, options);
      }
export function useLinkedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedAccountsQuery, LinkedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedAccountsQuery, LinkedAccountsQueryVariables>(LinkedAccountsDocument, options);
        }
export type LinkedAccountsQueryHookResult = ReturnType<typeof useLinkedAccountsQuery>;
export type LinkedAccountsLazyQueryHookResult = ReturnType<typeof useLinkedAccountsLazyQuery>;
export type LinkedAccountsQueryResult = Apollo.QueryResult<LinkedAccountsQuery, LinkedAccountsQueryVariables>;
export const AssignShipmentsToLiveRouteDocument = gql`
    mutation AssignShipmentsToLiveRoute($courierId: ID!, $shipmentIds: [ID!]!, $targetRouteTemplateId: ID!, $targetDate: Date!) {
  assignShipmentsToLiveRoute(
    courierId: $courierId
    shipmentIds: $shipmentIds
    targetRouteTemplateId: $targetRouteTemplateId
    targetDate: $targetDate
  ) {
    id
    courierId
    date
    routeTemplateId
    driverId
  }
}
    `;
export type AssignShipmentsToLiveRouteMutationFn = Apollo.MutationFunction<AssignShipmentsToLiveRouteMutation, AssignShipmentsToLiveRouteMutationVariables>;

/**
 * __useAssignShipmentsToLiveRouteMutation__
 *
 * To run a mutation, you first call `useAssignShipmentsToLiveRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignShipmentsToLiveRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignShipmentsToLiveRouteMutation, { data, loading, error }] = useAssignShipmentsToLiveRouteMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *      targetRouteTemplateId: // value for 'targetRouteTemplateId'
 *      targetDate: // value for 'targetDate'
 *   },
 * });
 */
export function useAssignShipmentsToLiveRouteMutation(baseOptions?: Apollo.MutationHookOptions<AssignShipmentsToLiveRouteMutation, AssignShipmentsToLiveRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignShipmentsToLiveRouteMutation, AssignShipmentsToLiveRouteMutationVariables>(AssignShipmentsToLiveRouteDocument, options);
      }
export type AssignShipmentsToLiveRouteMutationHookResult = ReturnType<typeof useAssignShipmentsToLiveRouteMutation>;
export type AssignShipmentsToLiveRouteMutationResult = Apollo.MutationResult<AssignShipmentsToLiveRouteMutation>;
export type AssignShipmentsToLiveRouteMutationOptions = Apollo.BaseMutationOptions<AssignShipmentsToLiveRouteMutation, AssignShipmentsToLiveRouteMutationVariables>;
export const GetOrCreateLocationsDocument = gql`
    mutation GetOrCreateLocations($googlePlaceIds: [String!]!) {
  getOrCreateLocations(googlePlaceIds: $googlePlaceIds) {
    location {
      ...LocationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}`;
export type GetOrCreateLocationsMutationFn = Apollo.MutationFunction<GetOrCreateLocationsMutation, GetOrCreateLocationsMutationVariables>;

/**
 * __useGetOrCreateLocationsMutation__
 *
 * To run a mutation, you first call `useGetOrCreateLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateLocationsMutation, { data, loading, error }] = useGetOrCreateLocationsMutation({
 *   variables: {
 *      googlePlaceIds: // value for 'googlePlaceIds'
 *   },
 * });
 */
export function useGetOrCreateLocationsMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateLocationsMutation, GetOrCreateLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateLocationsMutation, GetOrCreateLocationsMutationVariables>(GetOrCreateLocationsDocument, options);
      }
export type GetOrCreateLocationsMutationHookResult = ReturnType<typeof useGetOrCreateLocationsMutation>;
export type GetOrCreateLocationsMutationResult = Apollo.MutationResult<GetOrCreateLocationsMutation>;
export type GetOrCreateLocationsMutationOptions = Apollo.BaseMutationOptions<GetOrCreateLocationsMutation, GetOrCreateLocationsMutationVariables>;
export const GetOrCreateLocationsWithOverviewDocument = gql`
    mutation GetOrCreateLocationsWithOverview($googlePlaceIds: [String!]!) {
  getOrCreateLocationsWithOverview(googlePlaceIds: $googlePlaceIds) {
    locations {
      ...LocationFragment
    }
    totalDistanceInMiles
  }
}
    ${LocationFragmentFragmentDoc}`;
export type GetOrCreateLocationsWithOverviewMutationFn = Apollo.MutationFunction<GetOrCreateLocationsWithOverviewMutation, GetOrCreateLocationsWithOverviewMutationVariables>;

/**
 * __useGetOrCreateLocationsWithOverviewMutation__
 *
 * To run a mutation, you first call `useGetOrCreateLocationsWithOverviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateLocationsWithOverviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateLocationsWithOverviewMutation, { data, loading, error }] = useGetOrCreateLocationsWithOverviewMutation({
 *   variables: {
 *      googlePlaceIds: // value for 'googlePlaceIds'
 *   },
 * });
 */
export function useGetOrCreateLocationsWithOverviewMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateLocationsWithOverviewMutation, GetOrCreateLocationsWithOverviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateLocationsWithOverviewMutation, GetOrCreateLocationsWithOverviewMutationVariables>(GetOrCreateLocationsWithOverviewDocument, options);
      }
export type GetOrCreateLocationsWithOverviewMutationHookResult = ReturnType<typeof useGetOrCreateLocationsWithOverviewMutation>;
export type GetOrCreateLocationsWithOverviewMutationResult = Apollo.MutationResult<GetOrCreateLocationsWithOverviewMutation>;
export type GetOrCreateLocationsWithOverviewMutationOptions = Apollo.BaseMutationOptions<GetOrCreateLocationsWithOverviewMutation, GetOrCreateLocationsWithOverviewMutationVariables>;
export const GetOrCreateLocationFromCoordinateDocument = gql`
    mutation GetOrCreateLocationFromCoordinate($courierId: ID!, $lngLat: LngLatInput!, $createdBy: String!) {
  getOrCreateLocationFromCoordinate(
    courierId: $courierId
    lngLat: $lngLat
    createdBy: $createdBy
  ) {
    location {
      ...LocationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}`;
export type GetOrCreateLocationFromCoordinateMutationFn = Apollo.MutationFunction<GetOrCreateLocationFromCoordinateMutation, GetOrCreateLocationFromCoordinateMutationVariables>;

/**
 * __useGetOrCreateLocationFromCoordinateMutation__
 *
 * To run a mutation, you first call `useGetOrCreateLocationFromCoordinateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateLocationFromCoordinateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateLocationFromCoordinateMutation, { data, loading, error }] = useGetOrCreateLocationFromCoordinateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      lngLat: // value for 'lngLat'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useGetOrCreateLocationFromCoordinateMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateLocationFromCoordinateMutation, GetOrCreateLocationFromCoordinateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateLocationFromCoordinateMutation, GetOrCreateLocationFromCoordinateMutationVariables>(GetOrCreateLocationFromCoordinateDocument, options);
      }
export type GetOrCreateLocationFromCoordinateMutationHookResult = ReturnType<typeof useGetOrCreateLocationFromCoordinateMutation>;
export type GetOrCreateLocationFromCoordinateMutationResult = Apollo.MutationResult<GetOrCreateLocationFromCoordinateMutation>;
export type GetOrCreateLocationFromCoordinateMutationOptions = Apollo.BaseMutationOptions<GetOrCreateLocationFromCoordinateMutation, GetOrCreateLocationFromCoordinateMutationVariables>;
export const FullUpdateLocationDocument = gql`
    mutation FullUpdateLocation($courierId: ID!, $id: ID!, $streetAddress: String!, $city: String!) {
  fullUpdateLocation(
    courierId: $courierId
    id: $id
    streetAddress: $streetAddress
    city: $city
  ) {
    location {
      ...LocationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}`;
export type FullUpdateLocationMutationFn = Apollo.MutationFunction<FullUpdateLocationMutation, FullUpdateLocationMutationVariables>;

/**
 * __useFullUpdateLocationMutation__
 *
 * To run a mutation, you first call `useFullUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateLocationMutation, { data, loading, error }] = useFullUpdateLocationMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      streetAddress: // value for 'streetAddress'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useFullUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateLocationMutation, FullUpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateLocationMutation, FullUpdateLocationMutationVariables>(FullUpdateLocationDocument, options);
      }
export type FullUpdateLocationMutationHookResult = ReturnType<typeof useFullUpdateLocationMutation>;
export type FullUpdateLocationMutationResult = Apollo.MutationResult<FullUpdateLocationMutation>;
export type FullUpdateLocationMutationOptions = Apollo.BaseMutationOptions<FullUpdateLocationMutation, FullUpdateLocationMutationVariables>;
export const OverrideTripDistanceDocument = gql`
    mutation OverrideTripDistance($courierId: ID!, $sourceLocationId: ID!, $destinationLocationId: ID!, $distanceInMeters: Float!, $durationInSeconds: Float) {
  overrideTripDistance(
    courierId: $courierId
    sourceLocationId: $sourceLocationId
    destinationLocationId: $destinationLocationId
    distanceInMeters: $distanceInMeters
    durationInSeconds: $durationInSeconds
  ) {
    ...TripDistanceOverrideFragment
  }
}
    ${TripDistanceOverrideFragmentFragmentDoc}`;
export type OverrideTripDistanceMutationFn = Apollo.MutationFunction<OverrideTripDistanceMutation, OverrideTripDistanceMutationVariables>;

/**
 * __useOverrideTripDistanceMutation__
 *
 * To run a mutation, you first call `useOverrideTripDistanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideTripDistanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideTripDistanceMutation, { data, loading, error }] = useOverrideTripDistanceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      sourceLocationId: // value for 'sourceLocationId'
 *      destinationLocationId: // value for 'destinationLocationId'
 *      distanceInMeters: // value for 'distanceInMeters'
 *      durationInSeconds: // value for 'durationInSeconds'
 *   },
 * });
 */
export function useOverrideTripDistanceMutation(baseOptions?: Apollo.MutationHookOptions<OverrideTripDistanceMutation, OverrideTripDistanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideTripDistanceMutation, OverrideTripDistanceMutationVariables>(OverrideTripDistanceDocument, options);
      }
export type OverrideTripDistanceMutationHookResult = ReturnType<typeof useOverrideTripDistanceMutation>;
export type OverrideTripDistanceMutationResult = Apollo.MutationResult<OverrideTripDistanceMutation>;
export type OverrideTripDistanceMutationOptions = Apollo.BaseMutationOptions<OverrideTripDistanceMutation, OverrideTripDistanceMutationVariables>;
export const RemoveTripDistanceOverrideDocument = gql`
    mutation RemoveTripDistanceOverride($courierId: ID!, $sourceLocationId: ID!, $destinationLocationId: ID!) {
  removeTripDistanceOverride(
    courierId: $courierId
    sourceLocationId: $sourceLocationId
    destinationLocationId: $destinationLocationId
  )
}
    `;
export type RemoveTripDistanceOverrideMutationFn = Apollo.MutationFunction<RemoveTripDistanceOverrideMutation, RemoveTripDistanceOverrideMutationVariables>;

/**
 * __useRemoveTripDistanceOverrideMutation__
 *
 * To run a mutation, you first call `useRemoveTripDistanceOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTripDistanceOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTripDistanceOverrideMutation, { data, loading, error }] = useRemoveTripDistanceOverrideMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      sourceLocationId: // value for 'sourceLocationId'
 *      destinationLocationId: // value for 'destinationLocationId'
 *   },
 * });
 */
export function useRemoveTripDistanceOverrideMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTripDistanceOverrideMutation, RemoveTripDistanceOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTripDistanceOverrideMutation, RemoveTripDistanceOverrideMutationVariables>(RemoveTripDistanceOverrideDocument, options);
      }
export type RemoveTripDistanceOverrideMutationHookResult = ReturnType<typeof useRemoveTripDistanceOverrideMutation>;
export type RemoveTripDistanceOverrideMutationResult = Apollo.MutationResult<RemoveTripDistanceOverrideMutation>;
export type RemoveTripDistanceOverrideMutationOptions = Apollo.BaseMutationOptions<RemoveTripDistanceOverrideMutation, RemoveTripDistanceOverrideMutationVariables>;
export const TripDistanceOverridesPaginatedDocument = gql`
    query TripDistanceOverridesPaginated($courierId: ID!, $after: Int, $limit: Int) {
  tripDistanceOverridesPaginated(
    courierId: $courierId
    after: $after
    limit: $limit
  ) {
    edges {
      node {
        ...TripDistanceOverrideFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${TripDistanceOverrideFragmentFragmentDoc}`;

/**
 * __useTripDistanceOverridesPaginatedQuery__
 *
 * To run a query within a React component, call `useTripDistanceOverridesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripDistanceOverridesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripDistanceOverridesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTripDistanceOverridesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<TripDistanceOverridesPaginatedQuery, TripDistanceOverridesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripDistanceOverridesPaginatedQuery, TripDistanceOverridesPaginatedQueryVariables>(TripDistanceOverridesPaginatedDocument, options);
      }
export function useTripDistanceOverridesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripDistanceOverridesPaginatedQuery, TripDistanceOverridesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripDistanceOverridesPaginatedQuery, TripDistanceOverridesPaginatedQueryVariables>(TripDistanceOverridesPaginatedDocument, options);
        }
export type TripDistanceOverridesPaginatedQueryHookResult = ReturnType<typeof useTripDistanceOverridesPaginatedQuery>;
export type TripDistanceOverridesPaginatedLazyQueryHookResult = ReturnType<typeof useTripDistanceOverridesPaginatedLazyQuery>;
export type TripDistanceOverridesPaginatedQueryResult = Apollo.QueryResult<TripDistanceOverridesPaginatedQuery, TripDistanceOverridesPaginatedQueryVariables>;
export const CreateRoutingJobDocument = gql`
    mutation CreateRoutingJob($courierId: ID!, $jobCreate: RoutingJobCreate!, $vehicleCreates: [RoutingVehicleCreate!]!) {
  createRoutingJob(
    courierId: $courierId
    jobCreate: $jobCreate
    vehicleCreates: $vehicleCreates
  ) {
    ...RoutingJobFragment
  }
}
    ${RoutingJobFragmentFragmentDoc}`;
export type CreateRoutingJobMutationFn = Apollo.MutationFunction<CreateRoutingJobMutation, CreateRoutingJobMutationVariables>;

/**
 * __useCreateRoutingJobMutation__
 *
 * To run a mutation, you first call `useCreateRoutingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoutingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoutingJobMutation, { data, loading, error }] = useCreateRoutingJobMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      jobCreate: // value for 'jobCreate'
 *      vehicleCreates: // value for 'vehicleCreates'
 *   },
 * });
 */
export function useCreateRoutingJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoutingJobMutation, CreateRoutingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoutingJobMutation, CreateRoutingJobMutationVariables>(CreateRoutingJobDocument, options);
      }
export type CreateRoutingJobMutationHookResult = ReturnType<typeof useCreateRoutingJobMutation>;
export type CreateRoutingJobMutationResult = Apollo.MutationResult<CreateRoutingJobMutation>;
export type CreateRoutingJobMutationOptions = Apollo.BaseMutationOptions<CreateRoutingJobMutation, CreateRoutingJobMutationVariables>;
export const ApproveRoutingJobDocument = gql`
    mutation ApproveRoutingJob($courierId: ID!, $jobId: ID!, $approvedBy: String!) {
  approveRoutingJob(courierId: $courierId, jobId: $jobId, approvedBy: $approvedBy) {
    ...RoutingJobFragment
  }
}
    ${RoutingJobFragmentFragmentDoc}`;
export type ApproveRoutingJobMutationFn = Apollo.MutationFunction<ApproveRoutingJobMutation, ApproveRoutingJobMutationVariables>;

/**
 * __useApproveRoutingJobMutation__
 *
 * To run a mutation, you first call `useApproveRoutingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRoutingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRoutingJobMutation, { data, loading, error }] = useApproveRoutingJobMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      jobId: // value for 'jobId'
 *      approvedBy: // value for 'approvedBy'
 *   },
 * });
 */
export function useApproveRoutingJobMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRoutingJobMutation, ApproveRoutingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRoutingJobMutation, ApproveRoutingJobMutationVariables>(ApproveRoutingJobDocument, options);
      }
export type ApproveRoutingJobMutationHookResult = ReturnType<typeof useApproveRoutingJobMutation>;
export type ApproveRoutingJobMutationResult = Apollo.MutationResult<ApproveRoutingJobMutation>;
export type ApproveRoutingJobMutationOptions = Apollo.BaseMutationOptions<ApproveRoutingJobMutation, ApproveRoutingJobMutationVariables>;
export const CancelRoutingJobDocument = gql`
    mutation CancelRoutingJob($courierId: ID!, $jobId: ID!, $canceledBy: String!) {
  cancelRoutingJob(courierId: $courierId, jobId: $jobId, canceledBy: $canceledBy) {
    ...RoutingJobFragment
  }
}
    ${RoutingJobFragmentFragmentDoc}`;
export type CancelRoutingJobMutationFn = Apollo.MutationFunction<CancelRoutingJobMutation, CancelRoutingJobMutationVariables>;

/**
 * __useCancelRoutingJobMutation__
 *
 * To run a mutation, you first call `useCancelRoutingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRoutingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRoutingJobMutation, { data, loading, error }] = useCancelRoutingJobMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      jobId: // value for 'jobId'
 *      canceledBy: // value for 'canceledBy'
 *   },
 * });
 */
export function useCancelRoutingJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelRoutingJobMutation, CancelRoutingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRoutingJobMutation, CancelRoutingJobMutationVariables>(CancelRoutingJobDocument, options);
      }
export type CancelRoutingJobMutationHookResult = ReturnType<typeof useCancelRoutingJobMutation>;
export type CancelRoutingJobMutationResult = Apollo.MutationResult<CancelRoutingJobMutation>;
export type CancelRoutingJobMutationOptions = Apollo.BaseMutationOptions<CancelRoutingJobMutation, CancelRoutingJobMutationVariables>;
export const ReplaceRoutingVehicleSequenceDocument = gql`
    mutation ReplaceRoutingVehicleSequence($courierId: ID!, $routingVehicleId: ID!, $routingNodeIds: [ID!]!) {
  replaceRoutingVehicleSequence(
    courierId: $courierId
    routingVehicleId: $routingVehicleId
    routingNodeIds: $routingNodeIds
  ) {
    ...RoutingNodeFragment
  }
}
    ${RoutingNodeFragmentFragmentDoc}`;
export type ReplaceRoutingVehicleSequenceMutationFn = Apollo.MutationFunction<ReplaceRoutingVehicleSequenceMutation, ReplaceRoutingVehicleSequenceMutationVariables>;

/**
 * __useReplaceRoutingVehicleSequenceMutation__
 *
 * To run a mutation, you first call `useReplaceRoutingVehicleSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceRoutingVehicleSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceRoutingVehicleSequenceMutation, { data, loading, error }] = useReplaceRoutingVehicleSequenceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      routingVehicleId: // value for 'routingVehicleId'
 *      routingNodeIds: // value for 'routingNodeIds'
 *   },
 * });
 */
export function useReplaceRoutingVehicleSequenceMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceRoutingVehicleSequenceMutation, ReplaceRoutingVehicleSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceRoutingVehicleSequenceMutation, ReplaceRoutingVehicleSequenceMutationVariables>(ReplaceRoutingVehicleSequenceDocument, options);
      }
export type ReplaceRoutingVehicleSequenceMutationHookResult = ReturnType<typeof useReplaceRoutingVehicleSequenceMutation>;
export type ReplaceRoutingVehicleSequenceMutationResult = Apollo.MutationResult<ReplaceRoutingVehicleSequenceMutation>;
export type ReplaceRoutingVehicleSequenceMutationOptions = Apollo.BaseMutationOptions<ReplaceRoutingVehicleSequenceMutation, ReplaceRoutingVehicleSequenceMutationVariables>;
export const TransferShipmentDocument = gql`
    mutation TransferShipment($courierId: ID!, $shipmentId: ID!, $targetDriverId: ID!, $routingJobId: ID!) {
  transferShipment(
    courierId: $courierId
    shipmentId: $shipmentId
    targetDriverId: $targetDriverId
    routingJobId: $routingJobId
  ) {
    ...RoutingNodeFragment
  }
}
    ${RoutingNodeFragmentFragmentDoc}`;
export type TransferShipmentMutationFn = Apollo.MutationFunction<TransferShipmentMutation, TransferShipmentMutationVariables>;

/**
 * __useTransferShipmentMutation__
 *
 * To run a mutation, you first call `useTransferShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferShipmentMutation, { data, loading, error }] = useTransferShipmentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      targetDriverId: // value for 'targetDriverId'
 *      routingJobId: // value for 'routingJobId'
 *   },
 * });
 */
export function useTransferShipmentMutation(baseOptions?: Apollo.MutationHookOptions<TransferShipmentMutation, TransferShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferShipmentMutation, TransferShipmentMutationVariables>(TransferShipmentDocument, options);
      }
export type TransferShipmentMutationHookResult = ReturnType<typeof useTransferShipmentMutation>;
export type TransferShipmentMutationResult = Apollo.MutationResult<TransferShipmentMutation>;
export type TransferShipmentMutationOptions = Apollo.BaseMutationOptions<TransferShipmentMutation, TransferShipmentMutationVariables>;
export const RoutingJobsDocument = gql`
    query RoutingJobs($courierId: ID!, $start: Int, $limit: Int) {
  routingJobs(courierId: $courierId, start: $start, limit: $limit) {
    edges {
      node {
        ...RoutingJobFragment
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${RoutingJobFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useRoutingJobsQuery__
 *
 * To run a query within a React component, call `useRoutingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutingJobsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRoutingJobsQuery(baseOptions: Apollo.QueryHookOptions<RoutingJobsQuery, RoutingJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoutingJobsQuery, RoutingJobsQueryVariables>(RoutingJobsDocument, options);
      }
export function useRoutingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoutingJobsQuery, RoutingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoutingJobsQuery, RoutingJobsQueryVariables>(RoutingJobsDocument, options);
        }
export type RoutingJobsQueryHookResult = ReturnType<typeof useRoutingJobsQuery>;
export type RoutingJobsLazyQueryHookResult = ReturnType<typeof useRoutingJobsLazyQuery>;
export type RoutingJobsQueryResult = Apollo.QueryResult<RoutingJobsQuery, RoutingJobsQueryVariables>;
export const RoutingJobByIdDocument = gql`
    query RoutingJobById($courierId: ID!, $id: ID!) {
  routingJobById(courierId: $courierId, id: $id) {
    ...RoutingJobFragment
    results {
      ...RoutingDayResultFragment
      vehicles {
        ...RoutingVehicleFragment
        driver {
          ...DriverFragment
          lastReportedLocation {
            ...DriverLocationFragment
          }
        }
        nodes {
          ...RoutingNodeFragment
          stop {
            ...StopFragment
            shipment {
              ...ShipmentFragment
              order {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${RoutingJobFragmentFragmentDoc}
${RoutingDayResultFragmentFragmentDoc}
${RoutingVehicleFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}
${RoutingNodeFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}`;

/**
 * __useRoutingJobByIdQuery__
 *
 * To run a query within a React component, call `useRoutingJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutingJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutingJobByIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoutingJobByIdQuery(baseOptions: Apollo.QueryHookOptions<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>(RoutingJobByIdDocument, options);
      }
export function useRoutingJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>(RoutingJobByIdDocument, options);
        }
export type RoutingJobByIdQueryHookResult = ReturnType<typeof useRoutingJobByIdQuery>;
export type RoutingJobByIdLazyQueryHookResult = ReturnType<typeof useRoutingJobByIdLazyQuery>;
export type RoutingJobByIdQueryResult = Apollo.QueryResult<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>;
export const PreviewEtaForRoutingVehicleDocument = gql`
    query PreviewEtaForRoutingVehicle($courierId: ID!, $routingVehicleId: ID!) {
  previewEtaForRoutingVehicle(
    courierId: $courierId
    routingVehicleId: $routingVehicleId
  ) {
    ...RoutingNodeEtaFragment
  }
}
    ${RoutingNodeEtaFragmentFragmentDoc}`;

/**
 * __usePreviewEtaForRoutingVehicleQuery__
 *
 * To run a query within a React component, call `usePreviewEtaForRoutingVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewEtaForRoutingVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewEtaForRoutingVehicleQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      routingVehicleId: // value for 'routingVehicleId'
 *   },
 * });
 */
export function usePreviewEtaForRoutingVehicleQuery(baseOptions: Apollo.QueryHookOptions<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>(PreviewEtaForRoutingVehicleDocument, options);
      }
export function usePreviewEtaForRoutingVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>(PreviewEtaForRoutingVehicleDocument, options);
        }
export type PreviewEtaForRoutingVehicleQueryHookResult = ReturnType<typeof usePreviewEtaForRoutingVehicleQuery>;
export type PreviewEtaForRoutingVehicleLazyQueryHookResult = ReturnType<typeof usePreviewEtaForRoutingVehicleLazyQuery>;
export type PreviewEtaForRoutingVehicleQueryResult = Apollo.QueryResult<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>;
export const CreateOrderAttachmentsDocument = gql`
    mutation CreateOrderAttachments($courierId: ID!, $orderAttachmentUploads: [OrderAttachmentCreate!]!) {
  createOrderAttachments(
    courierId: $courierId
    orderAttachmentUploads: $orderAttachmentUploads
  ) {
    ...OrderAttachmentFragment
  }
}
    ${OrderAttachmentFragmentFragmentDoc}`;
export type CreateOrderAttachmentsMutationFn = Apollo.MutationFunction<CreateOrderAttachmentsMutation, CreateOrderAttachmentsMutationVariables>;

/**
 * __useCreateOrderAttachmentsMutation__
 *
 * To run a mutation, you first call `useCreateOrderAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderAttachmentsMutation, { data, loading, error }] = useCreateOrderAttachmentsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderAttachmentUploads: // value for 'orderAttachmentUploads'
 *   },
 * });
 */
export function useCreateOrderAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderAttachmentsMutation, CreateOrderAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderAttachmentsMutation, CreateOrderAttachmentsMutationVariables>(CreateOrderAttachmentsDocument, options);
      }
export type CreateOrderAttachmentsMutationHookResult = ReturnType<typeof useCreateOrderAttachmentsMutation>;
export type CreateOrderAttachmentsMutationResult = Apollo.MutationResult<CreateOrderAttachmentsMutation>;
export type CreateOrderAttachmentsMutationOptions = Apollo.BaseMutationOptions<CreateOrderAttachmentsMutation, CreateOrderAttachmentsMutationVariables>;
export const AttachAnswerPhotoToOrderDocument = gql`
    mutation AttachAnswerPhotoToOrder($courierId: ID!, $orderId: ID!, $driverAnswerId: ID!) {
  attachAnswerPhotoToOrder(
    courierId: $courierId
    orderId: $orderId
    driverAnswerId: $driverAnswerId
  ) {
    ...OrderAttachmentFragment
  }
}
    ${OrderAttachmentFragmentFragmentDoc}`;
export type AttachAnswerPhotoToOrderMutationFn = Apollo.MutationFunction<AttachAnswerPhotoToOrderMutation, AttachAnswerPhotoToOrderMutationVariables>;

/**
 * __useAttachAnswerPhotoToOrderMutation__
 *
 * To run a mutation, you first call `useAttachAnswerPhotoToOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachAnswerPhotoToOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachAnswerPhotoToOrderMutation, { data, loading, error }] = useAttachAnswerPhotoToOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      driverAnswerId: // value for 'driverAnswerId'
 *   },
 * });
 */
export function useAttachAnswerPhotoToOrderMutation(baseOptions?: Apollo.MutationHookOptions<AttachAnswerPhotoToOrderMutation, AttachAnswerPhotoToOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachAnswerPhotoToOrderMutation, AttachAnswerPhotoToOrderMutationVariables>(AttachAnswerPhotoToOrderDocument, options);
      }
export type AttachAnswerPhotoToOrderMutationHookResult = ReturnType<typeof useAttachAnswerPhotoToOrderMutation>;
export type AttachAnswerPhotoToOrderMutationResult = Apollo.MutationResult<AttachAnswerPhotoToOrderMutation>;
export type AttachAnswerPhotoToOrderMutationOptions = Apollo.BaseMutationOptions<AttachAnswerPhotoToOrderMutation, AttachAnswerPhotoToOrderMutationVariables>;
export const BuildOrderGroupsDocument = gql`
    mutation BuildOrderGroups($courierId: ID!, $orderGroupBuilderId: ID!, $orderIds: [ID!]!, $assignmentGroups: [OrderGroupAssignmentGroupInput!]) {
  buildOrderGroups(
    courierId: $courierId
    orderGroupBuilderId: $orderGroupBuilderId
    orderIds: $orderIds
    assignmentGroups: $assignmentGroups
  ) {
    id
    displayId
  }
}
    `;
export type BuildOrderGroupsMutationFn = Apollo.MutationFunction<BuildOrderGroupsMutation, BuildOrderGroupsMutationVariables>;

/**
 * __useBuildOrderGroupsMutation__
 *
 * To run a mutation, you first call `useBuildOrderGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildOrderGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildOrderGroupsMutation, { data, loading, error }] = useBuildOrderGroupsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderGroupBuilderId: // value for 'orderGroupBuilderId'
 *      orderIds: // value for 'orderIds'
 *      assignmentGroups: // value for 'assignmentGroups'
 *   },
 * });
 */
export function useBuildOrderGroupsMutation(baseOptions?: Apollo.MutationHookOptions<BuildOrderGroupsMutation, BuildOrderGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildOrderGroupsMutation, BuildOrderGroupsMutationVariables>(BuildOrderGroupsDocument, options);
      }
export type BuildOrderGroupsMutationHookResult = ReturnType<typeof useBuildOrderGroupsMutation>;
export type BuildOrderGroupsMutationResult = Apollo.MutationResult<BuildOrderGroupsMutation>;
export type BuildOrderGroupsMutationOptions = Apollo.BaseMutationOptions<BuildOrderGroupsMutation, BuildOrderGroupsMutationVariables>;
export const GetOrderGroupDocument = gql`
    query GetOrderGroup($courierId: ID!, $orderGroupId: ID!) {
  orderGroup(courierId: $courierId, orderGroupId: $orderGroupId) {
    orderGroup {
      id
      displayId
      createdAt
    }
    orderGroupBuilder {
      id
      name
    }
    isSequenced
    members {
      label
      sequenceNumber
      membershipType
      assignmentGroupId
      order {
        id
        displayId
        dispatchableType
        billableType
        endCustomer {
          id
          companyName
          contactEmail
          firstName
        }
        shipment {
          id
          trackingNumber
          status
          isClosed
          isForceCompleted
          driverConfirmedAt
          completionReason
          holdStatus
          routingJobId
          routingJob {
            id
            status
          }
          driver {
            id
            firstName
            lastName
          }
          stops {
            id
            type
            streetAddress
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrderGroupQuery__
 *
 * To run a query within a React component, call `useGetOrderGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderGroupQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderGroupId: // value for 'orderGroupId'
 *   },
 * });
 */
export function useGetOrderGroupQuery(baseOptions: Apollo.QueryHookOptions<GetOrderGroupQuery, GetOrderGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderGroupQuery, GetOrderGroupQueryVariables>(GetOrderGroupDocument, options);
      }
export function useGetOrderGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderGroupQuery, GetOrderGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderGroupQuery, GetOrderGroupQueryVariables>(GetOrderGroupDocument, options);
        }
export type GetOrderGroupQueryHookResult = ReturnType<typeof useGetOrderGroupQuery>;
export type GetOrderGroupLazyQueryHookResult = ReturnType<typeof useGetOrderGroupLazyQuery>;
export type GetOrderGroupQueryResult = Apollo.QueryResult<GetOrderGroupQuery, GetOrderGroupQueryVariables>;
export const AssignHolidayScheduleToRecurringOrderDocument = gql`
    mutation assignHolidayScheduleToRecurringOrder($courierId: ID!, $orderId: ID!, $holidayScheduleId: ID) {
  assignHolidayScheduleToRecurringOrder(
    courierId: $courierId
    orderId: $orderId
    holidayScheduleId: $holidayScheduleId
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type AssignHolidayScheduleToRecurringOrderMutationFn = Apollo.MutationFunction<AssignHolidayScheduleToRecurringOrderMutation, AssignHolidayScheduleToRecurringOrderMutationVariables>;

/**
 * __useAssignHolidayScheduleToRecurringOrderMutation__
 *
 * To run a mutation, you first call `useAssignHolidayScheduleToRecurringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignHolidayScheduleToRecurringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignHolidayScheduleToRecurringOrderMutation, { data, loading, error }] = useAssignHolidayScheduleToRecurringOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *   },
 * });
 */
export function useAssignHolidayScheduleToRecurringOrderMutation(baseOptions?: Apollo.MutationHookOptions<AssignHolidayScheduleToRecurringOrderMutation, AssignHolidayScheduleToRecurringOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignHolidayScheduleToRecurringOrderMutation, AssignHolidayScheduleToRecurringOrderMutationVariables>(AssignHolidayScheduleToRecurringOrderDocument, options);
      }
export type AssignHolidayScheduleToRecurringOrderMutationHookResult = ReturnType<typeof useAssignHolidayScheduleToRecurringOrderMutation>;
export type AssignHolidayScheduleToRecurringOrderMutationResult = Apollo.MutationResult<AssignHolidayScheduleToRecurringOrderMutation>;
export type AssignHolidayScheduleToRecurringOrderMutationOptions = Apollo.BaseMutationOptions<AssignHolidayScheduleToRecurringOrderMutation, AssignHolidayScheduleToRecurringOrderMutationVariables>;
export const OverrideOrderLegDistanceDocument = gql`
    mutation overrideOrderLegDistance($courierId: ID!, $orderId: ID!, $originStopId: ID!, $destinationStopId: ID!, $distanceInMeters: Float!) {
  overrideOrderLegDistance(
    courierId: $courierId
    orderId: $orderId
    originStopId: $originStopId
    destinationStopId: $destinationStopId
    distanceInMeters: $distanceInMeters
  ) {
    id
    sourceLocationId
    destinationLocationId
    distanceInMeters
  }
}
    `;
export type OverrideOrderLegDistanceMutationFn = Apollo.MutationFunction<OverrideOrderLegDistanceMutation, OverrideOrderLegDistanceMutationVariables>;

/**
 * __useOverrideOrderLegDistanceMutation__
 *
 * To run a mutation, you first call `useOverrideOrderLegDistanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideOrderLegDistanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideOrderLegDistanceMutation, { data, loading, error }] = useOverrideOrderLegDistanceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      originStopId: // value for 'originStopId'
 *      destinationStopId: // value for 'destinationStopId'
 *      distanceInMeters: // value for 'distanceInMeters'
 *   },
 * });
 */
export function useOverrideOrderLegDistanceMutation(baseOptions?: Apollo.MutationHookOptions<OverrideOrderLegDistanceMutation, OverrideOrderLegDistanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideOrderLegDistanceMutation, OverrideOrderLegDistanceMutationVariables>(OverrideOrderLegDistanceDocument, options);
      }
export type OverrideOrderLegDistanceMutationHookResult = ReturnType<typeof useOverrideOrderLegDistanceMutation>;
export type OverrideOrderLegDistanceMutationResult = Apollo.MutationResult<OverrideOrderLegDistanceMutation>;
export type OverrideOrderLegDistanceMutationOptions = Apollo.BaseMutationOptions<OverrideOrderLegDistanceMutation, OverrideOrderLegDistanceMutationVariables>;
export const ClearOrderLegDistanceOverrideDocument = gql`
    mutation clearOrderLegDistanceOverride($courierId: ID!, $orderId: ID!, $originStopId: ID!, $destinationStopId: ID!) {
  clearOrderLegDistanceOverride(
    courierId: $courierId
    orderId: $orderId
    originStopId: $originStopId
    destinationStopId: $destinationStopId
  )
}
    `;
export type ClearOrderLegDistanceOverrideMutationFn = Apollo.MutationFunction<ClearOrderLegDistanceOverrideMutation, ClearOrderLegDistanceOverrideMutationVariables>;

/**
 * __useClearOrderLegDistanceOverrideMutation__
 *
 * To run a mutation, you first call `useClearOrderLegDistanceOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearOrderLegDistanceOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearOrderLegDistanceOverrideMutation, { data, loading, error }] = useClearOrderLegDistanceOverrideMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      originStopId: // value for 'originStopId'
 *      destinationStopId: // value for 'destinationStopId'
 *   },
 * });
 */
export function useClearOrderLegDistanceOverrideMutation(baseOptions?: Apollo.MutationHookOptions<ClearOrderLegDistanceOverrideMutation, ClearOrderLegDistanceOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearOrderLegDistanceOverrideMutation, ClearOrderLegDistanceOverrideMutationVariables>(ClearOrderLegDistanceOverrideDocument, options);
      }
export type ClearOrderLegDistanceOverrideMutationHookResult = ReturnType<typeof useClearOrderLegDistanceOverrideMutation>;
export type ClearOrderLegDistanceOverrideMutationResult = Apollo.MutationResult<ClearOrderLegDistanceOverrideMutation>;
export type ClearOrderLegDistanceOverrideMutationOptions = Apollo.BaseMutationOptions<ClearOrderLegDistanceOverrideMutation, ClearOrderLegDistanceOverrideMutationVariables>;
export const FullUpdateOrderDocument = gql`
    mutation fullUpdateOrder($courierId: ID!, $id: ID!, $endCustomerId: ID!, $shipmentUpdates: [ShipmentFullUpdate!]!, $endCustomerReferenceNumber: String, $notes: String, $caller: String, $callerPhone: String, $serviceTypeId: ID, $costCenterId: ID, $customFieldValuesToReplace: [CustomFieldValueInput!], $updatedBy: String, $additionalEmailRecipients: [String!], $requiredDocumentTypes: [DocumentType!], $warnedDocumentTypes: [DocumentType!]) {
  fullUpdateOrder(
    id: $id
    courierId: $courierId
    endCustomerId: $endCustomerId
    shipmentUpdates: $shipmentUpdates
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    notes: $notes
    caller: $caller
    callerPhone: $callerPhone
    serviceTypeId: $serviceTypeId
    costCenterId: $costCenterId
    customFieldValuesToReplace: $customFieldValuesToReplace
    updatedBy: $updatedBy
    additionalEmailRecipients: $additionalEmailRecipients
    requiredDocumentTypes: $requiredDocumentTypes
    warnedDocumentTypes: $warnedDocumentTypes
  ) {
    id
    courierId
    displayId
    recurrenceType
    endCustomerReferenceNumber
    caller
    costCenterId
    endCustomer {
      ...EndCustomerFragment
    }
    costCenter {
      ...CostCenterFragment
    }
    serviceType {
      ...ServiceTypeFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}`;
export type FullUpdateOrderMutationFn = Apollo.MutationFunction<FullUpdateOrderMutation, FullUpdateOrderMutationVariables>;

/**
 * __useFullUpdateOrderMutation__
 *
 * To run a mutation, you first call `useFullUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateOrderMutation, { data, loading, error }] = useFullUpdateOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      endCustomerId: // value for 'endCustomerId'
 *      shipmentUpdates: // value for 'shipmentUpdates'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      notes: // value for 'notes'
 *      caller: // value for 'caller'
 *      callerPhone: // value for 'callerPhone'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      costCenterId: // value for 'costCenterId'
 *      customFieldValuesToReplace: // value for 'customFieldValuesToReplace'
 *      updatedBy: // value for 'updatedBy'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *      requiredDocumentTypes: // value for 'requiredDocumentTypes'
 *      warnedDocumentTypes: // value for 'warnedDocumentTypes'
 *   },
 * });
 */
export function useFullUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateOrderMutation, FullUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateOrderMutation, FullUpdateOrderMutationVariables>(FullUpdateOrderDocument, options);
      }
export type FullUpdateOrderMutationHookResult = ReturnType<typeof useFullUpdateOrderMutation>;
export type FullUpdateOrderMutationResult = Apollo.MutationResult<FullUpdateOrderMutation>;
export type FullUpdateOrderMutationOptions = Apollo.BaseMutationOptions<FullUpdateOrderMutation, FullUpdateOrderMutationVariables>;
export const CreateRecurringOrderDocument = gql`
    mutation CreateRecurringOrder($courierId: ID!, $orderTypeId: ID, $endCustomerId: ID, $endCustomerCreate: EndCustomerCreateInput, $acquisitionType: OrderAcquisitionType!, $recurrenceDetail: RecurrenceDetailInput!, $endCustomerReferenceNumber: String, $notes: String, $caller: String, $serviceTypeId: ID, $costCenterId: ID, $shipmentTemplates: [ShipmentTemplateCreateInput!]!, $customFieldValues: [CustomFieldValueInput!], $name: String, $additionalEmailRecipients: [String!]) {
  createRecurringOrder(
    courierId: $courierId
    orderTypeId: $orderTypeId
    endCustomerId: $endCustomerId
    endCustomerCreate: $endCustomerCreate
    acquisitionType: $acquisitionType
    recurrenceDetail: $recurrenceDetail
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    notes: $notes
    caller: $caller
    serviceTypeId: $serviceTypeId
    costCenterId: $costCenterId
    shipmentTemplates: $shipmentTemplates
    customFieldValues: $customFieldValues
    name: $name
    additionalEmailRecipients: $additionalEmailRecipients
  )
}
    `;
export type CreateRecurringOrderMutationFn = Apollo.MutationFunction<CreateRecurringOrderMutation, CreateRecurringOrderMutationVariables>;

/**
 * __useCreateRecurringOrderMutation__
 *
 * To run a mutation, you first call `useCreateRecurringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringOrderMutation, { data, loading, error }] = useCreateRecurringOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderTypeId: // value for 'orderTypeId'
 *      endCustomerId: // value for 'endCustomerId'
 *      endCustomerCreate: // value for 'endCustomerCreate'
 *      acquisitionType: // value for 'acquisitionType'
 *      recurrenceDetail: // value for 'recurrenceDetail'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      notes: // value for 'notes'
 *      caller: // value for 'caller'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      costCenterId: // value for 'costCenterId'
 *      shipmentTemplates: // value for 'shipmentTemplates'
 *      customFieldValues: // value for 'customFieldValues'
 *      name: // value for 'name'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *   },
 * });
 */
export function useCreateRecurringOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringOrderMutation, CreateRecurringOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringOrderMutation, CreateRecurringOrderMutationVariables>(CreateRecurringOrderDocument, options);
      }
export type CreateRecurringOrderMutationHookResult = ReturnType<typeof useCreateRecurringOrderMutation>;
export type CreateRecurringOrderMutationResult = Apollo.MutationResult<CreateRecurringOrderMutation>;
export type CreateRecurringOrderMutationOptions = Apollo.BaseMutationOptions<CreateRecurringOrderMutation, CreateRecurringOrderMutationVariables>;
export const FullUpdateRecurringOrderDocument = gql`
    mutation fullUpdateRecurringOrder($courierId: ID!, $id: ID!, $endCustomerId: ID!, $recurrenceDetail: RecurrenceDetailInput!, $endCustomerReferenceNumber: String, $serviceTypeId: ID, $costCenterId: ID, $shipmentTemplateUpdates: [ShipmentTemplateFullUpdate!]!, $additionalEmailRecipients: [String!], $customFieldValuesToReplace: [CustomFieldValueInput!], $name: String, $updatedBy: String) {
  fullUpdateRecurringOrder(
    courierId: $courierId
    id: $id
    endCustomerId: $endCustomerId
    recurrenceDetail: $recurrenceDetail
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    serviceTypeId: $serviceTypeId
    costCenterId: $costCenterId
    shipmentTemplateUpdates: $shipmentTemplateUpdates
    additionalEmailRecipients: $additionalEmailRecipients
    customFieldValuesToReplace: $customFieldValuesToReplace
    name: $name
    updatedBy: $updatedBy
  ) {
    id
  }
}
    `;
export type FullUpdateRecurringOrderMutationFn = Apollo.MutationFunction<FullUpdateRecurringOrderMutation, FullUpdateRecurringOrderMutationVariables>;

/**
 * __useFullUpdateRecurringOrderMutation__
 *
 * To run a mutation, you first call `useFullUpdateRecurringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateRecurringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateRecurringOrderMutation, { data, loading, error }] = useFullUpdateRecurringOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      endCustomerId: // value for 'endCustomerId'
 *      recurrenceDetail: // value for 'recurrenceDetail'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      costCenterId: // value for 'costCenterId'
 *      shipmentTemplateUpdates: // value for 'shipmentTemplateUpdates'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *      customFieldValuesToReplace: // value for 'customFieldValuesToReplace'
 *      name: // value for 'name'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useFullUpdateRecurringOrderMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateRecurringOrderMutation, FullUpdateRecurringOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateRecurringOrderMutation, FullUpdateRecurringOrderMutationVariables>(FullUpdateRecurringOrderDocument, options);
      }
export type FullUpdateRecurringOrderMutationHookResult = ReturnType<typeof useFullUpdateRecurringOrderMutation>;
export type FullUpdateRecurringOrderMutationResult = Apollo.MutationResult<FullUpdateRecurringOrderMutation>;
export type FullUpdateRecurringOrderMutationOptions = Apollo.BaseMutationOptions<FullUpdateRecurringOrderMutation, FullUpdateRecurringOrderMutationVariables>;
export const ForceInstantiateRecurringOrdersDocument = gql`
    mutation forceInstantiateRecurringOrders($courierId: ID!, $shipmentTemplateIds: [ID!]!, $targetDate: Date!) {
  forceInstantiateRecurringOrders(
    courierId: $courierId
    shipmentTemplateIds: $shipmentTemplateIds
    targetDate: $targetDate
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type ForceInstantiateRecurringOrdersMutationFn = Apollo.MutationFunction<ForceInstantiateRecurringOrdersMutation, ForceInstantiateRecurringOrdersMutationVariables>;

/**
 * __useForceInstantiateRecurringOrdersMutation__
 *
 * To run a mutation, you first call `useForceInstantiateRecurringOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceInstantiateRecurringOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceInstantiateRecurringOrdersMutation, { data, loading, error }] = useForceInstantiateRecurringOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *      targetDate: // value for 'targetDate'
 *   },
 * });
 */
export function useForceInstantiateRecurringOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ForceInstantiateRecurringOrdersMutation, ForceInstantiateRecurringOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceInstantiateRecurringOrdersMutation, ForceInstantiateRecurringOrdersMutationVariables>(ForceInstantiateRecurringOrdersDocument, options);
      }
export type ForceInstantiateRecurringOrdersMutationHookResult = ReturnType<typeof useForceInstantiateRecurringOrdersMutation>;
export type ForceInstantiateRecurringOrdersMutationResult = Apollo.MutationResult<ForceInstantiateRecurringOrdersMutation>;
export type ForceInstantiateRecurringOrdersMutationOptions = Apollo.BaseMutationOptions<ForceInstantiateRecurringOrdersMutation, ForceInstantiateRecurringOrdersMutationVariables>;
export const GetOrForceInstantiateRecurringOrdersDocument = gql`
    mutation getOrForceInstantiateRecurringOrders($courierId: ID!, $shipmentTemplateIds: [ID!]!, $targetDate: Date!, $shouldUseTemplateDriver: Boolean!) {
  getOrForceInstantiateRecurringOrders(
    courierId: $courierId
    shipmentTemplateIds: $shipmentTemplateIds
    targetDate: $targetDate
    shouldUseTemplateDriver: $shouldUseTemplateDriver
  ) {
    ...OrderFragment
    shipment {
      ...ShipmentFragment
      stops {
        ...StopFragment
      }
      order {
        ...OrderFragment
        endCustomer {
          ...EndCustomerFragment
        }
        serviceType {
          ...ServiceTypeFragment
        }
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}`;
export type GetOrForceInstantiateRecurringOrdersMutationFn = Apollo.MutationFunction<GetOrForceInstantiateRecurringOrdersMutation, GetOrForceInstantiateRecurringOrdersMutationVariables>;

/**
 * __useGetOrForceInstantiateRecurringOrdersMutation__
 *
 * To run a mutation, you first call `useGetOrForceInstantiateRecurringOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrForceInstantiateRecurringOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrForceInstantiateRecurringOrdersMutation, { data, loading, error }] = useGetOrForceInstantiateRecurringOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *      targetDate: // value for 'targetDate'
 *      shouldUseTemplateDriver: // value for 'shouldUseTemplateDriver'
 *   },
 * });
 */
export function useGetOrForceInstantiateRecurringOrdersMutation(baseOptions?: Apollo.MutationHookOptions<GetOrForceInstantiateRecurringOrdersMutation, GetOrForceInstantiateRecurringOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrForceInstantiateRecurringOrdersMutation, GetOrForceInstantiateRecurringOrdersMutationVariables>(GetOrForceInstantiateRecurringOrdersDocument, options);
      }
export type GetOrForceInstantiateRecurringOrdersMutationHookResult = ReturnType<typeof useGetOrForceInstantiateRecurringOrdersMutation>;
export type GetOrForceInstantiateRecurringOrdersMutationResult = Apollo.MutationResult<GetOrForceInstantiateRecurringOrdersMutation>;
export type GetOrForceInstantiateRecurringOrdersMutationOptions = Apollo.BaseMutationOptions<GetOrForceInstantiateRecurringOrdersMutation, GetOrForceInstantiateRecurringOrdersMutationVariables>;
export const GenerateOrdersPdfDocument = gql`
    mutation GenerateOrdersPdf($orderIds: [ID!]!, $numPackages: Int, $useOrderNumPackages: Boolean) {
  generateOrdersPdf(
    orderIds: $orderIds
    numPackages: $numPackages
    useOrderNumPackages: $useOrderNumPackages
  ) {
    url
  }
}
    `;
export type GenerateOrdersPdfMutationFn = Apollo.MutationFunction<GenerateOrdersPdfMutation, GenerateOrdersPdfMutationVariables>;

/**
 * __useGenerateOrdersPdfMutation__
 *
 * To run a mutation, you first call `useGenerateOrdersPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrdersPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrdersPdfMutation, { data, loading, error }] = useGenerateOrdersPdfMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *      numPackages: // value for 'numPackages'
 *      useOrderNumPackages: // value for 'useOrderNumPackages'
 *   },
 * });
 */
export function useGenerateOrdersPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOrdersPdfMutation, GenerateOrdersPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOrdersPdfMutation, GenerateOrdersPdfMutationVariables>(GenerateOrdersPdfDocument, options);
      }
export type GenerateOrdersPdfMutationHookResult = ReturnType<typeof useGenerateOrdersPdfMutation>;
export type GenerateOrdersPdfMutationResult = Apollo.MutationResult<GenerateOrdersPdfMutation>;
export type GenerateOrdersPdfMutationOptions = Apollo.BaseMutationOptions<GenerateOrdersPdfMutation, GenerateOrdersPdfMutationVariables>;
export const RecordOrderClickDocument = gql`
    mutation recordOrderClick($input: RecordOrderClickInput!) {
  recordOrderClick(input: $input)
}
    `;
export type RecordOrderClickMutationFn = Apollo.MutationFunction<RecordOrderClickMutation, RecordOrderClickMutationVariables>;

/**
 * __useRecordOrderClickMutation__
 *
 * To run a mutation, you first call `useRecordOrderClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordOrderClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordOrderClickMutation, { data, loading, error }] = useRecordOrderClickMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordOrderClickMutation(baseOptions?: Apollo.MutationHookOptions<RecordOrderClickMutation, RecordOrderClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordOrderClickMutation, RecordOrderClickMutationVariables>(RecordOrderClickDocument, options);
      }
export type RecordOrderClickMutationHookResult = ReturnType<typeof useRecordOrderClickMutation>;
export type RecordOrderClickMutationResult = Apollo.MutationResult<RecordOrderClickMutation>;
export type RecordOrderClickMutationOptions = Apollo.BaseMutationOptions<RecordOrderClickMutation, RecordOrderClickMutationVariables>;
export const CreateLiveOrderDocument = gql`
    mutation createLiveOrder($courierId: ID!, $branchId: ID, $orderTypeId: ID, $endCustomerId: ID, $endCustomerCreate: EndCustomerCreateInput, $acquisitionType: OrderAcquisitionType!, $shipments: [ShipmentCreateInput!]!, $endCustomerReferenceNumber: String, $notes: String, $caller: String, $callerPhone: String, $serviceTypeId: ID, $costCenterId: ID, $pricingAdjustments: [PricingAdjustmentCreate!], $basePriceOverride: Money, $priceOverride: Money, $priceOverrideBreakdown: [PriceOverrideBreakdownItemInput!], $additionalEmailRecipients: [String!], $createdBy: String, $customFieldValues: [CustomFieldValueInput!], $endUserId: ID, $originalOrderId: ID, $paymentInstrumentId: ID, $fraudSessionId: String, $requiredDocumentTypes: [DocumentType!], $warnedDocumentTypes: [DocumentType!], $orderGroupBuildDetail: OrderGroupBuildDetailInput) {
  createLiveOrder(
    courierId: $courierId
    branchId: $branchId
    orderTypeId: $orderTypeId
    endCustomerId: $endCustomerId
    endCustomerCreate: $endCustomerCreate
    acquisitionType: $acquisitionType
    shipments: $shipments
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    notes: $notes
    caller: $caller
    callerPhone: $callerPhone
    serviceTypeId: $serviceTypeId
    costCenterId: $costCenterId
    pricingAdjustments: $pricingAdjustments
    basePriceOverride: $basePriceOverride
    priceOverride: $priceOverride
    priceOverrideBreakdown: $priceOverrideBreakdown
    additionalEmailRecipients: $additionalEmailRecipients
    createdBy: $createdBy
    customFieldValues: $customFieldValues
    endUserId: $endUserId
    originalOrderId: $originalOrderId
    paymentInstrumentId: $paymentInstrumentId
    fraudSessionId: $fraudSessionId
    requiredDocumentTypes: $requiredDocumentTypes
    warnedDocumentTypes: $warnedDocumentTypes
    orderGroupBuildDetail: $orderGroupBuildDetail
  ) {
    endCustomer {
      companyName
    }
    shipment {
      id
      trackingNumber
    }
  }
}
    `;
export type CreateLiveOrderMutationFn = Apollo.MutationFunction<CreateLiveOrderMutation, CreateLiveOrderMutationVariables>;

/**
 * __useCreateLiveOrderMutation__
 *
 * To run a mutation, you first call `useCreateLiveOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLiveOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLiveOrderMutation, { data, loading, error }] = useCreateLiveOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      branchId: // value for 'branchId'
 *      orderTypeId: // value for 'orderTypeId'
 *      endCustomerId: // value for 'endCustomerId'
 *      endCustomerCreate: // value for 'endCustomerCreate'
 *      acquisitionType: // value for 'acquisitionType'
 *      shipments: // value for 'shipments'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      notes: // value for 'notes'
 *      caller: // value for 'caller'
 *      callerPhone: // value for 'callerPhone'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      costCenterId: // value for 'costCenterId'
 *      pricingAdjustments: // value for 'pricingAdjustments'
 *      basePriceOverride: // value for 'basePriceOverride'
 *      priceOverride: // value for 'priceOverride'
 *      priceOverrideBreakdown: // value for 'priceOverrideBreakdown'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *      createdBy: // value for 'createdBy'
 *      customFieldValues: // value for 'customFieldValues'
 *      endUserId: // value for 'endUserId'
 *      originalOrderId: // value for 'originalOrderId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      fraudSessionId: // value for 'fraudSessionId'
 *      requiredDocumentTypes: // value for 'requiredDocumentTypes'
 *      warnedDocumentTypes: // value for 'warnedDocumentTypes'
 *      orderGroupBuildDetail: // value for 'orderGroupBuildDetail'
 *   },
 * });
 */
export function useCreateLiveOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateLiveOrderMutation, CreateLiveOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLiveOrderMutation, CreateLiveOrderMutationVariables>(CreateLiveOrderDocument, options);
      }
export type CreateLiveOrderMutationHookResult = ReturnType<typeof useCreateLiveOrderMutation>;
export type CreateLiveOrderMutationResult = Apollo.MutationResult<CreateLiveOrderMutation>;
export type CreateLiveOrderMutationOptions = Apollo.BaseMutationOptions<CreateLiveOrderMutation, CreateLiveOrderMutationVariables>;
export const FinalizeOrderPricingDocument = gql`
    mutation finalizeOrderPricing($courierId: ID!, $orderId: ID!) {
  finalizeOrderPricing(courierId: $courierId, orderId: $orderId)
}
    `;
export type FinalizeOrderPricingMutationFn = Apollo.MutationFunction<FinalizeOrderPricingMutation, FinalizeOrderPricingMutationVariables>;

/**
 * __useFinalizeOrderPricingMutation__
 *
 * To run a mutation, you first call `useFinalizeOrderPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeOrderPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeOrderPricingMutation, { data, loading, error }] = useFinalizeOrderPricingMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFinalizeOrderPricingMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeOrderPricingMutation, FinalizeOrderPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeOrderPricingMutation, FinalizeOrderPricingMutationVariables>(FinalizeOrderPricingDocument, options);
      }
export type FinalizeOrderPricingMutationHookResult = ReturnType<typeof useFinalizeOrderPricingMutation>;
export type FinalizeOrderPricingMutationResult = Apollo.MutationResult<FinalizeOrderPricingMutation>;
export type FinalizeOrderPricingMutationOptions = Apollo.BaseMutationOptions<FinalizeOrderPricingMutation, FinalizeOrderPricingMutationVariables>;
export const UnfinalizeOrderPricingDocument = gql`
    mutation unfinalizeOrderPricing($courierId: ID!, $orderId: ID!) {
  unfinalizeOrderPricing(courierId: $courierId, orderId: $orderId)
}
    `;
export type UnfinalizeOrderPricingMutationFn = Apollo.MutationFunction<UnfinalizeOrderPricingMutation, UnfinalizeOrderPricingMutationVariables>;

/**
 * __useUnfinalizeOrderPricingMutation__
 *
 * To run a mutation, you first call `useUnfinalizeOrderPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfinalizeOrderPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfinalizeOrderPricingMutation, { data, loading, error }] = useUnfinalizeOrderPricingMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUnfinalizeOrderPricingMutation(baseOptions?: Apollo.MutationHookOptions<UnfinalizeOrderPricingMutation, UnfinalizeOrderPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfinalizeOrderPricingMutation, UnfinalizeOrderPricingMutationVariables>(UnfinalizeOrderPricingDocument, options);
      }
export type UnfinalizeOrderPricingMutationHookResult = ReturnType<typeof useUnfinalizeOrderPricingMutation>;
export type UnfinalizeOrderPricingMutationResult = Apollo.MutationResult<UnfinalizeOrderPricingMutation>;
export type UnfinalizeOrderPricingMutationOptions = Apollo.BaseMutationOptions<UnfinalizeOrderPricingMutation, UnfinalizeOrderPricingMutationVariables>;
export const GenerateBillOfLadingPdfDocument = gql`
    mutation GenerateBillOfLadingPdf($courierId: ID!, $orderIds: [ID!]!) {
  generateBillOfLadingPdf(courierId: $courierId, orderIds: $orderIds) {
    pdfUrl
    fileId
    orderId
  }
}
    `;
export type GenerateBillOfLadingPdfMutationFn = Apollo.MutationFunction<GenerateBillOfLadingPdfMutation, GenerateBillOfLadingPdfMutationVariables>;

/**
 * __useGenerateBillOfLadingPdfMutation__
 *
 * To run a mutation, you first call `useGenerateBillOfLadingPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBillOfLadingPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBillOfLadingPdfMutation, { data, loading, error }] = useGenerateBillOfLadingPdfMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useGenerateBillOfLadingPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateBillOfLadingPdfMutation, GenerateBillOfLadingPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateBillOfLadingPdfMutation, GenerateBillOfLadingPdfMutationVariables>(GenerateBillOfLadingPdfDocument, options);
      }
export type GenerateBillOfLadingPdfMutationHookResult = ReturnType<typeof useGenerateBillOfLadingPdfMutation>;
export type GenerateBillOfLadingPdfMutationResult = Apollo.MutationResult<GenerateBillOfLadingPdfMutation>;
export type GenerateBillOfLadingPdfMutationOptions = Apollo.BaseMutationOptions<GenerateBillOfLadingPdfMutation, GenerateBillOfLadingPdfMutationVariables>;
export const TriggerRecurringOrderGenerationDocument = gql`
    mutation TriggerRecurringOrderGeneration($courierId: ID!, $minDate: Date!, $maxDate: Date!) {
  triggerRecurringOrderGeneration(
    courierId: $courierId
    minDate: $minDate
    maxDate: $maxDate
  )
}
    `;
export type TriggerRecurringOrderGenerationMutationFn = Apollo.MutationFunction<TriggerRecurringOrderGenerationMutation, TriggerRecurringOrderGenerationMutationVariables>;

/**
 * __useTriggerRecurringOrderGenerationMutation__
 *
 * To run a mutation, you first call `useTriggerRecurringOrderGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerRecurringOrderGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerRecurringOrderGenerationMutation, { data, loading, error }] = useTriggerRecurringOrderGenerationMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useTriggerRecurringOrderGenerationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerRecurringOrderGenerationMutation, TriggerRecurringOrderGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerRecurringOrderGenerationMutation, TriggerRecurringOrderGenerationMutationVariables>(TriggerRecurringOrderGenerationDocument, options);
      }
export type TriggerRecurringOrderGenerationMutationHookResult = ReturnType<typeof useTriggerRecurringOrderGenerationMutation>;
export type TriggerRecurringOrderGenerationMutationResult = Apollo.MutationResult<TriggerRecurringOrderGenerationMutation>;
export type TriggerRecurringOrderGenerationMutationOptions = Apollo.BaseMutationOptions<TriggerRecurringOrderGenerationMutation, TriggerRecurringOrderGenerationMutationVariables>;
export const GenerateCsvForRecurringOrdersDocument = gql`
    mutation GenerateCsvForRecurringOrders($courierId: ID!) {
  generateCsvForRecurringOrders(courierId: $courierId) {
    url
  }
}
    `;
export type GenerateCsvForRecurringOrdersMutationFn = Apollo.MutationFunction<GenerateCsvForRecurringOrdersMutation, GenerateCsvForRecurringOrdersMutationVariables>;

/**
 * __useGenerateCsvForRecurringOrdersMutation__
 *
 * To run a mutation, you first call `useGenerateCsvForRecurringOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCsvForRecurringOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCsvForRecurringOrdersMutation, { data, loading, error }] = useGenerateCsvForRecurringOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGenerateCsvForRecurringOrdersMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCsvForRecurringOrdersMutation, GenerateCsvForRecurringOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCsvForRecurringOrdersMutation, GenerateCsvForRecurringOrdersMutationVariables>(GenerateCsvForRecurringOrdersDocument, options);
      }
export type GenerateCsvForRecurringOrdersMutationHookResult = ReturnType<typeof useGenerateCsvForRecurringOrdersMutation>;
export type GenerateCsvForRecurringOrdersMutationResult = Apollo.MutationResult<GenerateCsvForRecurringOrdersMutation>;
export type GenerateCsvForRecurringOrdersMutationOptions = Apollo.BaseMutationOptions<GenerateCsvForRecurringOrdersMutation, GenerateCsvForRecurringOrdersMutationVariables>;
export const MergeOrdersDocument = gql`
    mutation MergeOrders($courierId: ID!, $orderIds: [ID!]!) {
  mergeOrders(courierId: $courierId, orderIds: $orderIds) {
    ...OrderFragment
    shipment {
      id
      trackingNumber
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type MergeOrdersMutationFn = Apollo.MutationFunction<MergeOrdersMutation, MergeOrdersMutationVariables>;

/**
 * __useMergeOrdersMutation__
 *
 * To run a mutation, you first call `useMergeOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeOrdersMutation, { data, loading, error }] = useMergeOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useMergeOrdersMutation(baseOptions?: Apollo.MutationHookOptions<MergeOrdersMutation, MergeOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeOrdersMutation, MergeOrdersMutationVariables>(MergeOrdersDocument, options);
      }
export type MergeOrdersMutationHookResult = ReturnType<typeof useMergeOrdersMutation>;
export type MergeOrdersMutationResult = Apollo.MutationResult<MergeOrdersMutation>;
export type MergeOrdersMutationOptions = Apollo.BaseMutationOptions<MergeOrdersMutation, MergeOrdersMutationVariables>;
export const UpdateOrderLabelsDocument = gql`
    mutation UpdateOrderLabels($courierId: ID!, $orderIds: [ID!]!, $addLabelIds: [ID!]!, $removeLabelIds: [ID!]!) {
  updateOrderLabels(
    courierId: $courierId
    orderIds: $orderIds
    addLabelIds: $addLabelIds
    removeLabelIds: $removeLabelIds
  )
}
    `;
export type UpdateOrderLabelsMutationFn = Apollo.MutationFunction<UpdateOrderLabelsMutation, UpdateOrderLabelsMutationVariables>;

/**
 * __useUpdateOrderLabelsMutation__
 *
 * To run a mutation, you first call `useUpdateOrderLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderLabelsMutation, { data, loading, error }] = useUpdateOrderLabelsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderIds: // value for 'orderIds'
 *      addLabelIds: // value for 'addLabelIds'
 *      removeLabelIds: // value for 'removeLabelIds'
 *   },
 * });
 */
export function useUpdateOrderLabelsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderLabelsMutation, UpdateOrderLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderLabelsMutation, UpdateOrderLabelsMutationVariables>(UpdateOrderLabelsDocument, options);
      }
export type UpdateOrderLabelsMutationHookResult = ReturnType<typeof useUpdateOrderLabelsMutation>;
export type UpdateOrderLabelsMutationResult = Apollo.MutationResult<UpdateOrderLabelsMutation>;
export type UpdateOrderLabelsMutationOptions = Apollo.BaseMutationOptions<UpdateOrderLabelsMutation, UpdateOrderLabelsMutationVariables>;
export const UpdateOrderInvoiceDateDocument = gql`
    mutation UpdateOrderInvoiceDate($courierId: ID!, $orderId: ID!, $invoiceDate: Date) {
  updateOrderInvoiceDate(
    courierId: $courierId
    orderId: $orderId
    invoiceDate: $invoiceDate
  ) {
    id
  }
}
    `;
export type UpdateOrderInvoiceDateMutationFn = Apollo.MutationFunction<UpdateOrderInvoiceDateMutation, UpdateOrderInvoiceDateMutationVariables>;

/**
 * __useUpdateOrderInvoiceDateMutation__
 *
 * To run a mutation, you first call `useUpdateOrderInvoiceDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderInvoiceDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderInvoiceDateMutation, { data, loading, error }] = useUpdateOrderInvoiceDateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      invoiceDate: // value for 'invoiceDate'
 *   },
 * });
 */
export function useUpdateOrderInvoiceDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderInvoiceDateMutation, UpdateOrderInvoiceDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderInvoiceDateMutation, UpdateOrderInvoiceDateMutationVariables>(UpdateOrderInvoiceDateDocument, options);
      }
export type UpdateOrderInvoiceDateMutationHookResult = ReturnType<typeof useUpdateOrderInvoiceDateMutation>;
export type UpdateOrderInvoiceDateMutationResult = Apollo.MutationResult<UpdateOrderInvoiceDateMutation>;
export type UpdateOrderInvoiceDateMutationOptions = Apollo.BaseMutationOptions<UpdateOrderInvoiceDateMutation, UpdateOrderInvoiceDateMutationVariables>;
export const BulkUpdateOrderInvoiceDateDocument = gql`
    mutation BulkUpdateOrderInvoiceDate($courierId: ID!, $orderIds: [ID!]!, $invoiceDate: Date) {
  bulkUpdateOrderInvoiceDate(
    courierId: $courierId
    orderIds: $orderIds
    invoiceDate: $invoiceDate
  ) {
    id
  }
}
    `;
export type BulkUpdateOrderInvoiceDateMutationFn = Apollo.MutationFunction<BulkUpdateOrderInvoiceDateMutation, BulkUpdateOrderInvoiceDateMutationVariables>;

/**
 * __useBulkUpdateOrderInvoiceDateMutation__
 *
 * To run a mutation, you first call `useBulkUpdateOrderInvoiceDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateOrderInvoiceDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateOrderInvoiceDateMutation, { data, loading, error }] = useBulkUpdateOrderInvoiceDateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderIds: // value for 'orderIds'
 *      invoiceDate: // value for 'invoiceDate'
 *   },
 * });
 */
export function useBulkUpdateOrderInvoiceDateMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateOrderInvoiceDateMutation, BulkUpdateOrderInvoiceDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateOrderInvoiceDateMutation, BulkUpdateOrderInvoiceDateMutationVariables>(BulkUpdateOrderInvoiceDateDocument, options);
      }
export type BulkUpdateOrderInvoiceDateMutationHookResult = ReturnType<typeof useBulkUpdateOrderInvoiceDateMutation>;
export type BulkUpdateOrderInvoiceDateMutationResult = Apollo.MutationResult<BulkUpdateOrderInvoiceDateMutation>;
export type BulkUpdateOrderInvoiceDateMutationOptions = Apollo.BaseMutationOptions<BulkUpdateOrderInvoiceDateMutation, BulkUpdateOrderInvoiceDateMutationVariables>;
export const GetOrderAdditionalInfoDocument = gql`
    query GetOrderAdditionalInfo($courierId: ID!, $orderId: ID!) {
  orderAdditionalInfo(courierId: $courierId, orderId: $orderId) {
    key
    value
  }
}
    `;

/**
 * __useGetOrderAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useGetOrderAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderAdditionalInfoQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderAdditionalInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrderAdditionalInfoQuery, GetOrderAdditionalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderAdditionalInfoQuery, GetOrderAdditionalInfoQueryVariables>(GetOrderAdditionalInfoDocument, options);
      }
export function useGetOrderAdditionalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderAdditionalInfoQuery, GetOrderAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderAdditionalInfoQuery, GetOrderAdditionalInfoQueryVariables>(GetOrderAdditionalInfoDocument, options);
        }
export type GetOrderAdditionalInfoQueryHookResult = ReturnType<typeof useGetOrderAdditionalInfoQuery>;
export type GetOrderAdditionalInfoLazyQueryHookResult = ReturnType<typeof useGetOrderAdditionalInfoLazyQuery>;
export type GetOrderAdditionalInfoQueryResult = Apollo.QueryResult<GetOrderAdditionalInfoQuery, GetOrderAdditionalInfoQueryVariables>;
export const FullUpdatePackageTypeDocument = gql`
    mutation fullUpdatePackageType($courierId: ID!, $id: ID!, $name: String!, $defaultLength: Float, $defaultWidth: Float, $defaultHeight: Float, $defaultWeight: Float, $defaultWeightApplication: PackageTypeDefaultWeightApplication, $category: PackageTypeCategory, $enabled: Boolean) {
  fullUpdatePackageType(
    courierId: $courierId
    id: $id
    name: $name
    defaultLength: $defaultLength
    defaultWidth: $defaultWidth
    defaultHeight: $defaultHeight
    defaultWeight: $defaultWeight
    defaultWeightApplication: $defaultWeightApplication
    category: $category
    enabled: $enabled
  ) {
    ...PackageTypeFragment
  }
}
    ${PackageTypeFragmentFragmentDoc}`;
export type FullUpdatePackageTypeMutationFn = Apollo.MutationFunction<FullUpdatePackageTypeMutation, FullUpdatePackageTypeMutationVariables>;

/**
 * __useFullUpdatePackageTypeMutation__
 *
 * To run a mutation, you first call `useFullUpdatePackageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdatePackageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdatePackageTypeMutation, { data, loading, error }] = useFullUpdatePackageTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      defaultLength: // value for 'defaultLength'
 *      defaultWidth: // value for 'defaultWidth'
 *      defaultHeight: // value for 'defaultHeight'
 *      defaultWeight: // value for 'defaultWeight'
 *      defaultWeightApplication: // value for 'defaultWeightApplication'
 *      category: // value for 'category'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useFullUpdatePackageTypeMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdatePackageTypeMutation, FullUpdatePackageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdatePackageTypeMutation, FullUpdatePackageTypeMutationVariables>(FullUpdatePackageTypeDocument, options);
      }
export type FullUpdatePackageTypeMutationHookResult = ReturnType<typeof useFullUpdatePackageTypeMutation>;
export type FullUpdatePackageTypeMutationResult = Apollo.MutationResult<FullUpdatePackageTypeMutation>;
export type FullUpdatePackageTypeMutationOptions = Apollo.BaseMutationOptions<FullUpdatePackageTypeMutation, FullUpdatePackageTypeMutationVariables>;
export const CreatePackageTypeDocument = gql`
    mutation createPackageType($courierId: ID!, $name: String!, $defaultLength: Float, $defaultWidth: Float, $defaultHeight: Float, $defaultWeight: Float, $defaultWeightApplication: PackageTypeDefaultWeightApplication, $category: PackageTypeCategory, $enabled: Boolean) {
  createPackageType(
    courierId: $courierId
    name: $name
    defaultLength: $defaultLength
    defaultWidth: $defaultWidth
    defaultHeight: $defaultHeight
    defaultWeight: $defaultWeight
    defaultWeightApplication: $defaultWeightApplication
    category: $category
    enabled: $enabled
  ) {
    ...PackageTypeFragment
  }
}
    ${PackageTypeFragmentFragmentDoc}`;
export type CreatePackageTypeMutationFn = Apollo.MutationFunction<CreatePackageTypeMutation, CreatePackageTypeMutationVariables>;

/**
 * __useCreatePackageTypeMutation__
 *
 * To run a mutation, you first call `useCreatePackageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageTypeMutation, { data, loading, error }] = useCreatePackageTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      defaultLength: // value for 'defaultLength'
 *      defaultWidth: // value for 'defaultWidth'
 *      defaultHeight: // value for 'defaultHeight'
 *      defaultWeight: // value for 'defaultWeight'
 *      defaultWeightApplication: // value for 'defaultWeightApplication'
 *      category: // value for 'category'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useCreatePackageTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageTypeMutation, CreatePackageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageTypeMutation, CreatePackageTypeMutationVariables>(CreatePackageTypeDocument, options);
      }
export type CreatePackageTypeMutationHookResult = ReturnType<typeof useCreatePackageTypeMutation>;
export type CreatePackageTypeMutationResult = Apollo.MutationResult<CreatePackageTypeMutation>;
export type CreatePackageTypeMutationOptions = Apollo.BaseMutationOptions<CreatePackageTypeMutation, CreatePackageTypeMutationVariables>;
export const DeletePackageTypeDocument = gql`
    mutation deletePackageType($courierId: ID!, $id: ID!) {
  deletePackageType(courierId: $courierId, id: $id) {
    ...PackageTypeFragment
  }
}
    ${PackageTypeFragmentFragmentDoc}`;
export type DeletePackageTypeMutationFn = Apollo.MutationFunction<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>;

/**
 * __useDeletePackageTypeMutation__
 *
 * To run a mutation, you first call `useDeletePackageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageTypeMutation, { data, loading, error }] = useDeletePackageTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePackageTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>(DeletePackageTypeDocument, options);
      }
export type DeletePackageTypeMutationHookResult = ReturnType<typeof useDeletePackageTypeMutation>;
export type DeletePackageTypeMutationResult = Apollo.MutationResult<DeletePackageTypeMutation>;
export type DeletePackageTypeMutationOptions = Apollo.BaseMutationOptions<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>;
export const CreatePaymentInstrumentDocument = gql`
    mutation CreatePaymentInstrument($courierId: ID!, $endCustomerId: ID, $costCenterId: ID, $token: String!, $source: PaymentInstrumentAcquisitionSource!, $createdBy: String!) {
  createPaymentInstrument(
    courierId: $courierId
    endCustomerId: $endCustomerId
    costCenterId: $costCenterId
    token: $token
    source: $source
    createdBy: $createdBy
  ) {
    ...PaymentInstrumentFragment
  }
}
    ${PaymentInstrumentFragmentFragmentDoc}`;
export type CreatePaymentInstrumentMutationFn = Apollo.MutationFunction<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>;

/**
 * __useCreatePaymentInstrumentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentInstrumentMutation, { data, loading, error }] = useCreatePaymentInstrumentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      costCenterId: // value for 'costCenterId'
 *      token: // value for 'token'
 *      source: // value for 'source'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreatePaymentInstrumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>(CreatePaymentInstrumentDocument, options);
      }
export type CreatePaymentInstrumentMutationHookResult = ReturnType<typeof useCreatePaymentInstrumentMutation>;
export type CreatePaymentInstrumentMutationResult = Apollo.MutationResult<CreatePaymentInstrumentMutation>;
export type CreatePaymentInstrumentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>;
export const DeletePaymentInstrumentDocument = gql`
    mutation DeletePaymentInstrument($paymentInstrumentId: ID!, $courierId: ID!) {
  deletePaymentInstrument(
    paymentInstrumentId: $paymentInstrumentId
    courierId: $courierId
  )
}
    `;
export type DeletePaymentInstrumentMutationFn = Apollo.MutationFunction<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>;

/**
 * __useDeletePaymentInstrumentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentInstrumentMutation, { data, loading, error }] = useDeletePaymentInstrumentMutation({
 *   variables: {
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useDeletePaymentInstrumentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>(DeletePaymentInstrumentDocument, options);
      }
export type DeletePaymentInstrumentMutationHookResult = ReturnType<typeof useDeletePaymentInstrumentMutation>;
export type DeletePaymentInstrumentMutationResult = Apollo.MutationResult<DeletePaymentInstrumentMutation>;
export type DeletePaymentInstrumentMutationOptions = Apollo.BaseMutationOptions<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>;
export const UpdatePaymentInstrumentIsDefaultDocument = gql`
    mutation UpdatePaymentInstrumentIsDefault($courierId: ID!, $paymentInstrumentId: ID!, $isDefault: Boolean!) {
  updatePaymentInstrumentIsDefault(
    courierId: $courierId
    paymentInstrumentId: $paymentInstrumentId
    isDefault: $isDefault
  ) {
    ...PaymentInstrumentFragment
  }
}
    ${PaymentInstrumentFragmentFragmentDoc}`;
export type UpdatePaymentInstrumentIsDefaultMutationFn = Apollo.MutationFunction<UpdatePaymentInstrumentIsDefaultMutation, UpdatePaymentInstrumentIsDefaultMutationVariables>;

/**
 * __useUpdatePaymentInstrumentIsDefaultMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentInstrumentIsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentInstrumentIsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentInstrumentIsDefaultMutation, { data, loading, error }] = useUpdatePaymentInstrumentIsDefaultMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useUpdatePaymentInstrumentIsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentInstrumentIsDefaultMutation, UpdatePaymentInstrumentIsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentInstrumentIsDefaultMutation, UpdatePaymentInstrumentIsDefaultMutationVariables>(UpdatePaymentInstrumentIsDefaultDocument, options);
      }
export type UpdatePaymentInstrumentIsDefaultMutationHookResult = ReturnType<typeof useUpdatePaymentInstrumentIsDefaultMutation>;
export type UpdatePaymentInstrumentIsDefaultMutationResult = Apollo.MutationResult<UpdatePaymentInstrumentIsDefaultMutation>;
export type UpdatePaymentInstrumentIsDefaultMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentInstrumentIsDefaultMutation, UpdatePaymentInstrumentIsDefaultMutationVariables>;
export const ForceSendReceiptDocument = gql`
    mutation ForceSendReceipt($courierId: ID!, $paymentTransferId: ID!, $emailRecipients: [String!]!) {
  forceSendReceipt(
    courierId: $courierId
    paymentTransferId: $paymentTransferId
    emailRecipients: $emailRecipients
  )
}
    `;
export type ForceSendReceiptMutationFn = Apollo.MutationFunction<ForceSendReceiptMutation, ForceSendReceiptMutationVariables>;

/**
 * __useForceSendReceiptMutation__
 *
 * To run a mutation, you first call `useForceSendReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceSendReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceSendReceiptMutation, { data, loading, error }] = useForceSendReceiptMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      paymentTransferId: // value for 'paymentTransferId'
 *      emailRecipients: // value for 'emailRecipients'
 *   },
 * });
 */
export function useForceSendReceiptMutation(baseOptions?: Apollo.MutationHookOptions<ForceSendReceiptMutation, ForceSendReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceSendReceiptMutation, ForceSendReceiptMutationVariables>(ForceSendReceiptDocument, options);
      }
export type ForceSendReceiptMutationHookResult = ReturnType<typeof useForceSendReceiptMutation>;
export type ForceSendReceiptMutationResult = Apollo.MutationResult<ForceSendReceiptMutation>;
export type ForceSendReceiptMutationOptions = Apollo.BaseMutationOptions<ForceSendReceiptMutation, ForceSendReceiptMutationVariables>;
export const PaymentTransfersPaginatedDocument = gql`
    query PaymentTransfersPaginated($courierId: ID!, $endCustomerIdsFilter: [ID!], $statusFilter: [PaymentTransferStatus!], $refundTypes: [PaymentTransferRefundType!], $invoiceIds: [ID!], $settlementIds: [ID!], $limit: Int!, $after: Int!) {
  paymentTransfersPaginated(
    courierId: $courierId
    endCustomerIdsFilter: $endCustomerIdsFilter
    statusFilter: $statusFilter
    refundTypes: $refundTypes
    invoiceIds: $invoiceIds
    settlementIds: $settlementIds
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...PaymentTransferFragment
        sourcePaymentInstrument {
          ...PaymentInstrumentFragment
        }
        invoicePayments {
          ...InvoicePaymentFragment
          invoice {
            ...InvoiceFragment
          }
        }
        parentPaymentTransfer {
          ...PaymentTransferFragment
        }
        endCustomer {
          ...EndCustomerFragment
        }
        paymentAdditionalFees {
          ...PaymentAdditionalFeeFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PaymentTransferFragmentFragmentDoc}
${PaymentInstrumentFragmentFragmentDoc}
${InvoicePaymentFragmentFragmentDoc}
${InvoiceFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${PaymentAdditionalFeeFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __usePaymentTransfersPaginatedQuery__
 *
 * To run a query within a React component, call `usePaymentTransfersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTransfersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTransfersPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      statusFilter: // value for 'statusFilter'
 *      refundTypes: // value for 'refundTypes'
 *      invoiceIds: // value for 'invoiceIds'
 *      settlementIds: // value for 'settlementIds'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaymentTransfersPaginatedQuery(baseOptions: Apollo.QueryHookOptions<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>(PaymentTransfersPaginatedDocument, options);
      }
export function usePaymentTransfersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>(PaymentTransfersPaginatedDocument, options);
        }
export type PaymentTransfersPaginatedQueryHookResult = ReturnType<typeof usePaymentTransfersPaginatedQuery>;
export type PaymentTransfersPaginatedLazyQueryHookResult = ReturnType<typeof usePaymentTransfersPaginatedLazyQuery>;
export type PaymentTransfersPaginatedQueryResult = Apollo.QueryResult<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>;
export const PaymentInstrumentsDocument = gql`
    query PaymentInstruments($courierId: ID!, $endCustomerIds: [ID!]!) {
  paymentInstruments(courierId: $courierId, endCustomerIds: $endCustomerIds) {
    ...PaymentInstrumentFragment
  }
}
    ${PaymentInstrumentFragmentFragmentDoc}`;

/**
 * __usePaymentInstrumentsQuery__
 *
 * To run a query within a React component, call `usePaymentInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInstrumentsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *   },
 * });
 */
export function usePaymentInstrumentsQuery(baseOptions: Apollo.QueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>(PaymentInstrumentsDocument, options);
      }
export function usePaymentInstrumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>(PaymentInstrumentsDocument, options);
        }
export type PaymentInstrumentsQueryHookResult = ReturnType<typeof usePaymentInstrumentsQuery>;
export type PaymentInstrumentsLazyQueryHookResult = ReturnType<typeof usePaymentInstrumentsLazyQuery>;
export type PaymentInstrumentsQueryResult = Apollo.QueryResult<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>;
export const PaymentSettlementsPaginatedDocument = gql`
    query PaymentSettlementsPaginated($courierId: ID!, $limit: Int!, $after: Int!) {
  paymentSettlementsPaginated(courierId: $courierId, limit: $limit, after: $after) {
    edges {
      node {
        ...PaymentSettlementFragment
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PaymentSettlementFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __usePaymentSettlementsPaginatedQuery__
 *
 * To run a query within a React component, call `usePaymentSettlementsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentSettlementsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentSettlementsPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaymentSettlementsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>(PaymentSettlementsPaginatedDocument, options);
      }
export function usePaymentSettlementsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>(PaymentSettlementsPaginatedDocument, options);
        }
export type PaymentSettlementsPaginatedQueryHookResult = ReturnType<typeof usePaymentSettlementsPaginatedQuery>;
export type PaymentSettlementsPaginatedLazyQueryHookResult = ReturnType<typeof usePaymentSettlementsPaginatedLazyQuery>;
export type PaymentSettlementsPaginatedQueryResult = Apollo.QueryResult<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>;
export const FeeTransfersPaginatedDocument = gql`
    query FeeTransfersPaginated($courierId: ID!, $settlementIds: [ID!], $limit: Int!, $after: Int!) {
  feeTransfersPaginated(
    courierId: $courierId
    settlementIds: $settlementIds
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...FeeTransferFragment
        parentPaymentTransfer {
          ...PaymentTransferFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${FeeTransferFragmentFragmentDoc}
${PaymentTransferFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useFeeTransfersPaginatedQuery__
 *
 * To run a query within a React component, call `useFeeTransfersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeeTransfersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeeTransfersPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      settlementIds: // value for 'settlementIds'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeeTransfersPaginatedQuery(baseOptions: Apollo.QueryHookOptions<FeeTransfersPaginatedQuery, FeeTransfersPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeeTransfersPaginatedQuery, FeeTransfersPaginatedQueryVariables>(FeeTransfersPaginatedDocument, options);
      }
export function useFeeTransfersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeeTransfersPaginatedQuery, FeeTransfersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeeTransfersPaginatedQuery, FeeTransfersPaginatedQueryVariables>(FeeTransfersPaginatedDocument, options);
        }
export type FeeTransfersPaginatedQueryHookResult = ReturnType<typeof useFeeTransfersPaginatedQuery>;
export type FeeTransfersPaginatedLazyQueryHookResult = ReturnType<typeof useFeeTransfersPaginatedLazyQuery>;
export type FeeTransfersPaginatedQueryResult = Apollo.QueryResult<FeeTransfersPaginatedQuery, FeeTransfersPaginatedQueryVariables>;
export const InitiateInvoiceRefundDocument = gql`
    mutation InitiateInvoiceRefund($courierId: ID!, $parentPaymentTransferId: ID!, $amount: Money!, $idempotencyToken: String!, $createdBy: String!) {
  initiateInvoiceRefund(
    courierId: $courierId
    parentPaymentTransferId: $parentPaymentTransferId
    amount: $amount
    idempotencyToken: $idempotencyToken
    createdBy: $createdBy
  ) {
    ...InvoicePaymentFields
  }
}
    ${InvoicePaymentFieldsFragmentDoc}`;
export type InitiateInvoiceRefundMutationFn = Apollo.MutationFunction<InitiateInvoiceRefundMutation, InitiateInvoiceRefundMutationVariables>;

/**
 * __useInitiateInvoiceRefundMutation__
 *
 * To run a mutation, you first call `useInitiateInvoiceRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateInvoiceRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateInvoiceRefundMutation, { data, loading, error }] = useInitiateInvoiceRefundMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      parentPaymentTransferId: // value for 'parentPaymentTransferId'
 *      amount: // value for 'amount'
 *      idempotencyToken: // value for 'idempotencyToken'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useInitiateInvoiceRefundMutation(baseOptions?: Apollo.MutationHookOptions<InitiateInvoiceRefundMutation, InitiateInvoiceRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateInvoiceRefundMutation, InitiateInvoiceRefundMutationVariables>(InitiateInvoiceRefundDocument, options);
      }
export type InitiateInvoiceRefundMutationHookResult = ReturnType<typeof useInitiateInvoiceRefundMutation>;
export type InitiateInvoiceRefundMutationResult = Apollo.MutationResult<InitiateInvoiceRefundMutation>;
export type InitiateInvoiceRefundMutationOptions = Apollo.BaseMutationOptions<InitiateInvoiceRefundMutation, InitiateInvoiceRefundMutationVariables>;
export const GetInvoiceBalancesDocument = gql`
    query GetInvoiceBalances($courierId: ID!, $invoiceIds: [ID!]!) {
  invoiceBalances(courierId: $courierId, invoiceIds: $invoiceIds) {
    ...InvoiceBalanceFields
  }
}
    ${InvoiceBalanceFieldsFragmentDoc}`;

/**
 * __useGetInvoiceBalancesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceBalancesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useGetInvoiceBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>(GetInvoiceBalancesDocument, options);
      }
export function useGetInvoiceBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>(GetInvoiceBalancesDocument, options);
        }
export type GetInvoiceBalancesQueryHookResult = ReturnType<typeof useGetInvoiceBalancesQuery>;
export type GetInvoiceBalancesLazyQueryHookResult = ReturnType<typeof useGetInvoiceBalancesLazyQuery>;
export type GetInvoiceBalancesQueryResult = Apollo.QueryResult<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>;
export const UpsertPayrollSettingsDocument = gql`
    mutation UpsertPayrollSettings($courierId: ID!, $defaultCommission: Float!, $payPeriodType: PayPeriodType!, $payPeriodStartDate: Date, $ordersInclusionType: PayrollOrdersInclusionType, $driverPayExportType: DriverPayExportType) {
  upsertPayrollSettings(
    courierId: $courierId
    defaultCommission: $defaultCommission
    payPeriodType: $payPeriodType
    payPeriodStartDate: $payPeriodStartDate
    ordersInclusionType: $ordersInclusionType
    driverPayExportType: $driverPayExportType
  ) {
    ...PayrollSettingFragment
  }
}
    ${PayrollSettingFragmentFragmentDoc}`;
export type UpsertPayrollSettingsMutationFn = Apollo.MutationFunction<UpsertPayrollSettingsMutation, UpsertPayrollSettingsMutationVariables>;

/**
 * __useUpsertPayrollSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertPayrollSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPayrollSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPayrollSettingsMutation, { data, loading, error }] = useUpsertPayrollSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      defaultCommission: // value for 'defaultCommission'
 *      payPeriodType: // value for 'payPeriodType'
 *      payPeriodStartDate: // value for 'payPeriodStartDate'
 *      ordersInclusionType: // value for 'ordersInclusionType'
 *      driverPayExportType: // value for 'driverPayExportType'
 *   },
 * });
 */
export function useUpsertPayrollSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPayrollSettingsMutation, UpsertPayrollSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPayrollSettingsMutation, UpsertPayrollSettingsMutationVariables>(UpsertPayrollSettingsDocument, options);
      }
export type UpsertPayrollSettingsMutationHookResult = ReturnType<typeof useUpsertPayrollSettingsMutation>;
export type UpsertPayrollSettingsMutationResult = Apollo.MutationResult<UpsertPayrollSettingsMutation>;
export type UpsertPayrollSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertPayrollSettingsMutation, UpsertPayrollSettingsMutationVariables>;
export const GetOrGenerateDriverPayEntriesDocument = gql`
    mutation GetOrGenerateDriverPayEntries($courierId: ID!, $startDate: Date!, $endDate: Date!, $driverSearch: String, $sortFields: [DriverPayrollSorting!], $driverLabelIds: [ID!]) {
  getOrGenerateDriverPayEntries(
    courierId: $courierId
    startDate: $startDate
    endDate: $endDate
    driverSearch: $driverSearch
    sortFields: $sortFields
    driverLabelIds: $driverLabelIds
  ) {
    ...DriverPayEntryFragment
    driver {
      ...DriverFragment
    }
    remoteEntities {
      ...RemoteEntityFragment
    }
  }
}
    ${DriverPayEntryFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}`;
export type GetOrGenerateDriverPayEntriesMutationFn = Apollo.MutationFunction<GetOrGenerateDriverPayEntriesMutation, GetOrGenerateDriverPayEntriesMutationVariables>;

/**
 * __useGetOrGenerateDriverPayEntriesMutation__
 *
 * To run a mutation, you first call `useGetOrGenerateDriverPayEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrGenerateDriverPayEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrGenerateDriverPayEntriesMutation, { data, loading, error }] = useGetOrGenerateDriverPayEntriesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      driverSearch: // value for 'driverSearch'
 *      sortFields: // value for 'sortFields'
 *      driverLabelIds: // value for 'driverLabelIds'
 *   },
 * });
 */
export function useGetOrGenerateDriverPayEntriesMutation(baseOptions?: Apollo.MutationHookOptions<GetOrGenerateDriverPayEntriesMutation, GetOrGenerateDriverPayEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrGenerateDriverPayEntriesMutation, GetOrGenerateDriverPayEntriesMutationVariables>(GetOrGenerateDriverPayEntriesDocument, options);
      }
export type GetOrGenerateDriverPayEntriesMutationHookResult = ReturnType<typeof useGetOrGenerateDriverPayEntriesMutation>;
export type GetOrGenerateDriverPayEntriesMutationResult = Apollo.MutationResult<GetOrGenerateDriverPayEntriesMutation>;
export type GetOrGenerateDriverPayEntriesMutationOptions = Apollo.BaseMutationOptions<GetOrGenerateDriverPayEntriesMutation, GetOrGenerateDriverPayEntriesMutationVariables>;
export const GeneratePayrollReportDocument = gql`
    mutation GeneratePayrollReport($courierId: ID!, $driverIds: [ID!], $startDate: Date!, $endDate: Date!) {
  generatePayrollReport(
    courierId: $courierId
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...PayrollReportFileFragment
  }
}
    ${PayrollReportFileFragmentFragmentDoc}`;
export type GeneratePayrollReportMutationFn = Apollo.MutationFunction<GeneratePayrollReportMutation, GeneratePayrollReportMutationVariables>;

/**
 * __useGeneratePayrollReportMutation__
 *
 * To run a mutation, you first call `useGeneratePayrollReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePayrollReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePayrollReportMutation, { data, loading, error }] = useGeneratePayrollReportMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGeneratePayrollReportMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePayrollReportMutation, GeneratePayrollReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePayrollReportMutation, GeneratePayrollReportMutationVariables>(GeneratePayrollReportDocument, options);
      }
export type GeneratePayrollReportMutationHookResult = ReturnType<typeof useGeneratePayrollReportMutation>;
export type GeneratePayrollReportMutationResult = Apollo.MutationResult<GeneratePayrollReportMutation>;
export type GeneratePayrollReportMutationOptions = Apollo.BaseMutationOptions<GeneratePayrollReportMutation, GeneratePayrollReportMutationVariables>;
export const SendEmailToDriversDocument = gql`
    mutation SendEmailToDrivers($courierId: ID!, $driverPayEntryId: ID!, $recipients: [String!]!) {
  sendEmailToDrivers(
    courierId: $courierId
    driverPayEntryId: $driverPayEntryId
    recipients: $recipients
  ) {
    id
    driverPayEntryId
    driverId
    fileId
    recipients
    emailId
  }
}
    `;
export type SendEmailToDriversMutationFn = Apollo.MutationFunction<SendEmailToDriversMutation, SendEmailToDriversMutationVariables>;

/**
 * __useSendEmailToDriversMutation__
 *
 * To run a mutation, you first call `useSendEmailToDriversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToDriversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToDriversMutation, { data, loading, error }] = useSendEmailToDriversMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *      recipients: // value for 'recipients'
 *   },
 * });
 */
export function useSendEmailToDriversMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailToDriversMutation, SendEmailToDriversMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailToDriversMutation, SendEmailToDriversMutationVariables>(SendEmailToDriversDocument, options);
      }
export type SendEmailToDriversMutationHookResult = ReturnType<typeof useSendEmailToDriversMutation>;
export type SendEmailToDriversMutationResult = Apollo.MutationResult<SendEmailToDriversMutation>;
export type SendEmailToDriversMutationOptions = Apollo.BaseMutationOptions<SendEmailToDriversMutation, SendEmailToDriversMutationVariables>;
export const ApproveDriverPayDocument = gql`
    mutation ApproveDriverPay($courierId: ID!, $driverPayEntryId: ID!) {
  approveDriverPay(courierId: $courierId, driverPayEntryId: $driverPayEntryId) {
    ...DriverPayEntryFragment
  }
}
    ${DriverPayEntryFragmentFragmentDoc}`;
export type ApproveDriverPayMutationFn = Apollo.MutationFunction<ApproveDriverPayMutation, ApproveDriverPayMutationVariables>;

/**
 * __useApproveDriverPayMutation__
 *
 * To run a mutation, you first call `useApproveDriverPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDriverPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDriverPayMutation, { data, loading, error }] = useApproveDriverPayMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *   },
 * });
 */
export function useApproveDriverPayMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDriverPayMutation, ApproveDriverPayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveDriverPayMutation, ApproveDriverPayMutationVariables>(ApproveDriverPayDocument, options);
      }
export type ApproveDriverPayMutationHookResult = ReturnType<typeof useApproveDriverPayMutation>;
export type ApproveDriverPayMutationResult = Apollo.MutationResult<ApproveDriverPayMutation>;
export type ApproveDriverPayMutationOptions = Apollo.BaseMutationOptions<ApproveDriverPayMutation, ApproveDriverPayMutationVariables>;
export const BulkApproveDriverPaysDocument = gql`
    mutation BulkApproveDriverPays($courierId: ID!, $driverPayEntryIds: [ID!]!) {
  bulkApproveDriverPays(
    courierId: $courierId
    driverPayEntryIds: $driverPayEntryIds
  ) {
    approvedEntries {
      ...DriverPayEntryFragment
    }
    failures {
      id
      failure
    }
  }
}
    ${DriverPayEntryFragmentFragmentDoc}`;
export type BulkApproveDriverPaysMutationFn = Apollo.MutationFunction<BulkApproveDriverPaysMutation, BulkApproveDriverPaysMutationVariables>;

/**
 * __useBulkApproveDriverPaysMutation__
 *
 * To run a mutation, you first call `useBulkApproveDriverPaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkApproveDriverPaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkApproveDriverPaysMutation, { data, loading, error }] = useBulkApproveDriverPaysMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverPayEntryIds: // value for 'driverPayEntryIds'
 *   },
 * });
 */
export function useBulkApproveDriverPaysMutation(baseOptions?: Apollo.MutationHookOptions<BulkApproveDriverPaysMutation, BulkApproveDriverPaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkApproveDriverPaysMutation, BulkApproveDriverPaysMutationVariables>(BulkApproveDriverPaysDocument, options);
      }
export type BulkApproveDriverPaysMutationHookResult = ReturnType<typeof useBulkApproveDriverPaysMutation>;
export type BulkApproveDriverPaysMutationResult = Apollo.MutationResult<BulkApproveDriverPaysMutation>;
export type BulkApproveDriverPaysMutationOptions = Apollo.BaseMutationOptions<BulkApproveDriverPaysMutation, BulkApproveDriverPaysMutationVariables>;
export const ModifyDriverPayDeductionsDocument = gql`
    mutation ModifyDriverPayDeductions($courierId: ID!, $driverPayEntryId: ID!, $deductionsToAdd: [DriverPayDeductionValueInput!]!, $deductionIdsToRemove: [ID!]!) {
  modifyDriverPayDeductions(
    courierId: $courierId
    driverPayEntryId: $driverPayEntryId
    deductionsToAdd: $deductionsToAdd
    deductionIdsToRemove: $deductionIdsToRemove
  ) {
    ...DriverPayEntryFragment
  }
}
    ${DriverPayEntryFragmentFragmentDoc}`;
export type ModifyDriverPayDeductionsMutationFn = Apollo.MutationFunction<ModifyDriverPayDeductionsMutation, ModifyDriverPayDeductionsMutationVariables>;

/**
 * __useModifyDriverPayDeductionsMutation__
 *
 * To run a mutation, you first call `useModifyDriverPayDeductionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyDriverPayDeductionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyDriverPayDeductionsMutation, { data, loading, error }] = useModifyDriverPayDeductionsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *      deductionsToAdd: // value for 'deductionsToAdd'
 *      deductionIdsToRemove: // value for 'deductionIdsToRemove'
 *   },
 * });
 */
export function useModifyDriverPayDeductionsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyDriverPayDeductionsMutation, ModifyDriverPayDeductionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyDriverPayDeductionsMutation, ModifyDriverPayDeductionsMutationVariables>(ModifyDriverPayDeductionsDocument, options);
      }
export type ModifyDriverPayDeductionsMutationHookResult = ReturnType<typeof useModifyDriverPayDeductionsMutation>;
export type ModifyDriverPayDeductionsMutationResult = Apollo.MutationResult<ModifyDriverPayDeductionsMutation>;
export type ModifyDriverPayDeductionsMutationOptions = Apollo.BaseMutationOptions<ModifyDriverPayDeductionsMutation, ModifyDriverPayDeductionsMutationVariables>;
export const ForceExportDriverPayDocument = gql`
    mutation ForceExportDriverPay($courierId: ID!, $driverPayEntryId: ID!, $provider: ApiProvider!) {
  forceExportDriverPay(
    courierId: $courierId
    driverPayEntryId: $driverPayEntryId
    provider: $provider
  ) {
    ...DriverPayEntryFragment
  }
}
    ${DriverPayEntryFragmentFragmentDoc}`;
export type ForceExportDriverPayMutationFn = Apollo.MutationFunction<ForceExportDriverPayMutation, ForceExportDriverPayMutationVariables>;

/**
 * __useForceExportDriverPayMutation__
 *
 * To run a mutation, you first call `useForceExportDriverPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceExportDriverPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceExportDriverPayMutation, { data, loading, error }] = useForceExportDriverPayMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useForceExportDriverPayMutation(baseOptions?: Apollo.MutationHookOptions<ForceExportDriverPayMutation, ForceExportDriverPayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceExportDriverPayMutation, ForceExportDriverPayMutationVariables>(ForceExportDriverPayDocument, options);
      }
export type ForceExportDriverPayMutationHookResult = ReturnType<typeof useForceExportDriverPayMutation>;
export type ForceExportDriverPayMutationResult = Apollo.MutationResult<ForceExportDriverPayMutation>;
export type ForceExportDriverPayMutationOptions = Apollo.BaseMutationOptions<ForceExportDriverPayMutation, ForceExportDriverPayMutationVariables>;
export const CreatePayrollDeductionRuleDocument = gql`
    mutation CreatePayrollDeductionRule($courierId: ID!, $name: String!, $amount: Money!, $amountType: PayrollDeductionAmountType!, $ruleType: PayrollDeductionRuleType!, $driverIds: [ID!], $startDate: Date, $endDate: Date) {
  createPayrollDeductionRule(
    courierId: $courierId
    name: $name
    amount: $amount
    amountType: $amountType
    ruleType: $ruleType
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...PayrollDeductionRuleFragment
  }
}
    ${PayrollDeductionRuleFragmentFragmentDoc}`;
export type CreatePayrollDeductionRuleMutationFn = Apollo.MutationFunction<CreatePayrollDeductionRuleMutation, CreatePayrollDeductionRuleMutationVariables>;

/**
 * __useCreatePayrollDeductionRuleMutation__
 *
 * To run a mutation, you first call `useCreatePayrollDeductionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayrollDeductionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayrollDeductionRuleMutation, { data, loading, error }] = useCreatePayrollDeductionRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      amount: // value for 'amount'
 *      amountType: // value for 'amountType'
 *      ruleType: // value for 'ruleType'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreatePayrollDeductionRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayrollDeductionRuleMutation, CreatePayrollDeductionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayrollDeductionRuleMutation, CreatePayrollDeductionRuleMutationVariables>(CreatePayrollDeductionRuleDocument, options);
      }
export type CreatePayrollDeductionRuleMutationHookResult = ReturnType<typeof useCreatePayrollDeductionRuleMutation>;
export type CreatePayrollDeductionRuleMutationResult = Apollo.MutationResult<CreatePayrollDeductionRuleMutation>;
export type CreatePayrollDeductionRuleMutationOptions = Apollo.BaseMutationOptions<CreatePayrollDeductionRuleMutation, CreatePayrollDeductionRuleMutationVariables>;
export const FullUpdatePayrollDeductionRuleDocument = gql`
    mutation FullUpdatePayrollDeductionRule($courierId: ID!, $id: ID!, $name: String!, $amount: Money!, $amountType: PayrollDeductionAmountType!, $ruleType: PayrollDeductionRuleType!, $driverIds: [ID!], $startDate: Date, $endDate: Date) {
  fullUpdatePayrollDeductionRule(
    courierId: $courierId
    id: $id
    name: $name
    amount: $amount
    amountType: $amountType
    ruleType: $ruleType
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...PayrollDeductionRuleFragment
  }
}
    ${PayrollDeductionRuleFragmentFragmentDoc}`;
export type FullUpdatePayrollDeductionRuleMutationFn = Apollo.MutationFunction<FullUpdatePayrollDeductionRuleMutation, FullUpdatePayrollDeductionRuleMutationVariables>;

/**
 * __useFullUpdatePayrollDeductionRuleMutation__
 *
 * To run a mutation, you first call `useFullUpdatePayrollDeductionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdatePayrollDeductionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdatePayrollDeductionRuleMutation, { data, loading, error }] = useFullUpdatePayrollDeductionRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      amount: // value for 'amount'
 *      amountType: // value for 'amountType'
 *      ruleType: // value for 'ruleType'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useFullUpdatePayrollDeductionRuleMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdatePayrollDeductionRuleMutation, FullUpdatePayrollDeductionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdatePayrollDeductionRuleMutation, FullUpdatePayrollDeductionRuleMutationVariables>(FullUpdatePayrollDeductionRuleDocument, options);
      }
export type FullUpdatePayrollDeductionRuleMutationHookResult = ReturnType<typeof useFullUpdatePayrollDeductionRuleMutation>;
export type FullUpdatePayrollDeductionRuleMutationResult = Apollo.MutationResult<FullUpdatePayrollDeductionRuleMutation>;
export type FullUpdatePayrollDeductionRuleMutationOptions = Apollo.BaseMutationOptions<FullUpdatePayrollDeductionRuleMutation, FullUpdatePayrollDeductionRuleMutationVariables>;
export const DeletePayrollDeductionRuleDocument = gql`
    mutation DeletePayrollDeductionRule($courierId: ID!, $id: ID!) {
  deletePayrollDeductionRule(courierId: $courierId, id: $id) {
    ...PayrollDeductionRuleFragment
  }
}
    ${PayrollDeductionRuleFragmentFragmentDoc}`;
export type DeletePayrollDeductionRuleMutationFn = Apollo.MutationFunction<DeletePayrollDeductionRuleMutation, DeletePayrollDeductionRuleMutationVariables>;

/**
 * __useDeletePayrollDeductionRuleMutation__
 *
 * To run a mutation, you first call `useDeletePayrollDeductionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayrollDeductionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayrollDeductionRuleMutation, { data, loading, error }] = useDeletePayrollDeductionRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePayrollDeductionRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayrollDeductionRuleMutation, DeletePayrollDeductionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayrollDeductionRuleMutation, DeletePayrollDeductionRuleMutationVariables>(DeletePayrollDeductionRuleDocument, options);
      }
export type DeletePayrollDeductionRuleMutationHookResult = ReturnType<typeof useDeletePayrollDeductionRuleMutation>;
export type DeletePayrollDeductionRuleMutationResult = Apollo.MutationResult<DeletePayrollDeductionRuleMutation>;
export type DeletePayrollDeductionRuleMutationOptions = Apollo.BaseMutationOptions<DeletePayrollDeductionRuleMutation, DeletePayrollDeductionRuleMutationVariables>;
export const GetPayPeriodsDocument = gql`
    query GetPayPeriods($courierId: ID!, $minDate: Date!, $maxDate: Date!) {
  payPeriods(courierId: $courierId, minDate: $minDate, maxDate: $maxDate) {
    ...PayPeriodFragment
  }
}
    ${PayPeriodFragmentFragmentDoc}`;

/**
 * __useGetPayPeriodsQuery__
 *
 * To run a query within a React component, call `useGetPayPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayPeriodsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetPayPeriodsQuery(baseOptions: Apollo.QueryHookOptions<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>(GetPayPeriodsDocument, options);
      }
export function useGetPayPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>(GetPayPeriodsDocument, options);
        }
export type GetPayPeriodsQueryHookResult = ReturnType<typeof useGetPayPeriodsQuery>;
export type GetPayPeriodsLazyQueryHookResult = ReturnType<typeof useGetPayPeriodsLazyQuery>;
export type GetPayPeriodsQueryResult = Apollo.QueryResult<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>;
export const GetPayrollSettingsDocument = gql`
    query GetPayrollSettings($courierId: ID!) {
  payrollSettings(courierId: $courierId) {
    ...PayrollSettingFragment
  }
}
    ${PayrollSettingFragmentFragmentDoc}`;

/**
 * __useGetPayrollSettingsQuery__
 *
 * To run a query within a React component, call `useGetPayrollSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayrollSettingsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetPayrollSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>(GetPayrollSettingsDocument, options);
      }
export function useGetPayrollSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>(GetPayrollSettingsDocument, options);
        }
export type GetPayrollSettingsQueryHookResult = ReturnType<typeof useGetPayrollSettingsQuery>;
export type GetPayrollSettingsLazyQueryHookResult = ReturnType<typeof useGetPayrollSettingsLazyQuery>;
export type GetPayrollSettingsQueryResult = Apollo.QueryResult<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>;
export const CustomDeductionsDocument = gql`
    query CustomDeductions($courierId: ID!, $driverPayEntryId: ID!) {
  customDeductions(courierId: $courierId, driverPayEntryId: $driverPayEntryId) {
    id
    name
    amount
  }
}
    `;

/**
 * __useCustomDeductionsQuery__
 *
 * To run a query within a React component, call `useCustomDeductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDeductionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDeductionsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *   },
 * });
 */
export function useCustomDeductionsQuery(baseOptions: Apollo.QueryHookOptions<CustomDeductionsQuery, CustomDeductionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDeductionsQuery, CustomDeductionsQueryVariables>(CustomDeductionsDocument, options);
      }
export function useCustomDeductionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDeductionsQuery, CustomDeductionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDeductionsQuery, CustomDeductionsQueryVariables>(CustomDeductionsDocument, options);
        }
export type CustomDeductionsQueryHookResult = ReturnType<typeof useCustomDeductionsQuery>;
export type CustomDeductionsLazyQueryHookResult = ReturnType<typeof useCustomDeductionsLazyQuery>;
export type CustomDeductionsQueryResult = Apollo.QueryResult<CustomDeductionsQuery, CustomDeductionsQueryVariables>;
export const PayrollDeductionRulesPaginatedDocument = gql`
    query PayrollDeductionRulesPaginated($courierId: ID!, $limit: Int!, $after: Int!, $sortFields: [PayrollDeductionRuleSorting!]) {
  payrollDeductionRulesPaginated(
    courierId: $courierId
    limit: $limit
    after: $after
    sortFields: $sortFields
  ) {
    edges {
      node {
        ...PayrollDeductionRuleFragment
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PayrollDeductionRuleFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __usePayrollDeductionRulesPaginatedQuery__
 *
 * To run a query within a React component, call `usePayrollDeductionRulesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollDeductionRulesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollDeductionRulesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function usePayrollDeductionRulesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>(PayrollDeductionRulesPaginatedDocument, options);
      }
export function usePayrollDeductionRulesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>(PayrollDeductionRulesPaginatedDocument, options);
        }
export type PayrollDeductionRulesPaginatedQueryHookResult = ReturnType<typeof usePayrollDeductionRulesPaginatedQuery>;
export type PayrollDeductionRulesPaginatedLazyQueryHookResult = ReturnType<typeof usePayrollDeductionRulesPaginatedLazyQuery>;
export type PayrollDeductionRulesPaginatedQueryResult = Apollo.QueryResult<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>;
export const OrderPayBreakDownWithAllocationsDocument = gql`
    query OrderPayBreakDownWithAllocations($courierId: ID!, $orderId: ID!) {
  orderPayBreakDownWithAllocations(courierId: $courierId, orderId: $orderId) {
    allocations {
      driverId
      allocationRate
      allocationAmount
      breakdown {
        items {
          name
          description
          amount
        }
        total
      }
      driver {
        id
        firstName
        lastName
      }
    }
    isOverride
    total
  }
}
    `;

/**
 * __useOrderPayBreakDownWithAllocationsQuery__
 *
 * To run a query within a React component, call `useOrderPayBreakDownWithAllocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPayBreakDownWithAllocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPayBreakDownWithAllocationsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderPayBreakDownWithAllocationsQuery(baseOptions: Apollo.QueryHookOptions<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>(OrderPayBreakDownWithAllocationsDocument, options);
      }
export function useOrderPayBreakDownWithAllocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>(OrderPayBreakDownWithAllocationsDocument, options);
        }
export type OrderPayBreakDownWithAllocationsQueryHookResult = ReturnType<typeof useOrderPayBreakDownWithAllocationsQuery>;
export type OrderPayBreakDownWithAllocationsLazyQueryHookResult = ReturnType<typeof useOrderPayBreakDownWithAllocationsLazyQuery>;
export type OrderPayBreakDownWithAllocationsQueryResult = Apollo.QueryResult<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>;
export const PreviewPriceDocument = gql`
    mutation PreviewPrice($courierId: ID!, $googlePlaceIds: [String!]!, $serviceTypeId: String, $requestedPricingAdjustments: [PricingAdjustmentCreate!], $customFieldValues: [CustomFieldValueInput!], $endCustomerId: ID, $shipmentType: ShipmentType, $packageSize: PackageSize, $packageWeight: Float, $packageCount: Int, $packageTypeId: ID, $vehicleTypeId: ID, $shipmentDate: Date, $timeWindows: [TimeWindowInput!], $packageItems: [PackageItemInput!], $orderAcquisitionType: OrderAcquisitionType, $stopTypes: [ShipmentStopType!], $basePriceOverride: Money, $priceOverride: Money) {
  previewPrice(
    courierId: $courierId
    googlePlaceIds: $googlePlaceIds
    serviceTypeId: $serviceTypeId
    requestedPricingAdjustments: $requestedPricingAdjustments
    customFieldValues: $customFieldValues
    endCustomerId: $endCustomerId
    shipmentType: $shipmentType
    packageSize: $packageSize
    packageWeight: $packageWeight
    packageCount: $packageCount
    packageTypeId: $packageTypeId
    vehicleTypeId: $vehicleTypeId
    shipmentDate: $shipmentDate
    timeWindows: $timeWindows
    packageItems: $packageItems
    orderAcquisitionType: $orderAcquisitionType
    stopTypes: $stopTypes
    basePriceOverride: $basePriceOverride
    priceOverride: $priceOverride
  ) {
    taxBreakDown {
      taxItems {
        name
        amount
      }
      totalTaxAmount
    }
    totalAfterTax
    total
    breakdown {
      ...PricingBreakDownFragment
    }
    pricingListId
    pricingList {
      ...PricingListFragment
    }
    orderPrice {
      tripPrices {
        amount
        durationsInSeconds
        miles
        packageWeightInLbs
        pricingMultiplier
        pricingRuleDisplay
        readyTimeList
        selectedPricingRuleId
        unfreeMiles
      }
      pricingBreakDown {
        items {
          name
          amount
          description
          isAdjustmentOverride
          isBasePrice
          surchargePricingRuleId
        }
      }
    }
  }
}
    ${PricingBreakDownFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}`;
export type PreviewPriceMutationFn = Apollo.MutationFunction<PreviewPriceMutation, PreviewPriceMutationVariables>;

/**
 * __usePreviewPriceMutation__
 *
 * To run a mutation, you first call `usePreviewPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewPriceMutation, { data, loading, error }] = usePreviewPriceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      googlePlaceIds: // value for 'googlePlaceIds'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      requestedPricingAdjustments: // value for 'requestedPricingAdjustments'
 *      customFieldValues: // value for 'customFieldValues'
 *      endCustomerId: // value for 'endCustomerId'
 *      shipmentType: // value for 'shipmentType'
 *      packageSize: // value for 'packageSize'
 *      packageWeight: // value for 'packageWeight'
 *      packageCount: // value for 'packageCount'
 *      packageTypeId: // value for 'packageTypeId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      shipmentDate: // value for 'shipmentDate'
 *      timeWindows: // value for 'timeWindows'
 *      packageItems: // value for 'packageItems'
 *      orderAcquisitionType: // value for 'orderAcquisitionType'
 *      stopTypes: // value for 'stopTypes'
 *      basePriceOverride: // value for 'basePriceOverride'
 *      priceOverride: // value for 'priceOverride'
 *   },
 * });
 */
export function usePreviewPriceMutation(baseOptions?: Apollo.MutationHookOptions<PreviewPriceMutation, PreviewPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewPriceMutation, PreviewPriceMutationVariables>(PreviewPriceDocument, options);
      }
export type PreviewPriceMutationHookResult = ReturnType<typeof usePreviewPriceMutation>;
export type PreviewPriceMutationResult = Apollo.MutationResult<PreviewPriceMutation>;
export type PreviewPriceMutationOptions = Apollo.BaseMutationOptions<PreviewPriceMutation, PreviewPriceMutationVariables>;
export const CreatePricingRuleDocument = gql`
    mutation CreatePricingRule($courierId: ID!, $pricingRuleCreate: PricingRuleCreate!) {
  createPricingRule(courierId: $courierId, pricingRuleCreate: $pricingRuleCreate) {
    ...PricingRuleFragment
  }
}
    ${PricingRuleFragmentFragmentDoc}`;
export type CreatePricingRuleMutationFn = Apollo.MutationFunction<CreatePricingRuleMutation, CreatePricingRuleMutationVariables>;

/**
 * __useCreatePricingRuleMutation__
 *
 * To run a mutation, you first call `useCreatePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPricingRuleMutation, { data, loading, error }] = useCreatePricingRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingRuleCreate: // value for 'pricingRuleCreate'
 *   },
 * });
 */
export function useCreatePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePricingRuleMutation, CreatePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePricingRuleMutation, CreatePricingRuleMutationVariables>(CreatePricingRuleDocument, options);
      }
export type CreatePricingRuleMutationHookResult = ReturnType<typeof useCreatePricingRuleMutation>;
export type CreatePricingRuleMutationResult = Apollo.MutationResult<CreatePricingRuleMutation>;
export type CreatePricingRuleMutationOptions = Apollo.BaseMutationOptions<CreatePricingRuleMutation, CreatePricingRuleMutationVariables>;
export const CreateSurchargePricingRuleDocument = gql`
    mutation CreateSurchargePricingRule($courierId: ID!, $surchargePricingRuleCreate: SurchargePricingRuleCreate!) {
  createSurchargePricingRule(
    courierId: $courierId
    surchargePricingRuleCreate: $surchargePricingRuleCreate
  ) {
    ...SurchargePricingRuleFragment
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;
export type CreateSurchargePricingRuleMutationFn = Apollo.MutationFunction<CreateSurchargePricingRuleMutation, CreateSurchargePricingRuleMutationVariables>;

/**
 * __useCreateSurchargePricingRuleMutation__
 *
 * To run a mutation, you first call `useCreateSurchargePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurchargePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurchargePricingRuleMutation, { data, loading, error }] = useCreateSurchargePricingRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      surchargePricingRuleCreate: // value for 'surchargePricingRuleCreate'
 *   },
 * });
 */
export function useCreateSurchargePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurchargePricingRuleMutation, CreateSurchargePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurchargePricingRuleMutation, CreateSurchargePricingRuleMutationVariables>(CreateSurchargePricingRuleDocument, options);
      }
export type CreateSurchargePricingRuleMutationHookResult = ReturnType<typeof useCreateSurchargePricingRuleMutation>;
export type CreateSurchargePricingRuleMutationResult = Apollo.MutationResult<CreateSurchargePricingRuleMutation>;
export type CreateSurchargePricingRuleMutationOptions = Apollo.BaseMutationOptions<CreateSurchargePricingRuleMutation, CreateSurchargePricingRuleMutationVariables>;
export const DeletePricingRuleDocument = gql`
    mutation DeletePricingRule($courierId: ID!, $pricingRuleId: ID!) {
  deletePricingRule(courierId: $courierId, pricingRuleId: $pricingRuleId)
}
    `;
export type DeletePricingRuleMutationFn = Apollo.MutationFunction<DeletePricingRuleMutation, DeletePricingRuleMutationVariables>;

/**
 * __useDeletePricingRuleMutation__
 *
 * To run a mutation, you first call `useDeletePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePricingRuleMutation, { data, loading, error }] = useDeletePricingRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingRuleId: // value for 'pricingRuleId'
 *   },
 * });
 */
export function useDeletePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeletePricingRuleMutation, DeletePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePricingRuleMutation, DeletePricingRuleMutationVariables>(DeletePricingRuleDocument, options);
      }
export type DeletePricingRuleMutationHookResult = ReturnType<typeof useDeletePricingRuleMutation>;
export type DeletePricingRuleMutationResult = Apollo.MutationResult<DeletePricingRuleMutation>;
export type DeletePricingRuleMutationOptions = Apollo.BaseMutationOptions<DeletePricingRuleMutation, DeletePricingRuleMutationVariables>;
export const DeleteSurchargePricingRuleDocument = gql`
    mutation DeleteSurchargePricingRule($courierId: ID!, $surchargePricingRuleId: ID!) {
  deleteSurchargePricingRule(
    courierId: $courierId
    surchargePricingRuleId: $surchargePricingRuleId
  )
}
    `;
export type DeleteSurchargePricingRuleMutationFn = Apollo.MutationFunction<DeleteSurchargePricingRuleMutation, DeleteSurchargePricingRuleMutationVariables>;

/**
 * __useDeleteSurchargePricingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteSurchargePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurchargePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurchargePricingRuleMutation, { data, loading, error }] = useDeleteSurchargePricingRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      surchargePricingRuleId: // value for 'surchargePricingRuleId'
 *   },
 * });
 */
export function useDeleteSurchargePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurchargePricingRuleMutation, DeleteSurchargePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurchargePricingRuleMutation, DeleteSurchargePricingRuleMutationVariables>(DeleteSurchargePricingRuleDocument, options);
      }
export type DeleteSurchargePricingRuleMutationHookResult = ReturnType<typeof useDeleteSurchargePricingRuleMutation>;
export type DeleteSurchargePricingRuleMutationResult = Apollo.MutationResult<DeleteSurchargePricingRuleMutation>;
export type DeleteSurchargePricingRuleMutationOptions = Apollo.BaseMutationOptions<DeleteSurchargePricingRuleMutation, DeleteSurchargePricingRuleMutationVariables>;
export const CreatePricingListDocument = gql`
    mutation CreatePricingList($courierId: ID!, $name: String!, $copyBasePricingRules: Boolean, $pricingListIdToCopyFrom: ID, $pricingRulesValueMultiplier: Float, $fallbackToBasePricingList: Boolean) {
  createPricingList(
    courierId: $courierId
    name: $name
    copyBasePricingRules: $copyBasePricingRules
    pricingListIdToCopyFrom: $pricingListIdToCopyFrom
    pricingRulesValueMultiplier: $pricingRulesValueMultiplier
    fallbackToBasePricingList: $fallbackToBasePricingList
  ) {
    id
    displayId
    courierId
    name
    fallbackToBasePricingList
  }
}
    `;
export type CreatePricingListMutationFn = Apollo.MutationFunction<CreatePricingListMutation, CreatePricingListMutationVariables>;

/**
 * __useCreatePricingListMutation__
 *
 * To run a mutation, you first call `useCreatePricingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePricingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPricingListMutation, { data, loading, error }] = useCreatePricingListMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      copyBasePricingRules: // value for 'copyBasePricingRules'
 *      pricingListIdToCopyFrom: // value for 'pricingListIdToCopyFrom'
 *      pricingRulesValueMultiplier: // value for 'pricingRulesValueMultiplier'
 *      fallbackToBasePricingList: // value for 'fallbackToBasePricingList'
 *   },
 * });
 */
export function useCreatePricingListMutation(baseOptions?: Apollo.MutationHookOptions<CreatePricingListMutation, CreatePricingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePricingListMutation, CreatePricingListMutationVariables>(CreatePricingListDocument, options);
      }
export type CreatePricingListMutationHookResult = ReturnType<typeof useCreatePricingListMutation>;
export type CreatePricingListMutationResult = Apollo.MutationResult<CreatePricingListMutation>;
export type CreatePricingListMutationOptions = Apollo.BaseMutationOptions<CreatePricingListMutation, CreatePricingListMutationVariables>;
export const DeletePricingListDocument = gql`
    mutation DeletePricingList($courierId: ID!, $pricingListId: ID!) {
  deletePricingList(courierId: $courierId, pricingListId: $pricingListId)
}
    `;
export type DeletePricingListMutationFn = Apollo.MutationFunction<DeletePricingListMutation, DeletePricingListMutationVariables>;

/**
 * __useDeletePricingListMutation__
 *
 * To run a mutation, you first call `useDeletePricingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePricingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePricingListMutation, { data, loading, error }] = useDeletePricingListMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingListId: // value for 'pricingListId'
 *   },
 * });
 */
export function useDeletePricingListMutation(baseOptions?: Apollo.MutationHookOptions<DeletePricingListMutation, DeletePricingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePricingListMutation, DeletePricingListMutationVariables>(DeletePricingListDocument, options);
      }
export type DeletePricingListMutationHookResult = ReturnType<typeof useDeletePricingListMutation>;
export type DeletePricingListMutationResult = Apollo.MutationResult<DeletePricingListMutation>;
export type DeletePricingListMutationOptions = Apollo.BaseMutationOptions<DeletePricingListMutation, DeletePricingListMutationVariables>;
export const FullUpdatePriceListDocument = gql`
    mutation FullUpdatePriceList($courierId: ID!, $pricingListId: ID!, $name: String!, $fallbackToBasePricingList: Boolean!) {
  fullUpdatePriceList(
    courierId: $courierId
    pricingListId: $pricingListId
    name: $name
    fallbackToBasePricingList: $fallbackToBasePricingList
  ) {
    id
    displayId
    courierId
    name
    fallbackToBasePricingList
  }
}
    `;
export type FullUpdatePriceListMutationFn = Apollo.MutationFunction<FullUpdatePriceListMutation, FullUpdatePriceListMutationVariables>;

/**
 * __useFullUpdatePriceListMutation__
 *
 * To run a mutation, you first call `useFullUpdatePriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdatePriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdatePriceListMutation, { data, loading, error }] = useFullUpdatePriceListMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingListId: // value for 'pricingListId'
 *      name: // value for 'name'
 *      fallbackToBasePricingList: // value for 'fallbackToBasePricingList'
 *   },
 * });
 */
export function useFullUpdatePriceListMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdatePriceListMutation, FullUpdatePriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdatePriceListMutation, FullUpdatePriceListMutationVariables>(FullUpdatePriceListDocument, options);
      }
export type FullUpdatePriceListMutationHookResult = ReturnType<typeof useFullUpdatePriceListMutation>;
export type FullUpdatePriceListMutationResult = Apollo.MutationResult<FullUpdatePriceListMutation>;
export type FullUpdatePriceListMutationOptions = Apollo.BaseMutationOptions<FullUpdatePriceListMutation, FullUpdatePriceListMutationVariables>;
export const FullUpdatePricingRuleDocument = gql`
    mutation FullUpdatePricingRule($courierId: ID!, $pricingRuleFullUpdate: PricingRuleFullUpdate!) {
  fullUpdatePricingRule(
    courierId: $courierId
    pricingRuleFullUpdate: $pricingRuleFullUpdate
  ) {
    ...PricingRuleFragment
  }
}
    ${PricingRuleFragmentFragmentDoc}`;
export type FullUpdatePricingRuleMutationFn = Apollo.MutationFunction<FullUpdatePricingRuleMutation, FullUpdatePricingRuleMutationVariables>;

/**
 * __useFullUpdatePricingRuleMutation__
 *
 * To run a mutation, you first call `useFullUpdatePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdatePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdatePricingRuleMutation, { data, loading, error }] = useFullUpdatePricingRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingRuleFullUpdate: // value for 'pricingRuleFullUpdate'
 *   },
 * });
 */
export function useFullUpdatePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdatePricingRuleMutation, FullUpdatePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdatePricingRuleMutation, FullUpdatePricingRuleMutationVariables>(FullUpdatePricingRuleDocument, options);
      }
export type FullUpdatePricingRuleMutationHookResult = ReturnType<typeof useFullUpdatePricingRuleMutation>;
export type FullUpdatePricingRuleMutationResult = Apollo.MutationResult<FullUpdatePricingRuleMutation>;
export type FullUpdatePricingRuleMutationOptions = Apollo.BaseMutationOptions<FullUpdatePricingRuleMutation, FullUpdatePricingRuleMutationVariables>;
export const FullUpdateSurchargePricingRuleDocument = gql`
    mutation FullUpdateSurchargePricingRule($courierId: ID!, $surchargePricingRuleFullUpdate: SurchargePricingRuleFullUpdate!) {
  fullUpdateSurchargePricingRule(
    courierId: $courierId
    surchargePricingRuleFullUpdate: $surchargePricingRuleFullUpdate
  ) {
    id
    courierId
    pricingListId
    name
    amount
    percent
    amountType
    applyType
    amountDisplay
    minMiles
    maxMiles
    applicableStopTypes
    pricingList {
      ...PricingListFragment
    }
  }
}
    ${PricingListFragmentFragmentDoc}`;
export type FullUpdateSurchargePricingRuleMutationFn = Apollo.MutationFunction<FullUpdateSurchargePricingRuleMutation, FullUpdateSurchargePricingRuleMutationVariables>;

/**
 * __useFullUpdateSurchargePricingRuleMutation__
 *
 * To run a mutation, you first call `useFullUpdateSurchargePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateSurchargePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateSurchargePricingRuleMutation, { data, loading, error }] = useFullUpdateSurchargePricingRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      surchargePricingRuleFullUpdate: // value for 'surchargePricingRuleFullUpdate'
 *   },
 * });
 */
export function useFullUpdateSurchargePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateSurchargePricingRuleMutation, FullUpdateSurchargePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateSurchargePricingRuleMutation, FullUpdateSurchargePricingRuleMutationVariables>(FullUpdateSurchargePricingRuleDocument, options);
      }
export type FullUpdateSurchargePricingRuleMutationHookResult = ReturnType<typeof useFullUpdateSurchargePricingRuleMutation>;
export type FullUpdateSurchargePricingRuleMutationResult = Apollo.MutationResult<FullUpdateSurchargePricingRuleMutation>;
export type FullUpdateSurchargePricingRuleMutationOptions = Apollo.BaseMutationOptions<FullUpdateSurchargePricingRuleMutation, FullUpdateSurchargePricingRuleMutationVariables>;
export const UpdateSurchargePricingRuleAdvancedSettingDocument = gql`
    mutation UpdateSurchargePricingRuleAdvancedSetting($courierId: ID!, $input: SurchargePricingRuleAdvancedSettingsInput!) {
  updateSurchargePricingRuleAdvancedSetting(courierId: $courierId, input: $input) {
    ...SurchargePricingRuleFragment
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;
export type UpdateSurchargePricingRuleAdvancedSettingMutationFn = Apollo.MutationFunction<UpdateSurchargePricingRuleAdvancedSettingMutation, UpdateSurchargePricingRuleAdvancedSettingMutationVariables>;

/**
 * __useUpdateSurchargePricingRuleAdvancedSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSurchargePricingRuleAdvancedSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurchargePricingRuleAdvancedSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurchargePricingRuleAdvancedSettingMutation, { data, loading, error }] = useUpdateSurchargePricingRuleAdvancedSettingMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurchargePricingRuleAdvancedSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurchargePricingRuleAdvancedSettingMutation, UpdateSurchargePricingRuleAdvancedSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurchargePricingRuleAdvancedSettingMutation, UpdateSurchargePricingRuleAdvancedSettingMutationVariables>(UpdateSurchargePricingRuleAdvancedSettingDocument, options);
      }
export type UpdateSurchargePricingRuleAdvancedSettingMutationHookResult = ReturnType<typeof useUpdateSurchargePricingRuleAdvancedSettingMutation>;
export type UpdateSurchargePricingRuleAdvancedSettingMutationResult = Apollo.MutationResult<UpdateSurchargePricingRuleAdvancedSettingMutation>;
export type UpdateSurchargePricingRuleAdvancedSettingMutationOptions = Apollo.BaseMutationOptions<UpdateSurchargePricingRuleAdvancedSettingMutation, UpdateSurchargePricingRuleAdvancedSettingMutationVariables>;
export const ModifyOrderPricingDocument = gql`
    mutation ModifyOrderPricing($courierId: ID!, $orderId: ID!, $adjustmentsToAdd: [PricingAdjustmentCreate!], $adjustmentIdsToRemove: [ID!], $priceOverride: Money, $basePriceOverride: Money, $adjustmentOverrides: [AdjustmentOverrideInput!], $updatedBy: String, $priceOverrideBreakdown: [PriceOverrideBreakdownItemInput!]) {
  modifyOrderPricing(
    courierId: $courierId
    orderId: $orderId
    adjustmentsToAdd: $adjustmentsToAdd
    adjustmentIdsToRemove: $adjustmentIdsToRemove
    priceOverride: $priceOverride
    basePriceOverride: $basePriceOverride
    adjustmentOverrides: $adjustmentOverrides
    updatedBy: $updatedBy
    priceOverrideBreakdown: $priceOverrideBreakdown
  ) {
    ...OrderPriceFragment
  }
}
    ${OrderPriceFragmentFragmentDoc}`;
export type ModifyOrderPricingMutationFn = Apollo.MutationFunction<ModifyOrderPricingMutation, ModifyOrderPricingMutationVariables>;

/**
 * __useModifyOrderPricingMutation__
 *
 * To run a mutation, you first call `useModifyOrderPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrderPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrderPricingMutation, { data, loading, error }] = useModifyOrderPricingMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      adjustmentsToAdd: // value for 'adjustmentsToAdd'
 *      adjustmentIdsToRemove: // value for 'adjustmentIdsToRemove'
 *      priceOverride: // value for 'priceOverride'
 *      basePriceOverride: // value for 'basePriceOverride'
 *      adjustmentOverrides: // value for 'adjustmentOverrides'
 *      updatedBy: // value for 'updatedBy'
 *      priceOverrideBreakdown: // value for 'priceOverrideBreakdown'
 *   },
 * });
 */
export function useModifyOrderPricingMutation(baseOptions?: Apollo.MutationHookOptions<ModifyOrderPricingMutation, ModifyOrderPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyOrderPricingMutation, ModifyOrderPricingMutationVariables>(ModifyOrderPricingDocument, options);
      }
export type ModifyOrderPricingMutationHookResult = ReturnType<typeof useModifyOrderPricingMutation>;
export type ModifyOrderPricingMutationResult = Apollo.MutationResult<ModifyOrderPricingMutation>;
export type ModifyOrderPricingMutationOptions = Apollo.BaseMutationOptions<ModifyOrderPricingMutation, ModifyOrderPricingMutationVariables>;
export const PreviewOrderPricingModificationDocument = gql`
    mutation PreviewOrderPricingModification($courierId: ID!, $orderId: ID!, $adjustmentsToAdd: [PricingAdjustmentCreate!]!, $adjustmentIdsToRemove: [ID!]!, $priceOverride: Money) {
  previewOrderPricingModification(
    courierId: $courierId
    orderId: $orderId
    adjustmentsToAdd: $adjustmentsToAdd
    adjustmentIdsToRemove: $adjustmentIdsToRemove
    priceOverride: $priceOverride
  ) {
    total
  }
}
    `;
export type PreviewOrderPricingModificationMutationFn = Apollo.MutationFunction<PreviewOrderPricingModificationMutation, PreviewOrderPricingModificationMutationVariables>;

/**
 * __usePreviewOrderPricingModificationMutation__
 *
 * To run a mutation, you first call `usePreviewOrderPricingModificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewOrderPricingModificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewOrderPricingModificationMutation, { data, loading, error }] = usePreviewOrderPricingModificationMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      adjustmentsToAdd: // value for 'adjustmentsToAdd'
 *      adjustmentIdsToRemove: // value for 'adjustmentIdsToRemove'
 *      priceOverride: // value for 'priceOverride'
 *   },
 * });
 */
export function usePreviewOrderPricingModificationMutation(baseOptions?: Apollo.MutationHookOptions<PreviewOrderPricingModificationMutation, PreviewOrderPricingModificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewOrderPricingModificationMutation, PreviewOrderPricingModificationMutationVariables>(PreviewOrderPricingModificationDocument, options);
      }
export type PreviewOrderPricingModificationMutationHookResult = ReturnType<typeof usePreviewOrderPricingModificationMutation>;
export type PreviewOrderPricingModificationMutationResult = Apollo.MutationResult<PreviewOrderPricingModificationMutation>;
export type PreviewOrderPricingModificationMutationOptions = Apollo.BaseMutationOptions<PreviewOrderPricingModificationMutation, PreviewOrderPricingModificationMutationVariables>;
export const UpdatePriceOverrideForRecurringOrderDocument = gql`
    mutation UpdatePriceOverrideForRecurringOrder($courierId: ID!, $orderId: ID!, $priceOverride: Money, $updatedBy: String, $breakdown: [PriceOverrideBreakdownItemInput!]) {
  updatePriceOverrideForRecurringOrder(
    courierId: $courierId
    orderId: $orderId
    priceOverride: $priceOverride
    updatedBy: $updatedBy
    breakdown: $breakdown
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdatePriceOverrideForRecurringOrderMutationFn = Apollo.MutationFunction<UpdatePriceOverrideForRecurringOrderMutation, UpdatePriceOverrideForRecurringOrderMutationVariables>;

/**
 * __useUpdatePriceOverrideForRecurringOrderMutation__
 *
 * To run a mutation, you first call `useUpdatePriceOverrideForRecurringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceOverrideForRecurringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceOverrideForRecurringOrderMutation, { data, loading, error }] = useUpdatePriceOverrideForRecurringOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      priceOverride: // value for 'priceOverride'
 *      updatedBy: // value for 'updatedBy'
 *      breakdown: // value for 'breakdown'
 *   },
 * });
 */
export function useUpdatePriceOverrideForRecurringOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriceOverrideForRecurringOrderMutation, UpdatePriceOverrideForRecurringOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriceOverrideForRecurringOrderMutation, UpdatePriceOverrideForRecurringOrderMutationVariables>(UpdatePriceOverrideForRecurringOrderDocument, options);
      }
export type UpdatePriceOverrideForRecurringOrderMutationHookResult = ReturnType<typeof useUpdatePriceOverrideForRecurringOrderMutation>;
export type UpdatePriceOverrideForRecurringOrderMutationResult = Apollo.MutationResult<UpdatePriceOverrideForRecurringOrderMutation>;
export type UpdatePriceOverrideForRecurringOrderMutationOptions = Apollo.BaseMutationOptions<UpdatePriceOverrideForRecurringOrderMutation, UpdatePriceOverrideForRecurringOrderMutationVariables>;
export const UpdateDriverPayOverrideDocument = gql`
    mutation UpdateDriverPayOverride($courierId: ID!, $orderId: ID!, $driverPayOverride: Money, $driverPayPercent: Money, $updatedBy: String) {
  updateDriverPayOverride(
    courierId: $courierId
    orderId: $orderId
    driverPayOverride: $driverPayOverride
    driverPayPercent: $driverPayPercent
    updatedBy: $updatedBy
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdateDriverPayOverrideMutationFn = Apollo.MutationFunction<UpdateDriverPayOverrideMutation, UpdateDriverPayOverrideMutationVariables>;

/**
 * __useUpdateDriverPayOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateDriverPayOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverPayOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverPayOverrideMutation, { data, loading, error }] = useUpdateDriverPayOverrideMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      driverPayOverride: // value for 'driverPayOverride'
 *      driverPayPercent: // value for 'driverPayPercent'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useUpdateDriverPayOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverPayOverrideMutation, UpdateDriverPayOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverPayOverrideMutation, UpdateDriverPayOverrideMutationVariables>(UpdateDriverPayOverrideDocument, options);
      }
export type UpdateDriverPayOverrideMutationHookResult = ReturnType<typeof useUpdateDriverPayOverrideMutation>;
export type UpdateDriverPayOverrideMutationResult = Apollo.MutationResult<UpdateDriverPayOverrideMutation>;
export type UpdateDriverPayOverrideMutationOptions = Apollo.BaseMutationOptions<UpdateDriverPayOverrideMutation, UpdateDriverPayOverrideMutationVariables>;
export const UpdateCommissionableBaseDocument = gql`
    mutation UpdateCommissionableBase($courierId: ID!, $orderId: ID!, $commissionableBaseFixed: Money, $commissionableBasePercent: Money, $updatedBy: String) {
  updateCommissionableBase(
    courierId: $courierId
    orderId: $orderId
    commissionableBaseFixed: $commissionableBaseFixed
    commissionableBasePercent: $commissionableBasePercent
    updatedBy: $updatedBy
  ) {
    id
    commissionableBaseFixed
    commissionableBasePercent
  }
}
    `;
export type UpdateCommissionableBaseMutationFn = Apollo.MutationFunction<UpdateCommissionableBaseMutation, UpdateCommissionableBaseMutationVariables>;

/**
 * __useUpdateCommissionableBaseMutation__
 *
 * To run a mutation, you first call `useUpdateCommissionableBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommissionableBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommissionableBaseMutation, { data, loading, error }] = useUpdateCommissionableBaseMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      commissionableBaseFixed: // value for 'commissionableBaseFixed'
 *      commissionableBasePercent: // value for 'commissionableBasePercent'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useUpdateCommissionableBaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommissionableBaseMutation, UpdateCommissionableBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommissionableBaseMutation, UpdateCommissionableBaseMutationVariables>(UpdateCommissionableBaseDocument, options);
      }
export type UpdateCommissionableBaseMutationHookResult = ReturnType<typeof useUpdateCommissionableBaseMutation>;
export type UpdateCommissionableBaseMutationResult = Apollo.MutationResult<UpdateCommissionableBaseMutation>;
export type UpdateCommissionableBaseMutationOptions = Apollo.BaseMutationOptions<UpdateCommissionableBaseMutation, UpdateCommissionableBaseMutationVariables>;
export const UpdateBasePriceOverrideDocument = gql`
    mutation UpdateBasePriceOverride($courierId: ID!, $orderId: ID!, $priceOverride: Money, $updatedBy: String) {
  updateBasePriceOverride(
    courierId: $courierId
    orderId: $orderId
    priceOverride: $priceOverride
    updatedBy: $updatedBy
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdateBasePriceOverrideMutationFn = Apollo.MutationFunction<UpdateBasePriceOverrideMutation, UpdateBasePriceOverrideMutationVariables>;

/**
 * __useUpdateBasePriceOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateBasePriceOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasePriceOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasePriceOverrideMutation, { data, loading, error }] = useUpdateBasePriceOverrideMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      priceOverride: // value for 'priceOverride'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useUpdateBasePriceOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBasePriceOverrideMutation, UpdateBasePriceOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBasePriceOverrideMutation, UpdateBasePriceOverrideMutationVariables>(UpdateBasePriceOverrideDocument, options);
      }
export type UpdateBasePriceOverrideMutationHookResult = ReturnType<typeof useUpdateBasePriceOverrideMutation>;
export type UpdateBasePriceOverrideMutationResult = Apollo.MutationResult<UpdateBasePriceOverrideMutation>;
export type UpdateBasePriceOverrideMutationOptions = Apollo.BaseMutationOptions<UpdateBasePriceOverrideMutation, UpdateBasePriceOverrideMutationVariables>;
export const CreateZipGroupDocument = gql`
    mutation CreateZipGroup($courierId: ID!, $name: String!, $zipCodes: [String!]!) {
  createZipGroup(courierId: $courierId, name: $name, zipCodes: $zipCodes) {
    id
    name
    zipCodes
  }
}
    `;
export type CreateZipGroupMutationFn = Apollo.MutationFunction<CreateZipGroupMutation, CreateZipGroupMutationVariables>;

/**
 * __useCreateZipGroupMutation__
 *
 * To run a mutation, you first call `useCreateZipGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZipGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZipGroupMutation, { data, loading, error }] = useCreateZipGroupMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      zipCodes: // value for 'zipCodes'
 *   },
 * });
 */
export function useCreateZipGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateZipGroupMutation, CreateZipGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZipGroupMutation, CreateZipGroupMutationVariables>(CreateZipGroupDocument, options);
      }
export type CreateZipGroupMutationHookResult = ReturnType<typeof useCreateZipGroupMutation>;
export type CreateZipGroupMutationResult = Apollo.MutationResult<CreateZipGroupMutation>;
export type CreateZipGroupMutationOptions = Apollo.BaseMutationOptions<CreateZipGroupMutation, CreateZipGroupMutationVariables>;
export const FullUpdateZipGroupDocument = gql`
    mutation FullUpdateZipGroup($courierId: ID!, $zipGroupId: ID!, $name: String!, $zipCodes: [String!]!) {
  fullUpdateZipGroup(
    courierId: $courierId
    zipGroupId: $zipGroupId
    name: $name
    zipCodes: $zipCodes
  ) {
    id
    name
    zipCodes
  }
}
    `;
export type FullUpdateZipGroupMutationFn = Apollo.MutationFunction<FullUpdateZipGroupMutation, FullUpdateZipGroupMutationVariables>;

/**
 * __useFullUpdateZipGroupMutation__
 *
 * To run a mutation, you first call `useFullUpdateZipGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateZipGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateZipGroupMutation, { data, loading, error }] = useFullUpdateZipGroupMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      zipGroupId: // value for 'zipGroupId'
 *      name: // value for 'name'
 *      zipCodes: // value for 'zipCodes'
 *   },
 * });
 */
export function useFullUpdateZipGroupMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateZipGroupMutation, FullUpdateZipGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateZipGroupMutation, FullUpdateZipGroupMutationVariables>(FullUpdateZipGroupDocument, options);
      }
export type FullUpdateZipGroupMutationHookResult = ReturnType<typeof useFullUpdateZipGroupMutation>;
export type FullUpdateZipGroupMutationResult = Apollo.MutationResult<FullUpdateZipGroupMutation>;
export type FullUpdateZipGroupMutationOptions = Apollo.BaseMutationOptions<FullUpdateZipGroupMutation, FullUpdateZipGroupMutationVariables>;
export const OverrideAdjustmentAmountDocument = gql`
    mutation OverrideAdjustmentAmount($courierId: ID!, $adjustmentId: ID!, $amountOverride: Money) {
  overrideAdjustmentAmount(
    courierId: $courierId
    adjustmentId: $adjustmentId
    amountOverride: $amountOverride
  ) {
    ...PricingAdjustmentFragment
  }
}
    ${PricingAdjustmentFragmentFragmentDoc}`;
export type OverrideAdjustmentAmountMutationFn = Apollo.MutationFunction<OverrideAdjustmentAmountMutation, OverrideAdjustmentAmountMutationVariables>;

/**
 * __useOverrideAdjustmentAmountMutation__
 *
 * To run a mutation, you first call `useOverrideAdjustmentAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideAdjustmentAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideAdjustmentAmountMutation, { data, loading, error }] = useOverrideAdjustmentAmountMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      adjustmentId: // value for 'adjustmentId'
 *      amountOverride: // value for 'amountOverride'
 *   },
 * });
 */
export function useOverrideAdjustmentAmountMutation(baseOptions?: Apollo.MutationHookOptions<OverrideAdjustmentAmountMutation, OverrideAdjustmentAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideAdjustmentAmountMutation, OverrideAdjustmentAmountMutationVariables>(OverrideAdjustmentAmountDocument, options);
      }
export type OverrideAdjustmentAmountMutationHookResult = ReturnType<typeof useOverrideAdjustmentAmountMutation>;
export type OverrideAdjustmentAmountMutationResult = Apollo.MutationResult<OverrideAdjustmentAmountMutation>;
export type OverrideAdjustmentAmountMutationOptions = Apollo.BaseMutationOptions<OverrideAdjustmentAmountMutation, OverrideAdjustmentAmountMutationVariables>;
export const BulkUploadPricingRulesDocument = gql`
    mutation BulkUploadPricingRules($courierId: ID!, $file: Upload!, $overrideExistingPricingRules: Boolean) {
  bulkUploadPricingRules(
    courierId: $courierId
    file: $file
    overrideExistingPricingRules: $overrideExistingPricingRules
  ) {
    numSuccess
    numSkipped
    isAsynchronous
    errors {
      rowNumber
      messages
    }
  }
}
    `;
export type BulkUploadPricingRulesMutationFn = Apollo.MutationFunction<BulkUploadPricingRulesMutation, BulkUploadPricingRulesMutationVariables>;

/**
 * __useBulkUploadPricingRulesMutation__
 *
 * To run a mutation, you first call `useBulkUploadPricingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadPricingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadPricingRulesMutation, { data, loading, error }] = useBulkUploadPricingRulesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *      overrideExistingPricingRules: // value for 'overrideExistingPricingRules'
 *   },
 * });
 */
export function useBulkUploadPricingRulesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadPricingRulesMutation, BulkUploadPricingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadPricingRulesMutation, BulkUploadPricingRulesMutationVariables>(BulkUploadPricingRulesDocument, options);
      }
export type BulkUploadPricingRulesMutationHookResult = ReturnType<typeof useBulkUploadPricingRulesMutation>;
export type BulkUploadPricingRulesMutationResult = Apollo.MutationResult<BulkUploadPricingRulesMutation>;
export type BulkUploadPricingRulesMutationOptions = Apollo.BaseMutationOptions<BulkUploadPricingRulesMutation, BulkUploadPricingRulesMutationVariables>;
export const BulkUploadPricingListsDocument = gql`
    mutation BulkUploadPricingLists($courierId: ID!, $file: Upload!) {
  bulkUploadPricingLists(courierId: $courierId, file: $file) {
    numSuccess
    errors {
      rowNumber
      messages
    }
  }
}
    `;
export type BulkUploadPricingListsMutationFn = Apollo.MutationFunction<BulkUploadPricingListsMutation, BulkUploadPricingListsMutationVariables>;

/**
 * __useBulkUploadPricingListsMutation__
 *
 * To run a mutation, you first call `useBulkUploadPricingListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadPricingListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadPricingListsMutation, { data, loading, error }] = useBulkUploadPricingListsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkUploadPricingListsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadPricingListsMutation, BulkUploadPricingListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadPricingListsMutation, BulkUploadPricingListsMutationVariables>(BulkUploadPricingListsDocument, options);
      }
export type BulkUploadPricingListsMutationHookResult = ReturnType<typeof useBulkUploadPricingListsMutation>;
export type BulkUploadPricingListsMutationResult = Apollo.MutationResult<BulkUploadPricingListsMutation>;
export type BulkUploadPricingListsMutationOptions = Apollo.BaseMutationOptions<BulkUploadPricingListsMutation, BulkUploadPricingListsMutationVariables>;
export const BulkMultiplyPricingRulesDocument = gql`
    mutation BulkMultiplyPricingRules($courierId: ID!, $pricingListId: ID, $multiplier: Float!, $isBasePricingList: Boolean!) {
  bulkMultiplyPricingRules(
    courierId: $courierId
    pricingListId: $pricingListId
    multiplier: $multiplier
    isBasePricingList: $isBasePricingList
  ) {
    numSuccess
  }
}
    `;
export type BulkMultiplyPricingRulesMutationFn = Apollo.MutationFunction<BulkMultiplyPricingRulesMutation, BulkMultiplyPricingRulesMutationVariables>;

/**
 * __useBulkMultiplyPricingRulesMutation__
 *
 * To run a mutation, you first call `useBulkMultiplyPricingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMultiplyPricingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMultiplyPricingRulesMutation, { data, loading, error }] = useBulkMultiplyPricingRulesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingListId: // value for 'pricingListId'
 *      multiplier: // value for 'multiplier'
 *      isBasePricingList: // value for 'isBasePricingList'
 *   },
 * });
 */
export function useBulkMultiplyPricingRulesMutation(baseOptions?: Apollo.MutationHookOptions<BulkMultiplyPricingRulesMutation, BulkMultiplyPricingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkMultiplyPricingRulesMutation, BulkMultiplyPricingRulesMutationVariables>(BulkMultiplyPricingRulesDocument, options);
      }
export type BulkMultiplyPricingRulesMutationHookResult = ReturnType<typeof useBulkMultiplyPricingRulesMutation>;
export type BulkMultiplyPricingRulesMutationResult = Apollo.MutationResult<BulkMultiplyPricingRulesMutation>;
export type BulkMultiplyPricingRulesMutationOptions = Apollo.BaseMutationOptions<BulkMultiplyPricingRulesMutation, BulkMultiplyPricingRulesMutationVariables>;
export const BulkDeletePricingRulesDocument = gql`
    mutation BulkDeletePricingRules($courierId: ID!, $isBasePricingListOnly: Boolean!, $pricingListIdsFilter: [ID!], $serviceTypeIdsFilter: [ID!]) {
  bulkDeletePricingRules(
    courierId: $courierId
    isBasePricingListOnly: $isBasePricingListOnly
    pricingListIdsFilter: $pricingListIdsFilter
    serviceTypeIdsFilter: $serviceTypeIdsFilter
  )
}
    `;
export type BulkDeletePricingRulesMutationFn = Apollo.MutationFunction<BulkDeletePricingRulesMutation, BulkDeletePricingRulesMutationVariables>;

/**
 * __useBulkDeletePricingRulesMutation__
 *
 * To run a mutation, you first call `useBulkDeletePricingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeletePricingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeletePricingRulesMutation, { data, loading, error }] = useBulkDeletePricingRulesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      isBasePricingListOnly: // value for 'isBasePricingListOnly'
 *      pricingListIdsFilter: // value for 'pricingListIdsFilter'
 *      serviceTypeIdsFilter: // value for 'serviceTypeIdsFilter'
 *   },
 * });
 */
export function useBulkDeletePricingRulesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeletePricingRulesMutation, BulkDeletePricingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeletePricingRulesMutation, BulkDeletePricingRulesMutationVariables>(BulkDeletePricingRulesDocument, options);
      }
export type BulkDeletePricingRulesMutationHookResult = ReturnType<typeof useBulkDeletePricingRulesMutation>;
export type BulkDeletePricingRulesMutationResult = Apollo.MutationResult<BulkDeletePricingRulesMutation>;
export type BulkDeletePricingRulesMutationOptions = Apollo.BaseMutationOptions<BulkDeletePricingRulesMutation, BulkDeletePricingRulesMutationVariables>;
export const UpdatePricingRuleTimeScheduleSpecificAmountsDocument = gql`
    mutation UpdatePricingRuleTimeScheduleSpecificAmounts($courierId: ID!, $pricingRuleId: ID!, $timeScheduleSpecificAmounts: TimeScheduleSpecificAmountsInput!) {
  updatePricingRuleTimeScheduleSpecificAmounts(
    courierId: $courierId
    pricingRuleId: $pricingRuleId
    timeScheduleSpecificAmounts: $timeScheduleSpecificAmounts
  ) {
    ...PricingRuleFragment
  }
}
    ${PricingRuleFragmentFragmentDoc}`;
export type UpdatePricingRuleTimeScheduleSpecificAmountsMutationFn = Apollo.MutationFunction<UpdatePricingRuleTimeScheduleSpecificAmountsMutation, UpdatePricingRuleTimeScheduleSpecificAmountsMutationVariables>;

/**
 * __useUpdatePricingRuleTimeScheduleSpecificAmountsMutation__
 *
 * To run a mutation, you first call `useUpdatePricingRuleTimeScheduleSpecificAmountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePricingRuleTimeScheduleSpecificAmountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePricingRuleTimeScheduleSpecificAmountsMutation, { data, loading, error }] = useUpdatePricingRuleTimeScheduleSpecificAmountsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingRuleId: // value for 'pricingRuleId'
 *      timeScheduleSpecificAmounts: // value for 'timeScheduleSpecificAmounts'
 *   },
 * });
 */
export function useUpdatePricingRuleTimeScheduleSpecificAmountsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePricingRuleTimeScheduleSpecificAmountsMutation, UpdatePricingRuleTimeScheduleSpecificAmountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePricingRuleTimeScheduleSpecificAmountsMutation, UpdatePricingRuleTimeScheduleSpecificAmountsMutationVariables>(UpdatePricingRuleTimeScheduleSpecificAmountsDocument, options);
      }
export type UpdatePricingRuleTimeScheduleSpecificAmountsMutationHookResult = ReturnType<typeof useUpdatePricingRuleTimeScheduleSpecificAmountsMutation>;
export type UpdatePricingRuleTimeScheduleSpecificAmountsMutationResult = Apollo.MutationResult<UpdatePricingRuleTimeScheduleSpecificAmountsMutation>;
export type UpdatePricingRuleTimeScheduleSpecificAmountsMutationOptions = Apollo.BaseMutationOptions<UpdatePricingRuleTimeScheduleSpecificAmountsMutation, UpdatePricingRuleTimeScheduleSpecificAmountsMutationVariables>;
export const UpdatePricingRuleHolidaySchedulePricingAmountsDocument = gql`
    mutation UpdatePricingRuleHolidaySchedulePricingAmounts($courierId: ID!, $pricingRuleId: ID!, $holidaySchedulePricingAmounts: HolidaySchedulePricingAmountListInput!) {
  updatePricingRuleHolidaySchedulePricingAmounts(
    courierId: $courierId
    pricingRuleId: $pricingRuleId
    holidaySchedulePricingAmounts: $holidaySchedulePricingAmounts
  ) {
    ...PricingRuleFragment
  }
}
    ${PricingRuleFragmentFragmentDoc}`;
export type UpdatePricingRuleHolidaySchedulePricingAmountsMutationFn = Apollo.MutationFunction<UpdatePricingRuleHolidaySchedulePricingAmountsMutation, UpdatePricingRuleHolidaySchedulePricingAmountsMutationVariables>;

/**
 * __useUpdatePricingRuleHolidaySchedulePricingAmountsMutation__
 *
 * To run a mutation, you first call `useUpdatePricingRuleHolidaySchedulePricingAmountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePricingRuleHolidaySchedulePricingAmountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePricingRuleHolidaySchedulePricingAmountsMutation, { data, loading, error }] = useUpdatePricingRuleHolidaySchedulePricingAmountsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingRuleId: // value for 'pricingRuleId'
 *      holidaySchedulePricingAmounts: // value for 'holidaySchedulePricingAmounts'
 *   },
 * });
 */
export function useUpdatePricingRuleHolidaySchedulePricingAmountsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePricingRuleHolidaySchedulePricingAmountsMutation, UpdatePricingRuleHolidaySchedulePricingAmountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePricingRuleHolidaySchedulePricingAmountsMutation, UpdatePricingRuleHolidaySchedulePricingAmountsMutationVariables>(UpdatePricingRuleHolidaySchedulePricingAmountsDocument, options);
      }
export type UpdatePricingRuleHolidaySchedulePricingAmountsMutationHookResult = ReturnType<typeof useUpdatePricingRuleHolidaySchedulePricingAmountsMutation>;
export type UpdatePricingRuleHolidaySchedulePricingAmountsMutationResult = Apollo.MutationResult<UpdatePricingRuleHolidaySchedulePricingAmountsMutation>;
export type UpdatePricingRuleHolidaySchedulePricingAmountsMutationOptions = Apollo.BaseMutationOptions<UpdatePricingRuleHolidaySchedulePricingAmountsMutation, UpdatePricingRuleHolidaySchedulePricingAmountsMutationVariables>;
export const UpdatePricingRuleAdvancedMultipliersDocument = gql`
    mutation UpdatePricingRuleAdvancedMultipliers($courierId: ID!, $pricingRuleId: ID!, $advancedMultiplier: PricingRuleAdvancedMultiplierInput) {
  updatePricingRuleAdvancedMultipliers(
    courierId: $courierId
    pricingRuleId: $pricingRuleId
    advancedMultiplier: $advancedMultiplier
  ) {
    ...PricingRuleFragment
  }
}
    ${PricingRuleFragmentFragmentDoc}`;
export type UpdatePricingRuleAdvancedMultipliersMutationFn = Apollo.MutationFunction<UpdatePricingRuleAdvancedMultipliersMutation, UpdatePricingRuleAdvancedMultipliersMutationVariables>;

/**
 * __useUpdatePricingRuleAdvancedMultipliersMutation__
 *
 * To run a mutation, you first call `useUpdatePricingRuleAdvancedMultipliersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePricingRuleAdvancedMultipliersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePricingRuleAdvancedMultipliersMutation, { data, loading, error }] = useUpdatePricingRuleAdvancedMultipliersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingRuleId: // value for 'pricingRuleId'
 *      advancedMultiplier: // value for 'advancedMultiplier'
 *   },
 * });
 */
export function useUpdatePricingRuleAdvancedMultipliersMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePricingRuleAdvancedMultipliersMutation, UpdatePricingRuleAdvancedMultipliersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePricingRuleAdvancedMultipliersMutation, UpdatePricingRuleAdvancedMultipliersMutationVariables>(UpdatePricingRuleAdvancedMultipliersDocument, options);
      }
export type UpdatePricingRuleAdvancedMultipliersMutationHookResult = ReturnType<typeof useUpdatePricingRuleAdvancedMultipliersMutation>;
export type UpdatePricingRuleAdvancedMultipliersMutationResult = Apollo.MutationResult<UpdatePricingRuleAdvancedMultipliersMutation>;
export type UpdatePricingRuleAdvancedMultipliersMutationOptions = Apollo.BaseMutationOptions<UpdatePricingRuleAdvancedMultipliersMutation, UpdatePricingRuleAdvancedMultipliersMutationVariables>;
export const UpdateSurchargePricingRuleAdvancedMultipliersDocument = gql`
    mutation UpdateSurchargePricingRuleAdvancedMultipliers($courierId: ID!, $surchargePricingRuleId: ID!, $advancedMultiplier: SurchargePricingRuleAdvancedMultiplierInput) {
  updateSurchargePricingRuleAdvancedMultipliers(
    courierId: $courierId
    surchargePricingRuleId: $surchargePricingRuleId
    advancedMultiplier: $advancedMultiplier
  ) {
    ...SurchargePricingRuleFragment
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;
export type UpdateSurchargePricingRuleAdvancedMultipliersMutationFn = Apollo.MutationFunction<UpdateSurchargePricingRuleAdvancedMultipliersMutation, UpdateSurchargePricingRuleAdvancedMultipliersMutationVariables>;

/**
 * __useUpdateSurchargePricingRuleAdvancedMultipliersMutation__
 *
 * To run a mutation, you first call `useUpdateSurchargePricingRuleAdvancedMultipliersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurchargePricingRuleAdvancedMultipliersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurchargePricingRuleAdvancedMultipliersMutation, { data, loading, error }] = useUpdateSurchargePricingRuleAdvancedMultipliersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      surchargePricingRuleId: // value for 'surchargePricingRuleId'
 *      advancedMultiplier: // value for 'advancedMultiplier'
 *   },
 * });
 */
export function useUpdateSurchargePricingRuleAdvancedMultipliersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurchargePricingRuleAdvancedMultipliersMutation, UpdateSurchargePricingRuleAdvancedMultipliersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurchargePricingRuleAdvancedMultipliersMutation, UpdateSurchargePricingRuleAdvancedMultipliersMutationVariables>(UpdateSurchargePricingRuleAdvancedMultipliersDocument, options);
      }
export type UpdateSurchargePricingRuleAdvancedMultipliersMutationHookResult = ReturnType<typeof useUpdateSurchargePricingRuleAdvancedMultipliersMutation>;
export type UpdateSurchargePricingRuleAdvancedMultipliersMutationResult = Apollo.MutationResult<UpdateSurchargePricingRuleAdvancedMultipliersMutation>;
export type UpdateSurchargePricingRuleAdvancedMultipliersMutationOptions = Apollo.BaseMutationOptions<UpdateSurchargePricingRuleAdvancedMultipliersMutation, UpdateSurchargePricingRuleAdvancedMultipliersMutationVariables>;
export const UpdateSurchargePricingRuleInvoiceSummaryGroupDocument = gql`
    mutation UpdateSurchargePricingRuleInvoiceSummaryGroup($courierId: ID!, $surchargePricingRuleId: ID!, $invoiceSummaryGroup: String) {
  updateSurchargePricingRuleInvoiceSummaryGroup(
    courierId: $courierId
    surchargePricingRuleId: $surchargePricingRuleId
    invoiceSummaryGroup: $invoiceSummaryGroup
  ) {
    ...SurchargePricingRuleFragment
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;
export type UpdateSurchargePricingRuleInvoiceSummaryGroupMutationFn = Apollo.MutationFunction<UpdateSurchargePricingRuleInvoiceSummaryGroupMutation, UpdateSurchargePricingRuleInvoiceSummaryGroupMutationVariables>;

/**
 * __useUpdateSurchargePricingRuleInvoiceSummaryGroupMutation__
 *
 * To run a mutation, you first call `useUpdateSurchargePricingRuleInvoiceSummaryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurchargePricingRuleInvoiceSummaryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurchargePricingRuleInvoiceSummaryGroupMutation, { data, loading, error }] = useUpdateSurchargePricingRuleInvoiceSummaryGroupMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      surchargePricingRuleId: // value for 'surchargePricingRuleId'
 *      invoiceSummaryGroup: // value for 'invoiceSummaryGroup'
 *   },
 * });
 */
export function useUpdateSurchargePricingRuleInvoiceSummaryGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurchargePricingRuleInvoiceSummaryGroupMutation, UpdateSurchargePricingRuleInvoiceSummaryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurchargePricingRuleInvoiceSummaryGroupMutation, UpdateSurchargePricingRuleInvoiceSummaryGroupMutationVariables>(UpdateSurchargePricingRuleInvoiceSummaryGroupDocument, options);
      }
export type UpdateSurchargePricingRuleInvoiceSummaryGroupMutationHookResult = ReturnType<typeof useUpdateSurchargePricingRuleInvoiceSummaryGroupMutation>;
export type UpdateSurchargePricingRuleInvoiceSummaryGroupMutationResult = Apollo.MutationResult<UpdateSurchargePricingRuleInvoiceSummaryGroupMutation>;
export type UpdateSurchargePricingRuleInvoiceSummaryGroupMutationOptions = Apollo.BaseMutationOptions<UpdateSurchargePricingRuleInvoiceSummaryGroupMutation, UpdateSurchargePricingRuleInvoiceSummaryGroupMutationVariables>;
export const UpdateSurchargePricingRuleTaxableStatusDocument = gql`
    mutation UpdateSurchargePricingRuleTaxableStatus($courierId: ID!, $surchargePricingRuleId: ID!, $taxableStatus: SurchargeTaxStatus!) {
  updateSurchargePricingRuleTaxableStatus(
    courierId: $courierId
    surchargePricingRuleId: $surchargePricingRuleId
    taxableStatus: $taxableStatus
  ) {
    ...SurchargePricingRuleFragment
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;
export type UpdateSurchargePricingRuleTaxableStatusMutationFn = Apollo.MutationFunction<UpdateSurchargePricingRuleTaxableStatusMutation, UpdateSurchargePricingRuleTaxableStatusMutationVariables>;

/**
 * __useUpdateSurchargePricingRuleTaxableStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSurchargePricingRuleTaxableStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurchargePricingRuleTaxableStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurchargePricingRuleTaxableStatusMutation, { data, loading, error }] = useUpdateSurchargePricingRuleTaxableStatusMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      surchargePricingRuleId: // value for 'surchargePricingRuleId'
 *      taxableStatus: // value for 'taxableStatus'
 *   },
 * });
 */
export function useUpdateSurchargePricingRuleTaxableStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurchargePricingRuleTaxableStatusMutation, UpdateSurchargePricingRuleTaxableStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurchargePricingRuleTaxableStatusMutation, UpdateSurchargePricingRuleTaxableStatusMutationVariables>(UpdateSurchargePricingRuleTaxableStatusDocument, options);
      }
export type UpdateSurchargePricingRuleTaxableStatusMutationHookResult = ReturnType<typeof useUpdateSurchargePricingRuleTaxableStatusMutation>;
export type UpdateSurchargePricingRuleTaxableStatusMutationResult = Apollo.MutationResult<UpdateSurchargePricingRuleTaxableStatusMutation>;
export type UpdateSurchargePricingRuleTaxableStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSurchargePricingRuleTaxableStatusMutation, UpdateSurchargePricingRuleTaxableStatusMutationVariables>;
export const CreateBulkRerateJobDocument = gql`
    mutation CreateBulkRerateJob($courierId: ID!, $input: BulkRerateJobInput!) {
  createBulkRerateJob(courierId: $courierId, input: $input) {
    jobId
    message
  }
}
    `;
export type CreateBulkRerateJobMutationFn = Apollo.MutationFunction<CreateBulkRerateJobMutation, CreateBulkRerateJobMutationVariables>;

/**
 * __useCreateBulkRerateJobMutation__
 *
 * To run a mutation, you first call `useCreateBulkRerateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkRerateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkRerateJobMutation, { data, loading, error }] = useCreateBulkRerateJobMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkRerateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkRerateJobMutation, CreateBulkRerateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkRerateJobMutation, CreateBulkRerateJobMutationVariables>(CreateBulkRerateJobDocument, options);
      }
export type CreateBulkRerateJobMutationHookResult = ReturnType<typeof useCreateBulkRerateJobMutation>;
export type CreateBulkRerateJobMutationResult = Apollo.MutationResult<CreateBulkRerateJobMutation>;
export type CreateBulkRerateJobMutationOptions = Apollo.BaseMutationOptions<CreateBulkRerateJobMutation, CreateBulkRerateJobMutationVariables>;
export const ExportPricingRulesCsvDocument = gql`
    mutation ExportPricingRulesCsv($courierId: ID!, $pricingListId: ID, $isBasePricingList: Boolean!) {
  exportPricingRulesCsv(
    courierId: $courierId
    pricingListId: $pricingListId
    isBasePricingList: $isBasePricingList
  ) {
    url
  }
}
    `;
export type ExportPricingRulesCsvMutationFn = Apollo.MutationFunction<ExportPricingRulesCsvMutation, ExportPricingRulesCsvMutationVariables>;

/**
 * __useExportPricingRulesCsvMutation__
 *
 * To run a mutation, you first call `useExportPricingRulesCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPricingRulesCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPricingRulesCsvMutation, { data, loading, error }] = useExportPricingRulesCsvMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingListId: // value for 'pricingListId'
 *      isBasePricingList: // value for 'isBasePricingList'
 *   },
 * });
 */
export function useExportPricingRulesCsvMutation(baseOptions?: Apollo.MutationHookOptions<ExportPricingRulesCsvMutation, ExportPricingRulesCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPricingRulesCsvMutation, ExportPricingRulesCsvMutationVariables>(ExportPricingRulesCsvDocument, options);
      }
export type ExportPricingRulesCsvMutationHookResult = ReturnType<typeof useExportPricingRulesCsvMutation>;
export type ExportPricingRulesCsvMutationResult = Apollo.MutationResult<ExportPricingRulesCsvMutation>;
export type ExportPricingRulesCsvMutationOptions = Apollo.BaseMutationOptions<ExportPricingRulesCsvMutation, ExportPricingRulesCsvMutationVariables>;
export const ExportSurchargeRulesCsvDocument = gql`
    mutation ExportSurchargeRulesCsv($courierId: ID!, $pricingListId: ID, $isBasePricingList: Boolean!) {
  exportSurchargeRulesCsv(
    courierId: $courierId
    pricingListId: $pricingListId
    isBasePricingList: $isBasePricingList
  ) {
    url
  }
}
    `;
export type ExportSurchargeRulesCsvMutationFn = Apollo.MutationFunction<ExportSurchargeRulesCsvMutation, ExportSurchargeRulesCsvMutationVariables>;

/**
 * __useExportSurchargeRulesCsvMutation__
 *
 * To run a mutation, you first call `useExportSurchargeRulesCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSurchargeRulesCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSurchargeRulesCsvMutation, { data, loading, error }] = useExportSurchargeRulesCsvMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingListId: // value for 'pricingListId'
 *      isBasePricingList: // value for 'isBasePricingList'
 *   },
 * });
 */
export function useExportSurchargeRulesCsvMutation(baseOptions?: Apollo.MutationHookOptions<ExportSurchargeRulesCsvMutation, ExportSurchargeRulesCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSurchargeRulesCsvMutation, ExportSurchargeRulesCsvMutationVariables>(ExportSurchargeRulesCsvDocument, options);
      }
export type ExportSurchargeRulesCsvMutationHookResult = ReturnType<typeof useExportSurchargeRulesCsvMutation>;
export type ExportSurchargeRulesCsvMutationResult = Apollo.MutationResult<ExportSurchargeRulesCsvMutation>;
export type ExportSurchargeRulesCsvMutationOptions = Apollo.BaseMutationOptions<ExportSurchargeRulesCsvMutation, ExportSurchargeRulesCsvMutationVariables>;
export const GetOrderPriceDocument = gql`
    query GetOrderPrice($courierId: ID!, $orderId: ID!) {
  orderPrice(courierId: $courierId, orderId: $orderId) {
    ...OrderPriceFragment
  }
}
    ${OrderPriceFragmentFragmentDoc}`;

/**
 * __useGetOrderPriceQuery__
 *
 * To run a query within a React component, call `useGetOrderPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderPriceQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderPriceQuery(baseOptions: Apollo.QueryHookOptions<GetOrderPriceQuery, GetOrderPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderPriceQuery, GetOrderPriceQueryVariables>(GetOrderPriceDocument, options);
      }
export function useGetOrderPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderPriceQuery, GetOrderPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderPriceQuery, GetOrderPriceQueryVariables>(GetOrderPriceDocument, options);
        }
export type GetOrderPriceQueryHookResult = ReturnType<typeof useGetOrderPriceQuery>;
export type GetOrderPriceLazyQueryHookResult = ReturnType<typeof useGetOrderPriceLazyQuery>;
export type GetOrderPriceQueryResult = Apollo.QueryResult<GetOrderPriceQuery, GetOrderPriceQueryVariables>;
export const GetCurrentEiaFuelRateDocument = gql`
    query GetCurrentEiaFuelRate($courierId: ID!, $vehicleTypeId: ID) {
  currentEiaFuelRate(courierId: $courierId, vehicleTypeId: $vehicleTypeId) {
    ...EiaFuelRateFragment
  }
}
    ${EiaFuelRateFragmentFragmentDoc}`;

/**
 * __useGetCurrentEiaFuelRateQuery__
 *
 * To run a query within a React component, call `useGetCurrentEiaFuelRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEiaFuelRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEiaFuelRateQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *   },
 * });
 */
export function useGetCurrentEiaFuelRateQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentEiaFuelRateQuery, GetCurrentEiaFuelRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentEiaFuelRateQuery, GetCurrentEiaFuelRateQueryVariables>(GetCurrentEiaFuelRateDocument, options);
      }
export function useGetCurrentEiaFuelRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentEiaFuelRateQuery, GetCurrentEiaFuelRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentEiaFuelRateQuery, GetCurrentEiaFuelRateQueryVariables>(GetCurrentEiaFuelRateDocument, options);
        }
export type GetCurrentEiaFuelRateQueryHookResult = ReturnType<typeof useGetCurrentEiaFuelRateQuery>;
export type GetCurrentEiaFuelRateLazyQueryHookResult = ReturnType<typeof useGetCurrentEiaFuelRateLazyQuery>;
export type GetCurrentEiaFuelRateQueryResult = Apollo.QueryResult<GetCurrentEiaFuelRateQuery, GetCurrentEiaFuelRateQueryVariables>;
export const GetEiaFuelRateLinesDocument = gql`
    query GetEiaFuelRateLines($courierId: ID!, $orderId: ID!) {
  eiaFuelRateLines(courierId: $courierId, orderId: $orderId) {
    surchargePricingRuleId
    eiaFuelRate {
      ...EiaFuelRateFragment
    }
  }
}
    ${EiaFuelRateFragmentFragmentDoc}`;

/**
 * __useGetEiaFuelRateLinesQuery__
 *
 * To run a query within a React component, call `useGetEiaFuelRateLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEiaFuelRateLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEiaFuelRateLinesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetEiaFuelRateLinesQuery(baseOptions: Apollo.QueryHookOptions<GetEiaFuelRateLinesQuery, GetEiaFuelRateLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEiaFuelRateLinesQuery, GetEiaFuelRateLinesQueryVariables>(GetEiaFuelRateLinesDocument, options);
      }
export function useGetEiaFuelRateLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEiaFuelRateLinesQuery, GetEiaFuelRateLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEiaFuelRateLinesQuery, GetEiaFuelRateLinesQueryVariables>(GetEiaFuelRateLinesDocument, options);
        }
export type GetEiaFuelRateLinesQueryHookResult = ReturnType<typeof useGetEiaFuelRateLinesQuery>;
export type GetEiaFuelRateLinesLazyQueryHookResult = ReturnType<typeof useGetEiaFuelRateLinesLazyQuery>;
export type GetEiaFuelRateLinesQueryResult = Apollo.QueryResult<GetEiaFuelRateLinesQuery, GetEiaFuelRateLinesQueryVariables>;
export const GetPricingRulesPaginatedDocument = gql`
    query GetPricingRulesPaginated($courierId: ID!, $defaultOnly: Boolean, $locationBasedOnly: Boolean, $pricingListIdsFilter: [ID!], $defaultPricingListOnly: Boolean, $distanceBasedOnly: Boolean, $tripBasedOnly: Boolean, $sortFields: [PricingRulesSorting!], $originZoneIdFilter: ID, $originCityFilter: CityStateCountryCreate, $originZipFilter: String, $originZipGroupIdFilter: ID, $originCircleZoneIdFilter: ID, $destinationZoneIdFilter: ID, $destinationCityFilter: CityStateCountryCreate, $destinationZipFilter: String, $destinationZipGroupIdFilter: ID, $destinationCircleZoneIdFilter: ID, $serviceTypeIdsFilter: [String!], $limit: Int, $after: Int) {
  pricingRulesPaginated(
    courierId: $courierId
    defaultOnly: $defaultOnly
    locationBasedOnly: $locationBasedOnly
    pricingListIdsFilter: $pricingListIdsFilter
    defaultPricingListOnly: $defaultPricingListOnly
    distanceBasedOnly: $distanceBasedOnly
    tripBasedOnly: $tripBasedOnly
    sortFields: $sortFields
    originZoneIdFilter: $originZoneIdFilter
    originCityFilter: $originCityFilter
    originZipFilter: $originZipFilter
    originZipGroupIdFilter: $originZipGroupIdFilter
    originCircleZoneIdFilter: $originCircleZoneIdFilter
    destinationZoneIdFilter: $destinationZoneIdFilter
    destinationCityFilter: $destinationCityFilter
    destinationZipFilter: $destinationZipFilter
    destinationZipGroupIdFilter: $destinationZipGroupIdFilter
    destinationCircleZoneIdFilter: $destinationCircleZoneIdFilter
    serviceTypeIdsFilter: $serviceTypeIdsFilter
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...PricingRuleFragment
        pricingList {
          ...PricingListFragment
        }
        serviceType {
          ...ServiceTypeFragment
        }
        vehicleType {
          ...VehicleTypeFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PricingRuleFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${VehicleTypeFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetPricingRulesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetPricingRulesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingRulesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingRulesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      defaultOnly: // value for 'defaultOnly'
 *      locationBasedOnly: // value for 'locationBasedOnly'
 *      pricingListIdsFilter: // value for 'pricingListIdsFilter'
 *      defaultPricingListOnly: // value for 'defaultPricingListOnly'
 *      distanceBasedOnly: // value for 'distanceBasedOnly'
 *      tripBasedOnly: // value for 'tripBasedOnly'
 *      sortFields: // value for 'sortFields'
 *      originZoneIdFilter: // value for 'originZoneIdFilter'
 *      originCityFilter: // value for 'originCityFilter'
 *      originZipFilter: // value for 'originZipFilter'
 *      originZipGroupIdFilter: // value for 'originZipGroupIdFilter'
 *      originCircleZoneIdFilter: // value for 'originCircleZoneIdFilter'
 *      destinationZoneIdFilter: // value for 'destinationZoneIdFilter'
 *      destinationCityFilter: // value for 'destinationCityFilter'
 *      destinationZipFilter: // value for 'destinationZipFilter'
 *      destinationZipGroupIdFilter: // value for 'destinationZipGroupIdFilter'
 *      destinationCircleZoneIdFilter: // value for 'destinationCircleZoneIdFilter'
 *      serviceTypeIdsFilter: // value for 'serviceTypeIdsFilter'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPricingRulesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>(GetPricingRulesPaginatedDocument, options);
      }
export function useGetPricingRulesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>(GetPricingRulesPaginatedDocument, options);
        }
export type GetPricingRulesPaginatedQueryHookResult = ReturnType<typeof useGetPricingRulesPaginatedQuery>;
export type GetPricingRulesPaginatedLazyQueryHookResult = ReturnType<typeof useGetPricingRulesPaginatedLazyQuery>;
export type GetPricingRulesPaginatedQueryResult = Apollo.QueryResult<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>;
export const GetSurchargePricingRuleDocument = gql`
    query GetSurchargePricingRule($courierId: ID!, $surchargeApplyType: SurchargeApplyType, $pricingListIdsFilter: [ID], $defaultPricingListOnly: Boolean, $amountTypes: [SurchargeAmountType!]) {
  surchargePricingRules(
    courierId: $courierId
    applyType: $surchargeApplyType
    pricingListIdsFilter: $pricingListIdsFilter
    defaultPricingListOnly: $defaultPricingListOnly
    amountTypes: $amountTypes
  ) {
    ...SurchargePricingRuleFragment
    surchargePricingRulesToExclude {
      ...SurchargePricingRuleFragment
    }
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;

/**
 * __useGetSurchargePricingRuleQuery__
 *
 * To run a query within a React component, call `useGetSurchargePricingRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurchargePricingRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurchargePricingRuleQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      surchargeApplyType: // value for 'surchargeApplyType'
 *      pricingListIdsFilter: // value for 'pricingListIdsFilter'
 *      defaultPricingListOnly: // value for 'defaultPricingListOnly'
 *      amountTypes: // value for 'amountTypes'
 *   },
 * });
 */
export function useGetSurchargePricingRuleQuery(baseOptions: Apollo.QueryHookOptions<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>(GetSurchargePricingRuleDocument, options);
      }
export function useGetSurchargePricingRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>(GetSurchargePricingRuleDocument, options);
        }
export type GetSurchargePricingRuleQueryHookResult = ReturnType<typeof useGetSurchargePricingRuleQuery>;
export type GetSurchargePricingRuleLazyQueryHookResult = ReturnType<typeof useGetSurchargePricingRuleLazyQuery>;
export type GetSurchargePricingRuleQueryResult = Apollo.QueryResult<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>;
export const GetSurchargePricingRulesPaginatedDocument = gql`
    query GetSurchargePricingRulesPaginated($courierId: ID!, $pricingListIdsFilter: [ID!], $defaultPricingListOnly: Boolean, $nameFilter: String, $sortFields: [SurchargePricingRuleSorting!], $limit: Int!, $after: Int!) {
  surchargePricingRulesPaginated(
    courierId: $courierId
    pricingListIdsFilter: $pricingListIdsFilter
    defaultPricingListOnly: $defaultPricingListOnly
    nameFilter: $nameFilter
    sortFields: $sortFields
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...SurchargePricingRuleFragment
        surchargePricingRulesToExclude {
          ...SurchargePricingRuleFragment
        }
        pricingList {
          ...PricingListFragment
        }
        packageType {
          id
          courierId
          name
        }
        vehicleType {
          ...VehicleTypeFragment
        }
        serviceTypes {
          ...ServiceTypeFragment
        }
        vehicleTypes {
          id
          name
        }
        depotLocation {
          ...LocationFragment
        }
        zoneForOutOfPerimeterApplyType {
          ...ZoneFragment
        }
        zoneForInPerimeterApplyType {
          ...ZoneFragment
        }
        zoneForPerMilesFromOrToDepotAmountType {
          ...ZoneFragment
        }
        originZone {
          ...ZoneFragment
        }
        destinationZone {
          ...ZoneFragment
        }
        readyTimeHolidaySchedule {
          ...HolidayScheduleFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}
${VehicleTypeFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${ZoneFragmentFragmentDoc}
${HolidayScheduleFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetSurchargePricingRulesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetSurchargePricingRulesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurchargePricingRulesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurchargePricingRulesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingListIdsFilter: // value for 'pricingListIdsFilter'
 *      defaultPricingListOnly: // value for 'defaultPricingListOnly'
 *      nameFilter: // value for 'nameFilter'
 *      sortFields: // value for 'sortFields'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSurchargePricingRulesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>(GetSurchargePricingRulesPaginatedDocument, options);
      }
export function useGetSurchargePricingRulesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>(GetSurchargePricingRulesPaginatedDocument, options);
        }
export type GetSurchargePricingRulesPaginatedQueryHookResult = ReturnType<typeof useGetSurchargePricingRulesPaginatedQuery>;
export type GetSurchargePricingRulesPaginatedLazyQueryHookResult = ReturnType<typeof useGetSurchargePricingRulesPaginatedLazyQuery>;
export type GetSurchargePricingRulesPaginatedQueryResult = Apollo.QueryResult<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>;
export const GetPricingListsDocument = gql`
    query GetPricingLists($courierId: ID!) {
  pricingLists(courierId: $courierId) {
    ...PricingListFragment
  }
}
    ${PricingListFragmentFragmentDoc}`;

/**
 * __useGetPricingListsQuery__
 *
 * To run a query within a React component, call `useGetPricingListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingListsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetPricingListsQuery(baseOptions: Apollo.QueryHookOptions<GetPricingListsQuery, GetPricingListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingListsQuery, GetPricingListsQueryVariables>(GetPricingListsDocument, options);
      }
export function useGetPricingListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingListsQuery, GetPricingListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingListsQuery, GetPricingListsQueryVariables>(GetPricingListsDocument, options);
        }
export type GetPricingListsQueryHookResult = ReturnType<typeof useGetPricingListsQuery>;
export type GetPricingListsLazyQueryHookResult = ReturnType<typeof useGetPricingListsLazyQuery>;
export type GetPricingListsQueryResult = Apollo.QueryResult<GetPricingListsQuery, GetPricingListsQueryVariables>;
export const GetZipGroupsDocument = gql`
    query GetZipGroups($courierId: ID!) {
  zipGroups(courierId: $courierId) {
    ...ZipGroupFragment
  }
}
    ${ZipGroupFragmentFragmentDoc}`;

/**
 * __useGetZipGroupsQuery__
 *
 * To run a query within a React component, call `useGetZipGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZipGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZipGroupsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetZipGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetZipGroupsQuery, GetZipGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZipGroupsQuery, GetZipGroupsQueryVariables>(GetZipGroupsDocument, options);
      }
export function useGetZipGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZipGroupsQuery, GetZipGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZipGroupsQuery, GetZipGroupsQueryVariables>(GetZipGroupsDocument, options);
        }
export type GetZipGroupsQueryHookResult = ReturnType<typeof useGetZipGroupsQuery>;
export type GetZipGroupsLazyQueryHookResult = ReturnType<typeof useGetZipGroupsLazyQuery>;
export type GetZipGroupsQueryResult = Apollo.QueryResult<GetZipGroupsQuery, GetZipGroupsQueryVariables>;
export const PreviewRecurringOrderPriceDocument = gql`
    query PreviewRecurringOrderPrice($courierId: ID, $orderId: ID!) {
  previewRecurringOrderPrice(courierId: $courierId, orderId: $orderId) {
    total
    breakdown {
      ...PricingBreakDownFragment
    }
    taxBreakDown {
      taxItems {
        name
        amount
      }
      totalTaxAmount
    }
    totalAfterTax
  }
}
    ${PricingBreakDownFragmentFragmentDoc}`;

/**
 * __usePreviewRecurringOrderPriceQuery__
 *
 * To run a query within a React component, call `usePreviewRecurringOrderPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewRecurringOrderPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewRecurringOrderPriceQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePreviewRecurringOrderPriceQuery(baseOptions: Apollo.QueryHookOptions<PreviewRecurringOrderPriceQuery, PreviewRecurringOrderPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewRecurringOrderPriceQuery, PreviewRecurringOrderPriceQueryVariables>(PreviewRecurringOrderPriceDocument, options);
      }
export function usePreviewRecurringOrderPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewRecurringOrderPriceQuery, PreviewRecurringOrderPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewRecurringOrderPriceQuery, PreviewRecurringOrderPriceQueryVariables>(PreviewRecurringOrderPriceDocument, options);
        }
export type PreviewRecurringOrderPriceQueryHookResult = ReturnType<typeof usePreviewRecurringOrderPriceQuery>;
export type PreviewRecurringOrderPriceLazyQueryHookResult = ReturnType<typeof usePreviewRecurringOrderPriceLazyQuery>;
export type PreviewRecurringOrderPriceQueryResult = Apollo.QueryResult<PreviewRecurringOrderPriceQuery, PreviewRecurringOrderPriceQueryVariables>;
export const QualityReviewsByShipmentIdsDocument = gql`
    query QualityReviewsByShipmentIds($shipmentIds: [ID!]!) {
  qualityReviewsByShipmentIds(shipmentIds: $shipmentIds) {
    ...QualityReviewFragment
    items {
      ...QualityReviewItemFragment
      artifact {
        ...ArtifactFragment
      }
      resultStructured {
        pricingResult {
          issues {
            suggestedSurchargeAdd {
              surchargeRule {
                ...SurchargePricingRuleFragment
              }
            }
          }
        }
      }
    }
    price {
      ...OrderPriceFragment
    }
  }
}
    ${QualityReviewFragmentFragmentDoc}
${QualityReviewItemFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${SurchargePricingRuleFragmentFragmentDoc}
${OrderPriceFragmentFragmentDoc}`;

/**
 * __useQualityReviewsByShipmentIdsQuery__
 *
 * To run a query within a React component, call `useQualityReviewsByShipmentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQualityReviewsByShipmentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQualityReviewsByShipmentIdsQuery({
 *   variables: {
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useQualityReviewsByShipmentIdsQuery(baseOptions: Apollo.QueryHookOptions<QualityReviewsByShipmentIdsQuery, QualityReviewsByShipmentIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QualityReviewsByShipmentIdsQuery, QualityReviewsByShipmentIdsQueryVariables>(QualityReviewsByShipmentIdsDocument, options);
      }
export function useQualityReviewsByShipmentIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QualityReviewsByShipmentIdsQuery, QualityReviewsByShipmentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QualityReviewsByShipmentIdsQuery, QualityReviewsByShipmentIdsQueryVariables>(QualityReviewsByShipmentIdsDocument, options);
        }
export type QualityReviewsByShipmentIdsQueryHookResult = ReturnType<typeof useQualityReviewsByShipmentIdsQuery>;
export type QualityReviewsByShipmentIdsLazyQueryHookResult = ReturnType<typeof useQualityReviewsByShipmentIdsLazyQuery>;
export type QualityReviewsByShipmentIdsQueryResult = Apollo.QueryResult<QualityReviewsByShipmentIdsQuery, QualityReviewsByShipmentIdsQueryVariables>;
export const UpsertRemoteEntityLinkageDocument = gql`
    mutation UpsertRemoteEntityLinkage($courierId: ID!, $upsert: RemoteEntityLinkageUpsert!) {
  upsertRemoteEntityLinkage(courierId: $courierId, upsert: $upsert) {
    id
    externalUrl
  }
}
    `;
export type UpsertRemoteEntityLinkageMutationFn = Apollo.MutationFunction<UpsertRemoteEntityLinkageMutation, UpsertRemoteEntityLinkageMutationVariables>;

/**
 * __useUpsertRemoteEntityLinkageMutation__
 *
 * To run a mutation, you first call `useUpsertRemoteEntityLinkageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRemoteEntityLinkageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRemoteEntityLinkageMutation, { data, loading, error }] = useUpsertRemoteEntityLinkageMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      upsert: // value for 'upsert'
 *   },
 * });
 */
export function useUpsertRemoteEntityLinkageMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRemoteEntityLinkageMutation, UpsertRemoteEntityLinkageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRemoteEntityLinkageMutation, UpsertRemoteEntityLinkageMutationVariables>(UpsertRemoteEntityLinkageDocument, options);
      }
export type UpsertRemoteEntityLinkageMutationHookResult = ReturnType<typeof useUpsertRemoteEntityLinkageMutation>;
export type UpsertRemoteEntityLinkageMutationResult = Apollo.MutationResult<UpsertRemoteEntityLinkageMutation>;
export type UpsertRemoteEntityLinkageMutationOptions = Apollo.BaseMutationOptions<UpsertRemoteEntityLinkageMutation, UpsertRemoteEntityLinkageMutationVariables>;
export const QuickbookCustomerDocument = gql`
    query QuickbookCustomer($courierId: ID!, $remoteId: ID!) {
  quickbookCustomer(courierId: $courierId, remoteId: $remoteId) {
    id
    name
    email
    phone
  }
}
    `;

/**
 * __useQuickbookCustomerQuery__
 *
 * To run a query within a React component, call `useQuickbookCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbookCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbookCustomerQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      remoteId: // value for 'remoteId'
 *   },
 * });
 */
export function useQuickbookCustomerQuery(baseOptions: Apollo.QueryHookOptions<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>(QuickbookCustomerDocument, options);
      }
export function useQuickbookCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>(QuickbookCustomerDocument, options);
        }
export type QuickbookCustomerQueryHookResult = ReturnType<typeof useQuickbookCustomerQuery>;
export type QuickbookCustomerLazyQueryHookResult = ReturnType<typeof useQuickbookCustomerLazyQuery>;
export type QuickbookCustomerQueryResult = Apollo.QueryResult<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>;
export const QuickbookVendorDocument = gql`
    query QuickbookVendor($courierId: ID!, $remoteId: ID!) {
  quickbookVendor(courierId: $courierId, remoteId: $remoteId) {
    id
    name
    email
    phone
  }
}
    `;

/**
 * __useQuickbookVendorQuery__
 *
 * To run a query within a React component, call `useQuickbookVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbookVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbookVendorQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      remoteId: // value for 'remoteId'
 *   },
 * });
 */
export function useQuickbookVendorQuery(baseOptions: Apollo.QueryHookOptions<QuickbookVendorQuery, QuickbookVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickbookVendorQuery, QuickbookVendorQueryVariables>(QuickbookVendorDocument, options);
      }
export function useQuickbookVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickbookVendorQuery, QuickbookVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickbookVendorQuery, QuickbookVendorQueryVariables>(QuickbookVendorDocument, options);
        }
export type QuickbookVendorQueryHookResult = ReturnType<typeof useQuickbookVendorQuery>;
export type QuickbookVendorLazyQueryHookResult = ReturnType<typeof useQuickbookVendorLazyQuery>;
export type QuickbookVendorQueryResult = Apollo.QueryResult<QuickbookVendorQuery, QuickbookVendorQueryVariables>;
export const GenerateSalesReportCsvDocument = gql`
    mutation GenerateSalesReportCsv($courierId: ID!, $minDate: Date, $maxDate: Date, $minCompletedDate: Date, $maxCompletedDate: Date, $includeAllSurcharge: Boolean) {
  generateSalesReportCsv(
    courierId: $courierId
    minDate: $minDate
    maxDate: $maxDate
    minCompletedDate: $minCompletedDate
    maxCompletedDate: $maxCompletedDate
    includeAllSurcharge: $includeAllSurcharge
  ) {
    ...SalesReportFileFragment
  }
}
    ${SalesReportFileFragmentFragmentDoc}`;
export type GenerateSalesReportCsvMutationFn = Apollo.MutationFunction<GenerateSalesReportCsvMutation, GenerateSalesReportCsvMutationVariables>;

/**
 * __useGenerateSalesReportCsvMutation__
 *
 * To run a mutation, you first call `useGenerateSalesReportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSalesReportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSalesReportCsvMutation, { data, loading, error }] = useGenerateSalesReportCsvMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      minCompletedDate: // value for 'minCompletedDate'
 *      maxCompletedDate: // value for 'maxCompletedDate'
 *      includeAllSurcharge: // value for 'includeAllSurcharge'
 *   },
 * });
 */
export function useGenerateSalesReportCsvMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSalesReportCsvMutation, GenerateSalesReportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSalesReportCsvMutation, GenerateSalesReportCsvMutationVariables>(GenerateSalesReportCsvDocument, options);
      }
export type GenerateSalesReportCsvMutationHookResult = ReturnType<typeof useGenerateSalesReportCsvMutation>;
export type GenerateSalesReportCsvMutationResult = Apollo.MutationResult<GenerateSalesReportCsvMutation>;
export type GenerateSalesReportCsvMutationOptions = Apollo.BaseMutationOptions<GenerateSalesReportCsvMutation, GenerateSalesReportCsvMutationVariables>;
export const SalesOverviewDocument = gql`
    query SalesOverview($courierId: ID!, $minDate: Date!, $maxDate: Date!) {
  salesOverview(courierId: $courierId, minDate: $minDate, maxDate: $maxDate) {
    ...SalesOverviewFragment
  }
}
    ${SalesOverviewFragmentFragmentDoc}`;

/**
 * __useSalesOverviewQuery__
 *
 * To run a query within a React component, call `useSalesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOverviewQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useSalesOverviewQuery(baseOptions: Apollo.QueryHookOptions<SalesOverviewQuery, SalesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOverviewQuery, SalesOverviewQueryVariables>(SalesOverviewDocument, options);
      }
export function useSalesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOverviewQuery, SalesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOverviewQuery, SalesOverviewQueryVariables>(SalesOverviewDocument, options);
        }
export type SalesOverviewQueryHookResult = ReturnType<typeof useSalesOverviewQuery>;
export type SalesOverviewLazyQueryHookResult = ReturnType<typeof useSalesOverviewLazyQuery>;
export type SalesOverviewQueryResult = Apollo.QueryResult<SalesOverviewQuery, SalesOverviewQueryVariables>;
export const CreateServiceTypeDocument = gql`
    mutation createServiceType($courierId: ID!, $name: String!, $deliveryTimeInMinutes: Int, $dueTimeType: ServiceTypeDueTimeType, $dueTimeSecondsSinceMidnight: Int, $dueTimeInBusinessDaysAfter: Int, $dueTimeInDaysAfter: Int, $deliveryRoutedDaysAfter: Int, $milesLimit: Float, $extraSecondsPerMilePastLimit: Float, $pickupCloseType: ServiceTypeDueTimeType, $pickupCloseTimeInMinutes: Int, $pickupCloseTimeInSecondsSinceMidnight: Int, $pickupCloseTimeInBusinessDaysAfter: Int, $pickupCloseTimeInDaysAfter: Int, $orderingSequenceNumber: Int, $freeWaitTimeInSeconds: Int) {
  createServiceType(
    courierId: $courierId
    name: $name
    deliveryTimeInMinutes: $deliveryTimeInMinutes
    dueTimeType: $dueTimeType
    dueTimeSecondsSinceMidnight: $dueTimeSecondsSinceMidnight
    dueTimeInBusinessDaysAfter: $dueTimeInBusinessDaysAfter
    dueTimeInDaysAfter: $dueTimeInDaysAfter
    deliveryRoutedDaysAfter: $deliveryRoutedDaysAfter
    milesLimit: $milesLimit
    extraSecondsPerMilePastLimit: $extraSecondsPerMilePastLimit
    pickupCloseType: $pickupCloseType
    pickupCloseTimeInMinutes: $pickupCloseTimeInMinutes
    pickupCloseTimeInSecondsSinceMidnight: $pickupCloseTimeInSecondsSinceMidnight
    pickupCloseTimeInBusinessDaysAfter: $pickupCloseTimeInBusinessDaysAfter
    pickupCloseTimeInDaysAfter: $pickupCloseTimeInDaysAfter
    orderingSequenceNumber: $orderingSequenceNumber
    freeWaitTimeInSeconds: $freeWaitTimeInSeconds
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type CreateServiceTypeMutationFn = Apollo.MutationFunction<CreateServiceTypeMutation, CreateServiceTypeMutationVariables>;

/**
 * __useCreateServiceTypeMutation__
 *
 * To run a mutation, you first call `useCreateServiceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceTypeMutation, { data, loading, error }] = useCreateServiceTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      deliveryTimeInMinutes: // value for 'deliveryTimeInMinutes'
 *      dueTimeType: // value for 'dueTimeType'
 *      dueTimeSecondsSinceMidnight: // value for 'dueTimeSecondsSinceMidnight'
 *      dueTimeInBusinessDaysAfter: // value for 'dueTimeInBusinessDaysAfter'
 *      dueTimeInDaysAfter: // value for 'dueTimeInDaysAfter'
 *      deliveryRoutedDaysAfter: // value for 'deliveryRoutedDaysAfter'
 *      milesLimit: // value for 'milesLimit'
 *      extraSecondsPerMilePastLimit: // value for 'extraSecondsPerMilePastLimit'
 *      pickupCloseType: // value for 'pickupCloseType'
 *      pickupCloseTimeInMinutes: // value for 'pickupCloseTimeInMinutes'
 *      pickupCloseTimeInSecondsSinceMidnight: // value for 'pickupCloseTimeInSecondsSinceMidnight'
 *      pickupCloseTimeInBusinessDaysAfter: // value for 'pickupCloseTimeInBusinessDaysAfter'
 *      pickupCloseTimeInDaysAfter: // value for 'pickupCloseTimeInDaysAfter'
 *      orderingSequenceNumber: // value for 'orderingSequenceNumber'
 *      freeWaitTimeInSeconds: // value for 'freeWaitTimeInSeconds'
 *   },
 * });
 */
export function useCreateServiceTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceTypeMutation, CreateServiceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceTypeMutation, CreateServiceTypeMutationVariables>(CreateServiceTypeDocument, options);
      }
export type CreateServiceTypeMutationHookResult = ReturnType<typeof useCreateServiceTypeMutation>;
export type CreateServiceTypeMutationResult = Apollo.MutationResult<CreateServiceTypeMutation>;
export type CreateServiceTypeMutationOptions = Apollo.BaseMutationOptions<CreateServiceTypeMutation, CreateServiceTypeMutationVariables>;
export const FullUpdateServiceTypeDocument = gql`
    mutation fullUpdateServiceType($courierId: ID!, $id: ID!, $name: String!, $deliveryTimeInMinutes: Int, $color: String, $visibilityType: ServiceTypeVisibilityType, $dueTimeType: ServiceTypeDueTimeType, $dueTimeSecondsSinceMidnight: Int, $dueTimeInBusinessDaysAfter: Int, $dueTimeInDaysAfter: Int, $deliveryRoutedDaysAfter: Int, $customMessage: String, $milesLimit: Float, $extraSecondsPerMilePastLimit: Float, $pickupCloseType: ServiceTypeDueTimeType, $pickupCloseTimeInMinutes: Int, $pickupCloseTimeInSecondsSinceMidnight: Int, $pickupCloseTimeInBusinessDaysAfter: Int, $pickupCloseTimeInDaysAfter: Int, $orderingSequenceNumber: Int, $freeWaitTimeInSeconds: Int) {
  fullUpdateServiceType(
    courierId: $courierId
    fullUpdate: {id: $id, name: $name, deliveryTimeInMinutes: $deliveryTimeInMinutes, color: $color, visibilityType: $visibilityType, dueTimeType: $dueTimeType, dueTimeSecondsSinceMidnight: $dueTimeSecondsSinceMidnight, dueTimeInBusinessDaysAfter: $dueTimeInBusinessDaysAfter, dueTimeInDaysAfter: $dueTimeInDaysAfter, deliveryRoutedDaysAfter: $deliveryRoutedDaysAfter, customMessage: $customMessage, milesLimit: $milesLimit, extraSecondsPerMilePastLimit: $extraSecondsPerMilePastLimit, pickupCloseType: $pickupCloseType, pickupCloseTimeInMinutes: $pickupCloseTimeInMinutes, pickupCloseTimeInSecondsSinceMidnight: $pickupCloseTimeInSecondsSinceMidnight, pickupCloseTimeInBusinessDaysAfter: $pickupCloseTimeInBusinessDaysAfter, pickupCloseTimeInDaysAfter: $pickupCloseTimeInDaysAfter, orderingSequenceNumber: $orderingSequenceNumber, freeWaitTimeInSeconds: $freeWaitTimeInSeconds}
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type FullUpdateServiceTypeMutationFn = Apollo.MutationFunction<FullUpdateServiceTypeMutation, FullUpdateServiceTypeMutationVariables>;

/**
 * __useFullUpdateServiceTypeMutation__
 *
 * To run a mutation, you first call `useFullUpdateServiceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateServiceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateServiceTypeMutation, { data, loading, error }] = useFullUpdateServiceTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      deliveryTimeInMinutes: // value for 'deliveryTimeInMinutes'
 *      color: // value for 'color'
 *      visibilityType: // value for 'visibilityType'
 *      dueTimeType: // value for 'dueTimeType'
 *      dueTimeSecondsSinceMidnight: // value for 'dueTimeSecondsSinceMidnight'
 *      dueTimeInBusinessDaysAfter: // value for 'dueTimeInBusinessDaysAfter'
 *      dueTimeInDaysAfter: // value for 'dueTimeInDaysAfter'
 *      deliveryRoutedDaysAfter: // value for 'deliveryRoutedDaysAfter'
 *      customMessage: // value for 'customMessage'
 *      milesLimit: // value for 'milesLimit'
 *      extraSecondsPerMilePastLimit: // value for 'extraSecondsPerMilePastLimit'
 *      pickupCloseType: // value for 'pickupCloseType'
 *      pickupCloseTimeInMinutes: // value for 'pickupCloseTimeInMinutes'
 *      pickupCloseTimeInSecondsSinceMidnight: // value for 'pickupCloseTimeInSecondsSinceMidnight'
 *      pickupCloseTimeInBusinessDaysAfter: // value for 'pickupCloseTimeInBusinessDaysAfter'
 *      pickupCloseTimeInDaysAfter: // value for 'pickupCloseTimeInDaysAfter'
 *      orderingSequenceNumber: // value for 'orderingSequenceNumber'
 *      freeWaitTimeInSeconds: // value for 'freeWaitTimeInSeconds'
 *   },
 * });
 */
export function useFullUpdateServiceTypeMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateServiceTypeMutation, FullUpdateServiceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateServiceTypeMutation, FullUpdateServiceTypeMutationVariables>(FullUpdateServiceTypeDocument, options);
      }
export type FullUpdateServiceTypeMutationHookResult = ReturnType<typeof useFullUpdateServiceTypeMutation>;
export type FullUpdateServiceTypeMutationResult = Apollo.MutationResult<FullUpdateServiceTypeMutation>;
export type FullUpdateServiceTypeMutationOptions = Apollo.BaseMutationOptions<FullUpdateServiceTypeMutation, FullUpdateServiceTypeMutationVariables>;
export const UpdateServiceTypeReadyTimeScheduleDocument = gql`
    mutation UpdateServiceTypeReadyTimeSchedule($courierId: ID!, $serviceTypeId: ID!, $readyTimeSchedule: TimeScheduleInput!) {
  updateServiceTypeReadyTimeSchedule(
    courierId: $courierId
    serviceTypeId: $serviceTypeId
    readyTimeSchedule: $readyTimeSchedule
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type UpdateServiceTypeReadyTimeScheduleMutationFn = Apollo.MutationFunction<UpdateServiceTypeReadyTimeScheduleMutation, UpdateServiceTypeReadyTimeScheduleMutationVariables>;

/**
 * __useUpdateServiceTypeReadyTimeScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateServiceTypeReadyTimeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceTypeReadyTimeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceTypeReadyTimeScheduleMutation, { data, loading, error }] = useUpdateServiceTypeReadyTimeScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      readyTimeSchedule: // value for 'readyTimeSchedule'
 *   },
 * });
 */
export function useUpdateServiceTypeReadyTimeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceTypeReadyTimeScheduleMutation, UpdateServiceTypeReadyTimeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceTypeReadyTimeScheduleMutation, UpdateServiceTypeReadyTimeScheduleMutationVariables>(UpdateServiceTypeReadyTimeScheduleDocument, options);
      }
export type UpdateServiceTypeReadyTimeScheduleMutationHookResult = ReturnType<typeof useUpdateServiceTypeReadyTimeScheduleMutation>;
export type UpdateServiceTypeReadyTimeScheduleMutationResult = Apollo.MutationResult<UpdateServiceTypeReadyTimeScheduleMutation>;
export type UpdateServiceTypeReadyTimeScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateServiceTypeReadyTimeScheduleMutation, UpdateServiceTypeReadyTimeScheduleMutationVariables>;
export const UpdateServiceTypeBusinessHoursScheduleDocument = gql`
    mutation UpdateServiceTypeBusinessHoursSchedule($courierId: ID!, $serviceTypeId: ID!, $businessHoursSchedule: TimeScheduleInput) {
  updateServiceTypeBusinessHoursSchedule(
    courierId: $courierId
    serviceTypeId: $serviceTypeId
    businessHoursSchedule: $businessHoursSchedule
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type UpdateServiceTypeBusinessHoursScheduleMutationFn = Apollo.MutationFunction<UpdateServiceTypeBusinessHoursScheduleMutation, UpdateServiceTypeBusinessHoursScheduleMutationVariables>;

/**
 * __useUpdateServiceTypeBusinessHoursScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateServiceTypeBusinessHoursScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceTypeBusinessHoursScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceTypeBusinessHoursScheduleMutation, { data, loading, error }] = useUpdateServiceTypeBusinessHoursScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      businessHoursSchedule: // value for 'businessHoursSchedule'
 *   },
 * });
 */
export function useUpdateServiceTypeBusinessHoursScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceTypeBusinessHoursScheduleMutation, UpdateServiceTypeBusinessHoursScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceTypeBusinessHoursScheduleMutation, UpdateServiceTypeBusinessHoursScheduleMutationVariables>(UpdateServiceTypeBusinessHoursScheduleDocument, options);
      }
export type UpdateServiceTypeBusinessHoursScheduleMutationHookResult = ReturnType<typeof useUpdateServiceTypeBusinessHoursScheduleMutation>;
export type UpdateServiceTypeBusinessHoursScheduleMutationResult = Apollo.MutationResult<UpdateServiceTypeBusinessHoursScheduleMutation>;
export type UpdateServiceTypeBusinessHoursScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateServiceTypeBusinessHoursScheduleMutation, UpdateServiceTypeBusinessHoursScheduleMutationVariables>;
export const UpdateServiceTypeVisibleVehicleTypesDocument = gql`
    mutation UpdateServiceTypeVisibleVehicleTypes($courierId: ID!, $serviceTypeId: ID!, $visibleVehicleTypeIds: [String!], $defaultVehicleTypeId: ID) {
  updateServiceTypeVisibleVehicleTypes(
    courierId: $courierId
    serviceTypeId: $serviceTypeId
    visibleVehicleTypeIds: $visibleVehicleTypeIds
    defaultVehicleTypeId: $defaultVehicleTypeId
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type UpdateServiceTypeVisibleVehicleTypesMutationFn = Apollo.MutationFunction<UpdateServiceTypeVisibleVehicleTypesMutation, UpdateServiceTypeVisibleVehicleTypesMutationVariables>;

/**
 * __useUpdateServiceTypeVisibleVehicleTypesMutation__
 *
 * To run a mutation, you first call `useUpdateServiceTypeVisibleVehicleTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceTypeVisibleVehicleTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceTypeVisibleVehicleTypesMutation, { data, loading, error }] = useUpdateServiceTypeVisibleVehicleTypesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      visibleVehicleTypeIds: // value for 'visibleVehicleTypeIds'
 *      defaultVehicleTypeId: // value for 'defaultVehicleTypeId'
 *   },
 * });
 */
export function useUpdateServiceTypeVisibleVehicleTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceTypeVisibleVehicleTypesMutation, UpdateServiceTypeVisibleVehicleTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceTypeVisibleVehicleTypesMutation, UpdateServiceTypeVisibleVehicleTypesMutationVariables>(UpdateServiceTypeVisibleVehicleTypesDocument, options);
      }
export type UpdateServiceTypeVisibleVehicleTypesMutationHookResult = ReturnType<typeof useUpdateServiceTypeVisibleVehicleTypesMutation>;
export type UpdateServiceTypeVisibleVehicleTypesMutationResult = Apollo.MutationResult<UpdateServiceTypeVisibleVehicleTypesMutation>;
export type UpdateServiceTypeVisibleVehicleTypesMutationOptions = Apollo.BaseMutationOptions<UpdateServiceTypeVisibleVehicleTypesMutation, UpdateServiceTypeVisibleVehicleTypesMutationVariables>;
export const DeleteServiceTypeDocument = gql`
    mutation DeleteServiceType($courierId: ID!, $serviceTypeId: ID!) {
  deleteServiceType(courierId: $courierId, serviceTypeId: $serviceTypeId) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type DeleteServiceTypeMutationFn = Apollo.MutationFunction<DeleteServiceTypeMutation, DeleteServiceTypeMutationVariables>;

/**
 * __useDeleteServiceTypeMutation__
 *
 * To run a mutation, you first call `useDeleteServiceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceTypeMutation, { data, loading, error }] = useDeleteServiceTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      serviceTypeId: // value for 'serviceTypeId'
 *   },
 * });
 */
export function useDeleteServiceTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceTypeMutation, DeleteServiceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceTypeMutation, DeleteServiceTypeMutationVariables>(DeleteServiceTypeDocument, options);
      }
export type DeleteServiceTypeMutationHookResult = ReturnType<typeof useDeleteServiceTypeMutation>;
export type DeleteServiceTypeMutationResult = Apollo.MutationResult<DeleteServiceTypeMutation>;
export type DeleteServiceTypeMutationOptions = Apollo.BaseMutationOptions<DeleteServiceTypeMutation, DeleteServiceTypeMutationVariables>;
export const CalculateExtraSecondsFromMilesOverLimitForServiceTypeDocument = gql`
    mutation calculateExtraSecondsFromMilesOverLimitForServiceType($courierId: ID!, $serviceTypeId: ID!, $googlePlaceIds: [ID!]!) {
  calculateExtraSecondsFromMilesOverLimitForServiceType(
    courierId: $courierId
    serviceTypeId: $serviceTypeId
    googlePlaceIds: $googlePlaceIds
  )
}
    `;
export type CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationFn = Apollo.MutationFunction<CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation, CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationVariables>;

/**
 * __useCalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation__
 *
 * To run a mutation, you first call `useCalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateExtraSecondsFromMilesOverLimitForServiceTypeMutation, { data, loading, error }] = useCalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      googlePlaceIds: // value for 'googlePlaceIds'
 *   },
 * });
 */
export function useCalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation(baseOptions?: Apollo.MutationHookOptions<CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation, CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation, CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationVariables>(CalculateExtraSecondsFromMilesOverLimitForServiceTypeDocument, options);
      }
export type CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationHookResult = ReturnType<typeof useCalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation>;
export type CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationResult = Apollo.MutationResult<CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation>;
export type CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationOptions = Apollo.BaseMutationOptions<CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutation, CalculateExtraSecondsFromMilesOverLimitForServiceTypeMutationVariables>;
export const UpdateServiceTypePricingMultiplierDocument = gql`
    mutation UpdateServiceTypePricingMultiplier($courierId: ID!, $serviceTypeId: ID!, $multiplier: Money, $multiplierMode: ServiceTypeMultiplierMode!) {
  updateServiceTypePricingMultiplier(
    courierId: $courierId
    serviceTypeId: $serviceTypeId
    multiplier: $multiplier
    multiplierMode: $multiplierMode
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type UpdateServiceTypePricingMultiplierMutationFn = Apollo.MutationFunction<UpdateServiceTypePricingMultiplierMutation, UpdateServiceTypePricingMultiplierMutationVariables>;

/**
 * __useUpdateServiceTypePricingMultiplierMutation__
 *
 * To run a mutation, you first call `useUpdateServiceTypePricingMultiplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceTypePricingMultiplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceTypePricingMultiplierMutation, { data, loading, error }] = useUpdateServiceTypePricingMultiplierMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      multiplier: // value for 'multiplier'
 *      multiplierMode: // value for 'multiplierMode'
 *   },
 * });
 */
export function useUpdateServiceTypePricingMultiplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceTypePricingMultiplierMutation, UpdateServiceTypePricingMultiplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceTypePricingMultiplierMutation, UpdateServiceTypePricingMultiplierMutationVariables>(UpdateServiceTypePricingMultiplierDocument, options);
      }
export type UpdateServiceTypePricingMultiplierMutationHookResult = ReturnType<typeof useUpdateServiceTypePricingMultiplierMutation>;
export type UpdateServiceTypePricingMultiplierMutationResult = Apollo.MutationResult<UpdateServiceTypePricingMultiplierMutation>;
export type UpdateServiceTypePricingMultiplierMutationOptions = Apollo.BaseMutationOptions<UpdateServiceTypePricingMultiplierMutation, UpdateServiceTypePricingMultiplierMutationVariables>;
export const GetServiceTypesDocument = gql`
    query GetServiceTypes($courierId: ID!, $endCustomerId: ID, $showForEndCustomer: Boolean, $includeInternalOnly: Boolean) {
  serviceTypes(
    courierId: $courierId
    endCustomerId: $endCustomerId
    showForEndCustomer: $showForEndCustomer
    includeInternalOnly: $includeInternalOnly
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;

/**
 * __useGetServiceTypesQuery__
 *
 * To run a query within a React component, call `useGetServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceTypesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      showForEndCustomer: // value for 'showForEndCustomer'
 *      includeInternalOnly: // value for 'includeInternalOnly'
 *   },
 * });
 */
export function useGetServiceTypesQuery(baseOptions: Apollo.QueryHookOptions<GetServiceTypesQuery, GetServiceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceTypesQuery, GetServiceTypesQueryVariables>(GetServiceTypesDocument, options);
      }
export function useGetServiceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceTypesQuery, GetServiceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceTypesQuery, GetServiceTypesQueryVariables>(GetServiceTypesDocument, options);
        }
export type GetServiceTypesQueryHookResult = ReturnType<typeof useGetServiceTypesQuery>;
export type GetServiceTypesLazyQueryHookResult = ReturnType<typeof useGetServiceTypesLazyQuery>;
export type GetServiceTypesQueryResult = Apollo.QueryResult<GetServiceTypesQuery, GetServiceTypesQueryVariables>;
export const UnassignDriverFromShipmentDocument = gql`
    mutation UnassignDriverFromShipment($courierId: ID!, $shipmentId: ID!) {
  unassignDriverFromShipment(courierId: $courierId, shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type UnassignDriverFromShipmentMutationFn = Apollo.MutationFunction<UnassignDriverFromShipmentMutation, UnassignDriverFromShipmentMutationVariables>;

/**
 * __useUnassignDriverFromShipmentMutation__
 *
 * To run a mutation, you first call `useUnassignDriverFromShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignDriverFromShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignDriverFromShipmentMutation, { data, loading, error }] = useUnassignDriverFromShipmentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useUnassignDriverFromShipmentMutation(baseOptions?: Apollo.MutationHookOptions<UnassignDriverFromShipmentMutation, UnassignDriverFromShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignDriverFromShipmentMutation, UnassignDriverFromShipmentMutationVariables>(UnassignDriverFromShipmentDocument, options);
      }
export type UnassignDriverFromShipmentMutationHookResult = ReturnType<typeof useUnassignDriverFromShipmentMutation>;
export type UnassignDriverFromShipmentMutationResult = Apollo.MutationResult<UnassignDriverFromShipmentMutation>;
export type UnassignDriverFromShipmentMutationOptions = Apollo.BaseMutationOptions<UnassignDriverFromShipmentMutation, UnassignDriverFromShipmentMutationVariables>;
export const MarkShipmentAsFailedDocument = gql`
    mutation MarkShipmentAsFailed($courierId: ID!, $shipmentId: ID!) {
  markShipmentAsFailed(courierId: $courierId, shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentAsFailedMutationFn = Apollo.MutationFunction<MarkShipmentAsFailedMutation, MarkShipmentAsFailedMutationVariables>;

/**
 * __useMarkShipmentAsFailedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentAsFailedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentAsFailedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentAsFailedMutation, { data, loading, error }] = useMarkShipmentAsFailedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useMarkShipmentAsFailedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentAsFailedMutation, MarkShipmentAsFailedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentAsFailedMutation, MarkShipmentAsFailedMutationVariables>(MarkShipmentAsFailedDocument, options);
      }
export type MarkShipmentAsFailedMutationHookResult = ReturnType<typeof useMarkShipmentAsFailedMutation>;
export type MarkShipmentAsFailedMutationResult = Apollo.MutationResult<MarkShipmentAsFailedMutation>;
export type MarkShipmentAsFailedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentAsFailedMutation, MarkShipmentAsFailedMutationVariables>;
export const MarkShipmentAsDeletedDocument = gql`
    mutation MarkShipmentAsDeleted($courierId: ID!, $shipmentId: ID!) {
  markShipmentAsDeleted(courierId: $courierId, shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentAsDeletedMutationFn = Apollo.MutationFunction<MarkShipmentAsDeletedMutation, MarkShipmentAsDeletedMutationVariables>;

/**
 * __useMarkShipmentAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentAsDeletedMutation, { data, loading, error }] = useMarkShipmentAsDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useMarkShipmentAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentAsDeletedMutation, MarkShipmentAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentAsDeletedMutation, MarkShipmentAsDeletedMutationVariables>(MarkShipmentAsDeletedDocument, options);
      }
export type MarkShipmentAsDeletedMutationHookResult = ReturnType<typeof useMarkShipmentAsDeletedMutation>;
export type MarkShipmentAsDeletedMutationResult = Apollo.MutationResult<MarkShipmentAsDeletedMutation>;
export type MarkShipmentAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentAsDeletedMutation, MarkShipmentAsDeletedMutationVariables>;
export const MarkShipmentsAsDeletedDocument = gql`
    mutation MarkShipmentsAsDeleted($courierId: ID!, $shipmentIds: [ID!]!) {
  markShipmentsAsDeleted(courierId: $courierId, shipmentIds: $shipmentIds) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentsAsDeletedMutationFn = Apollo.MutationFunction<MarkShipmentsAsDeletedMutation, MarkShipmentsAsDeletedMutationVariables>;

/**
 * __useMarkShipmentsAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentsAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentsAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentsAsDeletedMutation, { data, loading, error }] = useMarkShipmentsAsDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useMarkShipmentsAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentsAsDeletedMutation, MarkShipmentsAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentsAsDeletedMutation, MarkShipmentsAsDeletedMutationVariables>(MarkShipmentsAsDeletedDocument, options);
      }
export type MarkShipmentsAsDeletedMutationHookResult = ReturnType<typeof useMarkShipmentsAsDeletedMutation>;
export type MarkShipmentsAsDeletedMutationResult = Apollo.MutationResult<MarkShipmentsAsDeletedMutation>;
export type MarkShipmentsAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentsAsDeletedMutation, MarkShipmentsAsDeletedMutationVariables>;
export const MarkShipmentAsClosedDocument = gql`
    mutation MarkShipmentAsClosed($courierId: ID!, $shipmentId: ID!) {
  markShipmentAsClosed(courierId: $courierId, shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentAsClosedMutationFn = Apollo.MutationFunction<MarkShipmentAsClosedMutation, MarkShipmentAsClosedMutationVariables>;

/**
 * __useMarkShipmentAsClosedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentAsClosedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentAsClosedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentAsClosedMutation, { data, loading, error }] = useMarkShipmentAsClosedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useMarkShipmentAsClosedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentAsClosedMutation, MarkShipmentAsClosedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentAsClosedMutation, MarkShipmentAsClosedMutationVariables>(MarkShipmentAsClosedDocument, options);
      }
export type MarkShipmentAsClosedMutationHookResult = ReturnType<typeof useMarkShipmentAsClosedMutation>;
export type MarkShipmentAsClosedMutationResult = Apollo.MutationResult<MarkShipmentAsClosedMutation>;
export type MarkShipmentAsClosedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentAsClosedMutation, MarkShipmentAsClosedMutationVariables>;
export const ResetShipmentDocument = gql`
    mutation ResetShipment($courierId: ID!, $shipmentId: ID!, $resetBy: String!) {
  resetShipment(courierId: $courierId, shipmentId: $shipmentId, resetBy: $resetBy) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ResetShipmentMutationFn = Apollo.MutationFunction<ResetShipmentMutation, ResetShipmentMutationVariables>;

/**
 * __useResetShipmentMutation__
 *
 * To run a mutation, you first call `useResetShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetShipmentMutation, { data, loading, error }] = useResetShipmentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      resetBy: // value for 'resetBy'
 *   },
 * });
 */
export function useResetShipmentMutation(baseOptions?: Apollo.MutationHookOptions<ResetShipmentMutation, ResetShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetShipmentMutation, ResetShipmentMutationVariables>(ResetShipmentDocument, options);
      }
export type ResetShipmentMutationHookResult = ReturnType<typeof useResetShipmentMutation>;
export type ResetShipmentMutationResult = Apollo.MutationResult<ResetShipmentMutation>;
export type ResetShipmentMutationOptions = Apollo.BaseMutationOptions<ResetShipmentMutation, ResetShipmentMutationVariables>;
export const UncloseShipmentDocument = gql`
    mutation UncloseShipment($courierId: ID!, $shipmentId: ID!) {
  uncloseShipment(courierId: $courierId, shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type UncloseShipmentMutationFn = Apollo.MutationFunction<UncloseShipmentMutation, UncloseShipmentMutationVariables>;

/**
 * __useUncloseShipmentMutation__
 *
 * To run a mutation, you first call `useUncloseShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncloseShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncloseShipmentMutation, { data, loading, error }] = useUncloseShipmentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useUncloseShipmentMutation(baseOptions?: Apollo.MutationHookOptions<UncloseShipmentMutation, UncloseShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncloseShipmentMutation, UncloseShipmentMutationVariables>(UncloseShipmentDocument, options);
      }
export type UncloseShipmentMutationHookResult = ReturnType<typeof useUncloseShipmentMutation>;
export type UncloseShipmentMutationResult = Apollo.MutationResult<UncloseShipmentMutation>;
export type UncloseShipmentMutationOptions = Apollo.BaseMutationOptions<UncloseShipmentMutation, UncloseShipmentMutationVariables>;
export const ForceCompleteShipmentDocument = gql`
    mutation ForceCompleteShipment($courierId: ID!, $shipmentId: ID!, $completedBy: String!, $completeAtOverride: Timestamp) {
  forceCompleteShipment(
    courierId: $courierId
    shipmentId: $shipmentId
    completedBy: $completedBy
    completeAtOverride: $completeAtOverride
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ForceCompleteShipmentMutationFn = Apollo.MutationFunction<ForceCompleteShipmentMutation, ForceCompleteShipmentMutationVariables>;

/**
 * __useForceCompleteShipmentMutation__
 *
 * To run a mutation, you first call `useForceCompleteShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceCompleteShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceCompleteShipmentMutation, { data, loading, error }] = useForceCompleteShipmentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      completedBy: // value for 'completedBy'
 *      completeAtOverride: // value for 'completeAtOverride'
 *   },
 * });
 */
export function useForceCompleteShipmentMutation(baseOptions?: Apollo.MutationHookOptions<ForceCompleteShipmentMutation, ForceCompleteShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceCompleteShipmentMutation, ForceCompleteShipmentMutationVariables>(ForceCompleteShipmentDocument, options);
      }
export type ForceCompleteShipmentMutationHookResult = ReturnType<typeof useForceCompleteShipmentMutation>;
export type ForceCompleteShipmentMutationResult = Apollo.MutationResult<ForceCompleteShipmentMutation>;
export type ForceCompleteShipmentMutationOptions = Apollo.BaseMutationOptions<ForceCompleteShipmentMutation, ForceCompleteShipmentMutationVariables>;
export const BulkForceCompleteShipmentsDocument = gql`
    mutation BulkForceCompleteShipments($courierId: ID!, $shipmentIds: [ID!]!, $completedBy: String!, $completeAtOverride: Timestamp, $stopIds: [ID!]) {
  bulkForceCompleteShipments(
    courierId: $courierId
    shipmentIds: $shipmentIds
    completedBy: $completedBy
    completeAtOverride: $completeAtOverride
    stopIds: $stopIds
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type BulkForceCompleteShipmentsMutationFn = Apollo.MutationFunction<BulkForceCompleteShipmentsMutation, BulkForceCompleteShipmentsMutationVariables>;

/**
 * __useBulkForceCompleteShipmentsMutation__
 *
 * To run a mutation, you first call `useBulkForceCompleteShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkForceCompleteShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkForceCompleteShipmentsMutation, { data, loading, error }] = useBulkForceCompleteShipmentsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *      completedBy: // value for 'completedBy'
 *      completeAtOverride: // value for 'completeAtOverride'
 *      stopIds: // value for 'stopIds'
 *   },
 * });
 */
export function useBulkForceCompleteShipmentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkForceCompleteShipmentsMutation, BulkForceCompleteShipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkForceCompleteShipmentsMutation, BulkForceCompleteShipmentsMutationVariables>(BulkForceCompleteShipmentsDocument, options);
      }
export type BulkForceCompleteShipmentsMutationHookResult = ReturnType<typeof useBulkForceCompleteShipmentsMutation>;
export type BulkForceCompleteShipmentsMutationResult = Apollo.MutationResult<BulkForceCompleteShipmentsMutation>;
export type BulkForceCompleteShipmentsMutationOptions = Apollo.BaseMutationOptions<BulkForceCompleteShipmentsMutation, BulkForceCompleteShipmentsMutationVariables>;
export const UpdateInternalNoteDocument = gql`
    mutation UpdateInternalNote($courierId: ID!, $shipmentId: ID!, $internalNote: String!, $updatedBy: String!) {
  updateInternalNote(
    courierId: $courierId
    shipmentId: $shipmentId
    internalNote: $internalNote
    updatedBy: $updatedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type UpdateInternalNoteMutationFn = Apollo.MutationFunction<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>;

/**
 * __useUpdateInternalNoteMutation__
 *
 * To run a mutation, you first call `useUpdateInternalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalNoteMutation, { data, loading, error }] = useUpdateInternalNoteMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      internalNote: // value for 'internalNote'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useUpdateInternalNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>(UpdateInternalNoteDocument, options);
      }
export type UpdateInternalNoteMutationHookResult = ReturnType<typeof useUpdateInternalNoteMutation>;
export type UpdateInternalNoteMutationResult = Apollo.MutationResult<UpdateInternalNoteMutation>;
export type UpdateInternalNoteMutationOptions = Apollo.BaseMutationOptions<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>;
export const AssignDriverForShipmentTemplatesDocument = gql`
    mutation assignDriverForShipmentTemplates($courierId: ID!, $shipmentTemplateIds: [ID!]!, $driverId: ID) {
  assignDriverForShipmentTemplates(
    courierId: $courierId
    shipmentTemplateIds: $shipmentTemplateIds
    driverId: $driverId
  ) {
    ...ShipmentTemplateFragment
  }
}
    ${ShipmentTemplateFragmentFragmentDoc}`;
export type AssignDriverForShipmentTemplatesMutationFn = Apollo.MutationFunction<AssignDriverForShipmentTemplatesMutation, AssignDriverForShipmentTemplatesMutationVariables>;

/**
 * __useAssignDriverForShipmentTemplatesMutation__
 *
 * To run a mutation, you first call `useAssignDriverForShipmentTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDriverForShipmentTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDriverForShipmentTemplatesMutation, { data, loading, error }] = useAssignDriverForShipmentTemplatesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useAssignDriverForShipmentTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<AssignDriverForShipmentTemplatesMutation, AssignDriverForShipmentTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignDriverForShipmentTemplatesMutation, AssignDriverForShipmentTemplatesMutationVariables>(AssignDriverForShipmentTemplatesDocument, options);
      }
export type AssignDriverForShipmentTemplatesMutationHookResult = ReturnType<typeof useAssignDriverForShipmentTemplatesMutation>;
export type AssignDriverForShipmentTemplatesMutationResult = Apollo.MutationResult<AssignDriverForShipmentTemplatesMutation>;
export type AssignDriverForShipmentTemplatesMutationOptions = Apollo.BaseMutationOptions<AssignDriverForShipmentTemplatesMutation, AssignDriverForShipmentTemplatesMutationVariables>;
export const OverridePodMetadataDocument = gql`
    mutation OverridePodMetadata($courierId: ID!, $shipmentId: ID!, $updatedBy: String!, $signedBy: String, $deliveredAt: Timestamp) {
  overridePodMetadata(
    courierId: $courierId
    shipmentId: $shipmentId
    updatedBy: $updatedBy
    signedBy: $signedBy
    deliveredAt: $deliveredAt
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type OverridePodMetadataMutationFn = Apollo.MutationFunction<OverridePodMetadataMutation, OverridePodMetadataMutationVariables>;

/**
 * __useOverridePodMetadataMutation__
 *
 * To run a mutation, you first call `useOverridePodMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverridePodMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overridePodMetadataMutation, { data, loading, error }] = useOverridePodMetadataMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      updatedBy: // value for 'updatedBy'
 *      signedBy: // value for 'signedBy'
 *      deliveredAt: // value for 'deliveredAt'
 *   },
 * });
 */
export function useOverridePodMetadataMutation(baseOptions?: Apollo.MutationHookOptions<OverridePodMetadataMutation, OverridePodMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverridePodMetadataMutation, OverridePodMetadataMutationVariables>(OverridePodMetadataDocument, options);
      }
export type OverridePodMetadataMutationHookResult = ReturnType<typeof useOverridePodMetadataMutation>;
export type OverridePodMetadataMutationResult = Apollo.MutationResult<OverridePodMetadataMutation>;
export type OverridePodMetadataMutationOptions = Apollo.BaseMutationOptions<OverridePodMetadataMutation, OverridePodMetadataMutationVariables>;
export const OverridePricingDetailDocument = gql`
    mutation overridePricingDetail($courierId: ID!, $shipmentId: ID!, $unfreeWaitTimeInMinutes: Float, $adjustmentUpdates: [PricingAdjustmentUpdate!], $adjustmentsToAdd: [PricingAdjustmentCreate!], $updatedBy: String) {
  overridePricingDetail(
    courierId: $courierId
    shipmentId: $shipmentId
    unfreeWaitTimeInMinutes: $unfreeWaitTimeInMinutes
    adjustmentUpdates: $adjustmentUpdates
    adjustmentsToAdd: $adjustmentsToAdd
    updatedBy: $updatedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type OverridePricingDetailMutationFn = Apollo.MutationFunction<OverridePricingDetailMutation, OverridePricingDetailMutationVariables>;

/**
 * __useOverridePricingDetailMutation__
 *
 * To run a mutation, you first call `useOverridePricingDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverridePricingDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overridePricingDetailMutation, { data, loading, error }] = useOverridePricingDetailMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      unfreeWaitTimeInMinutes: // value for 'unfreeWaitTimeInMinutes'
 *      adjustmentUpdates: // value for 'adjustmentUpdates'
 *      adjustmentsToAdd: // value for 'adjustmentsToAdd'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useOverridePricingDetailMutation(baseOptions?: Apollo.MutationHookOptions<OverridePricingDetailMutation, OverridePricingDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverridePricingDetailMutation, OverridePricingDetailMutationVariables>(OverridePricingDetailDocument, options);
      }
export type OverridePricingDetailMutationHookResult = ReturnType<typeof useOverridePricingDetailMutation>;
export type OverridePricingDetailMutationResult = Apollo.MutationResult<OverridePricingDetailMutation>;
export type OverridePricingDetailMutationOptions = Apollo.BaseMutationOptions<OverridePricingDetailMutation, OverridePricingDetailMutationVariables>;
export const MarkShipmentTemplatesAsDeletedDocument = gql`
    mutation MarkShipmentTemplatesAsDeleted($courierId: ID!, $shipmentTemplateIds: [ID!]!) {
  markShipmentTemplatesAsDeleted(
    courierId: $courierId
    shipmentTemplateIds: $shipmentTemplateIds
  ) {
    ...ShipmentTemplateFragment
  }
}
    ${ShipmentTemplateFragmentFragmentDoc}`;
export type MarkShipmentTemplatesAsDeletedMutationFn = Apollo.MutationFunction<MarkShipmentTemplatesAsDeletedMutation, MarkShipmentTemplatesAsDeletedMutationVariables>;

/**
 * __useMarkShipmentTemplatesAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentTemplatesAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentTemplatesAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentTemplatesAsDeletedMutation, { data, loading, error }] = useMarkShipmentTemplatesAsDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *   },
 * });
 */
export function useMarkShipmentTemplatesAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentTemplatesAsDeletedMutation, MarkShipmentTemplatesAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentTemplatesAsDeletedMutation, MarkShipmentTemplatesAsDeletedMutationVariables>(MarkShipmentTemplatesAsDeletedDocument, options);
      }
export type MarkShipmentTemplatesAsDeletedMutationHookResult = ReturnType<typeof useMarkShipmentTemplatesAsDeletedMutation>;
export type MarkShipmentTemplatesAsDeletedMutationResult = Apollo.MutationResult<MarkShipmentTemplatesAsDeletedMutation>;
export type MarkShipmentTemplatesAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentTemplatesAsDeletedMutation, MarkShipmentTemplatesAsDeletedMutationVariables>;
export const ReplaceAllocationDocument = gql`
    mutation ReplaceAllocation($courierId: ID!, $replacement: DriverPayAllocationReplacement!) {
  replaceAllocation(courierId: $courierId, replacement: $replacement) {
    ...DriverPayAllocationFragment
  }
}
    ${DriverPayAllocationFragmentFragmentDoc}`;
export type ReplaceAllocationMutationFn = Apollo.MutationFunction<ReplaceAllocationMutation, ReplaceAllocationMutationVariables>;

/**
 * __useReplaceAllocationMutation__
 *
 * To run a mutation, you first call `useReplaceAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceAllocationMutation, { data, loading, error }] = useReplaceAllocationMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      replacement: // value for 'replacement'
 *   },
 * });
 */
export function useReplaceAllocationMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceAllocationMutation, ReplaceAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceAllocationMutation, ReplaceAllocationMutationVariables>(ReplaceAllocationDocument, options);
      }
export type ReplaceAllocationMutationHookResult = ReturnType<typeof useReplaceAllocationMutation>;
export type ReplaceAllocationMutationResult = Apollo.MutationResult<ReplaceAllocationMutation>;
export type ReplaceAllocationMutationOptions = Apollo.BaseMutationOptions<ReplaceAllocationMutation, ReplaceAllocationMutationVariables>;
export const BulkUnassignDriversFromShipmentDocument = gql`
    mutation BulkUnassignDriversFromShipment($courierId: ID!, $shipmentIds: [ID!]!) {
  bulkUnassignDriversFromShipment(
    courierId: $courierId
    shipmentIds: $shipmentIds
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type BulkUnassignDriversFromShipmentMutationFn = Apollo.MutationFunction<BulkUnassignDriversFromShipmentMutation, BulkUnassignDriversFromShipmentMutationVariables>;

/**
 * __useBulkUnassignDriversFromShipmentMutation__
 *
 * To run a mutation, you first call `useBulkUnassignDriversFromShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnassignDriversFromShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnassignDriversFromShipmentMutation, { data, loading, error }] = useBulkUnassignDriversFromShipmentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useBulkUnassignDriversFromShipmentMutation(baseOptions?: Apollo.MutationHookOptions<BulkUnassignDriversFromShipmentMutation, BulkUnassignDriversFromShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUnassignDriversFromShipmentMutation, BulkUnassignDriversFromShipmentMutationVariables>(BulkUnassignDriversFromShipmentDocument, options);
      }
export type BulkUnassignDriversFromShipmentMutationHookResult = ReturnType<typeof useBulkUnassignDriversFromShipmentMutation>;
export type BulkUnassignDriversFromShipmentMutationResult = Apollo.MutationResult<BulkUnassignDriversFromShipmentMutation>;
export type BulkUnassignDriversFromShipmentMutationOptions = Apollo.BaseMutationOptions<BulkUnassignDriversFromShipmentMutation, BulkUnassignDriversFromShipmentMutationVariables>;
export const MarkShipmentsAsClosedDocument = gql`
    mutation MarkShipmentsAsClosed($courierId: ID!, $shipmentIds: [ID!]!, $closedBy: String) {
  markShipmentsAsClosed(
    courierId: $courierId
    shipmentIds: $shipmentIds
    closedBy: $closedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentsAsClosedMutationFn = Apollo.MutationFunction<MarkShipmentsAsClosedMutation, MarkShipmentsAsClosedMutationVariables>;

/**
 * __useMarkShipmentsAsClosedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentsAsClosedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentsAsClosedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentsAsClosedMutation, { data, loading, error }] = useMarkShipmentsAsClosedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *      closedBy: // value for 'closedBy'
 *   },
 * });
 */
export function useMarkShipmentsAsClosedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentsAsClosedMutation, MarkShipmentsAsClosedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentsAsClosedMutation, MarkShipmentsAsClosedMutationVariables>(MarkShipmentsAsClosedDocument, options);
      }
export type MarkShipmentsAsClosedMutationHookResult = ReturnType<typeof useMarkShipmentsAsClosedMutation>;
export type MarkShipmentsAsClosedMutationResult = Apollo.MutationResult<MarkShipmentsAsClosedMutation>;
export type MarkShipmentsAsClosedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentsAsClosedMutation, MarkShipmentsAsClosedMutationVariables>;
export const UncloseShipmentsDocument = gql`
    mutation UncloseShipments($courierId: ID!, $shipmentIds: [ID!]!) {
  uncloseShipments(courierId: $courierId, shipmentIds: $shipmentIds) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type UncloseShipmentsMutationFn = Apollo.MutationFunction<UncloseShipmentsMutation, UncloseShipmentsMutationVariables>;

/**
 * __useUncloseShipmentsMutation__
 *
 * To run a mutation, you first call `useUncloseShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncloseShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncloseShipmentsMutation, { data, loading, error }] = useUncloseShipmentsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useUncloseShipmentsMutation(baseOptions?: Apollo.MutationHookOptions<UncloseShipmentsMutation, UncloseShipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncloseShipmentsMutation, UncloseShipmentsMutationVariables>(UncloseShipmentsDocument, options);
      }
export type UncloseShipmentsMutationHookResult = ReturnType<typeof useUncloseShipmentsMutation>;
export type UncloseShipmentsMutationResult = Apollo.MutationResult<UncloseShipmentsMutation>;
export type UncloseShipmentsMutationOptions = Apollo.BaseMutationOptions<UncloseShipmentsMutation, UncloseShipmentsMutationVariables>;
export const ApproveShipmentDetailsDocument = gql`
    mutation ApproveShipmentDetails($courierId: ID!, $shipmentId: ID!, $updatedBy: String!) {
  approveShipmentDetails(
    courierId: $courierId
    shipmentId: $shipmentId
    updatedBy: $updatedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ApproveShipmentDetailsMutationFn = Apollo.MutationFunction<ApproveShipmentDetailsMutation, ApproveShipmentDetailsMutationVariables>;

/**
 * __useApproveShipmentDetailsMutation__
 *
 * To run a mutation, you first call `useApproveShipmentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveShipmentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveShipmentDetailsMutation, { data, loading, error }] = useApproveShipmentDetailsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useApproveShipmentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveShipmentDetailsMutation, ApproveShipmentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveShipmentDetailsMutation, ApproveShipmentDetailsMutationVariables>(ApproveShipmentDetailsDocument, options);
      }
export type ApproveShipmentDetailsMutationHookResult = ReturnType<typeof useApproveShipmentDetailsMutation>;
export type ApproveShipmentDetailsMutationResult = Apollo.MutationResult<ApproveShipmentDetailsMutation>;
export type ApproveShipmentDetailsMutationOptions = Apollo.BaseMutationOptions<ApproveShipmentDetailsMutation, ApproveShipmentDetailsMutationVariables>;
export const UpsertShipmentTemplateDriverAssignmentsDocument = gql`
    mutation UpsertShipmentTemplateDriverAssignments($courierId: ID!, $upserts: [ShipmentTemplateDriverAssignmentUpsertInput!]!) {
  upsertShipmentTemplateDriverAssignments(
    courierId: $courierId
    upserts: $upserts
  ) {
    ...ShipmentTemplateDriverAssignmentFragment
  }
}
    ${ShipmentTemplateDriverAssignmentFragmentFragmentDoc}`;
export type UpsertShipmentTemplateDriverAssignmentsMutationFn = Apollo.MutationFunction<UpsertShipmentTemplateDriverAssignmentsMutation, UpsertShipmentTemplateDriverAssignmentsMutationVariables>;

/**
 * __useUpsertShipmentTemplateDriverAssignmentsMutation__
 *
 * To run a mutation, you first call `useUpsertShipmentTemplateDriverAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertShipmentTemplateDriverAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertShipmentTemplateDriverAssignmentsMutation, { data, loading, error }] = useUpsertShipmentTemplateDriverAssignmentsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      upserts: // value for 'upserts'
 *   },
 * });
 */
export function useUpsertShipmentTemplateDriverAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertShipmentTemplateDriverAssignmentsMutation, UpsertShipmentTemplateDriverAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertShipmentTemplateDriverAssignmentsMutation, UpsertShipmentTemplateDriverAssignmentsMutationVariables>(UpsertShipmentTemplateDriverAssignmentsDocument, options);
      }
export type UpsertShipmentTemplateDriverAssignmentsMutationHookResult = ReturnType<typeof useUpsertShipmentTemplateDriverAssignmentsMutation>;
export type UpsertShipmentTemplateDriverAssignmentsMutationResult = Apollo.MutationResult<UpsertShipmentTemplateDriverAssignmentsMutation>;
export type UpsertShipmentTemplateDriverAssignmentsMutationOptions = Apollo.BaseMutationOptions<UpsertShipmentTemplateDriverAssignmentsMutation, UpsertShipmentTemplateDriverAssignmentsMutationVariables>;
export const MarkAsHoldDocument = gql`
    mutation MarkAsHold($courierId: ID!, $shipmentIds: [ID!]!) {
  markAsHold(courierId: $courierId, shipmentIds: $shipmentIds) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkAsHoldMutationFn = Apollo.MutationFunction<MarkAsHoldMutation, MarkAsHoldMutationVariables>;

/**
 * __useMarkAsHoldMutation__
 *
 * To run a mutation, you first call `useMarkAsHoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsHoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsHoldMutation, { data, loading, error }] = useMarkAsHoldMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useMarkAsHoldMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsHoldMutation, MarkAsHoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsHoldMutation, MarkAsHoldMutationVariables>(MarkAsHoldDocument, options);
      }
export type MarkAsHoldMutationHookResult = ReturnType<typeof useMarkAsHoldMutation>;
export type MarkAsHoldMutationResult = Apollo.MutationResult<MarkAsHoldMutation>;
export type MarkAsHoldMutationOptions = Apollo.BaseMutationOptions<MarkAsHoldMutation, MarkAsHoldMutationVariables>;
export const ClearHoldStatusDocument = gql`
    mutation ClearHoldStatus($courierId: ID!, $shipmentIds: [ID!]!) {
  clearHoldStatus(courierId: $courierId, shipmentIds: $shipmentIds) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ClearHoldStatusMutationFn = Apollo.MutationFunction<ClearHoldStatusMutation, ClearHoldStatusMutationVariables>;

/**
 * __useClearHoldStatusMutation__
 *
 * To run a mutation, you first call `useClearHoldStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearHoldStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearHoldStatusMutation, { data, loading, error }] = useClearHoldStatusMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useClearHoldStatusMutation(baseOptions?: Apollo.MutationHookOptions<ClearHoldStatusMutation, ClearHoldStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearHoldStatusMutation, ClearHoldStatusMutationVariables>(ClearHoldStatusDocument, options);
      }
export type ClearHoldStatusMutationHookResult = ReturnType<typeof useClearHoldStatusMutation>;
export type ClearHoldStatusMutationResult = Apollo.MutationResult<ClearHoldStatusMutation>;
export type ClearHoldStatusMutationOptions = Apollo.BaseMutationOptions<ClearHoldStatusMutation, ClearHoldStatusMutationVariables>;
export const GetShipmentsDocument = gql`
    query GetShipments($courierId: ID!, $limit: Int, $after: Int, $isAssignedFilter: Boolean, $statusFilter: ShipmentStatus, $statusListFilter: [ShipmentStatus!], $lateByFilter: Timestamp, $minClosingTimeFilter: Timestamp, $likelyLateOnlyFilter: Boolean, $isClosedFilter: Boolean, $driverIdsFilter: [ID!], $driverLabelIds: [ID!], $orderLabelIds: [ID!], $endCustomerLabelIds: [ID!], $courierBrandIds: [ID!], $acquisitionTypes: [OrderAcquisitionType!], $dispatchableTypes: [DispatchableType!], $recurrenceTypes: [RecurrenceType!], $endCustomerIdsFilter: [ID!], $trackingNumbersFilter: [String!], $displayIdsFilter: [Int!], $minExpectedCompletionDate: Date, $minShipmentDate: Date, $maxShipmentDate: Date, $minCompletedDate: Date, $maxCompletedDate: Date, $pickupZoneIds: [ID!], $dropOffZoneIds: [ID!], $sortFields: [ShipmentsSorting!], $simpleSearch: String, $userId: ID!, $serviceTypeIds: [ID!], $excludeWordsFromNote: [String!], $packageTypeIds: [ID!], $orderVehicleTypeIds: [ID!], $driverVehicleTypeIds: [ID!], $isConfirmed: Boolean, $isAttempted: Boolean, $minWeightInPounds: Float, $maxWeightInPounds: Float, $routeTemplateIds: [ID!], $holdStatusFilter: HoldStatus) {
  shipments(
    courierId: $courierId
    limit: $limit
    after: $after
    isAssignedFilter: $isAssignedFilter
    statusFilter: $statusFilter
    statusListFilter: $statusListFilter
    lateByFilter: $lateByFilter
    minClosingTimeFilter: $minClosingTimeFilter
    likelyLateOnlyFilter: $likelyLateOnlyFilter
    isClosedFilter: $isClosedFilter
    driverIdsFilter: $driverIdsFilter
    driverLabelIds: $driverLabelIds
    orderLabelIds: $orderLabelIds
    endCustomerLabelIds: $endCustomerLabelIds
    courierBrandIds: $courierBrandIds
    acquisitionTypes: $acquisitionTypes
    dispatchableTypes: $dispatchableTypes
    recurrenceTypes: $recurrenceTypes
    endCustomerIdsFilter: $endCustomerIdsFilter
    trackingNumbersFilter: $trackingNumbersFilter
    displayIdsFilter: $displayIdsFilter
    minExpectedCompletionDate: $minExpectedCompletionDate
    minShipmentDate: $minShipmentDate
    maxShipmentDate: $maxShipmentDate
    minCompletedDate: $minCompletedDate
    maxCompletedDate: $maxCompletedDate
    pickupZoneIds: $pickupZoneIds
    dropOffZoneIds: $dropOffZoneIds
    routeTemplateIds: $routeTemplateIds
    sortFields: $sortFields
    simpleSearch: $simpleSearch
    serviceTypeIds: $serviceTypeIds
    excludeWordsFromNote: $excludeWordsFromNote
    packageTypeIds: $packageTypeIds
    orderVehicleTypeIds: $orderVehicleTypeIds
    driverVehicleTypeIds: $driverVehicleTypeIds
    isConfirmed: $isConfirmed
    isAttempted: $isAttempted
    minWeightInPounds: $minWeightInPounds
    maxWeightInPounds: $maxWeightInPounds
    holdStatusFilter: $holdStatusFilter
  ) {
    edges {
      node {
        ...ShipmentFragment
        displayPackageStatuses
        dispatchedByUser {
          id
          email
        }
        packageType {
          id
          courierId
          name
        }
        vehicleType {
          id
          courierId
          name
          shortCode
        }
        packageItems {
          width
          height
          length
          weight
          packageTypeId
          quantity
        }
        routingJob {
          ...RoutingJobFragment
        }
        qualityReviews {
          ...QualityReviewFragment
        }
        stops {
          ...StopFragment
          tasks {
            ...TaskFragment
          }
          shipment {
            status
            order {
              id
              serviceType {
                id
                name
                color
              }
            }
            shipmentTemplate {
              ...ShipmentTemplateFragment
              order {
                id
                name
                serviceType {
                  id
                  name
                  color
                }
              }
            }
          }
          artifacts {
            ...ArtifactFragment
          }
        }
        order {
          ...OrderFragment
          orderGroupOverview {
            orderGroupId
            orderGroupDisplayId
            label
            assignmentGroupId
          }
          userHasClicked(userId: $userId)
          createdByUser {
            id
            email
          }
          createdByEndCustomer {
            id
            companyName
          }
          createdByEndUser {
            ...EndUserFragment
          }
          costCenter {
            ...CostCenterFragment
          }
          endCustomer {
            ...EndCustomerListItemFragment
            courierBrand {
              ...CourierBrandFragment
            }
          }
          serviceType {
            ...ServiceTypeFragment
          }
          customFieldValues {
            ...CustomFieldValueFragment
            field {
              ...CustomFieldFragment
            }
          }
          orderAttachments {
            ...OrderAttachmentFragment
          }
          assignedLabels {
            ...LabelFragment
          }
        }
        driver {
          id
          firstName
          lastName
          photoUrl
          avatarDisplay
          phone
          email
          isActive
        }
        driverPayAllocations {
          ...DriverPayAllocationFragment
        }
        shipmentTemplate {
          order {
            name
          }
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${ShipmentFragmentFragmentDoc}
${RoutingJobFragmentFragmentDoc}
${QualityReviewFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${EndUserFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${EndCustomerListItemFragmentFragmentDoc}
${CourierBrandFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${OrderAttachmentFragmentFragmentDoc}
${LabelFragmentFragmentDoc}
${DriverPayAllocationFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetShipmentsQuery__
 *
 * To run a query within a React component, call `useGetShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      isAssignedFilter: // value for 'isAssignedFilter'
 *      statusFilter: // value for 'statusFilter'
 *      statusListFilter: // value for 'statusListFilter'
 *      lateByFilter: // value for 'lateByFilter'
 *      minClosingTimeFilter: // value for 'minClosingTimeFilter'
 *      likelyLateOnlyFilter: // value for 'likelyLateOnlyFilter'
 *      isClosedFilter: // value for 'isClosedFilter'
 *      driverIdsFilter: // value for 'driverIdsFilter'
 *      driverLabelIds: // value for 'driverLabelIds'
 *      orderLabelIds: // value for 'orderLabelIds'
 *      endCustomerLabelIds: // value for 'endCustomerLabelIds'
 *      courierBrandIds: // value for 'courierBrandIds'
 *      acquisitionTypes: // value for 'acquisitionTypes'
 *      dispatchableTypes: // value for 'dispatchableTypes'
 *      recurrenceTypes: // value for 'recurrenceTypes'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      trackingNumbersFilter: // value for 'trackingNumbersFilter'
 *      displayIdsFilter: // value for 'displayIdsFilter'
 *      minExpectedCompletionDate: // value for 'minExpectedCompletionDate'
 *      minShipmentDate: // value for 'minShipmentDate'
 *      maxShipmentDate: // value for 'maxShipmentDate'
 *      minCompletedDate: // value for 'minCompletedDate'
 *      maxCompletedDate: // value for 'maxCompletedDate'
 *      pickupZoneIds: // value for 'pickupZoneIds'
 *      dropOffZoneIds: // value for 'dropOffZoneIds'
 *      sortFields: // value for 'sortFields'
 *      simpleSearch: // value for 'simpleSearch'
 *      userId: // value for 'userId'
 *      serviceTypeIds: // value for 'serviceTypeIds'
 *      excludeWordsFromNote: // value for 'excludeWordsFromNote'
 *      packageTypeIds: // value for 'packageTypeIds'
 *      orderVehicleTypeIds: // value for 'orderVehicleTypeIds'
 *      driverVehicleTypeIds: // value for 'driverVehicleTypeIds'
 *      isConfirmed: // value for 'isConfirmed'
 *      isAttempted: // value for 'isAttempted'
 *      minWeightInPounds: // value for 'minWeightInPounds'
 *      maxWeightInPounds: // value for 'maxWeightInPounds'
 *      routeTemplateIds: // value for 'routeTemplateIds'
 *      holdStatusFilter: // value for 'holdStatusFilter'
 *   },
 * });
 */
export function useGetShipmentsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
      }
export function useGetShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
        }
export type GetShipmentsQueryHookResult = ReturnType<typeof useGetShipmentsQuery>;
export type GetShipmentsLazyQueryHookResult = ReturnType<typeof useGetShipmentsLazyQuery>;
export type GetShipmentsQueryResult = Apollo.QueryResult<GetShipmentsQuery, GetShipmentsQueryVariables>;
export const GetShipmentCountsForFiltersDocument = gql`
    query GetShipmentCountsForFilters($courierId: ID!, $minExpectedCompletionDate: Date, $minShipmentDate: Date, $maxShipmentDate: Date, $minCompletedDate: Date, $maxCompletedDate: Date, $now: Timestamp!, $in15Minutes: Timestamp!, $in30Minutes: Timestamp!, $in60Minutes: Timestamp!, $endCustomerIdsFilter: [ID!], $driverIdsFilter: [ID!], $trackingNumbersFilter: [String!], $displayIdsFilter: [Int!], $orderNameSearch: String, $simpleSearch: String, $driverLabelIds: [ID!], $orderLabelIds: [ID!], $endCustomerLabelIds: [ID!], $courierBrandIds: [ID!], $acquisitionTypes: [OrderAcquisitionType!], $recurrenceTypes: [RecurrenceType!], $pickupZoneIds: [ID!], $dropOffZoneIds: [ID!], $packageTypeIds: [ID!], $orderVehicleTypeIds: [ID!], $driverVehicleTypeIds: [ID!], $serviceTypeIds: [ID!], $minWeightInPounds: Float, $maxWeightInPounds: Float, $hasOrderInternalNote: Boolean, $hasDriverNoteOnly: Boolean, $hasWaitTimeOrOverride: Boolean, $hasMultipleDriverPayOnly: Boolean, $hasUnapprovedDriverPackageReportOnly: Boolean, $isDeliveredOnTime: Boolean, $isAttempted: Boolean) {
  shipmentsOverview(
    courierId: $courierId
    minExpectedCompletionDate: $minExpectedCompletionDate
    minShipmentDate: $minShipmentDate
    maxShipmentDate: $maxShipmentDate
    minCompletedDate: $minCompletedDate
    maxCompletedDate: $maxCompletedDate
    endCustomerIds: $endCustomerIdsFilter
    driverIdsFilter: $driverIdsFilter
    trackingNumbersFilter: $trackingNumbersFilter
    displayIdsFilter: $displayIdsFilter
    orderNameSearch: $orderNameSearch
    simpleSearch: $simpleSearch
    driverLabelIds: $driverLabelIds
    orderLabelIds: $orderLabelIds
    endCustomerLabelIds: $endCustomerLabelIds
    courierBrandIds: $courierBrandIds
    acquisitionTypes: $acquisitionTypes
    recurrenceTypes: $recurrenceTypes
    pickupZoneIds: $pickupZoneIds
    dropOffZoneIds: $dropOffZoneIds
    packageTypeIds: $packageTypeIds
    orderVehicleTypeIds: $orderVehicleTypeIds
    driverVehicleTypeIds: $driverVehicleTypeIds
    serviceTypeIds: $serviceTypeIds
    minWeightInPounds: $minWeightInPounds
    maxWeightInPounds: $maxWeightInPounds
    hasOrderInternalNote: $hasOrderInternalNote
    hasDriverNoteOnly: $hasDriverNoteOnly
    hasWaitTimeOrOverride: $hasWaitTimeOrOverride
    hasMultipleDriverPayOnly: $hasMultipleDriverPayOnly
    hasUnapprovedDriverPackageReportOnly: $hasUnapprovedDriverPackageReportOnly
    isDeliveredOnTime: $isDeliveredOnTime
    isAttempted: $isAttempted
  ) {
    numLate: numLateBy(lateBy: $now)
    numLateIn15Minutes: numLateBy(lateBy: $in15Minutes, minClosingTime: $now)
    numLateIn30Minutes: numLateBy(lateBy: $in30Minutes, minClosingTime: $now)
    numLateIn60Minutes: numLateBy(lateBy: $in60Minutes, minClosingTime: $now)
    numLikelyLate: numLikelyLate(minClosingTime: $now)
    numActive
    numUnassigned
    numAssigned
    numDelivered
    numClosed
    numOnHold
    customFilterOverviews {
      name
      count
    }
  }
}
    `;

/**
 * __useGetShipmentCountsForFiltersQuery__
 *
 * To run a query within a React component, call `useGetShipmentCountsForFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentCountsForFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentCountsForFiltersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minExpectedCompletionDate: // value for 'minExpectedCompletionDate'
 *      minShipmentDate: // value for 'minShipmentDate'
 *      maxShipmentDate: // value for 'maxShipmentDate'
 *      minCompletedDate: // value for 'minCompletedDate'
 *      maxCompletedDate: // value for 'maxCompletedDate'
 *      now: // value for 'now'
 *      in15Minutes: // value for 'in15Minutes'
 *      in30Minutes: // value for 'in30Minutes'
 *      in60Minutes: // value for 'in60Minutes'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      driverIdsFilter: // value for 'driverIdsFilter'
 *      trackingNumbersFilter: // value for 'trackingNumbersFilter'
 *      displayIdsFilter: // value for 'displayIdsFilter'
 *      orderNameSearch: // value for 'orderNameSearch'
 *      simpleSearch: // value for 'simpleSearch'
 *      driverLabelIds: // value for 'driverLabelIds'
 *      orderLabelIds: // value for 'orderLabelIds'
 *      endCustomerLabelIds: // value for 'endCustomerLabelIds'
 *      courierBrandIds: // value for 'courierBrandIds'
 *      acquisitionTypes: // value for 'acquisitionTypes'
 *      recurrenceTypes: // value for 'recurrenceTypes'
 *      pickupZoneIds: // value for 'pickupZoneIds'
 *      dropOffZoneIds: // value for 'dropOffZoneIds'
 *      packageTypeIds: // value for 'packageTypeIds'
 *      orderVehicleTypeIds: // value for 'orderVehicleTypeIds'
 *      driverVehicleTypeIds: // value for 'driverVehicleTypeIds'
 *      serviceTypeIds: // value for 'serviceTypeIds'
 *      minWeightInPounds: // value for 'minWeightInPounds'
 *      maxWeightInPounds: // value for 'maxWeightInPounds'
 *      hasOrderInternalNote: // value for 'hasOrderInternalNote'
 *      hasDriverNoteOnly: // value for 'hasDriverNoteOnly'
 *      hasWaitTimeOrOverride: // value for 'hasWaitTimeOrOverride'
 *      hasMultipleDriverPayOnly: // value for 'hasMultipleDriverPayOnly'
 *      hasUnapprovedDriverPackageReportOnly: // value for 'hasUnapprovedDriverPackageReportOnly'
 *      isDeliveredOnTime: // value for 'isDeliveredOnTime'
 *      isAttempted: // value for 'isAttempted'
 *   },
 * });
 */
export function useGetShipmentCountsForFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>(GetShipmentCountsForFiltersDocument, options);
      }
export function useGetShipmentCountsForFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>(GetShipmentCountsForFiltersDocument, options);
        }
export type GetShipmentCountsForFiltersQueryHookResult = ReturnType<typeof useGetShipmentCountsForFiltersQuery>;
export type GetShipmentCountsForFiltersLazyQueryHookResult = ReturnType<typeof useGetShipmentCountsForFiltersLazyQuery>;
export type GetShipmentCountsForFiltersQueryResult = Apollo.QueryResult<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>;
export const ShipmentTemplatesPaginatedDocument = gql`
    query ShipmentTemplatesPaginated($courierId: ID!, $endCustomerIdsFilter: [ID!], $limit: Int, $after: Int, $sortFields: [ShipmentTemplatesSorting!], $driverIdsFilter: [ID!], $driverLabelIdsFilter: [ID!], $endCustomerLabelIdsFilter: [ID!], $orderLabelIdsFilter: [ID!], $simpleSearch: String) {
  shipmentTemplatesPaginated(
    courierId: $courierId
    endCustomerIdsFilter: $endCustomerIdsFilter
    limit: $limit
    after: $after
    sortFields: $sortFields
    driverIdsFilter: $driverIdsFilter
    driverLabelIdsFilter: $driverLabelIdsFilter
    endCustomerLabelIdsFilter: $endCustomerLabelIdsFilter
    orderLabelIdsFilter: $orderLabelIdsFilter
    simpleSearch: $simpleSearch
  ) {
    edges {
      node {
        ...ShipmentTemplateFragment
        stopTemplates {
          ...StopTemplateFragment
        }
        packageType {
          id
          courierId
          name
        }
        vehicleType {
          id
          courierId
          name
          shortCode
        }
        order {
          ...OrderFragment
          costCenter {
            ...CostCenterFragment
          }
          endCustomer {
            ...EndCustomerFragment
            customFields {
              ...CustomFieldFragment
            }
          }
          serviceType {
            ...ServiceTypeFragment
          }
          customFieldValues {
            ...CustomFieldValueFragment
            field {
              ...CustomFieldFragment
            }
          }
          holidaySchedule {
            ...HolidayScheduleFragment
          }
          assignedLabels {
            ...LabelFragment
          }
        }
        driver {
          ...DriverFragment
          assignedLabels {
            ...LabelFragment
          }
        }
        driverAssignments {
          ...ShipmentTemplateDriverAssignmentFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${ShipmentTemplateFragmentFragmentDoc}
${StopTemplateFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${HolidayScheduleFragmentFragmentDoc}
${LabelFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${ShipmentTemplateDriverAssignmentFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useShipmentTemplatesPaginatedQuery__
 *
 * To run a query within a React component, call `useShipmentTemplatesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentTemplatesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentTemplatesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *      driverIdsFilter: // value for 'driverIdsFilter'
 *      driverLabelIdsFilter: // value for 'driverLabelIdsFilter'
 *      endCustomerLabelIdsFilter: // value for 'endCustomerLabelIdsFilter'
 *      orderLabelIdsFilter: // value for 'orderLabelIdsFilter'
 *      simpleSearch: // value for 'simpleSearch'
 *   },
 * });
 */
export function useShipmentTemplatesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>(ShipmentTemplatesPaginatedDocument, options);
      }
export function useShipmentTemplatesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>(ShipmentTemplatesPaginatedDocument, options);
        }
export type ShipmentTemplatesPaginatedQueryHookResult = ReturnType<typeof useShipmentTemplatesPaginatedQuery>;
export type ShipmentTemplatesPaginatedLazyQueryHookResult = ReturnType<typeof useShipmentTemplatesPaginatedLazyQuery>;
export type ShipmentTemplatesPaginatedQueryResult = Apollo.QueryResult<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>;
export const ShipmentByIdDocument = gql`
    query ShipmentById($courierId: ID!, $shipmentId: ID!) {
  shipmentById(courierId: $courierId, shipmentId: $shipmentId) {
    ...ShipmentFragment
    packageType {
      id
      courierId
      name
    }
    driver {
      ...DriverFragment
    }
    stops {
      ...StopFragment
      artifacts {
        ...ArtifactFragment
      }
    }
    order {
      ...OrderFragment
      costCenter {
        ...CostCenterFragment
      }
      serviceType {
        ...ServiceTypeFragment
      }
      endCustomer {
        ...EndCustomerFragment
      }
      customFieldValues {
        ...CustomFieldValueFragment
        field {
          ...CustomFieldFragment
        }
      }
    }
    dispatchedByUser {
      ...CourieUserFragment
    }
    driverPayAllocations {
      ...DriverPayAllocationFragment
    }
  }
}
    ${ShipmentFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}
${DriverPayAllocationFragmentFragmentDoc}`;

/**
 * __useShipmentByIdQuery__
 *
 * To run a query within a React component, call `useShipmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentByIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useShipmentByIdQuery(baseOptions: Apollo.QueryHookOptions<ShipmentByIdQuery, ShipmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentByIdQuery, ShipmentByIdQueryVariables>(ShipmentByIdDocument, options);
      }
export function useShipmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentByIdQuery, ShipmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentByIdQuery, ShipmentByIdQueryVariables>(ShipmentByIdDocument, options);
        }
export type ShipmentByIdQueryHookResult = ReturnType<typeof useShipmentByIdQuery>;
export type ShipmentByIdLazyQueryHookResult = ReturnType<typeof useShipmentByIdLazyQuery>;
export type ShipmentByIdQueryResult = Apollo.QueryResult<ShipmentByIdQuery, ShipmentByIdQueryVariables>;
export const GetShipmentsForSalesReportDocument = gql`
    query GetShipmentsForSalesReport($courierId: ID!, $limit: Int, $after: Int, $isAssignedFilter: Boolean, $statusFilter: ShipmentStatus, $statusListFilter: [ShipmentStatus!], $lateByFilter: Timestamp, $minClosingTimeFilter: Timestamp, $likelyLateOnlyFilter: Boolean, $isClosedFilter: Boolean, $driverIdsFilter: [ID!], $driverLabelIds: [ID!], $orderLabelIds: [ID!], $endCustomerLabelIds: [ID!], $courierBrandIds: [ID!], $acquisitionTypes: [OrderAcquisitionType!], $recurrenceTypes: [RecurrenceType!], $endCustomerIdsFilter: [ID!], $trackingNumbersFilter: [String!], $displayIdsFilter: [Int!], $minExpectedCompletionDate: Date, $minShipmentDate: Date, $maxShipmentDate: Date, $minCompletedDate: Date, $maxCompletedDate: Date, $sortFields: [ShipmentsSorting!], $simpleSearch: String, $serviceTypeIds: [ID!], $excludeWordsFromNote: [String!], $packageTypeIds: [ID!], $orderVehicleTypeIds: [ID!], $driverVehicleTypeIds: [ID!], $pickupZoneIds: [ID!], $dropOffZoneIds: [ID!], $userId: ID!, $hasOrderInternalNote: Boolean, $hasDriverNoteOnly: Boolean, $hasWaitTimeOrOverride: Boolean, $hasMultipleDriverPayOnly: Boolean, $hasUnapprovedDriverPackageReportOnly: Boolean, $isDeliveredOnTime: Boolean, $isConfirmed: Boolean, $isAttempted: Boolean, $orderNameSearch: String, $minWeightInPounds: Float, $maxWeightInPounds: Float, $routeTemplateIds: [ID!], $holdStatusFilter: HoldStatus) {
  shipments(
    courierId: $courierId
    limit: $limit
    after: $after
    isAssignedFilter: $isAssignedFilter
    statusFilter: $statusFilter
    statusListFilter: $statusListFilter
    lateByFilter: $lateByFilter
    minClosingTimeFilter: $minClosingTimeFilter
    likelyLateOnlyFilter: $likelyLateOnlyFilter
    isClosedFilter: $isClosedFilter
    driverIdsFilter: $driverIdsFilter
    driverLabelIds: $driverLabelIds
    orderLabelIds: $orderLabelIds
    endCustomerLabelIds: $endCustomerLabelIds
    courierBrandIds: $courierBrandIds
    acquisitionTypes: $acquisitionTypes
    recurrenceTypes: $recurrenceTypes
    endCustomerIdsFilter: $endCustomerIdsFilter
    trackingNumbersFilter: $trackingNumbersFilter
    displayIdsFilter: $displayIdsFilter
    minExpectedCompletionDate: $minExpectedCompletionDate
    minShipmentDate: $minShipmentDate
    maxShipmentDate: $maxShipmentDate
    minCompletedDate: $minCompletedDate
    maxCompletedDate: $maxCompletedDate
    sortFields: $sortFields
    simpleSearch: $simpleSearch
    serviceTypeIds: $serviceTypeIds
    excludeWordsFromNote: $excludeWordsFromNote
    packageTypeIds: $packageTypeIds
    orderVehicleTypeIds: $orderVehicleTypeIds
    driverVehicleTypeIds: $driverVehicleTypeIds
    pickupZoneIds: $pickupZoneIds
    dropOffZoneIds: $dropOffZoneIds
    routeTemplateIds: $routeTemplateIds
    hasOrderInternalNote: $hasOrderInternalNote
    hasDriverNoteOnly: $hasDriverNoteOnly
    hasWaitTimeOrOverride: $hasWaitTimeOrOverride
    hasMultipleDriverPayOnly: $hasMultipleDriverPayOnly
    hasUnapprovedDriverPackageReportOnly: $hasUnapprovedDriverPackageReportOnly
    isDeliveredOnTime: $isDeliveredOnTime
    isConfirmed: $isConfirmed
    isAttempted: $isAttempted
    orderNameSearch: $orderNameSearch
    minWeightInPounds: $minWeightInPounds
    maxWeightInPounds: $maxWeightInPounds
    holdStatusFilter: $holdStatusFilter
  ) {
    edges {
      node {
        ...ShipmentFragment
        distancesInMeters
        packageType {
          id
          courierId
          name
        }
        vehicleType {
          id
          courierId
          name
          shortCode
        }
        packageItems {
          width
          height
          length
          weight
          packageTypeId
          quantity
        }
        stops {
          ...StopFragment
          wasLateByInMinutes
          tasks {
            ...TaskFragment
          }
          shipment {
            status
            order {
              id
              serviceType {
                id
                name
                color
              }
            }
          }
          artifacts {
            ...ArtifactFragment
          }
        }
        order {
          ...OrderFragment
          orderGroupOverview {
            orderGroupId
            orderGroupDisplayId
            label
            assignmentGroupId
          }
          orderPayBreakDownWithAllocation {
            allocations {
              driverId
              allocationRate
              breakdown {
                items {
                  name
                  description
                  amount
                }
                total
              }
              driver {
                id
                firstName
                lastName
                photoUrl
                avatarDisplay
                phone
                email
                isActive
              }
            }
            isOverride
            total
          }
          userHasClicked(userId: $userId)
          createdByEndCustomer {
            ...EndCustomerListItemFragment
          }
          createdByEndUser {
            ...EndUserFragment
          }
          costCenter {
            ...CostCenterFragment
          }
          endCustomer {
            ...EndCustomerListItemFragment
            courierBrand {
              ...CourierBrandFragment
            }
          }
          serviceType {
            ...ServiceTypeFragment
          }
          orderAttachments {
            ...OrderAttachmentFragment
          }
          price {
            ...OrderPriceFragment
          }
          customFieldValues {
            ...CustomFieldValueFragment
            field {
              ...CustomFieldFragment
            }
          }
          assignedLabels {
            ...LabelFragment
          }
        }
        shipmentTemplate {
          order {
            name
          }
          vehicleType {
            id
            courierId
            name
            shortCode
          }
        }
        driver {
          ...DriverFragment
        }
        driverPayAllocations {
          ...DriverPayAllocationFragment
        }
        dispatchedByUser {
          ...CourieUserFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${ShipmentFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${EndCustomerListItemFragmentFragmentDoc}
${EndUserFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${CourierBrandFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${OrderAttachmentFragmentFragmentDoc}
${OrderPriceFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${LabelFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${DriverPayAllocationFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetShipmentsForSalesReportQuery__
 *
 * To run a query within a React component, call `useGetShipmentsForSalesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsForSalesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsForSalesReportQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      isAssignedFilter: // value for 'isAssignedFilter'
 *      statusFilter: // value for 'statusFilter'
 *      statusListFilter: // value for 'statusListFilter'
 *      lateByFilter: // value for 'lateByFilter'
 *      minClosingTimeFilter: // value for 'minClosingTimeFilter'
 *      likelyLateOnlyFilter: // value for 'likelyLateOnlyFilter'
 *      isClosedFilter: // value for 'isClosedFilter'
 *      driverIdsFilter: // value for 'driverIdsFilter'
 *      driverLabelIds: // value for 'driverLabelIds'
 *      orderLabelIds: // value for 'orderLabelIds'
 *      endCustomerLabelIds: // value for 'endCustomerLabelIds'
 *      courierBrandIds: // value for 'courierBrandIds'
 *      acquisitionTypes: // value for 'acquisitionTypes'
 *      recurrenceTypes: // value for 'recurrenceTypes'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      trackingNumbersFilter: // value for 'trackingNumbersFilter'
 *      displayIdsFilter: // value for 'displayIdsFilter'
 *      minExpectedCompletionDate: // value for 'minExpectedCompletionDate'
 *      minShipmentDate: // value for 'minShipmentDate'
 *      maxShipmentDate: // value for 'maxShipmentDate'
 *      minCompletedDate: // value for 'minCompletedDate'
 *      maxCompletedDate: // value for 'maxCompletedDate'
 *      sortFields: // value for 'sortFields'
 *      simpleSearch: // value for 'simpleSearch'
 *      serviceTypeIds: // value for 'serviceTypeIds'
 *      excludeWordsFromNote: // value for 'excludeWordsFromNote'
 *      packageTypeIds: // value for 'packageTypeIds'
 *      orderVehicleTypeIds: // value for 'orderVehicleTypeIds'
 *      driverVehicleTypeIds: // value for 'driverVehicleTypeIds'
 *      pickupZoneIds: // value for 'pickupZoneIds'
 *      dropOffZoneIds: // value for 'dropOffZoneIds'
 *      userId: // value for 'userId'
 *      hasOrderInternalNote: // value for 'hasOrderInternalNote'
 *      hasDriverNoteOnly: // value for 'hasDriverNoteOnly'
 *      hasWaitTimeOrOverride: // value for 'hasWaitTimeOrOverride'
 *      hasMultipleDriverPayOnly: // value for 'hasMultipleDriverPayOnly'
 *      hasUnapprovedDriverPackageReportOnly: // value for 'hasUnapprovedDriverPackageReportOnly'
 *      isDeliveredOnTime: // value for 'isDeliveredOnTime'
 *      isConfirmed: // value for 'isConfirmed'
 *      isAttempted: // value for 'isAttempted'
 *      orderNameSearch: // value for 'orderNameSearch'
 *      minWeightInPounds: // value for 'minWeightInPounds'
 *      maxWeightInPounds: // value for 'maxWeightInPounds'
 *      routeTemplateIds: // value for 'routeTemplateIds'
 *      holdStatusFilter: // value for 'holdStatusFilter'
 *   },
 * });
 */
export function useGetShipmentsForSalesReportQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>(GetShipmentsForSalesReportDocument, options);
      }
export function useGetShipmentsForSalesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>(GetShipmentsForSalesReportDocument, options);
        }
export type GetShipmentsForSalesReportQueryHookResult = ReturnType<typeof useGetShipmentsForSalesReportQuery>;
export type GetShipmentsForSalesReportLazyQueryHookResult = ReturnType<typeof useGetShipmentsForSalesReportLazyQuery>;
export type GetShipmentsForSalesReportQueryResult = Apollo.QueryResult<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>;
export const GetShipmentDistancesDocument = gql`
    query GetShipmentDistances($courierId: ID!, $shipmentIds: [ID!]!) {
  shipmentDistances(courierId: $courierId, shipmentIds: $shipmentIds) {
    shipmentId
    distanceMeters
    stopTripDistances {
      sourceStopId
      destinationStopId
      sourceStop {
        ...StopFragment
      }
      destinationStop {
        ...StopFragment
      }
      tripDistance {
        sourceLocationId
        destinationLocationId
        distanceInMeters
        durationInSeconds
        isOverridden
      }
    }
  }
}
    ${StopFragmentFragmentDoc}`;

/**
 * __useGetShipmentDistancesQuery__
 *
 * To run a query within a React component, call `useGetShipmentDistancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentDistancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentDistancesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useGetShipmentDistancesQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentDistancesQuery, GetShipmentDistancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentDistancesQuery, GetShipmentDistancesQueryVariables>(GetShipmentDistancesDocument, options);
      }
export function useGetShipmentDistancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentDistancesQuery, GetShipmentDistancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentDistancesQuery, GetShipmentDistancesQueryVariables>(GetShipmentDistancesDocument, options);
        }
export type GetShipmentDistancesQueryHookResult = ReturnType<typeof useGetShipmentDistancesQuery>;
export type GetShipmentDistancesLazyQueryHookResult = ReturnType<typeof useGetShipmentDistancesLazyQuery>;
export type GetShipmentDistancesQueryResult = Apollo.QueryResult<GetShipmentDistancesQuery, GetShipmentDistancesQueryVariables>;
export const GetShipmentTemplateDistancesDocument = gql`
    query GetShipmentTemplateDistances($courierId: ID!, $shipmentTemplateIds: [ID!]!, $dayOfWeek: DayOfTheWeek!) {
  shipmentTemplateDistances(
    courierId: $courierId
    shipmentTemplateIds: $shipmentTemplateIds
    dayOfWeek: $dayOfWeek
  ) {
    shipmentTemplateId
    distanceMeters
    stopTemplateTripDistances {
      sourceStopTemplateId
      destinationStopTemplateId
      sourceStopTemplate {
        ...StopTemplateFragment
      }
      destinationStopTemplate {
        ...StopTemplateFragment
      }
      tripDistance {
        sourceLocationId
        destinationLocationId
        distanceInMeters
        durationInSeconds
      }
    }
  }
}
    ${StopTemplateFragmentFragmentDoc}`;

/**
 * __useGetShipmentTemplateDistancesQuery__
 *
 * To run a query within a React component, call `useGetShipmentTemplateDistancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentTemplateDistancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentTemplateDistancesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *      dayOfWeek: // value for 'dayOfWeek'
 *   },
 * });
 */
export function useGetShipmentTemplateDistancesQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentTemplateDistancesQuery, GetShipmentTemplateDistancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentTemplateDistancesQuery, GetShipmentTemplateDistancesQueryVariables>(GetShipmentTemplateDistancesDocument, options);
      }
export function useGetShipmentTemplateDistancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentTemplateDistancesQuery, GetShipmentTemplateDistancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentTemplateDistancesQuery, GetShipmentTemplateDistancesQueryVariables>(GetShipmentTemplateDistancesDocument, options);
        }
export type GetShipmentTemplateDistancesQueryHookResult = ReturnType<typeof useGetShipmentTemplateDistancesQuery>;
export type GetShipmentTemplateDistancesLazyQueryHookResult = ReturnType<typeof useGetShipmentTemplateDistancesLazyQuery>;
export type GetShipmentTemplateDistancesQueryResult = Apollo.QueryResult<GetShipmentTemplateDistancesQuery, GetShipmentTemplateDistancesQueryVariables>;
export const UpsertStopTemplateSequenceNumbersDocument = gql`
    mutation UpsertStopTemplateSequenceNumbers($courierId: ID!, $upserts: [ScheduledStopTemplateSequenceNumberUpsert!]!) {
  upsertStopTemplateSequenceNumbers(courierId: $courierId, upserts: $upserts) {
    id
    courierId
    stopTemplateId
    dayOfWeek
    sequenceNumber
    stopTemplate {
      ...StopTemplateFragment
    }
  }
}
    ${StopTemplateFragmentFragmentDoc}`;
export type UpsertStopTemplateSequenceNumbersMutationFn = Apollo.MutationFunction<UpsertStopTemplateSequenceNumbersMutation, UpsertStopTemplateSequenceNumbersMutationVariables>;

/**
 * __useUpsertStopTemplateSequenceNumbersMutation__
 *
 * To run a mutation, you first call `useUpsertStopTemplateSequenceNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStopTemplateSequenceNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStopTemplateSequenceNumbersMutation, { data, loading, error }] = useUpsertStopTemplateSequenceNumbersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      upserts: // value for 'upserts'
 *   },
 * });
 */
export function useUpsertStopTemplateSequenceNumbersMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStopTemplateSequenceNumbersMutation, UpsertStopTemplateSequenceNumbersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStopTemplateSequenceNumbersMutation, UpsertStopTemplateSequenceNumbersMutationVariables>(UpsertStopTemplateSequenceNumbersDocument, options);
      }
export type UpsertStopTemplateSequenceNumbersMutationHookResult = ReturnType<typeof useUpsertStopTemplateSequenceNumbersMutation>;
export type UpsertStopTemplateSequenceNumbersMutationResult = Apollo.MutationResult<UpsertStopTemplateSequenceNumbersMutation>;
export type UpsertStopTemplateSequenceNumbersMutationOptions = Apollo.BaseMutationOptions<UpsertStopTemplateSequenceNumbersMutation, UpsertStopTemplateSequenceNumbersMutationVariables>;
export const ForceCompleteStopsDocument = gql`
    mutation ForceCompleteStops($courierId: ID!, $shipmentId: ID!, $stopIds: [ID!]!, $completedBy: String!) {
  forceCompleteStops(
    courierId: $courierId
    shipmentId: $shipmentId
    stopIds: $stopIds
    completedBy: $completedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ForceCompleteStopsMutationFn = Apollo.MutationFunction<ForceCompleteStopsMutation, ForceCompleteStopsMutationVariables>;

/**
 * __useForceCompleteStopsMutation__
 *
 * To run a mutation, you first call `useForceCompleteStopsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceCompleteStopsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceCompleteStopsMutation, { data, loading, error }] = useForceCompleteStopsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      stopIds: // value for 'stopIds'
 *      completedBy: // value for 'completedBy'
 *   },
 * });
 */
export function useForceCompleteStopsMutation(baseOptions?: Apollo.MutationHookOptions<ForceCompleteStopsMutation, ForceCompleteStopsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceCompleteStopsMutation, ForceCompleteStopsMutationVariables>(ForceCompleteStopsDocument, options);
      }
export type ForceCompleteStopsMutationHookResult = ReturnType<typeof useForceCompleteStopsMutation>;
export type ForceCompleteStopsMutationResult = Apollo.MutationResult<ForceCompleteStopsMutation>;
export type ForceCompleteStopsMutationOptions = Apollo.BaseMutationOptions<ForceCompleteStopsMutation, ForceCompleteStopsMutationVariables>;
export const MarkStopTemplatesAsFixedSequenceDocument = gql`
    mutation MarkStopTemplatesAsFixedSequence($courierId: ID!, $shipmentTemplateId: ID!, $stopTemplateIdsInSequence: [ID!]!) {
  markStopTemplatesAsFixedSequence(
    courierId: $courierId
    shipmentTemplateId: $shipmentTemplateId
    stopTemplateIdsInSequence: $stopTemplateIdsInSequence
  ) {
    id
    shipmentTemplateId
    sequenceNumberInsideShipment
  }
}
    `;
export type MarkStopTemplatesAsFixedSequenceMutationFn = Apollo.MutationFunction<MarkStopTemplatesAsFixedSequenceMutation, MarkStopTemplatesAsFixedSequenceMutationVariables>;

/**
 * __useMarkStopTemplatesAsFixedSequenceMutation__
 *
 * To run a mutation, you first call `useMarkStopTemplatesAsFixedSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkStopTemplatesAsFixedSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markStopTemplatesAsFixedSequenceMutation, { data, loading, error }] = useMarkStopTemplatesAsFixedSequenceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentTemplateId: // value for 'shipmentTemplateId'
 *      stopTemplateIdsInSequence: // value for 'stopTemplateIdsInSequence'
 *   },
 * });
 */
export function useMarkStopTemplatesAsFixedSequenceMutation(baseOptions?: Apollo.MutationHookOptions<MarkStopTemplatesAsFixedSequenceMutation, MarkStopTemplatesAsFixedSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkStopTemplatesAsFixedSequenceMutation, MarkStopTemplatesAsFixedSequenceMutationVariables>(MarkStopTemplatesAsFixedSequenceDocument, options);
      }
export type MarkStopTemplatesAsFixedSequenceMutationHookResult = ReturnType<typeof useMarkStopTemplatesAsFixedSequenceMutation>;
export type MarkStopTemplatesAsFixedSequenceMutationResult = Apollo.MutationResult<MarkStopTemplatesAsFixedSequenceMutation>;
export type MarkStopTemplatesAsFixedSequenceMutationOptions = Apollo.BaseMutationOptions<MarkStopTemplatesAsFixedSequenceMutation, MarkStopTemplatesAsFixedSequenceMutationVariables>;
export const PrintMemorizationsPdfDocument = gql`
    mutation printMemorizationsPdf($courierId: ID!, $driverId: ID!, $dayOfWeek: DayOfTheWeek!) {
  printMemorizationsPdf(
    courierId: $courierId
    driverId: $driverId
    dayOfWeek: $dayOfWeek
  ) {
    id
    fileName
    initialUrl
  }
}
    `;
export type PrintMemorizationsPdfMutationFn = Apollo.MutationFunction<PrintMemorizationsPdfMutation, PrintMemorizationsPdfMutationVariables>;

/**
 * __usePrintMemorizationsPdfMutation__
 *
 * To run a mutation, you first call `usePrintMemorizationsPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintMemorizationsPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printMemorizationsPdfMutation, { data, loading, error }] = usePrintMemorizationsPdfMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      dayOfWeek: // value for 'dayOfWeek'
 *   },
 * });
 */
export function usePrintMemorizationsPdfMutation(baseOptions?: Apollo.MutationHookOptions<PrintMemorizationsPdfMutation, PrintMemorizationsPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintMemorizationsPdfMutation, PrintMemorizationsPdfMutationVariables>(PrintMemorizationsPdfDocument, options);
      }
export type PrintMemorizationsPdfMutationHookResult = ReturnType<typeof usePrintMemorizationsPdfMutation>;
export type PrintMemorizationsPdfMutationResult = Apollo.MutationResult<PrintMemorizationsPdfMutation>;
export type PrintMemorizationsPdfMutationOptions = Apollo.BaseMutationOptions<PrintMemorizationsPdfMutation, PrintMemorizationsPdfMutationVariables>;
export const PrintLiveRoutePdfDocument = gql`
    mutation printLiveRoutePdf($courierId: ID!, $driverId: ID!, $targetDate: Date!) {
  printLiveRoutePdf(
    courierId: $courierId
    driverId: $driverId
    targetDate: $targetDate
  ) {
    id
    fileName
    initialUrl
  }
}
    `;
export type PrintLiveRoutePdfMutationFn = Apollo.MutationFunction<PrintLiveRoutePdfMutation, PrintLiveRoutePdfMutationVariables>;

/**
 * __usePrintLiveRoutePdfMutation__
 *
 * To run a mutation, you first call `usePrintLiveRoutePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintLiveRoutePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printLiveRoutePdfMutation, { data, loading, error }] = usePrintLiveRoutePdfMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      targetDate: // value for 'targetDate'
 *   },
 * });
 */
export function usePrintLiveRoutePdfMutation(baseOptions?: Apollo.MutationHookOptions<PrintLiveRoutePdfMutation, PrintLiveRoutePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintLiveRoutePdfMutation, PrintLiveRoutePdfMutationVariables>(PrintLiveRoutePdfDocument, options);
      }
export type PrintLiveRoutePdfMutationHookResult = ReturnType<typeof usePrintLiveRoutePdfMutation>;
export type PrintLiveRoutePdfMutationResult = Apollo.MutationResult<PrintLiveRoutePdfMutation>;
export type PrintLiveRoutePdfMutationOptions = Apollo.BaseMutationOptions<PrintLiveRoutePdfMutation, PrintLiveRoutePdfMutationVariables>;
export const RevertStopCompletionDocument = gql`
    mutation RevertStopCompletion($courierId: ID!, $shipmentId: ID!, $stopIds: [ID!]!) {
  revertStopCompletion(
    courierId: $courierId
    shipmentId: $shipmentId
    stopIds: $stopIds
  ) {
    id
  }
}
    `;
export type RevertStopCompletionMutationFn = Apollo.MutationFunction<RevertStopCompletionMutation, RevertStopCompletionMutationVariables>;

/**
 * __useRevertStopCompletionMutation__
 *
 * To run a mutation, you first call `useRevertStopCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertStopCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertStopCompletionMutation, { data, loading, error }] = useRevertStopCompletionMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      stopIds: // value for 'stopIds'
 *   },
 * });
 */
export function useRevertStopCompletionMutation(baseOptions?: Apollo.MutationHookOptions<RevertStopCompletionMutation, RevertStopCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertStopCompletionMutation, RevertStopCompletionMutationVariables>(RevertStopCompletionDocument, options);
      }
export type RevertStopCompletionMutationHookResult = ReturnType<typeof useRevertStopCompletionMutation>;
export type RevertStopCompletionMutationResult = Apollo.MutationResult<RevertStopCompletionMutation>;
export type RevertStopCompletionMutationOptions = Apollo.BaseMutationOptions<RevertStopCompletionMutation, RevertStopCompletionMutationVariables>;
export const OverrideStopCompletedTimesDocument = gql`
    mutation OverrideStopCompletedTimes($courierId: ID!, $shipmentId: ID!, $overrides: [StopCompletedTimeOverride!]!) {
  overrideStopCompletedTimes(
    courierId: $courierId
    shipmentId: $shipmentId
    overrides: $overrides
  ) {
    id
  }
}
    `;
export type OverrideStopCompletedTimesMutationFn = Apollo.MutationFunction<OverrideStopCompletedTimesMutation, OverrideStopCompletedTimesMutationVariables>;

/**
 * __useOverrideStopCompletedTimesMutation__
 *
 * To run a mutation, you first call `useOverrideStopCompletedTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideStopCompletedTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideStopCompletedTimesMutation, { data, loading, error }] = useOverrideStopCompletedTimesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useOverrideStopCompletedTimesMutation(baseOptions?: Apollo.MutationHookOptions<OverrideStopCompletedTimesMutation, OverrideStopCompletedTimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideStopCompletedTimesMutation, OverrideStopCompletedTimesMutationVariables>(OverrideStopCompletedTimesDocument, options);
      }
export type OverrideStopCompletedTimesMutationHookResult = ReturnType<typeof useOverrideStopCompletedTimesMutation>;
export type OverrideStopCompletedTimesMutationResult = Apollo.MutationResult<OverrideStopCompletedTimesMutation>;
export type OverrideStopCompletedTimesMutationOptions = Apollo.BaseMutationOptions<OverrideStopCompletedTimesMutation, OverrideStopCompletedTimesMutationVariables>;
export const CopyMemorizationsDocument = gql`
    mutation CopyMemorizations($courierId: ID!, $driverId: ID!, $fromDayOfWeek: DayOfTheWeek!, $toDayOfTheWeeks: [DayOfTheWeek!]!, $toDays: [Date!]) {
  copyMemorizations(
    courierId: $courierId
    driverId: $driverId
    fromDayOfWeek: $fromDayOfWeek
    toDayOfTheWeeks: $toDayOfTheWeeks
    toDays: $toDays
  ) {
    dayOfWeek
  }
}
    `;
export type CopyMemorizationsMutationFn = Apollo.MutationFunction<CopyMemorizationsMutation, CopyMemorizationsMutationVariables>;

/**
 * __useCopyMemorizationsMutation__
 *
 * To run a mutation, you first call `useCopyMemorizationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyMemorizationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyMemorizationsMutation, { data, loading, error }] = useCopyMemorizationsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      fromDayOfWeek: // value for 'fromDayOfWeek'
 *      toDayOfTheWeeks: // value for 'toDayOfTheWeeks'
 *      toDays: // value for 'toDays'
 *   },
 * });
 */
export function useCopyMemorizationsMutation(baseOptions?: Apollo.MutationHookOptions<CopyMemorizationsMutation, CopyMemorizationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyMemorizationsMutation, CopyMemorizationsMutationVariables>(CopyMemorizationsDocument, options);
      }
export type CopyMemorizationsMutationHookResult = ReturnType<typeof useCopyMemorizationsMutation>;
export type CopyMemorizationsMutationResult = Apollo.MutationResult<CopyMemorizationsMutation>;
export type CopyMemorizationsMutationOptions = Apollo.BaseMutationOptions<CopyMemorizationsMutation, CopyMemorizationsMutationVariables>;
export const MemorizationsDocument = gql`
    query memorizations($courierId: ID!, $driverIds: [ID!], $dayOfWeeks: [DayOfTheWeek!], $days: [Date!]) {
  memorizations(
    courierId: $courierId
    driverIds: $driverIds
    dayOfWeeks: $dayOfWeeks
    days: $days
  ) {
    days {
      dayOfWeek
      stopTemplateSequenceNumbers {
        id
        courierId
        stopTemplateId
        dayOfWeek
        day
        sequenceNumber
        stopTemplate {
          ...StopTemplateFragment
          shipmentTemplate {
            ...ShipmentTemplateFragment
            order {
              ...OrderFragment
              serviceType {
                ...ServiceTypeFragment
              }
            }
          }
        }
      }
      unmemorizedStopTemplates {
        ...StopTemplateFragment
        shipmentTemplate {
          ...ShipmentTemplateFragment
          order {
            ...OrderFragment
            serviceType {
              ...ServiceTypeFragment
            }
          }
        }
      }
    }
  }
}
    ${StopTemplateFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}`;

/**
 * __useMemorizationsQuery__
 *
 * To run a query within a React component, call `useMemorizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemorizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemorizationsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      dayOfWeeks: // value for 'dayOfWeeks'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useMemorizationsQuery(baseOptions: Apollo.QueryHookOptions<MemorizationsQuery, MemorizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemorizationsQuery, MemorizationsQueryVariables>(MemorizationsDocument, options);
      }
export function useMemorizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemorizationsQuery, MemorizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemorizationsQuery, MemorizationsQueryVariables>(MemorizationsDocument, options);
        }
export type MemorizationsQueryHookResult = ReturnType<typeof useMemorizationsQuery>;
export type MemorizationsLazyQueryHookResult = ReturnType<typeof useMemorizationsLazyQuery>;
export type MemorizationsQueryResult = Apollo.QueryResult<MemorizationsQuery, MemorizationsQueryVariables>;
export const UniqueStopDatesDocument = gql`
    query UniqueStopDates($courierId: ID!, $shipmentStatusFilter: [ShipmentStatus!], $maxShipmentDate: Date, $minExpectedCompletionDate: Date) {
  uniqueStopDates(
    courierId: $courierId
    shipmentStatusFilter: $shipmentStatusFilter
    maxShipmentDate: $maxShipmentDate
    minExpectedCompletionDate: $minExpectedCompletionDate
  )
}
    `;

/**
 * __useUniqueStopDatesQuery__
 *
 * To run a query within a React component, call `useUniqueStopDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueStopDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueStopDatesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentStatusFilter: // value for 'shipmentStatusFilter'
 *      maxShipmentDate: // value for 'maxShipmentDate'
 *      minExpectedCompletionDate: // value for 'minExpectedCompletionDate'
 *   },
 * });
 */
export function useUniqueStopDatesQuery(baseOptions: Apollo.QueryHookOptions<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>(UniqueStopDatesDocument, options);
      }
export function useUniqueStopDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>(UniqueStopDatesDocument, options);
        }
export type UniqueStopDatesQueryHookResult = ReturnType<typeof useUniqueStopDatesQuery>;
export type UniqueStopDatesLazyQueryHookResult = ReturnType<typeof useUniqueStopDatesLazyQuery>;
export type UniqueStopDatesQueryResult = Apollo.QueryResult<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>;
export const MemorizedDaysDocument = gql`
    query MemorizedDays($courierId: ID!, $minDay: Date, $offset: Int!, $limit: Int!) {
  memorizedDays(
    courierId: $courierId
    minDay: $minDay
    offset: $offset
    limit: $limit
  )
}
    `;

/**
 * __useMemorizedDaysQuery__
 *
 * To run a query within a React component, call `useMemorizedDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemorizedDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemorizedDaysQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDay: // value for 'minDay'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMemorizedDaysQuery(baseOptions: Apollo.QueryHookOptions<MemorizedDaysQuery, MemorizedDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemorizedDaysQuery, MemorizedDaysQueryVariables>(MemorizedDaysDocument, options);
      }
export function useMemorizedDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemorizedDaysQuery, MemorizedDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemorizedDaysQuery, MemorizedDaysQueryVariables>(MemorizedDaysDocument, options);
        }
export type MemorizedDaysQueryHookResult = ReturnType<typeof useMemorizedDaysQuery>;
export type MemorizedDaysLazyQueryHookResult = ReturnType<typeof useMemorizedDaysLazyQuery>;
export type MemorizedDaysQueryResult = Apollo.QueryResult<MemorizedDaysQuery, MemorizedDaysQueryVariables>;
export const ReplaceRouteDocument = gql`
    mutation ReplaceRoute($courierId: ID!, $driverId: ID!, $newStopIds: [ID!]!, $shipmentDate: Date!, $replacedBy: String, $orderingAlgorithmType: OrderingAlgorithmType, $autoRoutedStopIds: [ID!], $dispatchSource: DispatchSource) {
  replaceRoute(
    courierId: $courierId
    driverId: $driverId
    newStopIds: $newStopIds
    shipmentDate: $shipmentDate
    replacedBy: $replacedBy
    orderingAlgorithmType: $orderingAlgorithmType
    autoRoutedStopIds: $autoRoutedStopIds
    dispatchSource: $dispatchSource
  ) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;
export type ReplaceRouteMutationFn = Apollo.MutationFunction<ReplaceRouteMutation, ReplaceRouteMutationVariables>;

/**
 * __useReplaceRouteMutation__
 *
 * To run a mutation, you first call `useReplaceRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceRouteMutation, { data, loading, error }] = useReplaceRouteMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      newStopIds: // value for 'newStopIds'
 *      shipmentDate: // value for 'shipmentDate'
 *      replacedBy: // value for 'replacedBy'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      autoRoutedStopIds: // value for 'autoRoutedStopIds'
 *      dispatchSource: // value for 'dispatchSource'
 *   },
 * });
 */
export function useReplaceRouteMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceRouteMutation, ReplaceRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceRouteMutation, ReplaceRouteMutationVariables>(ReplaceRouteDocument, options);
      }
export type ReplaceRouteMutationHookResult = ReturnType<typeof useReplaceRouteMutation>;
export type ReplaceRouteMutationResult = Apollo.MutationResult<ReplaceRouteMutation>;
export type ReplaceRouteMutationOptions = Apollo.BaseMutationOptions<ReplaceRouteMutation, ReplaceRouteMutationVariables>;
export const RefreshEtaStaleDocument = gql`
    mutation RefreshEtaStale($courierId: ID!, $driverId: ID!) {
  refreshEtaStale(courierId: $courierId, driverId: $driverId) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type RefreshEtaStaleMutationFn = Apollo.MutationFunction<RefreshEtaStaleMutation, RefreshEtaStaleMutationVariables>;

/**
 * __useRefreshEtaStaleMutation__
 *
 * To run a mutation, you first call `useRefreshEtaStaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshEtaStaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshEtaStaleMutation, { data, loading, error }] = useRefreshEtaStaleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useRefreshEtaStaleMutation(baseOptions?: Apollo.MutationHookOptions<RefreshEtaStaleMutation, RefreshEtaStaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshEtaStaleMutation, RefreshEtaStaleMutationVariables>(RefreshEtaStaleDocument, options);
      }
export type RefreshEtaStaleMutationHookResult = ReturnType<typeof useRefreshEtaStaleMutation>;
export type RefreshEtaStaleMutationResult = Apollo.MutationResult<RefreshEtaStaleMutation>;
export type RefreshEtaStaleMutationOptions = Apollo.BaseMutationOptions<RefreshEtaStaleMutation, RefreshEtaStaleMutationVariables>;
export const UploadFileV1Document = gql`
    mutation uploadFileV1($courierId: ID!, $file: Upload!, $type: FileType!, $taskId: ID, $value: String, $createdBy: ID) {
  uploadFileV1(
    courierId: $courierId
    file: $file
    type: $type
    taskId: $taskId
    value: $value
    createdBy: $createdBy
  ) {
    ...ArtifactFragment
  }
}
    ${ArtifactFragmentFragmentDoc}`;
export type UploadFileV1MutationFn = Apollo.MutationFunction<UploadFileV1Mutation, UploadFileV1MutationVariables>;

/**
 * __useUploadFileV1Mutation__
 *
 * To run a mutation, you first call `useUploadFileV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileV1Mutation, { data, loading, error }] = useUploadFileV1Mutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *      type: // value for 'type'
 *      taskId: // value for 'taskId'
 *      value: // value for 'value'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useUploadFileV1Mutation(baseOptions?: Apollo.MutationHookOptions<UploadFileV1Mutation, UploadFileV1MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileV1Mutation, UploadFileV1MutationVariables>(UploadFileV1Document, options);
      }
export type UploadFileV1MutationHookResult = ReturnType<typeof useUploadFileV1Mutation>;
export type UploadFileV1MutationResult = Apollo.MutationResult<UploadFileV1Mutation>;
export type UploadFileV1MutationOptions = Apollo.BaseMutationOptions<UploadFileV1Mutation, UploadFileV1MutationVariables>;
export const PreviewEtaForRouteDocument = gql`
    query PreviewEtaForRoute($driverId: ID!, $stopIds: [ID!]!, $baseTime: Timestamp) {
  previewEtaForRoute(driverId: $driverId, stopIds: $stopIds, baseTime: $baseTime) {
    stopEtas {
      ...StopEtaFragment
    }
  }
}
    ${StopEtaFragmentFragmentDoc}`;

/**
 * __usePreviewEtaForRouteQuery__
 *
 * To run a query within a React component, call `usePreviewEtaForRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewEtaForRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewEtaForRouteQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      stopIds: // value for 'stopIds'
 *      baseTime: // value for 'baseTime'
 *   },
 * });
 */
export function usePreviewEtaForRouteQuery(baseOptions: Apollo.QueryHookOptions<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>(PreviewEtaForRouteDocument, options);
      }
export function usePreviewEtaForRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>(PreviewEtaForRouteDocument, options);
        }
export type PreviewEtaForRouteQueryHookResult = ReturnType<typeof usePreviewEtaForRouteQuery>;
export type PreviewEtaForRouteLazyQueryHookResult = ReturnType<typeof usePreviewEtaForRouteLazyQuery>;
export type PreviewEtaForRouteQueryResult = Apollo.QueryResult<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>;
export const SparseUpdateColumnVisibilityDocument = gql`
    mutation SparseUpdateColumnVisibility($courierId: String!, $salesReportColumnIds: [SalesReportColumnId!], $driverReportColumnIds: [DriverReportColumnId!], $userOrEmployeeId: String!, $updatedBy: String!) {
  sparseUpdateColumnVisibility(
    courierId: $courierId
    salesReportColumnIds: $salesReportColumnIds
    driverReportColumnIds: $driverReportColumnIds
    userOrEmployeeId: $userOrEmployeeId
    updatedBy: $updatedBy
  ) {
    ...VisibleColumnsConfigFragment
  }
}
    ${VisibleColumnsConfigFragmentFragmentDoc}`;
export type SparseUpdateColumnVisibilityMutationFn = Apollo.MutationFunction<SparseUpdateColumnVisibilityMutation, SparseUpdateColumnVisibilityMutationVariables>;

/**
 * __useSparseUpdateColumnVisibilityMutation__
 *
 * To run a mutation, you first call `useSparseUpdateColumnVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSparseUpdateColumnVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sparseUpdateColumnVisibilityMutation, { data, loading, error }] = useSparseUpdateColumnVisibilityMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      salesReportColumnIds: // value for 'salesReportColumnIds'
 *      driverReportColumnIds: // value for 'driverReportColumnIds'
 *      userOrEmployeeId: // value for 'userOrEmployeeId'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useSparseUpdateColumnVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<SparseUpdateColumnVisibilityMutation, SparseUpdateColumnVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SparseUpdateColumnVisibilityMutation, SparseUpdateColumnVisibilityMutationVariables>(SparseUpdateColumnVisibilityDocument, options);
      }
export type SparseUpdateColumnVisibilityMutationHookResult = ReturnType<typeof useSparseUpdateColumnVisibilityMutation>;
export type SparseUpdateColumnVisibilityMutationResult = Apollo.MutationResult<SparseUpdateColumnVisibilityMutation>;
export type SparseUpdateColumnVisibilityMutationOptions = Apollo.BaseMutationOptions<SparseUpdateColumnVisibilityMutation, SparseUpdateColumnVisibilityMutationVariables>;
export const UpsertUserStoreDocument = gql`
    mutation UpsertUserStore($courierId: ID!, $userOrEmployeeId: ID!, $key: String!, $value: String!) {
  upsertUserStore(
    courierId: $courierId
    userOrEmployeeId: $userOrEmployeeId
    key: $key
    value: $value
  ) {
    ...UserStoreFragment
  }
}
    ${UserStoreFragmentFragmentDoc}`;
export type UpsertUserStoreMutationFn = Apollo.MutationFunction<UpsertUserStoreMutation, UpsertUserStoreMutationVariables>;

/**
 * __useUpsertUserStoreMutation__
 *
 * To run a mutation, you first call `useUpsertUserStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserStoreMutation, { data, loading, error }] = useUpsertUserStoreMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      userOrEmployeeId: // value for 'userOrEmployeeId'
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertUserStoreMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserStoreMutation, UpsertUserStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserStoreMutation, UpsertUserStoreMutationVariables>(UpsertUserStoreDocument, options);
      }
export type UpsertUserStoreMutationHookResult = ReturnType<typeof useUpsertUserStoreMutation>;
export type UpsertUserStoreMutationResult = Apollo.MutationResult<UpsertUserStoreMutation>;
export type UpsertUserStoreMutationOptions = Apollo.BaseMutationOptions<UpsertUserStoreMutation, UpsertUserStoreMutationVariables>;
export const GetVisibleColumnsDocument = gql`
    query GetVisibleColumns($courierId: String!, $userOrEmployeeId: String!) {
  getVisibleColumns(courierId: $courierId, userOrEmployeeId: $userOrEmployeeId) {
    ...VisibleColumnsConfigFragment
  }
}
    ${VisibleColumnsConfigFragmentFragmentDoc}`;

/**
 * __useGetVisibleColumnsQuery__
 *
 * To run a query within a React component, call `useGetVisibleColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibleColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibleColumnsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      userOrEmployeeId: // value for 'userOrEmployeeId'
 *   },
 * });
 */
export function useGetVisibleColumnsQuery(baseOptions: Apollo.QueryHookOptions<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>(GetVisibleColumnsDocument, options);
      }
export function useGetVisibleColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>(GetVisibleColumnsDocument, options);
        }
export type GetVisibleColumnsQueryHookResult = ReturnType<typeof useGetVisibleColumnsQuery>;
export type GetVisibleColumnsLazyQueryHookResult = ReturnType<typeof useGetVisibleColumnsLazyQuery>;
export type GetVisibleColumnsQueryResult = Apollo.QueryResult<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>;
export const GetUserStoresDocument = gql`
    query GetUserStores($courierId: ID!, $userOrEmployeeId: ID!, $keysFilter: [ID!]) {
  userStores(
    courierId: $courierId
    userOrEmployeeId: $userOrEmployeeId
    keysFilter: $keysFilter
  ) {
    ...UserStoreFragment
  }
}
    ${UserStoreFragmentFragmentDoc}`;

/**
 * __useGetUserStoresQuery__
 *
 * To run a query within a React component, call `useGetUserStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStoresQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      userOrEmployeeId: // value for 'userOrEmployeeId'
 *      keysFilter: // value for 'keysFilter'
 *   },
 * });
 */
export function useGetUserStoresQuery(baseOptions: Apollo.QueryHookOptions<GetUserStoresQuery, GetUserStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserStoresQuery, GetUserStoresQueryVariables>(GetUserStoresDocument, options);
      }
export function useGetUserStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserStoresQuery, GetUserStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserStoresQuery, GetUserStoresQueryVariables>(GetUserStoresDocument, options);
        }
export type GetUserStoresQueryHookResult = ReturnType<typeof useGetUserStoresQuery>;
export type GetUserStoresLazyQueryHookResult = ReturnType<typeof useGetUserStoresLazyQuery>;
export type GetUserStoresQueryResult = Apollo.QueryResult<GetUserStoresQuery, GetUserStoresQueryVariables>;
export const SyncUserWithFirebaseDocument = gql`
    mutation syncUserWithFirebase($email: String!, $firebaseUid: String!) {
  syncUserWithFirebase(email: $email, firebaseUid: $firebaseUid) {
    user {
      ...CourieUserFragment
    }
    error
    employeeId
  }
}
    ${CourieUserFragmentFragmentDoc}`;
export type SyncUserWithFirebaseMutationFn = Apollo.MutationFunction<SyncUserWithFirebaseMutation, SyncUserWithFirebaseMutationVariables>;

/**
 * __useSyncUserWithFirebaseMutation__
 *
 * To run a mutation, you first call `useSyncUserWithFirebaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserWithFirebaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserWithFirebaseMutation, { data, loading, error }] = useSyncUserWithFirebaseMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firebaseUid: // value for 'firebaseUid'
 *   },
 * });
 */
export function useSyncUserWithFirebaseMutation(baseOptions?: Apollo.MutationHookOptions<SyncUserWithFirebaseMutation, SyncUserWithFirebaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncUserWithFirebaseMutation, SyncUserWithFirebaseMutationVariables>(SyncUserWithFirebaseDocument, options);
      }
export type SyncUserWithFirebaseMutationHookResult = ReturnType<typeof useSyncUserWithFirebaseMutation>;
export type SyncUserWithFirebaseMutationResult = Apollo.MutationResult<SyncUserWithFirebaseMutation>;
export type SyncUserWithFirebaseMutationOptions = Apollo.BaseMutationOptions<SyncUserWithFirebaseMutation, SyncUserWithFirebaseMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($courierId: String!, $email: String!, $roleType: UserRoleType!) {
  createUser(courierId: $courierId, email: $email, roleType: $roleType) {
    ...CourieUserFragment
  }
}
    ${CourieUserFragmentFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      email: // value for 'email'
 *      roleType: // value for 'roleType'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const FullUpdateUserDocument = gql`
    mutation fullUpdateUser($courierId: ID!, $id: ID!, $email: String!, $roleType: UserRoleType!, $customRoleIds: [String!]) {
  fullUpdateUser(
    courierId: $courierId
    id: $id
    email: $email
    roleType: $roleType
    customRoleIds: $customRoleIds
  ) {
    ...CourieUserFragment
  }
}
    ${CourieUserFragmentFragmentDoc}`;
export type FullUpdateUserMutationFn = Apollo.MutationFunction<FullUpdateUserMutation, FullUpdateUserMutationVariables>;

/**
 * __useFullUpdateUserMutation__
 *
 * To run a mutation, you first call `useFullUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateUserMutation, { data, loading, error }] = useFullUpdateUserMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      roleType: // value for 'roleType'
 *      customRoleIds: // value for 'customRoleIds'
 *   },
 * });
 */
export function useFullUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateUserMutation, FullUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateUserMutation, FullUpdateUserMutationVariables>(FullUpdateUserDocument, options);
      }
export type FullUpdateUserMutationHookResult = ReturnType<typeof useFullUpdateUserMutation>;
export type FullUpdateUserMutationResult = Apollo.MutationResult<FullUpdateUserMutation>;
export type FullUpdateUserMutationOptions = Apollo.BaseMutationOptions<FullUpdateUserMutation, FullUpdateUserMutationVariables>;
export const MarkUserAsDeletedDocument = gql`
    mutation markUserAsDeleted($courierId: ID!, $id: ID!) {
  markUserAsDeleted(courierId: $courierId, id: $id) {
    ...CourieUserFragment
  }
}
    ${CourieUserFragmentFragmentDoc}`;
export type MarkUserAsDeletedMutationFn = Apollo.MutationFunction<MarkUserAsDeletedMutation, MarkUserAsDeletedMutationVariables>;

/**
 * __useMarkUserAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkUserAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserAsDeletedMutation, { data, loading, error }] = useMarkUserAsDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUserAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkUserAsDeletedMutation, MarkUserAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUserAsDeletedMutation, MarkUserAsDeletedMutationVariables>(MarkUserAsDeletedDocument, options);
      }
export type MarkUserAsDeletedMutationHookResult = ReturnType<typeof useMarkUserAsDeletedMutation>;
export type MarkUserAsDeletedMutationResult = Apollo.MutationResult<MarkUserAsDeletedMutation>;
export type MarkUserAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkUserAsDeletedMutation, MarkUserAsDeletedMutationVariables>;
export const UpdateUserNotificationSettingsDocument = gql`
    mutation updateUserNotificationSettings($courierId: ID!, $userId: ID!, $enabledNotificationTypes: [NotificationType!]!) {
  updateUserNotificationSettings(
    courierId: $courierId
    userId: $userId
    enabledNotificationTypes: $enabledNotificationTypes
  )
}
    `;
export type UpdateUserNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateUserNotificationSettingsMutation, UpdateUserNotificationSettingsMutationVariables>;

/**
 * __useUpdateUserNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationSettingsMutation, { data, loading, error }] = useUpdateUserNotificationSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      userId: // value for 'userId'
 *      enabledNotificationTypes: // value for 'enabledNotificationTypes'
 *   },
 * });
 */
export function useUpdateUserNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNotificationSettingsMutation, UpdateUserNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNotificationSettingsMutation, UpdateUserNotificationSettingsMutationVariables>(UpdateUserNotificationSettingsDocument, options);
      }
export type UpdateUserNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateUserNotificationSettingsMutation>;
export type UpdateUserNotificationSettingsMutationResult = Apollo.MutationResult<UpdateUserNotificationSettingsMutation>;
export type UpdateUserNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserNotificationSettingsMutation, UpdateUserNotificationSettingsMutationVariables>;
export const ChangePasswordUserDocument = gql`
    mutation changePasswordUser($courierId: ID!, $userId: ID!, $password: String!) {
  changePasswordUser(courierId: $courierId, userId: $userId, password: $password) {
    ...CourieUserFragment
  }
}
    ${CourieUserFragmentFragmentDoc}`;
export type ChangePasswordUserMutationFn = Apollo.MutationFunction<ChangePasswordUserMutation, ChangePasswordUserMutationVariables>;

/**
 * __useChangePasswordUserMutation__
 *
 * To run a mutation, you first call `useChangePasswordUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordUserMutation, { data, loading, error }] = useChangePasswordUserMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      userId: // value for 'userId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordUserMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordUserMutation, ChangePasswordUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordUserMutation, ChangePasswordUserMutationVariables>(ChangePasswordUserDocument, options);
      }
export type ChangePasswordUserMutationHookResult = ReturnType<typeof useChangePasswordUserMutation>;
export type ChangePasswordUserMutationResult = Apollo.MutationResult<ChangePasswordUserMutation>;
export type ChangePasswordUserMutationOptions = Apollo.BaseMutationOptions<ChangePasswordUserMutation, ChangePasswordUserMutationVariables>;
export const GetUsersDocument = gql`
    query GetUsers($courierId: ID!, $after: Int!, $limit: Int!) {
  users(courierId: $courierId, after: $after, limit: $limit) {
    edges {
      node {
        ...CourieUserFragment
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${CourieUserFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const FullUpdateVehicleTypeDocument = gql`
    mutation fullUpdateVehicleType($courierId: ID!, $id: ID!, $name: String!, $shortCode: String!, $fuelType: FuelType, $maxPackageLength: Float, $maxPackageWidth: Float, $maxPackageHeight: Float) {
  fullUpdateVehicleType(
    courierId: $courierId
    id: $id
    name: $name
    shortCode: $shortCode
    fuelType: $fuelType
    maxPackageLength: $maxPackageLength
    maxPackageWidth: $maxPackageWidth
    maxPackageHeight: $maxPackageHeight
  ) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;
export type FullUpdateVehicleTypeMutationFn = Apollo.MutationFunction<FullUpdateVehicleTypeMutation, FullUpdateVehicleTypeMutationVariables>;

/**
 * __useFullUpdateVehicleTypeMutation__
 *
 * To run a mutation, you first call `useFullUpdateVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateVehicleTypeMutation, { data, loading, error }] = useFullUpdateVehicleTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      shortCode: // value for 'shortCode'
 *      fuelType: // value for 'fuelType'
 *      maxPackageLength: // value for 'maxPackageLength'
 *      maxPackageWidth: // value for 'maxPackageWidth'
 *      maxPackageHeight: // value for 'maxPackageHeight'
 *   },
 * });
 */
export function useFullUpdateVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateVehicleTypeMutation, FullUpdateVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateVehicleTypeMutation, FullUpdateVehicleTypeMutationVariables>(FullUpdateVehicleTypeDocument, options);
      }
export type FullUpdateVehicleTypeMutationHookResult = ReturnType<typeof useFullUpdateVehicleTypeMutation>;
export type FullUpdateVehicleTypeMutationResult = Apollo.MutationResult<FullUpdateVehicleTypeMutation>;
export type FullUpdateVehicleTypeMutationOptions = Apollo.BaseMutationOptions<FullUpdateVehicleTypeMutation, FullUpdateVehicleTypeMutationVariables>;
export const CreateVehicleTypeDocument = gql`
    mutation createVehicleType($courierId: ID!, $name: String!, $shortCode: String!, $fuelType: FuelType, $maxPackageLength: Float, $maxPackageWidth: Float, $maxPackageHeight: Float) {
  createVehicleType(
    courierId: $courierId
    name: $name
    shortCode: $shortCode
    fuelType: $fuelType
    maxPackageLength: $maxPackageLength
    maxPackageWidth: $maxPackageWidth
    maxPackageHeight: $maxPackageHeight
  ) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;
export type CreateVehicleTypeMutationFn = Apollo.MutationFunction<CreateVehicleTypeMutation, CreateVehicleTypeMutationVariables>;

/**
 * __useCreateVehicleTypeMutation__
 *
 * To run a mutation, you first call `useCreateVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleTypeMutation, { data, loading, error }] = useCreateVehicleTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      shortCode: // value for 'shortCode'
 *      fuelType: // value for 'fuelType'
 *      maxPackageLength: // value for 'maxPackageLength'
 *      maxPackageWidth: // value for 'maxPackageWidth'
 *      maxPackageHeight: // value for 'maxPackageHeight'
 *   },
 * });
 */
export function useCreateVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateVehicleTypeMutation, CreateVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVehicleTypeMutation, CreateVehicleTypeMutationVariables>(CreateVehicleTypeDocument, options);
      }
export type CreateVehicleTypeMutationHookResult = ReturnType<typeof useCreateVehicleTypeMutation>;
export type CreateVehicleTypeMutationResult = Apollo.MutationResult<CreateVehicleTypeMutation>;
export type CreateVehicleTypeMutationOptions = Apollo.BaseMutationOptions<CreateVehicleTypeMutation, CreateVehicleTypeMutationVariables>;
export const DeleteVehicleTypeDocument = gql`
    mutation deleteVehicleType($courierId: ID!, $id: ID!) {
  deleteVehicleType(courierId: $courierId, id: $id) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;
export type DeleteVehicleTypeMutationFn = Apollo.MutationFunction<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>;

/**
 * __useDeleteVehicleTypeMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleTypeMutation, { data, loading, error }] = useDeleteVehicleTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>(DeleteVehicleTypeDocument, options);
      }
export type DeleteVehicleTypeMutationHookResult = ReturnType<typeof useDeleteVehicleTypeMutation>;
export type DeleteVehicleTypeMutationResult = Apollo.MutationResult<DeleteVehicleTypeMutation>;
export type DeleteVehicleTypeMutationOptions = Apollo.BaseMutationOptions<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>;
export const UpdateVehicleTypeVisiblePackageTypesDocument = gql`
    mutation UpdateVehicleTypeVisiblePackageTypes($courierId: ID!, $vehicleTypeId: ID!, $visiblePackageTypeIds: [String!]) {
  updateVehicleTypeVisiblePackageTypes(
    courierId: $courierId
    vehicleTypeId: $vehicleTypeId
    visiblePackageTypeIds: $visiblePackageTypeIds
  ) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;
export type UpdateVehicleTypeVisiblePackageTypesMutationFn = Apollo.MutationFunction<UpdateVehicleTypeVisiblePackageTypesMutation, UpdateVehicleTypeVisiblePackageTypesMutationVariables>;

/**
 * __useUpdateVehicleTypeVisiblePackageTypesMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleTypeVisiblePackageTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleTypeVisiblePackageTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleTypeVisiblePackageTypesMutation, { data, loading, error }] = useUpdateVehicleTypeVisiblePackageTypesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      visiblePackageTypeIds: // value for 'visiblePackageTypeIds'
 *   },
 * });
 */
export function useUpdateVehicleTypeVisiblePackageTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleTypeVisiblePackageTypesMutation, UpdateVehicleTypeVisiblePackageTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleTypeVisiblePackageTypesMutation, UpdateVehicleTypeVisiblePackageTypesMutationVariables>(UpdateVehicleTypeVisiblePackageTypesDocument, options);
      }
export type UpdateVehicleTypeVisiblePackageTypesMutationHookResult = ReturnType<typeof useUpdateVehicleTypeVisiblePackageTypesMutation>;
export type UpdateVehicleTypeVisiblePackageTypesMutationResult = Apollo.MutationResult<UpdateVehicleTypeVisiblePackageTypesMutation>;
export type UpdateVehicleTypeVisiblePackageTypesMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleTypeVisiblePackageTypesMutation, UpdateVehicleTypeVisiblePackageTypesMutationVariables>;
export const UpdateVehicleTypeReadyTimeScheduleDocument = gql`
    mutation UpdateVehicleTypeReadyTimeSchedule($courierId: ID!, $vehicleTypeId: ID!, $readyTimeSchedule: TimeScheduleInput!) {
  updateVehicleTypeReadyTimeSchedule(
    courierId: $courierId
    vehicleTypeId: $vehicleTypeId
    readyTimeSchedule: $readyTimeSchedule
  ) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;
export type UpdateVehicleTypeReadyTimeScheduleMutationFn = Apollo.MutationFunction<UpdateVehicleTypeReadyTimeScheduleMutation, UpdateVehicleTypeReadyTimeScheduleMutationVariables>;

/**
 * __useUpdateVehicleTypeReadyTimeScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleTypeReadyTimeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleTypeReadyTimeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleTypeReadyTimeScheduleMutation, { data, loading, error }] = useUpdateVehicleTypeReadyTimeScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      readyTimeSchedule: // value for 'readyTimeSchedule'
 *   },
 * });
 */
export function useUpdateVehicleTypeReadyTimeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleTypeReadyTimeScheduleMutation, UpdateVehicleTypeReadyTimeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleTypeReadyTimeScheduleMutation, UpdateVehicleTypeReadyTimeScheduleMutationVariables>(UpdateVehicleTypeReadyTimeScheduleDocument, options);
      }
export type UpdateVehicleTypeReadyTimeScheduleMutationHookResult = ReturnType<typeof useUpdateVehicleTypeReadyTimeScheduleMutation>;
export type UpdateVehicleTypeReadyTimeScheduleMutationResult = Apollo.MutationResult<UpdateVehicleTypeReadyTimeScheduleMutation>;
export type UpdateVehicleTypeReadyTimeScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleTypeReadyTimeScheduleMutation, UpdateVehicleTypeReadyTimeScheduleMutationVariables>;
export const GetVehicleTypesDocument = gql`
    query GetVehicleTypes($courierId: ID!) {
  vehicleTypes(courierId: $courierId) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;

/**
 * __useGetVehicleTypesQuery__
 *
 * To run a query within a React component, call `useGetVehicleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleTypesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetVehicleTypesQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleTypesQuery, GetVehicleTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleTypesQuery, GetVehicleTypesQueryVariables>(GetVehicleTypesDocument, options);
      }
export function useGetVehicleTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleTypesQuery, GetVehicleTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleTypesQuery, GetVehicleTypesQueryVariables>(GetVehicleTypesDocument, options);
        }
export type GetVehicleTypesQueryHookResult = ReturnType<typeof useGetVehicleTypesQuery>;
export type GetVehicleTypesLazyQueryHookResult = ReturnType<typeof useGetVehicleTypesLazyQuery>;
export type GetVehicleTypesQueryResult = Apollo.QueryResult<GetVehicleTypesQuery, GetVehicleTypesQueryVariables>;
export const CreateZonesDocument = gql`
    mutation CreateZones($courierId: ID!, $zones: [ZoneCreate!]!) {
  createZones(courierId: $courierId, zones: $zones) {
    ...ZoneFragment
  }
}
    ${ZoneFragmentFragmentDoc}`;
export type CreateZonesMutationFn = Apollo.MutationFunction<CreateZonesMutation, CreateZonesMutationVariables>;

/**
 * __useCreateZonesMutation__
 *
 * To run a mutation, you first call `useCreateZonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZonesMutation, { data, loading, error }] = useCreateZonesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      zones: // value for 'zones'
 *   },
 * });
 */
export function useCreateZonesMutation(baseOptions?: Apollo.MutationHookOptions<CreateZonesMutation, CreateZonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZonesMutation, CreateZonesMutationVariables>(CreateZonesDocument, options);
      }
export type CreateZonesMutationHookResult = ReturnType<typeof useCreateZonesMutation>;
export type CreateZonesMutationResult = Apollo.MutationResult<CreateZonesMutation>;
export type CreateZonesMutationOptions = Apollo.BaseMutationOptions<CreateZonesMutation, CreateZonesMutationVariables>;
export const UpdateZonesDocument = gql`
    mutation UpdateZones($courierId: ID!, $zones: [ZoneUpdate!]!) {
  updateZones(courierId: $courierId, zones: $zones) {
    ...ZoneFragment
  }
}
    ${ZoneFragmentFragmentDoc}`;
export type UpdateZonesMutationFn = Apollo.MutationFunction<UpdateZonesMutation, UpdateZonesMutationVariables>;

/**
 * __useUpdateZonesMutation__
 *
 * To run a mutation, you first call `useUpdateZonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZonesMutation, { data, loading, error }] = useUpdateZonesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      zones: // value for 'zones'
 *   },
 * });
 */
export function useUpdateZonesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZonesMutation, UpdateZonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZonesMutation, UpdateZonesMutationVariables>(UpdateZonesDocument, options);
      }
export type UpdateZonesMutationHookResult = ReturnType<typeof useUpdateZonesMutation>;
export type UpdateZonesMutationResult = Apollo.MutationResult<UpdateZonesMutation>;
export type UpdateZonesMutationOptions = Apollo.BaseMutationOptions<UpdateZonesMutation, UpdateZonesMutationVariables>;
export const CreateCircleZoneDocument = gql`
    mutation CreateCircleZone($courierId: ID!, $name: String!, $center: LngLatInput!, $minRadiusInMeters: Float!, $maxRadiusInMeters: Float!) {
  createCircleZone(
    courierId: $courierId
    name: $name
    center: $center
    minRadiusInMeters: $minRadiusInMeters
    maxRadiusInMeters: $maxRadiusInMeters
  ) {
    ...CircleZoneFragment
  }
}
    ${CircleZoneFragmentFragmentDoc}`;
export type CreateCircleZoneMutationFn = Apollo.MutationFunction<CreateCircleZoneMutation, CreateCircleZoneMutationVariables>;

/**
 * __useCreateCircleZoneMutation__
 *
 * To run a mutation, you first call `useCreateCircleZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCircleZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCircleZoneMutation, { data, loading, error }] = useCreateCircleZoneMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      center: // value for 'center'
 *      minRadiusInMeters: // value for 'minRadiusInMeters'
 *      maxRadiusInMeters: // value for 'maxRadiusInMeters'
 *   },
 * });
 */
export function useCreateCircleZoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateCircleZoneMutation, CreateCircleZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCircleZoneMutation, CreateCircleZoneMutationVariables>(CreateCircleZoneDocument, options);
      }
export type CreateCircleZoneMutationHookResult = ReturnType<typeof useCreateCircleZoneMutation>;
export type CreateCircleZoneMutationResult = Apollo.MutationResult<CreateCircleZoneMutation>;
export type CreateCircleZoneMutationOptions = Apollo.BaseMutationOptions<CreateCircleZoneMutation, CreateCircleZoneMutationVariables>;
export const UpdateCircleZoneDocument = gql`
    mutation UpdateCircleZone($id: ID!, $courierId: ID!, $name: String!, $center: LngLatInput!, $minRadiusInMeters: Float!, $maxRadiusInMeters: Float!) {
  updateCircleZone(
    id: $id
    courierId: $courierId
    name: $name
    center: $center
    minRadiusInMeters: $minRadiusInMeters
    maxRadiusInMeters: $maxRadiusInMeters
  ) {
    ...CircleZoneFragment
  }
}
    ${CircleZoneFragmentFragmentDoc}`;
export type UpdateCircleZoneMutationFn = Apollo.MutationFunction<UpdateCircleZoneMutation, UpdateCircleZoneMutationVariables>;

/**
 * __useUpdateCircleZoneMutation__
 *
 * To run a mutation, you first call `useUpdateCircleZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCircleZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCircleZoneMutation, { data, loading, error }] = useUpdateCircleZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      center: // value for 'center'
 *      minRadiusInMeters: // value for 'minRadiusInMeters'
 *      maxRadiusInMeters: // value for 'maxRadiusInMeters'
 *   },
 * });
 */
export function useUpdateCircleZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCircleZoneMutation, UpdateCircleZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCircleZoneMutation, UpdateCircleZoneMutationVariables>(UpdateCircleZoneDocument, options);
      }
export type UpdateCircleZoneMutationHookResult = ReturnType<typeof useUpdateCircleZoneMutation>;
export type UpdateCircleZoneMutationResult = Apollo.MutationResult<UpdateCircleZoneMutation>;
export type UpdateCircleZoneMutationOptions = Apollo.BaseMutationOptions<UpdateCircleZoneMutation, UpdateCircleZoneMutationVariables>;
export const DeleteCircleZoneDocument = gql`
    mutation DeleteCircleZone($id: ID!, $courierId: ID!) {
  deleteCircleZone(id: $id, courierId: $courierId)
}
    `;
export type DeleteCircleZoneMutationFn = Apollo.MutationFunction<DeleteCircleZoneMutation, DeleteCircleZoneMutationVariables>;

/**
 * __useDeleteCircleZoneMutation__
 *
 * To run a mutation, you first call `useDeleteCircleZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCircleZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCircleZoneMutation, { data, loading, error }] = useDeleteCircleZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useDeleteCircleZoneMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCircleZoneMutation, DeleteCircleZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCircleZoneMutation, DeleteCircleZoneMutationVariables>(DeleteCircleZoneDocument, options);
      }
export type DeleteCircleZoneMutationHookResult = ReturnType<typeof useDeleteCircleZoneMutation>;
export type DeleteCircleZoneMutationResult = Apollo.MutationResult<DeleteCircleZoneMutation>;
export type DeleteCircleZoneMutationOptions = Apollo.BaseMutationOptions<DeleteCircleZoneMutation, DeleteCircleZoneMutationVariables>;
export const UploadZonesFromKmzDocument = gql`
    mutation UploadZonesFromKmz($courierId: ID!, $file: Upload!) {
  uploadZonesFromKmz(courierId: $courierId, file: $file) {
    zonesUpserted
    warnings
  }
}
    `;
export type UploadZonesFromKmzMutationFn = Apollo.MutationFunction<UploadZonesFromKmzMutation, UploadZonesFromKmzMutationVariables>;

/**
 * __useUploadZonesFromKmzMutation__
 *
 * To run a mutation, you first call `useUploadZonesFromKmzMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadZonesFromKmzMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadZonesFromKmzMutation, { data, loading, error }] = useUploadZonesFromKmzMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadZonesFromKmzMutation(baseOptions?: Apollo.MutationHookOptions<UploadZonesFromKmzMutation, UploadZonesFromKmzMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadZonesFromKmzMutation, UploadZonesFromKmzMutationVariables>(UploadZonesFromKmzDocument, options);
      }
export type UploadZonesFromKmzMutationHookResult = ReturnType<typeof useUploadZonesFromKmzMutation>;
export type UploadZonesFromKmzMutationResult = Apollo.MutationResult<UploadZonesFromKmzMutation>;
export type UploadZonesFromKmzMutationOptions = Apollo.BaseMutationOptions<UploadZonesFromKmzMutation, UploadZonesFromKmzMutationVariables>;
export const ZonesDocument = gql`
    query Zones($courierId: ID!, $type: ZoneType!) {
  zones(courierId: $courierId, type: $type) {
    ...ZoneFragment
  }
}
    ${ZoneFragmentFragmentDoc}`;

/**
 * __useZonesQuery__
 *
 * To run a query within a React component, call `useZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useZonesQuery(baseOptions: Apollo.QueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
      }
export function useZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
        }
export type ZonesQueryHookResult = ReturnType<typeof useZonesQuery>;
export type ZonesLazyQueryHookResult = ReturnType<typeof useZonesLazyQuery>;
export type ZonesQueryResult = Apollo.QueryResult<ZonesQuery, ZonesQueryVariables>;
export const CircleZonesDocument = gql`
    query CircleZones($courierId: ID!) {
  circleZones(courierId: $courierId) {
    ...CircleZoneFragment
  }
}
    ${CircleZoneFragmentFragmentDoc}`;

/**
 * __useCircleZonesQuery__
 *
 * To run a query within a React component, call `useCircleZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleZonesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useCircleZonesQuery(baseOptions: Apollo.QueryHookOptions<CircleZonesQuery, CircleZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CircleZonesQuery, CircleZonesQueryVariables>(CircleZonesDocument, options);
      }
export function useCircleZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CircleZonesQuery, CircleZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CircleZonesQuery, CircleZonesQueryVariables>(CircleZonesDocument, options);
        }
export type CircleZonesQueryHookResult = ReturnType<typeof useCircleZonesQuery>;
export type CircleZonesLazyQueryHookResult = ReturnType<typeof useCircleZonesLazyQuery>;
export type CircleZonesQueryResult = Apollo.QueryResult<CircleZonesQuery, CircleZonesQueryVariables>;
export const AddCourierAnalyticsDashboardDocument = gql`
    mutation AddCourierAnalyticsDashboard($courierId: ID!, $name: String!, $metabaseDashboardId: String!) {
  addCourierAnalyticsDashboard(
    courierId: $courierId
    name: $name
    metabaseDashboardId: $metabaseDashboardId
  ) {
    ...AnalyticsDashboardFragment
  }
}
    ${AnalyticsDashboardFragmentFragmentDoc}`;
export type AddCourierAnalyticsDashboardMutationFn = Apollo.MutationFunction<AddCourierAnalyticsDashboardMutation, AddCourierAnalyticsDashboardMutationVariables>;

/**
 * __useAddCourierAnalyticsDashboardMutation__
 *
 * To run a mutation, you first call `useAddCourierAnalyticsDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCourierAnalyticsDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCourierAnalyticsDashboardMutation, { data, loading, error }] = useAddCourierAnalyticsDashboardMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      metabaseDashboardId: // value for 'metabaseDashboardId'
 *   },
 * });
 */
export function useAddCourierAnalyticsDashboardMutation(baseOptions?: Apollo.MutationHookOptions<AddCourierAnalyticsDashboardMutation, AddCourierAnalyticsDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCourierAnalyticsDashboardMutation, AddCourierAnalyticsDashboardMutationVariables>(AddCourierAnalyticsDashboardDocument, options);
      }
export type AddCourierAnalyticsDashboardMutationHookResult = ReturnType<typeof useAddCourierAnalyticsDashboardMutation>;
export type AddCourierAnalyticsDashboardMutationResult = Apollo.MutationResult<AddCourierAnalyticsDashboardMutation>;
export type AddCourierAnalyticsDashboardMutationOptions = Apollo.BaseMutationOptions<AddCourierAnalyticsDashboardMutation, AddCourierAnalyticsDashboardMutationVariables>;
export const GetAnalyticsDashboardsDocument = gql`
    query GetAnalyticsDashboards($courierId: ID!) {
  analyticsDashboards(courierId: $courierId) {
    id
    name
    metabaseDashboardId
  }
}
    `;

/**
 * __useGetAnalyticsDashboardsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsDashboardsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetAnalyticsDashboardsQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsDashboardsQuery, GetAnalyticsDashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsDashboardsQuery, GetAnalyticsDashboardsQueryVariables>(GetAnalyticsDashboardsDocument, options);
      }
export function useGetAnalyticsDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsDashboardsQuery, GetAnalyticsDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsDashboardsQuery, GetAnalyticsDashboardsQueryVariables>(GetAnalyticsDashboardsDocument, options);
        }
export type GetAnalyticsDashboardsQueryHookResult = ReturnType<typeof useGetAnalyticsDashboardsQuery>;
export type GetAnalyticsDashboardsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsDashboardsLazyQuery>;
export type GetAnalyticsDashboardsQueryResult = Apollo.QueryResult<GetAnalyticsDashboardsQuery, GetAnalyticsDashboardsQueryVariables>;
export const GetMetabaseJwtTokenDocument = gql`
    query GetMetabaseJwtToken($courierId: ID!) {
  metabaseJwtToken(courierId: $courierId)
}
    `;

/**
 * __useGetMetabaseJwtTokenQuery__
 *
 * To run a query within a React component, call `useGetMetabaseJwtTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetabaseJwtTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetabaseJwtTokenQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetMetabaseJwtTokenQuery(baseOptions: Apollo.QueryHookOptions<GetMetabaseJwtTokenQuery, GetMetabaseJwtTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetabaseJwtTokenQuery, GetMetabaseJwtTokenQueryVariables>(GetMetabaseJwtTokenDocument, options);
      }
export function useGetMetabaseJwtTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetabaseJwtTokenQuery, GetMetabaseJwtTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetabaseJwtTokenQuery, GetMetabaseJwtTokenQueryVariables>(GetMetabaseJwtTokenDocument, options);
        }
export type GetMetabaseJwtTokenQueryHookResult = ReturnType<typeof useGetMetabaseJwtTokenQuery>;
export type GetMetabaseJwtTokenLazyQueryHookResult = ReturnType<typeof useGetMetabaseJwtTokenLazyQuery>;
export type GetMetabaseJwtTokenQueryResult = Apollo.QueryResult<GetMetabaseJwtTokenQuery, GetMetabaseJwtTokenQueryVariables>;
export const CreateDriverQuestionListDocument = gql`
    mutation CreateDriverQuestionList($courierId: ID!, $name: String!, $inAdditionToBase: Boolean) {
  createDriverQuestionList(
    courierId: $courierId
    name: $name
    inAdditionToBase: $inAdditionToBase
  ) {
    ...DriverQuestionListFragment
  }
}
    ${DriverQuestionListFragmentFragmentDoc}`;
export type CreateDriverQuestionListMutationFn = Apollo.MutationFunction<CreateDriverQuestionListMutation, CreateDriverQuestionListMutationVariables>;

/**
 * __useCreateDriverQuestionListMutation__
 *
 * To run a mutation, you first call `useCreateDriverQuestionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverQuestionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverQuestionListMutation, { data, loading, error }] = useCreateDriverQuestionListMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      inAdditionToBase: // value for 'inAdditionToBase'
 *   },
 * });
 */
export function useCreateDriverQuestionListMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverQuestionListMutation, CreateDriverQuestionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverQuestionListMutation, CreateDriverQuestionListMutationVariables>(CreateDriverQuestionListDocument, options);
      }
export type CreateDriverQuestionListMutationHookResult = ReturnType<typeof useCreateDriverQuestionListMutation>;
export type CreateDriverQuestionListMutationResult = Apollo.MutationResult<CreateDriverQuestionListMutation>;
export type CreateDriverQuestionListMutationOptions = Apollo.BaseMutationOptions<CreateDriverQuestionListMutation, CreateDriverQuestionListMutationVariables>;
export const FullUpdateDriverQuestionListDocument = gql`
    mutation FullUpdateDriverQuestionList($courierId: ID!, $id: ID!, $name: String!, $inAdditionToBase: Boolean) {
  fullUpdateDriverQuestionList(
    courierId: $courierId
    id: $id
    name: $name
    inAdditionToBase: $inAdditionToBase
  ) {
    ...DriverQuestionListFragment
  }
}
    ${DriverQuestionListFragmentFragmentDoc}`;
export type FullUpdateDriverQuestionListMutationFn = Apollo.MutationFunction<FullUpdateDriverQuestionListMutation, FullUpdateDriverQuestionListMutationVariables>;

/**
 * __useFullUpdateDriverQuestionListMutation__
 *
 * To run a mutation, you first call `useFullUpdateDriverQuestionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateDriverQuestionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateDriverQuestionListMutation, { data, loading, error }] = useFullUpdateDriverQuestionListMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      inAdditionToBase: // value for 'inAdditionToBase'
 *   },
 * });
 */
export function useFullUpdateDriverQuestionListMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateDriverQuestionListMutation, FullUpdateDriverQuestionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateDriverQuestionListMutation, FullUpdateDriverQuestionListMutationVariables>(FullUpdateDriverQuestionListDocument, options);
      }
export type FullUpdateDriverQuestionListMutationHookResult = ReturnType<typeof useFullUpdateDriverQuestionListMutation>;
export type FullUpdateDriverQuestionListMutationResult = Apollo.MutationResult<FullUpdateDriverQuestionListMutation>;
export type FullUpdateDriverQuestionListMutationOptions = Apollo.BaseMutationOptions<FullUpdateDriverQuestionListMutation, FullUpdateDriverQuestionListMutationVariables>;
export const DeleteDriverQuestionListDocument = gql`
    mutation DeleteDriverQuestionList($courierId: ID!, $id: ID!) {
  deleteDriverQuestionList(courierId: $courierId, id: $id) {
    ...DriverQuestionListFragment
  }
}
    ${DriverQuestionListFragmentFragmentDoc}`;
export type DeleteDriverQuestionListMutationFn = Apollo.MutationFunction<DeleteDriverQuestionListMutation, DeleteDriverQuestionListMutationVariables>;

/**
 * __useDeleteDriverQuestionListMutation__
 *
 * To run a mutation, you first call `useDeleteDriverQuestionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriverQuestionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriverQuestionListMutation, { data, loading, error }] = useDeleteDriverQuestionListMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDriverQuestionListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDriverQuestionListMutation, DeleteDriverQuestionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDriverQuestionListMutation, DeleteDriverQuestionListMutationVariables>(DeleteDriverQuestionListDocument, options);
      }
export type DeleteDriverQuestionListMutationHookResult = ReturnType<typeof useDeleteDriverQuestionListMutation>;
export type DeleteDriverQuestionListMutationResult = Apollo.MutationResult<DeleteDriverQuestionListMutation>;
export type DeleteDriverQuestionListMutationOptions = Apollo.BaseMutationOptions<DeleteDriverQuestionListMutation, DeleteDriverQuestionListMutationVariables>;
export const MarkDriverQuestionListAsBaseDocument = gql`
    mutation MarkDriverQuestionListAsBase($courierId: ID!, $id: ID!, $isBase: Boolean!) {
  markDriverQuestionListAsBase(courierId: $courierId, id: $id, isBase: $isBase) {
    ...DriverQuestionListFragment
  }
}
    ${DriverQuestionListFragmentFragmentDoc}`;
export type MarkDriverQuestionListAsBaseMutationFn = Apollo.MutationFunction<MarkDriverQuestionListAsBaseMutation, MarkDriverQuestionListAsBaseMutationVariables>;

/**
 * __useMarkDriverQuestionListAsBaseMutation__
 *
 * To run a mutation, you first call `useMarkDriverQuestionListAsBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDriverQuestionListAsBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDriverQuestionListAsBaseMutation, { data, loading, error }] = useMarkDriverQuestionListAsBaseMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      isBase: // value for 'isBase'
 *   },
 * });
 */
export function useMarkDriverQuestionListAsBaseMutation(baseOptions?: Apollo.MutationHookOptions<MarkDriverQuestionListAsBaseMutation, MarkDriverQuestionListAsBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDriverQuestionListAsBaseMutation, MarkDriverQuestionListAsBaseMutationVariables>(MarkDriverQuestionListAsBaseDocument, options);
      }
export type MarkDriverQuestionListAsBaseMutationHookResult = ReturnType<typeof useMarkDriverQuestionListAsBaseMutation>;
export type MarkDriverQuestionListAsBaseMutationResult = Apollo.MutationResult<MarkDriverQuestionListAsBaseMutation>;
export type MarkDriverQuestionListAsBaseMutationOptions = Apollo.BaseMutationOptions<MarkDriverQuestionListAsBaseMutation, MarkDriverQuestionListAsBaseMutationVariables>;
export const CreateDriverQuestionDocument = gql`
    mutation CreateDriverQuestion($courierId: ID!, $input: DriverQuestionCreate!) {
  createDriverQuestion(courierId: $courierId, input: $input) {
    ...DriverQuestionFragment
  }
}
    ${DriverQuestionFragmentFragmentDoc}`;
export type CreateDriverQuestionMutationFn = Apollo.MutationFunction<CreateDriverQuestionMutation, CreateDriverQuestionMutationVariables>;

/**
 * __useCreateDriverQuestionMutation__
 *
 * To run a mutation, you first call `useCreateDriverQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverQuestionMutation, { data, loading, error }] = useCreateDriverQuestionMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDriverQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverQuestionMutation, CreateDriverQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverQuestionMutation, CreateDriverQuestionMutationVariables>(CreateDriverQuestionDocument, options);
      }
export type CreateDriverQuestionMutationHookResult = ReturnType<typeof useCreateDriverQuestionMutation>;
export type CreateDriverQuestionMutationResult = Apollo.MutationResult<CreateDriverQuestionMutation>;
export type CreateDriverQuestionMutationOptions = Apollo.BaseMutationOptions<CreateDriverQuestionMutation, CreateDriverQuestionMutationVariables>;
export const FullUpdateDriverQuestionDocument = gql`
    mutation FullUpdateDriverQuestion($courierId: ID!, $input: DriverQuestionUpdate!) {
  fullUpdateDriverQuestion(courierId: $courierId, input: $input) {
    ...DriverQuestionFragment
  }
}
    ${DriverQuestionFragmentFragmentDoc}`;
export type FullUpdateDriverQuestionMutationFn = Apollo.MutationFunction<FullUpdateDriverQuestionMutation, FullUpdateDriverQuestionMutationVariables>;

/**
 * __useFullUpdateDriverQuestionMutation__
 *
 * To run a mutation, you first call `useFullUpdateDriverQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateDriverQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateDriverQuestionMutation, { data, loading, error }] = useFullUpdateDriverQuestionMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFullUpdateDriverQuestionMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateDriverQuestionMutation, FullUpdateDriverQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateDriverQuestionMutation, FullUpdateDriverQuestionMutationVariables>(FullUpdateDriverQuestionDocument, options);
      }
export type FullUpdateDriverQuestionMutationHookResult = ReturnType<typeof useFullUpdateDriverQuestionMutation>;
export type FullUpdateDriverQuestionMutationResult = Apollo.MutationResult<FullUpdateDriverQuestionMutation>;
export type FullUpdateDriverQuestionMutationOptions = Apollo.BaseMutationOptions<FullUpdateDriverQuestionMutation, FullUpdateDriverQuestionMutationVariables>;
export const DeleteDriverQuestionDocument = gql`
    mutation DeleteDriverQuestion($courierId: ID!, $id: ID!) {
  deleteDriverQuestion(courierId: $courierId, id: $id) {
    ...DriverQuestionFragment
  }
}
    ${DriverQuestionFragmentFragmentDoc}`;
export type DeleteDriverQuestionMutationFn = Apollo.MutationFunction<DeleteDriverQuestionMutation, DeleteDriverQuestionMutationVariables>;

/**
 * __useDeleteDriverQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteDriverQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriverQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriverQuestionMutation, { data, loading, error }] = useDeleteDriverQuestionMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDriverQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDriverQuestionMutation, DeleteDriverQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDriverQuestionMutation, DeleteDriverQuestionMutationVariables>(DeleteDriverQuestionDocument, options);
      }
export type DeleteDriverQuestionMutationHookResult = ReturnType<typeof useDeleteDriverQuestionMutation>;
export type DeleteDriverQuestionMutationResult = Apollo.MutationResult<DeleteDriverQuestionMutation>;
export type DeleteDriverQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteDriverQuestionMutation, DeleteDriverQuestionMutationVariables>;
export const SetDriverQuestionsSequenceDocument = gql`
    mutation SetDriverQuestionsSequence($courierId: ID!, $questionIds: [ID!]!) {
  setDriverQuestionsSequence(courierId: $courierId, questionIds: $questionIds) {
    ...DriverQuestionFragment
  }
}
    ${DriverQuestionFragmentFragmentDoc}`;
export type SetDriverQuestionsSequenceMutationFn = Apollo.MutationFunction<SetDriverQuestionsSequenceMutation, SetDriverQuestionsSequenceMutationVariables>;

/**
 * __useSetDriverQuestionsSequenceMutation__
 *
 * To run a mutation, you first call `useSetDriverQuestionsSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDriverQuestionsSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDriverQuestionsSequenceMutation, { data, loading, error }] = useSetDriverQuestionsSequenceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function useSetDriverQuestionsSequenceMutation(baseOptions?: Apollo.MutationHookOptions<SetDriverQuestionsSequenceMutation, SetDriverQuestionsSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDriverQuestionsSequenceMutation, SetDriverQuestionsSequenceMutationVariables>(SetDriverQuestionsSequenceDocument, options);
      }
export type SetDriverQuestionsSequenceMutationHookResult = ReturnType<typeof useSetDriverQuestionsSequenceMutation>;
export type SetDriverQuestionsSequenceMutationResult = Apollo.MutationResult<SetDriverQuestionsSequenceMutation>;
export type SetDriverQuestionsSequenceMutationOptions = Apollo.BaseMutationOptions<SetDriverQuestionsSequenceMutation, SetDriverQuestionsSequenceMutationVariables>;
export const DriverAnswersByShipmentIdsDocument = gql`
    query DriverAnswersByShipmentIds($courierId: ID!, $shipmentIds: [ID!]!) {
  driverAnswersByShipmentIds(courierId: $courierId, shipmentIds: $shipmentIds) {
    stop {
      id
      type
      streetAddress
    }
    answers {
      id
      answerText
      answerNumber
      answerPhotoUrl
      question {
        id
        question
        type
      }
    }
  }
}
    `;

/**
 * __useDriverAnswersByShipmentIdsQuery__
 *
 * To run a query within a React component, call `useDriverAnswersByShipmentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverAnswersByShipmentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverAnswersByShipmentIdsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useDriverAnswersByShipmentIdsQuery(baseOptions: Apollo.QueryHookOptions<DriverAnswersByShipmentIdsQuery, DriverAnswersByShipmentIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverAnswersByShipmentIdsQuery, DriverAnswersByShipmentIdsQueryVariables>(DriverAnswersByShipmentIdsDocument, options);
      }
export function useDriverAnswersByShipmentIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverAnswersByShipmentIdsQuery, DriverAnswersByShipmentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverAnswersByShipmentIdsQuery, DriverAnswersByShipmentIdsQueryVariables>(DriverAnswersByShipmentIdsDocument, options);
        }
export type DriverAnswersByShipmentIdsQueryHookResult = ReturnType<typeof useDriverAnswersByShipmentIdsQuery>;
export type DriverAnswersByShipmentIdsLazyQueryHookResult = ReturnType<typeof useDriverAnswersByShipmentIdsLazyQuery>;
export type DriverAnswersByShipmentIdsQueryResult = Apollo.QueryResult<DriverAnswersByShipmentIdsQuery, DriverAnswersByShipmentIdsQueryVariables>;
export const DriverQuestionListsDocument = gql`
    query DriverQuestionLists($courierId: ID!) {
  driverQuestionLists(courierId: $courierId) {
    ...DriverQuestionListFragment
  }
}
    ${DriverQuestionListFragmentFragmentDoc}`;

/**
 * __useDriverQuestionListsQuery__
 *
 * To run a query within a React component, call `useDriverQuestionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverQuestionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverQuestionListsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useDriverQuestionListsQuery(baseOptions: Apollo.QueryHookOptions<DriverQuestionListsQuery, DriverQuestionListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverQuestionListsQuery, DriverQuestionListsQueryVariables>(DriverQuestionListsDocument, options);
      }
export function useDriverQuestionListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverQuestionListsQuery, DriverQuestionListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverQuestionListsQuery, DriverQuestionListsQueryVariables>(DriverQuestionListsDocument, options);
        }
export type DriverQuestionListsQueryHookResult = ReturnType<typeof useDriverQuestionListsQuery>;
export type DriverQuestionListsLazyQueryHookResult = ReturnType<typeof useDriverQuestionListsLazyQuery>;
export type DriverQuestionListsQueryResult = Apollo.QueryResult<DriverQuestionListsQuery, DriverQuestionListsQueryVariables>;
export const DriverQuestionsInListDocument = gql`
    query DriverQuestionsInList($courierId: ID!, $listId: ID!) {
  driverQuestionsInList(courierId: $courierId, listId: $listId) {
    ...DriverQuestionFragment
    serviceTypes {
      ...ServiceTypeFragment
    }
    packageTypes {
      ...PackageTypeFragment
    }
    stopLabels {
      ...LabelFragment
    }
  }
}
    ${DriverQuestionFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${PackageTypeFragmentFragmentDoc}
${LabelFragmentFragmentDoc}`;

/**
 * __useDriverQuestionsInListQuery__
 *
 * To run a query within a React component, call `useDriverQuestionsInListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverQuestionsInListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverQuestionsInListQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useDriverQuestionsInListQuery(baseOptions: Apollo.QueryHookOptions<DriverQuestionsInListQuery, DriverQuestionsInListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverQuestionsInListQuery, DriverQuestionsInListQueryVariables>(DriverQuestionsInListDocument, options);
      }
export function useDriverQuestionsInListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverQuestionsInListQuery, DriverQuestionsInListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverQuestionsInListQuery, DriverQuestionsInListQueryVariables>(DriverQuestionsInListDocument, options);
        }
export type DriverQuestionsInListQueryHookResult = ReturnType<typeof useDriverQuestionsInListQuery>;
export type DriverQuestionsInListLazyQueryHookResult = ReturnType<typeof useDriverQuestionsInListLazyQuery>;
export type DriverQuestionsInListQueryResult = Apollo.QueryResult<DriverQuestionsInListQuery, DriverQuestionsInListQueryVariables>;
export const FullUpdateLabelDocument = gql`
    mutation FullUpdateLabel($courierId: ID!, $labelId: ID!, $name: String!) {
  fullUpdateLabel(courierId: $courierId, labelId: $labelId, name: $name) {
    id
    courierId
    entityType
    name
    color
  }
}
    `;
export type FullUpdateLabelMutationFn = Apollo.MutationFunction<FullUpdateLabelMutation, FullUpdateLabelMutationVariables>;

/**
 * __useFullUpdateLabelMutation__
 *
 * To run a mutation, you first call `useFullUpdateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateLabelMutation, { data, loading, error }] = useFullUpdateLabelMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      labelId: // value for 'labelId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFullUpdateLabelMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateLabelMutation, FullUpdateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateLabelMutation, FullUpdateLabelMutationVariables>(FullUpdateLabelDocument, options);
      }
export type FullUpdateLabelMutationHookResult = ReturnType<typeof useFullUpdateLabelMutation>;
export type FullUpdateLabelMutationResult = Apollo.MutationResult<FullUpdateLabelMutation>;
export type FullUpdateLabelMutationOptions = Apollo.BaseMutationOptions<FullUpdateLabelMutation, FullUpdateLabelMutationVariables>;
export const DeleteLabelDocument = gql`
    mutation DeleteLabel($courierId: ID!, $labelId: ID!) {
  deleteLabel(courierId: $courierId, labelId: $labelId)
}
    `;
export type DeleteLabelMutationFn = Apollo.MutationFunction<DeleteLabelMutation, DeleteLabelMutationVariables>;

/**
 * __useDeleteLabelMutation__
 *
 * To run a mutation, you first call `useDeleteLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLabelMutation, { data, loading, error }] = useDeleteLabelMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useDeleteLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLabelMutation, DeleteLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLabelMutation, DeleteLabelMutationVariables>(DeleteLabelDocument, options);
      }
export type DeleteLabelMutationHookResult = ReturnType<typeof useDeleteLabelMutation>;
export type DeleteLabelMutationResult = Apollo.MutationResult<DeleteLabelMutation>;
export type DeleteLabelMutationOptions = Apollo.BaseMutationOptions<DeleteLabelMutation, DeleteLabelMutationVariables>;
export const GetAllLabelsDocument = gql`
    query GetAllLabels($courierId: ID!) {
  labels(courierId: $courierId) {
    id
    courierId
    entityType
    name
    color
  }
}
    `;

/**
 * __useGetAllLabelsQuery__
 *
 * To run a query within a React component, call `useGetAllLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLabelsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetAllLabelsQuery(baseOptions: Apollo.QueryHookOptions<GetAllLabelsQuery, GetAllLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLabelsQuery, GetAllLabelsQueryVariables>(GetAllLabelsDocument, options);
      }
export function useGetAllLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLabelsQuery, GetAllLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLabelsQuery, GetAllLabelsQueryVariables>(GetAllLabelsDocument, options);
        }
export type GetAllLabelsQueryHookResult = ReturnType<typeof useGetAllLabelsQuery>;
export type GetAllLabelsLazyQueryHookResult = ReturnType<typeof useGetAllLabelsLazyQuery>;
export type GetAllLabelsQueryResult = Apollo.QueryResult<GetAllLabelsQuery, GetAllLabelsQueryVariables>;
export const CreateLocationScanCodeDocument = gql`
    mutation CreateLocationScanCode($courierId: ID!, $code: String!, $locationId: ID!, $suite: String, $requirementType: LocationScanRequirement, $description: String, $createdBy: String!) {
  createLocationScanCode(
    courierId: $courierId
    code: $code
    locationId: $locationId
    suite: $suite
    requirementType: $requirementType
    description: $description
    createdBy: $createdBy
  ) {
    ...LocationScanCodeFragment
  }
}
    ${LocationScanCodeFragmentFragmentDoc}`;
export type CreateLocationScanCodeMutationFn = Apollo.MutationFunction<CreateLocationScanCodeMutation, CreateLocationScanCodeMutationVariables>;

/**
 * __useCreateLocationScanCodeMutation__
 *
 * To run a mutation, you first call `useCreateLocationScanCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationScanCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationScanCodeMutation, { data, loading, error }] = useCreateLocationScanCodeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      code: // value for 'code'
 *      locationId: // value for 'locationId'
 *      suite: // value for 'suite'
 *      requirementType: // value for 'requirementType'
 *      description: // value for 'description'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreateLocationScanCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationScanCodeMutation, CreateLocationScanCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationScanCodeMutation, CreateLocationScanCodeMutationVariables>(CreateLocationScanCodeDocument, options);
      }
export type CreateLocationScanCodeMutationHookResult = ReturnType<typeof useCreateLocationScanCodeMutation>;
export type CreateLocationScanCodeMutationResult = Apollo.MutationResult<CreateLocationScanCodeMutation>;
export type CreateLocationScanCodeMutationOptions = Apollo.BaseMutationOptions<CreateLocationScanCodeMutation, CreateLocationScanCodeMutationVariables>;
export const FullUpdateLocationScanCodeDocument = gql`
    mutation FullUpdateLocationScanCode($courierId: ID, $id: ID!, $code: String!, $locationId: ID!, $suite: String, $requirementType: LocationScanRequirement, $description: String) {
  fullUpdateLocationScanCode(
    courierId: $courierId
    id: $id
    code: $code
    locationId: $locationId
    suite: $suite
    requirementType: $requirementType
    description: $description
  ) {
    ...LocationScanCodeFragment
  }
}
    ${LocationScanCodeFragmentFragmentDoc}`;
export type FullUpdateLocationScanCodeMutationFn = Apollo.MutationFunction<FullUpdateLocationScanCodeMutation, FullUpdateLocationScanCodeMutationVariables>;

/**
 * __useFullUpdateLocationScanCodeMutation__
 *
 * To run a mutation, you first call `useFullUpdateLocationScanCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateLocationScanCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateLocationScanCodeMutation, { data, loading, error }] = useFullUpdateLocationScanCodeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      locationId: // value for 'locationId'
 *      suite: // value for 'suite'
 *      requirementType: // value for 'requirementType'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useFullUpdateLocationScanCodeMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateLocationScanCodeMutation, FullUpdateLocationScanCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateLocationScanCodeMutation, FullUpdateLocationScanCodeMutationVariables>(FullUpdateLocationScanCodeDocument, options);
      }
export type FullUpdateLocationScanCodeMutationHookResult = ReturnType<typeof useFullUpdateLocationScanCodeMutation>;
export type FullUpdateLocationScanCodeMutationResult = Apollo.MutationResult<FullUpdateLocationScanCodeMutation>;
export type FullUpdateLocationScanCodeMutationOptions = Apollo.BaseMutationOptions<FullUpdateLocationScanCodeMutation, FullUpdateLocationScanCodeMutationVariables>;
export const DeleteLocationScanCodeDocument = gql`
    mutation DeleteLocationScanCode($courierId: ID, $id: ID!) {
  deleteLocationScanCode(courierId: $courierId, id: $id) {
    ...LocationScanCodeFragment
  }
}
    ${LocationScanCodeFragmentFragmentDoc}`;
export type DeleteLocationScanCodeMutationFn = Apollo.MutationFunction<DeleteLocationScanCodeMutation, DeleteLocationScanCodeMutationVariables>;

/**
 * __useDeleteLocationScanCodeMutation__
 *
 * To run a mutation, you first call `useDeleteLocationScanCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationScanCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationScanCodeMutation, { data, loading, error }] = useDeleteLocationScanCodeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationScanCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationScanCodeMutation, DeleteLocationScanCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationScanCodeMutation, DeleteLocationScanCodeMutationVariables>(DeleteLocationScanCodeDocument, options);
      }
export type DeleteLocationScanCodeMutationHookResult = ReturnType<typeof useDeleteLocationScanCodeMutation>;
export type DeleteLocationScanCodeMutationResult = Apollo.MutationResult<DeleteLocationScanCodeMutation>;
export type DeleteLocationScanCodeMutationOptions = Apollo.BaseMutationOptions<DeleteLocationScanCodeMutation, DeleteLocationScanCodeMutationVariables>;
export const UpdateLocationScanCodeEndCustomerIdsDocument = gql`
    mutation UpdateLocationScanCodeEndCustomerIds($courierId: ID, $id: ID!, $customerIds: [ID!]) {
  updateLocationScanCodeEndCustomerIds(
    courierId: $courierId
    id: $id
    customerIds: $customerIds
  ) {
    ...LocationScanCodeFragment
  }
}
    ${LocationScanCodeFragmentFragmentDoc}`;
export type UpdateLocationScanCodeEndCustomerIdsMutationFn = Apollo.MutationFunction<UpdateLocationScanCodeEndCustomerIdsMutation, UpdateLocationScanCodeEndCustomerIdsMutationVariables>;

/**
 * __useUpdateLocationScanCodeEndCustomerIdsMutation__
 *
 * To run a mutation, you first call `useUpdateLocationScanCodeEndCustomerIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationScanCodeEndCustomerIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationScanCodeEndCustomerIdsMutation, { data, loading, error }] = useUpdateLocationScanCodeEndCustomerIdsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useUpdateLocationScanCodeEndCustomerIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationScanCodeEndCustomerIdsMutation, UpdateLocationScanCodeEndCustomerIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationScanCodeEndCustomerIdsMutation, UpdateLocationScanCodeEndCustomerIdsMutationVariables>(UpdateLocationScanCodeEndCustomerIdsDocument, options);
      }
export type UpdateLocationScanCodeEndCustomerIdsMutationHookResult = ReturnType<typeof useUpdateLocationScanCodeEndCustomerIdsMutation>;
export type UpdateLocationScanCodeEndCustomerIdsMutationResult = Apollo.MutationResult<UpdateLocationScanCodeEndCustomerIdsMutation>;
export type UpdateLocationScanCodeEndCustomerIdsMutationOptions = Apollo.BaseMutationOptions<UpdateLocationScanCodeEndCustomerIdsMutation, UpdateLocationScanCodeEndCustomerIdsMutationVariables>;
export const LocationScanCodesPaginatedDocument = gql`
    query LocationScanCodesPaginated($courierId: ID!, $after: Int, $limit: Int, $requirementTypeFilter: LocationScanRequirement, $endCustomerIdsFilter: [ID!], $sortFields: [LocationScanCodesSorting!]) {
  locationScanCodesPaginated(
    courierId: $courierId
    after: $after
    limit: $limit
    requirementTypeFilter: $requirementTypeFilter
    endCustomerIdsFilter: $endCustomerIdsFilter
    sortFields: $sortFields
  ) {
    edges {
      node {
        ...LocationScanCodeFragment
        endCustomers {
          ...EndCustomerFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${LocationScanCodeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useLocationScanCodesPaginatedQuery__
 *
 * To run a query within a React component, call `useLocationScanCodesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationScanCodesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationScanCodesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      requirementTypeFilter: // value for 'requirementTypeFilter'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useLocationScanCodesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<LocationScanCodesPaginatedQuery, LocationScanCodesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationScanCodesPaginatedQuery, LocationScanCodesPaginatedQueryVariables>(LocationScanCodesPaginatedDocument, options);
      }
export function useLocationScanCodesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationScanCodesPaginatedQuery, LocationScanCodesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationScanCodesPaginatedQuery, LocationScanCodesPaginatedQueryVariables>(LocationScanCodesPaginatedDocument, options);
        }
export type LocationScanCodesPaginatedQueryHookResult = ReturnType<typeof useLocationScanCodesPaginatedQuery>;
export type LocationScanCodesPaginatedLazyQueryHookResult = ReturnType<typeof useLocationScanCodesPaginatedLazyQuery>;
export type LocationScanCodesPaginatedQueryResult = Apollo.QueryResult<LocationScanCodesPaginatedQuery, LocationScanCodesPaginatedQueryVariables>;
export const OverrideOrderMilesDocument = gql`
    mutation overrideOrderMiles($courierId: ID!, $orderId: ID!, $milesOverride: Float) {
  overrideOrderMiles(
    courierId: $courierId
    orderId: $orderId
    milesOverride: $milesOverride
  ) {
    id
    milesOverride
  }
}
    `;
export type OverrideOrderMilesMutationFn = Apollo.MutationFunction<OverrideOrderMilesMutation, OverrideOrderMilesMutationVariables>;

/**
 * __useOverrideOrderMilesMutation__
 *
 * To run a mutation, you first call `useOverrideOrderMilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideOrderMilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideOrderMilesMutation, { data, loading, error }] = useOverrideOrderMilesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *      milesOverride: // value for 'milesOverride'
 *   },
 * });
 */
export function useOverrideOrderMilesMutation(baseOptions?: Apollo.MutationHookOptions<OverrideOrderMilesMutation, OverrideOrderMilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideOrderMilesMutation, OverrideOrderMilesMutationVariables>(OverrideOrderMilesDocument, options);
      }
export type OverrideOrderMilesMutationHookResult = ReturnType<typeof useOverrideOrderMilesMutation>;
export type OverrideOrderMilesMutationResult = Apollo.MutationResult<OverrideOrderMilesMutation>;
export type OverrideOrderMilesMutationOptions = Apollo.BaseMutationOptions<OverrideOrderMilesMutation, OverrideOrderMilesMutationVariables>;
export const GetPackagesPaginatedDocument = gql`
    query GetPackagesPaginated($courierId: ID!, $shipmentIds: [ID!], $statuses: [PackageStatus!], $start: Int, $limit: Int) {
  packagesPaginated(
    courierId: $courierId
    shipmentIds: $shipmentIds
    statuses: $statuses
    start: $start
    limit: $limit
  ) {
    edges {
      node {
        ...PackageFragment
        events {
          ...PackageEventFragment
          eventByDriver {
            ...DriverFragment
          }
          packageEventType {
            ...PackageEventTypeFragment
          }
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PackageFragmentFragmentDoc}
${PackageEventFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${PackageEventTypeFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetPackagesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetPackagesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *      statuses: // value for 'statuses'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPackagesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetPackagesPaginatedQuery, GetPackagesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagesPaginatedQuery, GetPackagesPaginatedQueryVariables>(GetPackagesPaginatedDocument, options);
      }
export function useGetPackagesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagesPaginatedQuery, GetPackagesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagesPaginatedQuery, GetPackagesPaginatedQueryVariables>(GetPackagesPaginatedDocument, options);
        }
export type GetPackagesPaginatedQueryHookResult = ReturnType<typeof useGetPackagesPaginatedQuery>;
export type GetPackagesPaginatedLazyQueryHookResult = ReturnType<typeof useGetPackagesPaginatedLazyQuery>;
export type GetPackagesPaginatedQueryResult = Apollo.QueryResult<GetPackagesPaginatedQuery, GetPackagesPaginatedQueryVariables>;
export const CreatePartnerDocument = gql`
    mutation CreatePartner($id: String!, $name: String!, $associatedCourierIds: [String!]!) {
  createPartner(id: $id, name: $name, associatedCourierIds: $associatedCourierIds) {
    id
    name
    apiKey
  }
}
    `;
export type CreatePartnerMutationFn = Apollo.MutationFunction<CreatePartnerMutation, CreatePartnerMutationVariables>;

/**
 * __useCreatePartnerMutation__
 *
 * To run a mutation, you first call `useCreatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerMutation, { data, loading, error }] = useCreatePartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      associatedCourierIds: // value for 'associatedCourierIds'
 *   },
 * });
 */
export function useCreatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerMutation, CreatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerMutation, CreatePartnerMutationVariables>(CreatePartnerDocument, options);
      }
export type CreatePartnerMutationHookResult = ReturnType<typeof useCreatePartnerMutation>;
export type CreatePartnerMutationResult = Apollo.MutationResult<CreatePartnerMutation>;
export type CreatePartnerMutationOptions = Apollo.BaseMutationOptions<CreatePartnerMutation, CreatePartnerMutationVariables>;
export const PartnersDocument = gql`
    query Partners {
  partners {
    id
    name
    apiKey
    courierIds
  }
}
    `;

/**
 * __usePartnersQuery__
 *
 * To run a query within a React component, call `usePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnersQuery(baseOptions?: Apollo.QueryHookOptions<PartnersQuery, PartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnersQuery, PartnersQueryVariables>(PartnersDocument, options);
      }
export function usePartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnersQuery, PartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnersQuery, PartnersQueryVariables>(PartnersDocument, options);
        }
export type PartnersQueryHookResult = ReturnType<typeof usePartnersQuery>;
export type PartnersLazyQueryHookResult = ReturnType<typeof usePartnersLazyQuery>;
export type PartnersQueryResult = Apollo.QueryResult<PartnersQuery, PartnersQueryVariables>;
export const GetCouriersForPartnersDocument = gql`
    query GetCouriersForPartners {
  couriers {
    id
    name
    externalId
  }
}
    `;

/**
 * __useGetCouriersForPartnersQuery__
 *
 * To run a query within a React component, call `useGetCouriersForPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouriersForPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouriersForPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCouriersForPartnersQuery(baseOptions?: Apollo.QueryHookOptions<GetCouriersForPartnersQuery, GetCouriersForPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouriersForPartnersQuery, GetCouriersForPartnersQueryVariables>(GetCouriersForPartnersDocument, options);
      }
export function useGetCouriersForPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouriersForPartnersQuery, GetCouriersForPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouriersForPartnersQuery, GetCouriersForPartnersQueryVariables>(GetCouriersForPartnersDocument, options);
        }
export type GetCouriersForPartnersQueryHookResult = ReturnType<typeof useGetCouriersForPartnersQuery>;
export type GetCouriersForPartnersLazyQueryHookResult = ReturnType<typeof useGetCouriersForPartnersLazyQuery>;
export type GetCouriersForPartnersQueryResult = Apollo.QueryResult<GetCouriersForPartnersQuery, GetCouriersForPartnersQueryVariables>;
export const CreatePackageEventTypeDocument = gql`
    mutation CreatePackageEventType($courierId: ID!, $name: String!, $action: PackageEventPostAction!, $packageScanNewPackageHandleType: PackageScanNewPackageHandleType!, $reassignDriverId: ID, $driverAssignmentValidationType: DriverAssignmentValidationType) {
  createPackageEventType(
    courierId: $courierId
    name: $name
    action: $action
    packageScanNewPackageHandleType: $packageScanNewPackageHandleType
    reassignDriverId: $reassignDriverId
    driverAssignmentValidationType: $driverAssignmentValidationType
  ) {
    ...PackageEventTypeFragment
  }
}
    ${PackageEventTypeFragmentFragmentDoc}`;
export type CreatePackageEventTypeMutationFn = Apollo.MutationFunction<CreatePackageEventTypeMutation, CreatePackageEventTypeMutationVariables>;

/**
 * __useCreatePackageEventTypeMutation__
 *
 * To run a mutation, you first call `useCreatePackageEventTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageEventTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageEventTypeMutation, { data, loading, error }] = useCreatePackageEventTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      action: // value for 'action'
 *      packageScanNewPackageHandleType: // value for 'packageScanNewPackageHandleType'
 *      reassignDriverId: // value for 'reassignDriverId'
 *      driverAssignmentValidationType: // value for 'driverAssignmentValidationType'
 *   },
 * });
 */
export function useCreatePackageEventTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageEventTypeMutation, CreatePackageEventTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageEventTypeMutation, CreatePackageEventTypeMutationVariables>(CreatePackageEventTypeDocument, options);
      }
export type CreatePackageEventTypeMutationHookResult = ReturnType<typeof useCreatePackageEventTypeMutation>;
export type CreatePackageEventTypeMutationResult = Apollo.MutationResult<CreatePackageEventTypeMutation>;
export type CreatePackageEventTypeMutationOptions = Apollo.BaseMutationOptions<CreatePackageEventTypeMutation, CreatePackageEventTypeMutationVariables>;
export const FullUpdatePackageEventTypeDocument = gql`
    mutation FullUpdatePackageEventType($courierId: ID!, $id: ID!, $name: String!, $action: PackageEventPostAction!, $packageScanNewPackageHandleType: PackageScanNewPackageHandleType!, $reassignDriverId: ID, $driverAssignmentValidationType: DriverAssignmentValidationType) {
  fullUpdatePackageEventType(
    courierId: $courierId
    id: $id
    name: $name
    action: $action
    packageScanNewPackageHandleType: $packageScanNewPackageHandleType
    reassignDriverId: $reassignDriverId
    driverAssignmentValidationType: $driverAssignmentValidationType
  ) {
    ...PackageEventTypeFragment
  }
}
    ${PackageEventTypeFragmentFragmentDoc}`;
export type FullUpdatePackageEventTypeMutationFn = Apollo.MutationFunction<FullUpdatePackageEventTypeMutation, FullUpdatePackageEventTypeMutationVariables>;

/**
 * __useFullUpdatePackageEventTypeMutation__
 *
 * To run a mutation, you first call `useFullUpdatePackageEventTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdatePackageEventTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdatePackageEventTypeMutation, { data, loading, error }] = useFullUpdatePackageEventTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      action: // value for 'action'
 *      packageScanNewPackageHandleType: // value for 'packageScanNewPackageHandleType'
 *      reassignDriverId: // value for 'reassignDriverId'
 *      driverAssignmentValidationType: // value for 'driverAssignmentValidationType'
 *   },
 * });
 */
export function useFullUpdatePackageEventTypeMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdatePackageEventTypeMutation, FullUpdatePackageEventTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdatePackageEventTypeMutation, FullUpdatePackageEventTypeMutationVariables>(FullUpdatePackageEventTypeDocument, options);
      }
export type FullUpdatePackageEventTypeMutationHookResult = ReturnType<typeof useFullUpdatePackageEventTypeMutation>;
export type FullUpdatePackageEventTypeMutationResult = Apollo.MutationResult<FullUpdatePackageEventTypeMutation>;
export type FullUpdatePackageEventTypeMutationOptions = Apollo.BaseMutationOptions<FullUpdatePackageEventTypeMutation, FullUpdatePackageEventTypeMutationVariables>;
export const DeletePackageEventTypeDocument = gql`
    mutation DeletePackageEventType($courierId: ID!, $id: ID!) {
  deletePackageEventType(courierId: $courierId, id: $id) {
    ...PackageEventTypeFragment
  }
}
    ${PackageEventTypeFragmentFragmentDoc}`;
export type DeletePackageEventTypeMutationFn = Apollo.MutationFunction<DeletePackageEventTypeMutation, DeletePackageEventTypeMutationVariables>;

/**
 * __useDeletePackageEventTypeMutation__
 *
 * To run a mutation, you first call `useDeletePackageEventTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageEventTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageEventTypeMutation, { data, loading, error }] = useDeletePackageEventTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePackageEventTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageEventTypeMutation, DeletePackageEventTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageEventTypeMutation, DeletePackageEventTypeMutationVariables>(DeletePackageEventTypeDocument, options);
      }
export type DeletePackageEventTypeMutationHookResult = ReturnType<typeof useDeletePackageEventTypeMutation>;
export type DeletePackageEventTypeMutationResult = Apollo.MutationResult<DeletePackageEventTypeMutation>;
export type DeletePackageEventTypeMutationOptions = Apollo.BaseMutationOptions<DeletePackageEventTypeMutation, DeletePackageEventTypeMutationVariables>;
export const GetPackageEventTypesDocument = gql`
    query GetPackageEventTypes($courierId: ID!) {
  packageEventTypes(courierId: $courierId) {
    ...PackageEventTypeFragment
    reassignDriver {
      ...DriverFragment
    }
  }
}
    ${PackageEventTypeFragmentFragmentDoc}
${DriverFragmentFragmentDoc}`;

/**
 * __useGetPackageEventTypesQuery__
 *
 * To run a query within a React component, call `useGetPackageEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageEventTypesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetPackageEventTypesQuery(baseOptions: Apollo.QueryHookOptions<GetPackageEventTypesQuery, GetPackageEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageEventTypesQuery, GetPackageEventTypesQueryVariables>(GetPackageEventTypesDocument, options);
      }
export function useGetPackageEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageEventTypesQuery, GetPackageEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageEventTypesQuery, GetPackageEventTypesQueryVariables>(GetPackageEventTypesDocument, options);
        }
export type GetPackageEventTypesQueryHookResult = ReturnType<typeof useGetPackageEventTypesQuery>;
export type GetPackageEventTypesLazyQueryHookResult = ReturnType<typeof useGetPackageEventTypesLazyQuery>;
export type GetPackageEventTypesQueryResult = Apollo.QueryResult<GetPackageEventTypesQuery, GetPackageEventTypesQueryVariables>;
export const UpsertCourierOfflineSettingsDocument = gql`
    mutation UpsertCourierOfflineSettings($courierId: ID!, $podValidation: OfflineValidationMode!, $scanValidation: OfflineValidationMode!, $gpsValidation: OfflineValidationMode!, $locationScanValidation: OfflineValidationMode!, $questionValidation: OfflineValidationMode!) {
  upsertCourierOfflineSettings(
    courierId: $courierId
    podValidation: $podValidation
    scanValidation: $scanValidation
    gpsValidation: $gpsValidation
    locationScanValidation: $locationScanValidation
    questionValidation: $questionValidation
  ) {
    ...CourierOfflineSettingsFragment
  }
}
    ${CourierOfflineSettingsFragmentFragmentDoc}`;
export type UpsertCourierOfflineSettingsMutationFn = Apollo.MutationFunction<UpsertCourierOfflineSettingsMutation, UpsertCourierOfflineSettingsMutationVariables>;

/**
 * __useUpsertCourierOfflineSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertCourierOfflineSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCourierOfflineSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCourierOfflineSettingsMutation, { data, loading, error }] = useUpsertCourierOfflineSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      podValidation: // value for 'podValidation'
 *      scanValidation: // value for 'scanValidation'
 *      gpsValidation: // value for 'gpsValidation'
 *      locationScanValidation: // value for 'locationScanValidation'
 *      questionValidation: // value for 'questionValidation'
 *   },
 * });
 */
export function useUpsertCourierOfflineSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCourierOfflineSettingsMutation, UpsertCourierOfflineSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCourierOfflineSettingsMutation, UpsertCourierOfflineSettingsMutationVariables>(UpsertCourierOfflineSettingsDocument, options);
      }
export type UpsertCourierOfflineSettingsMutationHookResult = ReturnType<typeof useUpsertCourierOfflineSettingsMutation>;
export type UpsertCourierOfflineSettingsMutationResult = Apollo.MutationResult<UpsertCourierOfflineSettingsMutation>;
export type UpsertCourierOfflineSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertCourierOfflineSettingsMutation, UpsertCourierOfflineSettingsMutationVariables>;
export const CourierOfflineSettingsDocument = gql`
    query CourierOfflineSettings($courierId: ID!) {
  courierOfflineSettings(courierId: $courierId) {
    ...CourierOfflineSettingsFragment
  }
}
    ${CourierOfflineSettingsFragmentFragmentDoc}`;

/**
 * __useCourierOfflineSettingsQuery__
 *
 * To run a query within a React component, call `useCourierOfflineSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourierOfflineSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourierOfflineSettingsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useCourierOfflineSettingsQuery(baseOptions: Apollo.QueryHookOptions<CourierOfflineSettingsQuery, CourierOfflineSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourierOfflineSettingsQuery, CourierOfflineSettingsQueryVariables>(CourierOfflineSettingsDocument, options);
      }
export function useCourierOfflineSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourierOfflineSettingsQuery, CourierOfflineSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourierOfflineSettingsQuery, CourierOfflineSettingsQueryVariables>(CourierOfflineSettingsDocument, options);
        }
export type CourierOfflineSettingsQueryHookResult = ReturnType<typeof useCourierOfflineSettingsQuery>;
export type CourierOfflineSettingsLazyQueryHookResult = ReturnType<typeof useCourierOfflineSettingsLazyQuery>;
export type CourierOfflineSettingsQueryResult = Apollo.QueryResult<CourierOfflineSettingsQuery, CourierOfflineSettingsQueryVariables>;